/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ((function(modules) {
	// Check all modules for deduplicated modules
	for(var i in modules) {
		if(Object.prototype.hasOwnProperty.call(modules, i)) {
			switch(typeof modules[i]) {
			case "function": break;
			case "object":
				// Module can be created from a template
				modules[i] = (function(_m) {
					var args = _m.slice(1), fn = modules[_m[0]];
					return function (a,b,c) {
						fn.apply(this, [a,b,c].concat(args));
					};
				}(modules[i]));
				break;
			default:
				// Module is a copy of another module
				modules[i] = modules[modules[i]];
				break;
			}
		}
	}
	return modules;
}([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	__webpack_require__(236);
	
	var _arrayTo = __webpack_require__(225);
	
	var _arrayTo2 = _interopRequireDefault(_arrayTo);
	
	var _isArray = __webpack_require__(11);
	
	var _isArray2 = _interopRequireDefault(_isArray);
	
	var _objectApplyIf = __webpack_require__(365);
	
	var _objectApplyIf2 = _interopRequireDefault(_objectApplyIf);
	
	var _d2ChartsApi = __webpack_require__(191);
	
	var _d2Analysis = __webpack_require__(57);
	
	var _Layout = __webpack_require__(90);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// extend
	_d2Analysis.api.Layout = _Layout.Layout;
	
	// references
	var refs = {
	    api: _d2Analysis.api,
	    init: _d2Analysis.init
	};
	
	// inits
	var inits = [_d2Analysis.init.legendSetsInit, _d2Analysis.init.dimensionsInit];
	
	// dimension config
	var dimensionConfig = new _d2Analysis.config.DimensionConfig();
	refs.dimensionConfig = dimensionConfig;
	
	// option config
	var optionConfig = new _d2Analysis.config.OptionConfig();
	refs.optionConfig = optionConfig;
	
	// period config
	var periodConfig = new _d2Analysis.config.PeriodConfig();
	refs.periodConfig = periodConfig;
	
	// chart config
	var chartConfig = new _d2Analysis.config.ChartConfig();
	refs.chartConfig = chartConfig;
	
	// app manager
	var appManager = new _d2Analysis.manager.AppManager(refs);
	appManager.apiVersion = 29;
	refs.appManager = appManager;
	
	// calendar manager
	var calendarManager = new _d2Analysis.manager.CalendarManager(refs);
	refs.calendarManager = calendarManager;
	
	// request manager
	var requestManager = new _d2Analysis.manager.RequestManager(refs);
	refs.requestManager = requestManager;
	
	// i18n manager
	var i18nManager = new _d2Analysis.manager.I18nManager(refs);
	refs.i18nManager = i18nManager;
	
	// session storage manager
	var sessionStorageManager = new _d2Analysis.manager.SessionStorageManager(refs);
	refs.sessionStorageManager = sessionStorageManager;
	
	// dependencies
	dimensionConfig.setI18nManager(i18nManager);
	dimensionConfig.init();
	optionConfig.setI18nManager(i18nManager);
	optionConfig.init();
	periodConfig.setI18nManager(i18nManager);
	periodConfig.init();
	
	appManager.applyTo((0, _arrayTo2.default)(_d2Analysis.api));
	optionConfig.applyTo((0, _arrayTo2.default)(_d2Analysis.api));
	
	// plugin
	function render(plugin, layout) {
	    var instanceRefs = _extends({}, refs);
	
	    var uiManager = new _d2Analysis.manager.UiManager(instanceRefs);
	    instanceRefs.uiManager = uiManager;
	    uiManager.applyTo((0, _arrayTo2.default)(_d2Analysis.api));
	    uiManager.preventMask = true;
	
	    var instanceManager = new _d2Analysis.manager.InstanceManager(instanceRefs);
	    instanceRefs.instanceManager = instanceManager;
	    instanceManager.apiResource = 'chart';
	    instanceManager.apiEndpoint = 'charts';
	    instanceManager.apiModule = 'dhis-web-visualizer';
	    instanceManager.plugin = true;
	    instanceManager.dashboard = chartPlugin.dashboard;
	    instanceManager.applyTo((0, _arrayTo2.default)(_d2Analysis.api));
	
	    // instance manager
	    uiManager.setInstanceManager(instanceManager);
	
	    instanceManager.setFn(function (_layout) {
	        var fn = function fn(legendSetId) {
	            var el = _layout.el;
	            var element = document.getElementById(el);
	            var response = _layout.getResponse();
	            var extraOptions = {
	                legendSet: appManager.getLegendSetById(legendSetId),
	                dashboard: instanceManager.dashboard
	            };
	
	            var _createChart = (0, _d2ChartsApi.createChart)(response, _layout, el, extraOptions),
	                chart = _createChart.chart;
	
	            // reg
	
	
	            uiManager.reg(chart, 'chart');
	
	            // dashboard item resize
	            element.setViewportWidth = function (width) {
	                chart.setSize(width, undefined, { duration: 50 });
	            };
	
	            element.setViewportHeight = function (height) {
	                chart.setSize(undefined, height, { duration: 50 });
	            };
	
	            element.setViewportSize = function (width, height) {
	                chart.setSize(width, height, { duration: 50 });
	            };
	
	            // mask
	            uiManager.unmask();
	        };
	
	        // legend set
	        if (_layout.doLegendSet()) {
	            appManager.getLegendSetIdByDxId(_layout.getFirstDxId(), function (legendSetId) {
	                fn(legendSetId);
	            });
	        } else {
	            fn();
	        }
	    });
	
	    if (plugin.loadingIndicator) {
	        uiManager.renderLoadingIndicator(layout.el);
	    }
	
	    if (layout.id) {
	        instanceManager.getById(layout.id, function (_layout) {
	            _layout = new _d2Analysis.api.Layout(instanceRefs, (0, _objectApplyIf2.default)(layout, _layout));
	
	            instanceManager.getReport(_layout);
	        });
	    } else {
	        instanceManager.getReport(new _d2Analysis.api.Layout(instanceRefs, layout), false, false, false, null, { noError: true, errorMessage: 'No data to display' });
	    }
	}
	
	global.chartPlugin = new _d2Analysis.util.Plugin({ refs: refs, inits: inits, renderFn: render, type: 'CHART' });
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 1 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/**
	 * Check if the value is an Array
	 *
	 * @param param Value to be checked
	 * @returns {boolean} Returns true when the `param` is an Array
	 *
	 * @example
	 * isArray([]); // Returns: true
	 * isArray({}); // Returns: false
	 * isArray('Hello'); // Returns: false
	 */
	exports.default = Array.isArray;
	//# sourceMappingURL=isArray.js.map

/***/ },
/* 2 */
[607, 1],
/* 3 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _lodash = __webpack_require__(83);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Check if the value is a String
	 *
	 * @name isString
	 * @param param Value to be checked
	 * @returns {boolean} Returns true when the `param` is a String
	 */
	exports.default = _lodash2.default;
	//# sourceMappingURL=isString.js.map

/***/ },
/* 4 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = arrayContains;
	/**
	 * Check if an array contains a specified item
	 *
	 * @param {Array} array The array to check for the item
	 * @param {*} item The item to look for in the array
	 * @returns {boolean} Returns true when the item is found, otherwise false
	 */
	function arrayContains(array, item) {
	  return Array.prototype.indexOf.call(array, item) !== -1;
	}
	//# sourceMappingURL=arrayContains.js.map

/***/ },
/* 5 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.default = arrayFrom;
	
	var _isArray = __webpack_require__(1);
	
	var _isArray2 = _interopRequireDefault(_isArray);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Create an array from a value
	 *
	 * @param {*} param Value to transform to an array
	 * @param {boolean} [isNewRef] Should return a new reference than the one from the `param` value
	 * @returns {Array} The resulting array
	 *
	 * @requires isArray
	 */
	function arrayFrom(param, isNewRef) {
	    var toArray = function toArray(iterable, start, end) {
	        if (!iterable || !iterable.length) {
	            return [];
	        }
	
	        // FIXME: This will never be called as the if check excludes type string
	        if (typeof iterable === 'string') {
	            iterable = iterable.split('');
	        }
	
	        if (supportsSliceOnNodeList) {
	            // FIXME: This does not exist
	            return slice.call(iterable, start || 0, end || iterable.length);
	        }
	
	        var array = [],
	            i;
	
	        // FIXME: start and end are always 0 and iterable.length
	        start = start || 0;
	        end = end ? end < 0 ? iterable.length + end : end : iterable.length;
	
	        for (i = start; i < end; i++) {
	            array.push(iterable[i]);
	        }
	
	        return array;
	    };
	
	    if (param === undefined || param === null) {
	        return [];
	    }
	
	    if ((0, _isArray2.default)(param)) {
	        return isNewRef ? Array.prototype.slice.call(param) : param;
	    }
	
	    var type = typeof param === 'undefined' ? 'undefined' : _typeof(param);
	    if (param && param.length !== undefined && type !== 'string' && (type !== 'function' || !param.apply)) {
	        // TODO: This function call will always fail because of supportsSliceOnNodeList being undefined
	        return toArray(param);
	    }
	
	    return [param];
	}
	//# sourceMappingURL=arrayFrom.js.map

/***/ },
/* 6 */
[602, 1, 2, 3],
/* 7 */
[605, 188],
/* 8 */
3,
/* 9 */
[597, 30],
/* 10 */
[599, 3, 7, 1, 2],
/* 11 */
1,
/* 12 */,
/* 13 */,
/* 14 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = arrayUnique;
	/**
	 * Creates an array of unique values from the array passed. This function does not do a _deep_ compare.
	 * Objects with the same values will therefore not be filtered.
	 *
	 * @param {Array} array The array to create the array of uniques from
	 * @returns {Array} The array containing the unique values
	 *
	 * @throws {TypeError} Is thrown when the argument passed is not an `array`
	 *
	 * @example
	 * const sourceArray = [1, 1, 2, 3, 2, 4, 4, 3];
	 * arrayUnique(sourceArray); // returns: [1, 2, 3, 4]
	 *
	 * @example
	 * const A = {name: 'A'};
	 * const B = {name: 'B'};
	 * arrayUnique([A, A, B, B]); // Returns: [{name: 'A'}, {name: 'B'}]
	 *
	 * @example
	 * const sourceArray = [{name: 'A'}, {name: 'B'}, {name: 'B'}];
	 * arrayUnique(sourceArray); // Returns: [{name: 'A'}, {name: 'B'}, {name: 'B'}]
	 */
	function arrayUnique(array) {
	    // TODO: Could be written as `return [...(new Set(array))];`
	    var newArray = [];
	    var i = 0;
	    var len = array.length;
	    var item;
	
	    for (; i < len; i++) {
	        item = array[i];
	
	        if (newArray.indexOf(item) === -1) {
	            newArray.push(item);
	        }
	    }
	
	    return newArray;
	}
	//# sourceMappingURL=arrayUnique.js.map

/***/ },
/* 15 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _lodash = __webpack_require__(79);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Check if a value is a boolean value `true` or `false`
	 *
	 * @name isBoolean
	 * @param {*} param The value to check for boolean type
	 * @returns {boolean} Returns `true` when the value is a boolean otherwise `false`
	 */
	exports.default = _lodash2.default;
	//# sourceMappingURL=isBoolean.js.map

/***/ },
/* 16 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.CHART_TYPE_GAUGE = exports.CHART_TYPE_PIE = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = function (_ref) {
	    var store = _ref.store,
	        layout = _ref.layout,
	        el = _ref.el,
	        extraConfig = _ref.extraConfig,
	        extraOptions = _ref.extraOptions;
	
	    var series = store.generateData({
	        seriesId: layout.columns[0].dimension,
	        categoryId: layout.rows[0].dimension
	    });
	
	    var isStacked = (0, _type.getIsStacked)(layout.type);
	
	    var config = {
	
	        // type etc
	        chart: (0, _chart2.default)(layout, el, extraOptions.dashboard),
	
	        // title
	        title: (0, _title2.default)(layout, store.data.metaData, extraOptions.dashboard),
	
	        // subtitle
	        subtitle: (0, _subtitle2.default)(series, layout, store.data.metaData, extraOptions.dashboard),
	
	        // x-axis
	        xAxis: (0, _xAxis2.default)(store, layout),
	
	        // y-axis
	        yAxis: (0, _yAxis2.default)(layout, extraOptions),
	
	        // series
	        series: (0, _series2.default)(series.slice(), store, layout, isStacked, extraOptions),
	
	        // legend
	        legend: (0, _legend2.default)(layout, extraOptions.dashboard),
	
	        // pane
	        pane: (0, _pane2.default)(layout.type),
	
	        // no data
	        noData: (0, _noData2.default)(),
	
	        // credits
	        credits: {
	            enabled: false
	        },
	
	        // exporting
	        exporting: {
	            // disable exporting context menu
	            enabled: false
	        }
	    };
	
	    // hide empty categories
	    if (layout.hideEmptyRowItems !== 'NONE') {
	        config = (0, _getTrimmedConfig2.default)(config, layout.hideEmptyRowItems);
	    }
	
	    // sorting
	    if (layout.sortOrder) {
	        config = (0, _getSortedConfig2.default)(config, layout, isStacked);
	    }
	
	    // DHIS2-1243 add trend lines after sorting
	    // trend line on pie and gauge does not make sense
	    if (layout.type !== CHART_TYPE_GAUGE && layout.type !== CHART_TYPE_PIE && layout.regressionType !== 'NONE') {
	        config.series = (0, _addTrendLines2.default)(layout.regressionType, config.series, isStacked);
	    }
	
	    // force apply extra config
	    _extends(config, extraConfig);
	
	    return (0, _objectClean2.default)(config);
	};
	
	var _objectClean = __webpack_require__(33);
	
	var _objectClean2 = _interopRequireDefault(_objectClean);
	
	var _chart = __webpack_require__(193);
	
	var _chart2 = _interopRequireDefault(_chart);
	
	var _xAxis = __webpack_require__(208);
	
	var _xAxis2 = _interopRequireDefault(_xAxis);
	
	var _yAxis = __webpack_require__(210);
	
	var _yAxis2 = _interopRequireDefault(_yAxis);
	
	var _series = __webpack_require__(202);
	
	var _series2 = _interopRequireDefault(_series);
	
	var _title = __webpack_require__(206);
	
	var _title2 = _interopRequireDefault(_title);
	
	var _subtitle = __webpack_require__(205);
	
	var _subtitle2 = _interopRequireDefault(_subtitle);
	
	var _legend = __webpack_require__(197);
	
	var _legend2 = _interopRequireDefault(_legend);
	
	var _pane = __webpack_require__(200);
	
	var _pane2 = _interopRequireDefault(_pane);
	
	var _noData = __webpack_require__(198);
	
	var _noData2 = _interopRequireDefault(_noData);
	
	var _type = __webpack_require__(32);
	
	var _getSortedConfig = __webpack_require__(195);
	
	var _getSortedConfig2 = _interopRequireDefault(_getSortedConfig);
	
	var _getTrimmedConfig = __webpack_require__(196);
	
	var _getTrimmedConfig2 = _interopRequireDefault(_getTrimmedConfig);
	
	var _addTrendLines = __webpack_require__(192);
	
	var _addTrendLines2 = _interopRequireDefault(_addTrendLines);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CHART_TYPE_PIE = exports.CHART_TYPE_PIE = 'pie';
	var CHART_TYPE_GAUGE = exports.CHART_TYPE_GAUGE = 'gauge';
	//# sourceMappingURL=index.js.map

/***/ },
/* 17 */
[607, 11],
/* 18 */
/***/ function(module, exports) {

	var core = module.exports = {version: '2.4.0'};
	if(typeof __e == 'number')__e = core; // eslint-disable-line no-undef

/***/ },
/* 19 */
/***/ function(module, exports) {

	// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
	var global = module.exports = typeof window != 'undefined' && window.Math == Math
	  ? window : typeof self != 'undefined' && self.Math == Math ? self : Function('return this')();
	if(typeof __g == 'number')__g = global; // eslint-disable-line no-undef

/***/ },
/* 20 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var scrollbarWidth = /\bchrome\b/.test(navigator.userAgent.toLowerCase()) ? 8 : 17;
	
	exports.default = {
	    nameCmpWidth: 440 - scrollbarWidth,
	    buttonCmpWidth: 20,
	    operatorCmpWidth: 70,
	    searchCmpWidth: 70,
	    triggerCmpWidth: 17,
	    valueCmpWidth: 235,
	    rangeSetWidth: 135,
	    namePadding: '3px 3px',
	    margin: '3px 0 1px',
	    removeCmpStyle: 'padding: 0; margin-left: 3px',
	    defaultRangeSetId: 'default'
	};
	//# sourceMappingURL=containerConfig.js.map

/***/ },
/* 21 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _lodash = __webpack_require__(235);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Check if the value is a Function
	 *
	 * @name isFunction
	 * @param {*} param Value to be checked
	 * @returns {boolean} Returns true when the `param` is a Function
	 */
	exports.default = _lodash2.default;
	//# sourceMappingURL=isFunction.js.map

/***/ },
/* 22 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.default = isNumeric;
	/**
	 * Check if a value is numeric
	 *
	 * @param param Value to be checked
	 * @returns {boolean} Returns true when the `param` is a numeric value
	 */
	function isNumeric(param) {
	    if ((typeof param === 'undefined' ? 'undefined' : _typeof(param)) === 'symbol') {
	        return false;
	    }
	
	    return !isNaN(parseFloat(param)) && global.isFinite(param);
	}
	//# sourceMappingURL=isNumeric.js.map
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 23 */
/***/ function(module, exports) {

	module.exports = function(it){
	  return typeof it === 'object' ? it !== null : typeof it === 'function';
	};

/***/ },
/* 24 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.DateManager = undefined;
	
	var _isString = __webpack_require__(3);
	
	var _isString2 = _interopRequireDefault(_isString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _DateManager;
	
	exports.DateManager = _DateManager;
	exports.DateManager = _DateManager = function DateManager() {
	    this.klass = _DateManager;
	};
	
	_DateManager.toDate = function (dateString) {
	    return (0, _isString2.default)(dateString) ? new Date(dateString) : dateString;
	};
	
	_DateManager.isValid = function (param) {
	    param = this.toDate(param);
	    return Object.prototype.toString.call(param) === '[object Date]' && param.toString() !== 'Invalid Date';
	};
	
	_DateManager.getYYYYMMDD = function (param, skipValidation) {
	    param = this.toDate(param);
	
	    if (!skipValidation && !_DateManager.isValid(param)) {
	        return null;
	    }
	
	    var date = new Date(param),
	        month = '' + (1 + date.getMonth()),
	        day = '' + date.getDate();
	
	    month = month.length === 1 ? '0' + month : month;
	    day = day.length === 1 ? '0' + day : day;
	
	    return date.getFullYear() + '-' + month + '-' + day;
	};
	
	_DateManager.getTimeDifference = function (date) {
	    var seconds = Math.floor((new Date() - new Date(date)) / 1000);
	
	    // Dirty hack to avoid having negative time due to difference between client zone and server zone
	    while (seconds < 0) {
	        seconds += 3600;
	    }
	    var interval = Math.floor(seconds / 31536000);
	
	    if (interval > 1) {
	        return interval + " years";
	    }
	    interval = Math.floor(seconds / 2592000);
	    if (interval > 1) {
	        return interval + " months";
	    }
	    interval = Math.floor(seconds / 86400);
	    if (interval > 1) {
	        return interval + " days";
	    }
	    interval = Math.floor(seconds / 3600);
	    if (interval > 1) {
	        return interval + " hours";
	    }
	    interval = Math.floor(seconds / 60);
	    if (interval > 1) {
	        return interval + " minutes";
	    }
	    return Math.floor(seconds) + " seconds";
	};
	//# sourceMappingURL=DateManager.js.map

/***/ },
/* 25 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var textfieldStyle = ['padding-right: 0', 'padding-left: 5px', 'border-color: transparent', 'background: none', 'font-size: 11px', 'line-height: 13px'];
	
	var textFieldLabelStyle = ['font-size: 11px', 'font-weight: bold', 'color: #111', 'padding-left: 5px', 'padding-top: 4px', 'margin-bottom: 0'];
	
	var toggleBtnWidth = 22;
	var toggleBtnMarginTop = 48;
	var toggleBtnMarginRight = 7;
	var toggleBtnMarginLeft = 10;
	
	var windowWidth = 700;
	var borderWidth = 14;
	var filtersComboBoxWidth = 160;
	var windowCmpWidth = windowWidth - borderWidth;
	
	var createdColWidth = 120;
	var lastUpdatedColWidth = 120;
	var buttonColWidth = 60;
	var paddingColWidth = 8;
	
	exports.default = {
	    textfieldStyle: textfieldStyle,
	    textFieldLabelStyle: textFieldLabelStyle,
	    toggleBtnWidth: toggleBtnWidth,
	    toggleBtnMarginTop: toggleBtnMarginTop,
	    toggleBtnMarginRight: toggleBtnMarginRight,
	    toggleBtnMarginLeft: toggleBtnMarginLeft,
	    windowWidth: windowWidth,
	    borderWidth: borderWidth,
	    windowCmpWidth: windowCmpWidth,
	    filtersComboBoxWidth: filtersComboBoxWidth,
	    createdColWidth: createdColWidth,
	    lastUpdatedColWidth: lastUpdatedColWidth,
	    buttonColWidth: buttonColWidth,
	    paddingColWidth: paddingColWidth
	};
	//# sourceMappingURL=FavoriteStyle.js.map

/***/ },
/* 26 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.InterpretationWindow = undefined;
	
	var _SharingWindow = __webpack_require__(27);
	
	var InterpretationWindow = exports.InterpretationWindow = undefined;
	
	exports.InterpretationWindow = InterpretationWindow = function InterpretationWindow(c, sharing, interpretation, success) {
	    var appManager = c.appManager,
	        uiManager = c.uiManager,
	        instanceManager = c.instanceManager,
	        i18n = c.i18nManager.get(),
	        apiPath = appManager.getApiPath(),
	        apiResource = instanceManager.apiResource,
	        apiEndpoint = instanceManager.apiEndpoint;
	
	    var textArea = Ext.create('Ext.form.field.TextArea', {
	        cls: 'ns-textarea',
	        height: 130,
	        width: 407,
	        fieldStyle: 'padding-left:3px; padding-top:3px',
	        emptyText: i18n.write_your_interpretation + '..',
	        enableKeyEvents: true,
	        value: interpretation ? interpretation.text : undefined,
	        listeners: {
	            keyup: function keyup() {
	                shareButton.xable();
	            }
	        }
	    });
	
	    var sharingCmp = sharing ? new _SharingWindow.SharingWindow(c, sharing, true) : null;
	
	    var sharingCt = Ext.create('Ext.container.Container', {
	        style: 'padding-top:10px; padding-bottom:25px',
	        items: sharingCmp ? sharingCmp.items : []
	    });
	
	    var method = interpretation ? 'PUT' : 'POST';
	
	    var interpretationSuccess = function interpretationSuccess(text) {
	        if (interpretation) {
	            interpretation.text = text;
	        }
	        if (success) {
	            success();
	        } else {
	            instanceManager.getById(null, function (layout, isFavorite) {
	                instanceManager.getReport(layout, isFavorite, false, false, function () {
	                    uiManager.unmask();
	                });
	            });
	        }
	    };
	
	    var updateSharing = function updateSharing(obj, text) {
	        var interpretationId = interpretation ? interpretation.id : (obj.getResponseHeader('location') || '').split('/').pop(),
	            sharingId = sharing.object.id,
	            sharingBody = sharingCmp.getBody();
	
	        Ext.Ajax.request({
	            url: encodeURI(apiPath + '/sharing?type=interpretation&id=' + interpretationId),
	            method: method,
	            headers: {
	                'Content-Type': 'application/json'
	            },
	            params: Ext.encode(sharingBody),
	            callback: function callback() {
	                interpretationSuccess(text);
	            }
	        });
	    };
	
	    var shareButton = Ext.create('Ext.button.Button', {
	        text: interpretation ? i18n.update : i18n.share,
	        disabled: !interpretation,
	        xable: function xable() {
	            this.setDisabled(!textArea.getValue());
	        },
	        handler: function handler() {
	            var text = textArea.getValue();
	            var interpretationPath = interpretation ? '/interpretations/' + interpretation.id : '/interpretations/' + apiResource + '/' + instanceManager.getStateFavoriteId();
	
	            if (text) {
	                Ext.Ajax.request({
	                    url: encodeURI(apiPath + interpretationPath),
	                    method: method,
	                    params: text,
	                    headers: { 'Content-Type': 'text/html' },
	                    success: function success(obj) {
	                        sharing ? updateSharing(obj, text) : interpretationSuccess(text);
	                        textArea.reset();
	                        window.destroy();
	                    }
	                });
	            }
	        }
	    });
	
	    var window = Ext.create('Ext.window.Window', {
	        title: i18n.write_interpretation,
	        layout: 'fit',
	        bodyStyle: 'padding:4px; background-color:#fff',
	        resizable: false,
	        destroyOnBlur: true,
	        modal: true,
	        items: [textArea, sharingCt],
	        bbar: {
	            cls: 'ns-toolbar-bbar',
	            defaults: {
	                height: 24
	            },
	            items: ['->', shareButton]
	        },
	        listeners: {
	            show: function show(w) {
	                uiManager.setAnchorPosition(w, 'favoriteButton');
	
	                uiManager.enableRightClick();
	
	                if (!w.hasDestroyOnBlurHandler) {
	                    uiManager.addDestroyOnBlurHandler(w);
	                }
	            },
	            hide: function hide() {
	                uiManager.disableRightClick();
	            }
	        }
	    });
	    uiManager.reg(window, 'interpretationWindow');
	
	    return window;
	};
	//# sourceMappingURL=InterpretationWindow.js.map

/***/ },
/* 27 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.SharingWindow = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _isArray = __webpack_require__(1);
	
	var _isArray2 = _interopRequireDefault(_isArray);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SharingWindow = exports.SharingWindow = undefined;
	
	exports.SharingWindow = SharingWindow = function SharingWindow(c, sharing, configOnly) {
	    var t = this;
	
	    var appManager = c.appManager,
	        uiManager = c.uiManager,
	        instanceManager = c.instanceManager,
	        i18n = c.i18nManager.get();
	
	    var apiPath = appManager.getApiPath();
	
	    var SharingAccessRow, getBody, sharingStore, sharingField, sharingButton, userGroupRowContainer, userRowContainer, sharingContainer, externalAccess, publicGroup, items, window;
	
	    SharingAccessRow = function SharingAccessRow(obj, isPublicAccess, disallowPublicAccess) {
	        var getData, store, getItems, combo, getAccess, panel;
	
	        getData = function getData() {
	            var data = [{ id: 'r-------', name: i18n.can_view }, { id: 'rw------', name: i18n.can_edit_and_view }];
	
	            if (isPublicAccess) {
	                data.unshift({ id: '--------', name: i18n.none });
	            }
	
	            return data;
	        };
	
	        store = Ext.create('Ext.data.Store', {
	            fields: ['id', 'name'],
	            data: getData()
	        });
	
	        getItems = function getItems() {
	            var items = [];
	
	            combo = Ext.create('Ext.form.field.ComboBox', {
	                style: 'margin-bottom:2px',
	                fieldLabel: isPublicAccess ? i18n.public_access : obj.name,
	                labelStyle: 'color:#333',
	                cls: 'ns-combo',
	                width: 380,
	                labelWidth: 250,
	                queryMode: 'local',
	                valueField: 'id',
	                displayField: 'name',
	                labelSeparator: null,
	                editable: false,
	                disabled: !!disallowPublicAccess,
	                value: obj.access || 'rw------',
	                store: store
	            });
	
	            items.push(combo);
	
	            if (!isPublicAccess) {
	                items.push(Ext.create('Ext.container.Container', {
	                    cls: 'ns-grid-row-icon-delete',
	                    style: 'margin-top:2px; margin-left:7px',
	                    bodyStyle: 'border:0 none; background:#fff',
	                    overCls: 'pointer',
	                    width: 16,
	                    height: 16,
	                    listeners: {
	                        render: function render(cmp) {
	                            cmp.getEl().on('click', function (e) {
	                                cmp.up('panel').destroy();
	
	                                if (window) {
	                                    window.doLayout();
	                                }
	                            });
	                        }
	                    }
	                }));
	            }
	
	            return items;
	        };
	
	        getAccess = function getAccess() {
	            return {
	                id: obj.id,
	                name: obj.name,
	                access: combo.getValue()
	            };
	        };
	
	        panel = Ext.create('Ext.panel.Panel', {
	            layout: 'column',
	            bodyStyle: 'border:0 none',
	            getAccess: getAccess,
	            items: getItems()
	        });
	
	        return panel;
	    };
	
	    getBody = function getBody() {
	        var body = {
	            object: {
	                id: sharing.object.id,
	                name: sharing.object.name,
	                publicAccess: publicGroup.down('combobox').getValue(),
	                externalAccess: externalAccess ? externalAccess.getValue() : false
	            }
	        };
	
	        if (userGroupRowContainer.items.items.length > 1) {
	            body.object.userGroupAccesses = [];
	            userGroupRowContainer.items.items.forEach(function (item, i) {
	                if (i > 0) {
	                    body.object.userGroupAccesses.push(item.getAccess());
	                }
	            });
	        }
	
	        if (userRowContainer.items.items.length > 1) {
	            body.object.userAccesses = [];
	            userRowContainer.items.items.forEach(function (item, i) {
	                if (i > 0) {
	                    body.object.userAccesses.push(item.getAccess());
	                }
	            });
	        }
	
	        return body;
	    };
	
	    // Initialize
	    sharingStore = Ext.create('Ext.data.Store', {
	        fields: ['id', 'name', 'isGroup'],
	        proxy: {
	            type: 'ajax',
	            url: encodeURI(apiPath + '/sharing/search'),
	            extraParams: {
	                pageSize: 50
	            },
	            startParam: false,
	            limitParam: false,
	            reader: {
	                type: 'json',
	                getData: function getData(data) {
	                    // manually populate the store with the records from the response
	                    // this is to avoid having to call the endpoint 2 times, one for user groups and one for users
	                    var records = [];
	
	                    data.userGroups.forEach(function (_ref) {
	                        var id = _ref.id,
	                            name = _ref.name;
	
	                        records.push({ id: id, name: name, isGroup: true });
	                    });
	
	                    data.users.forEach(function (_ref2) {
	                        var id = _ref2.id,
	                            name = _ref2.name;
	
	                        records.push({ id: id, name: name, isGroup: false });
	                    });
	
	                    return records;
	                }
	            }
	        }
	    });
	
	    var comboBoxConfig = {
	        valueField: 'id',
	        displayField: 'name',
	        queryParam: 'key',
	        queryDelay: 200,
	        minChars: 1,
	        hideTrigger: true,
	        fieldStyle: 'height:26px; padding-left:6px; border-radius:1px; font-size:11px',
	        style: 'margin-bottom:5px',
	        width: 380
	    };
	
	    sharingField = Ext.create('Ext.form.field.ComboBox', _extends({}, comboBoxConfig, {
	        emptyText: i18n.add_users_and_user_groups,
	        store: sharingStore,
	        listeners: {
	            beforeselect: function beforeselect(cb) {
	                // beforeselect instead of select, fires regardless of currently selected item
	                sharingButton.enable();
	            },
	            afterrender: function afterrender(cb) {
	                cb.inputEl.on('keyup', function (e) {
	                    if (e.getKey() !== e.ENTER) {
	                        sharingButton.disable();
	                    }
	                });
	            }
	        }
	    }));
	
	    var buttonConfig = {
	        text: '+',
	        style: 'margin-left:2px; padding-right:4px; padding-left:4px; border-radius:1px',
	        disabled: true,
	        height: 26
	    };
	
	    sharingButton = Ext.create('Ext.button.Button', _extends({}, buttonConfig, {
	        handler: function handler(b) {
	            var record = sharingStore.getById(sharingField.getValue());
	
	            if (record && record.data) {
	                if (record.data.isGroup) {
	                    userGroupRowContainer.add(SharingAccessRow({
	                        id: record.data.id,
	                        name: record.data.name,
	                        access: 'r-------'
	                    }));
	                } else {
	                    userRowContainer.add(SharingAccessRow({
	                        id: record.data.id,
	                        name: record.data.name,
	                        access: 'r-------'
	                    }));
	                }
	            }
	
	            sharingField.clearValue();
	            b.disable();
	        }
	    }));
	
	    sharingContainer = Ext.create('Ext.container.Container', {
	        bodyStyle: 'border:0 none'
	    });
	
	    var rowContainerConfig = {
	        hidden: true,
	        bodyStyle: 'border:0 none',
	        listeners: {
	            add: function add(el) {
	                if (el.items.length > 1) {
	                    // enable the whole container
	                    el.show();
	                }
	            },
	            remove: function remove(el) {
	                if (el.items.length === 1) {
	                    el.hide();
	                }
	            }
	        }
	    };
	
	    userGroupRowContainer = Ext.create('Ext.container.Container', _extends({}, rowContainerConfig, {
	        items: [{
	            html: i18n.groups_access,
	            bodyStyle: 'border:0 none; font-weight: bold'
	        }]
	    }));
	
	    userRowContainer = Ext.create('Ext.container.Container', _extends({}, rowContainerConfig, {
	        items: [{
	            html: i18n.users_access,
	            bodyStyle: 'border:0 none; font-weight: bold'
	        }]
	    }));
	
	    if (sharing.meta.allowExternalAccess) {
	        externalAccess = sharingContainer.add({
	            xtype: 'checkbox',
	            fieldLabel: i18n.allow_external_access,
	            labelSeparator: '',
	            labelWidth: 250,
	            checked: !!sharing.object.externalAccess
	        });
	    }
	
	    publicGroup = sharingContainer.add(SharingAccessRow({
	        id: sharing.object.id,
	        name: sharing.object.name,
	        access: sharing.object.publicAccess
	    }, true, !sharing.meta.allowPublicAccess));
	
	    if ((0, _isArray2.default)(sharing.object.userGroupAccesses)) {
	        sharing.object.userGroupAccesses.forEach(function (record) {
	            userGroupRowContainer.add(SharingAccessRow(record));
	        });
	    }
	
	    if ((0, _isArray2.default)(sharing.object.userAccesses)) {
	        sharing.object.userAccesses.forEach(function (record) {
	            userRowContainer.add(SharingAccessRow(record));
	        });
	    }
	
	    items = [{
	        html: sharing.object.name,
	        bodyStyle: 'border:0 none; font-weight:bold; color:#333',
	        style: 'margin-bottom:7px'
	    }, {
	        xtype: 'container',
	        layout: 'column',
	        bodyStyle: 'border:0 none',
	        items: [sharingField, sharingButton]
	    }, {
	        html: i18n.created_by + ' ' + sharing.object.user.name,
	        bodyStyle: 'border:0 none; color:#777',
	        style: 'margin-top:2px;margin-bottom:7px'
	    }, sharingContainer, userGroupRowContainer, userRowContainer];
	
	    if (configOnly) {
	        return {
	            SharingAccessRow: SharingAccessRow,
	            getBody: getBody,
	            sharingStore: sharingStore,
	            sharingField: sharingField,
	            sharingButton: sharingButton,
	            userGroupRowContainer: userGroupRowContainer,
	            userRowContainer: userRowContainer,
	            externalAccess: externalAccess,
	            publicGroup: publicGroup,
	            items: items
	        };
	    } else {
	        window = Ext.create('Ext.window.Window', {
	            title: i18n.sharing_settings,
	            bodyStyle: 'padding:5px 5px 3px; background-color:#fff',
	            resizable: false,
	            modal: true,
	            destroyOnBlur: true,
	            items: items,
	            bbar: ['->', {
	                text: i18n.save,
	                handler: function handler() {
	                    Ext.Ajax.request({
	                        url: encodeURI(apiPath + '/sharing?type=' + instanceManager.apiResource + '&id=' + sharing.object.id),
	                        method: 'POST',
	                        headers: {
	                            'Content-Type': 'application/json'
	                        },
	                        params: Ext.encode(getBody()),
	                        success: function success() {
	                            instanceManager.getById(null, function (layout, isFavorite) {
	                                instanceManager.getReport(layout, isFavorite, false, false, function () {
	                                    uiManager.unmask();
	                                });
	                            });
	                        }
	                    });
	
	                    window.destroy();
	                }
	            }],
	            listeners: {
	                show: function show(w) {
	                    var favoriteWindow = uiManager.get('favoriteWindow');
	
	                    if (favoriteWindow && favoriteWindow.rendered) {
	
	                        // position
	                        var x = (favoriteWindow.getWidth() - w.getWidth()) / 2 + favoriteWindow.getPosition()[0],
	                            y = w.getPosition()[1] / 3;
	
	                        w.setPosition(x, y);
	
	                        // blur
	                        favoriteWindow.destroyOnBlur = false;
	                    } else {
	                        uiManager.setAnchorPosition(w, 'favoriteButton');
	                    }
	
	                    if (!w.hasDestroyOnBlurHandler) {
	                        uiManager.addDestroyOnBlurHandler(w);
	                    }
	                },
	                destroy: function destroy() {
	                    var favoriteWindow = uiManager.get('favoriteWindow');
	
	                    if (favoriteWindow) {
	                        favoriteWindow.destroyOnBlur = true;
	                    }
	                }
	            }
	        });
	
	        return window;
	    }
	};
	//# sourceMappingURL=SharingWindow.js.map

/***/ },
/* 28 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = arrayPluck;
	/**
	 *
	 * @param {Array} array
	 * @param {string|number} propertyName The property of the
	 * @returns {Array}
	 *
	 * @throws {TypeError} When the `propertyName` can not be found on an item in the `array`. This generally happens when a value in the array is `null` or `undefined`
	 *
	 * @example
	 * const values = [{name: 'John'}, {name: 'James'}];
	 * arrayPluck(values, 'name') // returns: ['John', 'James']
	 *
	 * @example
	 * const values = [{name: 'John'}, {}, {name: 'James'}];
	 * arrayPluck(values, 'name') // returns: ['John', undefined, 'James']
	 *
	 * @example
	 * const values = [undefined, {name: 'James'}];
	 * arrayPluck(values, 'name') // throws: Cannot read property 'name' of undefined
	 */
	function arrayPluck(array, propertyName) {
	    var newArray = [];
	    var i;
	    var len;
	    var item;
	
	    for (i = 0, len = array.length; i < len; i++) {
	        item = array[i];
	
	        newArray.push(item[propertyName]);
	    }
	
	    return newArray;
	}
	//# sourceMappingURL=arrayPluck.js.map

/***/ },
/* 29 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = clone;
	// TODO: Throw an error on empty `item` (Unexpected token u)
	/**
	 * Create a clone a value
	 *
	 * @param {*} item
	 *
	 * @example
	 * const person1 = {name: 'John'};
	 * const person2 = clone(person1); // Returns {name: 'John'}
	 * // but
	 * person1 !== person2 // Returns:  true
	 */
	function clone(item) {
	  return global.JSON.parse(global.JSON.stringify(item));
	}
	//# sourceMappingURL=clone.js.map
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 30 */
[603, 1],
/* 31 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = uuid;
	/**
	 * Generates a universally unique identifier
	 *
	 * @see https://en.wikipedia.org/wiki/Universally_unique_identifier
	 *
	 * @returns {string} The uuid
	 */
	function uuid() {
	    var s4 = function s4() {
	        return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
	    };
	
	    return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
	}
	//# sourceMappingURL=uuid.js.map

/***/ },
/* 32 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.getIsStacked = getIsStacked;
	
	exports.default = function (type) {
	    return chartTypeMap.get(type.toLowerCase()) || {
	        type: type.toLowerCase()
	    };
	};
	
	var _arrayContains = __webpack_require__(45);
	
	var _arrayContains2 = _interopRequireDefault(_arrayContains);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Note: IE11 does not support passing the array directly to the constructor
	var chartTypeMap = new Map();
	
	chartTypeMap.set('radar', { type: 'line', polar: true });
	chartTypeMap.set('gauge', { type: 'solidgauge' });
	chartTypeMap.set('stackedcolumn', { type: 'column' });
	chartTypeMap.set('stackedbar', { type: 'bar' });
	
	var stackedTypes = ['stackedcolumn', 'stackedbar', 'area'];
	
	function getIsStacked(type) {
	    return (0, _arrayContains2.default)(stackedTypes, type.toLowerCase());
	}
	//# sourceMappingURL=type.js.map

/***/ },
/* 33 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = cleanObject;
	
	var _isEmpty = __webpack_require__(43);
	
	var _isEmpty2 = _interopRequireDefault(_isEmpty);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Applies properties from "config" if they are undefined in "object.
	 *
	 * @param {Object} object The object to be cleaned
	 * @param {Function} isEmptyFn Optional isEmpty function
	 * @returns {Object} A new cleaned object
	 *
	 * @example
	 * let object = {id: 1, name: undefined}
	 * objectClean(object); // returns: {id: 1}
	 */
	
	function cleanObject(object) {
	    var isEmptyFn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _isEmpty2.default;
	
	    return Object.keys(object).reduce(function (acc, key) {
	        if (!isEmptyFn(object[key])) {
	            acc[key] = object[key];
	        }
	        return acc;
	    }, {});
	}
	//# sourceMappingURL=objectClean.js.map

/***/ },
/* 34 */
/***/ function(module, exports, __webpack_require__) {

	// 22.1.3.31 Array.prototype[@@unscopables]
	var UNSCOPABLES = __webpack_require__(56)('unscopables')
	  , ArrayProto  = Array.prototype;
	if(ArrayProto[UNSCOPABLES] == undefined)__webpack_require__(37)(ArrayProto, UNSCOPABLES, {});
	module.exports = function(key){
	  ArrayProto[UNSCOPABLES][key] = true;
	};

/***/ },
/* 35 */
/***/ function(module, exports, __webpack_require__) {

	// Thank's IE8 for his funny defineProperty
	module.exports = !__webpack_require__(51)(function(){
	  return Object.defineProperty({}, 'a', {get: function(){ return 7; }}).a != 7;
	});

/***/ },
/* 36 */
/***/ function(module, exports, __webpack_require__) {

	var global    = __webpack_require__(19)
	  , core      = __webpack_require__(18)
	  , hide      = __webpack_require__(37)
	  , redefine  = __webpack_require__(107)
	  , ctx       = __webpack_require__(50)
	  , PROTOTYPE = 'prototype';
	
	var $export = function(type, name, source){
	  var IS_FORCED = type & $export.F
	    , IS_GLOBAL = type & $export.G
	    , IS_STATIC = type & $export.S
	    , IS_PROTO  = type & $export.P
	    , IS_BIND   = type & $export.B
	    , target    = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE]
	    , exports   = IS_GLOBAL ? core : core[name] || (core[name] = {})
	    , expProto  = exports[PROTOTYPE] || (exports[PROTOTYPE] = {})
	    , key, own, out, exp;
	  if(IS_GLOBAL)source = name;
	  for(key in source){
	    // contains in native
	    own = !IS_FORCED && target && target[key] !== undefined;
	    // export native or passed
	    out = (own ? target : source)[key];
	    // bind timers to global for call from export context
	    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
	    // extend global
	    if(target)redefine(target, key, out, type & $export.U);
	    // export
	    if(exports[key] != out)hide(exports, key, exp);
	    if(IS_PROTO && expProto[key] != out)expProto[key] = out;
	  }
	};
	global.core = core;
	// type bitmap
	$export.F = 1;   // forced
	$export.G = 2;   // global
	$export.S = 4;   // static
	$export.P = 8;   // proto
	$export.B = 16;  // bind
	$export.W = 32;  // wrap
	$export.U = 64;  // safe
	$export.R = 128; // real proto method for `library` 
	module.exports = $export;

/***/ },
/* 37 */
/***/ function(module, exports, __webpack_require__) {

	var dP         = __webpack_require__(105)
	  , createDesc = __webpack_require__(106);
	module.exports = __webpack_require__(35) ? function(object, key, value){
	  return dP.f(object, key, createDesc(1, value));
	} : function(object, key, value){
	  object[key] = value;
	  return object;
	};

/***/ },
/* 38 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.ResponseRowIdCombination = undefined;
	
	var _arrayContains = __webpack_require__(4);
	
	var _arrayContains2 = _interopRequireDefault(_arrayContains);
	
	var _arrayFrom = __webpack_require__(5);
	
	var _arrayFrom2 = _interopRequireDefault(_arrayFrom);
	
	var _isArray = __webpack_require__(1);
	
	var _isArray2 = _interopRequireDefault(_isArray);
	
	var _isString = __webpack_require__(3);
	
	var _isString2 = _interopRequireDefault(_isString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ResponseRowIdCombination = exports.ResponseRowIdCombination = undefined;
	
	exports.ResponseRowIdCombination = ResponseRowIdCombination = function ResponseRowIdCombination(refs, config) {
	    var t = this;
	
	    config = (0, _isArray2.default)(config) ? config.reduce(function (acc, cur) {
	        return acc += (acc.length === 0 ? '' : '-') + cur;
	    }, '') : null;
	    config = (0, _isString2.default)(config) ? config : '';
	
	    // constructor
	    t.ids = config;
	};
	
	ResponseRowIdCombination.prototype.add = function (id) {
	    if (id) {
	        this.ids += (this.ids.length === 0 ? '' : '-') + id;
	    }
	};
	
	ResponseRowIdCombination.prototype.get = function () {
	    return this.ids;
	};
	
	ResponseRowIdCombination.prototype.getNames = function (response, ignoreIndexes) {
	    var ids = this.ids.split('-');
	
	    if ((0, _isArray2.default)(ignoreIndexes)) {
	        ids = ids.filter(function (id, index) {
	            return !(0, _arrayContains2.default)(ignoreIndexes, index);
	        });
	    }
	
	    return ids.map(function (id) {
	        return response.getNameById(id);
	    });
	};
	
	ResponseRowIdCombination.prototype.getIdByIds = function (ids) {
	    return this.ids.split('-').filter(function (id) {
	        return (0, _arrayContains2.default)((0, _arrayFrom2.default)(ids), id);
	    })[0];
	};
	//# sourceMappingURL=ResponseRowIdCombination.js.map

/***/ },
/* 39 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = function (_ref) {
	    var layout = _ref.layout,
	        i18n = _ref.i18n;
	
	
	    var nameTextField = Ext.create('Ext.form.field.Text', {
	        width: _FavoriteStyle2.default.windowCmpWidth,
	        height: 45,
	        style: 'margin-top: 2px; margin-bottom: 0',
	        fieldStyle: _FavoriteStyle2.default.textfieldStyle.join(';'),
	        fieldLabel: i18n.name,
	        labelAlign: 'top',
	        labelStyle: _FavoriteStyle2.default.textFieldLabelStyle.join(';'),
	        labelSeparator: '',
	        emptyText: 'Unnamed',
	        enableKeyEvents: true,
	        currentValue: '',
	        value: layout.name,
	        setEventChangeHandler: function setEventChangeHandler(handler) {
	            this.eventChangeHandler = handler;
	        },
	        setEventKeyUpHandler: function setEventKeyUpHandler(handler) {
	            this.eventKeyUpHandler = handler;
	        },
	        listeners: {
	            change: function change(cmp, e) {
	                if (this.eventChangeHandler) {
	                    this.eventChangeHandler(cmp, e);
	                }
	            },
	            keyup: function keyup(cmp, e) {
	                if (e.keyCode === 13 && this.eventKeyUpHandler) {
	                    this.eventKeyUpHandler(cmp, e);
	                }
	            }
	        }
	    });
	
	    var descriptionTextField = Ext.create('Ext.form.field.TextArea', {
	        width: _FavoriteStyle2.default.windowCmpWidth,
	        rows: 3,
	        style: 'margin-bottom: 0',
	        fieldStyle: _FavoriteStyle2.default.textfieldStyle.concat(['padding-top: 5px']).join(';'),
	        fieldLabel: i18n.description,
	        labelAlign: 'top',
	        labelStyle: _FavoriteStyle2.default.textFieldLabelStyle.join(';'),
	        labelSeparator: '',
	        emptyText: 'No description (optional)',
	        enableKeyEvents: true,
	        value: layout.description
	    });
	
	    var titleTextField = Ext.create('Ext.form.field.Text', {
	        width: _FavoriteStyle2.default.windowCmpWidth,
	        height: 45,
	        style: 'margin-bottom: 0',
	        fieldStyle: _FavoriteStyle2.default.textfieldStyle.join(';'),
	        fieldLabel: i18n.title,
	        labelAlign: 'top',
	        labelStyle: _FavoriteStyle2.default.textFieldLabelStyle.join(';'),
	        labelSeparator: '',
	        emptyText: 'No title (optional)',
	        enableKeyEvents: true,
	        currentValue: '',
	        value: layout.title,
	        setEventKeyUpHandler: function setEventKeyUpHandler(handler) {
	            this.eventKeyUpHandler = handler;
	        },
	        listeners: {
	            keyup: function keyup(cmp, e) {
	                if (e.keyCode === 13 && this.eventKeyUpHandler) {
	                    this.eventKeyUpHandler(cmp, e);
	                }
	            }
	        }
	    });
	
	    return {
	        nameTextField: nameTextField,
	        descriptionTextField: descriptionTextField,
	        titleTextField: titleTextField
	    };
	};
	
	var _FavoriteStyle = __webpack_require__(25);
	
	var _FavoriteStyle2 = _interopRequireDefault(_FavoriteStyle);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	//# sourceMappingURL=FavoriteTextCmp.js.map

/***/ },
/* 40 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.FavoriteWindow = undefined;
	
	var _RenameWindow = __webpack_require__(41);
	
	var _SharingWindow = __webpack_require__(27);
	
	var _GridHeaders = __webpack_require__(64);
	
	var _FavoriteTextCmp = __webpack_require__(39);
	
	var _FavoriteTextCmp2 = _interopRequireDefault(_FavoriteTextCmp);
	
	var _FavoriteStyle = __webpack_require__(25);
	
	var _FavoriteStyle2 = _interopRequireDefault(_FavoriteStyle);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FavoriteWindow = exports.FavoriteWindow = undefined;
	
	exports.FavoriteWindow = FavoriteWindow = function FavoriteWindow(c, action) {
	    var appManager = c.appManager,
	        instanceManager = c.instanceManager,
	        uiManager = c.uiManager,
	        i18n = c.i18nManager.get(),
	        uiConfig = c.uiConfig,
	        apiPath = appManager.getApiPath(),
	        apiResource = instanceManager.apiResource,
	        apiEndpoint = instanceManager.apiEndpoint;
	
	    var getDirection,
	        getStoreUrl,
	        favoriteStore,
	        filtersStore,
	        getFilterUrlParam,
	        NameWindow,
	        nameWindow,
	        nameTextfield,
	        createButton,
	        updateButton,
	        cancelButton,
	        textfieldKeyUpHandlers,
	        showFavoritesLink,
	        showFavoritesLinkCt,
	        searchTextfield,
	        filtersComboBox,
	        descriptionPanel,
	        saveButtonHandler,
	        saveButton,
	        prevButton,
	        nextButton,
	        info,
	        gridHeaders,
	        renderers,
	        windowBbarSeparator,
	        windowBbar,
	        grid,
	        titles,
	        windowItems,
	        favoriteWindow,
	        nameColWidth = _FavoriteStyle2.default.windowCmpWidth - _FavoriteStyle2.default.createdColWidth - _FavoriteStyle2.default.lastUpdatedColWidth - _FavoriteStyle2.default.buttonColWidth - _FavoriteStyle2.default.paddingColWidth - 2,
	        storeFields = 'id,name,created,lastUpdated,access,title,description,user',
	        urlFields = 'id,displayName~rename(name),created,lastUpdated,access,title,description,user',
	        sortField = 'name',
	        sortDirection = 'asc',
	        cmpToToggle = [],
	        layout = instanceManager.getStateCurrent() || {};
	
	    var _getFavoriteTextCmp = (0, _FavoriteTextCmp2.default)({ layout: layout, i18n: i18n }),
	        nameTextField = _getFavoriteTextCmp.nameTextField,
	        descriptionTextField = _getFavoriteTextCmp.descriptionTextField;
	
	    getDirection = function getDirection(keepDir) {
	        return sortDirection = keepDir ? sortDirection : sortDirection === 'asc' ? 'desc' : 'asc';
	    };
	
	    getStoreUrl = function getStoreUrl(field, keepDir) {
	        sortField = field || sortField;
	
	        var value = action === 'open' ? searchTextfield.getValue() : null;
	
	        var url = apiPath + '/' + apiEndpoint + '.json?fields=' + urlFields + (value ? '&filter=displayName:ilike:' + value : '') + '&order=' + sortField + ':' + getDirection(keepDir);
	
	        var filterParam = getFilterUrlParam(filtersComboBox.value);
	
	        if (filterParam) {
	            url += '&filter=' + filterParam;
	        }
	
	        return url;
	    };
	
	    favoriteStore = Ext.create('Ext.data.Store', {
	        fields: storeFields.split(','),
	        proxy: {
	            type: 'ajax',
	            reader: {
	                type: 'json',
	                root: apiEndpoint
	            },
	            startParam: false,
	            limitParam: false
	        },
	        isLoaded: false,
	        pageSize: 10,
	        page: 1,
	        defaultUrl: apiPath + '/' + apiEndpoint + '.json?fields=' + urlFields + '&order=name:asc',
	        loadStore: function loadStore(url) {
	            this.proxy.url = encodeURI(url || this.defaultUrl);
	
	            this.load({
	                params: {
	                    pageSize: this.pageSize,
	                    page: this.page
	                }
	            });
	        },
	        loadFn: function loadFn(fn) {
	            if (this.isLoaded) {
	                fn.call();
	            } else {
	                this.load(fn);
	            }
	        },
	        get: function get(field, value) {
	            var index = this.findExact(field, value);
	            return index === -1 ? null : this.getAt(index);
	        },
	        listeners: {
	            load: function load(store, records) {
	                if (!this.isLoaded) {
	                    this.isLoaded = true;
	                }
	
	                // pager
	                var pager = store.proxy.reader.jsonData.pager;
	
	                info.setText('Page ' + pager.page + ' of ' + pager.pageCount);
	
	                prevButton.enable();
	                nextButton.enable();
	
	                if (pager.page === 1) {
	                    prevButton.disable();
	                }
	
	                if (pager.page === pager.pageCount) {
	                    nextButton.disable();
	                }
	            }
	        }
	    });
	
	    filtersStore = Ext.create('Ext.data.Store', {
	        fields: ['id', 'name'],
	        data: [{ id: 'SHOW_ALL', name: i18n.show_all }, { id: 'CREATED_BY_ME', name: i18n.created_by_me }, { id: 'CREATED_BY_OTHERS', name: i18n.created_by_others }]
	    });
	
	    getFilterUrlParam = function getFilterUrlParam(filterId) {
	        switch (filterId) {
	            case 'SHOW_ALL':
	                return null;
	            case 'CREATED_BY_ME':
	                return 'user.id:eq:' + appManager.userAccount.id;
	            case 'CREATED_BY_OTHERS':
	                return 'user.id:neq:' + appManager.userAccount.id;
	            default:
	                return null;
	        }
	    };
	
	    textfieldKeyUpHandlers = {
	        search: function search(cmp, e) {
	            var t = cmp,
	                value = Ext.isString(value) ? value : t.getValue();
	
	            if (action === 'open' && e.keyCode === 13 && favoriteStore.getRange().length) {
	                favoriteWindow.destroy();
	                instanceManager.getById(favoriteStore.getAt(0).data.id);
	            }
	
	            if (value !== t.currentValue) {
	                t.currentValue = value;
	
	                favoriteStore.page = 1;
	                favoriteStore.loadStore(getStoreUrl(null, true));
	            }
	        }
	    };
	
	    showFavoritesLink = Ext.create('Ext.form.Label', {
	        text: i18n.show_favorites,
	        style: 'color:#226aba',
	        nextAction: 'hide',
	        textMap: {
	            hide: i18n.hide_favorites,
	            show: i18n.show_favorites
	        },
	        toggle: function toggle() {
	            var t = this;
	
	            cmpToToggle.forEach(function (cmp) {
	                cmp[t.nextAction]();
	            });
	
	            this.nextAction = this.nextAction === 'hide' ? 'show' : 'hide';
	
	            this.setText(this.textMap[this.nextAction]);
	        },
	        listeners: {
	            render: function render(cmp) {
	                var t = this,
	                    el = this.getEl();
	
	                el.setStyle('cursor', 'pointer');
	
	                el.on('click', function () {
	                    t.toggle();
	                });
	            }
	        }
	    });
	
	    showFavoritesLinkCt = Ext.create('Ext.container.Container', {
	        width: _FavoriteStyle2.default.windowCmpWidth,
	        style: 'text-align:right; padding-right:7px; padding-bottom:4px',
	        items: showFavoritesLink
	    });
	
	    searchTextfield = Ext.create('Ext.form.field.Text', {
	        width: _FavoriteStyle2.default.windowCmpWidth - _FavoriteStyle2.default.filtersComboBoxWidth,
	        height: 27,
	        style: 'margin-bottom: 1px; display: inline-block',
	        fieldStyle: _FavoriteStyle2.default.textfieldStyle.concat(['color: #333']).join(';'),
	        emptyText: i18n.search_for_favorites + '..',
	        enableKeyEvents: true,
	        currentValue: '',
	        listeners: {
	            keyup: {
	                fn: function fn(cmp, e) {
	                    textfieldKeyUpHandlers['search'](cmp, e);
	                },
	                buffer: 100
	            }
	        }
	    });
	    cmpToToggle.push(searchTextfield);
	
	    filtersComboBox = Ext.create('Ext.form.field.ComboBox', {
	        width: _FavoriteStyle2.default.filtersComboBoxWidth,
	        height: 27,
	        style: 'display: inline-block; top: 7px; right: 5px',
	        fieldLabel: 'Filter',
	        labelWidth: 30,
	        store: filtersStore,
	        displayField: 'name',
	        valueField: 'id',
	        value: 'SHOW_ALL',
	        editable: false,
	        listeners: {
	            select: function select(_ref) {
	                var value = _ref.value;
	
	                var url = getStoreUrl(null, true, [getFilterUrlParam(value)]),
	                    store = favoriteStore;
	
	                store.page = store.page <= 1 ? 1 : store.page - 1;
	                store.loadStore(url);
	            }
	        }
	    });
	    cmpToToggle.push(filtersComboBox);
	
	    saveButton = Ext.create('Ext.button.Button', {
	        text: i18n.save,
	        // DHIS2-1147: avoid server conflict error when name value is not set
	        disabled: true,
	        xable: function xable() {
	            this.setDisabled(!nameTextField.getValue());
	        },
	        handler: function handler() {
	            saveButtonHandler();
	        }
	    });
	
	    saveButtonHandler = function saveButtonHandler() {
	        var name = nameTextField.getValue();
	
	        // DHIS2-1147: avoid submitting when no name is available
	        if (!name) {
	            return;
	        }
	
	        var currentLayout = instanceManager.getStateCurrent(),
	            id = instanceManager.getStateFavoriteId(),
	            description = descriptionTextField.getValue();
	
	        var preXhr = function preXhr() {
	            favoriteWindow.destroy();
	        };
	
	        var fn = function fn(id, success, r) {
	            currentLayout.id = id || currentLayout.id;
	            instanceManager.getById(currentLayout.id, function (layout, isFavorite) {
	                instanceManager.getReport(layout, isFavorite, false, false, function () {
	                    uiManager.unmask();
	                });
	            });
	        };
	
	        currentLayout.apply({
	            id: id,
	            name: name,
	            description: description
	        }, ['id', 'name', 'description']);
	
	        // search for a favorite with the same name
	        // and ask confirmation for replacing it
	        var request = new c.api.Request(c, {
	            baseUrl: apiPath + '/' + apiEndpoint + '.json?fields=id&filter=displayName:eq:' + name,
	            type: 'ajax',
	            method: 'GET',
	            success: function success(obj, _success, r) {
	                if (obj && obj.pager.total > 0 && obj[apiEndpoint].length) {
	                    uiManager.confirmReplace(i18n.save_favorite, function () {
	                        preXhr();
	                        currentLayout.clone().put(obj[apiEndpoint][0].id, fn, true, true);
	                    });
	                } else {
	                    preXhr();
	                    currentLayout.clone().post(fn, true, true);
	                }
	            }
	        });
	
	        request.run();
	    };
	
	    prevButton = Ext.create('Ext.button.Button', {
	        text: i18n.prev,
	        handler: function handler() {
	            var url = getStoreUrl(null, true),
	                store = favoriteStore;
	
	            store.page = store.page <= 1 ? 1 : store.page - 1;
	            store.loadStore(url);
	        }
	    });
	    cmpToToggle.push(prevButton);
	
	    nextButton = Ext.create('Ext.button.Button', {
	        text: i18n.next,
	        handler: function handler() {
	            var url = getStoreUrl(null, true),
	                store = favoriteStore;
	
	            store.page = store.page + 1;
	            store.loadStore(url);
	        }
	    });
	    cmpToToggle.push(nextButton);
	
	    info = Ext.create('Ext.form.Label', {
	        cls: 'ns-label-info',
	        width: 300,
	        height: 22
	    });
	    cmpToToggle.push(info);
	
	    gridHeaders = (0, _GridHeaders.GridHeaders)({
	        width: _FavoriteStyle2.default.windowCmpWidth,
	        height: 21,
	        direction: 'asc',
	        getDirection: function getDirection() {},
	        items: [{
	            text: i18n.name,
	            textAlign: 'left',
	            width: nameColWidth,
	            height: 20,
	            handler: function handler() {
	                var url = getStoreUrl('name'),
	                    store = favoriteStore;
	
	                store.page = 1;
	                store.loadStore(url);
	            }
	        }, {
	            text: i18n.created,
	            textAlign: 'left',
	            width: _FavoriteStyle2.default.createdColWidth,
	            height: 20,
	            direction: 'asc',
	            handler: function handler() {
	                var url = getStoreUrl('created'),
	                    store = favoriteStore;
	
	                store.page = 1;
	                store.loadStore(url);
	            }
	        }, {
	            text: i18n.last_updated,
	            textAlign: 'left',
	            width: _FavoriteStyle2.default.lastUpdatedColWidth,
	            height: 20,
	            direction: 'asc',
	            handler: function handler() {
	                var url = getStoreUrl('lastUpdated'),
	                    store = favoriteStore;
	
	                store.page = 1;
	                store.loadStore(url);
	            }
	        }]
	    });
	    cmpToToggle.push(gridHeaders);
	
	    renderers = {
	        open: function open(value, metaData, record) {
	            var fn = function fn() {
	                var element = Ext.get(record.data.id);
	
	                if (element) {
	                    element = element.parent('td');
	                    element.addClsOnOver('link');
	                    element.load = function () {
	                        favoriteWindow.destroy();
	                        instanceManager.getById(record.data.id);
	                    };
	                    element.handler = function () {
	                        if (instanceManager.isStateUnsaved()) {
	                            uiManager.confirmUnsaved(i18n.open, function () {
	                                element.load();
	                            });
	                        } else {
	                            element.load();
	                        }
	                    };
	                    element.dom.setAttribute('onclick', 'Ext.get(this).handler();');
	                }
	            };
	
	            Ext.defer(fn, 100);
	
	            return '<div id="' + record.data.id + '">' + value + '</div>';
	        },
	        saveas: function saveas(value, metaData, record) {
	            var fn = function fn() {
	                var element = Ext.get(record.data.id);
	
	                if (element) {
	                    element = element.parent('td');
	                    element.handler = function () {
	                        nameTextField.setValue(record.data.name);
	                        descriptionTextField.setValue(record.data.description);
	                    };
	                    element.dom.setAttribute('onclick', 'Ext.get(this).handler();');
	                }
	            };
	
	            Ext.defer(fn, 100);
	
	            return '<div id="' + record.data.id + '">' + value + '</div>';
	        }
	    };
	
	    windowBbarSeparator = Ext.create('Ext.toolbar.Separator', {
	        height: 20,
	        style: 'border-color:transparent; border-right-color:#d1d1d1; margin-right:4px'
	    });
	    cmpToToggle.push(windowBbarSeparator);
	
	    windowBbar = function () {
	        var items = [];
	
	        items.push(info, '->', prevButton, nextButton);
	
	        if (action === 'saveas') {
	            items.push(' ', windowBbarSeparator, ' ', saveButton);
	        }
	
	        return items;
	    }();
	
	    grid = Ext.create('Ext.grid.Panel', {
	        cls: 'ns-grid',
	        scroll: false,
	        hideHeaders: true,
	        columns: [{
	            dataIndex: 'name',
	            sortable: true,
	            width: nameColWidth,
	            renderer: renderers[action]
	        }, {
	            dataIndex: 'created',
	            sortable: true,
	            width: _FavoriteStyle2.default.createdColWidth,
	            renderer: function renderer(value) {
	                return (value || '').substring(0, 16).split('T').join(', ');
	            }
	        }, {
	            dataIndex: 'lastUpdated',
	            sortable: true,
	            width: _FavoriteStyle2.default.lastUpdatedColWidth,
	            renderer: function renderer(value) {
	                return (value || '').substring(0, 16).split('T').join(', ');
	            }
	        }, {
	            xtype: 'actioncolumn',
	            sortable: false,
	            width: _FavoriteStyle2.default.buttonColWidth,
	            items: [{
	                iconCls: 'ns-grid-row-icon-edit',
	                getClass: function getClass(value, metaData, record) {
	                    return 'tooltip-favorite-edit' + (!record.data.access.update ? ' disabled' : '');
	                },
	                handler: function handler(grid, rowIndex, colIndex, col, event) {
	                    var record = this.up('grid').store.getAt(rowIndex),
	                        x = event.target.x - nameColWidth - _FavoriteStyle2.default.lastUpdatedColWidth - _FavoriteStyle2.default.borderWidth + 6,
	                        y = event.target.y - 34,
	                        layoutObj = {
	                        id: record.data.id,
	                        name: record.data.name,
	                        description: record.data.description
	                    },
	                        listeners = {},
	                        fn;
	
	                    if (record.data.access.update) {
	                        fn = function fn() {
	                            favoriteStore.loadStore(getStoreUrl(null, true));
	                        };
	
	                        listeners.show = function () {
	                            favoriteWindow.destroyOnBlur = false;
	                        };
	
	                        listeners.destroy = function () {
	                            favoriteWindow.destroyOnBlur = true;
	                        };
	
	                        nameWindow = (0, _RenameWindow.RenameWindow)(c, layoutObj, fn, listeners);
	                        nameWindow.showAt(x, y);
	                    }
	                }
	            }, {
	                iconCls: 'ns-grid-row-icon-sharing',
	                getClass: function getClass(value, metaData, record) {
	                    return 'tooltip-favorite-sharing' + (!record.data.access.manage ? ' disabled' : '');
	                },
	                handler: function handler(grid, rowIndex) {
	                    var record = this.up('grid').store.getAt(rowIndex);
	
	                    if (record.data.access.manage) {
	                        instanceManager.getSharingById(record.data.id, function (r) {
	                            (0, _SharingWindow.SharingWindow)(c, r).show();
	                        });
	                    }
	                }
	            }, {
	                iconCls: 'ns-grid-row-icon-delete',
	                getClass: function getClass(value, metaData, record) {
	                    return 'tooltip-favorite-delete' + (!record.data.access['delete'] ? ' disabled' : '');
	                },
	                handler: function handler(grid, rowIndex, colIndex, col, event) {
	                    var record = this.up('grid').store.getAt(rowIndex),
	                        id = record.data.id,
	                        message;
	
	                    if (record.data.access['delete']) {
	                        uiManager.confirmDelete(i18n.delete_favorite, function () {
	                            instanceManager.delById(id, function () {
	                                // DHIS2-1475: preserve the filter when reloading the favorite list
	                                favoriteStore.loadStore(getStoreUrl(null, true));
	
	                                if (id === instanceManager.getStateFavoriteId()) {
	                                    instanceManager.setState();
	                                }
	                            }, true, true);
	                        });
	                    }
	                }
	            }]
	        }, {
	            sortable: false,
	            width: _FavoriteStyle2.default.paddingColWidth
	        }],
	        store: favoriteStore,
	        listeners: {
	            render: function render() {
	                var size = Math.floor((uiManager.getHeight() - 330) / uiConfig.grid_row_height);
	                this.store.pageSize = size;
	                this.store.page = 1;
	                this.store.loadStore();
	
	                favoriteStore.on('load', function () {
	                    if (this.isVisible()) {
	                        this.fireEvent('afterrender');
	                    }
	                }, this);
	            },
	            afterrender: function afterrender() {
	                var fn = function fn() {
	                    var editArray = Ext.query('.tooltip-favorite-edit'),
	                        sharingArray = Ext.query('.tooltip-favorite-sharing'),
	                        deleteArray = Ext.query('.tooltip-favorite-delete'),
	                        el;
	
	                    for (var i = 0; i < editArray.length; i++) {
	                        var el = editArray[i];
	                        Ext.create('Ext.tip.ToolTip', {
	                            target: el,
	                            html: i18n.rename,
	                            'anchor': 'bottom',
	                            anchorOffset: -14,
	                            showDelay: 1000
	                        });
	                    }
	
	                    for (var i = 0; i < sharingArray.length; i++) {
	                        el = sharingArray[i];
	                        Ext.create('Ext.tip.ToolTip', {
	                            target: el,
	                            html: i18n.share_with_other_people,
	                            'anchor': 'bottom',
	                            anchorOffset: -14,
	                            showDelay: 1000
	                        });
	                    }
	
	                    for (var i = 0; i < deleteArray.length; i++) {
	                        el = deleteArray[i];
	                        Ext.create('Ext.tip.ToolTip', {
	                            target: el,
	                            html: i18n.delete_,
	                            'anchor': 'bottom',
	                            anchorOffset: -14,
	                            showDelay: 1000
	                        });
	                    }
	                };
	
	                Ext.defer(fn, 100);
	            },
	            itemmouseenter: function itemmouseenter(grid, record, item) {
	                this.currentItem = Ext.get(item);
	                this.currentItem.removeCls('x-grid-row-over');
	            },
	            select: function select() {
	                if (action === 'open') {
	                    this.currentItem.removeCls('x-grid-row-selected');
	                }
	            },
	            selectionchange: function selectionchange() {
	                this.currentItem.removeCls('x-grid-row-focused');
	            },
	            itemdblclick: function itemdblclick() {
	                if (action === 'saveas') {
	                    saveButtonHandler();
	                }
	            }
	        }
	    });
	    cmpToToggle.push(grid);
	
	    titles = {
	        open: i18n.open_favorite,
	        saveas: i18n.save_favorite_as
	    };
	
	    windowItems = function () {
	        var items = [];
	
	        if (action === 'saveas') {
	            items.push(nameTextField, descriptionTextField, showFavoritesLinkCt);
	        }
	
	        items.push(searchTextfield, filtersComboBox, gridHeaders, grid);
	
	        return items;
	    }();
	
	    favoriteWindow = Ext.create('Ext.window.Window', {
	        title: titles[action],
	        bodyStyle: 'padding:1px; background-color:#fff',
	        resizable: false,
	        modal: true,
	        width: _FavoriteStyle2.default.windowWidth,
	        destroyOnBlur: true,
	        items: windowItems,
	        bbar: windowBbar,
	        listeners: {
	            show: function show(w) {
	                var favoriteButton = uiManager.get('favoriteButton') || {};
	
	                if (favoriteButton.rendered) {
	                    uiManager.setAnchorPosition(w, favoriteButton);
	
	                    if (!w.hasDestroyOnBlurHandler) {
	                        uiManager.addDestroyOnBlurHandler(w);
	                    }
	                }
	
	                (action === 'open' ? searchTextfield : nameTextField).focus(false, 500);
	
	                if (action === 'saveas') {
	                    showFavoritesLink.toggle();
	                }
	            },
	            destroy: function destroy(w) {
	                uiManager.unreg('favoriteWindow');
	            }
	        }
	    });
	
	    nameTextField.setEventKeyUpHandler(saveButtonHandler);
	    // DHIS2-1147: enable Save button on name value change
	    nameTextField.setEventChangeHandler(function () {
	        saveButton.xable();
	    });
	
	    return favoriteWindow;
	};
	//# sourceMappingURL=FavoriteWindow.js.map

/***/ },
/* 41 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.RenameWindow = undefined;
	
	var _isArray = __webpack_require__(1);
	
	var _isArray2 = _interopRequireDefault(_isArray);
	
	var _FavoriteTextCmp = __webpack_require__(39);
	
	var _FavoriteTextCmp2 = _interopRequireDefault(_FavoriteTextCmp);
	
	var _FavoriteStyle = __webpack_require__(25);
	
	var _FavoriteStyle2 = _interopRequireDefault(_FavoriteStyle);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var RenameWindow = exports.RenameWindow = undefined;
	
	exports.RenameWindow = RenameWindow = function RenameWindow(refs, layout, fn, listeners) {
	    var t = this,
	        appManager = refs.appManager,
	        uiManager = refs.uiManager,
	        instanceManager = refs.instanceManager,
	        i18n = refs.i18nManager.get(),
	        uiConfig = refs.uiConfig,
	        api = refs.api,
	        apiPath = appManager.getApiPath(),
	        apiEndpoint = instanceManager.apiEndpoint;
	
	    listeners = listeners || {};
	
	    var _getFavoriteTextCmp = (0, _FavoriteTextCmp2.default)({ layout: layout, i18n: i18n }),
	        nameTextField = _getFavoriteTextCmp.nameTextField,
	        descriptionTextField = _getFavoriteTextCmp.descriptionTextField;
	
	    var renameButton = Ext.create('Ext.button.Button', {
	        text: i18n.update,
	        handler: function handler() {
	            var name = nameTextField.getValue(),
	                description = descriptionTextField.getValue(),
	                patch = function patch() {
	                var properties = {
	                    name: name,
	                    description: description
	                };
	
	                layout.apply(properties);
	
	                layout.patch(properties, function () {
	                    if (fn) {
	                        fn();
	                    }
	                    instanceManager.getById(null, function (layout, isFavorite) {
	                        instanceManager.getReport(layout, isFavorite, false, false, function () {
	                            uiManager.unmask();
	                        });
	                    });
	                    window.destroy();
	                }, true, true);
	            };
	
	            if (layout.patch) {
	                patch();
	            } else {
	                var fields = appManager.getAnalysisFields(),
	                    url = apiPath + '/' + apiEndpoint + '/' + layout.id + '.json?fields=' + fields;
	
	                $.getJSON(encodeURI(url), function (r) {
	                    layout = new api.Layout(refs, r).val();
	                    patch();
	                });
	            }
	        }
	    });
	
	    var cancelButton = Ext.create('Ext.button.Button', {
	        text: i18n.cancel,
	        handler: function handler() {
	            window.destroy();
	        }
	    });
	
	    var window = Ext.create('Ext.window.Window', {
	        title: id ? 'Rename favorite' : 'Create new favorite',
	        bodyStyle: 'padding:1px; background:#fff',
	        resizable: false,
	        modal: true,
	        items: [nameTextField, descriptionTextField],
	        destroyOnBlur: true,
	        bbar: [cancelButton, '->', renameButton],
	        listeners: {
	            show: function show(w) {
	                var favoriteButton = uiManager.get('favoriteButton') || {};
	
	                if (favoriteButton.rendered) {
	                    uiManager.setAnchorPosition(w, favoriteButton);
	
	                    if (!w.hasDestroyOnBlurHandler) {
	                        uiManager.addDestroyOnBlurHandler(w);
	                    }
	                }
	
	                nameTextField.focus(false, 500);
	
	                if (listeners.show) {
	                    listeners.show();
	                }
	            },
	            destroy: function destroy() {
	                if (listeners.destroy) {
	                    listeners.destroy();
	                }
	            }
	        }
	    });
	
	    return window;
	};
	//# sourceMappingURL=RenameWindow.js.map

/***/ },
/* 42 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = arrayDifference;
	
	var _arrayUnique = __webpack_require__(14);
	
	var _arrayUnique2 = _interopRequireDefault(_arrayUnique);
	
	var _arrayContains = __webpack_require__(4);
	
	var _arrayContains2 = _interopRequireDefault(_arrayContains);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 *
	 * @param {Array} array1
	 * @param {Array} array2
	 * @param {boolean} biDirectional False returns A-B while true returns A-B concat B-A
	 * @returns {Array}
	 *
	 * @throws {TypeError} When `filter` can not be found on `array`. This generally happens when the array is `null` or `undefined`
	 *
	 * @example
	 * const a = [1, 2];
	 * const b = [1, 3];
	 * difference(a, b) // returns: [2]
	 * difference(a, b, true) // returns: [2, 3]
	 */
	function arrayDifference(array1, array2, biDirectional) {
	    return (0, _arrayUnique2.default)(array1.filter(function (item) {
	        return !(0, _arrayContains2.default)(array2, item);
	    }).concat(biDirectional === true ? array2.filter(function (item) {
	        return !(0, _arrayContains2.default)(array1, item);
	    }) : []));
	}
	//# sourceMappingURL=arrayDifference.js.map

/***/ },
/* 43 */
[603, 11],
/* 44 */
/***/ function(module, exports) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	// css base code, injected by the css-loader
	module.exports = function() {
		var list = [];
	
		// return the list of modules as css string
		list.toString = function toString() {
			var result = [];
			for(var i = 0; i < this.length; i++) {
				var item = this[i];
				if(item[2]) {
					result.push("@media " + item[2] + "{" + item[1] + "}");
				} else {
					result.push(item[1]);
				}
			}
			return result.join("");
		};
	
		// import a list of modules into the list
		list.i = function(modules, mediaQuery) {
			if(typeof modules === "string")
				modules = [[null, modules, ""]];
			var alreadyImportedModules = {};
			for(var i = 0; i < this.length; i++) {
				var id = this[i][0];
				if(typeof id === "number")
					alreadyImportedModules[id] = true;
			}
			for(i = 0; i < modules.length; i++) {
				var item = modules[i];
				// skip already imported module
				// this implementation is not 100% perfect for weird media query combinations
				//  when a module is imported multiple times with different media queries.
				//  I hope this will never occur (Hey this way we have smaller bundles)
				if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
					if(mediaQuery && !item[2]) {
						item[2] = mediaQuery;
					} else if(mediaQuery) {
						item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
					}
					list.push(item);
				}
			}
		};
		return list;
	};


/***/ },
/* 45 */
4,
/* 46 */
[605, 78],
/* 47 */
/***/ function(module, exports, __webpack_require__) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	var stylesInDom = {},
		memoize = function(fn) {
			var memo;
			return function () {
				if (typeof memo === "undefined") memo = fn.apply(this, arguments);
				return memo;
			};
		},
		isOldIE = memoize(function() {
			return /msie [6-9]\b/.test(window.navigator.userAgent.toLowerCase());
		}),
		getHeadElement = memoize(function () {
			return document.head || document.getElementsByTagName("head")[0];
		}),
		singletonElement = null,
		singletonCounter = 0,
		styleElementsInsertedAtTop = [];
	
	module.exports = function(list, options) {
		if(false) {
			if(typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
		}
	
		options = options || {};
		// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
		// tags it will allow on a page
		if (typeof options.singleton === "undefined") options.singleton = isOldIE();
	
		// By default, add <style> tags to the bottom of <head>.
		if (typeof options.insertAt === "undefined") options.insertAt = "bottom";
	
		var styles = listToStyles(list);
		addStylesToDom(styles, options);
	
		return function update(newList) {
			var mayRemove = [];
			for(var i = 0; i < styles.length; i++) {
				var item = styles[i];
				var domStyle = stylesInDom[item.id];
				domStyle.refs--;
				mayRemove.push(domStyle);
			}
			if(newList) {
				var newStyles = listToStyles(newList);
				addStylesToDom(newStyles, options);
			}
			for(var i = 0; i < mayRemove.length; i++) {
				var domStyle = mayRemove[i];
				if(domStyle.refs === 0) {
					for(var j = 0; j < domStyle.parts.length; j++)
						domStyle.parts[j]();
					delete stylesInDom[domStyle.id];
				}
			}
		};
	}
	
	function addStylesToDom(styles, options) {
		for(var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];
			if(domStyle) {
				domStyle.refs++;
				for(var j = 0; j < domStyle.parts.length; j++) {
					domStyle.parts[j](item.parts[j]);
				}
				for(; j < item.parts.length; j++) {
					domStyle.parts.push(addStyle(item.parts[j], options));
				}
			} else {
				var parts = [];
				for(var j = 0; j < item.parts.length; j++) {
					parts.push(addStyle(item.parts[j], options));
				}
				stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
			}
		}
	}
	
	function listToStyles(list) {
		var styles = [];
		var newStyles = {};
		for(var i = 0; i < list.length; i++) {
			var item = list[i];
			var id = item[0];
			var css = item[1];
			var media = item[2];
			var sourceMap = item[3];
			var part = {css: css, media: media, sourceMap: sourceMap};
			if(!newStyles[id])
				styles.push(newStyles[id] = {id: id, parts: [part]});
			else
				newStyles[id].parts.push(part);
		}
		return styles;
	}
	
	function insertStyleElement(options, styleElement) {
		var head = getHeadElement();
		var lastStyleElementInsertedAtTop = styleElementsInsertedAtTop[styleElementsInsertedAtTop.length - 1];
		if (options.insertAt === "top") {
			if(!lastStyleElementInsertedAtTop) {
				head.insertBefore(styleElement, head.firstChild);
			} else if(lastStyleElementInsertedAtTop.nextSibling) {
				head.insertBefore(styleElement, lastStyleElementInsertedAtTop.nextSibling);
			} else {
				head.appendChild(styleElement);
			}
			styleElementsInsertedAtTop.push(styleElement);
		} else if (options.insertAt === "bottom") {
			head.appendChild(styleElement);
		} else {
			throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");
		}
	}
	
	function removeStyleElement(styleElement) {
		styleElement.parentNode.removeChild(styleElement);
		var idx = styleElementsInsertedAtTop.indexOf(styleElement);
		if(idx >= 0) {
			styleElementsInsertedAtTop.splice(idx, 1);
		}
	}
	
	function createStyleElement(options) {
		var styleElement = document.createElement("style");
		styleElement.type = "text/css";
		insertStyleElement(options, styleElement);
		return styleElement;
	}
	
	function createLinkElement(options) {
		var linkElement = document.createElement("link");
		linkElement.rel = "stylesheet";
		insertStyleElement(options, linkElement);
		return linkElement;
	}
	
	function addStyle(obj, options) {
		var styleElement, update, remove;
	
		if (options.singleton) {
			var styleIndex = singletonCounter++;
			styleElement = singletonElement || (singletonElement = createStyleElement(options));
			update = applyToSingletonTag.bind(null, styleElement, styleIndex, false);
			remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true);
		} else if(obj.sourceMap &&
			typeof URL === "function" &&
			typeof URL.createObjectURL === "function" &&
			typeof URL.revokeObjectURL === "function" &&
			typeof Blob === "function" &&
			typeof btoa === "function") {
			styleElement = createLinkElement(options);
			update = updateLink.bind(null, styleElement);
			remove = function() {
				removeStyleElement(styleElement);
				if(styleElement.href)
					URL.revokeObjectURL(styleElement.href);
			};
		} else {
			styleElement = createStyleElement(options);
			update = applyToTag.bind(null, styleElement);
			remove = function() {
				removeStyleElement(styleElement);
			};
		}
	
		update(obj);
	
		return function updateStyle(newObj) {
			if(newObj) {
				if(newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap)
					return;
				update(obj = newObj);
			} else {
				remove();
			}
		};
	}
	
	var replaceText = (function () {
		var textStore = [];
	
		return function (index, replacement) {
			textStore[index] = replacement;
			return textStore.filter(Boolean).join('\n');
		};
	})();
	
	function applyToSingletonTag(styleElement, index, remove, obj) {
		var css = remove ? "" : obj.css;
	
		if (styleElement.styleSheet) {
			styleElement.styleSheet.cssText = replaceText(index, css);
		} else {
			var cssNode = document.createTextNode(css);
			var childNodes = styleElement.childNodes;
			if (childNodes[index]) styleElement.removeChild(childNodes[index]);
			if (childNodes.length) {
				styleElement.insertBefore(cssNode, childNodes[index]);
			} else {
				styleElement.appendChild(cssNode);
			}
		}
	}
	
	function applyToTag(styleElement, obj) {
		var css = obj.css;
		var media = obj.media;
	
		if(media) {
			styleElement.setAttribute("media", media)
		}
	
		if(styleElement.styleSheet) {
			styleElement.styleSheet.cssText = css;
		} else {
			while(styleElement.firstChild) {
				styleElement.removeChild(styleElement.firstChild);
			}
			styleElement.appendChild(document.createTextNode(css));
		}
	}
	
	function updateLink(linkElement, obj) {
		var css = obj.css;
		var sourceMap = obj.sourceMap;
	
		if(sourceMap) {
			// http://stackoverflow.com/a/26603875
			css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
		}
	
		var blob = new Blob([css], { type: "text/css" });
	
		var oldSrc = linkElement.href;
	
		linkElement.href = URL.createObjectURL(blob);
	
		if(oldSrc)
			URL.revokeObjectURL(oldSrc);
	}


/***/ },
/* 48 */
/***/ function(module, exports, __webpack_require__) {

	// 0 -> Array#forEach
	// 1 -> Array#map
	// 2 -> Array#filter
	// 3 -> Array#some
	// 4 -> Array#every
	// 5 -> Array#find
	// 6 -> Array#findIndex
	var ctx      = __webpack_require__(50)
	  , IObject  = __webpack_require__(103)
	  , toObject = __webpack_require__(54)
	  , toLength = __webpack_require__(53)
	  , asc      = __webpack_require__(98);
	module.exports = function(TYPE, $create){
	  var IS_MAP        = TYPE == 1
	    , IS_FILTER     = TYPE == 2
	    , IS_SOME       = TYPE == 3
	    , IS_EVERY      = TYPE == 4
	    , IS_FIND_INDEX = TYPE == 6
	    , NO_HOLES      = TYPE == 5 || IS_FIND_INDEX
	    , create        = $create || asc;
	  return function($this, callbackfn, that){
	    var O      = toObject($this)
	      , self   = IObject(O)
	      , f      = ctx(callbackfn, that, 3)
	      , length = toLength(self.length)
	      , index  = 0
	      , result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined
	      , val, res;
	    for(;length > index; index++)if(NO_HOLES || index in self){
	      val = self[index];
	      res = f(val, index, O);
	      if(TYPE){
	        if(IS_MAP)result[index] = res;            // map
	        else if(res)switch(TYPE){
	          case 3: return true;                    // some
	          case 5: return val;                     // find
	          case 6: return index;                   // findIndex
	          case 2: result.push(val);               // filter
	        } else if(IS_EVERY)return false;          // every
	      }
	    }
	    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
	  };
	};

/***/ },
/* 49 */
/***/ function(module, exports) {

	var toString = {}.toString;
	
	module.exports = function(it){
	  return toString.call(it).slice(8, -1);
	};

/***/ },
/* 50 */
/***/ function(module, exports, __webpack_require__) {

	// optional / simple context binding
	var aFunction = __webpack_require__(94);
	module.exports = function(fn, that, length){
	  aFunction(fn);
	  if(that === undefined)return fn;
	  switch(length){
	    case 1: return function(a){
	      return fn.call(that, a);
	    };
	    case 2: return function(a, b){
	      return fn.call(that, a, b);
	    };
	    case 3: return function(a, b, c){
	      return fn.call(that, a, b, c);
	    };
	  }
	  return function(/* ...args */){
	    return fn.apply(that, arguments);
	  };
	};

/***/ },
/* 51 */
/***/ function(module, exports) {

	module.exports = function(exec){
	  try {
	    return !!exec();
	  } catch(e){
	    return true;
	  }
	};

/***/ },
/* 52 */
/***/ function(module, exports) {

	// 7.1.4 ToInteger
	var ceil  = Math.ceil
	  , floor = Math.floor;
	module.exports = function(it){
	  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
	};

/***/ },
/* 53 */
/***/ function(module, exports, __webpack_require__) {

	// 7.1.15 ToLength
	var toInteger = __webpack_require__(52)
	  , min       = Math.min;
	module.exports = function(it){
	  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
	};

/***/ },
/* 54 */
/***/ function(module, exports, __webpack_require__) {

	// 7.1.13 ToObject(argument)
	var defined = __webpack_require__(99);
	module.exports = function(it){
	  return Object(defined(it));
	};

/***/ },
/* 55 */
/***/ function(module, exports) {

	var id = 0
	  , px = Math.random();
	module.exports = function(key){
	  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
	};

/***/ },
/* 56 */
/***/ function(module, exports, __webpack_require__) {

	var store      = __webpack_require__(108)('wks')
	  , uid        = __webpack_require__(55)
	  , Symbol     = __webpack_require__(19).Symbol
	  , USE_SYMBOL = typeof Symbol == 'function';
	
	var $exports = module.exports = function(name){
	  return store[name] || (store[name] =
	    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
	};
	
	$exports.store = store;

/***/ },
/* 57 */
/***/ function(module, exports, __webpack_require__) {

	var d2Analysis = __webpack_require__(129);
	
	module.exports = d2Analysis;


/***/ },
/* 58 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.Dimension = undefined;
	
	var _isString = __webpack_require__(3);
	
	var _isString2 = _interopRequireDefault(_isString);
	
	var _isObject = __webpack_require__(2);
	
	var _isObject2 = _interopRequireDefault(_isObject);
	
	var _arrayFrom = __webpack_require__(5);
	
	var _arrayFrom2 = _interopRequireDefault(_arrayFrom);
	
	var _arrayContains = __webpack_require__(4);
	
	var _arrayContains2 = _interopRequireDefault(_arrayContains);
	
	var _arrayPluck = __webpack_require__(28);
	
	var _arrayPluck2 = _interopRequireDefault(_arrayPluck);
	
	var _arrayUnique = __webpack_require__(14);
	
	var _arrayUnique2 = _interopRequireDefault(_arrayUnique);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var REQUIRED_DIMENSIONS = ['dx', 'pe', 'ou'];
	
	var Dimension = exports.Dimension = undefined;
	
	exports.Dimension = Dimension = function Dimension(refs, config) {
	    var t = this;
	
	    config = (0, _isObject2.default)(config) ? config : {};
	    config.items = (0, _arrayFrom2.default)(config.items);
	
	    var Record = refs.api.Record;
	
	    // constructor
	
	    t.dimension = config.dimension;
	
	    t.items = config.items.map(function (record) {
	        return new Record(refs, record).val();
	    });
	
	    if (config.sorted) {
	        t.sorted = config.sorted;
	    }
	
	    t.getRefs = function () {
	        return refs;
	    };
	};
	
	Dimension.prototype.log = function (text, noError) {
	    if (!noError) {
	        console.log(text, this);
	    }
	};
	
	Dimension.prototype.val = function (noError) {
	
	    // error
	    if (!(0, _isString2.default)(this.dimension)) {
	        this.log('(Dimension) Dimension is not a string', noError);
	        return null;
	    }
	
	    // warning
	    if (!this.items.length && !(0, _arrayContains2.default)(['co', 'dy', 'longitude', 'latitude'], this.dimension)) {//todo use centralised keys
	        //this.log('(Dimension) No items', noError);
	        //return null;
	    }
	
	    return this;
	};
	
	Dimension.prototype.add = function (recordConfig) {
	    var t = this,
	        refs = t.getRefs();
	
	    var Record = refs.api.Record;
	
	
	    var record = new Record(refs, recordConfig).val();
	
	    if (record) {
	        this.items.push(record);
	    }
	};
	
	Dimension.prototype.getRecords = function (sortProperty, response, isPure) {
	    var records = response ? response.getRecordsByDimensionName(this.dimension) : this.items;
	
	    if (isPure) {
	        records = records.slice(0);
	    }
	
	    sortProperty = (0, _arrayContains2.default)(['id', 'name'], sortProperty) ? sortProperty : null;
	
	    return sortProperty ? records.sort(function (a, b) {
	        return a[sortProperty] > b[sortProperty];
	    }) : records;
	};
	
	Dimension.prototype.removeItems = function () {
	    this.items = [];
	};
	
	Dimension.prototype.isRequired = function () {
	    return (0, _arrayContains2.default)(REQUIRED_DIMENSIONS, this.dimension);
	};
	
	// dep 1
	
	Dimension.prototype.getRecordIds = function (isSorted, response, isPure) {
	    var rec = this.getRecords(isSorted ? 'id' : null, response, isPure);
	
	    return (0, _arrayPluck2.default)(rec, 'id');
	};
	
	Dimension.prototype.getRecordNames = function (isSorted, response, isPure) {
	    return (0, _arrayPluck2.default)(this.getRecords(isSorted ? 'name' : null, response, isPure), 'name');
	};
	
	Dimension.prototype.extendRecords = function (response) {
	    var t = this;
	
	    var records = t.getRecords();
	
	    records.forEach(function (record) {
	        record.setName(null, response);
	    });
	
	    return records;
	};
	
	Dimension.prototype.toPlugin = function () {
	    delete this.klass;
	
	    this.items.forEach(function (record) {
	        record.toPlugin();
	    });
	};
	
	Dimension.prototype.toPost = function () {
	    delete this.klass;
	
	    this.items.forEach(function (record) {
	        record.toPost();
	    });
	};
	
	// dep 2
	
	Dimension.prototype.url = function (isSorted, response, isFilter) {
	    var url = (isFilter ? 'filter' : 'dimension') + '=' + this.dimension,
	        records = (0, _arrayUnique2.default)(this.getRecordIds(isSorted, response, true));
	
	    url += records.length ? ':' + records.join(';') : '';
	
	    return url;
	};
	//# sourceMappingURL=Dimension.js.map

/***/ },
/* 59 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.Period = undefined;
	
	var _isNumeric = __webpack_require__(22);
	
	var _isNumeric2 = _interopRequireDefault(_isNumeric);
	
	var _arrayContains = __webpack_require__(4);
	
	var _arrayContains2 = _interopRequireDefault(_arrayContains);
	
	var _arrayFrom = __webpack_require__(5);
	
	var _arrayFrom2 = _interopRequireDefault(_arrayFrom);
	
	var _arrayUnique = __webpack_require__(14);
	
	var _arrayUnique2 = _interopRequireDefault(_arrayUnique);
	
	var _stringTrim = __webpack_require__(190);
	
	var _stringTrim2 = _interopRequireDefault(_stringTrim);
	
	var _numberConstrain = __webpack_require__(68);
	
	var _numberConstrain2 = _interopRequireDefault(_numberConstrain);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Period = exports.Period = undefined;
	
	exports.Period = Period = function Period(config, refs) {
	    var t = this;
	
	    t.id = '' + config.id;
	    t.name = config.name;
	
	    // constants
	    t.yearOffset = 5;
	
	    // transient
	    t.year = t.id.slice(0, 4);
	    t.offset = parseInt(t.year) - new Date().getFullYear();
	    t.generator = refs.calendarManager.periodGenerator;
	
	    t.i18n = refs.i18nManager.get();
	
	    // uninitialized
	    t.sortId;
	
	    t.typeSortId;
	    t.typeName;
	
	    t.displayName;
	
	    t.getContextMenuItemsConfig;
	};
	
	Period.prototype.getPrefixedNumber = function (number) {
	    return parseInt(number) < 10 ? '0' + number : number;
	};
	
	Period.prototype.getNameByIdAndType = function (type, id, year) {
	    var t = this;
	
	    year = year || this.year;
	
	    var offset = parseInt(year) - new Date().getFullYear(),
	        periods = t.generator.generateReversedPeriods(type, offset);
	
	    for (var i = 0; i < periods.length; i++) {
	        if (periods[i].iso === id) {
	            return periods[i].name;
	        }
	    }
	};
	
	Period.prototype.getItemifiedPeriods = function (periods) {
	    var items = [];
	
	    periods = (0, _arrayFrom2.default)(periods);
	
	    for (var i = 0; i < periods.length; i++) {
	        items.push({
	            id: periods[i].iso,
	            name: periods[i].name
	        });
	    }
	
	    return items;
	};
	
	Period.prototype.gen = function (type, offset) {
	    return this.generator.generatePeriods(type, offset);
	};
	
	Period.prototype.genRev = function (type, offset) {
	    return this.generator.generateReversedPeriods(type, offset);
	};
	
	Period.prototype.getTypeById = function (id) {
	    if (!(0, _isNumeric2.default)(id.slice(0, 4))) {
	        return;
	    }
	
	    if (id.length === 4) {
	        return 'Yearly';
	    } else if ((0, _arrayContains2.default)([6, 7], id.length)) {
	        if ((0, _isNumeric2.default)(id)) {
	            return 'Monthly';
	        } else if (id.indexOf('W') !== -1) {
	            return 'Weekly';
	        } else if (id.indexOf('Q') !== -1) {
	            return 'Quarterly';
	        } else if (id.indexOf('S') !== -1) {
	            return 'SixMonthly';
	        } else if (id.indexOf('B') !== -1) {
	            return 'BiMonthly';
	        } else if (id.indexOf('Oct') !== -1) {
	            return 'FinancialOct';
	        }
	    } else if (id.length === 8) {
	        if ((0, _isNumeric2.default)(id.slice(4, 8))) {
	            return 'Daily';
	        } else if (id.indexOf('July') !== -1) {
	            return 'FinancialJuly';
	        }
	    } else if (id.length === 9) {
	        if (id.indexOf('April') !== -1) {
	            return 'FinancialApril';
	        }
	    } else if (id.length === 11) {
	        if (id.indexOf('AprilS') !== -1) {
	            return 'SixMonthlyApril';
	        }
	    }
	};
	
	Period.prototype.getNameByParents = function (parents, defaultName) {
	    if (parents.length !== 1 || parents[0].name === undefined) {
	        return defaultName;
	    }
	
	    return defaultName + ' (' + parents[0].name + ')';
	};
	
	// dep 1
	
	Period.prototype.getItemsByTypeByFinancialApril = function (type, isAll) {
	    var startDate = this.year + '-04-01';
	    var endDate = parseInt(this.year) + 1 + '-03-31';
	    var startMonth = this.year + '-04';
	    var endMonth = parseInt(this.year) + 1 + '-04';
	
	    // used by daily, weekly, monthly
	    var thisPeriods = this.gen(type, this.offset);
	    var thisSliceStartIndex;
	    var nextPeriods = this.gen(type, this.offset + 1);
	    var nextSliceEndIndex;
	
	    var thisYear;
	    var nextYear;
	
	    if (type === 'FinancialApril') {
	        if (isAll) {
	            return this.getItemifiedPeriods(this.gen(type, this.offset - 1 + this.yearOffset).slice(0, 2));
	        }
	
	        return this.getItemifiedPeriods(this.gen(type, this.offset + this.yearOffset).slice(0, 1));
	    } else if (type === 'FinancialJuly') {
	        return this.getItemifiedPeriods(this.gen(type, this.offset - 1 + this.yearOffset).slice(0, 2));
	    } else if (type === 'FinancialOct') {
	        return this.getItemifiedPeriods(this.gen(type, this.offset - 1 + this.yearOffset).slice(0, 2));
	    } else if (type === 'Yearly') {
	        thisYear = this.gen(type, this.offset + this.yearOffset)[0];
	        nextYear = this.gen(type, this.offset + 1 + this.yearOffset)[0];
	
	        return this.getItemifiedPeriods([thisYear, nextYear]);
	    } else if (type === 'SixMonthlyApril') {
	        return this.getItemifiedPeriods(thisPeriods);
	    } else if (type === 'SixMonthly') {
	        return this.getItemifiedPeriods([].concat(thisPeriods, nextPeriods.slice(0, 1)));
	    } else if (type === 'Quarterly') {
	        return this.getItemifiedPeriods([].concat(thisPeriods.slice(1), nextPeriods.slice(0, 1)));
	    } else if (type === 'BiMonthly') {
	        return this.getItemifiedPeriods([].concat(thisPeriods.slice(1), nextPeriods.slice(0, 2)));
	    } else if (type === 'Monthly') {
	        for (var i = 0, month; i < thisPeriods.length; i++) {
	            month = thisPeriods[i];
	
	            if (month.startDate.slice(0, 7) === startMonth) {
	                thisSliceStartIndex = i;
	            }
	        }
	
	        for (var j = 0, month; j < nextPeriods.length; j++) {
	            month = nextPeriods[j];
	
	            if (month.startDate.slice(0, 7) === endMonth) {
	                nextSliceEndIndex = j;
	            }
	        }
	
	        return this.getItemifiedPeriods([].concat(thisPeriods.slice(thisSliceStartIndex), nextPeriods.slice(0, nextSliceEndIndex)));
	    } else if (type === 'Weekly') {
	        for (var i = 0, week; i < thisPeriods.length; i++) {
	            week = thisPeriods[i];
	
	            if (week.startDate.slice(0, 7) === startMonth || week.endDate.slice(0, 7) === startMonth) {
	                thisSliceStartIndex = i;
	            }
	        }
	
	        for (var j = 0, week; j < nextPeriods.length; j++) {
	            week = nextPeriods[j];
	
	            if (week.startDate.slice(0, 7) === endMonth && week.endDate.slice(0, 7) === endMonth) {
	                nextSliceEndIndex = j;
	            }
	        }
	
	        return this.getItemifiedPeriods([].concat(thisPeriods.slice(thisSliceStartIndex), nextPeriods.slice(0, nextSliceEndIndex)));
	    } else if (type === 'Daily') {
	        for (var i = 0, day; i < thisPeriods.length; i++) {
	            if (thisPeriods[i].startDate === startDate) {
	                thisSliceStartIndex = i;
	            }
	        }
	
	        for (var j = 0, day; j < nextPeriods.length; j++) {
	            if (nextPeriods[j].endDate === endDate) {
	                nextSliceEndIndex = j + 1;
	            }
	        }
	
	        return this.getItemifiedPeriods([].concat(thisPeriods.slice(thisSliceStartIndex), nextPeriods.slice(0, nextSliceEndIndex)));
	    }
	
	    return [];
	};
	
	Period.prototype.getItemsByTypeByFinancialJuly = function (type, isAll) {
	    var startDate = this.year + '-07-01';
	    var endDate = parseInt(this.year) + 1 + '-06-30';
	    var startMonth = this.year + '-07';
	    var endMonth = parseInt(this.year) + 1 + '-07';
	
	    // used by daily, weekly, monthly
	    var thisPeriods = this.gen(type, this.offset);
	    var thisSliceStartIndex;
	    var nextPeriods = this.gen(type, this.offset + 1);
	    var nextSliceEndIndex;
	
	    var thisYear;
	    var nextYear;
	
	    if (type === 'FinancialApril') {
	        return this.getItemifiedPeriods(this.gen(type, this.offset + this.yearOffset).slice(0, 2));
	    } else if (type === 'FinancialJuly') {
	        if (isAll) {
	            return this.getItemifiedPeriods(this.gen(type, this.offset - 1 + this.yearOffset).slice(0, 2));
	        }
	
	        return this.getItemifiedPeriods(this.gen(type, this.offset + this.yearOffset).slice(0, 1));
	    } else if (type === 'FinancialOct') {
	        return this.getItemifiedPeriods(this.gen(type, this.offset - 1 + this.yearOffset).slice(0, 2));
	    } else if (type === 'Yearly') {
	        thisYear = this.gen(type, this.offset + this.yearOffset)[0];
	        nextYear = this.gen(type, this.offset + 1 + this.yearOffset)[0];
	
	        return this.getItemifiedPeriods([thisYear, nextYear]);
	    } else if (type === 'SixMonthlyApril') {
	        return this.getItemifiedPeriods([].concat(thisPeriods, nextPeriods.slice(0, 1)));
	    } else if (type === 'SixMonthly') {
	        return this.getItemifiedPeriods([].concat(thisPeriods.slice(1), nextPeriods.slice(0, 1)));
	    } else if (type === 'Quarterly') {
	        return this.getItemifiedPeriods([].concat(thisPeriods.slice(2), nextPeriods.slice(0, 2)));
	    } else if (type === 'BiMonthly') {
	        return this.getItemifiedPeriods([].concat(thisPeriods.slice(3), nextPeriods.slice(0, 3)));
	    } else if (type === 'Monthly') {
	        for (var i = 0, month; i < thisPeriods.length; i++) {
	            month = thisPeriods[i];
	
	            if (month.startDate.slice(0, 7) === startMonth) {
	                thisSliceStartIndex = i;
	            }
	        }
	
	        for (var j = 0, month; j < nextPeriods.length; j++) {
	            month = nextPeriods[j];
	
	            if (month.startDate.slice(0, 7) === endMonth) {
	                nextSliceEndIndex = j;
	            }
	        }
	
	        return this.getItemifiedPeriods([].concat(thisPeriods.slice(thisSliceStartIndex), nextPeriods.slice(0, nextSliceEndIndex)));
	    } else if (type === 'Weekly') {
	        for (var i = 0, week; i < thisPeriods.length; i++) {
	            week = thisPeriods[i];
	
	            if (week.startDate.slice(0, 7) === startMonth || week.endDate.slice(0, 7) === startMonth) {
	                thisSliceStartIndex = i;
	            }
	        }
	
	        for (var j = 0, week; j < nextPeriods.length; j++) {
	            week = nextPeriods[j];
	
	            if (week.startDate.slice(0, 7) === endMonth && week.endDate.slice(0, 7) === endMonth) {
	                nextSliceEndIndex = j;
	            }
	        }
	
	        return this.getItemifiedPeriods([].concat(thisPeriods.slice(thisSliceStartIndex), nextPeriods.slice(0, nextSliceEndIndex)));
	    } else if (type === 'Daily') {
	        for (var i = 0, day; i < thisPeriods.length; i++) {
	            if (thisPeriods[i].startDate === startDate) {
	                thisSliceStartIndex = i;
	            }
	        }
	
	        for (var j = 0, day; j < nextPeriods.length; j++) {
	            if (nextPeriods[j].endDate === endDate) {
	                nextSliceEndIndex = j + 1;
	            }
	        }
	
	        return this.getItemifiedPeriods([].concat(thisPeriods.slice(thisSliceStartIndex), nextPeriods.slice(0, nextSliceEndIndex)));
	    }
	
	    return [];
	};
	
	Period.prototype.getItemsByTypeByFinancialOct = function (type, isAll) {
	    var startDate = this.year + '-10-01';
	    var endDate = parseInt(this.year) + 1 + '-09-30';
	    var startMonth = this.year + '-10';
	    var endMonth = parseInt(this.year) + 1 + '-10';
	
	    // used by daily, weekly, monthly
	    var thisPeriods = this.gen(type, this.offset);
	    var thisSliceStartIndex;
	    var nextPeriods = this.gen(type, this.offset + 1);
	    var nextSliceEndIndex;
	
	    var thisYear;
	    var nextYear;
	
	    if (type === 'FinancialApril') {
	        return this.getItemifiedPeriods(this.gen(type, this.offset + this.yearOffset).slice(0, 2));
	    } else if (type === 'FinancialJuly') {
	        return this.getItemifiedPeriods(this.gen(type, this.offset + this.yearOffset).slice(0, 2));
	    } else if (type === 'FinancialOct') {
	        if (isAll) {
	            return this.getItemifiedPeriods(this.gen(type, this.offset - 1 + this.yearOffset).slice(0, 2));
	        }
	
	        return this.getItemifiedPeriods(this.gen(type, this.offset + this.yearOffset).slice(0, 1));
	    } else if (type === 'Yearly') {
	        thisYear = this.gen(type, this.offset + this.yearOffset)[0];
	        nextYear = this.gen(type, this.offset + 1 + this.yearOffset)[0];
	
	        return this.getItemifiedPeriods([thisYear, nextYear]);
	    } else if (type === 'SixMonthlyApril') {
	        return this.getItemifiedPeriods([].concat(thisPeriods.slice(1), nextPeriods.slice(0, 1)));
	    } else if (type === 'SixMonthly') {
	        return this.getItemifiedPeriods([].concat(thisPeriods.slice(1), nextPeriods));
	    } else if (type === 'Quarterly') {
	        return this.getItemifiedPeriods([].concat(thisPeriods.slice(3), nextPeriods.slice(0, 3)));
	    } else if (type === 'BiMonthly') {
	        return this.getItemifiedPeriods([].concat(thisPeriods.slice(4), nextPeriods.slice(0, 5)));
	    } else if (type === 'Monthly') {
	        for (var i = 0, month; i < thisPeriods.length; i++) {
	            month = thisPeriods[i];
	
	            if (month.startDate.slice(0, 7) === startMonth) {
	                thisSliceStartIndex = i;
	            }
	        }
	
	        for (var j = 0, month; j < nextPeriods.length; j++) {
	            month = nextPeriods[j];
	
	            if (month.startDate.slice(0, 7) === endMonth) {
	                nextSliceEndIndex = j;
	            }
	        }
	
	        return this.getItemifiedPeriods([].concat(thisPeriods.slice(thisSliceStartIndex), nextPeriods.slice(0, nextSliceEndIndex)));
	    } else if (type === 'Weekly') {
	        for (var i = 0, week; i < thisPeriods.length; i++) {
	            week = thisPeriods[i];
	
	            if (week.startDate.slice(0, 7) === startMonth || week.endDate.slice(0, 7) === startMonth) {
	                thisSliceStartIndex = i;
	            }
	        }
	
	        for (var j = 0, week; j < nextPeriods.length; j++) {
	            week = nextPeriods[j];
	
	            if (week.startDate.slice(0, 7) === endMonth && week.endDate.slice(0, 7) === endMonth) {
	                nextSliceEndIndex = j;
	            }
	        }
	
	        return this.getItemifiedPeriods([].concat(thisPeriods.slice(thisSliceStartIndex), nextPeriods.slice(0, nextSliceEndIndex)));
	    } else if (type === 'Daily') {
	        for (var i = 0, day; i < thisPeriods.length; i++) {
	            if (thisPeriods[i].startDate === startDate) {
	                thisSliceStartIndex = i;
	            }
	        }
	
	        for (var j = 0, day; j < nextPeriods.length; j++) {
	            if (nextPeriods[j].endDate === endDate) {
	                nextSliceEndIndex = j + 1;
	            }
	        }
	
	        return this.getItemifiedPeriods([].concat(thisPeriods.slice(thisSliceStartIndex), nextPeriods.slice(0, nextSliceEndIndex)));
	    }
	
	    return [];
	};
	
	Period.prototype.getItemsByTypeByYear = function (type) {
	    if (type === 'FinancialOct') {
	        return this.getItemifiedPeriods(this.genRev(type, this.offset - 5).slice(0, 2));
	    } else if (type === 'FinancialJuly') {
	        return this.getItemifiedPeriods(this.genRev(type, this.offset - 5).slice(0, 2));
	    } else if (type === 'FinancialApril') {
	        return this.getItemifiedPeriods(this.genRev(type, this.offset - 5).slice(0, 2));
	    } else if (type === 'Yearly') {
	        return this.getItemifiedPeriods(this.genRev(type, this.offset - 5).slice(0, 1));
	    } else if (type === 'SixMonthlyApril') {
	        return this.getItemifiedPeriods(this.genRev(type, this.offset));
	    } else if (type === 'SixMonthly') {
	        return this.getItemifiedPeriods(this.genRev(type, this.offset));
	    } else if (type === 'Quarterly') {
	        return this.getItemifiedPeriods(this.genRev(type, this.offset));
	    } else if (type === 'BiMonthly') {
	        return this.getItemifiedPeriods(this.genRev(type, this.offset));
	    } else if (type === 'Monthly') {
	        return this.getItemifiedPeriods(this.genRev(type, this.offset));
	    } else if (type === 'Weekly') {
	        return this.getItemifiedPeriods(this.genRev(type, this.offset));
	    } else if (type === 'Daily') {
	        return this.getItemifiedPeriods(this.genRev(type, this.offset));
	    }
	
	    return [];
	};
	
	Period.prototype.getItemsByTypeBySixmonthApril = function (type, isAll) {
	    var sixmonthaprilStr = this.id.slice(10, 11),
	        sixmonthapril = parseInt(sixmonthaprilStr);
	
	    if (type === 'FinancialOct') {
	        offset = sixmonthapril === 1 ? -1 : 0;
	        return this.getItemifiedPeriods(this.gen(type, this.offset + this.yearOffset + offset).slice(0, 1));
	    } else if (type === 'FinancialJuly') {
	        offset = sixmonthapril === 1 ? -1 : 0;
	        sliceEndIndex = offset === -1 ? 2 : 1;
	
	        return this.getItemifiedPeriods(this.gen(type, this.offset + this.yearOffset + offset).slice(0, sliceEndIndex));
	    } else if (type === 'FinancialApril') {
	        return this.getItemifiedPeriods(this.gen(type, this.offset + this.yearOffset).slice(0, 1));
	    } else if (type === 'Yearly') {
	        var sliceEndIndex = sixmonthapril === 1 ? 1 : 2;
	        return this.getItemifiedPeriods(this.gen(type, this.offset + this.yearOffset).slice(0, sliceEndIndex));
	    } else if (type === 'SixMonthlyApril') {
	        if (isAll) {
	            return this.getItemifiedPeriods(this.gen(type, this.offset - 1).slice(1, 2).concat(this.gen(type, this.offset)));
	        }
	
	        return this.getItemifiedPeriods([this.gen(type, this.offset)[sixmonthapril - 1]]);
	    } else if (type === 'SixMonthly') {
	        var offset = sixmonthapril === 1 ? 0 : 1;
	        return this.getItemifiedPeriods(this.gen(type, this.offset).slice(1, 2).concat(this.gen(type, this.offset + offset).slice(0, 1)));
	    } else if (type === 'Quarterly') {
	        var quarters = [];
	
	        if (sixmonthapril === 1) {
	            quarters = quarters.concat(this.gen(type, this.offset).slice(1, 3));
	        } else {
	            quarters = quarters.concat(this.gen(type, this.offset).slice(3, 4));
	            quarters = quarters.concat(this.gen(type, this.offset + 1).slice(0, 1));
	        }
	
	        return this.getItemifiedPeriods(quarters);
	    } else if (type === 'BiMonthly') {
	        var bimonths = [];
	
	        if (sixmonthapril === 1) {
	            bimonths = bimonths.concat(this.gen(type, this.offset).slice(1, 5));
	        } else {
	            bimonths = bimonths.concat(this.gen(type, this.offset).slice(4, 6));
	            bimonths = bimonths.concat(this.gen(type, this.offset + 1).slice(0, 2));
	        }
	
	        return this.getItemifiedPeriods(bimonths);
	    } else if (type === 'Monthly') {
	        var months = [];
	
	        if (sixmonthapril === 1) {
	            months = months.concat(this.gen(type, this.offset).slice(3, 9));
	        } else {
	            months = months.concat(this.gen(type, this.offset).slice(9, 12));
	            months = months.concat(this.gen(type, this.offset + 1).slice(0, 3));
	        }
	
	        return this.getItemifiedPeriods(months);
	    } else if (type === 'Weekly') {
	        var allWeeks = this.gen(type, this.offset),
	            weeks = [];
	
	        if (sixmonthapril === 1) {
	            for (var i = 0, week, sm, em; i < allWeeks.length; i++) {
	                week = allWeeks[i];
	                sm = parseInt(week.startDate.substring(5, 7));
	                em = parseInt(week.endDate.substring(5, 7));
	
	                if ((0, _numberConstrain2.default)(sm, 4, 9) === sm || (0, _numberConstrain2.default)(em, 4, 9) === em) {
	                    weeks.push(week);
	                }
	            }
	        } else {
	            var allWeeksNext = this.gen(type, this.offset + 1),
	                sliceStartIndex,
	                sliceEndIndex;
	
	            // this year
	            for (var i = 0, week, sm, em; i < allWeeks.length; i++) {
	                week = allWeeks[i];
	                sm = parseInt(week.startDate.substring(5, 7));
	                em = parseInt(week.endDate.substring(5, 7));
	
	                if (sm === 10 || em === 10) {
	                    sliceStartIndex = i;
	                    break;
	                }
	            }
	
	            weeks = weeks.concat(allWeeks.slice(sliceStartIndex));
	
	            // next year
	            for (var i = 0, week, sm, em; i < allWeeksNext.length; i++) {
	                week = allWeeks[i];
	                sm = parseInt(week.startDate.substring(5, 7));
	                em = parseInt(week.endDate.substring(5, 7));
	
	                if (sm === 4 && em === 4) {
	                    sliceEndIndex = i - 1;
	                    break;
	                }
	            }
	
	            weeks = weeks.concat(allWeeksNext.slice(0, sliceEndIndex));
	        }
	
	        return this.getItemifiedPeriods(weeks);
	    } else if (type === 'Daily') {
	        var allDays = this.gen(type, this.offset),
	            days = [];
	
	        if (sixmonthapril === 1) {
	            for (var i = 0, day, m; i < allDays.length; i++) {
	                day = allDays[i];
	                m = parseInt(day.startDate.substring(5, 7));
	
	                if ((0, _numberConstrain2.default)(m, 4, 9) === m) {
	                    days.push(day);
	                }
	            }
	        } else {
	            var allDaysNext = this.gen(type, this.offset + 1),
	                sliceStartIndex,
	                sliceEndIndex;
	
	            // this year
	            for (var i = 0, day, m; i < allDays.length; i++) {
	                day = allDays[i];
	                m = parseInt(day.startDate.substring(5, 7));
	
	                if (m === 10) {
	                    sliceStartIndex = i;
	                    break;
	                }
	            }
	
	            days = days.concat(allDays.slice(sliceStartIndex));
	
	            // next year
	            for (var i = 0, day, m; i < allDaysNext.length; i++) {
	                day = allDaysNext[i];
	                m = parseInt(day.startDate.substring(5, 7));
	
	                if (m === 4) {
	                    sliceEndIndex = i - 1;
	                    break;
	                }
	            }
	
	            days = days.concat(allDaysNext.slice(0, sliceEndIndex));
	        }
	
	        return this.getItemifiedPeriods(days);
	    }
	
	    return [];
	};
	
	Period.prototype.getItemsByTypeBySixmonth = function (type, isAll) {
	    var sixmonthStr = this.id.slice(5, 6),
	        sixmonth = parseInt(sixmonthStr),
	        firstMonth = sixmonth === 1 ? 1 : 7,
	        lastMonth = sixmonth === 1 ? 6 : 12,
	        startIndex,
	        endIndex,
	        offset,
	        sliceEndIndex;
	
	    if (type === 'FinancialOct') {
	        offset = -1;
	        sliceEndIndex = sixmonth === 1 ? 1 : 2;
	        return this.getItemifiedPeriods(this.gen(type, this.offset + this.yearOffset + offset).slice(0, sliceEndIndex));
	    } else if (type === 'FinancialJuly') {
	        offset = sixmonth === 1 ? -1 : 0;
	        return this.getItemifiedPeriods(this.gen(type, this.offset + this.yearOffset + offset).slice(0, 1));
	    } else if (type === 'FinancialApril') {
	        offset = sixmonth === 1 ? -1 : 0;
	        sliceEndIndex = sixmonth === 1 ? 2 : 1;
	        return this.getItemifiedPeriods(this.gen(type, this.offset + this.yearOffset + offset).slice(0, sliceEndIndex));
	    } else if (type === 'Yearly') {
	        return this.getItemifiedPeriods(this.gen(type, this.offset + this.yearOffset).slice(0, 1));
	    } else if (type === 'SixMonthlyApril') {
	        var allSixmonthaprils = this.gen(type, this.offset),
	            this1 = allSixmonthaprils[0],
	            this2 = allSixmonthaprils[1],
	            prev = this.gen(type, this.offset - 1)[1],
	            sixmonthaprils = [];
	
	        if (sixmonth === 1) {
	            sixmonthaprils.push(prev, this1);
	        } else if (sixmonth === 2) {
	            sixmonthaprils.push(this1, this2);
	        }
	
	        return this.getItemifiedPeriods(sixmonthaprils);
	    } else if (type === 'SixMonthly') {
	        if (isAll) {
	            return this.getItemifiedPeriods(this.gen(type, this.offset));
	        }
	
	        return this.getItemifiedPeriods([this.gen(type, this.offset)[sixmonth - 1]]);
	    } else if (type === 'Quarterly') {
	        var sliceStartIndex = sixmonth === 1 ? 0 : 2,
	            sliceEndIndex = sixmonth === 1 ? 2 : 4;
	
	        return this.getItemifiedPeriods(this.gen(type, this.offset).slice(sliceStartIndex, sliceEndIndex));
	    } else if (type === 'BiMonthly') {
	        var sliceStartIndex = sixmonth === 1 ? 0 : 3,
	            sliceEndIndex = sixmonth === 1 ? 3 : 6;
	
	        return this.getItemifiedPeriods(this.gen(type, this.offset).slice(sliceStartIndex, sliceEndIndex));
	    } else if (type === 'Monthly') {
	        var sliceStartIndex = sixmonth === 1 ? 0 : 6,
	            sliceEndIndex = sixmonth === 1 ? 6 : 12;
	
	        return this.getItemifiedPeriods(this.gen(type, this.offset).slice(sliceStartIndex, sliceEndIndex));
	    } else if (type === 'Weekly') {
	        var allWeeks = this.gen(type, this.offset),
	            weeks = [];
	
	        for (var i = 0, sd, ed, sy, ey; i < allWeeks.length; i++) {
	            sd = parseInt(allWeeks[i].startDate.substring(5, 7));
	            ed = parseInt(allWeeks[i].endDate.substring(5, 7));
	            sy = allWeeks[i].startDate.substring(0, 4);
	            ey = allWeeks[i].endDate.substring(0, 4);
	
	            if (sd >= firstMonth && sd <= lastMonth || ed >= firstMonth && ed <= lastMonth) {
	                if (sixmonth === 1 && ey !== this.year || sixmonth === 2 && sy !== this.year) {
	                    continue;
	                }
	
	                weeks.push(allWeeks[i]);
	            }
	        }
	
	        return this.getItemifiedPeriods(weeks);
	    } else if (type === 'Daily') {
	        var allDays = this.gen(type, this.offset),
	            days = [];
	
	        for (var i = 0, m; i < allDays.length; i++) {
	            m = parseInt(allDays[i].iso.substring(4, 6));
	
	            if (m >= firstMonth && m <= lastMonth) {
	                days.push(allDays[i]);
	            }
	        }
	
	        return this.getItemifiedPeriods(days);
	    }
	
	    return [];
	};
	
	Period.prototype.getItemsByTypeByQuarter = function (type, isAll) {
	    var quarterStr = this.id.slice(5, 6),
	        quarter = parseInt(quarterStr),
	        firstMonth = quarter === 1 ? 1 : quarter === 2 ? 4 : quarter === 3 ? 7 : 10,
	        lastMonth = quarter === 1 ? 3 : quarter === 2 ? 6 : quarter === 3 ? 9 : 12,
	        startIndex,
	        endIndex,
	        offset;
	
	    if (type === 'FinancialOct') {
	        offset = quarter <= 3 ? 4 : 5;
	        return this.getItemifiedPeriods(this.gen(type, this.offset + offset).slice(0, 1));
	    } else if (type === 'FinancialJuly') {
	        offset = quarter <= 2 ? 4 : 5;
	        return this.getItemifiedPeriods(this.gen(type, this.offset + offset).slice(0, 1));
	    } else if (type === 'FinancialApril') {
	        offset = quarter === 1 ? 4 : 5;
	        return this.getItemifiedPeriods(this.gen(type, this.offset + offset).slice(0, 1));
	    } else if (type === 'Yearly') {
	        return this.getItemifiedPeriods(this.gen(type, this.offset + 5).slice(0, 1));
	    } else if (type === 'SixMonthlyApril') {
	        var offset = quarter < 2 ? -1 : quarter > 3 ? 1 : 0,
	            index = quarter < 2 || quarter > 3 ? 1 : 2;
	
	        return this.getItemifiedPeriods(this.genRev(type, this.offset + offset).slice(0, index));
	    } else if (type === 'SixMonthly') {
	        startIndex = quarter <= 2 ? 0 : 1;
	        endIndex = startIndex + 1;
	
	        return this.getItemifiedPeriods(this.gen(type, this.offset).slice(startIndex, endIndex));
	    } else if (type === 'Quarterly') {
	        if (isAll) {
	            return this.getItemifiedPeriods(this.gen(type, this.offset));
	        }
	
	        return this.getItemifiedPeriods(this.gen(type, this.offset).slice(quarter - 1, quarter));
	    } else if (type === 'BiMonthly') {
	        startIndex = quarter === 1 ? 0 : quarter === 2 ? 1 : quarter === 3 ? 3 : 4;
	        endIndex = startIndex + 2;
	
	        return this.getItemifiedPeriods(this.gen(type, this.offset).slice(startIndex, endIndex));
	    } else if (type === 'Monthly') {
	        startIndex = quarter === 1 ? 0 : quarter === 2 ? 3 : quarter === 3 ? 6 : 9;
	        endIndex = startIndex + 3;
	
	        return this.getItemifiedPeriods(this.gen(type, this.offset).slice(startIndex, endIndex));
	    } else if (type === 'Weekly') {
	        var allWeeks = this.gen(type, this.offset),
	            weeks = [];
	
	        for (var i = 0, sd, ed, sy, ey; i < allWeeks.length; i++) {
	            sd = parseInt(allWeeks[i].startDate.substring(5, 7));
	            ed = parseInt(allWeeks[i].endDate.substring(5, 7));
	            sy = allWeeks[i].startDate.substring(0, 4);
	            ey = allWeeks[i].endDate.substring(0, 4);
	
	            if (sd >= firstMonth && sd <= lastMonth || ed >= firstMonth && ed <= lastMonth) {
	                if (quarter === 1 && ey !== this.year || quarter === 4 && sy !== this.year) {
	                    continue;
	                }
	
	                weeks.push(allWeeks[i]);
	            }
	        }
	
	        return this.getItemifiedPeriods(weeks);
	    } else if (type === 'Daily') {
	        var allDays = this.gen(type, this.offset),
	            days = [];
	
	        for (var i = 0, m; i < allDays.length; i++) {
	            m = parseInt(allDays[i].iso.substring(4, 6));
	
	            if (m >= firstMonth && m <= lastMonth) {
	                days.push(allDays[i]);
	            }
	        }
	
	        return this.getItemifiedPeriods(days);
	    }
	
	    return [];
	};
	
	Period.prototype.getItemsByTypeByBimonth = function (type, isAll) {
	    var bimonthStr = this.id.slice(4, 6),
	        bimonth = parseInt(bimonthStr),
	        firstMonth = bimonth * 2 - 1,
	        lastMonth = bimonth * 2,
	        startIndex,
	        endIndex,
	        offset;
	
	    if (type === 'FinancialOct') {
	        var isPrev = firstMonth < 10,
	            isThis = lastMonth >= 10,
	            offset = 0 + (isPrev ? -1 : 0),
	            sliceEndIndex = 0 + (isPrev ? 1 : 0) + (isThis ? 1 : 0),
	            financialoctobers = [];
	
	        return this.getItemifiedPeriods(this.gen(type, this.offset + this.yearOffset + offset).slice(0, sliceEndIndex));
	    } else if (type === 'FinancialJuly') {
	        var isPrev = firstMonth < 7,
	            isThis = lastMonth >= 7,
	            offset = 0 + (isPrev ? -1 : 0),
	            sliceEndIndex = 0 + (isPrev ? 1 : 0) + (isThis ? 1 : 0),
	            financialoctobers = [];
	
	        return this.getItemifiedPeriods(this.gen(type, this.offset + this.yearOffset + offset).slice(0, sliceEndIndex));
	    } else if (type === 'FinancialApril') {
	        var isPrev = firstMonth < 4,
	            isThis = lastMonth >= 4,
	            offset = 0 + (isPrev ? -1 : 0),
	            sliceEndIndex = 0 + (isPrev ? 1 : 0) + (isThis ? 1 : 0),
	            financialoctobers = [];
	
	        return this.getItemifiedPeriods(this.gen(type, this.offset + this.yearOffset + offset).slice(0, sliceEndIndex));
	    } else if (type === 'Yearly') {
	        return this.getItemifiedPeriods(this.gen(type, this.offset + 5).slice(0, 1));
	    } else if (type === 'SixMonthlyApril') {
	        var sixmonthaprils = [];
	
	        if (bimonth === 1) {
	            sixmonthaprils.push(this.gen('SixMonthlyApril', this.offset - 1)[1]);
	        } else if (bimonth === 2) {
	            sixmonthaprils.push(this.gen('SixMonthlyApril', this.offset - 1)[1]);
	            sixmonthaprils.push(this.gen('SixMonthlyApril', this.offset)[0]);
	        } else if (bimonth < 5) {
	            sixmonthaprils.push(this.gen('SixMonthlyApril', this.offset)[0]);
	        } else if (bimonth === 5) {
	            sixmonthaprils.push(this.gen('SixMonthlyApril', this.offset)[0]);
	            sixmonthaprils.push(this.gen('SixMonthlyApril', this.offset)[1]);
	        } else {
	            sixmonthaprils.push(this.gen('SixMonthlyApril', this.offset)[1]);
	        }
	
	        return this.getItemifiedPeriods(sixmonthaprils);
	    } else if (type === 'SixMonthly') {
	        var sliceStartIndex = bimonth < 4 ? 0 : 1,
	            sliceEndIndex = bimonth < 4 ? 1 : 2;
	
	        return this.getItemifiedPeriods(this.gen(type, this.offset).slice(sliceStartIndex, sliceEndIndex));
	    } else if (type === 'Quarterly') {
	        var sliceStartIndex = bimonth === 1 ? 0 : bimonth === 2 ? 0 : bimonth === 3 ? 1 : bimonth === 4 ? 2 : bimonth === 5 ? 2 : 3,
	            sliceEndIndex = bimonth === 1 ? 1 : bimonth === 2 ? 2 : bimonth === 3 ? 2 : bimonth === 4 ? 3 : bimonth === 5 ? 4 : 4;
	
	        return this.getItemifiedPeriods(this.gen('Quarterly', this.offset).slice(sliceStartIndex, sliceEndIndex));
	    } else if (type === 'BiMonthly') {
	        if (isAll) {
	            return this.getItemifiedPeriods(this.gen(type, this.offset));
	        }
	
	        return this.getItemifiedPeriods(this.gen(type, this.offset).slice(bimonth - 1, bimonth));
	    } else if (type === 'Monthly') {
	        var sliceStartIndex = bimonth === 1 ? 0 : bimonth === 2 ? 2 : bimonth === 3 ? 4 : bimonth === 4 ? 6 : bimonth === 5 ? 8 : 10,
	            sliceEndIndex = bimonth === 1 ? 2 : bimonth === 2 ? 4 : bimonth === 3 ? 6 : bimonth === 4 ? 8 : bimonth === 5 ? 10 : 12;
	
	        return this.getItemifiedPeriods(this.gen(type, this.offset).slice(sliceStartIndex, sliceEndIndex));
	    } else if (type === 'Weekly') {
	        var allWeeks = this.gen(type, this.offset),
	            weeks = [];
	
	        for (var i = 0, sd, ed, sy, ey; i < allWeeks.length; i++) {
	            sd = parseInt(allWeeks[i].startDate.substring(5, 7));
	            ed = parseInt(allWeeks[i].endDate.substring(5, 7));
	            sy = allWeeks[i].startDate.substring(0, 4);
	            ey = allWeeks[i].endDate.substring(0, 4);
	
	            if (sd >= firstMonth && sd <= lastMonth || ed >= firstMonth && ed <= lastMonth) {
	                if (bimonth === 1 && ey !== this.year || bimonth === 4 && sy !== this.year) {
	                    continue;
	                }
	
	                weeks.push(allWeeks[i]);
	            }
	        }
	
	        return this.getItemifiedPeriods(weeks);
	    } else if (type === 'Daily') {
	        var allDays = this.gen(type, this.offset),
	            days = [];
	
	        for (var i = 0, m; i < allDays.length; i++) {
	            m = parseInt(allDays[i].iso.substring(4, 6));
	
	            if (m >= firstMonth && m <= lastMonth) {
	                days.push(allDays[i]);
	            }
	        }
	
	        return this.getItemifiedPeriods(days);
	    }
	
	    return [];
	};
	
	Period.prototype.getItemsByTypeByMonth = function (type, isAll) {
	    var monthStr = this.id.slice(4, 6),
	        month = parseInt(monthStr),
	        offset;
	
	    if (type === 'FinancialOct') {
	        offset = month <= 9 ? 4 : 5;
	        return this.getItemifiedPeriods(this.gen(type, this.offset + offset).slice(0, 1));
	    } else if (type === 'FinancialJuly') {
	        offset = month <= 6 ? 4 : 5;
	        return this.getItemifiedPeriods(this.gen(type, this.offset + offset).slice(0, 1));
	    } else if (type === 'FinancialApril') {
	        offset = month <= 3 ? 4 : 5;
	        return this.getItemifiedPeriods(this.gen(type, this.offset + offset).slice(0, 1));
	    } else if (type === 'Yearly') {
	        return this.getItemifiedPeriods(this.genRev(type, this.offset - 5).slice(0, 1));
	    } else if (type === 'SixMonthlyApril') {
	        var offset = month < 4 ? -1 : 0,
	            index = month < 4 || month > 9 ? 1 : 2;
	
	        return this.getItemifiedPeriods(this.genRev(type, this.offset + offset).slice(0, index));
	    } else if (type === 'SixMonthly') {
	        var startIndex = month <= 6 ? 0 : 1,
	            endIndex = startIndex + 1;
	
	        return this.getItemifiedPeriods(this.gen(type, this.offset).slice(startIndex, endIndex));
	    } else if (type === 'Quarterly') {
	        var startIndex = month <= 3 ? 0 : month <= 6 ? 1 : month <= 9 ? 2 : 3;
	        endIndex = startIndex + 1;
	
	        return this.getItemifiedPeriods(this.gen(type, this.offset).slice(startIndex, endIndex));
	    } else if (type === 'BiMonthly') {
	        var startIndex = month <= 2 ? 0 : month <= 4 ? 1 : month <= 6 ? 2 : month <= 8 ? 3 : month <= 10 ? 4 : 5;
	        endIndex = startIndex + 1;
	
	        return this.getItemifiedPeriods(this.gen(type, this.offset).slice(startIndex, endIndex));
	    } else if (type === 'Monthly') {
	        if (isAll) {
	            return this.getItemifiedPeriods(this.gen(type, this.offset));
	        }
	
	        return this.getItemifiedPeriods(this.gen(type, this.offset).slice(month - 1, month));
	    } else if (type === 'Weekly') {
	        var t = this,
	            isFirstOrLast = month === 1 || month === 12,
	            allWeeks = function () {
	            var a = [];
	            a = a.concat(isFirstOrLast ? t.gen(type, t.offset - 1) : []);
	            a = a.concat(t.gen(type, t.offset));
	            a = a.concat(isFirstOrLast ? t.gen(type, t.offset + 1) : []);
	            return a;
	        }(),
	            monthTestString = this.year + '-' + monthStr,
	            weeks = [];
	
	        for (var i = 0, sd, ed, week; i < allWeeks.length; i++) {
	            week = allWeeks[i];
	            sd = week.startDate;
	            ed = week.endDate;
	
	            if (sd.substring(0, 7) === monthTestString || ed.substring(0, 7) === monthTestString) {
	                weeks.push(week);
	            }
	        }
	
	        return this.getItemifiedPeriods(weeks);
	    } else if (type === 'Daily') {
	        var allDays = this.gen(type, this.offset),
	            days = [];
	
	        for (var i = 0, m; i < allDays.length; i++) {
	            m = allDays[i].iso;
	
	            if (m.substring(4, 6) === monthStr) {
	                days.push(allDays[i]);
	            }
	        }
	
	        return this.getItemifiedPeriods(days);
	    }
	
	    return [];
	};
	
	Period.prototype.getItemsByTypeByWeek = function (type, isAll) {
	    var weekStr = this.id.slice(5, 7),
	        week = parseInt(weekStr),
	        allWeeks = this.gen('Weekly', this.offset),
	        weekPeriod = allWeeks[week - 1],
	        startDateMonth = parseInt(weekPeriod.startDate.substring(5, 7)),
	        endDateMonth = parseInt(weekPeriod.endDate.substring(5, 7)),
	        startDateYear = parseInt(weekPeriod.startDate.substring(0, 4)),
	        endDateYear = parseInt(weekPeriod.endDate.substring(0, 4)),
	        offset;
	
	    if (type === 'FinancialOct') {
	        var isPrev = startDateMonth < 10 || startDateYear < this.year,
	            isThis = endDateMonth >= 10 || startDateYear > this.year,
	            offset = isPrev ? -1 : 0,
	            sliceEndIndex = 1 + (isPrev ? 1 : 0) + (isThis ? 1 : 0),
	            financialaprils = [];
	
	        return this.getItemifiedPeriods(this.gen('FinancialOct', this.offset + this.yearOffset + offset).slice(0, sliceEndIndex));
	    } else if (type === 'FinancialJuly') {
	        var isPrev = startDateMonth < 7 || startDateYear < this.year,
	            isThis = endDateMonth >= 7 || startDateYear > this.year,
	            offset = isPrev ? -1 : 0,
	            sliceEndIndex = 1 + (isPrev ? 1 : 0) + (isThis ? 1 : 0),
	            financialaprils = [];
	
	        return this.getItemifiedPeriods(this.gen('FinancialJuly', this.offset + this.yearOffset + offset).slice(0, sliceEndIndex));
	    } else if (type === 'FinancialApril') {
	        var isPrev = startDateMonth < 4 || startDateYear < this.year,
	            isThis = endDateMonth >= 4 || startDateYear > this.year,
	            offset = isPrev ? -1 : 0,
	            sliceEndIndex = 1 + (isPrev ? 1 : 0) + (isThis ? 1 : 0),
	            financialaprils = [];
	
	        return this.getItemifiedPeriods(this.gen('FinancialApril', this.offset + this.yearOffset + offset).slice(0, sliceEndIndex));
	    } else if (type === 'Yearly') {
	        var offset = startDateYear < parseInt(this.year) ? -1 : 0,
	            sliceEndIndex = 1 + (startDateYear !== endDateYear ? 1 : 0);
	
	        return this.getItemifiedPeriods(this.gen('Yearly', this.offset + this.yearOffset + offset).slice(0, sliceEndIndex));
	    } else if (type === 'SixMonthlyApril') {
	        var sixmonthaprils = [];
	
	        if (startDateMonth < 4 || startDateYear < this.year) {
	            sixmonthaprils.push(this.gen('SixMonthlyApril', this.offset - 1)[1]);
	        }
	
	        if ((0, _numberConstrain2.default)(startDateMonth, 4, 9) === startDateMonth || (0, _numberConstrain2.default)(endDateMonth, 4, 9) === endDateMonth) {
	            sixmonthaprils.push(this.gen('SixMonthlyApril', this.offset)[0]);
	        }
	
	        if (endDateMonth > 9 || endDateYear > this.year) {
	            sixmonthaprils.push(this.gen('SixMonthlyApril', this.offset)[1]);
	        }
	
	        return this.getItemifiedPeriods(sixmonthaprils);
	    } else if (type === 'SixMonthly') {
	        var allSixmonths = this.gen(type, this.offset),
	            actualSixmonthIndexes = (0, _arrayUnique2.default)([Math.ceil(startDateMonth / 6), Math.ceil(endDateMonth / 6)]),
	            sixmonths = [];
	
	        for (var i = 0; i < actualSixmonthIndexes.length; i++) {
	            sixmonths.push(allSixmonths[actualSixmonthIndexes[i] - 1]);
	        }
	
	        return this.getItemifiedPeriods(sixmonths);
	    } else if (type === 'Quarterly') {
	        var allQuarters = this.gen(type, this.offset),
	            actualQuarterIndexes = (0, _arrayUnique2.default)([Math.ceil(startDateMonth / 3), Math.ceil(endDateMonth / 3)]),
	            quarters = [];
	
	        for (var i = 0; i < actualQuarterIndexes.length; i++) {
	            quarters.push(allQuarters[actualQuarterIndexes[i] - 1]);
	        }
	
	        return this.getItemifiedPeriods(quarters);
	    } else if (type === 'BiMonthly') {
	        var allBimonths = this.gen(type, this.offset),
	            actualBimonthIndexes = (0, _arrayUnique2.default)([Math.ceil(startDateMonth / 2), Math.ceil(endDateMonth / 2)]),
	            bimonths = [];
	
	        for (var i = 0; i < actualBimonthIndexes.length; i++) {
	            bimonths.push(allBimonths[actualBimonthIndexes[i] - 1]);
	        }
	
	        return this.getItemifiedPeriods(bimonths);
	    } else if (type === 'Monthly') {
	        var allMonths = this.gen(type, this.offset),
	            months = [];
	
	        if (startDateMonth === 12 && endDateMonth === 1) {
	            months.push(this.gen(type, this.offset - 1)[11]);
	            months.push(allMonths[0]);
	        } else if (startDateMonth === 1 && endDateMonth === 12) {
	            months.push(allMonths[11]);
	            months.push(this.gen(type, this.offset + 1)[0]);
	        } else {
	            var actualMonthIndexes = (0, _arrayUnique2.default)([startDateMonth, endDateMonth]);
	
	            for (var i = 0, monthIndexes = (0, _arrayUnique2.default)([startDateMonth, endDateMonth]); i < monthIndexes.length; i++) {
	                months.push(allMonths[monthIndexes[i] - 1]);
	            }
	        }
	
	        return this.getItemifiedPeriods(months);
	    } else if (type === 'Weekly') {
	        var allWeeks = this.gen(type, this.offset),
	            weekPeriod = allWeeks[week - 1];
	
	        if (isAll) {
	            return this.getItemifiedPeriods(allWeeks);
	        }
	
	        return this.getItemifiedPeriods(weekPeriod);
	    } else if (type === 'Daily') {
	        var allDays = this.gen(type, this.offset),
	            startSlice,
	            endSlice,
	            weekPeriod = this.gen('Weekly', this.offset)[week - 1],
	            days = [];
	
	        if (isAll) {
	            return this.getItemifiedPeriods(allDays);
	        }
	
	        // last year
	        if (weekPeriod.startDate.slice(0, 4) < this.year) {
	            for (var i = 0, lastDaysLastYear = this.gen(type, this.offset - 1).slice(358), day; i < lastDaysLastYear.length; i++) {
	                day = lastDaysLastYear[i];
	
	                if (day.startDate === weekPeriod.startDate) {
	                    days = days.concat(lastDaysLastYear.slice(i));
	                }
	            }
	        }
	
	        // this year
	        for (var i = 0, sd; i < allDays.length; i++) {
	            sd = allDays[i].startDate;
	
	            if (sd === weekPeriod.startDate) {
	                startSlice = i;
	            } else if (sd === weekPeriod.endDate) {
	                endSlice = i + 1;
	            }
	        }
	
	        days = days.concat(allDays.slice(startSlice, endSlice));
	
	        // next year
	        if (weekPeriod.endDate.slice(0, 4) > this.year) {
	            for (var i = 0, firstDaysNextYear = this.gen(type, this.offset + 1).slice(0, 7), day; i < firstDaysNextYear.length; i++) {
	                day = firstDaysNextYear[i];
	
	                days.push(day);
	
	                if (day.endDate === weekPeriod.endDate) {
	                    break;
	                }
	            }
	        }
	
	        return this.getItemifiedPeriods(days);
	    }
	
	    return [];
	};
	
	Period.prototype.getItemsByTypeByDay = function (type, isAll) {
	    var dayStr = this.id.slice(6, 8),
	        day = parseInt(dayStr),
	        monthStr = this.id.slice(4, 6),
	        month = parseInt(monthStr),
	        offset;
	
	    if (type === 'FinancialOct') {
	        offset = month <= 9 ? 4 : 5;
	        return this.getItemifiedPeriods(this.gen(type, this.offset + offset).slice(0, 1));
	    } else if (type === 'FinancialJuly') {
	        offset = month <= 6 ? 4 : 5;
	        return this.getItemifiedPeriods(this.gen(type, this.offset + offset).slice(0, 1));
	    } else if (type === 'FinancialApril') {
	        offset = month <= 3 ? 4 : 5;
	        return this.getItemifiedPeriods(this.gen(type, this.offset + offset).slice(0, 1));
	    } else if (type === 'Yearly') {
	        return this.getItemifiedPeriods(this.genRev(type, this.offset - 5).slice(0, 1));
	    } else if (type === 'SixMonthlyApril') {
	        var offset = month < 4 ? -1 : 0,
	            sliceStartIndex = month < 4 || month > 9 ? 1 : 0,
	            sliceEndIndex = sliceStartIndex + 1;
	
	        return this.getItemifiedPeriods(this.gen(type, this.offset + offset).slice(sliceStartIndex, sliceEndIndex));
	    } else if (type === 'SixMonthly') {
	        var sliceStartIndex = month <= 6 ? 0 : 1,
	            sliceEndIndex = sliceStartIndex + 1;
	
	        return this.getItemifiedPeriods(this.gen(type, this.offset).slice(sliceStartIndex, sliceEndIndex));
	    } else if (type === 'Quarterly') {
	        var sliceStartIndex = month <= 3 ? 0 : month <= 6 ? 1 : month <= 9 ? 2 : 3;
	        sliceEndIndex = sliceStartIndex + 1;
	
	        return this.getItemifiedPeriods(this.gen(type, this.offset).slice(sliceStartIndex, sliceEndIndex));
	    } else if (type === 'BiMonthly') {
	        var sliceStartIndex = month <= 2 ? 0 : month <= 4 ? 1 : month <= 6 ? 2 : month <= 8 ? 3 : month <= 10 ? 4 : 5;
	        sliceEndIndex = sliceStartIndex + 1;
	
	        return this.getItemifiedPeriods(this.gen(type, this.offset).slice(sliceStartIndex, sliceEndIndex));
	    } else if (type === 'Monthly') {
	        return this.getItemifiedPeriods(this.gen(type, this.offset).slice(month - 1, month));
	    } else if (type === 'Weekly') {
	        var allWeeks = this.gen(type, this.offset),
	            week;
	
	        for (var i = 0, sd, ed; i < allWeeks.length; i++) {
	            sd = allWeeks[i].startDate;
	            ed = allWeeks[i].endDate;
	
	            if (sd.substring(5, 7) === monthStr || ed.substring(5, 7) === monthStr) {
	                if (sd.substring(8, 10) <= dayStr || ed.substring(8, 10) >= dayStr) {
	                    week = allWeeks[i];
	                    break;
	                }
	            }
	        }
	
	        return this.getItemifiedPeriods(week);
	    } else if (type === 'Daily') {
	        var allDays = this.gen(type, this.offset),
	            day;
	
	        if (isAll) {
	            return this.getItemifiedPeriods(allDays);
	        }
	
	        for (var i = 0, sd; i < allDays.length; i++) {
	            sd = allDays[i].startDate;
	
	            if (sd.substring(5, 7) === monthStr && sd.substring(8, 10) === dayStr) {
	                day = allDays[i];
	            }
	        }
	
	        return this.getItemifiedPeriods(day);
	    }
	
	    return [];
	};
	
	//TYPE                ID              NAME
	//Financial October   2015Oct         Oct 2015 to Sep 2016
	//Financial July      2015July        Jul 2015 to Jun 2016
	//Financial April     2015April       Apr 2015 to Mar 2016
	//Yearly              2015            2015
	//Six-monthly April   2015AprilS1     Apr to Sep 2015
	//Six-monthly April   2015AprilS2     Oct to Mar 2014
	//Six-monthly         2015S1          Jan to Jun 2015
	//Quarterly           2015Q1          Jan to Mar 2015
	//Bi-monthly          201501B         Jan to Feb 2015
	//Monthly             201501          January 2015
	//Weekly              2015W1          2015W1
	//Daily               20150101        2015-01-01
	
	// dep 2
	
	Period.prototype.generateDisplayProperties = function () {
	    var p = this;
	
	    var id = p.id,
	        months = 'Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec'.split('|'),
	        offset = parseInt(p.year) - new Date().getFullYear(),
	        generator = refs.calendarManager.generator,
	        getSuffix = function getSuffix(array) {
	        return array.length > 1 ? 's' : '';
	    };
	
	    var type = p.getTypeById(id);
	
	    if (type === 'Daily') {
	        this.sortId = id;
	        this.typeSortId = '01';
	        this.typeName = 'Daily';
	        this.displayName = parseInt(this.name.split('-')[2]) + ' ' + months[new Date(this.name).getMonth()] + ', ' + this.year;
	
	        this.getContextMenuItemsConfig = function () {
	            var items = [];
	
	            // drill up
	            items.push({
	                isSubtitle: true,
	                style: 'padding: 5px 5px 5px 5px; font-size: 120%; font-weight:bold',
	                text: this.i18n.drill_up
	            });
	
	            // financial april
	            (function () {
	                items.push({
	                    items: p.getItemsByTypeByDay('FinancialApril'),
	                    text: 'Show <span class="name">financial April ' + p.year + '</span>',
	                    iconCls: 'ns-menu-item-float'
	                });
	            })();
	
	            // financial july
	            (function () {
	                items.push({
	                    items: p.getItemsByTypeByDay('FinancialJuly'),
	                    text: 'Show <span class="name">financial July ' + p.year + '</span>',
	                    iconCls: 'ns-menu-item-float'
	                });
	            })();
	
	            // financial october
	            (function () {
	                items.push({
	                    items: p.getItemsByTypeByDay('FinancialOct'),
	                    text: 'Show <span class="name">financial October ' + p.year + '</span>',
	                    iconCls: 'ns-menu-item-float'
	                });
	            })();
	
	            // yearly
	            (function () {
	                items.push({
	                    items: p.getItemsByTypeByDay('Yearly'),
	                    text: 'Show <span class="name">year ' + p.year + '</span>',
	                    iconCls: 'ns-menu-item-float'
	                });
	            })();
	
	            // six-monthly april
	            (function () {
	                var periods = p.getItemsByTypeByDay('SixMonthlyApril');
	
	                items.push({
	                    items: periods,
	                    text: 'Show <span class="name">' + p.getNameByParents(periods, 'six-month') + '</span>',
	                    iconCls: 'ns-menu-item-float'
	                });
	            })();
	
	            // six-monthly
	            (function () {
	                var periods = p.getItemsByTypeByDay('SixMonthly');
	
	                items.push({
	                    items: periods,
	                    text: 'Show <span class="name">' + p.getNameByParents(periods, 'six-month') + '</span>',
	                    iconCls: 'ns-menu-item-float'
	                });
	            })();
	
	            // quarterly
	            (function () {
	                var periods = p.getItemsByTypeByDay('Quarterly');
	
	                items.push({
	                    items: periods,
	                    text: 'Show <span class="name">' + p.getNameByParents(periods, 'quarter') + '</span>',
	                    iconCls: 'ns-menu-item-float'
	                });
	            })();
	
	            // bi-monthly
	            (function () {
	                var periods = p.getItemsByTypeByDay('BiMonthly');
	
	                items.push({
	                    items: periods,
	                    text: 'Show <span class="name">' + p.getNameByParents(periods, 'bi-month') + '</span>',
	                    iconCls: 'ns-menu-item-float'
	                });
	            })();
	
	            // monthly
	            (function () {
	                var periods = p.getItemsByTypeByDay('Monthly');
	
	                items.push({
	                    items: periods,
	                    text: 'Show <span class="name">' + p.getNameByParents(periods, 'month') + '</span>',
	                    iconCls: 'ns-menu-item-float'
	                });
	            })();
	
	            // weekly
	            (function () {
	                items.push({
	                    items: p.getItemsByTypeByDay('Weekly'),
	                    text: 'Show <span class="name">week ' + p.year + '</span>',
	                    iconCls: 'ns-menu-item-float'
	                });
	            })();
	
	            // same level
	            items.push({
	                isSubtitle: true,
	                style: 'padding: 5px 5px 5px 5px; font-size: 120%; font-weight:bold',
	                text: this.i18n.daily
	            });
	
	            items.push({
	                items: p.getItemsByTypeByDay('Daily'),
	                text: 'Show <span class="name">' + p.displayName + '</span> only',
	                iconCls: 'ns-menu-item-float'
	            });
	
	            items.push({
	                items: p.getItemsByTypeByDay('Daily', true),
	                text: 'Show all <span class="name">days</span> in <span class="name">' + p.year + '</span>',
	                iconCls: 'ns-menu-item-float'
	            });
	
	            return items;
	        };
	    } else if (type === 'Weekly') {
	        this.sortId = function () {
	            var a = id.split('W');
	            return a[0] + (a[1].length === 1 ? '000' : '00') + a[1];
	        }();
	        this.typeSortId = '02';
	        this.typeName = 'Weekly';
	        this.displayName = 'Week ' + id.split('W')[1] + ', ' + this.year;
	
	        this.getContextMenuItemsConfig = function () {
	            var items = [];
	
	            // drill up
	            items.push({
	                isSubtitle: true,
	                style: 'padding: 5px 5px 5px 5px; font-size: 120%; font-weight:bold',
	                text: this.i18n.drill_up
	            });
	
	            // financial april
	            (function () {
	                items.push({
	                    items: p.getItemsByTypeByWeek('FinancialApril'),
	                    text: 'Show <span class="name">financial April ' + p.year + '</span>',
	                    iconCls: 'ns-menu-item-float'
	                });
	            })();
	
	            // financial july
	            (function () {
	                items.push({
	                    items: p.getItemsByTypeByWeek('FinancialJuly'),
	                    text: 'Show <span class="name">financial July ' + p.year + '</span>',
	                    iconCls: 'ns-menu-item-float'
	                });
	            })();
	
	            // financial october
	            (function () {
	                var periods = p.getItemsByTypeByWeek('FinancialOct');
	
	                items.push({
	                    items: periods,
	                    text: 'Show <span class="name">financial October' + getSuffix(periods) + ' ' + p.year + '</span>',
	                    iconCls: 'ns-menu-item-float'
	                });
	            })();
	
	            // yearly
	            (function () {
	                items.push({
	                    items: p.getItemsByTypeByWeek('Yearly'),
	                    text: 'Show <span class="name">' + p.year + '</span>',
	                    iconCls: 'ns-menu-item-float'
	                });
	            })();
	
	            // six-monthly april
	            (function () {
	                var periods = p.getItemsByTypeByWeek('SixMonthlyApril');
	
	                items.push({
	                    items: periods,
	                    text: 'Show <span class="name">' + p.getNameByParents(periods, 'six-month') + '</span>',
	                    iconCls: 'ns-menu-item-float'
	                });
	            })();
	
	            // six-monthly
	            (function () {
	                var periods = p.getItemsByTypeByWeek('SixMonthly');
	
	                items.push({
	                    items: periods,
	                    text: 'Show <span class="name">' + p.getNameByParents(periods, 'six-month') + '</span>',
	                    iconCls: 'ns-menu-item-float'
	                });
	            })();
	
	            // quarterly
	            (function () {
	                var periods = p.getItemsByTypeByWeek('Quarterly');
	
	                items.push({
	                    items: periods,
	                    text: 'Show <span class="name">' + p.getNameByParents(periods, 'quarter') + '</span>',
	                    iconCls: 'ns-menu-item-float'
	                });
	            })();
	
	            // bi-monthly
	            (function () {
	                var periods = p.getItemsByTypeByWeek('BiMonthly');
	
	                items.push({
	                    items: periods,
	                    text: 'Show <span class="name">' + p.getNameByParents(periods, 'bi-month') + '</span>',
	                    iconCls: 'ns-menu-item-float'
	                });
	            })();
	
	            // monthly
	            (function () {
	                var periods = p.getItemsByTypeByWeek('Monthly');
	
	                items.push({
	                    items: periods,
	                    text: 'Show <span class="name">' + p.getNameByParents(periods, 'monthly') + '</span>',
	                    iconCls: 'ns-menu-item-float'
	                });
	            })();
	
	            // same level
	            items.push({
	                isSubtitle: true,
	                style: 'padding: 5px 5px 5px 5px; font-size: 120%; font-weight:bold',
	                text: this.i18n.weekly
	            });
	
	            items.push({
	                items: p.getItemsByTypeByWeek('Weekly'),
	                text: 'Show <span class="name">' + p.displayName + '</span> only',
	                iconCls: 'ns-menu-item-float'
	            });
	
	            items.push({
	                items: p.getItemsByTypeByWeek('Weekly', true),
	                text: 'Show all <span class="name">weeks</span> in <span class="name">' + p.year + '</span>',
	                iconCls: 'ns-menu-item-float'
	            });
	
	            // drill down
	            items.push({
	                isSubtitle: true,
	                style: 'padding: 5px 5px 5px 5px; font-size: 120%; font-weight:bold',
	                text: this.i18n.drill_down
	            });
	
	            // daily
	            (function () {
	                items.push({
	                    items: p.getItemsByTypeByWeek('Daily'),
	                    text: 'Show <span class="name">days</span> in <span class="name">' + p.displayName + '</span>',
	                    iconCls: 'ns-menu-item-float'
	                });
	            })();
	
	            return items;
	        };
	    } else if (type === 'Monthly') {
	        this.sortId = this.year + '00' + id.slice(4, 6);
	        this.typeSortId = '03';
	        this.typeName = 'Monthly';
	        this.displayName = this.name.split(' ')[0] + ' ' + this.year;
	
	        this.getContextMenuItemsConfig = function () {
	            var items = [];
	
	            // drill up
	            items.push({
	                isSubtitle: true,
	                style: 'padding: 5px 5px 5px 5px; font-size: 120%; font-weight:bold',
	                text: this.i18n.drill_up
	            });
	
	            // financial april
	            (function () {
	                var periods = p.getItemsByTypeByMonth('FinancialApril');
	
	                items.push({
	                    items: periods,
	                    text: 'Show <span class="name">financial April' + getSuffix(periods) + ' ' + p.year + '</span>',
	                    iconCls: 'ns-menu-item-float'
	                });
	            })();
	
	            // financial july
	            (function () {
	                var periods = p.getItemsByTypeByMonth('FinancialJuly');
	
	                items.push({
	                    items: periods,
	                    text: 'Show <span class="name">financial July' + getSuffix(periods) + ' ' + p.year + '</span>',
	                    iconCls: 'ns-menu-item-float'
	                });
	            })();
	
	            // financial october
	            (function () {
	                var periods = p.getItemsByTypeByMonth('FinancialOct');
	
	                items.push({
	                    items: periods,
	                    text: 'Show <span class="name">financial October' + getSuffix(periods) + ' ' + p.year + '</span>',
	                    iconCls: 'ns-menu-item-float'
	                });
	            })();
	
	            // yearly
	            (function () {
	                var periods = p.getItemsByTypeByMonth('Yearly');
	
	                items.push({
	                    items: periods,
	                    text: 'Show <span class="name">year' + getSuffix(periods) + ' ' + p.year + '</span>',
	                    iconCls: 'ns-menu-item-float'
	                });
	            })();
	
	            // six-monthly april
	            (function () {
	                var periods = p.getItemsByTypeByMonth('SixMonthlyApril');
	
	                items.push({
	                    items: periods,
	                    text: 'Show <span class="name">six-month April' + getSuffix(periods) + ' ' + p.year + '</span>',
	                    iconCls: 'ns-menu-item-float'
	                });
	            })();
	
	            // six-monthly
	            (function () {
	                var periods = p.getItemsByTypeByMonth('SixMonthly');
	
	                items.push({
	                    items: periods,
	                    text: 'Show <span class="name">' + p.getNameByParents(periods, 'six-month') + '</span>',
	                    iconCls: 'ns-menu-item-float'
	                });
	            })();
	
	            // quarterly
	            (function () {
	                var periods = p.getItemsByTypeByMonth('Quarterly');
	
	                items.push({
	                    items: periods,
	                    text: 'Show <span class="name">' + p.getNameByParents(periods, 'quarter') + '</span>',
	                    iconCls: 'ns-menu-item-float'
	                });
	            })();
	
	            // bi-monthly
	            (function () {
	                var periods = p.getItemsByTypeByMonth('BiMonthly');
	
	                items.push({
	                    items: periods,
	                    text: 'Show <span class="name">' + p.getNameByParents(periods, 'bimonthly') + '</span>',
	                    iconCls: 'ns-menu-item-float'
	                });
	            })();
	
	            // same level
	            items.push({
	                isSubtitle: true,
	                style: 'padding: 5px 5px 5px 5px; font-size: 120%; font-weight:bold',
	                text: this.i18n.monthly
	            });
	
	            items.push({
	                items: p.getItemsByTypeByMonth('Monthly'),
	                text: 'Show <span class="name">' + p.displayName + '</span> only',
	                iconCls: 'ns-menu-item-float'
	            });
	
	            items.push({
	                items: p.getItemsByTypeByMonth('Monthly', true),
	                text: 'Show all <span class="name">months</span> in <span class="name">' + p.year + '</span>',
	                iconCls: 'ns-menu-item-float'
	            });
	
	            // drill down
	            items.push({
	                isSubtitle: true,
	                style: 'padding: 5px 5px 5px 5px; font-size: 120%; font-weight:bold',
	                text: this.i18n.drill_down
	            });
	
	            // weekly
	            (function () {
	                items.push({
	                    items: p.getItemsByTypeByMonth('Weekly'),
	                    text: 'Show <span class="name">weeks</span> in <span class="name">' + p.name + '</span>',
	                    iconCls: 'ns-menu-item-float'
	                });
	            })();
	
	            // daily
	            (function () {
	                items.push({
	                    items: p.getItemsByTypeByMonth('Daily'),
	                    text: 'Show <span class="name">days</span> in <span class="name">' + p.name + '</span>',
	                    iconCls: 'ns-menu-item-float'
	                });
	            })();
	
	            return items;
	        };
	    } else if (type === 'BiMonthly') {
	        this.sortId = id.slice(0, 4) + '00' + id.slice(4, 6);
	        this.typeSortId = '04';
	        this.typeName = 'Bi-monthly';
	        this.displayName = (0, _stringTrim2.default)(this.name.split(this.year)[0]);
	
	        this.getContextMenuItemsConfig = function () {
	            var items = [];
	
	            // drill up
	            items.push({
	                isSubtitle: true,
	                style: 'padding: 5px 5px 5px 5px; font-size: 120%; font-weight:bold',
	                text: this.i18n.drill_up
	            });
	
	            // financial april
	            (function () {
	                var periods = p.getItemsByTypeByBimonth('FinancialApril');
	
	                items.push({
	                    items: periods,
	                    text: 'Show <span class="name">financial April' + getSuffix(periods) + ' ' + p.year + '</span>',
	                    iconCls: 'ns-menu-item-float'
	                });
	            })();
	
	            // financial july
	            (function () {
	                var periods = p.getItemsByTypeByBimonth('FinancialJuly');
	
	                items.push({
	                    items: periods,
	                    text: 'Show <span class="name">financial July' + getSuffix(periods) + ' ' + p.year + '</span>',
	                    iconCls: 'ns-menu-item-float'
	                });
	            })();
	
	            // financial october
	            (function () {
	                var periods = p.getItemsByTypeByBimonth('FinancialOct');
	
	                items.push({
	                    items: periods,
	                    text: 'Show <span class="name">financial October' + getSuffix(periods) + ' ' + p.year + '</span>',
	                    iconCls: 'ns-menu-item-float'
	                });
	            })();
	
	            // yearly
	            (function () {
	                var periods = p.getItemsByTypeByBimonth('Yearly');
	
	                items.push({
	                    items: periods,
	                    text: 'Show <span class="name">' + p.year + '</span>',
	                    iconCls: 'ns-menu-item-float'
	                });
	            })();
	
	            // six-monthly april
	            (function () {
	                var periods = p.getItemsByTypeByBimonth('SixMonthlyApril');
	
	                items.push({
	                    items: periods,
	                    text: 'Show <span class="name">' + p.getNameByParents(periods, 'six-month') + '</span>',
	                    iconCls: 'ns-menu-item-float'
	                });
	            })();
	
	            // six-monthly
	            (function () {
	                var periods = p.getItemsByTypeByBimonth('SixMonthly');
	
	                items.push({
	                    items: periods,
	                    text: 'Show <span class="name">' + p.getNameByParents(periods, 'six-month') + '</span>',
	                    iconCls: 'ns-menu-item-float'
	                });
	            })();
	
	            // quarterly
	            (function () {
	                var periods = p.getItemsByTypeByBimonth('Quarterly');
	
	                items.push({
	                    items: periods,
	                    text: 'Show <span class="name">' + p.getNameByParents(periods, 'quarter') + '</span>',
	                    iconCls: 'ns-menu-item-float'
	                });
	            })();
	
	            // same level
	            items.push({
	                isSubtitle: true,
	                style: 'padding: 5px 5px 5px 5px; font-size: 120%; font-weight:bold',
	                text: this.i18n.bimonthly
	            });
	
	            // bimonthly
	            items.push({
	                items: p.getItemsByTypeByBimonth('BiMonthly'),
	                text: 'Show <span class="name">' + p.displayName + '</span> only',
	                iconCls: 'ns-menu-item-float'
	            });
	
	            items.push({
	                items: p.getItemsByTypeByBimonth('BiMonthly', true),
	                text: 'Show all <span class="name">bi-months</span> in <span class="name">' + p.year + '</span>',
	                iconCls: 'ns-menu-item-float'
	            });
	
	            // drill down
	            items.push({
	                isSubtitle: true,
	                style: 'padding: 5px 5px 5px 5px; font-size: 120%; font-weight:bold',
	                text: this.i18n.drill_down
	            });
	
	            // monthly
	            (function () {
	                items.push({
	                    items: p.getItemsByTypeByBimonth('Monthly'),
	                    text: 'Show <span class="name">months</span> in <span class="name">' + p.displayName + ' ' + p.year + '</span>',
	                    iconCls: 'ns-menu-item-float'
	                });
	            })();
	
	            // weekly
	            (function () {
	                items.push({
	                    items: p.getItemsByTypeByBimonth('Weekly'),
	                    text: 'Show <span class="name">weeks</span> in <span class="name">' + p.displayName + ' ' + p.year + '</span>',
	                    iconCls: 'ns-menu-item-float'
	                });
	            })();
	
	            // daily
	            (function () {
	                items.push({
	                    items: p.getItemsByTypeByBimonth('Daily'),
	                    text: 'Show <span class="name">days</span> in <span class="name">' + p.displayName + ' ' + p.year + '</span>',
	                    iconCls: 'ns-menu-item-float'
	                });
	            })();
	
	            return items;
	        };
	    } else if (type === 'Quarterly') {
	        this.sortId = function () {
	            var a = id.split('Q');
	            return a[0] + (a[1].length === 1 ? '000' : '00') + a[1];
	        }();
	        this.typeSortId = '05';
	        this.typeName = 'Quarterly';
	        this.displayName = (0, _stringTrim2.default)(this.name.split(this.year)[0]);
	
	        this.getContextMenuItemsConfig = function () {
	            var items = [];
	
	            // drill up
	            items.push({
	                isSubtitle: true,
	                style: 'padding: 5px 5px 5px 5px; font-size: 120%; font-weight:bold',
	                text: this.i18n.drill_up
	            });
	
	            // financial april
	            (function () {
	                items.push({
	                    items: p.getItemsByTypeByQuarter('FinancialApril'),
	                    text: 'Show <span class="name">financial April ' + p.year + '</span>',
	                    iconCls: 'ns-menu-item-float'
	                });
	            })();
	
	            // financial july
	            (function () {
	                items.push({
	                    items: p.getItemsByTypeByQuarter('FinancialJuly'),
	                    text: 'Show <span class="name">financial July ' + p.year + '</span>',
	                    iconCls: 'ns-menu-item-float'
	                });
	            })();
	
	            // financial october
	            (function () {
	                items.push({
	                    items: p.getItemsByTypeByQuarter('FinancialOct'),
	                    text: 'Show <span class="name">financial October ' + p.year + '</span>',
	                    iconCls: 'ns-menu-item-float'
	                });
	            })();
	
	            // yearly
	            (function () {
	                items.push({
	                    items: p.getItemsByTypeByQuarter('Yearly'),
	                    text: 'Show <span class="name">' + p.year + '</span>',
	                    iconCls: 'ns-menu-item-float'
	                });
	            })();
	
	            // six-monthly april
	            (function () {
	                var periods = p.getItemsByTypeByQuarter('SixMonthlyApril');
	                items.push({
	                    items: periods,
	                    text: 'Show <span class="name">' + p.getNameByParents(periods, 'six-month April') + '</span>',
	                    iconCls: 'ns-menu-item-float'
	                });
	            })();
	
	            // six-monthly
	            (function () {
	                var periods = p.getItemsByTypeByQuarter('SixMonthly');
	
	                items.push({
	                    items: periods,
	                    text: 'Show <span class="name">' + p.getNameByParents(periods, 'six-month') + '</span>',
	                    iconCls: 'ns-menu-item-float'
	                });
	            })();
	
	            // same level
	            items.push({
	                isSubtitle: true,
	                style: 'padding: 5px 5px 5px 5px; font-size: 120%; font-weight:bold',
	                text: this.i18n.quarterly
	            });
	
	            // quarterly
	            items.push({
	                items: p.getItemsByTypeByQuarter('Quarterly'),
	                text: 'Show <span class="name">' + p.name + '</span> only',
	                iconCls: 'ns-menu-item-float'
	            });
	
	            items.push({
	                items: p.getItemsByTypeByQuarter('Quarterly', true),
	                text: 'Show all <span class="name">quarters</span> in <span class="name">' + p.year + '</span>',
	                iconCls: 'ns-menu-item-float'
	            });
	
	            // drill down
	            items.push({
	                isSubtitle: true,
	                style: 'padding: 5px 5px 5px 5px; font-size: 120%; font-weight:bold',
	                text: this.i18n.drill_down
	            });
	
	            // bi-monthly
	            (function () {
	                items.push({
	                    items: p.getItemsByTypeByQuarter('BiMonthly'),
	                    text: 'Show <span class="name">bi-months</span> in <span class="name">' + p.name + '</span>',
	                    iconCls: 'ns-menu-item-float'
	                });
	            })();
	
	            // monthly
	            (function () {
	                items.push({
	                    items: p.getItemsByTypeByQuarter('Monthly'),
	                    text: 'Show <span class="name">months</span> in <span class="name">' + p.name + '</span>',
	                    iconCls: 'ns-menu-item-float'
	                });
	            })();
	
	            // weekly
	            (function () {
	                items.push({
	                    items: p.getItemsByTypeByQuarter('Weekly'),
	                    text: 'Show <span class="name">weeks</span> in <span class="name">' + p.name + '</span>',
	                    iconCls: 'ns-menu-item-float'
	                });
	            })();
	
	            // daily
	            (function () {
	                items.push({
	                    items: p.getItemsByTypeByQuarter('Daily'),
	                    text: 'Show <span class="name">days</span> in <span class="name">' + p.name + '</span>',
	                    iconCls: 'ns-menu-item-float'
	                });
	            })();
	
	            return items;
	        };
	    } else if (type === 'SixMonthly') {
	        this.sortId = function () {
	            var a = id.split('S');
	            return a[0] + (a[1].length === 1 ? '000' : '00') + a[1];
	        }();
	        this.typeSortId = '06';
	        this.typeName = 'Six-monthly';
	        this.displayName = (0, _stringTrim2.default)(this.name.split(this.year)[0]);
	
	        this.getContextMenuItemsConfig = function () {
	            var items = [];
	
	            // drill up
	            items.push({
	                isSubtitle: true,
	                style: 'padding: 5px 5px 5px 5px; font-size: 120%; font-weight:bold',
	                text: this.i18n.drill_up
	            });
	
	            // financial april
	            (function () {
	                var periods = p.getItemsByTypeBySixmonth('FinancialApril');
	
	                items.push({
	                    items: periods,
	                    text: 'Show <span class="name">financial April ' + p.year + '</span>',
	                    iconCls: 'ns-menu-item-float'
	                });
	            })();
	
	            // financial july
	            (function () {
	                var periods = p.getItemsByTypeBySixmonth('FinancialJuly');
	
	                items.push({
	                    items: periods,
	                    text: 'Show <span class="name">financial July ' + p.year + '</span>',
	                    iconCls: 'ns-menu-item-float'
	                });
	            })();
	
	            // financial october
	            (function () {
	                var periods = p.getItemsByTypeBySixmonth('FinancialOct');
	
	                items.push({
	                    items: periods,
	                    text: 'Show <span class="name">financial October' + getSuffix(periods) + ' ' + p.year + '</span>',
	                    iconCls: 'ns-menu-item-float'
	                });
	            })();
	
	            // yearly
	            (function () {
	                var periods = p.getItemsByTypeBySixmonth('Yearly');
	
	                items.push({
	                    items: periods,
	                    text: 'Show <span class="name">year' + getSuffix(periods) + ' ' + p.year + '</span>',
	                    iconCls: 'ns-menu-item-float'
	                });
	            })();
	
	            // six-monthly april
	            (function () {
	                var periods = p.getItemsByTypeBySixmonth('SixMonthlyApril');
	
	                items.push({
	                    items: periods,
	                    text: 'Show <span class="name">six-month April' + getSuffix(periods) + ' ' + p.year + '</span>',
	                    iconCls: 'ns-menu-item-float'
	                });
	            })();
	
	            // same level
	            items.push({
	                isSubtitle: true,
	                style: 'padding: 5px 5px 5px 5px; font-size: 120%; font-weight:bold',
	                text: this.i18n.sixmonthly
	            });
	
	            // six-monthly
	            items.push({
	                items: p.getItemsByTypeBySixmonth('SixMonthly'),
	                text: 'Show <span class="name">' + p.name + '</span> only',
	                iconCls: 'ns-menu-item-float'
	            });
	
	            items.push({
	                items: p.getItemsByTypeBySixmonth('SixMonthly', true),
	                text: 'Show all <span class="name">six-months</span> in <span class="name">' + p.year + '</span>',
	                iconCls: 'ns-menu-item-float'
	            });
	
	            // drill down
	            items.push({
	                isSubtitle: true,
	                style: 'padding: 5px 5px 5px 5px; font-size: 120%; font-weight:bold',
	                text: this.i18n.drill_down
	            });
	
	            // quarterly
	            (function () {
	                items.push({
	                    items: p.getItemsByTypeBySixmonth('Quarterly'),
	                    text: 'Show <span class="name">quarters</span> in <span class="name">' + p.name + '</span>',
	                    iconCls: 'ns-menu-item-float'
	                });
	            })();
	
	            // bi-monthly
	            (function () {
	                items.push({
	                    items: p.getItemsByTypeBySixmonth('BiMonthly'),
	                    text: 'Show <span class="name">bi-months</span> in <span class="name">' + p.name + '</span>',
	                    iconCls: 'ns-menu-item-float'
	                });
	            })();
	
	            // weekly
	            (function () {
	                items.push({
	                    items: p.getItemsByTypeBySixmonth('Weekly'),
	                    text: 'Show <span class="name">weeks</span> in <span class="name">' + p.name + '</span>',
	                    iconCls: 'ns-menu-item-float'
	                });
	            })();
	
	            // daily
	            (function () {
	                items.push({
	                    items: p.getItemsByTypeBySixmonth('Daily'),
	                    text: 'Show <span class="name">days</span> in <span class="name">' + p.name + '</span>',
	                    iconCls: 'ns-menu-item-float'
	                });
	            })();
	
	            return items;
	        };
	        //return;
	    } else if (type === 'SixMonthlyApril') {
	        this.sortId = function () {
	            var a = id.split('AprilS');
	            return a[0] + (a[1].length === 1 ? '000' : '00') + a[1];
	        }();
	        this.typeSortId = '07';
	        this.typeName = 'Six-monthly April';
	        this.displayName = (0, _stringTrim2.default)(this.name.split(this.year)[0]);
	
	        this.getContextMenuItemsConfig = function () {
	            var items = [];
	
	            // drill up
	            items.push({
	                isSubtitle: true,
	                style: 'padding: 5px 5px 5px 5px; font-size: 120%; font-weight:bold',
	                text: this.i18n.drill_up
	            });
	
	            // financial april
	            (function () {
	                var periods = p.getItemsByTypeBySixmonthApril('FinancialApril');
	
	                items.push({
	                    items: periods,
	                    text: 'Show <span class="name">financial Apri ' + p.year + '</span>',
	                    iconCls: 'ns-menu-item-float'
	                });
	            })();
	
	            // financial july
	            (function () {
	                var periods = p.getItemsByTypeBySixmonthApril('FinancialJuly');
	
	                items.push({
	                    items: periods,
	                    text: 'Show <span class="name">financial July' + getSuffix(periods) + ' ' + p.year + '</span>',
	                    iconCls: 'ns-menu-item-float'
	                });
	            })();
	
	            // financial october
	            (function () {
	                var periods = p.getItemsByTypeBySixmonthApril('FinancialOct');
	
	                items.push({
	                    items: periods,
	                    text: 'Show <span class="name">financial October' + p.year + '</span>',
	                    iconCls: 'ns-menu-item-float'
	                });
	            })();
	
	            // yearly
	            (function () {
	                var periods = p.getItemsByTypeBySixmonthApril('Yearly');
	
	                items.push({
	                    items: periods,
	                    text: 'Show <span class="name">' + (getSuffix(periods) ? 'parent years' : p.year) + '</span>',
	                    iconCls: 'ns-menu-item-float'
	                });
	            })();
	
	            // same level
	            items.push({
	                isSubtitle: true,
	                style: 'padding: 5px 5px 5px 5px; font-size: 120%; font-weight:bold',
	                text: this.i18n.sixmonthly
	            });
	
	            // six-monthly april
	            items.push({
	                items: p.getItemsByTypeBySixmonthApril('SixMonthlyApril'),
	                text: 'Show <span class="name">' + p.name + '</span> only',
	                iconCls: 'ns-menu-item-float'
	            });
	
	            items.push({
	                items: p.getItemsByTypeBySixmonthApril('SixMonthlyApril', true),
	                text: 'Show all <span class="name">six-month Aprils</span> in <span class="name">' + p.year + '</span>',
	                iconCls: 'ns-menu-item-float'
	            });
	
	            // drill down
	            items.push({
	                isSubtitle: true,
	                style: 'padding: 5px 5px 5px 5px; font-size: 120%; font-weight:bold',
	                text: this.i18n.drill_down
	            });
	
	            // six-monthly
	            (function () {
	                var periods = p.getItemsByTypeBySixmonthApril('SixMonthly');
	
	                items.push({
	                    items: periods,
	                    text: 'Show <span class="name">six-months</span> in <span class="name">' + p.name + '</span>',
	                    iconCls: 'ns-menu-item-float'
	                });
	            })();
	
	            // quarterly
	            (function () {
	                items.push({
	                    items: p.getItemsByTypeBySixmonthApril('Quarterly'),
	                    text: 'Show <span class="name">quarters</span> in <span class="name">' + p.name + '</span>',
	                    iconCls: 'ns-menu-item-float'
	                });
	            })();
	
	            // bi-monthly
	            (function () {
	                items.push({
	                    items: p.getItemsByTypeBySixmonthApril('BiMonthly'),
	                    text: 'Show <span class="name">bi-months</span> in <span class="name">' + p.name + '</span>',
	                    iconCls: 'ns-menu-item-float'
	                });
	            })();
	
	            // weekly
	            (function () {
	                items.push({
	                    items: p.getItemsByTypeBySixmonthApril('Weekly'),
	                    text: 'Show <span class="name">weeks</span> in <span class="name">' + p.name + '</span>',
	                    iconCls: 'ns-menu-item-float'
	                });
	            })();
	
	            // daily
	            (function () {
	                items.push({
	                    items: p.getItemsByTypeBySixmonthApril('Daily'),
	                    text: 'Show <span class="name">days</span> in <span class="name">' + p.name + '</span>',
	                    iconCls: 'ns-menu-item-float'
	                });
	            })();
	
	            return items;
	        };
	    } else if (type === 'Yearly') {
	        this.sortId = id + '0000';
	        this.typeSortId = '08';
	        this.typeName = 'Yearly';
	        this.displayName = this.name;
	
	        this.getContextMenuItemsConfig = function () {
	            var items = [];
	
	            // drill up
	            items.push({
	                isSubtitle: true,
	                style: 'padding: 5px 5px 5px 5px; font-size: 120%; font-weight:bold',
	                text: this.i18n.drill_up
	            });
	
	            // financial april
	            (function () {
	                var periods = p.getItemsByTypeByYear('FinancialApril');
	
	                items.push({
	                    items: periods,
	                    text: 'Show <span class="name">financial April' + getSuffix(periods) + ' ' + p.year + '</span>',
	                    iconCls: 'ns-menu-item-float'
	                });
	            })();
	
	            // financial july
	            (function () {
	                var periods = p.getItemsByTypeByYear('FinancialJuly');
	
	                items.push({
	                    items: periods,
	                    text: 'Show <span class="name">financial July' + getSuffix(periods) + ' ' + p.year + '</span>',
	                    iconCls: 'ns-menu-item-float'
	                });
	            })();
	
	            // financial october
	            (function () {
	                var periods = p.getItemsByTypeByYear('FinancialOct');
	
	                items.push({
	                    items: periods,
	                    text: 'Show <span class="name">financial October' + getSuffix(periods) + ' ' + p.year + '</span>',
	                    iconCls: 'ns-menu-item-float'
	                });
	            })();
	
	            // same level
	            items.push({
	                isSubtitle: true,
	                style: 'padding: 5px 5px 5px 5px; font-size: 120%; font-weight:bold',
	                text: this.i18n.yearly
	            });
	
	            items.push({
	                items: p.getItemsByTypeByYear('Yearly'),
	                text: 'Show <span class="name">' + p.displayName + '</span> only',
	                iconCls: 'ns-menu-item-float'
	            });
	
	            // drill down
	            items.push({
	                isSubtitle: true,
	                style: 'padding: 5px 5px 5px 5px; font-size: 120%; font-weight:bold',
	                text: this.i18n.drill_down
	            });
	
	            // six-monthly april
	            (function () {
	                items.push({
	                    items: p.getItemsByTypeByYear('SixMonthlyApril'),
	                    text: 'Show <span class="name">six-month Aprils</span> in <span class="name">' + p.name + '</span>',
	                    iconCls: 'ns-menu-item-float'
	                });
	            })();
	
	            // six-monthly
	            (function () {
	                items.push({
	                    items: p.getItemsByTypeByYear('SixMonthly'),
	                    text: 'Show <span class="name">six-months</span> in <span class="name">' + p.name + '</span>',
	                    iconCls: 'ns-menu-item-float'
	                });
	            })();
	
	            // quarterly
	            (function () {
	                items.push({
	                    items: p.getItemsByTypeByYear('Quarterly'),
	                    text: 'Show <span class="name">quarters</span> in <span class="name">' + p.name + '</span>',
	                    iconCls: 'ns-menu-item-float'
	                });
	            })();
	
	            // bi-monthly
	            (function () {
	                items.push({
	                    items: p.getItemsByTypeByYear('BiMonthly'),
	                    text: 'Show <span class="name">bi-months</span> in <span class="name">' + p.name + '</span>',
	                    iconCls: 'ns-menu-item-float'
	                });
	            })();
	
	            // monthly
	            (function () {
	                items.push({
	                    items: p.getItemsByTypeByYear('Monthly'),
	                    text: 'Show <span class="name">months</span> in <span class="name">' + p.name + '</span>',
	                    iconCls: 'ns-menu-item-float'
	                });
	            })();
	
	            // weekly
	            (function () {
	                items.push({
	                    items: p.getItemsByTypeByYear('Weekly'),
	                    text: 'Show <span class="name">weeks</span> in <span class="name">' + p.name + '</span>',
	                    iconCls: 'ns-menu-item-float'
	                });
	            })();
	
	            // daily
	            (function () {
	                items.push({
	                    items: p.getItemsByTypeByYear('Daily'),
	                    text: 'Show <span class="name">days</span> in <span class="name">' + p.name + '</span>',
	                    iconCls: 'ns-menu-item-float'
	                });
	            })();
	
	            return items;
	        };
	    } else if (type === 'FinancialOct') {
	        this.sortId = id.slice(0, 4) + '0003';
	        this.typeSortId = '11';
	        this.typeName = 'Financial October';
	        this.displayName = this.name;
	
	        this.getContextMenuItemsConfig = function () {
	            var items = [];
	
	            // drill up
	            items.push({
	                isSubtitle: true,
	                style: 'padding: 5px 5px 5px 5px; font-size: 120%; font-weight:bold',
	                text: this.i18n.drill_up
	            });
	
	            // financial april
	            (function () {
	                var periods = p.getItemsByTypeByFinancialOct('FinancialApril');
	
	                items.push({
	                    items: periods,
	                    text: 'Show <span class="name">financial April' + getSuffix(periods) + ' ' + p.year + '</span>',
	                    iconCls: 'ns-menu-item-float'
	                });
	            })();
	
	            // financial july
	            (function () {
	                var periods = p.getItemsByTypeByFinancialOct('FinancialJuly');
	
	                items.push({
	                    items: periods,
	                    text: 'Show <span class="name">financial July' + getSuffix(periods) + ' ' + p.year + '</span>',
	                    iconCls: 'ns-menu-item-float'
	                });
	            })();
	
	            // same level
	            items.push({
	                isSubtitle: true,
	                style: 'padding: 5px 5px 5px 5px; font-size: 120%; font-weight:bold',
	                text: this.i18n.financial_oct
	            });
	
	            // financial october
	            items.push({
	                items: p.getItemsByTypeByFinancialOct('FinancialOct'),
	                text: 'Show <span class="name">' + p.name + '</span> only',
	                iconCls: 'ns-menu-item-float'
	            });
	
	            items.push({
	                items: p.getItemsByTypeByFinancialOct('FinancialOct', true),
	                text: 'Show all <span class="name">financial Octobers</span> in <span class="name">' + p.year + '</span>',
	                iconCls: 'ns-menu-item-float'
	            });
	
	            // drill down
	            items.push({
	                isSubtitle: true,
	                style: 'padding: 5px 5px 5px 5px; font-size: 120%; font-weight:bold',
	                text: this.i18n.drill_down
	            });
	
	            // yearly
	            (function () {
	                items.push({
	                    items: p.getItemsByTypeByFinancialOct('Yearly'),
	                    text: 'Show <span class="name">years</span> in <span class="name">' + p.name + '</span>',
	                    iconCls: 'ns-menu-item-float'
	                });
	            })();
	
	            // six-monthly april
	            (function () {
	                items.push({
	                    items: p.getItemsByTypeByFinancialOct('SixMonthlyApril'),
	                    text: 'Show <span class="name">six-month Aprils</span> in <span class="name">' + p.name + '</span>',
	                    iconCls: 'ns-menu-item-float'
	                });
	            })();
	
	            // six-monthly
	            (function () {
	                items.push({
	                    items: p.getItemsByTypeByFinancialOct('SixMonthly'),
	                    text: 'Show <span class="name">six-months</span> in <span class="name">' + p.name + '</span>',
	                    iconCls: 'ns-menu-item-float'
	                });
	            })();
	
	            // quarterly
	            (function () {
	                items.push({
	                    items: p.getItemsByTypeByFinancialOct('Quarterly'),
	                    text: 'Show <span class="name">quarters</span> in <span class="name">' + p.name + '</span>',
	                    iconCls: 'ns-menu-item-float'
	                });
	            })();
	
	            // bi-monthly
	            (function () {
	                items.push({
	                    items: p.getItemsByTypeByFinancialOct('BiMonthly'),
	                    text: 'Show <span class="name">bi-months</span> in <span class="name">' + p.name + '</span>',
	                    iconCls: 'ns-menu-item-float'
	                });
	            })();
	
	            // monthly
	            (function () {
	                items.push({
	                    items: p.getItemsByTypeByFinancialOct('Monthly'),
	                    text: 'Show <span class="name">months</span> in <span class="name">' + p.name + '</span>',
	                    iconCls: 'ns-menu-item-float'
	                });
	            })();
	
	            // weekly
	            (function () {
	                items.push({
	                    items: p.getItemsByTypeByFinancialOct('Weekly'),
	                    text: 'Show <span class="name">weeks</span> in <span class="name">' + p.name + '</span>',
	                    iconCls: 'ns-menu-item-float'
	                });
	            })();
	
	            // daily
	            (function () {
	                items.push({
	                    items: p.getItemsByTypeByFinancialOct('Daily'),
	                    text: 'Show <span class="name">days</span> in <span class="name">' + p.name + '</span>',
	                    iconCls: 'ns-menu-item-float'
	                });
	            })();
	
	            return items;
	        };
	    } else if (type === 'FinancialJuly') {
	        this.sortId = id.slice(0, 4) + '0002';
	        this.typeSortId = '10';
	        this.typeName = 'Financial July';
	        this.displayName = this.name;
	
	        this.getContextMenuItemsConfig = function () {
	            var items = [];
	
	            // drill up
	            items.push({
	                isSubtitle: true,
	                style: 'padding: 5px 5px 5px 5px; font-size: 120%; font-weight:bold',
	                text: this.i18n.drill_up
	            });
	
	            // financial april
	            (function () {
	                var periods = p.getItemsByTypeByFinancialJuly('FinancialApril');
	
	                items.push({
	                    items: periods,
	                    text: 'Show <span class="name">financial April' + getSuffix(periods) + ' ' + p.year + '</span>',
	                    iconCls: 'ns-menu-item-float'
	                });
	            })();
	
	            // same level
	            items.push({
	                isSubtitle: true,
	                style: 'padding: 5px 5px 5px 5px; font-size: 120%; font-weight:bold',
	                text: this.i18n.financial_july
	            });
	
	            // financial july
	            items.push({
	                items: p.getItemsByTypeByFinancialJuly('FinancialJuly'),
	                text: 'Show <span class="name">' + p.name + '</span> only',
	                iconCls: 'ns-menu-item-float'
	            });
	
	            items.push({
	                items: p.getItemsByTypeByFinancialJuly('FinancialJuly', true),
	                text: 'Show all <span class="name">financial Julys</span> in <span class="name">' + p.year + '</span>',
	                iconCls: 'ns-menu-item-float'
	            });
	
	            // drill down
	            items.push({
	                isSubtitle: true,
	                style: 'padding: 5px 5px 5px 5px; font-size: 120%; font-weight:bold',
	                text: this.i18n.drill_down
	            });
	
	            // financial oct
	            (function () {
	                items.push({
	                    items: p.getItemsByTypeByFinancialJuly('FinancialOct'),
	                    text: 'Show <span class="name">financial Octobers</span> in <span class="name">' + p.name + '</span>',
	                    iconCls: 'ns-menu-item-float'
	                });
	            })();
	
	            // yearly
	            (function () {
	                items.push({
	                    items: p.getItemsByTypeByFinancialJuly('Yearly'),
	                    text: 'Show <span class="name">years</span> in <span class="name">' + p.name + '</span>',
	                    iconCls: 'ns-menu-item-float'
	                });
	            })();
	
	            // six-monthly april
	            (function () {
	                items.push({
	                    items: p.getItemsByTypeByFinancialJuly('SixMonthlyApril'),
	                    text: 'Show <span class="name">six-month Aprils</span> in <span class="name">' + p.name + '</span>',
	                    iconCls: 'ns-menu-item-float'
	                });
	            })();
	
	            // six-monthly
	            (function () {
	                items.push({
	                    items: p.getItemsByTypeByFinancialJuly('SixMonthly'),
	                    text: 'Show <span class="name">six-months</span> in <span class="name">' + p.name + '</span>',
	                    iconCls: 'ns-menu-item-float'
	                });
	            })();
	
	            // quarterly
	            (function () {
	                items.push({
	                    items: p.getItemsByTypeByFinancialJuly('Quarterly'),
	                    text: 'Show <span class="name">quarters</span> in <span class="name">' + p.name + '</span>',
	                    iconCls: 'ns-menu-item-float'
	                });
	            })();
	
	            // bi-monthly
	            (function () {
	                items.push({
	                    items: p.getItemsByTypeByFinancialJuly('BiMonthly'),
	                    text: 'Show <span class="name">bi-months</span> in <span class="name">' + p.name + '</span>',
	                    iconCls: 'ns-menu-item-float'
	                });
	            })();
	
	            // monthly
	            (function () {
	                items.push({
	                    items: p.getItemsByTypeByFinancialJuly('Monthly'),
	                    text: 'Show <span class="name">months</span> in <span class="name">' + p.name + '</span>',
	                    iconCls: 'ns-menu-item-float'
	                });
	            })();
	
	            // weekly
	            (function () {
	                items.push({
	                    items: p.getItemsByTypeByFinancialJuly('Weekly'),
	                    text: 'Show <span class="name">weeks</span> in <span class="name">' + p.name + '</span>',
	                    iconCls: 'ns-menu-item-float'
	                });
	            })();
	
	            // daily
	            (function () {
	                items.push({
	                    items: p.getItemsByTypeByFinancialJuly('Daily'),
	                    text: 'Show <span class="name">days</span> in <span class="name">' + p.name + '</span>',
	                    iconCls: 'ns-menu-item-float'
	                });
	            })();
	
	            return items;
	        };
	    } else if (type === 'FinancialApril') {
	        this.sortId = id.slice(0, 4) + '0001';
	        this.typeSortId = '09';
	        this.typeName = 'Financial April';
	        this.displayName = this.name;
	
	        this.getContextMenuItemsConfig = function () {
	            var items = [];
	
	            // same level
	            items.push({
	                isSubtitle: true,
	                style: 'padding: 5px 5px 5px 5px; font-size: 120%; font-weight:bold',
	                text: this.i18n.financial_april
	            });
	
	            // financial april
	            items.push({
	                items: p.getItemsByTypeByFinancialApril('FinancialApril'),
	                text: 'Show <span class="name">' + p.name + '</span> only',
	                iconCls: 'ns-menu-item-float'
	            });
	
	            items.push({
	                items: p.getItemsByTypeByFinancialApril('FinancialApril', true),
	                text: 'Show all <span class="name">financial Aprils</span> in <span class="name">' + p.year + '</span>',
	                iconCls: 'ns-menu-item-float'
	            });
	
	            // drill down
	            items.push({
	                isSubtitle: true,
	                style: 'padding: 5px 5px 5px 5px; font-size: 120%; font-weight:bold',
	                text: this.i18n.drill_down
	            });
	
	            // financial july
	            (function () {
	                items.push({
	                    items: p.getItemsByTypeByFinancialApril('FinancialJuly'),
	                    text: 'Show <span class="name">financial Julys</span> in <span class="name">' + p.name + '</span>',
	                    iconCls: 'ns-menu-item-float'
	                });
	            })();
	
	            // financial october
	            (function () {
	                items.push({
	                    items: p.getItemsByTypeByFinancialApril('FinancialOct'),
	                    text: 'Show <span class="name">financial Octobers</span> in <span class="name">' + p.name + '</span>',
	                    iconCls: 'ns-menu-item-float'
	                });
	            })();
	
	            // yearly
	            (function () {
	                items.push({
	                    items: p.getItemsByTypeByFinancialApril('Yearly'),
	                    text: 'Show <span class="name">years</span> in <span class="name">' + p.name + '</span>',
	                    iconCls: 'ns-menu-item-float'
	                });
	            })();
	
	            // six-monthly april
	            (function () {
	                items.push({
	                    items: p.getItemsByTypeByFinancialApril('SixMonthlyApril'),
	                    text: 'Show <span class="name">six-month Aprils</span> in <span class="name">' + p.name + '</span>',
	                    iconCls: 'ns-menu-item-float'
	                });
	            })();
	
	            // six-monthly
	            (function () {
	                items.push({
	                    items: p.getItemsByTypeByFinancialApril('SixMonthly'),
	                    text: 'Show <span class="name">six-months</span> in <span class="name">' + p.name + '</span>',
	                    iconCls: 'ns-menu-item-float'
	                });
	            })();
	
	            // quarterly
	            (function () {
	                items.push({
	                    items: p.getItemsByTypeByFinancialApril('Quarterly'),
	                    text: 'Show <span class="name">quarters</span> in <span class="name">' + p.name + '</span>',
	                    iconCls: 'ns-menu-item-float'
	                });
	            })();
	
	            // bi-monthly
	            (function () {
	                items.push({
	                    items: p.getItemsByTypeByFinancialApril('BiMonthly'),
	                    text: 'Show <span class="name">bi-months</span> in <span class="name">' + p.name + '</span>',
	                    iconCls: 'ns-menu-item-float'
	                });
	            })();
	
	            // monthly
	            (function () {
	                items.push({
	                    items: p.getItemsByTypeByFinancialApril('Monthly'),
	                    text: 'Show <span class="name">months</span> in <span class="name">' + p.name + '</span>',
	                    iconCls: 'ns-menu-item-float'
	                });
	            })();
	
	            // weekly
	            (function () {
	                items.push({
	                    items: p.getItemsByTypeByFinancialApril('Weekly'),
	                    text: 'Show <span class="name">weeks</span> in <span class="name">' + p.name + '</span>',
	                    iconCls: 'ns-menu-item-float'
	                });
	            })();
	
	            // daily
	            (function () {
	                items.push({
	                    items: p.getItemsByTypeByFinancialApril('Daily'),
	                    text: 'Show <span class="name">days</span> in <span class="name">' + p.name + '</span>',
	                    iconCls: 'ns-menu-item-float'
	                });
	            })();
	
	            return items;
	        };
	    }
	};
	//# sourceMappingURL=Period.js.map

/***/ },
/* 60 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.defaultProxyGenerator = exports.addMerge = exports.getUniqueFactor = exports.buildTable2D = exports.getPercentageHtml = exports.getRoundedHtmlValue = exports.getNumberOfDecimals = exports.toRow = exports.getValue = exports.roundIf = undefined;
	
	var _numberToFixed = __webpack_require__(189);
	
	var _numberToFixed2 = _interopRequireDefault(_numberToFixed);
	
	var _isNumber = __webpack_require__(7);
	
	var _isNumber2 = _interopRequireDefault(_isNumber);
	
	var _isBoolean = __webpack_require__(15);
	
	var _isBoolean2 = _interopRequireDefault(_isBoolean);
	
	var _isArray = __webpack_require__(1);
	
	var _isArray2 = _interopRequireDefault(_isArray);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** @description round number if needed.
	 *  @param   {number} number 
	 *  @param   {number} precision 
	 *  @returns {number}
	 */
	var roundIf = exports.roundIf = function roundIf(number, precision) {
	    number = parseFloat(number);
	    precision = parseFloat(precision);
	
	    if ((0, _isNumber2.default)(number) && (0, _isNumber2.default)(precision)) {
	        var numberOfDecimals = getNumberOfDecimals(number);
	        return numberOfDecimals > precision ? (0, _numberToFixed2.default)(number, precision) : number;
	    }
	
	    return number;
	};
	
	/** @description gets integer representation of given string.
	 *  @param   {string} str 
	 *  @returns {number}
	 */
	var getValue = exports.getValue = function getValue(str) {
	    var n = parseFloat(str);
	
	    if ((0, _isBoolean2.default)(str)) {
	        return 1;
	    }
	
	    if (!(0, _isNumber2.default)(n) || n != str) {
	        return 0;
	    }
	
	    return n;
	};
	
	/** @description turns array of arrays into a single row.
	 *  @param   {array} array 
	 *  @returns {array}
	 */
	var toRow = exports.toRow = function toRow(array) {
	
	    if (!(0, _isArray2.default)(array[0])) {
	        return [array];
	    }
	
	    var row = new Array(array[0].length);
	
	    for (var i = 0; i < row.length; i++) {
	        row[i] = [];
	    }
	
	    for (var _i = 0; _i < array.length; _i++) {
	        for (var j = 0; j < array[_i].length; j++) {
	            row[j].push(array[_i][j]);
	        }
	    }
	
	    return row;
	};
	
	/** @description returns the number of decumal of given float
	 *  @param   {number} number 
	 *  @returns {number}
	 *  @deprecated should switch to use function located in d2-utilizr
	 */
	var getNumberOfDecimals = exports.getNumberOfDecimals = function getNumberOfDecimals(number) {
	    var str = new String(number);
	    return str.indexOf('.') > -1 ? str.length - str.indexOf('.') - 1 : 0;
	};
	
	/** @description returns the rounded value of the given float.
	 *  @param   {number} value 
	 *  @param   {number} [dec=2] 
	 *  @returns {number}
	 */
	var getRoundedHtmlValue = exports.getRoundedHtmlValue = function getRoundedHtmlValue(value) {
	    var dec = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
	
	    return parseFloat(roundIf(value, 2)).toString();
	};
	
	/** @description get percentage representation of value.
	 *  @param   {number} value 
	 *  @param   {number} total 
	 *  @returns {string}
	 */
	var getPercentageHtml = exports.getPercentageHtml = function getPercentageHtml(value, total) {
	    return getRoundedHtmlValue(value / total * 100) + '%';
	};
	
	/** @description Builds a 2D array with the given dimensions
	 *  @param   {number} rows
	 *  @param   {number} columns
	 *  @returns {array}  
	 */
	var buildTable2D = exports.buildTable2D = function buildTable2D(rows, columns, fill) {
	    var table2D = new Array(rows);
	
	    for (var i = 0; i < rows; i++) {
	        table2D[i] = new Array(columns);
	        if (typeof fill !== 'undefined') table2D[i].fill(fill);
	    }
	
	    return table2D;
	};
	
	var getUniqueFactor = exports.getUniqueFactor = function getUniqueFactor(axis) {
	    if (axis.xItems && axis.xItems.unique) {
	        return axis.xItems.unique.length < 2 ? 1 : axis.size / axis.xItems.unique[0].length;
	    }
	    return null;
	};
	
	var addMerge = exports.addMerge = function addMerge(a, b) {
	    Object.keys(a).forEach(function (key) {
	        if (b[key]) {
	            a[key] += b[key];
	        }
	    });
	};
	
	var defaultProxyGenerator = exports.defaultProxyGenerator = function defaultProxyGenerator(defaultReturnValue) {
	    return new Proxy({}, { get: function get(target, name) {
	            return name in target ? target[name] : defaultReturnValue;
	        } });
	};
	//# sourceMappingURL=PivotTableUtils.js.map

/***/ },
/* 61 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.AboutWindow = undefined;
	
	var _isObject = __webpack_require__(2);
	
	var _isObject2 = _interopRequireDefault(_isObject);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AboutWindow = exports.AboutWindow = undefined;
	
	exports.AboutWindow = AboutWindow = function AboutWindow(c) {
	    var appManager = c.appManager,
	        uiManager = c.uiManager,
	        instanceManager = c.instanceManager,
	        i18n = c.i18nManager.get(),
	        apiPath = appManager.getApiPath();
	
	    return Ext.create('Ext.window.Window', {
	        title: i18n.about,
	        bodyStyle: 'background:#fff; padding:6px',
	        modal: true,
	        resizable: false,
	        destroyOnBlur: true,
	        getData: function getData() {
	            var t = this;
	
	            Ext.Ajax.request({
	                url: encodeURI(apiPath + '/system/info.json'),
	                success: function success(r) {
	                    var info = Ext.decode(r.responseText),
	                        divStyle = 'padding:3px',
	                        html = '<div class="user-select">';
	
	                    if ((0, _isObject2.default)(info)) {
	                        html += '<div style="' + divStyle + '"><b>' + i18n.time_since_last_data_update + ': </b>' + info.intervalSinceLastAnalyticsTableSuccess + '</div>';
	                        html += '<div style="' + divStyle + '"><b>' + i18n.version + ': </b>' + info.version + '</div>';
	                        html += '<div style="' + divStyle + '"><b>' + i18n.revision + ': </b>' + info.revision + '</div>';
	                        html += '<div style="' + divStyle + '"><b>' + i18n.username + ': </b>' + appManager.userAccount.username + '</div>';
	                        html += '</div>';
	                    } else {
	                        html += 'No system info found';
	                    }
	
	                    t.update(html);
	                },
	                failure: function failure(r) {
	                    t.update(r.status + '\n' + r.statusText + '\n' + r.responseText);
	                },
	                callback: function callback() {
	                    t.show();
	
	                    uiManager.enableRightClick();
	
	                    var aboutButton = uiManager.get('aboutButton') || {};
	
	                    if (aboutButton.rendered) {
	                        uiManager.setAnchorPosition(t, aboutButton);
	
	                        if (!t.hasDestroyOnBlurHandler) {
	                            uiManager.addDestroyOnBlurHandler(t);
	                        }
	                    }
	                }
	            });
	        },
	        listeners: {
	            hide: function hide() {
	                uiManager.disableRightClick();
	            },
	            destroy: function destroy() {
	                uiManager.disableRightClick();
	            }
	        }
	    });
	};
	//# sourceMappingURL=AboutWindow.js.map

/***/ },
/* 62 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.EastRegion = undefined;
	
	var _DateManager = __webpack_require__(24);
	
	var _InterpretationWindow = __webpack_require__(26);
	
	var _SharingWindow = __webpack_require__(27);
	
	var _RenameWindow = __webpack_require__(41);
	
	var _arraySort = __webpack_require__(10);
	
	var _arraySort2 = _interopRequireDefault(_arraySort);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EastRegion = exports.EastRegion = undefined;
	
	exports.EastRegion = EastRegion = function EastRegion(c) {
	
	    var t = this,
	        uiManager = c.uiManager,
	        uiConfig = c.uiConfig,
	        instanceManager = c.instanceManager,
	        appManager = c.appManager,
	        i18nManager = c.i18nManager;
	
	    var i18n = i18nManager.get(),
	        path = appManager.getPath(),
	        apiPath = appManager.getApiPath();
	
	    var descriptionMaxNumberCharacter = 500;
	
	    var openInterpretationWindow = function openInterpretationWindow(id, interpretation, success) {
	        var favoriteId = id || instanceManager.getStateFavoriteId();
	        instanceManager.getSharingById(favoriteId, function (r) {
	            (0, _InterpretationWindow.InterpretationWindow)(c, r, interpretation, success).show();
	        }, { allowForbidden: true });
	    };
	
	    var userCanManageInterpretation = function userCanManageInterpretation(interpretation) {
	        return interpretation.user.id == appManager.userAccount.id || appManager.isAdmin;
	    };
	
	    var userCanManageComment = function userCanManageComment(comment) {
	        return comment.user.id == appManager.userAccount.id || appManager.isAdmin;
	    };
	
	    var getLink = function getLink(text, isBold, isBrackets) {
	        return (isBrackets ? '<span class="bold">[</span> ' : '') + '<span class="eastPanelLink' + (isBold ? ' bold' : '') + '">' + text + '</span>' + (isBrackets ? ' <span class="bold">]</span>' : '');
	    };
	
	    /*
	     * FAVORITE DETAILS PANEL
	     */
	
	    var getDetailsPanelItems = function getDetailsPanelItems(layout) {
	        // Favorite loaded ->  Add favorite detail panel and update
	        // Otherwise -> Display No Favorite Panel
	        var detailsPanelItems;
	        if (instanceManager.isStateFavorite()) {
	
	            var moreText = i18n.show_more;
	            var lessText = i18n.show_less;
	            var editText = i18n.edit;
	
	            // Create Description Panel from description field
	            var getDescriptionPanel = function getDescriptionPanel(description) {
	                var descriptionItems = [];
	                if (description == undefined) {
	                    description = i18n.no_description;
	                }
	
	                var isTooLongDescription = description.length > descriptionMaxNumberCharacter;
	                var shortDescription = description.substring(0, descriptionMaxNumberCharacter) + ' ... ';
	
	                // DHIS2-2210: render line breaks
	                description = description.replace(/\n/g, '<br />');
	                shortDescription = shortDescription.replace(/\n/g, '<br />');
	
	                // Description label
	                descriptionItems.push({
	                    xtype: 'label',
	                    itemId: 'descriptionLabel',
	                    html: isTooLongDescription ? shortDescription : description,
	                    cls: 'interpretationActions'
	                });
	
	                // Longer than [descriptionMaxNumberCharacter] characters -> Create More/Less link
	                if (isTooLongDescription) {
	                    var longDescription = description;
	
	                    descriptionItems.push({
	                        xtype: 'label',
	                        html: getLink(moreText, false, true),
	                        cls: 'interpretationActions',
	                        isShortDescriptionDisplayed: true,
	                        style: 'margin: 1px 3px 0;',
	                        listeners: {
	                            render: function render(label) {
	                                label.getEl().on('click', function () {
	                                    if (this.isShortDescriptionDisplayed) {
	                                        this.up('#descriptionPanel').down('#descriptionLabel').setText(longDescription, false);
	                                        this.getEl().dom.innerHTML = getLink(lessText, false, true);
	                                    } else {
	                                        this.up('#descriptionPanel').down('#descriptionLabel').setText(shortDescription, false);
	                                        this.getEl().dom.innerHTML = getLink(moreText, false, true);
	                                    }
	                                    this.isShortDescriptionDisplayed = !this.isShortDescriptionDisplayed;
	                                    this.up('#descriptionPanel').doLayout();
	                                }, label);
	                            }
	                        }
	                    });
	                }
	
	                // Change Link
	                if (layout && layout.permission === "write") {
	                    descriptionItems.push({
	                        xtype: 'label',
	                        html: getLink(editText, false, true),
	                        cls: 'interpretationActions',
	                        style: 'margin: 1px 3px 0;',
	                        listeners: {
	                            'render': function render(label) {
	                                label.getEl().on('click', function () {
	                                    (0, _RenameWindow.RenameWindow)(c, instanceManager.getStateFavorite()).show();
	                                }, label);
	                            }
	                        }
	                    });
	                }
	
	                return descriptionItems;
	            };
	
	            // Create Sharing setting text from publicAccess and userGroupAccesses field
	            var getSharingText = function getSharingText(layout) {
	                // Public permissions
	                var sharingText = i18n.public + ': ';
	                if (layout.publicAccess == "r-------") {
	                    sharingText += i18n.read;
	                } else if (layout.publicAccess == "rw------") {
	                    sharingText += i18n.read_write;
	                } else {
	                    sharingText += i18n.none;
	                }
	
	                // User Group Accesses permissions
	                // TODO: Create a tooltip
	                if (layout.userGroupAccesses != undefined) {
	                    sharingText += ' + ';
	                    if (layout.userGroupAccesses.length > 2) {
	                        sharingText += layout.userGroupAccesses.length + ' ' + i18n.groups;
	                    } else {
	                        for (var i = 0; i < layout.userGroupAccesses.length; i++) {
	                            if (i > 0) {
	                                sharingText += ', ';
	                            }
	                            sharingText += i18n.group + ' ' + layout.userGroupAccesses[i].displayName;
	                        }
	                    }
	                }
	                return sharingText;
	            };
	
	            // Get Number of Views from analytics api and update label
	            var setNumberOfViews = function setNumberOfViews(label, favoritesId) {
	                Ext.Ajax.request({
	                    url: encodeURI(apiPath + '/dataStatistics/favorites/' + favoritesId + '.json'),
	                    method: 'GET',
	                    scope: this,
	                    success: function success(r) {
	                        label.setValue(Ext.decode(r.responseText).views);
	                    }
	                });
	                return i18n.loading + '..';
	            };
	
	            // Favorite Details Panel content when favorite loaded
	            var userCanEditSharing = layout && layout.permission === 'write';
	
	            detailsPanelItems = [{
	                xtype: 'panel',
	                itemId: 'descriptionPanel',
	                bodyStyle: 'border-style:none;',
	                style: 'margin-bottom:5px;',
	                items: [getDescriptionPanel(layout.displayDescription)]
	            }, {
	                xtype: 'displayfield',
	                fieldLabel: i18n.owner,
	                labelStyle: 'padding-top:0',
	                style: 'margin-bottom:3px',
	                itemId: 'owner',
	                value: layout.user != undefined ? layout.user.displayName : '',
	                cls: 'interpretationDetailsField'
	            }, {
	                xtype: 'displayfield',
	                itemId: 'created',
	                fieldLabel: i18n.created,
	                labelStyle: 'padding-top:0',
	                style: 'margin-bottom:3px',
	                value: layout.created,
	                cls: 'interpretationDetailsField'
	            }, {
	                xtype: 'displayfield',
	                itemId: 'lastUpdated',
	                fieldLabel: i18n.last_updated,
	                labelStyle: 'padding-top:0',
	                style: 'margin-bottom:3px',
	                value: layout.lastUpdated,
	                cls: 'interpretationDetailsField'
	            }, {
	                xtype: 'displayfield',
	                itemId: 'numberViews',
	                fieldLabel: i18n.views,
	                labelStyle: 'padding-top:0',
	                style: 'margin-bottom:3px',
	                value: i18n.loading + '..',
	                cls: 'interpretationDetailsField',
	                listeners: {
	                    'render': function render(label) {
	                        setNumberOfViews(label, layout.id);
	                    }
	                }
	            }, {
	                xtype: 'displayfield',
	                itemId: 'sharing',
	                fieldLabel: i18n.sharing,
	                labelStyle: 'padding-top:0',
	                style: 'margin-bottom:3px',
	                value: getSharingText(layout) + (userCanEditSharing ? '<span style="padding-left:10px">' + getLink(editText, false, true) + '</span>' : ''),
	                cls: 'interpretationDetailsField',
	                listeners: {
	                    'render': function render(label) {
	                        if (userCanEditSharing) {
	                            label.getEl().on('click', function () {
	                                instanceManager.getSharingById(instanceManager.getStateFavoriteId(), function (r) {
	                                    (0, _SharingWindow.SharingWindow)(c, r).show();
	                                });
	                            }, label);
	                        }
	                    }
	                }
	            }];
	        } else {
	            // Favorite Details Panel content when no favorite is loaded
	            detailsPanelItems = [{
	                xtype: 'label',
	                text: i18n.no_current_favorite,
	                cls: 'interpretationActions',
	                style: 'padding:4px 1px;'
	            }];
	        }
	
	        return {
	            xtype: 'panel',
	            bodyStyle: 'border-style:none',
	            style: 'padding:6px;',
	            itemId: 'noFavoriteDetailsPanel',
	            defaults: {
	                style: 'margin-top: 1px;'
	            },
	            items: [detailsPanelItems]
	        };
	    };
	
	    // Main Details Panel Container
	    var detailsPanel = {
	        xtype: 'panel',
	        cls: 'ns-panel-title-east-default first',
	        title: i18n.details,
	        itemId: 'detailsPanel',
	
	        addAndUpdateFavoritePanel: function addAndUpdateFavoritePanel(layout) {
	            // Remove any previous panel
	            this.removeAll(true);
	
	            this.add(getDetailsPanelItems(layout));
	        },
	
	        tools: [{
	            type: 'triple-chevron-right',
	            cls: 'tool-triple-chevron-right',
	            handler: function handler() {
	                uiManager.toggleCollapseRegion('eastRegion');
	                uiManager.get('centerRegion').toggleEastRegion();
	            }
	        }],
	
	        // By default no favorite details panel is displayed
	        items: getDetailsPanelItems()
	    };
	
	    /*
	     * INTERPRETATIONS PANEL
	     */
	
	    // Create interpretation panel depending on interpretation
	    var getInterpretationPanel = function getInterpretationPanel(layout, interpretation, displayingComments) {
	
	        var numberOfCommentsToDisplay = 3;
	
	        var getWriteCommentBox = function getWriteCommentBox(comment, visible) {
	            return {
	                xtype: 'panel',
	                bodyStyle: 'border-style:none',
	                layout: 'column',
	                itemId: 'commentPanel-' + (comment ? comment.id : "new"),
	                hidden: !visible || !layout || layout.permission === "none",
	                style: 'margin-top: 1px;',
	                cls: 'comment greyBackground',
	                items: [{
	                    xtype: 'panel',
	                    bodyStyle: 'border-style:none',
	                    items: [{
	                        xtype: 'label',
	                        cls: 'avatar',
	                        text: appManager.userAccount.firstName[0] + appManager.userAccount.surname.split(' ')[appManager.userAccount.surname.split(' ').length - 1][0]
	                    }],
	                    columnWidth: 0.11
	                }, {
	                    xtype: 'panel',
	                    bodyStyle: 'border-style:none',
	                    autoWidth: true,
	                    layout: 'fit',
	                    flex: 1,
	                    items: [{
	                        xtype: 'textarea',
	                        itemId: 'commentArea',
	                        cls: 'commentArea',
	                        emptyText: i18n.write_your_interpretation,
	                        value: comment && comment.text,
	                        submitEmptyText: false,
	                        flex: 1,
	                        border: 0,
	                        enableKeyEvents: true,
	                        listeners: {
	                            keypress: function keypress(f, e) {
	                                if (e.getKey() == e.ENTER && !e.shiftKey) {
	                                    commentInterpretation(f, comment);
	                                }
	                            }
	                        }
	                    }, {
	                        xtype: 'panel',
	                        bodyStyle: 'border-style:none',
	                        items: [{
	                            xtype: 'label',
	                            html: getLink(i18n.post_comment),
	                            cls: 'link',
	                            listeners: {
	                                'render': function render(label) {
	                                    label.getEl().on('click', function () {
	                                        commentInterpretation(this.up("panel").up("panel").down('#commentArea'), comment);
	                                    }, label);
	                                }
	                            }
	                        }, {
	                            xtype: 'label',
	                            text: '·',
	                            hidden: !comment,
	                            style: 'margin-left: 5px; margin-right: 5px;'
	                        }, {
	                            xtype: 'label',
	                            html: getLink(i18n.cancel),
	                            hidden: !comment,
	                            cls: 'link',
	                            listeners: {
	                                'render': function render(label) {
	                                    label.getEl().on('click', function () {
	                                        cancelCommentEdit(this, comment);
	                                    }, label);
	                                }
	                            }
	                        }]
	                    }],
	                    columnWidth: 0.89
	                }]
	            };
	        };
	
	        // Create inner comments panel depending on comments
	        var getCommentsPanel = function getCommentsPanel(comments) {
	
	            var commentsPanel = [];
	
	            // Textarea to comment
	            commentsPanel.push(getWriteCommentBox(null, true));
	
	            // Comments
	            // Sorting by last updated
	            (0, _arraySort2.default)(comments, 'DESC', 'lastUpdated');
	            for (var i = 0; i < comments.length; i++) {
	                var comment = comments[i];
	                commentsPanel.push({
	                    xtype: 'panel',
	                    bodyStyle: 'border-style:none;',
	                    id: 'commentContent-' + comment.id,
	                    cls: 'comment greyBackground',
	                    layout: 'column',
	                    hidden: i > numberOfCommentsToDisplay - 1,
	                    items: [{
	                        xtype: 'panel',
	                        bodyStyle: 'border-style:none',
	                        items: [{
	                            xtype: 'label',
	                            cls: 'avatar',
	                            text: comment.user.displayName.split(' ')[0][0] + comment.user.displayName.split(' ')[comment.user.displayName.split(' ').length - 1][0]
	                        }],
	                        columnWidth: 0.11
	                    }, {
	                        xtype: 'panel',
	                        bodyStyle: 'border-style:none',
	                        items: [{
	                            xtype: 'panel',
	                            style: 'margin-bottom: 3px;',
	                            bodyStyle: 'border-style:none',
	                            items: [{
	                                xtype: 'label',
	                                html: getLink(comment.user.displayName, true),
	                                cls: 'link bold',
	                                style: 'margin-right: 7px;',
	                                listeners: {
	                                    render: function render() {
	                                        this.getEl().on('click', function () {
	                                            window.location.href = path + '/dhis-web-messaging/profile.action?id=' + comment.user.id;
	                                        });
	                                    }
	                                }
	                            }, {
	                                xtype: 'label',
	                                text: comment.text
	                            }]
	                        }, {
	                            xtype: 'label',
	                            style: 'color: #666',
	                            text: _DateManager.DateManager.getTimeDifference(comment.lastUpdated) + ' ' + i18n.ago
	                        }, {
	                            xtype: 'label',
	                            html: getLink(i18n.edit),
	                            hidden: !userCanManageComment(comment),
	                            style: 'margin-right: 5px; margin-left: 5px',
	                            listeners: {
	                                'render': function (comment_) {
	                                    return function (label) {
	                                        label.getEl().on('click', function () {
	                                            editComment(this, comment_);
	                                        }, this);
	                                    };
	                                }(comment)
	                            }
	                        }, {
	                            xtype: 'label',
	                            text: '·',
	                            style: 'margin-right: 5px;'
	                        }, {
	                            xtype: 'label',
	                            html: getLink(i18n.delete_),
	                            style: 'margin-right: 5px;',
	                            hidden: !userCanManageComment(comment),
	                            listeners: {
	                                'render': function (comment_) {
	                                    return function (label) {
	                                        label.getEl().on('click', function () {
	                                            var label = this;
	                                            uiManager.confirmCommentDelete(function () {
	                                                deleteComment(label, comment_);
	                                            });
	                                        }, this);
	                                    };
	                                }(comment)
	                            }
	                        }],
	                        columnWidth: 0.89
	                    }]
	                });
	
	                // Box to edit the comment
	                commentsPanel.push(getWriteCommentBox(comment, false));
	            }
	
	            // Show more comments
	            if (comments.length > 3 && comments.length > numberOfCommentsToDisplay) {
	                commentsPanel.push({
	                    xtype: 'panel',
	                    bodyStyle: 'border-style:none',
	                    style: 'margin-top: 1px;',
	                    cls: 'comment greyBackground',
	                    items: [{
	                        xtype: 'label',
	                        text: '[' + (comments.length - numberOfCommentsToDisplay) + ' ' + i18n.more_comments + ']',
	                        cls: 'link',
	                        listeners: {
	                            'render': function render(label) {
	                                label.getEl().on('click', function () {
	                                    numberOfCommentsToDisplay += 3;
	                                    this.up('#interpretationPanel' + interpretation.id).updateInterpretationPanelItems();
	                                }, label);
	                            }
	                        }
	                    }]
	                });
	            }
	
	            return commentsPanel;
	        };
	
	        // User has liked this interpretation -> true
	        // Otherwise -> false
	        var isLiked = function isLiked(interpretation) {
	            var userId = appManager.userAccount.id;
	            for (var i = 0; i < interpretation.likedBy.length; i++) {
	                if (interpretation.likedBy[i].id == userId) {
	                    return true;
	                }
	            }
	            return false;
	        };
	
	        var refreshInterpretationDataModel = function refreshInterpretationDataModel(interpretationPanel) {
	            Ext.Ajax.request({
	                url: encodeURI(apiPath + '/interpretations/' + interpretation.id + '.json?fields=*,user[id,displayName],likedBy[id,displayName],comments[id,lastUpdated,text,user[id,displayName]]'),
	                method: 'GET',
	                scope: this,
	                success: function success(r) {
	                    // Refreshing interpretation panel
	                    interpretation = JSON.parse(r.responseText);
	                    interpretationPanel.updateInterpretationPanelItems(interpretation);
	                }
	            });
	        };
	
	        // Call Like or Unlike interpretation, update data model and update/reload panel
	        var likeUnlikeInterpretation = function likeUnlikeInterpretation() {
	            var that = this;
	            if (isLiked(interpretation)) {
	                Ext.Ajax.request({
	                    url: encodeURI(apiPath + '/interpretations/' + interpretation.id + '/like'),
	                    method: 'DELETE',
	                    success: function success() {
	                        refreshInterpretationDataModel(that.up('#interpretationPanel' + interpretation.id));
	                    }
	                });
	            } else {
	                Ext.Ajax.request({
	                    url: encodeURI(apiPath + '/interpretations/' + interpretation.id + '/like'),
	                    method: 'POST',
	                    success: function success() {
	                        refreshInterpretationDataModel(that.up('#interpretationPanel' + interpretation.id));
	                    }
	                });
	            }
	        };
	
	        // Call comment interpretation, update data model and update/reload panel
	        var commentInterpretation = function commentInterpretation(f, comment) {
	            var text = f.getValue();
	
	            if (text.trim() != '') {
	                var commentsUrl = encodeURI(apiPath + '/interpretations/' + interpretation.id + '/comments');
	                Ext.Ajax.request({
	                    url: comment ? commentsUrl + '/' + comment.id : commentsUrl,
	                    method: comment ? 'PUT' : 'POST',
	                    params: text,
	                    headers: {
	                        'Content-Type': 'text/plain'
	                    },
	                    success: function success() {
	                        refreshInterpretationDataModel(f.up('#interpretationPanel' + interpretation.id));
	                    }
	                });
	            }
	        };
	
	        // Update an interpretation update data model and update/reload panel
	        var editInterpretation = function editInterpretation(el) {
	            openInterpretationWindow(null, interpretation, function () {
	                var interpretationPanel = el.up('#interpretationPanel' + interpretation.id);
	                interpretationPanel.updateInterpretationPanelItems(interpretation);
	            });
	        };
	
	        // Delete an interpretation and return to main interpretations panel
	        var deleteInterpretation = function deleteInterpretation() {
	            Ext.Ajax.request({
	                url: encodeURI(apiPath + '/interpretations/' + interpretation.id),
	                method: 'DELETE',
	                success: function success() {
	                    instanceManager.getById(instanceManager.getStateCurrent().id);
	                }
	            });
	        };
	
	        // Delete a comment interpretation, update data model and update/reload panel
	        var deleteComment = function deleteComment(el, comment) {
	            Ext.Ajax.request({
	                url: encodeURI(apiPath + '/interpretations/' + interpretation.id + '/comments/' + comment.id),
	                method: 'DELETE',
	                success: function success() {
	                    refreshInterpretationDataModel(el.up('#interpretationPanel' + interpretation.id));
	                }
	            });
	        };
	
	        var editComment = function editComment(label, comment) {
	            var commentBox = label.up('#commentContent-' + comment.id);
	            var editableCommentBox = commentBox.next();
	            commentBox.hide();
	            editableCommentBox.show();
	        };
	
	        var cancelCommentEdit = function cancelCommentEdit(label, comment) {
	            var editableCommentBox = label.up('#commentPanel-' + comment.id);
	            var commentBox = editableCommentBox.prev();
	            editableCommentBox.hide();
	            commentBox.show();
	        };
	
	        // Create tooltip for Like link
	        var getTooltipLike = function getTooltipLike() {
	            var toolTipLike = "";
	            for (var i = 0; i < interpretation.likedBy.length; i++) {
	                toolTipLike += interpretation.likedBy[i].displayName + "</br>";
	            }
	            return toolTipLike;
	        };
	
	        // Get inner items for interpretation panel.
	        var getInterpretationPanelItems = function getInterpretationPanelItems(interpretation, displayingComments) {
	
	            var interpretationPanelItems = [{
	                xtype: 'panel',
	                bodyStyle: 'border-style:none',
	                style: 'margin-bottom: 6px;',
	                items: [{
	                    xtype: 'label',
	                    html: getLink(interpretation.user.displayName, true),
	                    style: 'margin-right:7px;',
	                    listeners: {
	                        render: function render() {
	                            var element = this.getEl();
	
	                            element.on('click', function () {
	                                window.location.href = path + '/dhis-web-messaging/profile.action?id=' + interpretation.user.id;
	                            });
	                        }
	                    }
	                }, {
	                    xtype: 'label',
	                    style: 'color:#666',
	                    text: _DateManager.DateManager.getYYYYMMDD(interpretation.lastUpdated, true)
	                }]
	            }, {
	                xtype: 'panel',
	                bodyStyle: 'border-style:none',
	                style: 'margin-bottom: 8px;',
	                items: [{
	                    xtype: 'label',
	                    text: interpretation.text
	                }]
	            }, {
	                xtype: 'panel',
	                bodyStyle: 'border-style:none',
	                cls: 'likeContainer',
	                itemId: 'likePanelUnselected',
	                hidden: displayingComments,
	                items: [{
	                    xtype: 'label',
	                    html: '<div class="thumbs_up greyBackground">' + interpretation.likes + ' ' + i18n.people_like_this + '<span style="padding:0 5px">·</span>' + interpretation.comments.length + ' ' + i18n.people_commented + '</div>'
	                }]
	            }, {
	                xtype: 'panel',
	                bodyStyle: 'border-style:none',
	                style: 'margin-top: 1px;',
	                itemId: 'likePanelSelected',
	                hidden: !displayingComments,
	
	                items: [{
	                    xtype: 'panel',
	                    bodyStyle: 'border-style:none',
	                    style: 'margin-bottom: 5px;',
	                    hidden: !layout || layout.permission === "none",
	
	                    items: [{
	                        xtype: 'label',
	                        html: isLiked(interpretation) ? getLink(i18n.unlike) : getLink(i18n.like),
	                        style: 'margin-right: 5px;',
	                        listeners: {
	                            'render': function render(label) {
	                                label.getEl().on('click', likeUnlikeInterpretation, this);
	                            }
	                        }
	                    }, {
	                        xtype: 'label',
	                        text: '·',
	                        style: 'margin-right: 5px;'
	                    }, {
	                        xtype: 'label',
	                        html: getLink(i18n.comment),
	                        style: 'margin-right: 5px;',
	                        listeners: {
	                            'render': function render(label) {
	                                label.getEl().on('click', function () {
	                                    this.up('#interpretationPanel' + interpretation.id).down('#commentPanel-new').show();
	                                    this.up('#interpretationPanel' + interpretation.id).down('#commentArea').focus();
	                                }, this);
	                            }
	                        }
	                    }, {
	                        xtype: 'label',
	                        text: '·',
	                        style: 'margin-right: 5px;'
	                    }, {
	                        xtype: 'label',
	                        html: getLink(i18n.edit),
	                        hidden: !userCanManageInterpretation(interpretation),
	                        style: 'margin-right: 5px;',
	                        listeners: {
	                            'render': function render(label) {
	                                label.getEl().on('click', function () {
	                                    editInterpretation(this);
	                                }, this);
	                            }
	                        }
	                    }, {
	                        xtype: 'label',
	                        text: '·',
	                        style: 'margin-right: 5px;'
	                    }, {
	                        xtype: 'label',
	                        html: getLink(i18n.delete_),
	                        hidden: !userCanManageInterpretation(interpretation),
	                        style: 'margin-right: 5px;',
	                        listeners: {
	                            'render': function render(label) {
	                                label.getEl().on('click', function () {
	                                    uiManager.confirmInterpretationDelete(function () {
	                                        deleteInterpretation();
	                                    });
	                                }, this);
	                            }
	                        }
	                    }]
	                }, {
	                    xtype: 'panel',
	                    bodyStyle: 'border-style:none',
	                    cls: 'likeContainer',
	                    items: [{
	                        xtype: 'label',
	                        html: '<div class="thumbs_up greyBackground">' + getLink(interpretation.likes + ' ' + i18n.people) + ' ' + i18n.like_this + '</div>',
	                        listeners: {
	                            'render': function render(label) {
	
	                                if (interpretation.likedBy.length > 0) {
	                                    Ext.create('Ext.tip.ToolTip', {
	                                        target: label.getEl(),
	                                        html: getTooltipLike(),
	                                        bodyStyle: 'background-color: white;border'
	                                    });
	                                }
	                            }
	                        }
	                    }]
	                }]
	            }, {
	                xtype: 'panel',
	                hidden: !displayingComments,
	                bodyStyle: 'border-style:none',
	                itemId: 'comments',
	                items: [getCommentsPanel(interpretation.comments)]
	            }];
	            return interpretationPanelItems;
	        };
	
	        // Interpretation panel per single interpretation
	        var interpretationPanel = {
	            xtype: 'panel',
	            bodyStyle: 'border-style:none;',
	            style: 'padding:6px; border-bottom:1px solid #d0d0d0;',
	            cls: 'clickable',
	            instanceManager: instanceManager,
	            interpretation: interpretation,
	            displayingComments: displayingComments,
	            itemId: 'interpretationPanel' + interpretation.id,
	
	            // Update inner interpretation panel items depending on interpretation. If none is provided, previously store one will be used
	            updateInterpretationPanelItems: function updateInterpretationPanelItems(interpretation) {
	                if (interpretation != undefined) {
	                    this.interpretation = interpretation;
	                }
	                this.removeAll(true);
	                this.add(getInterpretationPanelItems(this.interpretation, this.displayingComments));
	
	                // Remove pointer effect. This is not clickable any more
	                if (this.displayingComments) {
	                    this.removeCls('clickable');
	                } else {
	                    this.addCls('clickable');
	                }
	            },
	
	            // Expand comments on click
	            expandComments: function expandComments() {
	                if (!this.displayingComments) {
	                    for (var i = 0; i < this.up("#interpretationsPanel").items.items.length; i++) {
	                        if (this.up("#interpretationsPanel").items.items[i].interpretation != undefined) {
	                            this.up("#interpretationsPanel").items.items[i].displayingComments = this.up("#interpretationsPanel").items.items[i].id == this.id;
	                            //this.up("#interpretationsPanel").items.items[i].numberOfCommentsToDisplay = 3;
	                            this.up("#interpretationsPanel").items.items[i].updateInterpretationPanelItems();
	                        }
	                    }
	
	                    // Swop top panel
	                    this.up("[xtype='panel']").down('#shareInterpretation').hide();
	                    this.up("[xtype='panel']").down('#backToToday').show();
	
	                    // Update canvas with favorite as it was by the time the interpretation was created
	                    uiManager.updateInterpretation(interpretation);
	                }
	            },
	
	            items: getInterpretationPanelItems(interpretation, displayingComments),
	
	            listeners: {
	                'render': function render(panel) {
	                    panel.body.on('click', this.expandComments, this);
	                },
	                scope: interpretationPanel
	            }
	        };
	        return interpretationPanel;
	    };
	
	    var getTopInterpretationsPanel = function getTopInterpretationsPanel(layout, interpretations, displayingInterpretation) {
	        var topInterpretationPanelItems = [];
	
	        var shareInterpretationPanel = {
	            xtype: 'panel',
	            bodyStyle: 'border-style:none',
	            style: 'padding:6px; border-width:0 0 1px 0; border-style:solid;',
	            hidden: displayingInterpretation || !layout || layout.permission === "none",
	            itemId: 'shareInterpretation',
	            items: [{
	                xtype: 'label',
	                html: getLink(i18n.write_interpretation),
	                cls: 'interpretationActions',
	                listeners: {
	                    'render': function render(label) {
	                        label.getEl().on('click', function () {
	                            openInterpretationWindow();
	                        }, label);
	                    }
	                }
	            }]
	        };
	
	        var noInterpretationsPanel = {
	            xtype: 'panel',
	            bodyStyle: 'border-style:none',
	            style: 'padding:6px; border-width:0; border-bottom:1px solid #d0d0d0',
	            items: [{
	                xtype: 'label',
	                text: i18n.no_interpretations,
	                cls: 'interpretationActions'
	            }]
	        };
	
	        var backToTodayPanel = {
	            xtype: 'panel',
	            bodyStyle: 'border-style:none',
	            style: 'padding:6px; border:1px solid #dadada; border-width:0 0 1px 0;',
	            hidden: !displayingInterpretation,
	            itemId: 'backToToday',
	            items: [{
	                xtype: 'label',
	                html: getLink('<< ' + i18n.clear_interpretation),
	                cls: 'interpretationActions link',
	                listeners: {
	                    'render': function render(label) {
	                        label.getEl().on('click', function () {
	                            instanceManager.getById(instanceManager.getStateCurrent().id);
	                        }, label);
	                    }
	                }
	            }]
	        };
	
	        if (instanceManager.isStateFavorite() && !instanceManager.isStateDirty()) {
	            // Interpretations Panel when no favorite is loaded
	            topInterpretationPanelItems.push(shareInterpretationPanel);
	
	            if (interpretations == undefined) {
	                // Interpretations Panel when no favorite is loaded
	                topInterpretationPanelItems.push(noInterpretationsPanel);
	            } else {
	                topInterpretationPanelItems.push(backToTodayPanel);
	            }
	        } else {
	            topInterpretationPanelItems.push(noInterpretationsPanel);
	        }
	
	        // Add Share/Back to Today Panel.
	        // If displayingInterpretation on canvas -> Back to Today
	        // Otherwise -> Share Interpretation
	        var topInterpretationPanel = {
	            xtype: 'panel',
	            bodyStyle: 'border-style:none',
	            style: 'border-width:0',
	            items: topInterpretationPanelItems
	        };
	
	        return topInterpretationPanel;
	    };
	
	    // Main Interpretations Panel Container
	    var interpretationsPanel = {
	        xtype: 'panel',
	        cls: 'ns-panel-title-east-default',
	        bodyStyle: 'border-bottom-width: 0',
	        title: i18n.interpretations,
	        itemId: 'interpretationsPanel',
	        displayingInterpretation: false,
	
	        getInterpretationPanel: getInterpretationPanel,
	        getTopInterpretationsPanel: getTopInterpretationsPanel,
	
	        addAndUpdateInterpretationsPanel: function addAndUpdateInterpretationsPanel(layout) {
	            layout = layout || {};
	
	            // Remove any previous panel
	            this.removeAll(true);
	
	            var interpretations = layout.interpretations;
	            var interpretationId = layout.interpretationId;
	
	            //Get top interpretations panel depending on interpretations and if we are displaying an interpretation
	            this.add(this.getTopInterpretationsPanel(layout, interpretations, interpretationId != undefined));
	
	            // Add an interpretation panel per interpretation
	            if (interpretations != undefined && interpretations.length > 0) {
	                for (var i = 0; i < interpretations.length; i++) {
	                    if (interpretations[i].id == interpretationId || interpretationId == undefined) {
	                        this.add(this.getInterpretationPanel(layout, interpretations[i], interpretations[i].id == interpretationId));
	                    }
	                }
	            }
	        },
	
	        // By default no interpretations panel is displayed
	        items: getTopInterpretationsPanel()
	    };
	
	    /*
	     * RIGHT PANEL CONTAINER
	     */
	    var rightPanel = Ext.create('Ext.panel.Panel', {
	        region: 'east',
	        openInterpretationWindow: openInterpretationWindow,
	        preventHeader: true,
	        collapsible: true,
	        collapseMode: 'mini',
	        collapsed: true,
	        border: false,
	        width: uiConfig.west_width + uiManager.getScrollbarSize().width,
	        items: [detailsPanel, interpretationsPanel],
	        cls: 'eastPanel',
	        setState: function setState(layout) {
	            this.getComponent('detailsPanel').addAndUpdateFavoritePanel(layout);
	
	            // Favorite loaded with interpretations ->  Add interpretation panel and update
	
	            this.getComponent('interpretationsPanel').addAndUpdateInterpretationsPanel(layout);
	        },
	        listeners: {
	            expand: function expand() {
	                this.doLayout();
	            }
	        }
	    });
	
	    return rightPanel;
	};
	//# sourceMappingURL=EastRegion.js.map

/***/ },
/* 63 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.FavoriteButton = undefined;
	
	var _FavoriteWindow = __webpack_require__(40);
	
	var _RenameWindow = __webpack_require__(41);
	
	var _SharingWindow = __webpack_require__(27);
	
	var _InterpretationWindow = __webpack_require__(26);
	
	var _LinkWindow = __webpack_require__(164);
	
	var _TranslateWindow = __webpack_require__(168);
	
	var FavoriteButton = exports.FavoriteButton = undefined;
	
	exports.FavoriteButton = FavoriteButton = function FavoriteButton(c) {
	    var appManager = c.appManager,
	        uiManager = c.uiManager,
	        instanceManager = c.instanceManager,
	        i18n = c.i18nManager.get();
	
	    return Ext.create('Ext.button.Button', {
	        text: i18n.favorites,
	        menu: {},
	        handler: function handler(b) {
	            b.menu = Ext.create('Ext.menu.Menu', {
	                closeAction: 'destroy',
	                shadow: false,
	                showSeparator: false,
	                items: function () {
	                    var getTitle = function getTitle(text) {
	                        return text + '&nbsp;&nbsp;&nbsp;';
	                    };
	
	                    var newItem = Ext.create('Ext.menu.Item', {
	                        text: getTitle(i18n.new_),
	                        iconCls: 'ns-menu-item-favorite-new',
	                        disabled: !instanceManager.isStateCurrent(),
	                        handler: function handler() {
	                            if (instanceManager.isStateUnsaved()) {
	                                uiManager.confirmUnsaved(i18n.new_favorite, function () {
	                                    instanceManager.setState();
	                                });
	                            } else {
	                                instanceManager.setState();
	                            }
	                        }
	                    });
	                    uiManager.reg(newItem, 'newItem');
	
	                    var openItem = Ext.create('Ext.menu.Item', {
	                        text: getTitle(i18n.open),
	                        iconCls: 'ns-menu-item-favorite-open',
	                        handler: function handler() {
	                            uiManager.reg((0, _FavoriteWindow.FavoriteWindow)(c, 'open'), 'favoriteWindow').show();
	                        }
	                    });
	                    uiManager.reg(openItem, 'openItem');
	
	                    var saveItem = Ext.create('Ext.menu.Item', {
	                        text: getTitle(i18n.save),
	                        iconCls: 'ns-menu-item-favorite-save',
	                        disabled: !instanceManager.isStateDirty(),
	                        handler: function handler() {
	                            var layout = instanceManager.getStateCurrent(),
	                                favorite = instanceManager.getStateFavorite();
	
	                            if (!favorite) {
	                                saveAsItem.handlerFn();
	                                return;
	                            }
	
	                            layout.apply(favorite, ['id', 'name', 'description']);
	
	                            layout.clone().put(layout.id, function () {
	                                instanceManager.getById(layout.id, function (layout, isFavorite) {
	                                    instanceManager.getReport(layout, isFavorite, false, false, function () {
	                                        uiManager.unmask();
	                                    });
	                                });
	                            }, true, true);
	                        }
	                    });
	                    uiManager.reg(saveItem, 'saveItem');
	
	                    var saveAsItem = Ext.create('Ext.menu.Item', {
	                        text: getTitle(i18n.save_as),
	                        iconCls: 'ns-menu-item-favorite-save',
	                        disabled: !instanceManager.isStateCurrent(),
	                        handlerFn: function handlerFn() {
	                            (0, _FavoriteWindow.FavoriteWindow)(c, 'saveas').show();
	                        },
	                        handler: function handler() {
	                            this.handlerFn();
	                        }
	                    });
	                    uiManager.reg(saveAsItem, 'saveAsItem');
	
	                    var renameItem = Ext.create('Ext.menu.Item', {
	                        text: getTitle(i18n.rename),
	                        iconCls: 'ns-menu-item-favorite-rename',
	                        disabled: !instanceManager.isStateFavorite(),
	                        handler: function handler() {
	                            (0, _RenameWindow.RenameWindow)(c, instanceManager.getStateFavorite()).show();
	                        }
	                    });
	                    uiManager.reg(saveAsItem, 'renameItem');
	
	                    var translateItem = Ext.create('Ext.menu.Item', {
	                        text: getTitle(i18n.translate),
	                        iconCls: 'ns-menu-item-favorite-translate',
	                        disabled: !instanceManager.isStateFavorite(),
	                        handler: function handler() {
	                            (0, _TranslateWindow.TranslateWindow)(c, instanceManager.getStateFavorite()).show();
	                        }
	                    });
	                    uiManager.reg(saveAsItem, 'translateItem');
	
	                    var shareItem = Ext.create('Ext.menu.Item', {
	                        text: getTitle(i18n.share),
	                        iconCls: 'ns-menu-item-favorite-share',
	                        disabled: function () {
	                            var fav = instanceManager.getStateFavorite();
	
	                            if (fav && (!fav.getAccess() || fav.getAccess().manage)) {
	                                return false;
	                            }
	
	                            return true;
	                        }(),
	                        handler: function handler() {
	                            instanceManager.getSharingById(instanceManager.getStateFavoriteId(), function (r) {
	                                (0, _SharingWindow.SharingWindow)(c, r).show();
	                            });
	                        }
	                    });
	                    uiManager.reg(interpretationItem, 'interpretationItem');
	
	                    var interpretationItem = Ext.create('Ext.menu.Item', {
	                        text: getTitle(i18n.write_interpretation),
	                        iconCls: 'ns-menu-item-favorite-interpretation',
	                        disabled: !instanceManager.isStateFavorite(),
	                        handler: function handler() {
	                            instanceManager.getSharingById(instanceManager.getStateFavoriteId(), function (r) {
	                                (0, _InterpretationWindow.InterpretationWindow)(c, r).show();
	                            });
	                        }
	                    });
	                    uiManager.reg(interpretationItem, 'interpretationItem');
	
	                    var linkItem = Ext.create('Ext.menu.Item', {
	                        text: getTitle(i18n.get_link),
	                        iconCls: 'ns-menu-item-favorite-link',
	                        disabled: !instanceManager.isStateFavorite(),
	                        handler: function handler() {
	                            (0, _LinkWindow.LinkWindow)(c).show();
	                        }
	                    });
	                    uiManager.reg(linkItem, 'linkItem');
	
	                    var deleteItem = Ext.create('Ext.menu.Item', {
	                        text: getTitle(i18n.delete_),
	                        iconCls: 'ns-menu-item-favorite-delete',
	                        disabled: !instanceManager.isStateFavorite(),
	                        handler: function handler() {
	                            uiManager.confirmDelete(i18n.delete_favorite, function () {
	                                instanceManager.getStateFavorite().del(function () {
	                                    instanceManager.setState();
	                                });
	                            });
	                        }
	                    });
	                    uiManager.reg(deleteItem, 'deleteItem');
	
	                    return [newItem, '-', openItem, '-', saveItem, saveAsItem, '-',
	                    //discardItem,
	                    //'-',
	                    renameItem, translateItem, '-', shareItem, interpretationItem, linkItem, '-', deleteItem];
	                }(),
	                listeners: {
	                    show: function show() {
	                        uiManager.setAnchorPosition(b.menu, b);
	                    },
	                    hide: function hide() {
	                        b.menu.destroy();
	                    },
	                    destroy: function destroy(m) {
	                        b.menu = null;
	                    }
	                }
	            });
	
	            b.menu.show();
	        }
	    });
	};
	//# sourceMappingURL=FavoriteButton.js.map

/***/ },
/* 64 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var GridHeaders = exports.GridHeaders = undefined;
	
	exports.GridHeaders = GridHeaders = function GridHeaders(config) {
	    return Ext.create('Ext.toolbar.Toolbar', $.extend(config, {
	        cls: 'd2analysis-gridheaders'
	    }));
	};
	//# sourceMappingURL=GridHeaders.js.map

/***/ },
/* 65 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.InterpretationItem = undefined;
	
	var _InterpretationWindow = __webpack_require__(26);
	
	var InterpretationItem = exports.InterpretationItem = undefined;
	
	exports.InterpretationItem = InterpretationItem = function InterpretationItem(c) {
	    var instanceManager = c.instanceManager,
	        i18nManager = c.i18nManager,
	        i18n = c.i18nManager.get();
	
	    return Ext.create('Ext.menu.Item', {
	        text: i18n.write_interpretation + '&nbsp;&nbsp;',
	        iconCls: 'ns-menu-item-tablelayout',
	        disabled: true,
	        xable: function xable() {
	            this.setDisabled(!instanceManager.isStateSaved());
	        },
	        handler: function handler() {
	            (0, _InterpretationWindow.InterpretationWindow)(c).show();
	        }
	    });
	};
	//# sourceMappingURL=InterpretationItem.js.map

/***/ },
/* 66 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var PluginItem = exports.PluginItem = undefined;
	
	exports.PluginItem = PluginItem = function PluginItem(c) {
	    var appManager = c.appManager,
	        instanceManager = c.instanceManager,
	        uiManager = c.uiManager,
	        i18nManager = c.i18nManager,
	        i18n = c.i18nManager.get();
	
	    return Ext.create('Ext.menu.Item', {
	        text: i18n.embed_in_web_page + '&nbsp;&nbsp;',
	        iconCls: 'ns-menu-item-datasource',
	        disabled: true,
	        xable: function xable() {
	            this.setDisabled(!instanceManager.isStateCurrent());
	        },
	        handler: function handler() {
	            var textArea,
	                window,
	                text = '',
	                version = 'v' + parseFloat(appManager.systemInfo.version.split('.').join('')),
	                layout = instanceManager.getStateCurrent();
	
	            text += '<html>\n<head>\n';
	            text += '<link rel="stylesheet" href="//dhis2-cdn.org/' + version + '/ext/resources/css/ext-plugin-gray.css" />\n';
	            text += '<script src="//dhis2-cdn.org/' + version + '/ext/ext-all.js"></script>\n';
	            text += '<script src="//dhis2-cdn.org/' + version + '/plugin/table.js"></script>\n';
	            text += '</head>\n\n<body>\n';
	            text += '<div id="table1"></div>\n\n';
	            text += '<script>\n\n';
	            text += 'Ext.onReady(function() {\n\n';
	            text += 'DHIS.getTable(' + JSON.stringify(layout.toPlugin('table1'), null, 2) + ');\n\n';
	            text += '});\n\n';
	            text += '</script>\n\n';
	            text += '</body>\n</html>';
	
	            textArea = Ext.create('Ext.form.field.TextArea', {
	                width: 700,
	                height: 400,
	                readOnly: true,
	                cls: 'ns-textarea monospaced',
	                value: text
	            });
	
	            window = Ext.create('Ext.window.Window', {
	                title: i18n.embed_in_web_page + (layout.displayName ? '<span style="font-weight:normal">&nbsp;|&nbsp;&nbsp;' + layout + '</span>' : ''),
	                layout: 'fit',
	                modal: true,
	                resizable: false,
	                items: textArea,
	                destroyOnBlur: true,
	                bbar: ['->', {
	                    text: 'Select',
	                    handler: function handler() {
	                        textArea.selectText();
	                    }
	                }],
	                listeners: {
	                    show: function show(w) {
	                        uiManager.setAnchorPosition(w, 'shareButton');
	
	                        uiManager.enableRightClick();
	
	                        if (!w.hasDestroyOnBlurHandler) {
	                            uiManager.addDestroyOnBlurHandler(w);
	                        }
	                    },
	                    hide: function hide() {
	                        uiManager.disableRightClick();
	                    }
	                }
	            });
	
	            window.show();
	        }
	    });
	};
	//# sourceMappingURL=PluginItem.js.map

/***/ },
/* 67 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isDefined;
	/**
	 * Check if `param` is defined.
	 *
	 * @param {*} param The value to check
	 * @returns {boolean} Returns `false` when `param` is `undefined` otherwise true.
	 */
	function isDefined(param) {
	  return typeof param !== 'undefined';
	}
	//# sourceMappingURL=isDefined.js.map

/***/ },
/* 68 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = numberConstrain;
	/**
	 * Constrains the value between the passed min and max
	 *
	 * @param {Number} number The value to be constrained
	 * @param {Number} min The minumum number that the value should be within
	 * @param {Number} max The maximum number that the value should be within
	 * @returns {Number|*} The resulting number
	 */
	function numberConstrain(number, min, max) {
	    number = parseFloat(number);
	
	    if (!isNaN(min)) {
	        number = Math.max(number, min);
	    }
	    if (!isNaN(max)) {
	        number = Math.min(number, max);
	    }
	    return number;
	}
	//# sourceMappingURL=numberConstrain.js.map

/***/ },
/* 69 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = objectApplyIf;
	/**
	 * Applies properties from "config" if they are undefined in "object.
	 *
	 * @param {Object} object The object to receive properties
	 * @param {Object} config The object to pass properties
	 * @returns {Object} The object that may have received properties
	 *
	 * @example
	 * let object = {id: 1}
	 * const config = {id: 2, name: 'Name'}
	 * objectApplyIf(object, config); // returns: {id: 1, name: 'Name'}
	 */
	function objectApplyIf(object, config) {
	    var property;
	
	    if (object) {
	        for (property in config) {
	            if (object[property] === undefined) {
	                object[property] = config[property];
	            }
	        }
	    }
	
	    return object;
	}
	//# sourceMappingURL=objectApplyIf.js.map

/***/ },
/* 70 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = stringReplaceAll;
	/**
	 * Replace all occurrences of the `matchValue` within the `str` parameter.
	 *
	 * @param {string} str The string to operate on
	 * @param {string} matchValue The value to match on
	 * @param {string|function} replaceValue The value to replace the matches with
	 * @param {boolean} ignore Case sensitivity ignore flag. Pass `true` to ignore case. (Defaults to `false`)
	 * @returns {XML|void|string|*} The resulting string.
	 */
	function stringReplaceAll(str, matchValue, replaceValue, ignore) {
	  return str.replace(new RegExp(matchValue.replace(/([\/\,\!\\\^\$\{\}\[\]\(\)\.\*\+\?\|\<\>\-\&])/g, "\\$&"), ignore ? "gi" : "g"), typeof replaceValue == "string" ? replaceValue.replace(/\$/g, "$$$$") : replaceValue);
	}
	//# sourceMappingURL=stringReplaceAll.js.map

/***/ },
/* 71 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = function (title) {
	    return (0, _isString2.default)(title) ? _extends({}, DEFAULT_AXIS_TITLE, {
	        text: title
	    }) : {
	        text: null
	    };
	};
	
	var _isString = __webpack_require__(8);
	
	var _isString2 = _interopRequireDefault(_isString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DEFAULT_AXIS_TITLE = {
	    align: 'low',
	    margin: 15,
	    style: {
	        color: '#222',
	        textShadow: '0 0 #999',
	        fontSize: '13px'
	    }
	};
	
	;
	//# sourceMappingURL=getAxisTitle.js.map

/***/ },
/* 72 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = function (store, layout) {
	    var metaData = store.data.metaData;
	    var dimensionName = layout.rows[0].dimension;
	
	    var dimensionIds = (0, _isArray2.default)(metaData.dimensions[dimensionName]) ? metaData.dimensions[dimensionName] : [];
	
	    return dimensionIds.map(function (id) {
	        return metaData.items[id].name;
	    });
	};
	
	var _isArray = __webpack_require__(11);
	
	var _isArray2 = _interopRequireDefault(_isArray);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	;
	//# sourceMappingURL=getCategories.js.map

/***/ },
/* 73 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = function (filters, metaData) {
	    var title = void 0;
	
	    if ((0, _isArray2.default)(filters) && filters.length) {
	        title = '';
	
	        var filterItems = void 0,
	            i = void 0,
	            l = void 0;
	
	        filters.forEach(function (dimension, index, array) {
	            filterItems = metaData.dimensions[dimension.dimension];
	
	            if ((0, _isArray2.default)(filterItems)) {
	                l = filterItems.length;
	                var id = void 0;
	
	                for (i = 0; i < l; i++) {
	                    id = filterItems[i];
	
	                    // if the value is present in items take the name to show from there
	                    if (metaData.items[id]) {
	                        title += metaData.items[id].name + (i < l - 1 ? ', ' : '');
	                    }
	                    // otherwise use the values directly
	                    // this is a temporary fix to avoid app crashing when using filters with data items in EV
	                    else {
	                            title += metaData.items[dimension.dimension].name + ': ' + filterItems.join(', ');
	
	                            break;
	                        }
	                }
	
	                title += index < array.length - 1 ? ' - ' : '';
	            }
	        });
	    }
	
	    return title || null;
	};
	
	var _isArray = __webpack_require__(11);
	
	var _isArray2 = _interopRequireDefault(_isArray);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	//# sourceMappingURL=getFilterTitle.js.map

/***/ },
/* 74 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = function (series, isZeroAsNull) {
	    return series[0].data.map(function (value, index) {
	        return series.reduce(function (total, obj) {
	            return total + obj.data[index];
	        }, 0);
	    }).map(function (value) {
	        return isZeroAsNull && value === 0 ? null : value;
	    });
	};
	//# sourceMappingURL=getStackedData.js.map

/***/ },
/* 75 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.createChart = exports.Config = exports.Store = undefined;
	
	__webpack_require__(92);
	
	var _store = __webpack_require__(219);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _config = __webpack_require__(214);
	
	var _config2 = _interopRequireDefault(_config);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var defaultError = function defaultError(error) {
	    throw new Error(error);
	};
	
	var defaultWarning = function defaultWarning(warning) {
	    console.log(warning);
	};
	
	function createChart(data, layout, el, extraOptions) {
	    var error = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : defaultError;
	    var warning = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : defaultWarning;
	
	    var store = new _store2.default({ data: data, error: error, warning: warning });
	    var config = new _config2.default({ store: store, layout: layout, el: el, extraOptions: extraOptions, error: error, warning: warning });
	
	    return {
	        store: store,
	        config: config,
	        chart: config.createChart()
	    };
	}
	
	exports.Store = _store2.default;
	exports.Config = _config2.default;
	exports.createChart = createChart;
	exports.default = {
	    Store: _store2.default,
	    Config: _config2.default,
	    createChart: createChart
	};
	//# sourceMappingURL=index.js.map

/***/ },
/* 76 */
[599, 8, 46, 11, 17],
/* 77 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isInteger;
	/**
	 * Check if a value is an integer
	 *
	 * @param param Value that will be checked if it is an integer
	 * @returns {boolean} Returns `true` when param is a integer otherwise false
	 *
	 * @example
	 * isInteger(17); // Returns: true
	 *
	 * @example
	 * isInteger(0xFF); // Returns: true
	 *
	 * @example
	 * isInteger(-17); // Returns: true
	 *
	 * @example
	 * isInteger(2e-3); // Returns: false
	 */
	function isInteger(param) {
	  return typeof param === 'number' && parseFloat(param) == parseInt(param, 10) && !isNaN(param);
	}
	//# sourceMappingURL=isInteger.js.map

/***/ },
/* 78 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	/**
	 * Check if a number is finite
	 *
	 * @param param Number to be checked
	 * @returns {boolean} Returns true when the `param` is a finite number
	 */
	exports.default = Number.isFinite || function (param) {
	  return typeof param === 'number' && global.isFinite(param);
	};
	//# sourceMappingURL=numberIsFinite.js.map
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 79 */
/***/ function(module, exports) {

	/**
	 * lodash 3.0.3 (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright 2012-2016 The Dojo Foundation <http://dojofoundation.org/>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright 2009-2016 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 * Available under MIT license <https://lodash.com/license>
	 */
	
	/** `Object#toString` result references. */
	var boolTag = '[object Boolean]';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/**
	 * Checks if `value` is classified as a boolean primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	 * @example
	 *
	 * _.isBoolean(false);
	 * // => true
	 *
	 * _.isBoolean(null);
	 * // => false
	 */
	function isBoolean(value) {
	  return value === true || value === false ||
	    (isObjectLike(value) && objectToString.call(value) == boolTag);
	}
	
	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	module.exports = isBoolean;


/***/ },
/* 80 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, module) {/**
	 * lodash (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	
	/** `Object#toString` result references. */
	var funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    mapTag = '[object Map]',
	    objectTag = '[object Object]',
	    promiseTag = '[object Promise]',
	    setTag = '[object Set]',
	    weakMapTag = '[object WeakMap]';
	
	var dataViewTag = '[object DataView]';
	
	/**
	 * Used to match `RegExp`
	 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	 */
	var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
	
	/** Used to detect host constructors (Safari). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Detect free variable `process` from Node.js. */
	var freeProcess = moduleExports && freeGlobal.process;
	
	/** Used to access faster Node.js helpers. */
	var nodeUtil = (function() {
	  try {
	    return freeProcess && freeProcess.binding('util');
	  } catch (e) {}
	}());
	
	/* Node.js helper references. */
	var nodeIsMap = nodeUtil && nodeUtil.isMap;
	
	/**
	 * The base implementation of `_.unary` without support for storing metadata.
	 *
	 * @private
	 * @param {Function} func The function to cap arguments for.
	 * @returns {Function} Returns the new capped function.
	 */
	function baseUnary(func) {
	  return function(value) {
	    return func(value);
	  };
	}
	
	/**
	 * Gets the value at `key` of `object`.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {string} key The key of the property to get.
	 * @returns {*} Returns the property value.
	 */
	function getValue(object, key) {
	  return object == null ? undefined : object[key];
	}
	
	/**
	 * Checks if `value` is a host object in IE < 9.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
	 */
	function isHostObject(value) {
	  // Many host objects are `Object` objects that can coerce to strings
	  // despite having improperly defined `toString` methods.
	  var result = false;
	  if (value != null && typeof value.toString != 'function') {
	    try {
	      result = !!(value + '');
	    } catch (e) {}
	  }
	  return result;
	}
	
	/** Used for built-in method references. */
	var funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to detect overreaching core-js shims. */
	var coreJsData = root['__core-js_shared__'];
	
	/** Used to detect methods masquerading as native. */
	var maskSrcKey = (function() {
	  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	  return uid ? ('Symbol(src)_1.' + uid) : '';
	}());
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);
	
	/* Built-in method references that are verified to be native. */
	var DataView = getNative(root, 'DataView'),
	    Map = getNative(root, 'Map'),
	    Promise = getNative(root, 'Promise'),
	    Set = getNative(root, 'Set'),
	    WeakMap = getNative(root, 'WeakMap');
	
	/** Used to detect maps, sets, and weakmaps. */
	var dataViewCtorString = toSource(DataView),
	    mapCtorString = toSource(Map),
	    promiseCtorString = toSource(Promise),
	    setCtorString = toSource(Set),
	    weakMapCtorString = toSource(WeakMap);
	
	/**
	 * The base implementation of `getTag`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	function baseGetTag(value) {
	  return objectToString.call(value);
	}
	
	/**
	 * The base implementation of `_.isMap` without Node.js optimizations.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
	 */
	function baseIsMap(value) {
	  return isObjectLike(value) && getTag(value) == mapTag;
	}
	
	/**
	 * The base implementation of `_.isNative` without bad shim checks.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function,
	 *  else `false`.
	 */
	function baseIsNative(value) {
	  if (!isObject(value) || isMasked(value)) {
	    return false;
	  }
	  var pattern = (isFunction(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
	  return pattern.test(toSource(value));
	}
	
	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = getValue(object, key);
	  return baseIsNative(value) ? value : undefined;
	}
	
	/**
	 * Gets the `toStringTag` of `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	var getTag = baseGetTag;
	
	// Fallback for data views, maps, sets, and weak maps in IE 11,
	// for data views in Edge < 14, and promises in Node.js.
	if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
	    (Map && getTag(new Map) != mapTag) ||
	    (Promise && getTag(Promise.resolve()) != promiseTag) ||
	    (Set && getTag(new Set) != setTag) ||
	    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
	  getTag = function(value) {
	    var result = objectToString.call(value),
	        Ctor = result == objectTag ? value.constructor : undefined,
	        ctorString = Ctor ? toSource(Ctor) : undefined;
	
	    if (ctorString) {
	      switch (ctorString) {
	        case dataViewCtorString: return dataViewTag;
	        case mapCtorString: return mapTag;
	        case promiseCtorString: return promiseTag;
	        case setCtorString: return setTag;
	        case weakMapCtorString: return weakMapTag;
	      }
	    }
	    return result;
	  };
	}
	
	/**
	 * Checks if `func` has its source masked.
	 *
	 * @private
	 * @param {Function} func The function to check.
	 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	 */
	function isMasked(func) {
	  return !!maskSrcKey && (maskSrcKey in func);
	}
	
	/**
	 * Converts `func` to its source code.
	 *
	 * @private
	 * @param {Function} func The function to process.
	 * @returns {string} Returns the source code.
	 */
	function toSource(func) {
	  if (func != null) {
	    try {
	      return funcToString.call(func);
	    } catch (e) {}
	    try {
	      return (func + '');
	    } catch (e) {}
	  }
	  return '';
	}
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 8-9 which returns 'object' for typed array and other constructors.
	  var tag = isObject(value) ? objectToString.call(value) : '';
	  return tag == funcTag || tag == genTag;
	}
	
	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	/**
	 * Checks if `value` is classified as a `Map` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.3.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
	 * @example
	 *
	 * _.isMap(new Map);
	 * // => true
	 *
	 * _.isMap(new WeakMap);
	 * // => false
	 */
	var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
	
	module.exports = isMap;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(86)(module)))

/***/ },
/* 81 */
/***/ function(module, exports) {

	/**
	 * lodash 3.0.2 (Custom Build) <https://lodash.com/>
	 * Build: `lodash modern modularize exports="npm" -o ./`
	 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 * Available under MIT license <https://lodash.com/license>
	 */
	
	/**
	 * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
	 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(1);
	 * // => false
	 */
	function isObject(value) {
	  // Avoid a V8 JIT bug in Chrome 19-20.
	  // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	module.exports = isObject;


/***/ },
/* 82 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, module) {/**
	 * lodash (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	
	/** `Object#toString` result references. */
	var funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    mapTag = '[object Map]',
	    objectTag = '[object Object]',
	    promiseTag = '[object Promise]',
	    setTag = '[object Set]',
	    weakMapTag = '[object WeakMap]';
	
	var dataViewTag = '[object DataView]';
	
	/**
	 * Used to match `RegExp`
	 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	 */
	var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
	
	/** Used to detect host constructors (Safari). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Detect free variable `process` from Node.js. */
	var freeProcess = moduleExports && freeGlobal.process;
	
	/** Used to access faster Node.js helpers. */
	var nodeUtil = (function() {
	  try {
	    return freeProcess && freeProcess.binding('util');
	  } catch (e) {}
	}());
	
	/* Node.js helper references. */
	var nodeIsSet = nodeUtil && nodeUtil.isSet;
	
	/**
	 * The base implementation of `_.unary` without support for storing metadata.
	 *
	 * @private
	 * @param {Function} func The function to cap arguments for.
	 * @returns {Function} Returns the new capped function.
	 */
	function baseUnary(func) {
	  return function(value) {
	    return func(value);
	  };
	}
	
	/**
	 * Gets the value at `key` of `object`.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {string} key The key of the property to get.
	 * @returns {*} Returns the property value.
	 */
	function getValue(object, key) {
	  return object == null ? undefined : object[key];
	}
	
	/**
	 * Checks if `value` is a host object in IE < 9.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
	 */
	function isHostObject(value) {
	  // Many host objects are `Object` objects that can coerce to strings
	  // despite having improperly defined `toString` methods.
	  var result = false;
	  if (value != null && typeof value.toString != 'function') {
	    try {
	      result = !!(value + '');
	    } catch (e) {}
	  }
	  return result;
	}
	
	/** Used for built-in method references. */
	var funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to detect overreaching core-js shims. */
	var coreJsData = root['__core-js_shared__'];
	
	/** Used to detect methods masquerading as native. */
	var maskSrcKey = (function() {
	  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	  return uid ? ('Symbol(src)_1.' + uid) : '';
	}());
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);
	
	/* Built-in method references that are verified to be native. */
	var DataView = getNative(root, 'DataView'),
	    Map = getNative(root, 'Map'),
	    Promise = getNative(root, 'Promise'),
	    Set = getNative(root, 'Set'),
	    WeakMap = getNative(root, 'WeakMap');
	
	/** Used to detect maps, sets, and weakmaps. */
	var dataViewCtorString = toSource(DataView),
	    mapCtorString = toSource(Map),
	    promiseCtorString = toSource(Promise),
	    setCtorString = toSource(Set),
	    weakMapCtorString = toSource(WeakMap);
	
	/**
	 * The base implementation of `getTag`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	function baseGetTag(value) {
	  return objectToString.call(value);
	}
	
	/**
	 * The base implementation of `_.isNative` without bad shim checks.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function,
	 *  else `false`.
	 */
	function baseIsNative(value) {
	  if (!isObject(value) || isMasked(value)) {
	    return false;
	  }
	  var pattern = (isFunction(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
	  return pattern.test(toSource(value));
	}
	
	/**
	 * The base implementation of `_.isSet` without Node.js optimizations.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
	 */
	function baseIsSet(value) {
	  return isObjectLike(value) && getTag(value) == setTag;
	}
	
	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = getValue(object, key);
	  return baseIsNative(value) ? value : undefined;
	}
	
	/**
	 * Gets the `toStringTag` of `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	var getTag = baseGetTag;
	
	// Fallback for data views, maps, sets, and weak maps in IE 11,
	// for data views in Edge < 14, and promises in Node.js.
	if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
	    (Map && getTag(new Map) != mapTag) ||
	    (Promise && getTag(Promise.resolve()) != promiseTag) ||
	    (Set && getTag(new Set) != setTag) ||
	    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
	  getTag = function(value) {
	    var result = objectToString.call(value),
	        Ctor = result == objectTag ? value.constructor : undefined,
	        ctorString = Ctor ? toSource(Ctor) : undefined;
	
	    if (ctorString) {
	      switch (ctorString) {
	        case dataViewCtorString: return dataViewTag;
	        case mapCtorString: return mapTag;
	        case promiseCtorString: return promiseTag;
	        case setCtorString: return setTag;
	        case weakMapCtorString: return weakMapTag;
	      }
	    }
	    return result;
	  };
	}
	
	/**
	 * Checks if `func` has its source masked.
	 *
	 * @private
	 * @param {Function} func The function to check.
	 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	 */
	function isMasked(func) {
	  return !!maskSrcKey && (maskSrcKey in func);
	}
	
	/**
	 * Converts `func` to its source code.
	 *
	 * @private
	 * @param {Function} func The function to process.
	 * @returns {string} Returns the source code.
	 */
	function toSource(func) {
	  if (func != null) {
	    try {
	      return funcToString.call(func);
	    } catch (e) {}
	    try {
	      return (func + '');
	    } catch (e) {}
	  }
	  return '';
	}
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 8-9 which returns 'object' for typed array and other constructors.
	  var tag = isObject(value) ? objectToString.call(value) : '';
	  return tag == funcTag || tag == genTag;
	}
	
	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	/**
	 * Checks if `value` is classified as a `Set` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.3.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
	 * @example
	 *
	 * _.isSet(new Set);
	 * // => true
	 *
	 * _.isSet(new WeakSet);
	 * // => false
	 */
	var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
	
	module.exports = isSet;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(86)(module)))

/***/ },
/* 83 */
/***/ function(module, exports) {

	/**
	 * lodash 4.0.1 (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright 2012-2016 The Dojo Foundation <http://dojofoundation.org/>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright 2009-2016 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 * Available under MIT license <https://lodash.com/license>
	 */
	
	/** `Object#toString` result references. */
	var stringTag = '[object String]';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @type Function
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(document.body.children);
	 * // => false
	 *
	 * _.isArray('abc');
	 * // => false
	 *
	 * _.isArray(_.noop);
	 * // => false
	 */
	var isArray = Array.isArray;
	
	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	/**
	 * Checks if `value` is classified as a `String` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	 * @example
	 *
	 * _.isString('abc');
	 * // => true
	 *
	 * _.isString(1);
	 * // => false
	 */
	function isString(value) {
	  return typeof value == 'string' ||
	    (!isArray(value) && isObjectLike(value) && objectToString.call(value) == stringTag);
	}
	
	module.exports = isString;


/***/ },
/* 84 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAAQCAYAAAAbBi9cAAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAB3RJTUUH4AMeChwOIa4e0gAAAQtJREFUOMvlkj9Kg0EQxd8slsFGsfLbN/uNImhhsBeskjqFCCJY24mFNhYqXsUbiBfQIyiIIEo8hH+za5PE1Zg9gL7yN7zHm9kF/pfqKmyaZztnRs7V1PVxzP0MCVVoi6SzJHjNDIuA3CXBdIllTXTDvKaabOUGo74E6nGJfTXxodUPWcsM80aNSj0psawJO/2Q4V1MuWLU50DdLbGBHACIk20IuuldLoeTXtoC0JMUL4osD/LNpU4Eum4CN4PB/VN3T1I8EHG3Rt8cx35/duq5eX0Iszo5XKfyh0a+Gf1yiY0evdIr8/o4U1fuu1GjkQvj2Mg/anBqNQHXjQ93lK15KjHuIGG/xP6oPgFIPWmq9LOmhgAAAABJRU5ErkJggg=="

/***/ },
/* 85 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAAQCAYAAAAbBi9cAAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAB3RJTUUH4AMeCh401ZSl4gAAASJJREFUOMvl0L9KA0EQx/HfXgwBiyPETryZ2Z2YIiAKtgqxiaCFjWDhA4j4CjYGbH0DBcEHsAiIpfoUgnIEW8EYBP+AtxZKitxl7XXKT/HdmQX+9ijxcT2hnd/MEXccSXduadGMNkoAUKtWb2Gii1ocfz4Nnq/HWXkqvqpk0eF7/3WzP+ifFG/FNK/MH5rQfsjsjMRKkjqW7vgTmRaUJasT7YXs+3RJLcvNysa6KYw5ooayvGhCRyGz0zKpLD1lOQeAaDTkTbQGoISSOQuZKftleJDP/GluG2HpKEumzLMhc8wtJfGWbDsXsSwHyvKmzM2QOea2kniXyFY+IrL782ozZMNNErs62pgAAOPxCPjGfa93N/yDYqt4b7bTh/QS/2e+APm4a833Y1DsAAAAAElFTkSuQmCC"

/***/ },
/* 86 */
/***/ function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ },
/* 87 */
15,
/* 88 */,
/* 89 */,
/* 90 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.Layout = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _isString = __webpack_require__(8);
	
	var _isString2 = _interopRequireDefault(_isString);
	
	var _isNumber = __webpack_require__(46);
	
	var _isNumber2 = _interopRequireDefault(_isNumber);
	
	var _isBoolean = __webpack_require__(87);
	
	var _isBoolean2 = _interopRequireDefault(_isBoolean);
	
	var _isObject = __webpack_require__(17);
	
	var _isObject2 = _interopRequireDefault(_isObject);
	
	var _isEmpty = __webpack_require__(43);
	
	var _isEmpty2 = _interopRequireDefault(_isEmpty);
	
	var _d2Analysis = __webpack_require__(57);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Layout = exports.Layout = function Layout(refs, c, applyConfig, forceApplyConfig) {
	    var t = this;
	
	    c = (0, _isObject2.default)(c) ? c : {};
	
	    // inherit
	    _extends(t, new _d2Analysis.Layout(refs, c, applyConfig));
	    t.prototype = _d2Analysis.Layout.prototype;
	
	    // ensure 1 column, 1 row, n filters
	    t.stripAxes();
	
	    //type
	    t.type = refs.chartConfig.s2c[c.type] || refs.chartConfig.client[c.type] || refs.chartConfig.client['column'];
	
	    // options
	    t.showValues = (0, _isBoolean2.default)(c.showData) ? c.showData : (0, _isBoolean2.default)(c.showValues) ? c.showValues : true;
	    t.percentStackedValues = (0, _isBoolean2.default)(c.percentStackedValues) ? c.percentStackedValues : false;
	    t.cumulativeValues = (0, _isBoolean2.default)(c.cumulativeValues) ? c.cumulativeValues : false;
	    t.hideEmptyRowItems = (0, _isString2.default)(c.hideEmptyRowItems) ? c.hideEmptyRowItems : 'NONE';
	    t.regressionType = (0, _isString2.default)(c.regressionType) ? c.regressionType : 'NONE';
	
	    t.completedOnly = (0, _isBoolean2.default)(c.completedOnly) ? c.completedOnly : false;
	
	    t.targetLineValue = (0, _isNumber2.default)(c.targetLineValue) ? c.targetLineValue : null;
	    t.targetLineTitle = (0, _isString2.default)(c.targetLineLabel) && !(0, _isEmpty2.default)(c.targetLineLabel) ? c.targetLineLabel : (0, _isString2.default)(c.targetLineTitle) && !(0, _isEmpty2.default)(c.targetLineTitle) ? c.targetLineTitle : null;
	    t.baseLineValue = (0, _isNumber2.default)(c.baseLineValue) ? c.baseLineValue : null;
	    t.baseLineTitle = (0, _isString2.default)(c.baseLineLabel) && !(0, _isEmpty2.default)(c.baseLineLabel) ? c.baseLineLabel : (0, _isString2.default)(c.baseLineTitle) && !(0, _isEmpty2.default)(c.baseLineTitle) ? c.baseLineTitle : null;
	    t.sortOrder = (0, _isNumber2.default)(c.sortOrder) ? c.sortOrder : 0;
	    t.aggregationType = (0, _isString2.default)(c.aggregationType) ? c.aggregationType : 'DEFAULT';
	
	    t.rangeAxisMaxValue = (0, _isNumber2.default)(c.rangeAxisMaxValue) ? c.rangeAxisMaxValue : null;
	    t.rangeAxisMinValue = (0, _isNumber2.default)(c.rangeAxisMinValue) ? c.rangeAxisMinValue : null;
	    t.rangeAxisSteps = (0, _isNumber2.default)(c.rangeAxisSteps) ? c.rangeAxisSteps : null;
	    t.rangeAxisDecimals = (0, _isNumber2.default)(c.rangeAxisDecimals) ? c.rangeAxisDecimals : null;
	    t.rangeAxisTitle = (0, _isString2.default)(c.rangeAxisLabel) && !(0, _isEmpty2.default)(c.rangeAxisLabel) ? c.rangeAxisLabel : (0, _isString2.default)(c.rangeAxisTitle) && !(0, _isEmpty2.default)(c.rangeAxisTitle) ? c.rangeAxisTitle : null;
	    t.domainAxisTitle = (0, _isString2.default)(c.domainAxisLabel) && !(0, _isEmpty2.default)(c.domainAxisLabel) ? c.domainAxisLabel : (0, _isString2.default)(c.domainAxisTitle) && !(0, _isEmpty2.default)(c.domainAxisTitle) ? c.domainAxisTitle : null;
	
	    t.noSpaceBetweenColumns = (0, _isBoolean2.default)(c.noSpaceBetweenColumns) ? c.noSpaceBetweenColumns : false;
	
	    t.hideLegend = (0, _isBoolean2.default)(c.hideLegend) ? c.hideLegend : false;
	    t.hideTitle = (0, _isBoolean2.default)(c.hideTitle) ? c.hideTitle : false;
	    t.title = (0, _isString2.default)(t.title) && !(0, _isEmpty2.default)(t.title) ? t.title : null;
	    t.hideSubtitle = (0, _isBoolean2.default)(c.hideSubtitle) ? c.hideSubtitle : false;
	    t.subtitle = (0, _isString2.default)(c.subtitle) && !(0, _isEmpty2.default)(c.subtitle) ? c.subtitle : null;
	
	    // graph map
	    t.parentGraphMap = (0, _isObject2.default)(c.parentGraphMap) ? c.parentGraphMap : null;
	
	    // style
	    if ((0, _isObject2.default)(c.domainAxisStyle)) {
	        t.domainAxisStyle = c.domainAxisStyle;
	    }
	
	    if ((0, _isObject2.default)(c.rangeAxisStyle)) {
	        t.rangeAxisStyle = c.rangeAxisStyle;
	    }
	
	    if ((0, _isObject2.default)(c.legendStyle)) {
	        t.legendStyle = c.legendStyle;
	    }
	
	    if ((0, _isObject2.default)(c.seriesStyle)) {
	        t.seriesStyle = c.seriesStyle;
	    }
	
	    // force apply
	    _extends(t, forceApplyConfig);
	
	    t.getRefs = function () {
	        return refs;
	    };
	};
	
	Layout.prototype = _d2Analysis.Layout.prototype;
	
	Layout.prototype.clone = function () {
	    var t = this,
	        refs = this.getRefs();
	
	    var layout = new refs.api.Layout(refs, JSON.parse(JSON.stringify(t)));
	
	    layout.setResponse(t.getResponse());
	    layout.setAccess(t.getAccess());
	    layout.setDataDimensionItems(t.getDataDimensionItems());
	
	    return layout;
	};
	
	Layout.prototype.toPost = function () {
	    var t = this,
	        refs = t.getRefs();
	
	    t.toPostSuper();
	
	    t.type = refs.chartConfig.c2s[t.type] || t.type;
	
	    t.showData = t.showValues;
	    delete t.showValues;
	
	    t.regression = t.showTrendLine;
	    delete t.showTrendLine;
	
	    t.targetLineLabel = t.targetLineTitle;
	    delete t.targetLineTitle;
	
	    t.baseLineLabel = t.baseLineTitle;
	    delete t.baseLineTitle;
	
	    t.domainAxisLabel = t.domainAxisTitle;
	    delete t.domainAxisTitle;
	
	    t.rangeAxisLabel = t.rangeAxisTitle;
	    delete t.rangeAxisTitle;
	};
	
	Layout.prototype.doLegendSet = function () {
	    return this.type === 'gauge' && this.hasDimension('dx');
	};

/***/ },
/* 91 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(111);
	module.exports = __webpack_require__(18).Array.fill;

/***/ },
/* 92 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(112);
	module.exports = __webpack_require__(18).Array.findIndex;

/***/ },
/* 93 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(113);
	module.exports = __webpack_require__(18).Array.find;

/***/ },
/* 94 */
/***/ function(module, exports) {

	module.exports = function(it){
	  if(typeof it != 'function')throw TypeError(it + ' is not a function!');
	  return it;
	};

/***/ },
/* 95 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(23);
	module.exports = function(it){
	  if(!isObject(it))throw TypeError(it + ' is not an object!');
	  return it;
	};

/***/ },
/* 96 */
/***/ function(module, exports, __webpack_require__) {

	// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
	'use strict';
	var toObject = __webpack_require__(54)
	  , toIndex  = __webpack_require__(109)
	  , toLength = __webpack_require__(53);
	module.exports = function fill(value /*, start = 0, end = @length */){
	  var O      = toObject(this)
	    , length = toLength(O.length)
	    , aLen   = arguments.length
	    , index  = toIndex(aLen > 1 ? arguments[1] : undefined, length)
	    , end    = aLen > 2 ? arguments[2] : undefined
	    , endPos = end === undefined ? length : toIndex(end, length);
	  while(endPos > index)O[index++] = value;
	  return O;
	};

/***/ },
/* 97 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(23)
	  , isArray  = __webpack_require__(104)
	  , SPECIES  = __webpack_require__(56)('species');
	
	module.exports = function(original){
	  var C;
	  if(isArray(original)){
	    C = original.constructor;
	    // cross-realm fallback
	    if(typeof C == 'function' && (C === Array || isArray(C.prototype)))C = undefined;
	    if(isObject(C)){
	      C = C[SPECIES];
	      if(C === null)C = undefined;
	    }
	  } return C === undefined ? Array : C;
	};

/***/ },
/* 98 */
/***/ function(module, exports, __webpack_require__) {

	// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
	var speciesConstructor = __webpack_require__(97);
	
	module.exports = function(original, length){
	  return new (speciesConstructor(original))(length);
	};

/***/ },
/* 99 */
/***/ function(module, exports) {

	// 7.2.1 RequireObjectCoercible(argument)
	module.exports = function(it){
	  if(it == undefined)throw TypeError("Can't call method on  " + it);
	  return it;
	};

/***/ },
/* 100 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(23)
	  , document = __webpack_require__(19).document
	  // in old IE typeof document.createElement is 'object'
	  , is = isObject(document) && isObject(document.createElement);
	module.exports = function(it){
	  return is ? document.createElement(it) : {};
	};

/***/ },
/* 101 */
/***/ function(module, exports) {

	var hasOwnProperty = {}.hasOwnProperty;
	module.exports = function(it, key){
	  return hasOwnProperty.call(it, key);
	};

/***/ },
/* 102 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = !__webpack_require__(35) && !__webpack_require__(51)(function(){
	  return Object.defineProperty(__webpack_require__(100)('div'), 'a', {get: function(){ return 7; }}).a != 7;
	});

/***/ },
/* 103 */
/***/ function(module, exports, __webpack_require__) {

	// fallback for non-array-like ES3 and non-enumerable old V8 strings
	var cof = __webpack_require__(49);
	module.exports = Object('z').propertyIsEnumerable(0) ? Object : function(it){
	  return cof(it) == 'String' ? it.split('') : Object(it);
	};

/***/ },
/* 104 */
/***/ function(module, exports, __webpack_require__) {

	// 7.2.2 IsArray(argument)
	var cof = __webpack_require__(49);
	module.exports = Array.isArray || function isArray(arg){
	  return cof(arg) == 'Array';
	};

/***/ },
/* 105 */
/***/ function(module, exports, __webpack_require__) {

	var anObject       = __webpack_require__(95)
	  , IE8_DOM_DEFINE = __webpack_require__(102)
	  , toPrimitive    = __webpack_require__(110)
	  , dP             = Object.defineProperty;
	
	exports.f = __webpack_require__(35) ? Object.defineProperty : function defineProperty(O, P, Attributes){
	  anObject(O);
	  P = toPrimitive(P, true);
	  anObject(Attributes);
	  if(IE8_DOM_DEFINE)try {
	    return dP(O, P, Attributes);
	  } catch(e){ /* empty */ }
	  if('get' in Attributes || 'set' in Attributes)throw TypeError('Accessors not supported!');
	  if('value' in Attributes)O[P] = Attributes.value;
	  return O;
	};

/***/ },
/* 106 */
/***/ function(module, exports) {

	module.exports = function(bitmap, value){
	  return {
	    enumerable  : !(bitmap & 1),
	    configurable: !(bitmap & 2),
	    writable    : !(bitmap & 4),
	    value       : value
	  };
	};

/***/ },
/* 107 */
/***/ function(module, exports, __webpack_require__) {

	var global    = __webpack_require__(19)
	  , hide      = __webpack_require__(37)
	  , has       = __webpack_require__(101)
	  , SRC       = __webpack_require__(55)('src')
	  , TO_STRING = 'toString'
	  , $toString = Function[TO_STRING]
	  , TPL       = ('' + $toString).split(TO_STRING);
	
	__webpack_require__(18).inspectSource = function(it){
	  return $toString.call(it);
	};
	
	(module.exports = function(O, key, val, safe){
	  var isFunction = typeof val == 'function';
	  if(isFunction)has(val, 'name') || hide(val, 'name', key);
	  if(O[key] === val)return;
	  if(isFunction)has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
	  if(O === global){
	    O[key] = val;
	  } else {
	    if(!safe){
	      delete O[key];
	      hide(O, key, val);
	    } else {
	      if(O[key])O[key] = val;
	      else hide(O, key, val);
	    }
	  }
	// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
	})(Function.prototype, TO_STRING, function toString(){
	  return typeof this == 'function' && this[SRC] || $toString.call(this);
	});

/***/ },
/* 108 */
/***/ function(module, exports, __webpack_require__) {

	var global = __webpack_require__(19)
	  , SHARED = '__core-js_shared__'
	  , store  = global[SHARED] || (global[SHARED] = {});
	module.exports = function(key){
	  return store[key] || (store[key] = {});
	};

/***/ },
/* 109 */
/***/ function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(52)
	  , max       = Math.max
	  , min       = Math.min;
	module.exports = function(index, length){
	  index = toInteger(index);
	  return index < 0 ? max(index + length, 0) : min(index, length);
	};

/***/ },
/* 110 */
/***/ function(module, exports, __webpack_require__) {

	// 7.1.1 ToPrimitive(input [, PreferredType])
	var isObject = __webpack_require__(23);
	// instead of the ES6 spec version, we didn't implement @@toPrimitive case
	// and the second argument - flag - preferred type is a string
	module.exports = function(it, S){
	  if(!isObject(it))return it;
	  var fn, val;
	  if(S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it)))return val;
	  if(typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it)))return val;
	  if(!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it)))return val;
	  throw TypeError("Can't convert object to primitive value");
	};

/***/ },
/* 111 */
/***/ function(module, exports, __webpack_require__) {

	// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
	var $export = __webpack_require__(36);
	
	$export($export.P, 'Array', {fill: __webpack_require__(96)});
	
	__webpack_require__(34)('fill');

/***/ },
/* 112 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 22.1.3.9 Array.prototype.findIndex(predicate, thisArg = undefined)
	var $export = __webpack_require__(36)
	  , $find   = __webpack_require__(48)(6)
	  , KEY     = 'findIndex'
	  , forced  = true;
	// Shouldn't skip holes
	if(KEY in [])Array(1)[KEY](function(){ forced = false; });
	$export($export.P + $export.F * forced, 'Array', {
	  findIndex: function findIndex(callbackfn/*, that = undefined */){
	    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});
	__webpack_require__(34)(KEY);

/***/ },
/* 113 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 22.1.3.8 Array.prototype.find(predicate, thisArg = undefined)
	var $export = __webpack_require__(36)
	  , $find   = __webpack_require__(48)(5)
	  , KEY     = 'find'
	  , forced  = true;
	// Shouldn't skip holes
	if(KEY in [])Array(1)[KEY](function(){ forced = false; });
	$export($export.P + $export.F * forced, 'Array', {
	  find: function find(callbackfn/*, that = undefined */){
	    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});
	__webpack_require__(34)(KEY);

/***/ },
/* 114 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(44)();
	// imports
	
	
	// module
	exports.push([module.id, ".x-body,.x-btn-default-toolbar-small .x-btn-inner,.x-form-field,.x-form-item,.x-form-item-label,.x-grid-cell-inner,.x-panel-header-text-default,body{font-size:11px;font-family:Helvetica Neue,Helvetica,Arial,\"sans-serif\"!important}#init{display:table;margin:300px auto;font-size:13px;color:#444}#init .brand{font-weight:600;padding-right:5px}::-webkit-scrollbar{width:8px;height:7px;border:0 none}::-webkit-scrollbar-track:horizontal{background-color:#ddd;margin:0 2px;border-bottom:1px solid #fff}::-webkit-scrollbar-thumb:horizontal{background-color:#bbb;border-bottom:1px solid #fff}::-webkit-scrollbar-track:vertical{background-color:#e1e1e1;margin:1px 0;border-right:1px solid #fff}::-webkit-scrollbar-thumb:vertical{background-color:#bbb;border-right:1px solid #fff}.user-select{-webkit-touch-callout:text;-webkit-user-select:text;-moz-user-select:text;-ms-user-select:text;user-select:text}.x-scroller-vertical{border:0 none}.disabled{opacity:.4;cursor:default!important}.disabled-toolbar{opacity:1}.x-splitter{display:none}.fixed{position:fixed}.pointer{cursor:pointer}.text-medium{font-weight:600}.highcharts-container *{font-family:Helvetica Neue,Helvetica,Arial,Roboto,sans-serif}.spinner{width:20px;height:20px;margin:50px auto;background-color:#aaa;border-radius:100%;-webkit-animation:sk-scaleout .8s infinite ease-in-out;animation:sk-scaleout .8s infinite ease-in-out}@-webkit-keyframes sk-scaleout{0%{-webkit-transform:scale(0)}to{-webkit-transform:scale(1);opacity:0}}@keyframes sk-scaleout{0%{-webkit-transform:scale(0);transform:scale(0)}to{-webkit-transform:scale(1);transform:scale(1);opacity:0}}.ns-viewport-text *{padding:3px 10px;font-size:13px;color:#777}.ns-viewport-text h3{font-size:13px;font-weight:500;color:#333;padding:0 0 8px}.x-panel-body{font-size:11px;border-color:#dadada}.x-panel .x-grid-body{border-style:none}.ns-panel-title-data,.ns-panel-title-dimension,.ns-panel-title-organisationunit,.ns-panel-title-period{height:17px;background-repeat:no-repeat;padding-left:22px}.ns-panel-title-data{background-image:url(" + __webpack_require__(256) + ")}.ns-panel-title-period{background-image:url(" + __webpack_require__(289) + ")}.ns-panel-title-organisationunit{background-image:url(" + __webpack_require__(288) + ")}.ns-panel-title-dimension{background-image:url(" + __webpack_require__(257) + ")}.x-webkit .x-form-empty-field{line-height:14px}.x-form-text,textarea.x-form-field{font-size:10px}.x-form-item-label{font-size:11px;color:#111}.ns-combo .x-form-text{padding-left:5px}.ns-combo .small .x-form-field{padding-top:2px}.ns-combo input{border-radius:1px 0 0 0}.ns-trigger-filter .x-form-trigger{height:22px!important;background:url(" + __webpack_require__(253) + ") 0 0 no-repeat;border-top:1px solid #b5b8c8;border-right:1px solid #b5b8c8}.ns-trigger-filter-focused .x-form-trigger{border:1px solid #a1a1a1;border-left:0 none}.ns-trigger-filter .x-form-trigger-over{background:url(" + __webpack_require__(252) + ") 0 0 no-repeat}.x-fit-item{border-style:none}.x-boundlist-item{color:#333;padding:3px 2px 3px 4px;font-size:10px;border:1px solid transparent}.x-boundlist-item-over{background-color:#e1e1e1;border-color:#e1e1e1}.x-boundlist-selected{background-color:#d3d3d3;border-color:#d3d3d3}.ns-multiselect{color:#111}.ns-toolbar-multiselect-left .x-docked-top{border-top-left-radius:1px;border-right:0 none}.ns-toolbar-multiselect-right .x-docked-top{border-top-right-radius:1px}.ns-toolbar-multiselect-leftright .x-docked-top{border-top-left-radius:1px;border-top-right-radius:1px}.ns-toolbar-multiselect-left .ns-toolbar-multiselect-left-label,.ns-toolbar-multiselect-leftright .ns-toolbar-multiselect-leftright-label,.ns-toolbar-multiselect-right .ns-toolbar-multiselect-right-label{font-size:11px;color:#222}.ns-toolbar-multiselect-left .ns-toolbar-multiselect-left-label{padding-left:6px}.ns-toolbar-multiselect-right .ns-toolbar-multiselect-right-label{padding-right:7px}.ns-toolbar-multiselect-leftright .ns-toolbar-multiselect-leftright-label{padding-left:4px}.ns-toolbar-multiselect-left .x-boundlist-item-over,.ns-toolbar-multiselect-right .x-boundlist-item-over{background-color:transparent;border-color:transparent}.ns-toolbar-multiselect-left .x-boundlist-selected,.ns-toolbar-multiselect-right .x-boundlist-selected{background-color:#e5e5e5;border-color:#e5e5e5}.ns-toolbar-multiselect-left .x-panel-body{border-right:0 none}.x-form-cb-label-after{padding-left:1px;font-size:11px;color:#333;position:relative;top:-1px}.x-form-checkbox{background-image:url(" + __webpack_require__(251) + ")}.x-form-cb-wrap{padding-top:2px;line-height:12px}.ns-checkbox .x-form-item-label{padding-left:5px}.ns-checkbox .x-form-cb-label-after{margin-left:3px;font-size:11px}.x-toolbar .x-toolbar-separator-horizontal{height:15px;border-right:1px solid #f2f2f2}.x-toolbar.x-item-disabled{opacity:1}.x-toolbar-default{border-color:#dadada;background-image:none;background-color:#f6f6f6}.x-tool-triple-chevron-left{background-image:url(" + __webpack_require__(84) + ")!important}.x-tool-triple-chevron-right{background-image:url(" + __webpack_require__(85) + ")!important}.tool-triple-chevron-right img{width:20px!important}.ns-toolbar-btn-menu{margin-top:4px}.x-menu-body{border-color:#bbb;border-radius:2px}.x-menu-item-active .x-menu-item-link{border-radius:0;border-color:#e1e1e1;background-color:#e1e1e1;background-image:none}.x-menu-body{padding:0}.x-box-inner{-webkit-touch-callout:none;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.x-menu-body .x-box-inner,.x-menu-item{background-color:#fafafa}.x-menu-item-link{padding:4px 5px 4px 26px}.x-menu-item-text{color:#111}.ns-menu-item-noicon .x-menu-item-link{padding-left:10px}.ns-menu-item-advanced,.ns-menu-item-datasource,.ns-menu-item-image,.ns-menu-item-scheme,.ns-menu-item-selected,.ns-menu-item-tablelayout,.ns-menu-item-unselected{padding-left:18px}.ns-menu-item-image{background-image:url(" + __webpack_require__(261) + ")}.ns-menu-item-tablelayout{background-image:url(" + __webpack_require__(263) + ")}.ns-menu-item-datasource{background-image:url(" + __webpack_require__(260) + ")}.ns-menu-item-advanced{background-image:url(" + __webpack_require__(259) + ")}.ns-menu-item-scheme{background-image:url(" + __webpack_require__(262) + ")}.ns-menu-item-selected{background-image:url(" + __webpack_require__(250) + ")}.ns-menu-item-unselected{background-image:url(" + __webpack_require__(249) + ")}.ns-btn-menu{margin-top:2px}.ns-menu-item-favorite-new{background-image:url(" + __webpack_require__(268) + ")}.ns-menu-item-favorite-open{background-image:url(" + __webpack_require__(269) + ")}.ns-menu-item-favorite-save{background-image:url(" + __webpack_require__(272) + ")}.ns-menu-item-favorite-restore{background-image:url(" + __webpack_require__(271) + ")}.ns-menu-item-favorite-rename{background-image:url(" + __webpack_require__(270) + ")}.ns-menu-item-favorite-share{background-image:url(" + __webpack_require__(273) + ")}.ns-menu-item-favorite-interpretation{background-image:url(" + __webpack_require__(266) + ")}.ns-menu-item-favorite-link{background-image:url(" + __webpack_require__(267) + ")}.ns-menu-item-favorite-delete{background-image:url(" + __webpack_require__(265) + ")}.ns-menu-item-favorite-translate{background-image:url(" + __webpack_require__(274) + ")}.x-btn-arrow{background-image:url(" + __webpack_require__(241) + ")!important}.x-btn-default-toolbar-small,.x-btn-default-toolbar-small-over,.x-btn-default-toolbar-small-pressed{border-radius:1px}.x-btn-default-toolbar-small-over,.x-btn-default-toolbar-small-pressed{border-color:#bbb}.x-btn-default-toolbar-small-icon button{width:32px!important}.x-btn-default-toolbar-small-icon .x-btn-icon{width:32px;height:32px}.x-btn-default-small{border-radius:1px}.x-btn-default-toolbar-small-pressed{border-color:#bbb;background-image:none;background-color:#d6d6d6;background-image:-webkit-gradient(linear,50% 0,50% 100%,color-stop(0,#d1d1d1),color-stop(100%,#e5e5e5));background-image:-webkit-linear-gradient(top,#d1d1d1,#e5e5e5);background-image:linear-gradient(top,#d1d1d1,#e5e5e5)}.ns-button-icon-type-column{background:url(" + __webpack_require__(255) + ") no-repeat}.ns-button-icon-type-columnstacked{background:url(" + __webpack_require__(254) + ") no-repeat}.ns-button-icon-type-bar{background:url(" + __webpack_require__(247) + ") no-repeat}.ns-button-icon-type-barstacked{background:url(" + __webpack_require__(246) + ") no-repeat}.ns-button-icon-type-line{background:url(" + __webpack_require__(285) + ") no-repeat}.ns-button-icon-type-area{background:url(" + __webpack_require__(240) + ") no-repeat}.ns-button-icon-type-pie{background:url(" + __webpack_require__(290) + ") no-repeat}.ns-button-icon-type-radar{background:url(" + __webpack_require__(291) + ") no-repeat}.ns-button-icon-type-gauge{background:url(" + __webpack_require__(276) + ") no-repeat}.ns-button-icon-gear{width:22px!important;height:22px!important;background:url(" + __webpack_require__(277) + ") no-repeat}.ns-button-icon-table{background:url(" + __webpack_require__(293) + ") no-repeat}.ns-button-icon-chart{background:url(" + __webpack_require__(248) + ") no-repeat}.ns-button-icon-map{background:url(" + __webpack_require__(286) + ") no-repeat}.ns-button-icon-arrowleft{background:url(" + __webpack_require__(242) + ") no-repeat}.ns-button-icon-arrowleftdouble{background:url(" + __webpack_require__(243) + ") no-repeat}.ns-button-icon-arrowlefttriple{background:url(" + __webpack_require__(84) + ") no-repeat;width:26px!important}.ns-button-icon-arrowright{background:url(" + __webpack_require__(244) + ") no-repeat}.ns-button-icon-arrowrightdouble{background:url(" + __webpack_require__(245) + ") no-repeat}.ns-button-icon-arrowrighttriple{background:url(" + __webpack_require__(85) + ") no-repeat;width:26px!important}.ns-button-icon-search{background:url(" + __webpack_require__(292) + ") 1px 1px no-repeat}.ns-button-icon-nodeselectchild{background:url(" + __webpack_require__(287) + ") 1px 1px no-repeat}.ns-button-organisationunitselection .x-btn-center{width:18px!important}.ns-button-icon.x-btn-default-toolbar-small-disabled{-ms-filter:\"progid:DXImageTransform.Microsoft.Alpha(Opacity=25)\";opacity:.25}.x-tip{border-radius:2px;padding:1px 4px;border:1px solid #111;background-color:#111}.x-tip .x-tip-body{font-size:10px;color:#fff;-webkit-text-stroke:.2px #fff}.x-tip-anchor{border-top-color:#111}.x-mask-msg{padding:0;border:0 none;background-image:none;background-color:transparent}.x-mask-msg div{background-position:11px}.x-mask-msg .x-mask-loading{border:0 none;background-color:#000;color:#fff;border-radius:2px;padding:12px 14px 12px 30px;opacity:.65}.x-grid-row-selected .x-grid-cell{background-color:#eaeaea!important;border-style:solid;border-color:transparent}.ns-grid-row-icon-dashboard,.ns-grid-row-icon-delete,.ns-grid-row-icon-edit,.ns-grid-row-icon-overwrite,.ns-grid-row-icon-sharing{width:16px;height:16px;cursor:pointer}.ns-grid-row-icon-edit{background:url(" + __webpack_require__(280) + ") no-repeat}.ns-grid-row-icon-overwrite{background:url(" + __webpack_require__(281) + ") no-repeat;margin-left:4px}.ns-grid-row-icon-sharing{background:url(" + __webpack_require__(282) + ") no-repeat;margin-left:4px}.ns-grid-row-icon-dashboard{background:url(" + __webpack_require__(278) + ") no-repeat;margin-left:4px}.ns-grid-row-icon-delete{background:url(" + __webpack_require__(279) + ") no-repeat;margin-left:4px}.ns-grid-row-icon-disabled img.ns-grid-row-icon-dashboard,.ns-grid-row-icon-disabled img.ns-grid-row-icon-sharing{cursor:pointer!important}.ns-grid .x-grid-cell-inner,.ns-grid .x-grid-cell-inner *{font-size:11px!important}.ns-grid .x-grid-cell-inner{padding-top:3px;padding-bottom:3px}.ns-grid .x-column-header-text{color:#333}.ns-grid .x-grid-header-ct{border-bottom-width:1px!important;border-bottom-color:#d6d6d6}.ns-grid .x-grid-body{border:1px solid #d6d6d6;border-top:0 none!important}.ns-grid .x-grid-dirty-cell{background-image:none}.ns-grid .x-grid-row{vertical-align:middle}.ns-grid .x-grid-row .x-grid-cell{border-top:0 none}.ns-grid .link,.ns-grid .link *{cursor:pointer;cursor:hand;color:#001eff;text-decoration:underline}.x-window .x-window-header-text-default{font-size:10px;text-transform:uppercase;text-align:center;color:#444;padding-left:8px;padding-top:1px}.ns-window-title-favorite{padding-left:19px;background-image:url(" + __webpack_require__(275) + ")}.ns-window-title-interpretation{padding-left:19px;background-image:url(" + __webpack_require__(283) + ")}.ns-window-title-datatable{padding-left:19px;background-image:url(" + __webpack_require__(258) + ")}.ns-window-title-messagebox{padding-left:16px;background-position-y:1px}.ns-window-title-messagebox.error{background-image:url(" + __webpack_require__(264) + ")}.ns-window-title-messagebox.warning{background-image:url(" + __webpack_require__(295) + ")}.ns-window-confirm-list .x-panel-body{color:#444;font-size:10px;border-style:none}.ns-label-period-heading,.ns-label-period-heading-options{font-size:11px;font-weight:700;color:#333;line-height:18px}.ns-label-period-heading-options{background-color:#e1e1e1;padding:1px 5px;border-radius:2px}.ns-label-info{font-size:10px!important;color:#666;padding-left:4px;height:22px;line-height:21px}.ns-textfield-alt1 .x-form-field,.ns-textfield .x-form-field{height:26px;padding-left:4px;border-radius:1px;font-size:11px;color:#333}.ns-textfield .x-form-item-label{padding-left:5px;line-height:20px}.ns-textfield-alt1 .x-form-item-label{padding-left:5px;line-height:8px}.x-tree-icon-leaf{background-image:url(" + __webpack_require__(284) + ")}.ns-tree.x-tree-panel .x-grid-row .x-grid-cell-inner{height:17px;font-size:10px}.ns-tree .x-grid-table{width:100%!important}.ns-tree .x-grid-row-selected .x-grid-cell,.ns-tree .x-grid-row-selected .x-grid-rowwrap-div{background-color:#e0e0e0;border-radius:2px 2px 2px 2px}.ns-tree .x-grid-cell{border-radius:2px 2px 2px 2px}#treepanel-contextmenu{border-radius:3px;border:1px solid #ddd}.ns-statusbar .x-panel-body-default{padding:5px 0 0 6px;border:0 none;background-color:transparent;color:#111;vertical-align:top;font-size:10px;line-height:14px}.ns-accordion .x-accordion-item .x-accordion-hd{padding:6px 5px 4px 8px;border:0 none;cursor:pointer;border-radius:0;background-image:none;background-color:#e0e0e0;background-image:-webkit-gradient(linear,50% 0,50% 100%,color-stop(0,#dedede),color-stop(100%,#e6e6e6))!important;background-image:-webkit-linear-gradient(top,#ddd,#e6e6e6)!important;background-image:linear-gradient(top,#ddd,#e6e6e6)!important}.ns-accordion .collapsed .x-accordion-hd{padding-bottom:5px!important}.ns-accordion .x-accordion-item{border-radius:1px;border:1px solid #c5c5c5;border-bottom:0 none}.ns-accordion .ns-accordion-last{border:1px solid #c5c5c5}.ns-accordion .x-accordion-hd .x-panel-header-text{font-weight:700;cursor:pointer}.ns-accordion .x-accordion-body{padding:1px;border-top:1px solid #c5c5c5!important}.ns-accordion .x-accordion-hd-sibling-expanded{-o-box-shadow:none;box-shadow:none}.ns-accordion .ns-toolbar-multiselect-left,.ns-accordion .ns-toolbar-multiselect-right{margin-bottom:0}.ns-accordion .ns-combo .x-form-text,.ns-accordion .ns-combo .x-form-trigger{height:24px;padding-top:1px}.ns-accordion .ns-combo .x-form-item-label{padding:4px 0 0}.ns-accordion .x-component.x-panel-header-text-container.x-box-item.x-component-default{width:100%!important}.ns-textarea .x-form-field{font-size:11px;line-height:14px!important}.ns-textarea.monospaced textarea{font-family:Monospace,Consolas,Courier New,Courier\\ 10 Pitch!important;padding:4px;border:0 none}.favorite-li{padding:0}.favorite-li:hover{color:#222}.ns-chart-tips{border-radius:2px;padding:1px 4px 2px;border:2px solid #777;background-color:#f1f1f1}.ns-chart-tips .x-tip-body{background-color:#f1f1f1;font-size:13px;font-weight:400;color:#444;-webkit-text-stroke:0}.legend3Lines .x-legend .x-legend-items{display:inline-block!important}.legend3Lines .x-legend .x-legend-item{float:left!important;width:205px!important;overflow:hidden}.legend3Lines .x-legend{height:110px!important;width:400px!important}.x-tip,.x-tip-body,.x-tip-body span{width:auto!important;background-color:grey!important;border:0}.eastPanel .clickable,.eastPanel .clickable div,.eastPanel .clickable label{cursor:pointer!important}.eastPanel .thumbs_up{background-image:url(" + __webpack_require__(294) + ");background-position:5px 5px;padding:7px 25px;background-repeat:no-repeat}.eastPanel .greyBackground,.eastPanel .greyBackground div{background-color:#efefef}.eastPanel .comment{padding:5px;margin-top:1px}.eastPanel .eastPanelLink{cursor:pointer;color:#3162c5}.eastPanel .eastPanelLink:hover{color:#1c3974}.eastPanel .bold{font-weight:700}.eastPanel .interpretationActions{line-height:16px}.eastPanel .interpretationDetailsField{white-space:nowrap;font-weight:700;line-height:18px}.eastPanel .avatar{height:30px;width:30px;border-radius:50%;display:inline-block;background-color:#bdbdbd;text-align:center;line-height:30px;font-size:14px;color:#000;font-weight:700}.eastPanel .commentArea textarea{margin-bottom:5px;font-size:12px}.ns-panel-title-east-default .x-panel-header{background:#e6e6e6;border-top-width:0;border-left-width:0;box-shadow:none;-webkit-box-shadow:none;padding-top:8px;padding-bottom:7px;padding-left:7px}.ns-panel-title-east-default.first .x-panel-header{border-top-width:1px}.ns-panel-title-east-default .x-panel-body{border-left:0}", ""]);
	
	// exports


/***/ },
/* 115 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.Axis = undefined;
	
	var _arrayFrom = __webpack_require__(5);
	
	var _arrayFrom2 = _interopRequireDefault(_arrayFrom);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Axis = exports.Axis = undefined;
	
	exports.Axis = Axis = function Axis(refs, config) {
	    var t = [];
	
	    var _refs$api = refs.api,
	        Axis = _refs$api.Axis,
	        Dimension = _refs$api.Dimension;
	
	
	    config = (0, _arrayFrom2.default)(config);
	
	    // constructor
	    config.forEach(function (dimensionConfig) {
	        t.push(new Dimension(refs, dimensionConfig).val());
	    });
	
	    // prototype
	    t.log = function (text, noError) {
	        if (!noError) {
	            console.log(text, this, config);
	        }
	    };
	
	    t.val = function (noError) {
	        if (!this.length) {
	            this.log('(Axis) No dimensions', noError);
	            return null;
	        }
	
	        return this;
	    };
	
	    t.add = function (dimensionConfig, skipValidation) {
	        var dimension = skipValidation ? dimensionConfig : new Dimension(refs, dimensionConfig).val();
	
	        if (dimension) {
	            t.push(dimension);
	        }
	    };
	
	    t.clone = function () {
	        return Axis(refs, this);
	    };
	
	    t.empty = function () {
	        var cache = t.slice(0);
	
	        for (var i = 0, len = t.length; i < len; i++) {
	            t.pop();
	        }
	
	        return cache;
	    };
	
	    t.getRecordIds = function (isSorted, asString) {
	        var ids = asString ? '' : [];
	
	        t.forEach(function (dimension, dIndex, dArray) {
	            dimension.getRecordIds(isSorted, null, true).forEach(function (id, nIndex, nArray) {
	                if (asString) {
	                    ids += id + (nIndex !== nArray.length - 1 ? ', ' : '');
	                } else {
	                    ids.push(id);
	                }
	            });
	
	            if (asString) {
	                ids += dIndex !== dArray.length - 1 ? ' - ' : '';
	            }
	        });
	
	        return ids;
	    };
	
	    t.getRecordNames = function (isSorted, response, asString) {
	        var names = asString ? '' : [];
	
	        t.forEach(function (dimension, dIndex, dArray) {
	            dimension.getRecordNames(isSorted, response, true).forEach(function (name, nIndex, nArray) {
	                if (asString) {
	                    names += name + (nIndex !== nArray.length - 1 ? ', ' : '');
	                } else {
	                    names.push(name);
	                }
	            });
	
	            if (asString) {
	                names += dIndex !== dArray.length - 1 ? ' - ' : '';
	            }
	        });
	
	        return names;
	    };
	
	    t.getDimension = function (dimensionName) {
	        return this.find(function (dimension) {
	            return dimension.dimension === dimensionName;
	        });
	    };
	
	    t.getDimensionNames = function () {
	        var names = [];
	
	        this.forEach(function (dimension) {
	            names.push(dimension.dimension);
	        });
	
	        return names;
	    };
	
	    t.has = function (dimensionName) {
	        return !!t.getDimension(dimensionName);
	    };
	
	    t.sorted = function () {
	        return t.clone().sort(function (a, b) {
	            return a.dimension > b.dimension;
	        });
	    };
	
	    t.extendRecords = function (response) {
	        t.forEach(function (dimension) {
	            dimension.extendRecords(response);
	        });
	    };
	
	    t.strip = function () {
	        var rest = [];
	
	        while (t.length > 1) {
	            rest.push(t.pop());
	        }
	
	        return rest.reverse();
	    };
	
	    t.toPlugin = function () {
	        delete t.klass;
	
	        t.forEach(function (item) {
	            item.toPlugin();
	        });
	    };
	
	    t.replaceDimensionByName = function (dimension) {
	        for (var i = 0; i < this.length; ++i) {
	            if (this[i].dimension === dimension.dimension) {
	                this[i] = dimension;
	            }
	        }
	    };
	
	    return t;
	};
	//# sourceMappingURL=Axis.js.map

/***/ },
/* 116 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.Layout = undefined;
	
	var _isArray = __webpack_require__(1);
	
	var _isArray2 = _interopRequireDefault(_isArray);
	
	var _isBoolean = __webpack_require__(15);
	
	var _isBoolean2 = _interopRequireDefault(_isBoolean);
	
	var _isDefined = __webpack_require__(67);
	
	var _isDefined2 = _interopRequireDefault(_isDefined);
	
	var _isNumber = __webpack_require__(7);
	
	var _isNumber2 = _interopRequireDefault(_isNumber);
	
	var _isObject = __webpack_require__(2);
	
	var _isObject2 = _interopRequireDefault(_isObject);
	
	var _isString = __webpack_require__(3);
	
	var _isString2 = _interopRequireDefault(_isString);
	
	var _arrayClean = __webpack_require__(9);
	
	var _arrayClean2 = _interopRequireDefault(_arrayClean);
	
	var _arrayContains = __webpack_require__(4);
	
	var _arrayContains2 = _interopRequireDefault(_arrayContains);
	
	var _arrayFrom = __webpack_require__(5);
	
	var _arrayFrom2 = _interopRequireDefault(_arrayFrom);
	
	var _arrayPluck = __webpack_require__(28);
	
	var _arrayPluck2 = _interopRequireDefault(_arrayPluck);
	
	var _arraySort = __webpack_require__(10);
	
	var _arraySort2 = _interopRequireDefault(_arraySort);
	
	var _DateManager = __webpack_require__(24);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Layout = exports.Layout = undefined;
	
	exports.Layout = Layout = function Layout(refs, c, applyConfig, forceApplyConfig) {
	    var t = this;
	
	    refs = (0, _isObject2.default)(refs) ? refs : {};
	
	    var _refs$api = refs.api,
	        Axis = _refs$api.Axis,
	        Sorting = _refs$api.Sorting;
	
	
	    c = (0, _isObject2.default)(c) ? c : {};
	    $.extend(c, applyConfig);
	
	    // private
	    var _path = refs.appManager.getApiPath();
	    var _source = '/analytics';
	    var _format = 'json';
	
	    var _response;
	    var _access;
	
	    var _dataDimensionItems;
	
	    // constructor
	    t.columns = Axis(refs, c.columns).val(true);
	    t.rows = Axis(refs, c.rows).val(true);
	    t.filters = Axis(refs, c.filters).val(true);
	
	    // access
	    _access = (0, _isObject2.default)(c.access) ? c.access : null;
	
	    // data dimension items
	    _dataDimensionItems = (0, _isArray2.default)(c.dataDimensionItems) ? c.dataDimensionItems : null;
	
	    // non model
	
	    // id
	    if ((0, _isString2.default)(c.id)) {
	        t.id = c.id;
	    }
	
	    // interpretationId
	    if ((0, _isString2.default)(c.interpretationId)) {
	        t.interpretationId = c.interpretationId;
	    }
	
	    // DHIS2-2784: propagate both name and displayName
	    // to avoid name being replaced by a translation in the translate dialog
	    // name
	    if ((0, _isString2.default)(c.name)) {
	        t.name = c.name;
	    }
	
	    t.displayName = (0, _arrayClean2.default)([c.displayName, c.displayShortName, c.name, c.shortName]).find(function (item) {
	        return (0, _isString2.default)(item);
	    });
	
	    // title
	    t.title = (0, _arrayClean2.default)([c.displayShortName, c.title]).find(function (item) {
	        return (0, _isString2.default)(item);
	    });
	
	    // description
	    if ((0, _isString2.default)(c.description)) {
	        t.description = c.description;
	    }
	
	    // sorting
	    if ((0, _isObject2.default)(c.sorting) && (0, _isDefined2.default)(c.sorting.id) && (0, _isString2.default)(c.sorting.direction)) {
	        t.sorting = new Sorting(refs, c.sorting);
	    }
	
	    // displayProperty
	    if ((0, _isString2.default)(c.displayProperty)) {
	        t.displayProperty = c.displayProperty;
	    }
	
	    // userOrgUnit
	    if ((0, _arrayFrom2.default)(c.userOrgUnit).length) {
	        t.userOrgUnit = (0, _arrayFrom2.default)(c.userOrgUnit);
	    }
	
	    // startDate
	    if ((0, _isString2.default)(c.startDate)) {
	        t.startDate = c.startDate;
	    }
	
	    // endDate
	    if ((0, _isString2.default)(c.endDate)) {
	        t.endDate = c.endDate;
	    }
	
	    // relative period date
	    if (_DateManager.DateManager.getYYYYMMDD(c.relativePeriodDate)) {
	        t.relativePeriodDate = _DateManager.DateManager.getYYYYMMDD(c.relativePeriodDate);
	    }
	
	    //description
	    if ((0, _isString2.default)(c.displayDescription)) {
	        t.displayDescription = c.displayDescription;
	    }
	
	    //interpretations
	    if ((0, _arrayFrom2.default)(c.interpretations).length) {
	        t.interpretations = (0, _isArray2.default)(c.interpretations) ? c.interpretations : null;
	    }
	
	    //lastUpdated
	    if (_DateManager.DateManager.getYYYYMMDD(c.lastUpdated)) {
	        t.lastUpdated = _DateManager.DateManager.getYYYYMMDD(c.lastUpdated);
	    }
	
	    //created
	    if (_DateManager.DateManager.getYYYYMMDD(c.created)) {
	        t.created = _DateManager.DateManager.getYYYYMMDD(c.created);
	    }
	
	    //favorite user
	    if ((0, _isObject2.default)(c.user)) {
	        t.user = c.user;
	    }
	
	    //public access
	    if ((0, _isString2.default)(c.publicAccess)) {
	        t.publicAccess = c.publicAccess;
	    }
	
	    //permission
	    if ((0, _isString2.default)(c.permission)) {
	        t.permission = c.permission;
	    }
	
	    //user group accesses
	    if ((0, _arrayFrom2.default)(c.userGroupAccesses).length) {
	        t.userGroupAccesses = c.userGroupAccesses;
	    }
	
	    if (c.el && (0, _isString2.default)(c.el)) {
	        t.el = c.el;
	    }
	
	    $.extend(t, forceApplyConfig);
	
	    // setter/getter
	    t.getResponse = function () {
	        return _response;
	    };
	
	    t.setResponse = function (r) {
	        _response = r;
	    };
	
	    t.getAccess = function () {
	        return _access;
	    };
	
	    t.setAccess = function (a) {
	        _access = a;
	    };
	
	    t.getDataDimensionItems = function () {
	        return _dataDimensionItems;
	    };
	
	    t.setDataDimensionItems = function (a) {
	        _dataDimensionItems = a;
	    };
	
	    t.getDefaultPath = function () {
	        return _path;
	    };
	
	    t.getDefaultSource = function () {
	        return _source;
	    };
	
	    t.getDefaultFormat = function () {
	        return _format;
	    };
	
	    t.getRequestPath = function (s, f) {
	        return (_path || refs.appManager.getPath()) + (s || _source) + '.' + (f || _format);
	    };
	
	    t.getRefs = function () {
	        return refs;
	    };
	};
	
	Layout.prototype.log = function (text, noError) {
	    if (!noError) {
	        console.log(text, this);
	    }
	};
	
	Layout.prototype.alert = function (text, noError) {
	    if (!noError) {
	        alert(text);
	    }
	};
	
	Layout.prototype.apply = function (obj, keys) {
	    var t = this;
	
	    if (!(0, _isObject2.default)(obj)) {
	        return t;
	    }
	
	    var preservedProps = ['name', 'description'];
	
	    keys = (0, _isArray2.default)(keys) ? keys : preservedProps;
	
	    keys.forEach(function (key) {
	        t[key] = obj[key];
	    });
	
	    return t;
	};
	
	Layout.prototype.toRows = function (includeFilter) {
	    this.rows = (0, _arrayClean2.default)(this.rows.concat(this.columns.empty(), includeFilter ? this.filters.empty() : []));
	};
	
	Layout.prototype.getAxes = function (includeFilter) {
	    return (0, _arrayClean2.default)([this.columns, this.rows, includeFilter ? this.filters : null]);
	};
	
	Layout.prototype.getUserOrgUnitUrl = function () {
	    if ((0, _isArray2.default)(this.userOrgUnit) && this.userOrgUnit.length) {
	        return 'userOrgUnit=' + this.userOrgUnit.join(';');
	    }
	};
	
	Layout.prototype.applyInterpretation = function (interpretation) {
	    this.setResponse(null);
	    this.relativePeriodDate = interpretation.created;
	    this.interpretationId = interpretation.id;
	};
	
	Layout.prototype.setSharing = function (sharing) {
	    this.publicAccess = sharing.publicAccess;
	    this.externalAccess = sharing.externalAccess;
	    this.userGroupAccesses = sharing.userGroupAccesses;
	    this.userAccesses = sharing.userAccesses;
	};
	
	// dep 1
	
	Layout.prototype.hasDimension = function (dimensionName, includeFilter) {
	    return this.getAxes(includeFilter).some(function (axis) {
	        return axis.has(dimensionName);
	    });
	};
	
	Layout.prototype.getDimensions = function (includeFilter, isSorted, axes) {
	    var dimensions = [];
	
	    axes = (0, _arrayClean2.default)(axes ? (0, _arrayFrom2.default)(axes) : this.getAxes(includeFilter));
	
	    axes.forEach(function (axis) {
	        dimensions = dimensions.concat(axis);
	    });
	
	    return isSorted ? dimensions.sort(function (a, b) {
	        return a.dimension > b.dimension;
	    }) : dimensions;
	};
	
	Layout.prototype.getRecords = function (includeFilter, response) {
	    var t = this;
	
	    var records = [];
	
	    this.getAxes(includeFilter).forEach(function (axis) {
	        axis.forEach(function (dimension) {
	            records = records.concat(dimension.getRecords(null, response));
	        });
	    });
	
	    return records;
	};
	
	Layout.prototype.extendRecords = function (response) {
	    this.getAxes(true).forEach(function (axis) {
	        axis.extendRecords(response);
	    });
	};
	
	Layout.prototype.stripAxes = function (includeFilter, skipAddToFilter) {
	    var t = this,
	        refs = t.getRefs();
	
	    var Axis = refs.api.Axis;
	
	
	    if (!skipAddToFilter && !t.filters) {
	        t.filters = new Axis(refs);
	    }
	
	    t.getAxes(includeFilter).forEach(function (axis) {
	        axis.strip().forEach(function (dimension) {
	            if (!skipAddToFilter) {
	                t.filters.add(dimension);
	            }
	        });
	    });
	};
	
	Layout.prototype.replaceDimensionByName = function (dimension, includeFilter) {
	    this.getAxes(includeFilter).forEach(function (axis) {
	        if (axis.has(dimension.dimension)) {
	            axis.replaceDimensionByName(dimension);
	        }
	    });
	};
	
	// dep 2
	
	Layout.prototype.getRecordIds = function (includeFilter) {
	    var ids = [];
	
	    this.getRecords(includeFilter).forEach(function (record) {
	        ids.push(record.id);
	    });
	
	    return ids;
	};
	
	Layout.prototype.getDimension = function (dimensionName) {
	    return this.getDimensions(true).find(function (dimension) {
	        return dimension.dimension === dimensionName;
	    });
	};
	
	Layout.prototype.getDimensionNames = function (includeFilter, isSorted, axes) {
	    var names = (0, _arrayPluck2.default)(this.getDimensions(includeFilter, false, axes), 'dimension');
	
	    return isSorted ? names.sort() : names;
	};
	
	Layout.prototype.getDimensionNameIdsMap = function (response) {
	    var map = {};
	
	    response = response || this.getResponse();
	
	    this.getDimensions(true).forEach(function (dimension) {
	        map[dimension.dimension] = dimension.getRecordIds(false, response);
	    });
	
	    return map;
	};
	
	Layout.prototype.removeDimensionItems = function (includeFilter) {
	    this.getDimensions(includeFilter).forEach(function (dimension) {
	        dimension.removeItems();
	    });
	};
	
	Layout.prototype.val = function (noError) {
	    var refs = this.getRefs();
	    var i18nManager = refs.i18nManager;
	
	    if (!(this.columns || this.rows)) {
	        this.alert(i18nManager.get('at_least_one_dimension_must_be_specified_as_row_or_column'), noError); //todo alert
	        return null;
	    }
	
	    if (!this.hasDimension(refs.dimensionConfig.get('period').dimensionName, true)) {
	        this.alert(i18nManager.get('at_least_one_period_must_be_specified_as_column_row_or_filter'), noError); //todo alert
	        return null;
	    }
	
	    return this;
	};
	
	Layout.prototype.toPlugin = function (el) {
	    var t = this,
	        refs = this.getRefs();
	
	    var appManager = refs.appManager,
	        optionConfig = refs.optionConfig,
	        layout;
	
	    if (t.id) {
	        layout = {
	            id: t.id
	        };
	    } else {
	        layout = t.clone();
	
	        // columns, rows, filters
	        layout.getAxes(true).forEach(function (item) {
	            item.toPlugin();
	        });
	
	        // properties
	        var deleteIfTruthy = ['showRowTotals', 'showColTotals', 'showColSubTotals', 'showRowSubTotals', 'showDimensionLabels', 'showValues'];
	
	        var deleteIfFalsy = ['hideEmptyRows', 'hideEmptyColumns', 'stickyColumnDimension', 'stickyRowDimension', 'skipRounding', 'showHierarchy', 'completedOnly', 'hideLegend', 'hideTitle', 'title', 'legendSet', 'sorting', 'targetLineValue', 'targetLineTitle', 'baseLineValue', 'baseLineTitle', 'rangeAxisMaxValue', 'rangeAxisMinValue', 'rangeAxisSteps', 'rangeAxisDecimals', 'rangeAxisTitle', 'domainAxisTitle', 'regression', 'cumulative', 'sortOrder', 'topLimit'];
	
	        var deleteAnyway = ['klass', 'name', 'parentGraphMap', 'reportingPeriod', 'organisationUnit', 'parentOrganisationUnit', 'cumulative', 'sortOrder', 'topLimit', 'displayDescription', 'displayName', 'interpretations', 'lastUpdated', 'created', 'user', 'publicAccess', 'permission', 'userGroupAccesses', 'prototype', 'url'];
	
	        deleteIfTruthy.forEach(function (item) {
	            if (!!layout[item]) {
	                delete layout[item];
	            }
	        });
	
	        deleteIfFalsy.forEach(function (item) {
	            if (!layout[item]) {
	                delete layout[item];
	            }
	        });
	
	        deleteAnyway.forEach(function (item) {
	            delete layout[item];
	        });
	
	        if (layout.displayDensity === optionConfig.getDisplayDensity('normal').id) {
	            delete layout.displayDensity;
	        }
	
	        if (layout.fontSize === optionConfig.getFontSize('normal').id) {
	            delete layout.fontSize;
	        }
	
	        if (layout.digitGroupSeparator === optionConfig.getDigitGroupSeparator('space').id) {
	            delete layout.digitGroupSeparator;
	        }
	
	        if (layout.aggregationType === optionConfig.getAggregationType('def').id) {
	            delete layout.aggregationType;
	        }
	
	        if (layout.numberType === optionConfig.getNumberType('value').id) {
	            delete layout.numberType;
	        }
	
	        if (layout.dataApprovalLevel && layout.dataApprovalLevel.id === optionConfig.getDataApprovalLevel('def').id) {
	            delete layout.dataApprovalLevel;
	        }
	
	        if (layout.regressionType === 'NONE') {
	            delete layout.regressionType;
	        }
	    }
	
	    layout.url = appManager.getPath();
	
	    if (el) {
	        layout.el = el;
	    }
	
	    return layout;
	};
	
	Layout.prototype.toPostSuper = function () {
	    delete this.klass;
	    delete this.getResponse;
	    delete this.setResponse;
	    delete this.getAccess;
	    delete this.setAccess;
	    delete this.getDataDimensionItems;
	    delete this.setDataDimensionItems;
	    delete this.getRequestPath;
	
	    this.getDimensions(true).forEach(function (dimension) {
	        dimension.toPost();
	    });
	
	    this.rowTotals = this.showRowTotals;
	    delete this.showRowTotals;
	
	    this.colTotals = this.showColTotals;
	    delete this.showColTotals;
	
	    this.rowSubTotals = this.showRowSubTotals;
	    delete this.showRowSubTotals;
	
	    this.colSubTotals = this.showColSubTotals;
	    delete this.showColSubTotals;
	
	    this.reportParams = {
	        paramReportingPeriod: this.reportingPeriod,
	        paramOrganisationUnit: this.organisationUnit,
	        paramParentOrganisationUnit: this.parentOrganisationUnit
	    };
	
	    delete this.reportingPeriod;
	    delete this.organisationUnit;
	    delete this.parentOrganisationUnit;
	
	    delete this.parentGraphMap;
	
	    delete this.id;
	    delete this.el;
	
	    delete this.displayDescription;
	    delete this.interpretations;
	    delete this.lastUpdated;
	    delete this.created;
	    delete this.user;
	    delete this.publicAccess;
	    delete this.permission, delete this.userGroupAccesses;
	    delete this.displayName;
	};
	
	Layout.prototype.toSession = function () {
	    var t = this;
	
	    var response = t.getResponse();
	
	    t.extendRecords(response);
	
	    return t;
	};
	
	Layout.prototype.sort = function (table) {
	    var t = this,
	        refs = t.getRefs();
	
	    var _refs$api2 = refs.api,
	        Record = _refs$api2.Record,
	        Dimension = _refs$api2.Dimension,
	        ResponseRowIdCombination = _refs$api2.ResponseRowIdCombination;
	
	
	    var id = this.sorting.id,
	        direction = this.sorting.direction,
	        dimension = this.rows[0],
	        response = this.getResponse(),
	        idValueMap = table ? table.idValueMap : response.getIdValueMap(t),
	        records = [],
	        ids,
	        sortingId,
	        obj;
	
	    if (!(0, _isString2.default)(id)) {
	        return;
	    }
	
	    ids = this.getDimensionNameIdsMap(response)[dimension.dimension];
	
	    ids.forEach(function (item) {
	        var validId = new ResponseRowIdCombination(refs, [id, item]).get();
	        sortingId = parseFloat(idValueMap[validId]);
	
	        obj = {
	            id: item,
	            sortingId: (0, _isNumber2.default)(sortingId) ? sortingId : Number.MAX_VALUE * -1
	        };
	
	        records.push(obj);
	    });
	
	    // sort
	    (0, _arraySort2.default)(records, direction, 'sortingId');
	
	    // dimension
	    dimension.items = records.map(function (record) {
	        return new Record(refs, record);
	    });
	    dimension.sorted = true;
	
	    this.sorting.id = id;
	};
	
	// dep 3
	
	Layout.prototype.hasRecordIds = function (idParam, includeFilter) {
	    var ids = this.getRecordIds(includeFilter);
	    var has = false;
	
	    idParam = (0, _arrayFrom2.default)(idParam);
	
	    idParam.forEach(function (id) {
	        if ((0, _arrayContains2.default)(ids, id)) {
	            has = true;
	        }
	    });
	
	    return has;
	};
	
	Layout.prototype.getFirstDxId = function () {
	    return this.getDimension('dx').getRecordIds()[0];
	};
	
	Layout.prototype.del = function (fn, doMask, doUnmask) {
	    var t = this,
	        refs = this.getRefs();
	
	    var instanceManager = refs.instanceManager;
	
	    instanceManager.delById(t.id, fn, doMask, doUnmask);
	};
	
	Layout.prototype.toPost = function () {
	    var t = this;
	
	    t.toPostSuper();
	};
	
	Layout.prototype.isDimensionInRows = function (dimensionName) {
	    return this.rows.getDimensionNames().indexOf(dimensionName) !== -1;
	};
	
	// dep 4
	
	Layout.prototype.toPut = function () {
	    this.toPost();
	};
	
	Layout.prototype.isPeriodInRows = function () {
	    return this.isDimensionInRows('pe');
	};
	
	Layout.prototype.isOrganisationUnitInRows = function () {
	    return this.isDimensionInRows('ou');
	};
	
	// dep 5
	
	Layout.prototype.post = function (fn, doMask, doUnmask) {
	    var t = this,
	        refs = this.getRefs();
	
	    var appManager = refs.appManager,
	        instanceManager = refs.instanceManager,
	        uiManager = refs.uiManager;
	
	    var apiPath = appManager.getApiPath(),
	        apiEndpoint = instanceManager.apiEndpoint;
	
	    var url = apiPath + '/' + apiEndpoint;
	
	    if (doMask) {
	        uiManager.mask();
	    }
	
	    // "Save as" mode, t.id is present, copy settings from original
	    if (t.id) {
	        instanceManager.getSharingById(t.id, function (sharing) {
	            // set sharing
	            if ((0, _isObject2.default)(sharing) && (0, _isObject2.default)(sharing.object)) {
	                t.setSharing(sharing.object);
	            }
	        });
	    }
	
	    t.toPost();
	
	    // post
	    var postRequest = new refs.api.Request(refs, {
	        baseUrl: url,
	        type: 'ajax',
	        method: 'POST',
	        data: JSON.stringify(t),
	        success: function success(obj, _success, r) {
	            var id = (r.getResponseHeader('location') || '').split('/').pop();
	
	            if (!(0, _isString2.default)(id)) {
	                console.log('Layout post', 'Invalid id', id);
	            }
	
	            if (doUnmask) {
	                uiManager.unmask();
	            }
	
	            if (fn) {
	                fn(id, _success, r);
	            }
	        }
	    });
	
	    postRequest.run();
	    //    });
	};
	
	Layout.prototype.put = function (id, fn, doMask, doUnmask) {
	    var t = this,
	        refs = this.getRefs();
	
	    var appManager = refs.appManager,
	        instanceManager = refs.instanceManager,
	        uiManager = refs.uiManager;
	
	    var apiPath = appManager.getApiPath(),
	        apiEndpoint = instanceManager.apiEndpoint;
	
	    var url = apiPath + '/' + apiEndpoint + '/' + id;
	
	    if (doMask) {
	        uiManager.mask();
	    }
	
	    instanceManager.getSharingById(t.id, function (sharing) {
	        t.toPut();
	
	        // set sharing
	        if ((0, _isObject2.default)(sharing) && (0, _isObject2.default)(sharing.object)) {
	            t.setSharing(sharing.object);
	        }
	
	        // put
	        var putRequest = new refs.api.Request(refs, {
	            baseUrl: url,
	            type: 'ajax',
	            method: 'PUT',
	            data: JSON.stringify(t),
	            success: function success(obj, _success2, r) {
	                if (doUnmask) {
	                    uiManager.unmask();
	                }
	
	                if (fn) {
	                    fn(id, _success2, r);
	                }
	            },
	            error: function error(r) {
	                if ((0, _arrayContains2.default)([403], parseInt(r.httpStatusCode))) {
	                    r.message = i18n.you_do_not_have_access_to_all_items_in_this_favorite || r.message;
	                }
	
	                if (doMask) {
	                    uiManager.unmask();
	                }
	
	                uiManager.alert(r);
	            }
	        });
	
	        putRequest.run();
	    });
	};
	
	Layout.prototype.patch = function (properties, fn, doMask, doUnmask) {
	    var t = this,
	        refs = this.getRefs();
	
	    var appManager = refs.appManager,
	        instanceManager = refs.instanceManager,
	        uiManager = refs.uiManager;
	
	    var apiPath = appManager.getApiPath(),
	        apiEndpoint = instanceManager.apiEndpoint;
	
	    var url = apiPath + '/' + apiEndpoint + '/' + t.id;
	
	    if (!(0, _isObject2.default)(properties)) {
	        return;
	    }
	
	    if (doMask) {
	        uiManager.mask();
	    }
	
	    var patchRequest = new refs.api.Request(refs, {
	        baseUrl: url,
	        type: 'ajax',
	        method: 'PATCH',
	        data: JSON.stringify(properties),
	        dataType: 'text',
	        headers: appManager.defaultRequestHeaders,
	        success: function success(obj, _success3, r) {
	            if (doUnmask) {
	                uiManager.unmask();
	            }
	
	            if (fn) {
	                fn(null, _success3, r);
	            }
	        }
	    });
	
	    patchRequest.run();
	};
	
	Layout.prototype.req = function (source, format, isSorted, isTableLayout, isFilterAsDimension) {
	    var t = this,
	        refs = this.getRefs();
	
	    var Request = refs.api.Request;
	
	
	    var optionConfig = refs.optionConfig,
	        appManager = refs.appManager,
	        request = new Request(refs);
	
	    var defAggTypeId = optionConfig.getAggregationType('def').id,
	        displayProperty = this.displayProperty || appManager.getAnalyticsDisplayProperty();
	
	    // dimensions
	    this.getDimensions(false, isSorted).forEach(function (dimension) {
	        request.add(dimension.url(isSorted));
	    });
	
	    // filters
	    if (this.filters) {
	        this.filters.forEach(function (dimension) {
	            var isFilter = !(isFilterAsDimension && dimension.isRequired());
	
	            request.add(dimension.url(isSorted, null, isFilter));
	        });
	    }
	
	    // skip rounding
	    if (this.skipRounding) {
	        request.add('skipRounding=true');
	    }
	
	    // display property
	    request.add('displayProperty=' + displayProperty.toUpperCase());
	
	    // normal request only
	    if (!isTableLayout) {
	        // hierarchy
	        if (this.showHierarchy) {
	            request.add('hierarchyMeta=true');
	        }
	
	        // completed only
	        if (this.completedOnly) {
	            request.add('completedOnly=true');
	        }
	
	        // aggregation type
	        if ((0, _isString2.default)(this.aggregationType) && this.aggregationType !== defAggTypeId) {
	            request.add('aggregationType=' + this.aggregationType);
	        }
	
	        // user org unit
	        if ((0, _isArray2.default)(this.userOrgUnit) && this.userOrgUnit.length) {
	            request.add(this.getUserOrgUnitUrl());
	        }
	
	        // data approval level
	        if ((0, _isObject2.default)(this.dataApprovalLevel) && (0, _isString2.default)(this.dataApprovalLevel.id) && this.dataApprovalLevel.id !== 'DEFAULT') {
	            request.add('approvalLevel=' + this.dataApprovalLevel.id);
	        }
	
	        // relative period date
	        if (this.relativePeriodDate) {
	            request.add('relativePeriodDate=' + this.relativePeriodDate);
	        }
	
	        // measure criteria
	        if (this.measureCriteria) {
	            request.add('measureCriteria=' + this.measureCriteria);
	        }
	    } else {
	        // table layout
	        request.add('tableLayout=true');
	
	        // columns
	        request.add('columns=' + this.getDimensionNames(false, false, this.columns).join(';'));
	
	        // rows
	        request.add('rows=' + this.getDimensionNames(false, false, this.rows).join(';'));
	
	        // hide empty columns
	        if (this.hideEmptyColumns) {
	            request.add('hideEmptyColumns=true');
	        }
	
	        // hide empty rows
	        if (this.hideEmptyRows) {
	            request.add('hideEmptyRows=true');
	        }
	
	        // show hierarchy
	        if (this.showHierarchy) {
	            request.add('showHierarchy=true');
	        }
	    }
	
	    // relative orgunits / user
	    if (this.hasRecordIds(appManager.userIdDestroyCacheKeys, true)) {
	        request.add('user=' + appManager.userAccount.id);
	    }
	
	    // base
	    request.setBaseUrl(this.getRequestPath(source, format));
	
	    return request;
	};
	
	// dep 5
	
	Layout.prototype.data = function (source, format) {
	    var t = this,
	        refs = this.getRefs();
	
	    var uiManager = refs.uiManager;
	
	    var metaDataRequest = this.req(source, format);
	    var dataRequest = this.req(source, format, true);
	
	    var errorFn = function errorFn(r) {
	        // 409
	        // DHIS2-2020: 503 error (perhaps analytics maintenance mode)
	        if ((0, _isObject2.default)(r) && (r.status == 409 || r.status === 503)) {
	            uiManager.unmask();
	
	            if ((0, _isString2.default)(r.responseText)) {
	                uiManager.alert(JSON.parse(r.responseText));
	            }
	        }
	    };
	
	    metaDataRequest.setType(this.getDefaultFormat());
	    dataRequest.setType(this.getDefaultFormat());
	
	    metaDataRequest.add('skipData=true');
	    dataRequest.add('skipMeta=true');
	
	    metaDataRequest.add('includeMetadataDetails=true');
	    dataRequest.add('includeNumDen=true');
	
	    metaDataRequest.setError(errorFn);
	    dataRequest.setError(errorFn);
	
	    return {
	        metaData: metaDataRequest.run(),
	        data: dataRequest.run()
	    };
	};
	//# sourceMappingURL=Layout.js.map

/***/ },
/* 117 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.OrganisationUnit = undefined;
	
	var _arrayFrom = __webpack_require__(5);
	
	var _arrayFrom2 = _interopRequireDefault(_arrayFrom);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var OrganisationUnit = exports.OrganisationUnit = undefined;
	
	exports.OrganisationUnit = OrganisationUnit = function OrganisationUnit(refs, config) {
	    var t = this;
	
	    t.id = config.id;
	    t.refs = refs;
	    t.i18n = refs.i18nManager.get();
	
	    // dynamic
	    t.ancestors = [];
	    t.level = null;
	};
	
	OrganisationUnit.prototype.getLevel = function () {
	    return this.level;
	};
	
	OrganisationUnit.prototype.setLevel = function (level) {
	    this.level = level;
	};
	
	OrganisationUnit.prototype.getAncestors = function () {
	    return this.ancestors;
	};
	
	OrganisationUnit.prototype.setAncestors = function (ancestors) {
	    this.ancestors = (0, _arrayFrom2.default)(ancestors);
	};
	
	OrganisationUnit.prototype.getInstanceManager = function () {
	    return this.refs.instanceManager;
	};
	
	OrganisationUnit.prototype.getAppManager = function () {
	    return this.refs.appManager;
	};
	
	OrganisationUnit.prototype.getUpperLevels = function () {
	    return this.getAncestors();
	};
	
	// dep 1
	
	OrganisationUnit.prototype.getAncestorsRequest = function (shouldRun) {
	    var Request = this.refs.api.Request;
	
	
	    var request = new Request(refs, {
	        baseUrl: this.getAppManager().getApiPath() + '/organisationUnits/' + this.id + '.json',
	        type: 'json',
	        params: ['fields=id,level,ancestors[id,level,displayName~rename(name)]', 'paging=false']
	    });
	
	    return shouldRun ? request.run() : request;
	};
	
	OrganisationUnit.prototype.getOrganisationUnitLevels = function () {
	    return this.getAppManager().organisationUnitLevels;
	};
	
	OrganisationUnit.prototype.getResponse = function () {
	    return this.getInstanceManager().getStateCurrent().getResponse();
	};
	
	OrganisationUnit.prototype.getRootAncestor = function () {
	    var sorted = this.getAncestors().slice().sort(function (a, b) {
	        return a.level > b.level;
	    });
	
	    return sorted.length ? sorted[0] : this;
	};
	
	OrganisationUnit.prototype.getParent = function () {
	    var ancestors = this.getAncestors().slice().sort(function (a, b) {
	        return a.level > b.level;
	    });
	
	    return ancestors.length ? ancestors[ancestors.length - 1] : null;
	};
	
	// dep 2
	
	OrganisationUnit.prototype.getHierarchyName = function () {
	    var _this = this;
	
	    return this.getOrganisationUnitLevels().find(function (ou) {
	        return ou.level === _this.getLevel();
	    }).name;
	};
	
	OrganisationUnit.prototype.isRoot = function () {
	    var ancestor = this.getRootAncestor();
	
	    return ancestor ? this.getLevel() === ancestor.level : false;
	};
	
	OrganisationUnit.prototype.getName = function () {
	    return this.getResponse().getNameById(this.id);
	};
	
	// dep 3
	
	OrganisationUnit.prototype.getSublevels = function () {
	    var _this2 = this;
	
	    var level = this.getLevel();
	
	    var sublevels = this.getOrganisationUnitLevels().filter(function (ou) {
	        return ou.level > level;
	    });
	
	    sublevels = sublevels.map(function (ou) {
	        return {
	            id: _this2.id,
	            name: ou.name.toLowerCase(),
	            level: ou.level
	        };
	    });
	
	    return sublevels;
	};
	
	// dep 4
	
	OrganisationUnit.prototype.getContextMenuItemsConfig = function () {
	    var _this3 = this;
	
	    // fun goes here
	    var items = [];
	
	    var sublevels = this.getSublevels();
	    var upperLevels = this.getUpperLevels();
	
	    // generate upper levels
	    if (upperLevels.length > 0) {
	        items.push({
	            isSubtitle: true,
	            style: 'padding: 5px 5px 5px 5px; font-size: 120%; font-weight:bold',
	            html: this.i18n.drill_up
	        });
	
	        upperLevels.forEach(function (ou) {
	            items.push({
	                items: [{ id: ou.id }],
	                text: 'Show <span class="name">' + ou.name + '</span>',
	                iconCls: 'ns-menu-item-float'
	            });
	        });
	    }
	
	    // generate menu item for current level
	    items.push({
	        isSubtitle: true,
	        style: 'padding: 5px 5px 5px 5px; font-size: 120%; font-weight:bold',
	        html: this.getHierarchyName()
	    });
	
	    items.push({
	        items: [{ id: this.id }],
	        text: 'Show only <span class="name">' + this.getName() + '</span>',
	        iconCls: 'ns-menu-item-float'
	    });
	
	    if (this.getParent()) {
	        items.push({
	            items: [{ id: this.getParent().id + ';LEVEL-' + this.getLevel() }],
	            text: 'Show all <span class="name">' + this.getHierarchyName() + ' units in ' + this.getParent().name + '</span>',
	            iconCls: 'ns-menu-item-float'
	        });
	    }
	
	    // generate menu items for sublevels
	    if (sublevels.length > 0) {
	        (function () {
	            var root = _this3.getRootAncestor();
	
	            items.push({
	                isSubtitle: true,
	                style: 'padding: 5px 5px 5px 5px; font-size: 120%; font-weight:bold',
	                html: _this3.i18n.drill_down
	            });
	
	            sublevels.forEach(function (ou) {
	                items.push({
	                    items: [{ id: ou.id + ';' + 'LEVEL-' + ou.level }],
	                    text: 'Show all <span class="name">' + ou.name.toLowerCase() + ' units in ' + _this3.getName() + '</span>',
	                    iconCls: 'ns-menu-item-float'
	                });
	            });
	
	            sublevels.forEach(function (ou) {
	                if (root.level !== _this3.getLevel()) {
	                    items.push({
	                        items: [{ id: root.id + ';' + 'LEVEL-' + ou.level }],
	                        text: 'Show all <span class="name">' + ou.name + ' units</span>',
	                        iconCls: 'ns-menu-item-float'
	                    });
	                }
	            });
	        })();
	    }
	
	    return items;
	};
	//# sourceMappingURL=OrganisationUnit.js.map

/***/ },
/* 118 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.Record = undefined;
	
	var _isString = __webpack_require__(3);
	
	var _isString2 = _interopRequireDefault(_isString);
	
	var _isObject = __webpack_require__(2);
	
	var _isObject2 = _interopRequireDefault(_isObject);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Record = exports.Record = undefined;
	
	exports.Record = Record = function Record(refs, config) {
	    var t = this;
	
	    config = (0, _isObject2.default)(config) ? config : {};
	
	    // constructor
	    t.id = config.id;
	    t.name = config.name;
	
	    // tmp 2.22
	    t.objectName = config.objectName;
	
	    if ((0, _isString2.default)(config.dimensionItemType)) {
	        t.dimensionItemType = config.dimensionItemType;
	    }
	};
	
	Record.prototype.log = function (text, noError) {
	    if (!noError) {
	        console.log(text, this);
	    }
	};
	
	Record.prototype.val = function (noError) {
	    if (!this || !(0, _isString2.default)(this.id)) {
	        this.log('(Record) Id is not a string', noError);
	        return null;
	    }
	
	    return this;
	};
	
	Record.prototype.setName = function (name, response) {
	    this.name = name || this.name || (this.id && response ? response.getNameById(this.id) : null);
	};
	
	Record.prototype.toPlugin = function () {
	    delete this.klass;
	};
	
	Record.prototype.toPost = function () {
	    delete this.klass;
	    delete this.name;
	    delete this.dimensionItemType;
	};
	//# sourceMappingURL=Record.js.map

/***/ },
/* 119 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.Request = undefined;
	
	var _isString = __webpack_require__(3);
	
	var _isString2 = _interopRequireDefault(_isString);
	
	var _isArray = __webpack_require__(1);
	
	var _isArray2 = _interopRequireDefault(_isArray);
	
	var _isObject = __webpack_require__(2);
	
	var _isObject2 = _interopRequireDefault(_isObject);
	
	var _isFunction = __webpack_require__(21);
	
	var _isFunction2 = _interopRequireDefault(_isFunction);
	
	var _isEmpty = __webpack_require__(30);
	
	var _isEmpty2 = _interopRequireDefault(_isEmpty);
	
	var _arrayClean = __webpack_require__(9);
	
	var _arrayClean2 = _interopRequireDefault(_arrayClean);
	
	var _arrayContains = __webpack_require__(4);
	
	var _arrayContains2 = _interopRequireDefault(_arrayContains);
	
	var _arrayFrom = __webpack_require__(5);
	
	var _arrayFrom2 = _interopRequireDefault(_arrayFrom);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Request = exports.Request = undefined;
	
	exports.Request = Request = function Request(refs, config) {
	    var t = this;
	
	    config = (0, _isObject2.default)(config) ? config : {};
	
	    // constructor
	    t.method = (0, _isString2.default)(config.method) ? config.method : 'GET';
	    t.headers = (0, _isObject2.default)(config.headers) ? config.headers : refs.appManager.defaultRequestHeaders;
	    t.dataType = (0, _isString2.default)(config.dataType) ? config.dataType : 'json';
	    t.contentType = (0, _isString2.default)(config.contentType) ? config.contentType : null;
	    t.success = (0, _isFunction2.default)(config.success) ? config.success : function () {
	        t.defaultSuccess();
	    };
	    t.error = (0, _isFunction2.default)(config.error) ? config.error : function () {
	        t.defaultError();
	    };
	    t.complete = (0, _isFunction2.default)(config.complete) ? config.complete : function () {
	        t.defaultComplete();
	    };
	
	    t.type = (0, _isString2.default)(config.type) ? config.type : 'ajax';
	    t.baseUrl = (0, _isString2.default)(config.baseUrl) ? config.baseUrl : '';
	    t.params = (0, _arrayFrom2.default)(config.params);
	    t.data = config.data ? config.data : null;
	    t.manager = config.manager || null;
	
	    t.beforeRun = (0, _isFunction2.default)(config.beforeRun) ? config.beforeRun : null;
	    t.afterRun = (0, _isFunction2.default)(config.afterRun) ? config.afterRun : null;
	
	    // defaults
	    t.defaultSuccess = function () {
	        var t = this;
	
	        if (t.manager) {
	            t.manager.ok(t);
	        }
	    };
	
	    t.defaultError = function () {};
	    t.defaultComplete = function () {};
	};
	
	Request.prototype.log = function (text, noError) {
	    if (!noError) {
	        console.log(text, this);
	    }
	};
	
	Request.prototype.alert = function (text, noError) {
	    if (!noError) {
	        alert(text);
	    }
	};
	
	Request.prototype.handle = function (statusCode, noError) {
	    var url = this.url(),
	        text;
	
	    if ((0, _arrayContains2.default)([413, 414], statusCode)) {
	        if (isIE()) {
	            text = 'Too many items selected (url has ' + url.length + ' characters). Internet Explorer accepts maximum 2048 characters.';
	        } else {
	            var len = url.length > 8000 ? '8000' : url.length > 4000 ? '4000' : '2000';
	            text = 'Too many items selected (url has ' + url.length + ' characters). Please reduce to less than ' + len + ' characters.';
	        }
	    }
	
	    if (text) {
	        text += '\n\n' + 'Hint: A good way to reduce the number of items is to use relative periods and level/group organisation unit selection modes.';
	
	        this.alert(text);
	    }
	};
	
	Request.prototype.add = function (param) {
	    var t = this;
	
	    if ((0, _isString2.default)(param)) {
	        t.params.push(param);
	    } else if ((0, _isArray2.default)(param)) {
	        param.forEach(function (item) {
	            if ((0, _isString2.default)(item)) {
	                t.params.push(item);
	            }
	        });
	    } else if ((0, _isObject2.default)(param)) {
	        for (var key in param) {
	            if (param.hasOwnProperty(key) && !(0, _isEmpty2.default)(param[key])) {
	                t.params.push(key + '=' + param[key]);
	            }
	        }
	    }
	
	    return this;
	};
	
	Request.prototype.setBaseUrl = function (baseUrl) {
	    if ((0, _isString2.default)(baseUrl)) {
	        this.baseUrl = baseUrl;
	    }
	};
	
	Request.prototype.setType = function (type) {
	    if ((0, _isString2.default)(type)) {
	        this.type = type;
	    }
	};
	
	Request.prototype.setManager = function (manager) {
	    this.manager = manager;
	};
	
	Request.prototype.setSuccess = function (fn) {
	    if ((0, _isFunction2.default)(fn)) {
	        this.success = fn;
	    }
	};
	
	Request.prototype.setError = function (fn) {
	    if ((0, _isFunction2.default)(fn)) {
	        this.error = fn;
	    }
	};
	
	Request.prototype.setBeforeRun = function (fn) {
	    if ((0, _isFunction2.default)(fn)) {
	        this.beforeRun = fn;
	    }
	};
	
	Request.prototype.setComplete = function (fn) {
	    if ((0, _isFunction2.default)(fn)) {
	        this.complete = fn;
	    }
	};
	
	Request.prototype.url = function (extraParams) {
	    var params = (0, _arrayClean2.default)([].concat(this.params, (0, _arrayFrom2.default)(extraParams)));
	
	    return this.baseUrl + (params.length ? '?' + params.join('&') : '');
	};
	
	// dep 1
	
	Request.prototype.run = function (config) {
	    var t = this,
	        url = encodeURI(this.url());
	
	    config = (0, _isObject2.default)(config) ? config : {};
	
	    var success = config.success || t.success,
	        error = config.error || t.error,
	        complete = config.complete || t.complete;
	
	    var completeFn = function completeFn() {
	        if ((0, _isFunction2.default)(t.afterRun)) {
	            t.afterRun();
	        }
	
	        complete();
	    };
	
	    if (t.beforeRun && t.beforeRun() === false) {
	        return;
	    }
	
	    if (t.type === 'json') {
	        return $.getJSON(url, success).error(error).complete(complete);
	    } else {
	        var method = config.method || t.method,
	            headers = config.headers || t.headers,
	            dataType = config.dataType || t.dataType,
	            contentType = config.contentType || t.contentType,
	            data = config.data || t.data,
	            xhr = {};
	
	        xhr.url = url;
	        xhr.method = method;
	        xhr.type = method;
	        xhr.data = data;
	        headers && (xhr.headers = headers);
	        dataType && (xhr.dataType = dataType);
	        contentType && (xhr.contentType = contentType);
	        xhr.success = success;
	        xhr.error = error;
	        xhr.complete = completeFn;
	
	        return $.ajax(xhr);
	    }
	};
	//# sourceMappingURL=Request.js.map

/***/ },
/* 120 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.Response = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _arrayClean = __webpack_require__(9);
	
	var _arrayClean2 = _interopRequireDefault(_arrayClean);
	
	var _arrayContains = __webpack_require__(4);
	
	var _arrayContains2 = _interopRequireDefault(_arrayContains);
	
	var _arrayFrom = __webpack_require__(5);
	
	var _arrayFrom2 = _interopRequireDefault(_arrayFrom);
	
	var _arrayInsert = __webpack_require__(183);
	
	var _arrayInsert2 = _interopRequireDefault(_arrayInsert);
	
	var _arraySort = __webpack_require__(10);
	
	var _arraySort2 = _interopRequireDefault(_arraySort);
	
	var _arrayUnique = __webpack_require__(14);
	
	var _arrayUnique2 = _interopRequireDefault(_arrayUnique);
	
	var _objectApplyIf = __webpack_require__(69);
	
	var _objectApplyIf2 = _interopRequireDefault(_objectApplyIf);
	
	var _clone = __webpack_require__(29);
	
	var _clone2 = _interopRequireDefault(_clone);
	
	var _isBoolean = __webpack_require__(15);
	
	var _isBoolean2 = _interopRequireDefault(_isBoolean);
	
	var _isDefined = __webpack_require__(67);
	
	var _isDefined2 = _interopRequireDefault(_isDefined);
	
	var _isEmpty = __webpack_require__(30);
	
	var _isEmpty2 = _interopRequireDefault(_isEmpty);
	
	var _isNumber = __webpack_require__(7);
	
	var _isNumber2 = _interopRequireDefault(_isNumber);
	
	var _isNumeric = __webpack_require__(22);
	
	var _isNumeric2 = _interopRequireDefault(_isNumeric);
	
	var _isObject = __webpack_require__(2);
	
	var _isObject2 = _interopRequireDefault(_isObject);
	
	var _isString = __webpack_require__(3);
	
	var _isString2 = _interopRequireDefault(_isString);
	
	var _getParseMiddleware = __webpack_require__(175);
	
	var _getParseMiddleware2 = _interopRequireDefault(_getParseMiddleware);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var Response = exports.Response = function Response(refs, config) {
	    var t = this;
	
	    config = (0, _isObject2.default)(config) ? config : {};
	
	    var appManager = refs.appManager,
	        indexedDbManager = refs.indexedDbManager,
	        i18nManager = refs.i18nManager;
	    var _refs$api = refs.api,
	        ResponseHeader = _refs$api.ResponseHeader,
	        ResponseRow = _refs$api.ResponseRow;
	
	
	    var i18n = i18nManager.get();
	
	    var booleanMap = {
	        '0': i18n.no || 'No',
	        '1': i18n.yes || 'Yes'
	    };
	
	    var OUNAME = 'ouname',
	        OU = 'ou';
	
	    var DEFAULT_COLLECT_IGNORE_HEADERS = ['psi', 'ps', 'eventdate', 'longitude', 'latitude', 'ouname', 'oucode', 'eventdate', 'eventdate'];
	
	    var DEFAULT_PREFIX_IGNORE_HEADERS = ['dy'].concat(DEFAULT_COLLECT_IGNORE_HEADERS);
	
	    //DIMENSIONS      ITEMS    -> COLLECT         PREFIX
	
	    //- required                        V               V           no             no
	
	    //- legendSet                       V               V           no             no
	    //- !dimensions                     x               x           yes            yes
	
	    //- optionset, !dimensions          x               x           yes            yes
	    //- optionset                       V               x           no             yes
	
	    // functions
	    var isPrefixHeader = function isPrefixHeader(header, dimensions) {
	        if ((0, _arrayContains2.default)(DEFAULT_PREFIX_IGNORE_HEADERS, header.name)) {
	            return false;
	        }
	
	        return (0, _isEmpty2.default)(dimensions);
	    };
	
	    var isCollectHeader = function isCollectHeader(header, dimensions) {
	        if ((0, _arrayContains2.default)(DEFAULT_COLLECT_IGNORE_HEADERS, header.name)) {
	            return false;
	        }
	
	        return (0, _isEmpty2.default)(dimensions);
	    };
	
	    var getHeader = function getHeader(name) {
	        return t.headers.find(function (header) {
	            return header.name === name;
	        });
	    };
	    var hasHeader = function hasHeader(name) {
	        return getHeader(name) !== undefined;
	    };
	
	    t.getPrefixedId = function (id, prefix) {
	        return (prefix || '') + '_' + id;
	    };
	
	    t.getSortedUniqueRowIdStringsByHeader = function (header) {
	        var parseByType = (0, _getParseMiddleware2.default)(header.valueType);
	        var parseString = (0, _getParseMiddleware2.default)('STRING');
	
	        return (0, _arraySort2.default)((0, _arrayClean2.default)((0, _arrayUnique2.default)(t.rows.map(function (responseRow) {
	            return parseByType(responseRow.getAt(header.index));
	        })))).map(function (id) {
	            return parseString(id);
	        });
	    };
	
	    t.getNameByIdsByValueType = function (id, valueType) {
	        if (valueType === 'BOOLEAN') {
	            return booleanMap[id];
	        }
	
	        return id;
	    };
	
	    t.optionCodeIdMap = function () {
	        var dimensions = config.metaData.dimensions;
	        var items = config.metaData.items;
	        var map = {};
	
	        config.headers.filter(function (header) {
	            return (0, _isString2.default)(header.optionSet);
	        }).forEach(function (header) {
	            var optionIds = dimensions[header.name];
	
	            var mapByDimension = optionIds.map(function (id) {
	                return _defineProperty({}, items[id].code, id);
	            }).reduce(function (map, obj) {
	                return _extends(map, obj);
	            }, {});
	
	            map[header.name] = mapByDimension;
	        });
	
	        return map;
	    }();
	
	    // headers
	    t.headers = (config.headers || []).map(function (header, index) {
	        var dimensions = config.metaData.dimensions;
	
	        var prefixConfig = isPrefixHeader(header, dimensions[header.name]) ? { isPrefix: true } : {};
	        var collectConfig = isCollectHeader(header, dimensions[header.name]) ? { isCollect: true } : {};
	
	        return new ResponseHeader(refs, header, _extends({}, prefixConfig, collectConfig, { index: index }));
	    });
	
	    // rows
	    t.rows = function () {
	        var headersWithOptionSet = t.headers.filter(function (header) {
	            return header.optionSet;
	        });
	        var rows = config.rows;
	
	        if (headersWithOptionSet.length) {
	            rows = rows.slice();
	
	            // replace option code with option uid
	            headersWithOptionSet.forEach(function (header) {
	                rows.forEach(function (row) {
	                    var id = t.optionCodeIdMap[header.name][row[header.index]];
	
	                    if (id) {
	                        row[header.index] = id;
	                    }
	                });
	            });
	        }
	        // map to ResponseRow
	        return rows.map(function (row) {
	            return ResponseRow(refs, row);
	        });
	    }();
	
	    // metadata
	    t.metaData = function () {
	        var metaData = _extends({}, config.metaData);
	
	        var dimensions = metaData.dimensions,
	            items = metaData.items;
	
	        // populate metaData dimensions and items
	        t.headers.filter(function (header) {
	            return !(0, _arrayContains2.default)(DEFAULT_COLLECT_IGNORE_HEADERS, header.name);
	        }).forEach(function (header) {
	            var ids;
	
	            // collect row values
	            if (header.isCollect) {
	                ids = t.getSortedUniqueRowIdStringsByHeader(header);
	                dimensions[header.name] = ids;
	            } else {
	                ids = dimensions[header.name];
	            }
	
	            if (header.isPrefix) {
	
	                // create prefixed dimensions array
	                dimensions[header.name] = ids.map(function (id) {
	                    return t.getPrefixedId(id, header.name);
	                });
	
	                // create items
	                if (header.optionSet) {
	                    dimensions[header.name].forEach(function (prefixedId, index) {
	                        var id = ids[index];
	                        var optionSet = header.optionSet;
	
	                        var name = indexedDbManager.getCachedOptionName(id, optionSet);
	
	                        items[prefixedId] = { name: metaData.items[name] ? metaData.items[name].name : name };
	                    });
	                } else {
	                    dimensions[header.name].forEach(function (prefixedId, index) {
	                        var id = ids[index];
	                        var valueType = header.valueType;
	
	                        var name = t.getNameByIdsByValueType(id, valueType);
	
	                        items[prefixedId] = { name: name };
	                    });
	                }
	            }
	        });
	
	        // for events, add items from 'ouname'
	        if (hasHeader(OUNAME) && hasHeader(OU)) {
	            var ounameHeaderIndex = getHeader(OUNAME).getIndex();
	            var ouHeaderIndex = getHeader(OU).getIndex();
	
	            for (var i = 0, row, ouId, ouName, item; i < t.rows.length; i++) {
	                row = t.rows[i];
	                ouId = row.getAt(ouHeaderIndex);
	
	                if (items[ouId] !== undefined) {
	                    continue;
	                }
	
	                ouName = row.getAt(ounameHeaderIndex);
	
	                items[ouId] = {
	                    name: ouName
	                };
	            }
	        }
	
	        return metaData;
	    }();
	
	    // transient
	    t.nameHeaderMap = function () {
	        var map = {};
	
	        t.headers.forEach(function (header) {
	            map[header.name] = header;
	        });
	
	        return map;
	    }();
	
	    // uninitialized
	    t.idValueMap;
	    t.sortedRows;
	
	    t.getRefs = function () {
	        return refs;
	    };
	};
	
	Response.prototype.sortOrganisationUnitsHierarchy = function () {
	    var _this = this;
	
	    var organisationUnits = this.metaData.dimensions.ou;
	
	    var _loop = function _loop(i) {
	        var organisationUnit = organisationUnits[i],
	            hierarchyPrefix = _this.metaData.ouHierarchy[organisationUnit],
	            hierarchyIds = [organisationUnit],
	            hierarchyNames = [];
	
	        hierarchyPrefix.split('/').reverse().forEach(function (ouId) {
	            hierarchyIds.unshift(ouId);
	        });
	
	        hierarchyIds.map(function (ouId) {
	            if (_this.metaData.items[ouId]) {
	                hierarchyNames.push(_this.metaData.items[ouId].name);
	            }
	        });
	
	        organisationUnits[i] = {
	            id: organisationUnit,
	            fullName: hierarchyNames.join(' / ')
	        };
	    };
	
	    for (var i = 0; i < organisationUnits.length; ++i) {
	        _loop(i);
	    }
	
	    (0, _arraySort2.default)(organisationUnits, null, 'fullName');
	
	    this.metaData.dimensions.ou = organisationUnits.map(function (ou) {
	        return ou.id;
	    });
	};
	
	Response.prototype.clone = function () {
	    var refs = this.getRefs();
	
	    var Response = refs.api.Response;
	
	
	    return new Response(refs, this);
	};
	
	Response.prototype.getHeaderByName = function (name) {
	    return this.nameHeaderMap[name];
	};
	
	Response.prototype.getHeaderByIndex = function (index) {
	    return this.headers[index];
	};
	
	Response.prototype.getHeaderIndexByName = function (name) {
	    var header = this.nameHeaderMap[name] || {};
	
	    return header.index;
	};
	
	Response.prototype.getOptionSetHeaders = function () {
	    return t.headers.filter(function (header) {
	        return (0, _isString2.default)(header.optionSet) || isArray(header.optionSet);
	    });
	};
	
	Response.prototype.getNameById = function (id) {
	    return (this.metaData.items[id] || {}).name || id;
	};
	
	Response.prototype.getHierarchyNameById = function (id, isHierarchy, isHtml) {
	    var metaData = this.metaData,
	        name = '';
	
	    var items = metaData.items;
	
	    if (isHierarchy && metaData.ouHierarchy.hasOwnProperty(id)) {
	        var a = (0, _arrayClean2.default)(metaData.ouHierarchy[id].split('/'));
	
	        a.forEach(function (id) {
	            name += (isHtml ? '<span class="text-weak">' : '') + items[id].name + (isHtml ? '</span>' : '') + ' / ';
	        });
	    }
	
	    return name;
	};
	
	Response.prototype.getIdsByDimensionName = function (dimensionName) {
	    return this.metaData.dimensions ? this.metaData.dimensions[dimensionName] || [] : [];
	};
	
	Response.prototype.addMetaDataItems = function (items) {
	    this.metaData.items = _extends(this.metaData.items, items);
	};
	
	Response.prototype.addOuHierarchyDimensions = function () {
	    var t = this;
	
	    var headers = t.headers,
	        ouHierarchy = t.metaData.ouHierarchy,
	        rows = t.rows,
	        ouIndex,
	        numLevels = 0,
	        initArray = [],
	        newHeaders = [],
	        ou = 'ou',
	        a;
	
	    if (!ouHierarchy) {
	        return;
	    }
	
	    // get ou index
	    for (var i = 0, header; i < headers.length; i++) {
	        if (headers[i].name === ou) {
	            ouIndex = i;
	            break;
	        }
	    }
	
	    // get numLevels
	    for (var i = 0; i < rows.length; i++) {
	        numLevels = Math.max(numLevels, (0, _arrayClean2.default)(ouHierarchy[rows[i][ouIndex]].split('/')).length);
	    }
	
	    // init array
	    for (var i = 0; i < numLevels; i++) {
	        initArray.push('');
	    }
	
	    // extend rows
	    for (var i = 0, row, ouArray; i < rows.length; i++) {
	        row = rows[i];
	        ouArray = (0, _objectApplyIf2.default)((0, _arrayClean2.default)(ouHierarchy[row[ouIndex]].split('/')), (0, _clone2.default)(initArray));
	
	        (0, _arrayInsert2.default)(row, ouIndex, ouArray);
	    }
	
	    // create new headers
	    for (var i = 0; i < numLevels; i++) {
	        newHeaders.push({
	            column: 'Organisation unit',
	            hidden: false,
	            meta: true,
	            name: 'ou',
	            type: 'java.lang.String'
	        });
	    }
	
	    (0, _arrayInsert2.default)(headers, ouIndex, newHeaders);
	
	    return t;
	};
	
	Response.prototype.printResponseCSV = function () {
	    var t = this;
	
	    var headers = t.headers,
	        items = t.metaData.items,
	        rows = t.rows,
	        csv = '',
	        alink;
	
	    // headers
	    for (var i = 0; i < headers.length; i++) {
	        csv += '"' + headers[i].column + '"' + (i < headers.length - 1 ? ',' : '\n');
	    }
	
	    // rows
	    for (var i = 0; i < rows.length; i++) {
	        for (var j = 0, val, isMeta; j < rows[i].length; j++) {
	            val = rows[i][j];
	            isMeta = headers[j].meta;
	
	            csv += '"' + (isMeta && items[val] && (0, _isString2.default)(items[val].name) ? items[val].name : val) + '"';
	            csv += j < rows[i].length - 1 ? ',' : '\n';
	        }
	    }
	
	    alink = document.createElement('a');
	    alink.setAttribute('href', 'data:text/csv;charset=utf-8,' + encodeURIComponent(csv));
	    alink.setAttribute('download', 'data.csv');
	    alink.click();
	};
	
	Response.prototype.getFilteredHeaders = function (names) {
	    return this.headers.filter(function (header) {
	        return (0, _arrayContains2.default)(names, header.name);
	    });
	};
	
	Response.prototype.getOrganisationUnitsIds = function () {
	    return this.metaData.dimensions.ou;
	};
	
	// dep 1
	Response.prototype.getHeaderNameByIndex = function (index) {
	    return this.getHeaderByIndex(index).name;
	};
	
	Response.prototype.getHeaderIndexOrder = function (dimensionNames) {
	    var _this2 = this;
	
	    return dimensionNames.map(function (name) {
	        return _this2.getHeaderIndexByName(name);
	    });
	};
	
	Response.prototype.getIdsByDimensionNames = function (dimensionName) {
	    var _this3 = this;
	
	    return (0, _arrayClean2.default)(dimensionName.reduce(function (ids, name) {
	        return ids.concat(_this3.getIdsByDimensionName(name) || []);
	    }, []));
	};
	
	Response.prototype.getItemName = function (id, isHierarchy, isHtml) {
	    return this.getHierarchyNameById(id, isHierarchy) + this.getNameById(id);
	};
	
	Response.prototype.getRecordsByDimensionName = function (dimensionName) {
	    var _this4 = this;
	
	    var refs = this.getRefs(),
	        Record = refs.api.Record;
	
	
	    var ids = this.getIdsByDimensionName(dimensionName) || [],
	        records = ids.map(function (id) {
	        return new Record(refs, { id: id, name: _this4.getNameById(id) }).val();
	    });
	
	    return (0, _arrayClean2.default)(records);
	};
	
	Response.prototype.getValueHeader = function () {
	    return this.getHeaderByName('value');
	};
	
	Response.prototype.getNumeratorHeader = function () {
	    return this.getHeaderByName('numerator');
	};
	
	Response.prototype.getDenominatorHeader = function () {
	    return this.getHeaderByName('denominator');
	};
	
	Response.prototype.getFactorHeader = function () {
	    return this.getHeaderByName('factor');
	};
	
	Response.prototype.hasIdByDimensionName = function (id, dimensionName) {
	    return (0, _arrayContains2.default)(this.getIdsByDimensionName(dimensionName), id);
	};
	
	// dep 2
	Response.prototype.getValueHeaderIndex = function () {
	    return this.getValueHeader() ? this.getValueHeader().getIndex() : null;
	};
	
	Response.prototype.getNumeratorHeaderIndex = function () {
	    return this.getNumeratorHeader() ? this.getNumeratorHeader().getIndex() : null;
	};
	
	Response.prototype.getDenominatorHeaderIndex = function () {
	    return this.getDenominatorHeader() ? this.getDenominatorHeader().getIndex() : null;
	};
	
	Response.prototype.getFactorHeaderIndex = function () {
	    return this.getFactorHeader() ? this.getFactorHeader().getIndex() : null;
	};
	
	// dep 3
	Response.prototype.getSortedRows = function () {
	    if (this.sortedRows) {
	        return this.sortedRows;
	    }
	
	    var valueHeaderIndex = this.getValueHeaderIndex();
	
	    // filter
	    var rows = this.rows.filter(function (row) {
	        return (0, _isNumeric2.default)(row[valueHeaderIndex]);
	    });
	
	    // parse
	    rows.forEach(function (row) {
	        return row.toFloat(valueHeaderIndex);
	    });
	
	    // sort
	    (0, _arraySort2.default)(rows, 'DESC', valueHeaderIndex);
	
	    return this.sortedRows = rows;
	};
	
	Response.prototype.getIdValueMap = function (layout) {
	    return this.idValueMap = this.getIdMap(layout, 'value');
	};
	
	Response.prototype.getIdDenominatorMap = function (layout) {
	    return this.idDenominatorMap = this.getIdMap(layout, 'denominator');
	};
	
	Response.prototype.getIdNumeratorMap = function (layout) {
	    return this.idNumeratorMap = this.getIdMap(layout, 'numerator');
	};
	
	Response.prototype.getIdFactorMap = function (layout) {
	    return this.idFactorMap = this.getIdMap(layout, 'factor');
	};
	
	Response.prototype.getIdMap = function (layout, name) {
	    var _this5 = this;
	
	    var refs = this.getRefs(),
	        ResponseRowIdCombination = refs.api.ResponseRowIdCombination,
	        headerIndexOrder = (0, _arrayClean2.default)(this.getHeaderIndexOrder(layout.getDimensionNames())),
	        idMap = {};
	
	
	    this.rows.forEach(function (responseRow) {
	        var idCombination = new ResponseRowIdCombination(refs),
	            key = void 0,
	            rowValue = void 0,
	            header = void 0;
	
	        headerIndexOrder.forEach(function (index) {
	            header = _this5.getHeaderByIndex(index);
	            rowValue = responseRow.getAt(index);
	            key = header.isPrefix ? _this5.getPrefixedId(rowValue, header.name) : rowValue;
	
	            idCombination.add(key);
	        });
	
	        responseRow.setIdCombination(idCombination);
	        idMap[idCombination.get()] = responseRow.getAt(_this5.getHeaderByName(name).getIndex());
	    });
	
	    return idMap;
	};
	
	// dep 4
	Response.prototype.getValue = function (param, layout) {
	    var _getRefs = this.getRefs(),
	        ResponseRowIdCombination = _getRefs.refs.api,
	        id = param instanceof ResponseRowIdCombination ? param.get() : param;
	
	    return this.getIdValueMap(layout)[id];
	};
	
	Response.prototype.getExtremalRows = function (limit, isTop, isBottom) {
	    limit = (0, _isNumeric2.default)(limit) ? parseInt(limit) : 10;
	    isTop = (0, _isBoolean2.default)(isTop) ? isTop : true;
	    isBottom = (0, _isBoolean2.default)(isBottom) ? isBottom : true;
	
	    var sortedRows = this.getSortedRows(),
	        len = sortedRows.length;
	
	    return [].concat(_toConsumableArray(isTop ? sortedRows.slice(0, limit) : []), _toConsumableArray(isBottom ? sortedRows.slice(len - limit, len) : []));
	};
	
	// dep 5
	Response.prototype.getValues = function (paramArray, layout) {
	    var _this6 = this;
	
	    return (0, _arrayFrom2.default)(paramArray).map(function (param) {
	        return _this6.getValue(param, layout);
	    });
	};
	//# sourceMappingURL=Response.js.map

/***/ },
/* 121 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.ResponseHeader = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _isObject = __webpack_require__(2);
	
	var _isObject2 = _interopRequireDefault(_isObject);
	
	var _isNumeric = __webpack_require__(22);
	
	var _isNumeric2 = _interopRequireDefault(_isNumeric);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ResponseHeader = exports.ResponseHeader = undefined;
	
	exports.ResponseHeader = ResponseHeader = function ResponseHeader(refs, config, extraConfig) {
	    var t = this;
	
	    t.isPrefix = false;
	    t.isCollect = false;
	    t.index;
	
	    config = (0, _isObject2.default)(config) ? config : {};
	
	    // constructor
	    _extends(t, config, extraConfig);
	};
	
	ResponseHeader.prototype.setIndex = function (index) {
	    if ((0, _isNumeric2.default)(index)) {
	        this.index = parseInt(index);
	    }
	};
	
	ResponseHeader.prototype.getIndex = function (index) {
	    return this.index;
	};
	//# sourceMappingURL=ResponseHeader.js.map

/***/ },
/* 122 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.ResponseRow = undefined;
	
	var _arrayFrom = __webpack_require__(5);
	
	var _arrayFrom2 = _interopRequireDefault(_arrayFrom);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ResponseRow = exports.ResponseRow = undefined;
	
	exports.ResponseRow = ResponseRow = function ResponseRow(refs, config) {
	    var t = (0, _arrayFrom2.default)(config);
	
	    t.getAt = function (index) {
	        return this[index];
	    };
	
	    t.setIdCombination = function (idCombination) {
	        t.idCombination = idCombination;
	    };
	
	    t.getNames = function (response, ignoreIndexes) {
	        if (!t.idCombination) {
	            t.setIdCombination(new refs.api.ResponseRowIdCombination(refs, t));
	        }
	
	        return t.idCombination.getNames(response, ignoreIndexes);
	    };
	
	    t.toFloat = function (index) {
	        t[index] = parseFloat(t[index]);
	    };
	
	    t.getRowHtml = function (response, trClass, tdClass, ignoreIndexes) {
	        trClass = trClass ? ' class="' + trClass + '"' : '';
	        tdClass = tdClass ? ' class="' + tdClass + '"' : '';
	
	        var tdStyle = ' style="padding:0 5px"';
	
	        return '<tr' + trClass + '>' + t.getNames(response, ignoreIndexes).map(function (name) {
	            return '<td' + tdClass + tdStyle + '>' + name + '</td>';
	        }).join('') + '</tr>';
	    };
	
	    // uninitialized
	    t.idCombination;
	
	    return t;
	};
	//# sourceMappingURL=ResponseRow.js.map

/***/ },
/* 123 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var Sorting = exports.Sorting = undefined;
	
	exports.Sorting = Sorting = function Sorting(refs, config) {
	    var t = this;
	
	    t.id = config.id || null;
	    t.direction = config.direction || null;
	    t.emptyFirst = config.emptyFirst || false;
	
	    var _keyMap = {
	        'asc': 'DESC',
	        'desc': 'ASC'
	    };
	
	    t.getKeyMap = function () {
	        return _keyMap;
	    };
	};
	
	Sorting.prototype.toggleDirection = function () {
	    this.direction = this.getKeyMap()[(this.direction || '').toLowerCase()];
	};
	//# sourceMappingURL=Sorting.js.map

/***/ },
/* 124 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var ChartConfig = exports.ChartConfig = undefined;
	
	exports.ChartConfig = ChartConfig = function ChartConfig() {
	    var t = this;
	
	    t.client = {
	        series: 'series',
	        category: 'category',
	        filter: 'filter',
	        column: 'column',
	        stackedcolumn: 'stackedcolumn',
	        bar: 'bar',
	        stackedbar: 'stackedbar',
	        line: 'line',
	        area: 'area',
	        pie: 'pie',
	        radar: 'radar',
	        gauge: 'gauge'
	    };
	
	    t.server = {
	        column: 'COLUMN',
	        stackedcolumn: 'STACKED_COLUMN',
	        bar: 'BAR',
	        stackedbar: 'STACKED_BAR',
	        line: 'LINE',
	        area: 'AREA',
	        pie: 'PIE',
	        radar: 'RADAR',
	        gauge: 'GAUGE'
	    };
	
	    t.consts = {
	        domain: 'domain_',
	        targetLine: 'targetline_',
	        baseLine: 'baseline_',
	        trendLine: 'trendline_'
	    };
	
	    t.style = {
	        inset: 30,
	        fontFamily: 'Arial,Sans-serif,Roboto,Helvetica,Consolas'
	    };
	
	    t.theme = {
	        dv1: ['#94ae0a', '#1d5991', '#a61120', '#ff8809', '#7c7474', '#a61187', '#ffd13e', '#24ad9a', '#a66111', '#414141', '#4500c4', '#1d5700']
	    };
	
	    // transient
	
	    t.c2s = {};
	    t.s2c = {};
	
	    // initialize
	    (function () {
	        Object.keys(t.client).forEach(function (key) {
	            t.c2s[t.client[key]] = t.server[key];
	        });
	
	        Object.keys(t.server).forEach(function (key) {
	            t.s2c[t.server[key]] = t.client[key];
	        });
	    })();
	};
	//# sourceMappingURL=ChartConfig.js.map

/***/ },
/* 125 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.DimensionConfig = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _arrayFrom = __webpack_require__(5);
	
	var _arrayFrom2 = _interopRequireDefault(_arrayFrom);
	
	var _arrayTo = __webpack_require__(6);
	
	var _arrayTo2 = _interopRequireDefault(_arrayTo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DimensionConfig = exports.DimensionConfig = undefined;
	
	exports.DimensionConfig = DimensionConfig = function DimensionConfig() {
	    var t = this;
	
	    // service
	    var i18nManager;
	
	    // uninitialized
	    var dimensions = {};
	
	    // dimension name map
	    var dimensionNameDimensionMap = {
	        'dx': 'data',
	        'co': 'category',
	        'pe': 'period',
	        'ou': 'organisationUnit'
	    };
	
	    var defaultDataType = 'aggregated_values';
	
	    // data type
	    t.dataType = {
	        'aggregated_values': 'AGGREGATED_VALUES',
	        'individual_cases': 'EVENTS'
	    };
	
	    t.dataTypeUrl = {
	        'AGGREGATED_VALUES': '/events/aggregate',
	        'EVENTS': '/events/query'
	    };
	
	    // value type
	    t.valueType = {
	        'numeric_types': ['NUMBER', 'UNIT_INTERVAL', 'PERCENTAGE', 'INTEGER', 'INTEGER_POSITIVE', 'INTEGER_NEGATIVE', 'INTEGER_ZERO_OR_POSITIVE'],
	        'text_types': ['TEXT', 'LONG_TEXT', 'LETTER', 'PHONE_NUMBER', 'EMAIL'],
	        'boolean_types': ['BOOLEAN', 'TRUE_ONLY'],
	        'date_types': ['DATE', 'DATETIME'],
	        'aggregate_aggregatable_types': ['BOOLEAN', 'TRUE_ONLY', 'TEXT', 'LONG_TEXT', 'LETTER', 'INTEGER', 'INTEGER_POSITIVE', 'INTEGER_NEGATIVE', 'INTEGER_ZERO_OR_POSITIVE', 'NUMBER', 'UNIT_INTERVAL', 'PERCENTAGE', 'COORDINATE'],
	        'tracker_aggregatable_types': ['NUMBER', 'UNIT_INTERVAL', 'PERCENTAGE', 'INTEGER', 'INTEGER_POSITIVE', 'INTEGER_NEGATIVE', 'INTEGER_ZERO_OR_POSITIVE', 'BOOLEAN', 'TRUE_ONLY']
	    };
	
	    // setter
	    var setDimensions = function setDimensions() {
	        dimensions = _extends(dimensions, {
	            data: {
	                value: 'data',
	                name: i18nManager.get('data') || 'Data',
	                id: 'dx',
	                dimensionName: 'dx',
	                objectName: 'dx'
	            },
	            category: {
	                name: i18nManager.get('assigned_categories') || 'Assigned categories',
	                id: 'co',
	                dimensionName: 'co',
	                objectName: 'co'
	            },
	            indicator: {
	                value: 'indicator',
	                name: i18nManager.get('indicators') || 'Indicators',
	                dimensionName: 'dx',
	                objectName: 'in'
	            },
	            dataElement: {
	                value: 'dataElement',
	                name: i18nManager.get('data_elements') || 'Data elements',
	                dimensionName: 'dx',
	                objectName: 'de'
	            },
	            operand: {
	                value: 'operand',
	                name: i18nManager.get('operand') || 'Operand',
	                dimensionName: 'dx',
	                objectName: 'dc'
	            },
	            dataSet: {
	                value: 'dataSet',
	                name: i18nManager.get('data_sets') || 'Data sets',
	                dimensionName: 'dx',
	                objectName: 'ds'
	            },
	            eventDataItem: {
	                value: 'eventDataItem',
	                name: i18nManager.get('event_data_items') || 'Event data items',
	                dimensionName: 'dx',
	                objectName: 'di'
	            },
	            programIndicator: {
	                value: 'programIndicator',
	                name: i18nManager.get('program_indicators') || 'Program indicators',
	                dimensionName: 'dx',
	                objectName: 'pi'
	            },
	            period: {
	                value: 'period',
	                name: i18nManager.get('periods') || 'Periods',
	                id: 'pe',
	                dimensionName: 'pe',
	                objectName: 'pe'
	            },
	            fixedPeriod: {
	                value: 'period'
	            },
	            relativePeriod: {
	                value: 'relativePeriod'
	            },
	            startEndDate: {
	                value: 'dates',
	                name: i18nManager.get('start_end_dates')
	            },
	            organisationUnit: {
	                value: 'organisationUnit',
	                name: i18nManager.get('i18n.organisation_units') || 'Organisation units',
	                id: 'ou',
	                dimensionName: 'ou',
	                objectName: 'ou'
	            },
	            dimension: {
	                value: 'dimension'
	                //objectName: 'di'
	            },
	            value: {
	                value: 'value'
	            }
	        });
	    };
	
	    // init
	    t.init = function () {
	        setDimensions();
	    };
	
	    // prototype
	    t.add = function (param) {
	        (0, _arrayFrom2.default)(param).forEach(function (dimension) {
	            dimension.dimensionName = dimension.dimensionName || dimension.id;
	            dimension.objectName = dimension.objectName || dimension.id;
	
	            dimensions[dimension.id] = dimension;
	        });
	    };
	
	    t.get = function (name) {
	        var map = dimensionNameDimensionMap;
	
	        return name ? dimensions[name] || dimensions[map[name]] : dimensions;
	    };
	
	    t.getDimensionNameMap = function () {
	        var map = {};
	
	        for (var name in dimensions) {
	            if (dimensions.hasOwnProperty(name)) {
	                map[dimensions[name].dimensionName] = dimensions[name];
	            }
	        }
	
	        return map;
	    };
	
	    t.getObjectNameMap = function () {
	        var map = {};
	
	        for (var name in dimensions) {
	            if (dimensions.hasOwnProperty(name)) {
	                map[dimensions[name].objectName] = dimensions[name];
	            }
	        }
	
	        return map;
	    };
	
	    t.getDefaultDataType = function () {
	        return t.dataType[defaultDataType];
	    };
	
	    t.setI18nManager = function (manager) {
	        i18nManager = manager;
	    };
	};
	
	DimensionConfig.prototype.applyTo = function (modules) {
	    var t = this;
	
	    (0, _arrayTo2.default)(modules).forEach(function (module) {
	        module.dimensionConfig = t;
	    });
	};
	//# sourceMappingURL=DimensionConfig.js.map

/***/ },
/* 126 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.OptionConfig = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _arrayTo = __webpack_require__(6);
	
	var _arrayTo2 = _interopRequireDefault(_arrayTo);
	
	var _arraySort = __webpack_require__(10);
	
	var _arraySort2 = _interopRequireDefault(_arraySort);
	
	var _stringReplaceAll = __webpack_require__(70);
	
	var _stringReplaceAll2 = _interopRequireDefault(_stringReplaceAll);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var OptionConfig = exports.OptionConfig = undefined;
	
	exports.OptionConfig = OptionConfig = function OptionConfig() {
	    var t = this;
	
	    // service
	    var i18nManager;
	
	    // uninitialized
	    var displayDensity;
	    var fontSize;
	    var digitGroupSeparator;
	    var aggregationType;
	    var numberType;
	    var outputType;
	    var dataApprovalLevel;
	    var dataSetMetric;
	    var legendDisplayStyle;
	    var legendDisplayStrategy;
	    var programStatus;
	    var eventStatus;
	
	    // setter
	    var setDisplayDensity = function setDisplayDensity() {
	        displayDensity = {
	            'comfortable': {
	                index: 1,
	                id: 'COMFORTABLE',
	                name: i18nManager.get('comfortable') || 'Comfortable'
	            },
	            'normal': {
	                index: 2,
	                id: 'NORMAL',
	                name: i18nManager.get('normal') || 'Normal'
	            },
	            'compact': {
	                index: 3,
	                id: 'COMPACT',
	                name: i18nManager.get('compact') || 'Compact'
	            }
	        };
	    };
	
	    var setFontSize = function setFontSize() {
	        fontSize = {
	            'large': {
	                index: 1,
	                id: 'LARGE',
	                name: i18nManager.get('large') || 'Large'
	            },
	            'normal': {
	                index: 2,
	                id: 'NORMAL',
	                name: i18nManager.get('normal') || 'Normal'
	            },
	            'small': {
	                index: 3,
	                id: 'SMALL',
	                name: i18nManager.get('small') || 'Small'
	            }
	        };
	    };
	
	    var setDigitGroupSeparator = function setDigitGroupSeparator() {
	        digitGroupSeparator = {
	            'none': {
	                index: 1,
	                id: 'NONE',
	                name: i18nManager.get('none') || 'None',
	                value: ''
	            },
	            'space': {
	                index: 2,
	                id: 'SPACE',
	                name: i18nManager.get('space') || 'Space',
	                value: '&nbsp;'
	            },
	            'comma': {
	                index: 3,
	                id: 'COMMA',
	                name: i18nManager.get('comma') || 'Comma',
	                value: ','
	            }
	        };
	    };
	
	    var setAggregationType = function setAggregationType() {
	        aggregationType = {
	            'def': {
	                index: 1,
	                id: 'DEFAULT',
	                name: i18nManager.get('by_data_element') || 'By data element'
	            },
	            'count': {
	                index: 2,
	                id: 'COUNT',
	                name: i18nManager.get('count') || 'Count'
	            },
	            'avg': {
	                index: 3,
	                id: 'AVERAGE',
	                name: i18nManager.get('average') || 'Average'
	            },
	            'avg-sum-org-unit': {
	                index: 3,
	                id: 'AVERAGE_SUM_ORG_UNIT',
	                name: i18nManager.get('average_sum_org_unit') || 'Average (sum in org unit hierarchy)'
	            },
	            'sum': {
	                index: 3,
	                id: 'SUM',
	                name: i18nManager.get('sum') || 'Sum'
	            },
	            'stddev': {
	                index: 4,
	                id: 'STDDEV',
	                name: i18nManager.get('stddev') || 'Standard deviation'
	            },
	            'variance': {
	                index: 5,
	                id: 'VARIANCE',
	                name: i18nManager.get('variance') || 'Variance'
	            },
	            'min': {
	                index: 6,
	                id: 'MIN',
	                name: i18nManager.get('min') || 'Min'
	            },
	            'max': {
	                index: 7,
	                id: 'MAX',
	                name: i18nManager.get('max') || 'Max'
	            },
	            'last': {
	                index: 8,
	                id: 'LAST',
	                name: i18nManager.get('last') || 'Last value'
	            },
	            'last-average-org-unit': {
	                index: 9,
	                id: 'LAST_AVERAGE_ORG_UNIT',
	                name: i18nManager.get('last_average_org_unit') || 'Last value (average in org unit hierarchy)'
	            }
	        };
	    };
	
	    var setNumberType = function setNumberType() {
	        numberType = {
	            'value': {
	                index: 1,
	                id: 'VALUE',
	                name: i18nManager.get('value') || 'Value'
	            },
	            'percentofrow': {
	                index: 2,
	                id: 'ROW_PERCENTAGE',
	                name: i18nManager.get('percent_of_row') || 'Percentage of row'
	            },
	            'percentofcolumn': {
	                index: 3,
	                id: 'COLUMN_PERCENTAGE',
	                name: i18nManager.get('percent_of_column') || 'Percentage of column'
	            }
	        };
	    };
	
	    var setOutputType = function setOutputType() {
	        outputType = {
	            'event': {
	                index: 1,
	                id: 'EVENT',
	                name: i18nManager.get('event') || 'Event'
	            },
	            'enrollment': {
	                index: 2,
	                id: 'ENROLLMENT',
	                name: i18nManager.get('enrollment') || 'Enrollment'
	            },
	            'trackedentityinstance': {
	                index: 3,
	                id: 'TRACKED_ENTITY_INSTANCE',
	                name: i18nManager.get('tracked_entity_instance') || 'Tracked entity instance'
	            }
	        };
	    };
	
	    var setDataApprovalLevel = function setDataApprovalLevel() {
	        dataApprovalLevel = {
	            'def': {
	                index: 1,
	                id: 'DEFAULT',
	                name: i18nManager.get('show_all_data') || 'Show all data'
	            }
	        };
	    };
	
	    var setDataSetMetric = function setDataSetMetric() {
	        dataSetMetric = {
	            'reportingRates': {
	                index: 1,
	                id: 'REPORTING_RATE',
	                name: i18nManager.get('reporting_rates') || 'Reporting rates'
	            },
	            'reportingRatesOnTime': {
	                index: 2,
	                id: 'REPORTING_RATE_ON_TIME',
	                name: i18nManager.get('reporting_rates_on_time') || 'Reporting rates on time'
	            },
	            'actualReports': {
	                index: 3,
	                id: 'ACTUAL_REPORTS',
	                name: i18nManager.get('actual_reports') || 'Actual reports'
	            },
	            'actualReportsOnTime': {
	                index: 4,
	                id: 'ACTUAL_REPORTS_ON_TIME',
	                name: i18nManager.get('actual_reports_on_time') || 'Actual reports on time'
	            },
	            'expectedReports': {
	                index: 5,
	                id: 'EXPECTED_REPORTS',
	                name: i18nManager.get('expected_reports') || 'Expected reports'
	            }
	        };
	    };
	
	    var setLegendDisplayStyle = function setLegendDisplayStyle() {
	        legendDisplayStyle = {
	            'fill': {
	                index: 2,
	                id: 'FILL',
	                name: i18nManager.get('background_color') || 'Background color'
	            },
	            'text': {
	                index: 3,
	                id: 'TEXT',
	                name: i18nManager.get('text_color') || 'Text color'
	            }
	        };
	    };
	
	    var setLegendDisplayStrategy = function setLegendDisplayStrategy() {
	        legendDisplayStrategy = {
	            'fixed': {
	                index: 1,
	                id: 'FIXED',
	                name: i18nManager.get('all_data_items') || 'All'
	            },
	            'by_data_item': {
	                index: 2,
	                id: 'BY_DATA_ITEM',
	                name: i18nManager.get('by_data_item') || 'By data item'
	            }
	        };
	    };
	
	    var setProgramStatus = function setProgramStatus() {
	        programStatus = {
	            'def': {
	                index: 1,
	                id: 'DEFAULT',
	                name: i18nManager.get('all') || 'All'
	            },
	            'active': {
	                index: 2,
	                id: 'ACTIVE',
	                name: i18nManager.get('active') || 'Active'
	            },
	            'completed': {
	                index: 3,
	                id: 'COMPLETED',
	                name: i18nManager.get('completed') || 'Completed'
	            },
	            'cancelled': {
	                index: 4,
	                id: 'CANCELLED',
	                name: i18nManager.get('cancelled') || 'Cancelled'
	            }
	        };
	    };
	
	    var setEventStatus = function setEventStatus() {
	        eventStatus = {
	            'def': {
	                index: 1,
	                id: 'DEFAULT',
	                name: i18nManager.get('all') || 'All'
	            },
	            'active': {
	                index: 2,
	                id: 'ACTIVE',
	                name: i18nManager.get('active') || 'Active'
	            },
	            'completed': {
	                index: 3,
	                id: 'COMPLETED',
	                name: i18nManager.get('completed') || 'Completed'
	            },
	            'scheduled': {
	                index: 4,
	                id: 'SCHEDULE',
	                name: i18nManager.get('scheduled') || 'Scheduled'
	            },
	            'overdue': {
	                index: 5,
	                id: 'OVERDUE',
	                name: i18nManager.get('overdue') || 'Overdue'
	            },
	            'skipped': {
	                index: 6,
	                id: 'SKIPPED',
	                name: i18nManager.get('skipped') || 'Skipped'
	            }
	        };
	    };
	
	    // logic
	    var getRecords = function getRecords(optionType) {
	        var records = [];
	
	        for (var option in optionType) {
	            if (optionType.hasOwnProperty(option)) {
	                records.push(optionType[option]);
	            }
	        }
	
	        (0, _arraySort2.default)(records, 'ASC', 'index');
	
	        return records;
	    };
	
	    // init
	    t.init = function () {
	        setDisplayDensity();
	        setFontSize();
	        setDigitGroupSeparator();
	        setAggregationType();
	        setNumberType();
	        setOutputType();
	        setDataApprovalLevel();
	        setDataSetMetric();
	        setLegendDisplayStyle();
	        setLegendDisplayStrategy();
	        setProgramStatus();
	        setEventStatus();
	    };
	
	    // prototype
	    t.getDisplayDensity = function (key) {
	        return key ? displayDensity[key] : displayDensity;
	    };
	
	    t.getFontSize = function (key) {
	        return key ? fontSize[key] : fontSize;
	    };
	
	    t.getDigitGroupSeparator = function (key) {
	        return key ? digitGroupSeparator[key] : digitGroupSeparator;
	    };
	
	    t.getAggregationType = function (key) {
	        return key ? aggregationType[key] : aggregationType;
	    };
	
	    t.getNumberType = function (key) {
	        return key ? numberType[key] : numberType;
	    };
	
	    t.getOutputType = function (key) {
	        return key ? outputType[key] : outputType;
	    };
	
	    t.getDataApprovalLevel = function (key) {
	        return key ? dataApprovalLevel[key] : dataApprovalLevel;
	    };
	
	    t.getDataSetMetric = function (key) {
	        return key ? dataSetMetric[key] : dataSetMetric;
	    };
	
	    t.getLegendDisplayStyle = function (key) {
	        return key ? legendDisplayStyle[key] : legendDisplayStyle;
	    };
	
	    t.getLegendDisplayStrategy = function (key) {
	        return key ? legendDisplayStrategy[key] : legendDisplayStrategy;
	    };
	
	    t.getProgramStatus = function (key) {
	        return key ? programStatus[key] : programStatus;
	    };
	
	    t.getEventStatus = function (key) {
	        return key ? eventStatus[key] : eventStatus;
	    };
	
	    t.getDisplayDensityRecords = function () {
	        return getRecords(displayDensity);
	    };
	
	    t.getFontSizeRecords = function () {
	        return getRecords(fontSize);
	    };
	
	    t.getDigitGroupSeparatorRecords = function () {
	        return getRecords(digitGroupSeparator);
	    };
	
	    t.getAggregationTypeRecords = function () {
	        return getRecords(aggregationType);
	    };
	
	    t.getNumberTypeRecords = function () {
	        return getRecords(numberType);
	    };
	
	    t.getOutputTypeRecords = function () {
	        return getRecords(outputType);
	    };
	
	    t.getDataSetMetricRecords = function () {
	        return getRecords(dataSetMetric);
	    };
	
	    t.getLegendDisplayStyleRecords = function () {
	        return getRecords(legendDisplayStyle);
	    };
	
	    t.getLegendDisplayStrategyRecords = function () {
	        return getRecords(legendDisplayStrategy);
	    };
	
	    t.getProgramStatusRecords = function () {
	        return getRecords(programStatus);
	    };
	
	    t.getEventStatusRecords = function () {
	        return getRecords(eventStatus);
	    };
	
	    t.getDigitGroupSeparatorIdMap = function () {
	        var map = {};
	
	        for (var separator in digitGroupSeparator) {
	            if (digitGroupSeparator.hasOwnProperty(separator)) {
	                map[digitGroupSeparator[separator].id] = digitGroupSeparator[separator];
	            }
	        }
	
	        return map;
	    };
	
	    t.setI18nManager = function (manager) {
	        i18nManager = manager;
	    };
	};
	
	OptionConfig.prototype.applyTo = function (modules) {
	    var t = this;
	
	    (0, _arrayTo2.default)(modules).forEach(function (module) {
	        module.optionConfig = t;
	    });
	};
	
	OptionConfig.prototype.getDigitGroupSeparatorValueById = function (id) {
	    var t = this;
	
	    var separator = t.getDigitGroupSeparatorIdMap()[id];
	
	    return separator ? separator.value : '';
	};
	
	// dep 1
	
	OptionConfig.prototype.prettyPrint = function (number, separator, noHtml) {
	    var t = this;
	
	    var spaceId = t.getDigitGroupSeparator('space').id,
	        noneId = t.getDigitGroupSeparator('none').id,
	        noneValue = t.getDigitGroupSeparator('none').value;
	
	    separator = separator || spaceId;
	
	    if (separator === noneId) {
	        return number;
	    }
	
	    var _split = ('' + number).split('.'),
	        _split2 = _slicedToArray(_split, 2),
	        num = _split2[0],
	        dec = _split2[1];
	
	    var pp = num.replace(/\B(?=(\d{3})+(?!\d))/g, t.getDigitGroupSeparatorValueById(separator) || noneValue) + (dec ? '.' + dec : '');
	
	    if (noHtml) {
	        pp = (0, _stringReplaceAll2.default)(pp, "&nbsp;", " ");
	    }
	
	    return pp;
	};
	//# sourceMappingURL=OptionConfig.js.map

/***/ },
/* 127 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.PeriodConfig = undefined;
	
	var _arrayTo = __webpack_require__(6);
	
	var _arrayTo2 = _interopRequireDefault(_arrayTo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PeriodConfig = exports.PeriodConfig = undefined;
	
	exports.PeriodConfig = PeriodConfig = function PeriodConfig() {
	    var t = this;
	
	    // service
	    var i18nManager;
	
	    // uninitialized
	    var periodTypes;
	
	    // setter
	    var setPeriodTypes = function setPeriodTypes() {
	        periodTypes = {
	            'Daily': i18nManager.get('daily') || 'Daily',
	            'Weekly': i18nManager.get('weekly') || 'Weekly',
	            'WeeklyWednesday': i18nManager.get('weekly_wednesday') || 'Weekly (Start Wednesday)',
	            'WeeklyThursday': i18nManager.get('weekly_thursday') || 'Weekly (Start Thursday)',
	            'WeeklySaturday': i18nManager.get('weekly_saturday') || 'Weekly (Start Saturday)',
	            'WeeklySunday': i18nManager.get('weekly_sunday') || 'Weekly (Start Sunday)',
	            'Monthly': i18nManager.get('monthly') || 'Monthly',
	            'BiMonthly': i18nManager.get('bimonthly') || 'BiMonthly',
	            'Quarterly': i18nManager.get('quarterly') || 'Quarterly',
	            'SixMonthly': i18nManager.get('sixmonthly') || 'SixMonthly',
	            'SixMonthlyApril': i18nManager.get('sixmonthly_april') || 'SixMonthly April',
	            'Yearly': i18nManager.get('yearly') || 'Yearly',
	            'FinancialOct': i18nManager.get('financial_oct') || 'Financial year (Start October)',
	            'FinancialJuly': i18nManager.get('financial_july') || 'Financial year (Start July)',
	            'FinancialApril': i18nManager.get('financial_april') || 'Financial year (Start April)'
	        };
	    };
	
	    // init
	    t.init = function () {
	        setPeriodTypes();
	    };
	
	    // prototype
	    t.getPeriodTypeRecords = function () {
	        var records = [];
	
	        for (var type in periodTypes) {
	            if (periodTypes.hasOwnProperty(type)) {
	                records.push({
	                    id: type,
	                    name: periodTypes[type]
	                });
	            }
	        }
	
	        return records;
	    };
	
	    t.setI18nManager = function (manager) {
	        i18nManager = manager;
	    };
	};
	
	PeriodConfig.prototype.applyTo = function (modules) {
	    var t = this;
	
	    (0, _arrayTo2.default)(modules).forEach(function (module) {
	        module.periodConfig = t;
	    });
	};
	//# sourceMappingURL=PeriodConfig.js.map

/***/ },
/* 128 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.UiConfig = undefined;
	
	var _arrayTo = __webpack_require__(6);
	
	var _arrayTo2 = _interopRequireDefault(_arrayTo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var UiConfig = exports.UiConfig = undefined;
	
	exports.UiConfig = UiConfig = function UiConfig() {
	    var branch = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'aggregate';
	
	    var t = this;
	
	    var layout = {
	        'aggregate': {
	            west_width: 424,
	            west_fieldset_width: 420,
	            west_width_padding: 2,
	            west_fill: 2,
	            west_fill_accordion_indicator: 81,
	            west_fill_accordion_dataelement: 81,
	            west_fill_accordion_dataset: 81,
	            west_fill_accordion_eventdataitem: 81,
	            west_fill_accordion_programindicator: 81,
	            west_fill_accordion_period: 340,
	            west_fill_accordion_organisationunit: 58,
	            west_fill_accordion_group: 31,
	            west_maxheight_accordion_indicator: 400,
	            west_maxheight_accordion_dataelement: 400,
	            west_maxheight_accordion_dataset: 400,
	            west_maxheight_accordion_period: 513,
	            west_maxheight_accordion_organisationunit: 900,
	            west_maxheight_accordion_group: 340,
	            west_maxheight_accordion_options: 449,
	            west_scrollbarheight_accordion_indicator: 300,
	            west_scrollbarheight_accordion_dataelement: 300,
	            west_scrollbarheight_accordion_dataset: 300,
	            west_scrollbarheight_accordion_period: 450,
	            west_scrollbarheight_accordion_organisationunit: 450,
	            west_scrollbarheight_accordion_group: 300,
	            east_tbar_height: 31,
	            east_gridcolumn_height: 30,
	            form_label_width: 55,
	            window_favorite_ypos: 100,
	            window_confirm_width: 250,
	            window_share_width: 500,
	            grid_favorite_width: 420,
	            grid_row_height: 27,
	            treepanel_minheight: 135,
	            treepanel_maxheight: 400,
	            treepanel_fill_default: 310,
	            treepanel_toolbar_menu_width_group: 140,
	            treepanel_toolbar_menu_width_level: 120,
	            multiselect_minheight: 100,
	            multiselect_maxheight: 250,
	            multiselect_fill_default: 345,
	            multiselect_fill_reportingrates: 315
	        },
	        'tracker': {
	            west_width: 452,
	            west_fill: 2,
	            west_fill_accordion_indicator: 56,
	            west_fill_accordion_dataelement: 59,
	            west_fill_accordion_dataset: 31,
	            west_fill_accordion_period: 365,
	            west_fill_accordion_organisationunit: 58,
	            west_maxheight_accordion_indicator: 450,
	            west_maxheight_accordion_dataset: 350,
	            west_maxheight_accordion_period: 405,
	            west_maxheight_accordion_organisationunit: 500,
	            west_scrollbarheight_accordion_indicator: 300,
	            west_scrollbarheight_accordion_dataset: 250,
	            west_scrollbarheight_accordion_period: 405,
	            west_scrollbarheight_accordion_organisationunit: 350,
	            east_tbar_height: 31,
	            east_gridcolumn_height: 30,
	            form_label_width: 55,
	            window_favorite_ypos: 100,
	            window_confirm_width: 250,
	            window_share_width: 500,
	            grid_favorite_width: 420,
	            grid_row_height: 27,
	            treepanel_minheight: 135,
	            treepanel_maxheight: 400,
	            treepanel_fill_default: 310,
	            treepanel_toolbar_menu_width_group: 140,
	            treepanel_toolbar_menu_width_level: 120,
	            multiselect_minheight: 100,
	            multiselect_maxheight: 250,
	            multiselect_fill_default: 345,
	            multiselect_fill_reportingrates: 315
	        }
	    };
	
	    t.checkout = function () {
	        var branch = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : branch;
	
	        $.extend(t, layout[branch]);
	    };
	
	    (function () {
	        t.checkout();
	    })();
	};
	
	UiConfig.prototype.applyTo = function (modules) {
	    var t = this;
	
	    (0, _arrayTo2.default)(modules).forEach(function (module) {
	        module.uiConfig = t;
	    });
	};
	//# sourceMappingURL=UiConfig.js.map

/***/ },
/* 129 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.ux = exports.override = exports.util = exports.init = exports.ui = exports.config = exports.manager = exports.table = exports.api = exports.StatusBar = exports.LimitContainer = exports.GroupSetContainer = exports.DataElementStringContainer = exports.DataElementIntegerContainer = exports.DataElementDateContainer = exports.DataElementBooleanContainer = exports.extChartOverrides = exports.extOverrides = exports.Plugin = exports.SimpleRegression = exports.categoryOptionGroupSetsInit = exports.userFavoritesInit = exports.dataApprovalLevelsInit = exports.dimensionsInit = exports.optionSetsInit = exports.legendSetsInit = exports.organisationUnitLevelsInit = exports.rootNodesInit = exports.isAdminInit = exports.authViewUnapprovedDataInit = exports.i18nInit = exports.WestRegionTrackerItems = exports.WestRegionAggregateItems = exports.IntegrationButton = exports.ChartTypeToolbar = exports.ChartDownloadButtonItems = exports.GridHeaders = exports.AboutWindow = exports.PluginItem = exports.InterpretationItem = exports.InterpretationWindow = exports.FavoriteButton = exports.FavoriteWindow = exports.EastRegion = exports.NorthRegion = exports.Viewport = exports.ChartConfig = exports.UiConfig = exports.OptionConfig = exports.PeriodConfig = exports.DimensionConfig = exports.TableManager = exports.InstanceManager = exports.UiManager = exports.IndexedDbManager = exports.SessionStorageManager = exports.RequestManager = exports.I18nManager = exports.CalendarManager = exports.DateManager = exports.AppManager = exports.EventDataTable = exports.PivotTable = exports.PivotTableAxis = exports.Sorting = exports.Response = exports.ResponseRowIdCombination = exports.ResponseRow = exports.ResponseHeader = exports.Request = exports.Period = exports.Layout = exports.Axis = exports.Dimension = exports.Record = undefined;
	
	__webpack_require__(91);
	
	__webpack_require__(93);
	
	var _Record = __webpack_require__(118);
	
	var _Dimension = __webpack_require__(58);
	
	var _Axis = __webpack_require__(115);
	
	var _Layout = __webpack_require__(116);
	
	var _Period = __webpack_require__(59);
	
	var _Request = __webpack_require__(119);
	
	var _ResponseHeader = __webpack_require__(121);
	
	var _ResponseRow = __webpack_require__(122);
	
	var _ResponseRowIdCombination = __webpack_require__(38);
	
	var _Response = __webpack_require__(120);
	
	var _Sorting = __webpack_require__(123);
	
	var _PivotTableAxis = __webpack_require__(154);
	
	var _PivotTable = __webpack_require__(153);
	
	var _EventDataTable = __webpack_require__(152);
	
	var _AppManager = __webpack_require__(141);
	
	var _DateManager = __webpack_require__(24);
	
	var _CalendarManager = __webpack_require__(142);
	
	var _I18nManager = __webpack_require__(143);
	
	var _RequestManager = __webpack_require__(146);
	
	var _SessionStorageManager = __webpack_require__(147);
	
	var _IndexedDbManager = __webpack_require__(144);
	
	var _UiManager = __webpack_require__(149);
	
	var _InstanceManager = __webpack_require__(145);
	
	var _TableManager = __webpack_require__(148);
	
	var _DimensionConfig = __webpack_require__(125);
	
	var _PeriodConfig = __webpack_require__(127);
	
	var _OptionConfig = __webpack_require__(126);
	
	var _UiConfig = __webpack_require__(128);
	
	var _ChartConfig = __webpack_require__(124);
	
	var _Viewport = __webpack_require__(169);
	
	var _NorthRegion = __webpack_require__(165);
	
	var _EastRegion = __webpack_require__(62);
	
	var _FavoriteWindow = __webpack_require__(40);
	
	var _FavoriteButton = __webpack_require__(63);
	
	var _InterpretationWindow = __webpack_require__(26);
	
	var _InterpretationItem = __webpack_require__(65);
	
	var _PluginItem = __webpack_require__(66);
	
	var _AboutWindow = __webpack_require__(61);
	
	var _GridHeaders = __webpack_require__(64);
	
	var _ChartDownloadButtonItems = __webpack_require__(156);
	
	var _ChartTypeToolbar = __webpack_require__(157);
	
	var _IntegrationButton = __webpack_require__(162);
	
	var _WestRegionAggregateItems = __webpack_require__(170);
	
	var _WestRegionTrackerItems = __webpack_require__(171);
	
	var _i18nInit = __webpack_require__(134);
	
	var _authViewUnapprovedDataInit = __webpack_require__(130);
	
	var _isAdminInit = __webpack_require__(135);
	
	var _rootNodesInit = __webpack_require__(139);
	
	var _organisationUnitLevelsInit = __webpack_require__(138);
	
	var _legendSetsInit = __webpack_require__(136);
	
	var _optionSetsInit = __webpack_require__(137);
	
	var _dimensionsInit = __webpack_require__(133);
	
	var _dataApprovalLevelsInit = __webpack_require__(132);
	
	var _userFavoritesInit = __webpack_require__(140);
	
	var _categoryOptionGroupSetsInit = __webpack_require__(131);
	
	var _SimpleRegression = __webpack_require__(173);
	
	var _Plugin = __webpack_require__(172);
	
	var _extOverrides = __webpack_require__(151);
	
	var _extChartOverrides = __webpack_require__(150);
	
	var _DataElementBooleanContainer = __webpack_require__(176);
	
	var _DataElementDateContainer = __webpack_require__(177);
	
	var _DataElementIntegerContainer = __webpack_require__(178);
	
	var _DataElementStringContainer = __webpack_require__(179);
	
	var _GroupSetContainer = __webpack_require__(180);
	
	var _LimitContainer = __webpack_require__(181);
	
	var _StatusBar = __webpack_require__(182);
	
	exports.Record = _Record.Record;
	exports.Dimension = _Dimension.Dimension;
	exports.Axis = _Axis.Axis;
	exports.Layout = _Layout.Layout;
	exports.Period = _Period.Period;
	exports.Request = _Request.Request;
	exports.ResponseHeader = _ResponseHeader.ResponseHeader;
	exports.ResponseRow = _ResponseRow.ResponseRow;
	exports.ResponseRowIdCombination = _ResponseRowIdCombination.ResponseRowIdCombination;
	exports.Response = _Response.Response;
	exports.Sorting = _Sorting.Sorting;
	exports.PivotTableAxis = _PivotTableAxis.PivotTableAxis;
	exports.PivotTable = _PivotTable.PivotTable;
	exports.EventDataTable = _EventDataTable.EventDataTable;
	exports.AppManager = _AppManager.AppManager;
	exports.DateManager = _DateManager.DateManager;
	exports.CalendarManager = _CalendarManager.CalendarManager;
	exports.I18nManager = _I18nManager.I18nManager;
	exports.RequestManager = _RequestManager.RequestManager;
	exports.SessionStorageManager = _SessionStorageManager.SessionStorageManager;
	exports.IndexedDbManager = _IndexedDbManager.IndexedDbManager;
	exports.UiManager = _UiManager.UiManager;
	exports.InstanceManager = _InstanceManager.InstanceManager;
	exports.TableManager = _TableManager.TableManager;
	exports.DimensionConfig = _DimensionConfig.DimensionConfig;
	exports.PeriodConfig = _PeriodConfig.PeriodConfig;
	exports.OptionConfig = _OptionConfig.OptionConfig;
	exports.UiConfig = _UiConfig.UiConfig;
	exports.ChartConfig = _ChartConfig.ChartConfig;
	exports.Viewport = _Viewport.Viewport;
	exports.NorthRegion = _NorthRegion.NorthRegion;
	exports.EastRegion = _EastRegion.EastRegion;
	exports.FavoriteWindow = _FavoriteWindow.FavoriteWindow;
	exports.FavoriteButton = _FavoriteButton.FavoriteButton;
	exports.InterpretationWindow = _InterpretationWindow.InterpretationWindow;
	exports.InterpretationItem = _InterpretationItem.InterpretationItem;
	exports.PluginItem = _PluginItem.PluginItem;
	exports.AboutWindow = _AboutWindow.AboutWindow;
	exports.GridHeaders = _GridHeaders.GridHeaders;
	exports.ChartDownloadButtonItems = _ChartDownloadButtonItems.ChartDownloadButtonItems;
	exports.ChartTypeToolbar = _ChartTypeToolbar.ChartTypeToolbar;
	exports.IntegrationButton = _IntegrationButton.IntegrationButton;
	exports.WestRegionAggregateItems = _WestRegionAggregateItems.WestRegionAggregateItems;
	exports.WestRegionTrackerItems = _WestRegionTrackerItems.WestRegionTrackerItems;
	exports.i18nInit = _i18nInit.i18nInit;
	exports.authViewUnapprovedDataInit = _authViewUnapprovedDataInit.authViewUnapprovedDataInit;
	exports.isAdminInit = _isAdminInit.isAdminInit;
	exports.rootNodesInit = _rootNodesInit.rootNodesInit;
	exports.organisationUnitLevelsInit = _organisationUnitLevelsInit.organisationUnitLevelsInit;
	exports.legendSetsInit = _legendSetsInit.legendSetsInit;
	exports.optionSetsInit = _optionSetsInit.optionSetsInit;
	exports.dimensionsInit = _dimensionsInit.dimensionsInit;
	exports.dataApprovalLevelsInit = _dataApprovalLevelsInit.dataApprovalLevelsInit;
	exports.userFavoritesInit = _userFavoritesInit.userFavoritesInit;
	exports.categoryOptionGroupSetsInit = _categoryOptionGroupSetsInit.categoryOptionGroupSetsInit;
	exports.SimpleRegression = _SimpleRegression.SimpleRegression;
	exports.Plugin = _Plugin.Plugin;
	exports.extOverrides = _extOverrides.extOverrides;
	exports.extChartOverrides = _extChartOverrides.extChartOverrides;
	exports.DataElementBooleanContainer = _DataElementBooleanContainer.DataElementBooleanContainer;
	exports.DataElementDateContainer = _DataElementDateContainer.DataElementDateContainer;
	exports.DataElementIntegerContainer = _DataElementIntegerContainer.DataElementIntegerContainer;
	exports.DataElementStringContainer = _DataElementStringContainer.DataElementStringContainer;
	exports.GroupSetContainer = _GroupSetContainer.GroupSetContainer;
	exports.LimitContainer = _LimitContainer.LimitContainer;
	exports.StatusBar = _StatusBar.StatusBar;
	var api = exports.api = {
	    Record: _Record.Record,
	    Dimension: _Dimension.Dimension,
	    Axis: _Axis.Axis,
	    Layout: _Layout.Layout,
	    Period: _Period.Period,
	    Request: _Request.Request,
	    ResponseHeader: _ResponseHeader.ResponseHeader,
	    ResponseRow: _ResponseRow.ResponseRow,
	    ResponseRowIdCombination: _ResponseRowIdCombination.ResponseRowIdCombination,
	    Response: _Response.Response,
	    Sorting: _Sorting.Sorting
	};
	
	var table = exports.table = {
	    PivotTableAxis: _PivotTableAxis.PivotTableAxis,
	    PivotTable: _PivotTable.PivotTable,
	    EventDataTable: _EventDataTable.EventDataTable
	};
	
	var manager = exports.manager = {
	    AppManager: _AppManager.AppManager,
	    DateManager: _DateManager.DateManager,
	    CalendarManager: _CalendarManager.CalendarManager,
	    I18nManager: _I18nManager.I18nManager,
	    RequestManager: _RequestManager.RequestManager,
	    SessionStorageManager: _SessionStorageManager.SessionStorageManager,
	    IndexedDbManager: _IndexedDbManager.IndexedDbManager,
	    UiManager: _UiManager.UiManager,
	    InstanceManager: _InstanceManager.InstanceManager,
	    TableManager: _TableManager.TableManager
	};
	
	var config = exports.config = {
	    DimensionConfig: _DimensionConfig.DimensionConfig,
	    PeriodConfig: _PeriodConfig.PeriodConfig,
	    OptionConfig: _OptionConfig.OptionConfig,
	    UiConfig: _UiConfig.UiConfig,
	    ChartConfig: _ChartConfig.ChartConfig
	};
	
	var ui = exports.ui = {
	    Viewport: _Viewport.Viewport,
	    NorthRegion: _NorthRegion.NorthRegion,
	    EastRegion: _EastRegion.EastRegion,
	    FavoriteWindow: _FavoriteWindow.FavoriteWindow,
	    FavoriteButton: _FavoriteButton.FavoriteButton,
	    InterpretationWindow: _InterpretationWindow.InterpretationWindow,
	    InterpretationItem: _InterpretationItem.InterpretationItem,
	    PluginItem: _PluginItem.PluginItem,
	    AboutWindow: _AboutWindow.AboutWindow,
	    GridHeaders: _GridHeaders.GridHeaders,
	    ChartDownloadButtonItems: _ChartDownloadButtonItems.ChartDownloadButtonItems,
	    ChartTypeToolbar: _ChartTypeToolbar.ChartTypeToolbar,
	    IntegrationButton: _IntegrationButton.IntegrationButton,
	    WestRegionAggregateItems: _WestRegionAggregateItems.WestRegionAggregateItems,
	    WestRegionTrackerItems: _WestRegionTrackerItems.WestRegionTrackerItems
	};
	
	var init = exports.init = {
	    i18nInit: _i18nInit.i18nInit,
	    authViewUnapprovedDataInit: _authViewUnapprovedDataInit.authViewUnapprovedDataInit,
	    isAdminInit: _isAdminInit.isAdminInit,
	    rootNodesInit: _rootNodesInit.rootNodesInit,
	    organisationUnitLevelsInit: _organisationUnitLevelsInit.organisationUnitLevelsInit,
	    legendSetsInit: _legendSetsInit.legendSetsInit,
	    optionSetsInit: _optionSetsInit.optionSetsInit,
	    dimensionsInit: _dimensionsInit.dimensionsInit,
	    dataApprovalLevelsInit: _dataApprovalLevelsInit.dataApprovalLevelsInit,
	    userFavoritesInit: _userFavoritesInit.userFavoritesInit,
	    categoryOptionGroupSetsInit: _categoryOptionGroupSetsInit.categoryOptionGroupSetsInit
	};
	
	var util = exports.util = {
	    SimpleRegression: _SimpleRegression.SimpleRegression,
	    Plugin: _Plugin.Plugin
	};
	
	var override = exports.override = {
	    extOverrides: _extOverrides.extOverrides,
	    extChartOverrides: _extChartOverrides.extChartOverrides
	};
	
	var ux = exports.ux = {
	    DataElementBooleanContainer: _DataElementBooleanContainer.DataElementBooleanContainer,
	    DataElementDateContainer: _DataElementDateContainer.DataElementDateContainer,
	    DataElementIntegerContainer: _DataElementIntegerContainer.DataElementIntegerContainer,
	    DataElementStringContainer: _DataElementStringContainer.DataElementStringContainer,
	    GroupSetContainer: _GroupSetContainer.GroupSetContainer,
	    LimitContainer: _LimitContainer.LimitContainer,
	    StatusBar: _StatusBar.StatusBar
	};
	//# sourceMappingURL=index.js.map

/***/ },
/* 130 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var authViewUnapprovedDataInit = exports.authViewUnapprovedDataInit = undefined;
	
	exports.authViewUnapprovedDataInit = authViewUnapprovedDataInit = function authViewUnapprovedDataInit(c) {
	    var t = this,
	        appManager = c.appManager,
	        requestManager = c.requestManager;
	
	    return {
	        baseUrl: appManager.getApiPath() + '/me/authorization/F_VIEW_UNAPPROVED_DATA',
	        success: function success(r) {
	            appManager.viewUnapprovedData = r;
	            requestManager.ok(this);
	        }
	    };
	};
	//# sourceMappingURL=authViewUnapprovedDataInit.js.map

/***/ },
/* 131 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var categoryOptionGroupSetsInit = exports.categoryOptionGroupSetsInit = undefined;
	
	exports.categoryOptionGroupSetsInit = categoryOptionGroupSetsInit = function categoryOptionGroupSetsInit(c) {
	    var extraParams = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
	
	    var t = this,
	        appManager = c.appManager,
	        requestManager = c.requestManager,
	        dimensionConfig = c.dimensionConfig,
	        apiPath = appManager.getApiPath(),
	        displayPropertyUrl = appManager.getDisplayPropertyUrl();
	
	    return {
	        baseUrl: apiPath + '/categoryOptionGroupSets.json',
	        params: ['fields=id,' + displayPropertyUrl + ',dataDimensionType', 'paging=false'].concat(extraParams),
	        success: function success(r) {
	            appManager.addCategoryOptionGroupSets(r.categoryOptionGroupSets);
	
	            requestManager.ok(this);
	        }
	    };
	};
	//# sourceMappingURL=categoryOptionGroupSetsInit.js.map

/***/ },
/* 132 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var dataApprovalLevelsInit = exports.dataApprovalLevelsInit = undefined;
	
	exports.dataApprovalLevelsInit = dataApprovalLevelsInit = function dataApprovalLevelsInit(c) {
	    var t = this,
	        appManager = c.appManager,
	        requestManager = c.requestManager,
	        apiPath = appManager.getApiPath(),
	        displayPropertyUrl = appManager.getDisplayPropertyUrl();
	
	    return {
	        baseUrl: apiPath + '/dataApprovalLevels.json',
	        params: ['order=level:asc', 'fields=id,displayName~rename(name),level', 'paging=false'],
	        success: function success(r) {
	            appManager.addDataApprovalLevels(r.dataApprovalLevels);
	            requestManager.ok(this);
	        }
	    };
	};
	//# sourceMappingURL=dataApprovalLevelsInit.js.map

/***/ },
/* 133 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var dimensionsInit = exports.dimensionsInit = undefined;
	
	exports.dimensionsInit = dimensionsInit = function dimensionsInit(c) {
	    var extraParams = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
	
	    var t = this,
	        appManager = c.appManager,
	        requestManager = c.requestManager,
	        dimensionConfig = c.dimensionConfig,
	        apiPath = appManager.getApiPath(),
	        displayPropertyUrl = appManager.getDisplayPropertyUrl();
	
	    return {
	        baseUrl: apiPath + '/dimensions.json',
	        params: ['fields=id,' + displayPropertyUrl + ',dimensionType', 'paging=false'].concat(extraParams),
	        success: function success(r) {
	            appManager.addDimensions(r.dimensions);
	            dimensionConfig.add(r.dimensions);
	
	            requestManager.ok(this);
	        }
	    };
	};
	//# sourceMappingURL=dimensionsInit.js.map

/***/ },
/* 134 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var i18nInit = exports.i18nInit = undefined;
	
	exports.i18nInit = i18nInit = function i18nInit(refs) {
	    var t = this,
	        appManager = refs.appManager,
	        requestManager = refs.requestManager,
	        i18nManager = refs.i18nManager,
	        uiLocale = appManager.getUiLocale(),
	        isUiLocaleDefault = appManager.isUiLocaleDefault(),
	        defaultUiLocale = appManager.defaultUiLocale;
	
	    return {
	        baseUrl: 'i18n/i18n_app.properties',
	        type: 'ajax',
	        dataType: 'text',
	        headers: {
	            'Accept': 'text/plain; charset=utf-8'
	        },
	        success: function success(r) {
	            var t = this;
	
	            i18nManager.add(dhis2.util.parseJavaProperties(r));
	
	            if (isUiLocaleDefault) {
	                requestManager.ok(t);
	            } else {
	                $.ajax({
	                    url: 'i18n/i18n_app_' + uiLocale + '.properties',
	                    success: function success(r) {
	                        i18nManager.add(dhis2.util.parseJavaProperties(r));
	                    },
	                    error: function error() {
	                        console.log('(i18n) No translations found for system locale (' + uiLocale + ')');
	                    },
	                    complete: function complete() {
	                        requestManager.ok(t);
	                    }
	                });
	            }
	        },
	        error: function error() {
	            $.ajax({
	                url: 'i18n/i18n_app_' + uiLocale + '.properties',
	                success: function success(r) {
	                    i18nManager.add(dhis2.util.parseJavaProperties(r));
	                },
	                error: function error() {
	                    alert('(i18n) No translations found for system locale (' + uiLocale + ') or default locale (' + defaultUiLocale + ')');
	                },
	                complete: function complete() {
	                    requestManager.ok(this);
	                }
	            });
	        }
	    };
	};
	//# sourceMappingURL=i18nInit.js.map

/***/ },
/* 135 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var isAdminInit = exports.isAdminInit = undefined;
	
	exports.isAdminInit = isAdminInit = function isAdminInit(c) {
	    var t = this,
	        appManager = c.appManager,
	        requestManager = c.requestManager,
	        apiPath = appManager.getApiPath();
	
	    return {
	        baseUrl: appManager.getPath() + '/api/me/authorization/ALL',
	        success: function success(r) {
	            appManager.isAdmin = r;
	            requestManager.ok(this);
	        }
	    };
	};
	//# sourceMappingURL=isAdminInit.js.map

/***/ },
/* 136 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var legendSetsInit = exports.legendSetsInit = undefined;
	
	exports.legendSetsInit = legendSetsInit = function legendSetsInit(c) {
	    var t = this,
	        appManager = c.appManager,
	        requestManager = c.requestManager,
	        apiPath = appManager.getApiPath(),
	        displayPropertyUrl = appManager.getDisplayPropertyUrl();
	
	    return {
	        baseUrl: apiPath + '/legendSets.json',
	        params: ['fields=id,displayName~rename(name),legends[id,displayName~rename(name),startValue,endValue,color]', 'paging=false'],
	        success: function success(r) {
	            appManager.addLegendSets(r.legendSets);
	            requestManager.ok(this);
	        }
	    };
	};
	//# sourceMappingURL=legendSetsInit.js.map

/***/ },
/* 137 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.optionSetsInit = undefined;
	
	var _isObject = __webpack_require__(2);
	
	var _isObject2 = _interopRequireDefault(_isObject);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var optionSetsInit = exports.optionSetsInit = undefined;
	
	exports.optionSetsInit = optionSetsInit = function optionSetsInit(refs) {
	    var t = this;
	
	    var appManager = refs.appManager,
	        requestManager = refs.requestManager,
	        indexedDbManager = refs.indexedDbManager;
	    var Request = refs.api.Request;
	
	
	    var apiPath = appManager.getApiPath(),
	        displayPropertyUrl = appManager.getDisplayPropertyUrl();
	
	    return {
	        baseUrl: '.',
	        type: 'ajax',
	        dataType: 'text',
	        disableCaching: false,
	        success: function success() {
	            indexedDbManager.open().done(function () {
	
	                // check if idb has any option sets
	                indexedDbManager.getKeys('optionSets').done(function (keys) {
	                    if (keys.length === 0) {
	                        new Request(refs, {
	                            baseUrl: appManager.getApiPath() + '/optionSets.json',
	                            params: ['fields=id,name,version,options[code,name]', 'paging=false'],
	                            success: function success(r) {
	                                var optionSets = r.optionSets;
	
	                                if (optionSets.length) {
	                                    indexedDbManager.setAll('optionSets', optionSets).done(function () {
	                                        requestManager.ok(t);
	                                    });
	                                } else {
	                                    requestManager.ok(t);
	                                }
	                            }
	                        }).run();
	
	                        //Ext.Ajax.request({
	                        //url: appManager.getApiPath() + '/optionSets.json?fields=id,name,version,options[code,name]&paging=false',
	                        //success: function(r) {
	                        //var sets = Ext.decode(r.responseText).optionSets;
	
	                        //if (sets.length) {
	                        //indexedDbManager.setAll('optionSets', sets).done(function() {
	                        //requestManager.ok(t);
	                        //});
	                        //}
	                        //else {
	                        //requestManager.ok(t);
	                        //}
	                        //}
	                        //});
	                    } else {
	                        new Request(refs, {
	                            baseUrl: appManager.getApiPath() + '/optionSets.json',
	                            params: ['fields=id,version', 'paging=false'],
	                            success: function success(r) {
	
	                                //Ext.Ajax.request({
	                                //url: appManager.getApiPath() + '/optionSets.json?fields=id,version&paging=false',
	                                //disableCaching: false,
	                                //success: function(r) {
	                                var optionSets = r.optionSets || [],
	                                    ids = [],
	                                    filters = [],
	                                    callbacks = 0;
	
	                                var updateStore = function updateStore() {
	                                    if (++callbacks === optionSets.length) {
	                                        if (!ids.length) {
	                                            requestManager.ok(t);
	                                            return;
	                                        }
	
	                                        for (var i = 0; i < ids.length; i++) {
	                                            filters.push('filter=id:eq:' + ids[i]);
	                                        }
	
	                                        new Request(refs, {
	                                            baseUrl: appManager.getApiPath() + '/optionSets.json',
	                                            params: filters.concat(['fields=id,name,version,options[code,name]', 'paging=false']),
	                                            success: function success(r) {
	                                                var optionSets = r.optionSets;
	
	                                                indexedDbManager.setAll('optionSets', optionSets).done(function () {
	                                                    requestManager.ok(t);
	                                                });
	                                            }
	                                        }).run();
	
	                                        //Ext.Ajax.request({
	                                        //url: appManager.getApiPath() + '/optionSets.json?fields=id,name,version,options[code,name]&paging=false' + url,
	                                        //success: function(r) {
	                                        //var sets = Ext.decode(r.responseText).optionSets;
	
	                                        //indexedDbManager.setAll('optionSets', sets).done(function() {
	                                        //requestManager.ok(t);
	                                        //});
	                                        //}
	                                        //});
	                                    }
	                                };
	
	                                var registerOptionSet = function registerOptionSet(optionSet) {
	                                    indexedDbManager.get('optionSets', optionSet.id).done(function (obj) {
	                                        if (!(0, _isObject2.default)(obj) || obj.version !== optionSet.version) {
	                                            ids.push(optionSet.id);
	                                        }
	
	                                        updateStore();
	                                    });
	                                };
	
	                                if (optionSets.length) {
	                                    optionSets.forEach(function (optionSet) {
	                                        return registerOptionSet(optionSet);
	                                    });
	                                } else {
	                                    requestManager.ok(t);
	                                }
	                            }
	                        }).run();
	                    }
	                });
	            });
	        }
	    };
	};
	//# sourceMappingURL=optionSetsInit.js.map

/***/ },
/* 138 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var organisationUnitLevelsInit = exports.organisationUnitLevelsInit = undefined;
	
	exports.organisationUnitLevelsInit = organisationUnitLevelsInit = function organisationUnitLevelsInit(c) {
	    var t = this,
	        appManager = c.appManager,
	        requestManager = c.requestManager,
	        apiPath = appManager.getApiPath(),
	        displayPropertyUrl = appManager.getDisplayPropertyUrl();
	
	    return {
	        baseUrl: apiPath + '/organisationUnitLevels.json',
	        params: ['fields=id,displayName~rename(name),level', 'paging=false'],
	        success: function success(r) {
	            appManager.addOrganisationUnitLevels(r.organisationUnitLevels);
	
	            if (!r.organisationUnitLevels.length) {
	                alert('No organisation unit levels found');
	            }
	
	            requestManager.ok(this);
	        }
	    };
	};
	//# sourceMappingURL=organisationUnitLevelsInit.js.map

/***/ },
/* 139 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var rootNodesInit = exports.rootNodesInit = undefined;
	
	exports.rootNodesInit = rootNodesInit = function rootNodesInit(c) {
	    var t = this,
	        appManager = c.appManager,
	        requestManager = c.requestManager,
	        apiPath = appManager.getApiPath(),
	        displayPropertyUrl = appManager.getDisplayPropertyUrl();
	
	    return {
	        baseUrl: apiPath + '/organisationUnits.json',
	        params: ['userDataViewFallback=true', 'fields=id,' + displayPropertyUrl + ',children[id,' + displayPropertyUrl + ']', 'paging=false'],
	        success: function success(r) {
	            appManager.addRootNodes(r.organisationUnits);
	            requestManager.ok(this);
	        }
	    };
	};
	//# sourceMappingURL=rootNodesInit.js.map

/***/ },
/* 140 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var userFavoritesInit = exports.userFavoritesInit = undefined;
	
	exports.userFavoritesInit = userFavoritesInit = function userFavoritesInit(refs) {
	    var pageSize = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 10;
	
	    var t = this;
	
	    var appManager = refs.appManager,
	        requestManager = refs.requestManager,
	        instanceManager = refs.instanceManager;
	
	    var apiPath = appManager.getApiPath(),
	        username = appManager.userAccount.userCredentials.username,
	        eventType = instanceManager.dataStatisticsEventType;
	
	    return {
	        baseUrl: apiPath + '/dataStatistics/favorites.json',
	        params: ['eventType=' + eventType, 'username=' + username, 'pageSize=' + pageSize],
	        success: function success(response) {
	            appManager.userFavorites = response;
	            requestManager.ok(this);
	        }
	    };
	};
	//# sourceMappingURL=userFavoritesInit.js.map

/***/ },
/* 141 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.AppManager = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _isArray = __webpack_require__(1);
	
	var _isArray2 = _interopRequireDefault(_isArray);
	
	var _isFunction = __webpack_require__(21);
	
	var _isFunction2 = _interopRequireDefault(_isFunction);
	
	var _isNumeric = __webpack_require__(22);
	
	var _isNumeric2 = _interopRequireDefault(_isNumeric);
	
	var _isObject = __webpack_require__(2);
	
	var _isObject2 = _interopRequireDefault(_isObject);
	
	var _isString = __webpack_require__(3);
	
	var _isString2 = _interopRequireDefault(_isString);
	
	var _stringReplaceAll = __webpack_require__(70);
	
	var _stringReplaceAll2 = _interopRequireDefault(_stringReplaceAll);
	
	var _arrayClean = __webpack_require__(9);
	
	var _arrayClean2 = _interopRequireDefault(_arrayClean);
	
	var _arrayFrom = __webpack_require__(5);
	
	var _arrayFrom2 = _interopRequireDefault(_arrayFrom);
	
	var _arraySort = __webpack_require__(10);
	
	var _arraySort2 = _interopRequireDefault(_arraySort);
	
	var _arrayTo = __webpack_require__(6);
	
	var _arrayTo2 = _interopRequireDefault(_arrayTo);
	
	var _arrayUnique = __webpack_require__(14);
	
	var _arrayUnique2 = _interopRequireDefault(_arrayUnique);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var AppManager = exports.AppManager = undefined;
	
	exports.AppManager = AppManager = function AppManager(refs) {
	    var t = this;
	
	    t.refs = (0, _isObject2.default)(refs) ? refs : {};
	
	    // constants
	    t.defaultUiLocale = 'en';
	    t.defaultDisplayProperty = 'displayName';
	    t.defaultAnalyticsDisplayProperty = 'name';
	    t.defaultIndexedDb = 'dhis2';
	    t.rootNodeId = 'root';
	
	    t.defaultRequestHeaders = {
	        'Accept': 'application/json',
	        'Content-Type': 'application/json'
	    };
	
	    t.defaultAnalysisFields = ['*', 'interpretations[*,user[id,displayName],likedBy[id,displayName],comments[id,lastUpdated,text,user[id,displayName]]]', 'columns[dimension,filter,legendSet[id],items[dimensionItem~rename(id),dimensionItemType,$]]', 'rows[dimension,filter,legendSet[id],items[dimensionItem~rename(id),dimensionItemType,$]]', 'filters[dimension,filter,legendSet[id],items[dimensionItem~rename(id),dimensionItemType,$]]', 'access', 'userGroupAccesses', 'publicAccess', 'displayDescription', 'user[displayName]', '!href', '!rewindRelativePeriods', '!userOrganisationUnit', '!userOrganisationUnitChildren', '!userOrganisationUnitGrandChildren', '!externalAccess', '!relativePeriods', '!columnDimensions', '!rowDimensions', '!filterDimensions', '!organisationUnitGroups', '!itemOrganisationUnitGroups', '!indicators', '!dataElements', '!dataElementOperands', '!dataElementGroups', '!dataSets', '!periods', '!organisationUnitLevels', '!organisationUnits'];
	
	    t.displayPropertyMap = {
	        'name': 'displayName',
	        'displayName': 'displayName',
	        'shortName': 'displayShortName',
	        'displayShortName': 'displayShortName'
	    };
	
	    t.userIdDestroyCacheKeys = ['USER_ORGUNIT', 'USER_ORGUNIT_CHILDREN', 'USER_ORGUNIT_GRANDCHILDREN'];
	
	    t.ignoreResponseHeaders = ['dy', 'value', 'psi', 'ps', 'eventdate', 'longitude', 'latitude', 'ouname', 'oucode'];
	
	    // uninitialized
	    t.appName;
	    t.sessionName;
	    t.manifest;
	    t.env;
	    t.systemInfo;
	    t.systemSettings;
	    t.userAccount;
	    t.calendar;
	    t.periodGenerator;
	    t.viewUnapprovedData;
	
	    t.rootNodes = [];
	    t.organisationUnitLevels = [];
	    t.dimensions = [];
	    t.categoryOptionGroupSets = [];
	    t.dimensions = [];
	    t.legendSets = [];
	    t.dataApprovalLevels = [];
	    t.userFavorites = [];
	
	    // transient
	    t.path;
	    t.dateFormat;
	    t.relativePeriod;
	    t.uiLocale;
	    t.displayProperty;
	    t.displayPropertyUrl;
	    t.analyticsDisplayProperty;
	    t.analysisFields;
	    t.legendSetMap;
	
	    // optional
	    t.manifestVersion;
	    t.apiVersion;
	
	    // fns
	    t.getUrlParam = function (s) {
	        var output = '';
	        var href = window.location.href;
	        if (href.indexOf('?') > -1) {
	            var query = href.substr(href.indexOf('?') + 1);
	            var query = query.split('&');
	            for (var i = 0; i < query.length; i++) {
	                if (query[i].indexOf('=') > -1) {
	                    var a = query[i].split('=');
	                    if (a[0].toLowerCase() === s) {
	                        output = a[1];
	                        break;
	                    }
	                }
	            }
	        }
	        return unescape(output);
	    };
	
	    // event handler array
	    t.getEventHandlerArray = function () {
	        var a = [];
	
	        a.run = function (params) {
	            a.forEach(function (fn) {
	                fn(params.cmp, params.width, params.height, params.eOpts);
	            });
	        };
	
	        return a;
	    };
	};
	
	AppManager.prototype.init = function (callbackFn) {
	    var t = this;
	
	    // manifest
	    var manifestReq = function manifestReq() {
	        new t.refs.api.Request(t.refs, {
	            baseUrl: 'manifest.webapp',
	            type: 'json',
	            success: function success(response) {
	                t.manifest = response;
	                t.env = ('production');
	                t.setAuth();
	                t.logVersion();
	
	                systemInfoReq();
	            }
	        }).run();
	    };
	
	    // system info
	    var systemInfoReq = function systemInfoReq() {
	        new t.refs.api.Request(t.refs, {
	            baseUrl: t.getApiPath() + '/system/info.json',
	            type: 'json',
	            success: function success(response) {
	                t.systemInfo = response;
	                t.path = response.contextPath;
	
	                systemSettingsReq();
	            }
	        }).run();
	    };
	
	    // system settings
	    var systemSettingsReq = function systemSettingsReq() {
	        new t.refs.api.Request(t.refs, {
	            baseUrl: t.getApiPath() + '/systemSettings.json',
	            type: 'json',
	            params: ['key=keyCalendar', 'key=keyDateFormat', 'key=keyAnalysisRelativePeriod', 'key=keyHideUnapprovedDataInAnalytics', 'key=keyAnalysisDigitGroupSeparator', 'key=keyIgnoreAnalyticsApprovalYearThreshold'],
	            success: function success(response) {
	                t.systemSettings = response;
	
	                userAccountReq();
	            }
	        }).run();
	    };
	
	    // user account
	    var userAccountReq = function userAccountReq() {
	        new t.refs.api.Request(t.refs, {
	            baseUrl: t.getApiPath() + '/me.json',
	            type: 'json',
	            params: ['fields=id,firstName,surname,userCredentials[username],settings'],
	            success: function success(response) {
	                t.userAccount = response;
	
	                var calendarManager = t.refs.calendarManager;
	
	                calendarManager.setBaseUrl(t.getPath());
	                calendarManager.setDateFormat(t.getDateFormat());
	                calendarManager.init(t.systemSettings.keyCalendar);
	
	                // allow for other code to be executed after all the init stuff is done
	                if (callbackFn) {
	                    callbackFn();
	                }
	            }
	        }).run();
	    };
	
	    manifestReq();
	};
	
	AppManager.prototype.logVersion = function () {
	    if (console && this.manifest && this.manifest.version) {
	        var version = 'v' + this.manifest.version;
	        var name = this.manifest.name || null;
	
	        var msg = (0, _arrayClean2.default)([name, version]).join(' ');
	        var fn = console.info || console.log;
	
	        fn.call(console, msg);
	    }
	};
	
	AppManager.prototype.getPath = function () {
	    var dhis = this.manifest ? this.manifest.activities.dhis : {};
	
	    return this.path ? this.path : this.env === 'production' ? dhis.href : dhis.devHref || dhis.href;
	};
	
	AppManager.prototype.getManifestFullVersionNumber = function () {
	    var t = this;
	
	    return t.manifest && (0, _isNumeric2.default)(parseInt(t.manifest.version)) ? parseInt(t.manifest.version) : t.manifestVersion || undefined;
	};
	
	AppManager.prototype.getApiVersion = function () {
	    return this.apiVersion;
	};
	
	AppManager.prototype.getDateFormat = function () {
	    return this.dateFormat ? this.dateFormat : this.dateFormat = (0, _isString2.default)(this.systemSettings.keyDateFormat) ? this.systemSettings.keyDateFormat.toLowerCase() : 'yyyy-mm-dd';
	};
	
	AppManager.prototype.getRelativePeriod = function () {
	    return this.relativePeriod ? this.relativePeriod : this.relativePeriod = this.systemSettings.keyAnalysisRelativePeriod || 'LAST_12_MONTHS';
	};
	
	AppManager.prototype.getUiLocale = function () {
	    return this.uiLocale ? this.uiLocale : this.uiLocale = this.userAccount.settings.keyUiLocale || this.defaultUiLocale;
	};
	
	AppManager.prototype.getDisplayProperty = function () {
	    if (this.displayProperty) {
	        return this.displayProperty;
	    }
	
	    var keyAnalysisDisplayProperty = this.userAccount && this.userAccount.settings ? this.userAccount.settings.keyAnalysisDisplayProperty : null;
	
	    return this.displayProperty = this.displayPropertyMap[keyAnalysisDisplayProperty || this.defaultDisplayProperty];
	};
	
	AppManager.prototype.getAnalyticsDisplayProperty = function () {
	    if (this.analyticsDisplayProperty) {
	        return this.analyticsDisplayProperty;
	    }
	
	    var keyAnalysisDisplayProperty = this.userAccount && this.userAccount.settings ? this.userAccount.settings.keyAnalysisDisplayProperty : null;
	
	    return this.analyticsDisplayProperty = (keyAnalysisDisplayProperty || this.defaultAnalyticsDisplayProperty).toUpperCase();
	};
	
	AppManager.prototype.getRootNodes = function () {
	    return this.rootNodes;
	};
	
	AppManager.prototype.addRootNodes = function (param) {
	    var t = this,
	        nodes = (0, _arrayFrom2.default)(param);
	
	    nodes.forEach(function (node) {
	        node.expanded = true;
	        node.path = '/' + t.rootId + '/' + node.id;
	    });
	
	    t.rootNodes = (0, _arrayClean2.default)(t.rootNodes.concat(nodes));
	};
	
	AppManager.prototype.addOrganisationUnitLevels = function (param) {
	    this.organisationUnitLevels = (0, _arrayClean2.default)(this.organisationUnitLevels.concat((0, _arrayFrom2.default)(param)));
	
	    (0, _arraySort2.default)(this.organisationUnitLevels, 'ASC', 'level');
	};
	
	AppManager.prototype.addLegendSets = function (param) {
	    this.legendSets = (0, _arrayClean2.default)(this.legendSets.concat((0, _arrayFrom2.default)(param)));
	
	    (0, _arraySort2.default)(this.legendSets, 'ASC', 'name');
	};
	
	AppManager.prototype.getLegendSetById = function (id) {
	    var t = this;
	
	    if (t.legendSetMap) {
	        return t.legendSetMap[id];
	    }
	
	    t.legendSetMap = {};
	
	    t.legendSets.forEach(function (set) {
	        t.legendSetMap[set.id] = set;
	    });
	
	    return t.legendSetMap[id];
	};
	
	AppManager.prototype.addDimensions = function (param) {
	    this.dimensions = (0, _arrayClean2.default)(this.dimensions.concat((0, _arrayFrom2.default)(param)));
	
	    (0, _arraySort2.default)(this.dimensions, 'ASC', 'name');
	};
	
	AppManager.prototype.addCategoryOptionGroupSets = function (param) {
	    this.categoryOptionGroupSets = (0, _arrayClean2.default)(this.categoryOptionGroupSets.concat((0, _arrayFrom2.default)(param)));
	
	    (0, _arraySort2.default)(this.categoryOptionGroupSets, 'ASC', 'name');
	};
	
	AppManager.prototype.addDataApprovalLevels = function (param) {
	    this.dataApprovalLevels = (0, _arrayClean2.default)(this.dataApprovalLevels.concat((0, _arrayFrom2.default)(param)));
	
	    (0, _arraySort2.default)(this.dataApprovalLevels, 'ASC', 'level');
	};
	
	AppManager.prototype.addIgnoreResponseHeaders = function (headers, append) {
	    var t = this;
	
	    t.ignoreResponseHeaders = (0, _arrayUnique2.default)([].concat(_toConsumableArray(append ? t.ignoreResponseHeaders : []), _toConsumableArray(headers)));
	};
	
	AppManager.prototype.setAuth = function (binary, ascii) {
	    var J = 'jQuery' in window ? window['jQuery'] : undefined;
	    var E = 'Ext' in window ? window['Ext'] : undefined;
	    var headers;
	    var auth;
	
	    if (binary || ascii) {
	        headers = {
	            Authorization: ascii ? ascii : 'Basic ' + btoa(binary)
	        };
	    } else if (this.env !== 'production' && this.manifest && (0, _isString2.default)(this.manifest.activities.dhis.auth)) {
	        headers = {
	            Authorization: 'Basic ' + btoa(this.manifest.activities.dhis.auth)
	        };
	    }
	
	    if (headers) {
	        if (J) {
	            J.ajaxSetup({
	                headers: headers
	            });
	        }
	
	        if (E && (0, _isObject2.default)(E.Ajax)) {
	            E.Ajax.defaultHeaders = headers;
	        }
	    }
	};
	
	AppManager.prototype.applyTo = function (modules) {
	    var t = this;
	
	    (0, _arrayTo2.default)(modules).forEach(function (module) {
	        module.appManager = t;
	    });
	};
	
	// dep 1
	
	AppManager.prototype.getApiPath = function () {
	    var t = this;
	
	    var version = t.getApiVersion() || '';
	
	    return t.getPath() + '/api' + (version ? '/' + version : '');
	};
	
	AppManager.prototype.getLegendColorByValue = function (id, value) {
	    var t = this,
	        color;
	
	    var legendSet = t.getLegendSetById(id);
	
	    for (var i = 0, legend; i < legendSet.legends.length; i++) {
	        legend = legendSet.legends[i];
	
	        if (value >= parseFloat(legend.startValue) && value < parseFloat(legend.endValue)) {
	            color = legend.color;
	            break;
	        }
	    }
	
	    return color;
	};
	
	AppManager.prototype.getDisplayPropertyUrl = function () {
	    if (this.displayPropertyUrl) {
	        return this.displayPropertyUrl;
	    }
	
	    var key = this.getDisplayProperty();
	
	    return this.displayPropertyUrl = key + '~rename(name)';
	};
	
	AppManager.prototype.isUiLocaleDefault = function () {
	    return this.getUiLocale() === this.defaultUiLocale;
	};
	
	AppManager.prototype.getAnalysisFields = function () {
	    return this.analysisFields ? this.analysisFields : this.analysisFields = (0, _stringReplaceAll2.default)(this.defaultAnalysisFields.join(','), '$', this.getDisplayPropertyUrl());
	};
	
	AppManager.prototype.getRootNode = function () {
	    return this.getRootNodes()[0];
	};
	
	// dep 2
	
	AppManager.prototype.getLegendSetIdByDxId = function (id, fn) {
	    if (!((0, _isString2.default)(id) && (0, _isFunction2.default)(fn))) {
	        return;
	    }
	
	    var t = this;
	
	    var legendSetId;
	
	    new t.refs.api.Request(t.refs, {
	        type: 'json',
	        baseUrl: t.getApiPath() + '/indicators.json',
	        params: ['filter=id:eq:' + id, 'fields=legendSet[id]', 'paging=false'],
	        success: function success(json) {
	            if ((0, _isArray2.default)(json.indicators) && json.indicators.length) {
	                if ((0, _isObject2.default)(json.indicators[0].legendSet)) {
	                    var legendSet = json.indicators[0].legendSet;
	
	                    if ((0, _isObject2.default)(legendSet)) {
	                        legendSetId = legendSet.id;
	                    }
	                }
	            }
	        },
	        complete: function complete() {
	            fn(legendSetId);
	        }
	    }).run();
	};
	
	AppManager.prototype.getOptionSets = function (response, callbackFn) {
	    var optionSetHeaders = response.getOptionSetHeaders();
	    var dhis2 = window.dhis2;
	
	    if (optionSetHeaders.length) {
	        var callbacks = 0,
	            optionMap = {};
	
	        var fn = function fn() {
	            if (++callbacks === optionSetHeaders.length) {
	                response.metaData.optionNames = optionMap;
	                callbackFn();
	            }
	        };
	
	        var getObjectMap = function getObjectMap(array) {
	            var idProperty = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'id';
	            var nameProperty = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'name';
	            var namePrefix = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
	
	            if (!((0, _isArray2.default)(array) && array.length)) {
	                return {};
	            }
	
	            var map = {};
	
	            array.forEach(function (obj) {
	                map[namePrefix + obj[idProperty]] = obj[nameProperty];
	            });
	
	            return map;
	        };
	
	        var getOptions = function getOptions(optionSetId, dataElementId) {
	            dhis2.er.store.get('optionSets', optionSetId).done(function (obj) {
	                _extends(optionMap, getObjectMap(obj.options, 'code', 'name', dataElementId));
	                fn();
	            });
	        };
	
	        // execute
	        optionSetHeaders.forEach(function (header) {
	            var optionSetIds = (0, _arrayFrom2.default)(header.optionSet);
	            var dataElementId = header.name;
	
	            optionSetIds.forEach(function (id) {
	                getOptions(id, dataElementId);
	            });
	        });
	    } else {
	        callbackFn();
	    }
	};
	//# sourceMappingURL=AppManager.js.map

/***/ },
/* 142 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.CalendarManager = undefined;
	
	var _isObject = __webpack_require__(2);
	
	var _isObject2 = _interopRequireDefault(_isObject);
	
	var _arrayContains = __webpack_require__(4);
	
	var _arrayContains2 = _interopRequireDefault(_arrayContains);
	
	var _arrayTo = __webpack_require__(6);
	
	var _arrayTo2 = _interopRequireDefault(_arrayTo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CalendarManager = exports.CalendarManager = undefined;
	
	exports.CalendarManager = CalendarManager = function CalendarManager(refs, config) {
	    var t = this;
	
	    config = (0, _isObject2.default)(config) ? config : {};
	
	    // constructor
	    t.baseUrl = config.baseUrl || '..';
	    t.dateFormat = config.dateFormat || 'yyyy-MM-dd';
	    t.defaultCalendarId = 'gregorian';
	    t.defaultCalendarIsoId = 'iso8601';
	    t.calendarIds = ['coptic', 'ethiopian', 'islamic', 'julian', 'nepali', 'thai', 'persian'];
	
	    // uninitialized
	    t.calendar;
	    t.periodGenerator;
	
	    // transient
	    t.calendarIdMap;
	};
	
	CalendarManager.prototype.setBaseUrl = function (baseUrl) {
	    this.baseUrl = baseUrl;
	};
	
	CalendarManager.prototype.setDateFormat = function (dateFormat) {
	    this.dateFormat = dateFormat;
	};
	
	CalendarManager.prototype.getPeriodScriptUrl = function () {
	    return this.baseUrl + '/dhis-web-commons/javascripts/dhis2/dhis2.period.js';
	};
	
	CalendarManager.prototype.getCalendarScriptUrl = function (calendarId) {
	    return this.baseUrl + '/dhis-web-commons/javascripts/jQuery/calendars/jquery.calendars.' + calendarId + '.min.js';
	};
	
	CalendarManager.prototype.getCalendarIdMap = function () {
	    if (this.calendarIdMap) {
	        return this.calendarIdMap;
	    }
	
	    this.calendarIdMap = {};
	    this.calendarIdMap[this.defaultCalendarIsoId] = this.defaultCalendarId;
	
	    return this.calendarIdMap;
	};
	
	CalendarManager.prototype.createCalendar = function (calendarId) {
	    this.calendar = $.calendars.instance(calendarId);
	};
	
	CalendarManager.prototype.createPeriodGenerator = function (calendarId) {
	    this.periodGenerator = new dhis2.period.PeriodGenerator(this.calendar, this.dateFormat);
	};
	
	CalendarManager.prototype.applyTo = function (modules) {
	    var t = this;
	
	    (0, _arrayTo2.default)(modules).forEach(function (module) {
	        module.calendarManager = t;
	    });
	};
	
	// dep 1
	
	CalendarManager.prototype.init = function (calendarId, dateFormat) {
	    calendarId = this.getCalendarIdMap()[calendarId] || calendarId || this.defaultCalendarId;
	
	    if (this.calendar && this.periodGenerator) {
	        return;
	    }
	
	    var t = this,
	        periodUrl = t.getPeriodScriptUrl(),
	        success = function success() {
	        t.createCalendar(calendarId);
	        t.createPeriodGenerator(calendarId);
	    };
	
	    if ((0, _arrayContains2.default)(t.calendarIds, calendarId)) {
	        var calendarUrl = t.getCalendarScriptUrl(calendarId);
	
	        $.getScript(calendarUrl, function () {
	            $.getScript(periodUrl, function () {
	                success();
	            });
	        });
	    } else {
	        $.getScript(periodUrl, function () {
	            success();
	        });
	    }
	};
	//# sourceMappingURL=CalendarManager.js.map

/***/ },
/* 143 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.I18nManager = undefined;
	
	var _arrayTo = __webpack_require__(6);
	
	var _arrayTo2 = _interopRequireDefault(_arrayTo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var I18nManager = exports.I18nManager = undefined;
	
	exports.I18nManager = I18nManager = function I18nManager(refs, config) {
	    var t = this;
	
	    var translations = config || {};
	
	    // prototype
	    t.add = function (obj, force) {
	        if (force) {
	            translations = obj;
	        } else {
	            $.extend(translations, obj);
	        }
	    };
	
	    t.get = function (key) {
	        return key ? translations[key] : translations;
	    };
	};
	
	I18nManager.prototype.applyTo = function (modules) {
	    var t = this;
	
	    (0, _arrayTo2.default)(modules).forEach(function (module) {
	        module.i18nManager = t;
	    });
	};
	//# sourceMappingURL=I18nManager.js.map

/***/ },
/* 144 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.IndexedDbManager = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _arrayFrom = __webpack_require__(5);
	
	var _arrayFrom2 = _interopRequireDefault(_arrayFrom);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var IndexedDbManager = exports.IndexedDbManager = undefined;
	
	exports.IndexedDbManager = IndexedDbManager = function IndexedDbManager() {
	    var t = this;
	
	    // constants
	    var _db = 'dhis2';
	    var _objectStores = ['optionSets'];
	
	    _extends(t, new dhis2.storage.Store({
	        name: _db,
	        objectStores: _objectStores,
	        adapters: [dhis2.storage.IndexedDBAdapter, dhis2.storage.DomSessionStorageAdapter, dhis2.storage.InMemoryAdapter]
	    }));
	
	    // cache
	    t.cachedOptionSets = {};
	};
	
	IndexedDbManager.prototype.getCachedOptionSet = function (id) {
	    return this.cachedOptionSets[id];
	};
	
	IndexedDbManager.prototype.setCachedOptionSet = function (optionSet) {
	    this.cachedOptionSets[optionSet.id] = optionSet;
	};
	
	IndexedDbManager.prototype.hasCachedOptionSet = function (id) {
	    return id in this.cachedOptionSets;
	};
	
	// dep 1
	
	IndexedDbManager.prototype.getOptionSets = function (ids, callbackFn) {
	    ids = (0, _arrayFrom2.default)(ids);
	
	    var t = this;
	    var callbacks = 0;
	    var requestIds = [];
	    var optionSets = [];
	
	    var fn = function fn() {
	        if (!requestIds.length || requestIds.length === ++callbacks) {
	            callbackFn(optionSets);
	        }
	    };
	
	    // cached option sets
	    ids.forEach(function (id) {
	        var cachedOptionSet = t.getCachedOptionSet(id);
	
	        if (cachedOptionSet) {
	            optionSets.push(cachedOptionSet);
	        } else {
	            requestIds.push(id);
	        }
	    });
	
	    // requested option sets
	    if (requestIds.length) {
	        requestIds.forEach(function (id) {
	            t.get('optionSets', id).done(function (requestedOptionSet) {
	                t.setCachedOptionSet(requestedOptionSet);
	                optionSets.push(requestedOptionSet);
	
	                fn();
	            });
	        });
	    } else {
	        fn();
	    }
	};
	
	// dep 2
	
	IndexedDbManager.prototype.getCachedOption = function (code, optionSetId) {
	    var cachedOptionSet = this.getCachedOptionSet(optionSetId);
	
	    if (!cachedOptionSet) {
	        console.log('WARNING: Option set with id "' + optionSetId + '" not found');
	        return;
	    }
	
	    if (!cachedOptionSet.options) {
	        console.log('WARNING: Option set with id "' + optionSetId + '" has no options');
	        return;
	    }
	
	    return cachedOptionSet.options.find(function (option) {
	        return option.code === code;
	    });
	};
	
	// dep 3
	
	IndexedDbManager.prototype.getCachedOptionName = function (code, optionSetId) {
	    var cachedOption = this.getCachedOption(code, optionSetId);
	
	    if (!cachedOption) {
	        console.log('WARNING: Option set with id "' + optionSetId + '" has no option with code "' + code + '"');
	        return code;
	    }
	
	    return cachedOption.name;
	};
	//# sourceMappingURL=IndexedDbManager.js.map

/***/ },
/* 145 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.InstanceManager = undefined;
	
	var _isFunction = __webpack_require__(21);
	
	var _isFunction2 = _interopRequireDefault(_isFunction);
	
	var _isString = __webpack_require__(3);
	
	var _isString2 = _interopRequireDefault(_isString);
	
	var _isObject = __webpack_require__(2);
	
	var _isObject2 = _interopRequireDefault(_isObject);
	
	var _arrayContains = __webpack_require__(4);
	
	var _arrayContains2 = _interopRequireDefault(_arrayContains);
	
	var _arrayTo = __webpack_require__(6);
	
	var _arrayTo2 = _interopRequireDefault(_arrayTo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var InstanceManager = exports.InstanceManager = undefined;
	
	exports.InstanceManager = InstanceManager = function InstanceManager(refs) {
	    var t = this;
	
	    refs = (0, _isObject2.default)(refs) ? refs : {};
	
	    t.appManager = refs.appManager;
	    t.uiManager = refs.uiManager;
	    t.i18nManager = refs.i18nManager;
	    t.tableManager = refs.tableManager;
	    t.sessionStorageManager = refs.sessionStorageManager;
	
	    // state
	    var _state = {
	        favorite: null,
	        current: null
	    };
	
	    // done fn
	    var fn;
	
	    // initialized
	    t.plugin = false;
	    t.dashboard = false;
	
	    // configurable
	    t.apiResource;
	    t.apiEndpoint;
	    t.analyticsEndpoint = '/analytics';
	    t.dataStatisticsEventType;
	
	    // getter/setter
	    t.isStateFavorite = function () {
	        return !!_state.favorite;
	    };
	
	    t.isStateCurrent = function () {
	        return !!_state.current;
	    };
	
	    t.isStateDirty = function () {
	        return _state.favorite !== _state.current;
	    };
	
	    t.isStateSaved = function () {
	        return t.isStateFavorite() ? !t.isStateDirty() : false;
	    };
	
	    t.isStateUnsaved = function () {
	        return t.isStateFavorite() ? t.isStateDirty() : false;
	    };
	
	    t.getStateFavorite = function () {
	        return t.isStateFavorite() ? _state.favorite.clone() : _state.favorite;
	    };
	
	    t.getStateFavoriteId = function () {
	        return t.isStateFavorite() ? _state.favorite.id : null;
	    };
	
	    t.getStateFavoriteName = function () {
	        return t.isStateFavorite() ? _state.favorite.name : null;
	    };
	
	    t.getStateCurrent = function () {
	        return _state.current ? _state.current.clone() : _state.current;
	    };
	
	    t.setState = function (curr, isFavorite, skipStateWest, forceUiState) {
	        _state.current = curr ? curr : null;
	
	        if (!_state.current || isFavorite) {
	            _state.favorite = _state.current;
	        }
	
	        if (t.sessionStorageManager && _state.current) {
	            t.sessionStorageManager.set(_state.current.toSession(), t.appManager.sessionName);
	        }
	
	        var current = _state.current ? _state.current.clone() : null;
	        var favorite = _state.favorite ? _state.favorite.clone() : null;
	
	        t.uiManager.setState(current, favorite, isFavorite, skipStateWest, forceUiState);
	    };
	
	    t.setStateIf = function (curr, isFavorite) {
	        if (curr.id === t.getStateFavoriteId()) {
	            t.setState(curr, isFavorite);
	        }
	    };
	
	    t.getFn = function () {
	        return fn;
	    };
	
	    t.setFn = function (func) {
	        fn = func;
	    };
	
	    t.getRefs = function () {
	        return refs;
	    };
	};
	
	InstanceManager.prototype.getLayout = function (layoutConfig, fromFavorite) {
	    var t = this,
	        refs = t.getRefs(),
	        favorite = t.getStateFavorite(),
	        layout;
	
	    var Layout = refs.api.Layout;
	
	
	    layoutConfig = layoutConfig || t.uiManager.getUiState();
	
	    layout = new Layout(refs, layoutConfig);
	
	    if (layout) {
	        layout = favorite && fromFavorite ? favorite.apply(layout, Object.keys(layout)) : layout.apply(favorite);
	    }
	
	    return layout;
	};
	
	InstanceManager.prototype.getById = function (id, fn, doMask, doUnmask) {
	    var t = this,
	        refs = t.getRefs();
	
	    var _refs$api = refs.api,
	        Layout = _refs$api.Layout,
	        Request = _refs$api.Request;
	
	
	    id = (0, _isString2.default)(id) ? id : t.getStateFavoriteId() || null;
	
	    if (!(0, _isString2.default)(id)) {
	        console.log('Instance manager, getById, invalid id', id);
	        return;
	    }
	
	    var appManager = t.appManager;
	    var uiManager = t.uiManager;
	    var i18n = t.i18nManager ? t.i18nManager.get() : {};
	
	    fn = fn || function (layout, isFavorite) {
	        t.getReport(layout, isFavorite);
	    };
	
	    var request = new Request(refs, {
	        baseUrl: appManager.getApiPath() + '/' + t.apiEndpoint + '/' + id + '.json',
	        type: 'json',
	        beforeRun: function beforeRun() {
	            if (doMask) {
	                uiManager.mask();
	            }
	        },
	        afterRun: function afterRun() {
	            if (doUnmask) {
	                uiManager.unmask();
	            }
	        },
	        success: function success(r) {
	            $.ajax({
	                url: appManager.getApiPath() + '/' + t.apiEndpoint + '/' + id,
	                type: 'PATCH',
	                data: JSON.stringify({}),
	                // avoid jQuery choke on empty 200 Success response
	                dataType: 'text',
	                headers: appManager.defaultRequestHeaders,
	                success: function success(sharing) {
	                    var layout = new Layout(refs, r, { permission: "write" });
	                    fn(layout, true);
	                },
	                error: function error(xhr) {
	                    var permission = xhr.status === 404 ? "none" : "read";
	                    var layout = new Layout(refs, r, { permission: permission });
	                    fn(layout, true);
	                }
	            });
	        },
	        error: function error(r) {
	            if ((0, _arrayContains2.default)([403], parseInt(r.httpStatusCode))) {
	                r.message = i18n.you_do_not_have_access_to_all_items_in_this_favorite || r.message;
	            }
	
	            uiManager.alert(r);
	        }
	    });
	
	    request.add({
	        fields: appManager.getAnalysisFields()
	    });
	
	    request.run();
	};
	
	InstanceManager.prototype.delById = function (id, fn, doMask, doUnmask) {
	    if (!(0, _isString2.default)(id)) {
	        console.log('Invalid id', id);
	        return;
	    }
	
	    var t = this,
	        refs = this.getRefs();
	
	    var Request = refs.api.Request;
	
	
	    var appManager = t.appManager;
	    var uiManager = t.uiManager;
	    var i18n = t.i18nManager.get();
	
	    var request = new Request(refs, {
	        baseUrl: appManager.getApiPath() + '/' + t.apiEndpoint + '/' + id,
	        method: 'DELETE',
	        beforeRun: function beforeRun() {
	            if (doMask) {
	                uiManager.mask();
	            }
	        },
	        success: function (_success) {
	            function success(_x, _x2, _x3) {
	                return _success.apply(this, arguments);
	            }
	
	            success.toString = function () {
	                return _success.toString();
	            };
	
	            return success;
	        }(function (obj, success, r) {
	            if (doUnmask) {
	                uiManager.unmask();
	            }
	
	            fn && fn(obj, success, r);
	        }),
	        error: function error(r) {
	            uiManager.unmask();
	
	            uiManager.alert(r);
	        }
	    });
	
	    request.run();
	};
	
	InstanceManager.prototype.getSharingById = function (id, fn, options) {
	    var t = this,
	        refs = this.getRefs();
	    options = options || {};
	
	    var Request = refs.api.Request;
	
	
	    var appManager = t.appManager;
	
	    var request = new Request(refs, {
	        baseUrl: appManager.getApiPath() + '/sharing',
	        type: 'json',
	        success: function success(r) {
	            fn && fn(r);
	        },
	        error: function error(res) {
	            // If allowForbidden enabled, call the callback anyway, with an empty object
	            if (res.status == 403 && options.allowForbidden) {
	                success(null);
	            } else {
	                t.uiManager.alert(res);
	                t.uiManager.unmask();
	            }
	        }
	    });
	
	    request.add({
	        type: t.apiResource,
	        id: id
	    });
	
	    request.run();
	};
	
	InstanceManager.prototype.getUiState = function () {
	    return this.uiManager.getUiState();
	};
	
	InstanceManager.prototype.postDataStatistics = function () {
	    var t = this,
	        refs = this.getRefs();
	
	    var Request = refs.api.Request;
	
	
	    var request = new Request(refs, {
	        baseUrl: t.appManager.getApiPath() + '/dataStatistics',
	        method: 'POST'
	    });
	
	    request.add({
	        eventType: t.dataStatisticsEventType,
	        favorite: t.getStateFavoriteId()
	    });
	
	    request.run();
	};
	
	InstanceManager.prototype.applyTo = function (modules) {
	    var t = this;
	
	    (0, _arrayTo2.default)(modules).forEach(function (module) {
	        module.instanceManager = t;
	    });
	};
	
	InstanceManager.prototype.getInterpretationById = function (id, fn) {
	    if (!(0, _isString2.default)(id)) {
	        console.log('Invalid id', id);
	        return;
	    }
	
	    var t = this,
	        refs = this.getRefs();
	
	    var Request = refs.api.Request;
	
	
	    var appManager = t.appManager;
	    var uiManager = t.uiManager;
	
	    var request = new Request(refs, {
	        baseUrl: appManager.getApiPath() + '/interpretations/' + id + '.json',
	        type: 'json',
	        success: function success(r) {
	            if ((0, _isFunction2.default)(fn)) {
	                fn(r);
	            }
	        },
	        error: function error(r) {
	            uiManager.alert(r);
	        },
	        complete: function complete(r) {
	            if (!(0, _isFunction2.default)(fn)) {
	                uiManager.unmask();
	            }
	        }
	    });
	
	    request.add({
	        fields: 'id,created'
	    });
	
	    request.run();
	};
	
	// dep 1
	
	InstanceManager.prototype.getData = function (layout) {
	    layout = layout || this.getLayout();
	
	    return layout.data();
	};
	
	InstanceManager.prototype.getReport = function (layout, isFavorite, skipState, forceUiState, fn) {
	    var _ref = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {},
	        noError = _ref.noError,
	        errorMessage = _ref.errorMessage;
	
	    var t = this,
	        refs = this.getRefs();
	
	    var Response = refs.api.Response;
	
	
	    var _fn = function _fn() {
	        if (!skipState) {
	            t.setState(layout, isFavorite, false, forceUiState);
	        }
	
	        (fn || t.getFn())(layout);
	    };
	
	    // layout
	    if (!layout) {
	        layout = t.getLayout(undefined, true);
	
	        if (!layout) {
	            return;
	        }
	    }
	
	    // validation
	    if ((0, _isFunction2.default)(layout.val) && !layout.val(noError)) {
	        if (errorMessage) {
	            t.uiManager.updateErrorMessage(errorMessage, layout.el);
	        }
	        return;
	    }
	
	    t.uiManager.mask();
	
	    // response
	    var response = layout.getResponse();
	
	    // fn
	    if (response) {
	        _fn();
	    } else {
	        var reqMap = layout.data();
	
	        reqMap.metaData.done(function (md) {
	            reqMap.data.done(function (res) {
	                res.metaData = md.metaData;
	
	                var response = new Response(refs, res);
	
	                if (layout.showHierarchy === true) {
	                    response.sortOrganisationUnitsHierarchy();
	                }
	
	                layout.setResponse(response);
	
	                _fn();
	            });
	        });
	    }
	};
	//# sourceMappingURL=InstanceManager.js.map

/***/ },
/* 146 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.RequestManager = undefined;
	
	var _isArray = __webpack_require__(1);
	
	var _isArray2 = _interopRequireDefault(_isArray);
	
	var _isObject = __webpack_require__(2);
	
	var _isObject2 = _interopRequireDefault(_isObject);
	
	var _isFunction = __webpack_require__(21);
	
	var _isFunction2 = _interopRequireDefault(_isFunction);
	
	var _arrayFrom = __webpack_require__(5);
	
	var _arrayFrom2 = _interopRequireDefault(_arrayFrom);
	
	var _arrayTo = __webpack_require__(6);
	
	var _arrayTo2 = _interopRequireDefault(_arrayTo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var RequestManager = exports.RequestManager = undefined;
	
	exports.RequestManager = RequestManager = function RequestManager(refs, config) {
	    var t = this;
	
	    config = (0, _isObject2.default)(config) ? config : {};
	
	    // constructor
	    t.requests = (0, _isArray2.default)(config.requests) ? config.requests : [];
	
	    t.responses = [];
	
	    t.fn = (0, _isFunction2.default)(config.fn) ? config.fn : function () {
	        console.log('Request manager done');
	    };
	
	    t.fnParams = [];
	};
	
	RequestManager.prototype.add = function (param) {
	    var t = this,
	        requests = (0, _arrayFrom2.default)(param);
	
	    requests.forEach(function (request) {
	        request.setManager(t);
	    });
	
	    this.requests = [].concat(this.requests, requests);
	};
	
	RequestManager.prototype.set = function (fn, params) {
	    this.fn = fn;
	
	    if (params) {
	        this.fnParams = params;
	    }
	};
	
	RequestManager.prototype.ok = function (xhr, suppress) {
	    this.responses.push(xhr);
	
	    if (!suppress) {
	        this.resolve();
	    }
	};
	
	RequestManager.prototype.run = function () {
	    this.requests.forEach(function (request) {
	        request.run();
	    });
	};
	
	RequestManager.prototype.resolve = function () {
	    if (this.responses.length === this.requests.length) {
	        this.fn(this.fnParams);
	    }
	};
	
	RequestManager.prototype.applyTo = function (modules) {
	    var t = this;
	
	    (0, _arrayTo2.default)(modules).forEach(function (module) {
	        module.requestManager = t;
	    });
	};
	//# sourceMappingURL=RequestManager.js.map

/***/ },
/* 147 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var SessionStorageManager = exports.SessionStorageManager = undefined;
	
	exports.SessionStorageManager = SessionStorageManager = function SessionStorageManager(refs) {
	    var t = this;
	
	    // constants
	    t.db = 'dhis2';
	    t.supported = 'sessionStorage' in window && window['sessionStorage'] !== null;
	
	    // fn
	    t.supportHandler = function () {
	        if (!this.supported) {
	            alert("Your browser is outdated and does not support local storage. Please upgrade your browser.");
	            return;
	        }
	
	        return true;
	    };
	};
	
	SessionStorageManager.prototype.get = function (session) {
	    if (!this.supportHandler()) {
	        return;
	    }
	
	    var db = JSON.parse(sessionStorage.getItem(this.db)) || {};
	
	    return db[session];
	};
	
	SessionStorageManager.prototype.set = function (layout, session, redirectUrl) {
	    if (!this.supportHandler()) {
	        return;
	    }
	
	    var db = JSON.parse(sessionStorage.getItem(this.db)) || {};
	    db[session] = layout;
	    sessionStorage.setItem(this.db, JSON.stringify(db));
	
	    if (redirectUrl) {
	        window.location.href = redirectUrl;
	    }
	};
	//# sourceMappingURL=SessionStorageManager.js.map

/***/ },
/* 148 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.TableManager = undefined;
	
	var _isString = __webpack_require__(3);
	
	var _isString2 = _interopRequireDefault(_isString);
	
	var _isArray = __webpack_require__(1);
	
	var _isArray2 = _interopRequireDefault(_isArray);
	
	var _arrayContains = __webpack_require__(4);
	
	var _arrayContains2 = _interopRequireDefault(_arrayContains);
	
	var _Period = __webpack_require__(59);
	
	var _Dimension = __webpack_require__(58);
	
	var _OrganisationUnit = __webpack_require__(117);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TableManager = exports.TableManager = undefined;
	
	exports.TableManager = TableManager = function TableManager(c) {
	    var t = this;
	
	    var appManager = c.appManager,
	        instanceManager = c.instanceManager,
	        uiManager = c.uiManager,
	        sessionStorageManager = c.sessionStorageManager,
	        dimensionConfig = c.dimensionConfig;
	
	    // Metadata item types to provide details about
	    var METADATA_DETAILED_TYPES = ['CATEGORY_OPTION', 'DATA_ELEMENT', 'PROGRAM_INDICATOR', 'INDICATOR'];
	
	    var toggleDirection = function toggleDirection(direction) {
	        return direction.toUpperCase() === 'ASC' ? 'DESC' : 'ASC';
	    };
	
	    var sortIdMap = {
	        'pe': 'eventdate',
	        'ou': 'ouname'
	    };
	
	    var getSortId = function getSortId(id, type) {
	        if (type === dimensionConfig.dataType['aggregated_values']) {
	            return id;
	        }
	
	        return sortIdMap[id] || id;
	    };
	
	    var onColumnHeaderMouseClick = function onColumnHeaderMouseClick(layout, id) {
	        var sortId = getSortId(id);
	
	        if (layout.sorting && layout.sorting.id === sortId) {
	            layout.sorting.direction = toggleDirection(layout.sorting.direction);
	        } else {
	            layout.sorting = {
	                id: getSortId(id, layout.dataType),
	                direction: 'DESC'
	            };
	        }
	
	        instanceManager.getReport(layout);
	    };
	
	    var onColumnHeaderMouseOver = function onColumnHeaderMouseOver(el) {
	        var elObject = $(el);
	
	        if (elObject) {
	            elObject.addClass('pointer highlighted');
	        }
	    };
	
	    var onColumnHeaderMouseOut = function onColumnHeaderMouseOut(el) {
	        var elObject = $(el);
	
	        if (elObject) {
	            elObject.removeClass('pointer highlighted');
	        }
	    };
	
	    t.setColumnHeaderMouseHandlers = function (layout, table) {
	        var elObjects = table.sortableIdObjects,
	            dom;
	
	        elObjects.forEach(function (item) {
	            dom = document.getElementById(item.uuid);
	
	            if (dom) {
	                dom.layout = layout;
	                dom.metaDataId = item.id;
	                dom.onColumnHeaderMouseClick = onColumnHeaderMouseClick;
	                dom.onColumnHeaderMouseOver = onColumnHeaderMouseOver;
	                dom.onColumnHeaderMouseOut = onColumnHeaderMouseOut;
	
	                dom.setAttribute('onclick', 'this.onColumnHeaderMouseClick(this.layout, this.metaDataId)');
	                dom.setAttribute('onmouseover', 'this.onColumnHeaderMouseOver(this)');
	                dom.setAttribute('onmouseout', 'this.onColumnHeaderMouseOut(this)');
	            }
	        });
	    };
	
	    var onValueMouseClick = function onValueMouseClick(layout, table, uuid) {
	        var uuidObjectMap = table.getUuidObjectMap(),
	            response = layout.getResponse(),
	            parentGraphMap = {},
	            objects = [],
	            path = appManager.getPath(),
	            dom = document.getElementById(uuid),
	            periodId = dom.getAttribute('data-period-id'),
	            ouId = dom.getAttribute('data-ou-id'),
	            i18n = layout.getRefs().i18nManager.get(),
	            menu;
	
	        var uuids = table.uuidDimUuidsMap[uuid];
	
	        // modify layout dimension items based on uuid objects
	
	        // get objects
	        for (var i = 0; i < uuids.length; i++) {
	            objects.push(uuidObjectMap[uuids[i]]);
	        }
	
	        // clear layoutConfig dimension items
	        layout.removeDimensionItems();
	
	        // add new items
	        for (var i = 0, obj, axis, dimension; i < objects.length; i++) {
	            obj = objects[i];
	
	            axis = obj.axis === 'column' ? layout.columns || [] : layout.rows || [];
	
	            if (axis.length) {
	                dimension = axis[obj.dim];
	
	                dimension.add({
	                    id: obj.id,
	                    name: response.getNameById(obj.id)
	                });
	            }
	        }
	
	        // parent graph map
	        for (var i = 0, id; i < objects.length; i++) {
	            id = objects[i].id;
	
	            if (layout.parentGraphMap && layout.parentGraphMap.hasOwnProperty(id)) {
	                parentGraphMap[id] = layout.parentGraphMap[id];
	            }
	        }
	
	        layout.parentGraphMap = parentGraphMap;
	
	        layout.toSession();
	
	        var menuItems = [{
	            text: i18n.open_selection_as,
	            iconCls: 'ns-menu-item-datasource',
	            menu: [{
	                text: i18n.open_selection_as_chart,
	                iconCls: 'ns-button-icon-chart',
	                param: 'chart',
	                handler: function handler() {
	                    sessionStorageManager.set(layout, 'analytical', path + '/dhis-web-visualizer/index.html?s=analytical');
	                },
	                listeners: {
	                    render: function render() {
	                        //TODO
	                        this.getEl().on('mouseover', function () {
	                            onValueMenuMouseHover(table, uuid, 'mouseover', 'chart');
	                        });
	
	                        this.getEl().on('mouseout', function () {
	                            onValueMenuMouseHover(table, uuid, 'mouseout', 'chart');
	                        });
	                    }
	                }
	            }, {
	                text: i18n.open_selection_as_map,
	                iconCls: 'ns-button-icon-map',
	                param: 'map',
	                disabled: true,
	                handler: function handler() {
	                    sessionStorageManager.set(layout, 'analytical', path + '/dhis-web-mapping/index.html?s=analytical');
	                },
	                listeners: {
	                    render: function render() {
	                        this.getEl().on('mouseover', function () {
	                            onValueMenuMouseHover(table, uuid, 'mouseover', 'map');
	                        });
	
	                        this.getEl().on('mouseout', function () {
	                            onValueMenuMouseHover(table, uuid, 'mouseout', 'map');
	                        });
	                    }
	                }
	            }]
	        }];
	
	        if (periodId) {
	            var periodMenuItems = [];
	            var period = new _Period.Period({
	                id: periodId,
	                name: response.getNameById(periodId)
	            }, layout.getRefs());
	
	            period.generateDisplayProperties();
	
	            var periods = period.getContextMenuItemsConfig();
	
	            for (var _i = 0, periodItem; _i < periods.length; ++_i) {
	                periodItem = periods[_i];
	
	                if (periodItem.isSubtitle) {
	                    periodMenuItems.push({
	                        xtype: 'label',
	                        html: periodItem.text,
	                        style: periodItem.style
	                    });
	
	                    continue;
	                }
	
	                periodMenuItems.push({
	                    text: periodItem.text,
	                    iconCls: periodItem.iconCls,
	                    peReqItems: periodItem.items,
	                    handler: function handler() {
	                        var layout = instanceManager.getStateCurrent();
	                        var peDimension = new _Dimension.Dimension(layout.getRefs(), { dimension: 'pe', items: this.peReqItems });
	
	                        layout.replaceDimensionByName(peDimension);
	
	                        layout.setResponse(null);
	
	                        instanceManager.getReport(layout, false, false, true);
	                    }
	                });
	            }
	
	            menuItems.push({
	                text: i18n.period_drill_down_up,
	                iconCls: 'ns-menu-item-datasource',
	                menu: periodMenuItems
	            });
	        }
	
	        // menu
	        menu = Ext.create('Ext.menu.Menu', {
	            shadow: true,
	            showSeparator: false,
	            items: menuItems
	        });
	
	        if (ouId) {
	            (function () {
	                menu.add({
	                    uid: 'OU_MENU',
	                    text: i18n.organisation_units_drill_down || 'Org unit drill down/up',
	                    iconCls: 'ns-menu-item-datasource',
	                    menu: {
	                        items: [{ html: '<div class="spinner"></div>' }]
	                    }
	                });
	
	                var ouMenu = menu.items.findBy(function (submenu) {
	                    return submenu.uid === 'OU_MENU';
	                });
	                var organisationUnit = new _OrganisationUnit.OrganisationUnit(layout.getRefs(), { id: ouId });
	
	                uiManager.mask();
	
	                organisationUnit.getAncestorsRequest(true).done(function (data) {
	                    organisationUnit.setAncestors(data.ancestors);
	                    organisationUnit.setLevel(data.level);
	
	                    var organisationUnitMenuItems = organisationUnit.getContextMenuItemsConfig();
	
	                    // setting click handler
	                    for (var i = 0; i < organisationUnitMenuItems.length; ++i) {
	                        var ou = organisationUnitMenuItems[i];
	
	                        if (ou.isSubtitle) {
	                            continue;
	                        }
	
	                        ou.handler = function () {
	                            var layout = instanceManager.getStateCurrent();
	                            var ouDimension = new _Dimension.Dimension(layout.getRefs(), { dimension: 'ou', items: this.items });
	
	                            layout.replaceDimensionByName(ouDimension);
	
	                            layout.setResponse(null);
	
	                            instanceManager.getReport(layout, false, false, true);
	                        };
	                    }
	
	                    ouMenu.menu.removeAll();
	                    ouMenu.menu.add(organisationUnitMenuItems);
	                    uiManager.unmask();
	                });
	            })();
	        }
	
	        menu.showAt(function () {
	            var el = Ext.get(uuid),
	                xy = el.getXY();
	
	            xy[0] += el.getWidth() - 5;
	            xy[1] += el.getHeight() - 5;
	
	            return xy;
	        }());
	    };
	
	    var onValueMouseOver = function onValueMouseOver(uuid) {
	        Ext.get(uuid).addCls('highlighted');
	    };
	
	    var onValueMouseOut = function onValueMouseOut(uuid) {
	        Ext.get(uuid).removeCls('highlighted');
	    };
	
	    var onValueMenuMouseHover = function onValueMenuMouseHover(table, uuid, event, param) {
	        var uuidDimUuidsMap = table.uuidDimUuidsMap,
	            dimUuids;
	
	        // dimension elements
	        if (param === 'chart') {
	            if ((0, _isString2.default)(uuid) && (0, _isArray2.default)(uuidDimUuidsMap[uuid])) {
	                dimUuids = uuidDimUuidsMap[uuid];
	
	                for (var i = 0, el; i < dimUuids.length; i++) {
	                    el = Ext.get(dimUuids[i]);
	
	                    if (el) {
	                        if (event === 'mouseover') {
	                            el.addCls('highlighted');
	                        } else if (event === 'mouseout') {
	                            el.removeCls('highlighted');
	                        }
	                    }
	                }
	            }
	        }
	    };
	
	    t.setValueMouseHandlers = function (layout, table) {
	        var uuids = table.valueUuids,
	            valueEl;
	
	        for (var uuid in uuids) {
	            valueEl = Ext.get(uuids[uuid]);
	
	            if (valueEl && !isNaN(parseFloat(valueEl.dom.textContent))) {
	                valueEl.dom.onValueMouseClick = onValueMouseClick;
	                valueEl.dom.onValueMouseOver = onValueMouseOver;
	                valueEl.dom.onValueMouseOut = onValueMouseOut;
	                valueEl.dom.layout = layout;
	                valueEl.dom.table = table;
	                valueEl.dom.setAttribute('onclick', 'this.onValueMouseClick(this.layout, this.table, this.id);');
	                valueEl.dom.setAttribute('onmouseover', 'this.onValueMouseOver(this);');
	                valueEl.dom.setAttribute('onmouseout', 'this.onValueMouseOut(this);');
	            }
	        }
	    };
	
	    t.setDimensionMouseHandlers = function (layout, table) {
	        var response = layout.getResponse();
	
	        var setMouseHandler = function setMouseHandler(obj) {
	            var item = response.metaData.items[obj.id];
	
	            if (item && (0, _arrayContains2.default)(METADATA_DETAILED_TYPES, item.dimensionItemType)) {
	                (function () {
	                    var html = '<p>Type: ' + item.dimensionItemType + '</p>';
	
	                    if (item.description) {
	                        html += '<p>Description: ' + item.description + '</p>';
	                    }
	
	                    if (item.code) {
	                        html += '<p>Code: ' + item.code + '</p>';
	                    }
	
	                    var tip = Ext.create('Ext.tip.ToolTip', {
	                        target: Ext.get(obj.uuid),
	                        bodyStyle: 'font-size: 110%',
	                        html: html
	                    });
	
	                    Ext.get(obj.uuid).on({
	                        mouseover: function mouseover() {
	                            Ext.Function.createBuffered(tip.show, 1000, tip);
	                        }
	                    });
	                })();
	            }
	        };
	
	        if (table.colAxis && table.colAxis.uuidObjectMap) {
	            for (var key in table.colAxis.uuidObjectMap) {
	                if (table.colAxis.uuidObjectMap.hasOwnProperty(key)) {
	                    setMouseHandler(table.colAxis.uuidObjectMap[key]);
	                }
	            }
	        }
	
	        if (table.rowAxis && table.rowAxis.uuidObjectMap) {
	            for (var _key in table.rowAxis.uuidObjectMap) {
	                if (table.rowAxis.uuidObjectMap.hasOwnProperty(_key)) {
	                    setMouseHandler(table.rowAxis.uuidObjectMap[_key]);
	                }
	            }
	        }
	    };
	};
	//# sourceMappingURL=TableManager.js.map

/***/ },
/* 149 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.UiManager = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _isArray = __webpack_require__(1);
	
	var _isArray2 = _interopRequireDefault(_isArray);
	
	var _isFunction = __webpack_require__(21);
	
	var _isFunction2 = _interopRequireDefault(_isFunction);
	
	var _isObject = __webpack_require__(2);
	
	var _isObject2 = _interopRequireDefault(_isObject);
	
	var _isString = __webpack_require__(3);
	
	var _isString2 = _interopRequireDefault(_isString);
	
	var _arrayTo = __webpack_require__(6);
	
	var _arrayTo2 = _interopRequireDefault(_arrayTo);
	
	var _ConfirmWindow = __webpack_require__(159);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var UiManager = exports.UiManager = undefined;
	
	exports.UiManager = UiManager = function UiManager(refs) {
	    var t = this;
	
	    refs = (0, _isObject2.default)(refs) ? refs : {};
	
	    t.appManager = refs.appManager;
	    t.instanceManager = refs.instanceManager;
	    t.i18nManager;
	
	    t.preventMask = false;
	    t.introHtmlIsAsync = false;
	
	    var components = {};
	
	    var componentTags = {
	        onCurrent: [],
	        onFavorite: []
	    };
	
	    var componentGroups = {};
	
	    var defaultUpdateComponentName = 'centerRegion';
	
	    var theme = 'meringue';
	
	    var introHtml = '';
	
	    var introFn = Function.prototype;
	    var updateIntroHtml = Function.prototype;
	
	    var updateFn = function updateFn(content, elementId) {
	        var el = document.getElementById(elementId);
	
	        if (elementId && el) {
	            el.innerHTML = content;
	            return;
	        }
	
	        if (content) {
	            t.getUpdateComponent().update(content);
	            return;
	        }
	
	        t.getIntroHtml().then(function (html) {
	            t.getUpdateComponent().renew(html);
	        });
	    };
	
	    var updateInterpretationFn = function updateInterpretationFn(interpretation, layout) {
	        var layout = layout || t.instanceManager.getStateCurrent();
	
	        if (layout) {
	            layout.applyInterpretation(interpretation);
	
	            t.instanceManager.getReport(layout, true);
	        }
	    };
	
	    var resizeHandlers = t.appManager.getEventHandlerArray();
	
	    var withErrorStyle = function withErrorStyle(content) {
	        return '<div style="padding:20px; font-size:13px; color:#60606a">' + content + '</div>';
	    };
	
	    // setters
	    t.setInstanceManager = function (instanceManager) {
	        t.instanceManager = instanceManager;
	    };
	
	    t.setI18nManager = function (i18nManager) {
	        t.i18nManager = i18nManager;
	    };
	
	    t.setUpdateFn = function (fn) {
	        updateFn = fn;
	    };
	
	    t.setUpdateInterpretationFn = function (fn) {
	        updateInterpretationFn = fn;
	    };
	
	    // components
	    t.reg = function (cmp, name, tags, groups, doNotOverwrite) {
	        if (components.hasOwnProperty(name) && doNotOverwrite) {
	            return;
	        }
	
	        // cmp
	        components[name] = cmp;
	
	        // tags
	        if ((0, _isString2.default)(tags)) {
	            tags.split(',').forEach(function (tag) {
	                if ((0, _isArray2.default)(componentTags[tag])) {
	                    componentTags[tag].push(cmp);
	                }
	            });
	        }
	
	        // groups
	        if ((0, _isString2.default)(groups)) {
	            groups.split(',').forEach(function (group) {
	                componentGroups[group] = (0, _isArray2.default)(componentGroups[group]) ? componentGroups[group] : [];
	                componentGroups[group].push(cmp);
	            });
	        }
	
	        return cmp;
	    };
	
	    t.unreg = function (name) {
	        delete components[name];
	    };
	
	    t.get = function (name) {
	        return components[name] || document.getElementById(name) || null;
	    };
	
	    t.subscribe = function (component, fn) {
	        t.get(component) && t.get(component).subscribe(fn);
	    };
	
	    t.setScrollFn = function (component, fn) {
	        t.get(component) && t.get(component).setScroll(fn);
	    };
	
	    t.removeScrollFn = function (component) {
	        t.get(component) && t.get(component).removeScroll();
	    };
	
	    t.setOnResizeFn = function (component, fn) {
	        t.get(component) && t.get(component).setOnResize(fn);
	    };
	
	    t.removeResizeFn = function (component) {
	        t.get(component) && t.get(component).removeOnResize();
	    };
	
	    t.scrollTo = function (component, x, y) {
	        t.get(component) && t.get(component).scrollTo(x, y);
	    };
	
	    t.getByGroup = function (groupName) {
	        return componentGroups[groupName];
	    };
	
	    t.getUpdateComponent = function () {
	        return t.get(defaultUpdateComponentName);
	    };
	
	    t.setUpdateComponent = function (name) {
	        defaultUpdateComponentName = name;
	    };
	
	    t.componentFrom = function (param) {
	        return (0, _isString2.default)(param) ? t.get(param) : param;
	    };
	
	    t.update = function (content, elementId) {
	        updateFn(content, elementId);
	    };
	
	    t.updateErrorMessage = function (content, elementId) {
	        t.update(withErrorStyle(content), elementId);
	    };
	
	    t.toggleCollapseRegion = function (region) {
	        t.get(region).toggleCollapse();
	    };
	
	    t.updateInterpretation = function (interpretation, layout) {
	        updateInterpretationFn(interpretation, layout);
	    };
	
	    // state
	    t.setState = function (currentState, favoriteState, isFavorite, skipStateWest, forceUiState, skipStateCenter) {
	        var north = t.get('northRegion'),
	            west = t.get('westRegion'),
	            east = t.get('eastRegion');
	
	        // app, not plugin
	        if (!t.instanceManager.plugin) {
	
	            // set url state
	            if (favoriteState) {
	                t.setUrlState('?id=' + favoriteState.id + (favoriteState.interpretationId ? '&interpretationid=' + favoriteState.interpretationId : ''));
	            } else {
	                t.setUrlState('.');
	            }
	
	            // toolbar
	            if (north) {
	                north.setState(currentState, isFavorite);
	            }
	
	            // current
	            componentTags.onCurrent.forEach(function (item) {
	                item.setDisabled(!(currentState && item.enable));
	            });
	
	            // favorite
	            componentTags.onFavorite.forEach(function (item) {
	                item.setDisabled(!(currentState && item.enable && isFavorite));
	            });
	
	            // west
	            if (forceUiState || west && !skipStateWest && (!currentState || isFavorite)) {
	                west.setState(currentState);
	            }
	
	            // east
	            if (east) {
	                east.setState(currentState);
	            }
	        }
	
	        // set init text
	        if (!currentState) {
	            t.update();
	        }
	    };
	
	    t.setUrlState = function (text) {
	        global.history.pushState(null, null, text);
	    };
	
	    // theme
	    t.getTheme = function () {
	        return theme;
	    };
	
	    t.setTheme = function (newTheme) {
	        theme = newTheme;
	    };
	
	    // intro
	    t.getIntroHtml = function () {
	        if (t.introHtmlIsAsync) {
	            return updateIntroHtml();
	        }
	        return introHtml;
	    };
	
	    t.setUpdateIntroHtmlFn = function (fn) {
	        updateIntroHtml = fn;
	    };
	
	    t.setIntroHtml = function (html) {
	        return introHtml = html;
	    };
	
	    t.setIntroFn = function (fn) {
	        introFn = fn;
	    };
	
	    t.callIntroFn = function () {
	        introFn();
	    };
	
	    // browser
	    t.getScrollbarSize = function () {
	        var size,
	            body = document.body,
	            div = document.createElement('div');
	
	        div.style.width = div.style.height = '100px';
	        div.style.overflow = 'scroll';
	        div.style.position = 'absolute';
	
	        body.appendChild(div);
	
	        size = {
	            width: div.offsetWidth - div.clientWidth,
	            height: div.offsetHeight - div.clientHeight
	        };
	
	        body.removeChild(div);
	
	        return size;
	    };
	
	    t.isScrolled = function (e) {
	        var el = e.srcElement,
	            scrollBottom = el.scrollTop + el.clientHeight / el.scrollHeight * el.scrollHeight;
	
	        return scrollBottom / el.scrollHeight > 0.9;
	    };
	
	    // multiselect
	    t.msSetHeight = function (ms, panel, fill) {
	        var toolbarHeight = 25,
	            height;
	
	        ms.forEach(function (item) {
	            height = panel.getHeight() - fill - (item.hasToolbar ? toolbarHeight : 0);
	            item.setHeight(height);
	        });
	    };
	
	    t.msSelect = function (a, s) {
	        var selected = a.getValue();
	        if (selected.length) {
	            var array = [];
	            selected.forEach(function (item) {
	                array.push(a.store.getAt(a.store.findExact('id', item)));
	            });
	            s.store.add(array);
	        }
	        t.msFilterAvailable(a, s);
	    };
	
	    t.msSelectAll = function (a, s, isReverse) {
	        var array = a.store.getRange();
	        if (isReverse) {
	            array.reverse();
	        }
	        s.store.add(array);
	        t.msFilterAvailable(a, s);
	    };
	
	    t.msUnselect = function (a, s) {
	        var selected = s.getValue();
	        if (selected.length) {
	            selected.forEach(function (id) {
	                a.store.add(s.store.getAt(s.store.findExact('id', id)));
	                s.store.remove(s.store.getAt(s.store.findExact('id', id)));
	            });
	            t.msFilterAvailable(a, s);
	            a.store.sortStore();
	        }
	    };
	
	    t.msUnselectAll = function (a, s) {
	        a.store.add(s.store.getRange());
	        s.store.removeAll();
	        t.msFilterAvailable(a, s);
	        a.store.sortStore();
	    };
	
	    t.msFilterAvailable = function (a, s) {
	        if (a.store.getRange().length && s.store.getRange().length) {
	            var recordsToRemove = [];
	
	            a.store.each(function (ar) {
	                var removeRecord = false;
	
	                s.store.each(function (sr) {
	                    if (sr.data.id === ar.data.id) {
	                        removeRecord = true;
	                    }
	                });
	
	                if (removeRecord) {
	                    recordsToRemove.push(ar);
	                }
	            });
	
	            a.store.remove(recordsToRemove);
	        }
	    };
	
	    // mask
	    t.mask = function (component, message) {
	        component = (0, _isObject2.default)(component) ? component : t.get(component) || t.getUpdateComponent();
	
	        if (!(0, _isObject2.default)(component) || t.preventMask) {
	            //console.log('mask: no component', component, message);
	            return;
	        }
	
	        message = message || 'Loading..';
	
	        if (component.mask && component.mask.destroy) {
	            component.mask.destroy();
	            component.mask = null;
	        }
	
	        component.mask = new Ext.create('Ext.LoadMask', component, {
	            shadow: false,
	            msg: message,
	            style: 'box-shadow:0',
	            bodyStyle: 'box-shadow:0'
	        });
	
	        component.mask.show();
	    };
	
	    t.unmask = function (component) {
	        component = (0, _isObject2.default)(component) ? component : t.get(component) || t.getUpdateComponent();
	
	        if (!(0, _isObject2.default)(component)) {
	            //console.log('unmask: no component', component, message);
	            return;
	        }
	
	        if (component.mask && component.mask.destroy) {
	            component.mask.destroy();
	            component.mask = null;
	        }
	    };
	
	    // window
	    t.setAnchorPosition = function (w, target) {
	        target = t.componentFrom(target);
	
	        var txy = target.getPosition ? target.getPosition() : target.getXY ? target.getXY() : null,
	            th = target.getHeight(),
	            vpw = t.get('viewport').getWidth(),
	            ww = w.getWidth();
	
	        var tx = txy[0],
	            ty = txy[1] + th + 4;
	
	        if (tx + ww > vpw) {
	            w.setPosition(vpw - ww - 2, ty);
	        } else {
	            w.setPosition(tx, ty);
	        }
	    };
	
	    t.getBodyMask = function () {
	        return Ext.getBody().child('.x-mask');
	    };
	
	    t.addHideOnBlurHandler = function (w) {
	        t.getBodyMask().on('click', function () {
	            if (w.hideOnBlur) {
	                w.hide();
	            }
	        });
	
	        w.hasHideOnBlurHandler = true;
	    };
	
	    t.addDestroyOnBlurHandler = function (w) {
	        t.getBodyMask().on('click', function () {
	            if (w.destroyOnBlur) {
	                w.destroy();
	            }
	        });
	
	        w.hasDestroyOnBlurHandler = true;
	    };
	
	    // alert
	    t.alert = function (obj) {
	        var config = {},
	            type,
	            window;
	
	        if (!obj || (0, _isObject2.default)(obj) && !obj.message && !obj.responseText) {
	            return;
	        }
	
	        // if response object
	        if ((0, _isObject2.default)(obj) && obj.responseText && !obj.message) {
	            obj = JSON.parse(obj.responseText);
	        }
	
	        // if string
	        if ((0, _isString2.default)(obj)) {
	            obj = {
	                status: 'ERROR',
	                message: obj
	            };
	        }
	
	        // web message
	        type = (obj.status || 'INFO').toLowerCase();
	
	        config.title = obj.status;
	        config.iconCls = 'ns-window-title-messagebox ' + type;
	
	        // html
	        config.html = '';
	        config.html += obj.httpStatusCode ? 'Code: ' + obj.httpStatusCode + '<br>' : '';
	        config.html += obj.httpStatus ? 'Status: ' + obj.httpStatus + '<br><br>' : '';
	        config.html += obj.message + (obj.message.substr(obj.message.length - 1) === '.' ? '' : '.');
	
	        // bodyStyle
	        config.bodyStyle = 'padding: 12px; background: #fff; max-width: 600px; max-height: ' + t.getHeight() / 2 + 'px';
	
	        // destroy handler
	        config.modal = true;
	        config.destroyOnBlur = true;
	
	        // listeners
	        config.listeners = {
	            show: function show(w) {
	                w.setPosition(w.getPosition()[0], w.getPosition()[1] / 2);
	
	                if (!w.hasDestroyOnBlurHandler) {
	                    t.addDestroyOnBlurHandler(w);
	                }
	            }
	        };
	
	        window = Ext.create('Ext.window.Window', config);
	
	        window.show();
	    };
	
	    // context menu
	    t.enableRightClick = function () {
	        document.body.oncontextmenu = true;
	    };
	
	    t.disableRightClick = function () {
	        document.body.oncontextmenu = function () {
	            return false;
	        };
	    };
	
	    // dialogue
	    t.confirmUnsaved = function (title, fn) {
	        var i18n = t.i18nManager ? t.i18nManager.get() : {};
	
	        (0, _ConfirmWindow.ConfirmWindow)(refs, title, i18n.all_unsaved_changes_will_be_discarded_continue, null, fn).show();
	    };
	
	    t.confirmReplace = function (title, fn) {
	        var i18n = t.i18nManager ? t.i18nManager.get() : {};
	
	        (0, _ConfirmWindow.ConfirmWindow)(refs, title, i18n.existing_favorite_will_be_replaced_continue, null, fn).show();
	    };
	
	    t.confirmDelete = function (title, fn) {
	        var i18n = t.i18nManager ? t.i18nManager.get() : {};
	
	        (0, _ConfirmWindow.ConfirmWindow)(refs, title, i18n.this_favorite_will_be_deleted_continue, null, fn).show();
	    };
	
	    t.confirmRender = function (title, fn, cancelFn) {
	        var i18n = t.i18nManager ? t.i18nManager.get() : {};
	
	        (0, _ConfirmWindow.ConfirmWindow)(refs, title, i18n.render_table_warning, "Continue", fn, null, cancelFn, true).show();
	    };
	
	    t.confirmCustom = function (title, msg, btnText, fn, applyConfig) {
	        (0, _ConfirmWindow.ConfirmWindow)(refs, title, msg, btnText, fn, applyConfig).show();
	    };
	
	    t.confirmInterpretationDelete = function (fn) {
	        var i18n = t.i18nManager ? t.i18nManager.get() : {};
	        (0, _ConfirmWindow.ConfirmWindow)(refs, i18n.are_you_sure, i18n.this_interpretation_will_be_deleted_continue, null, fn).show();
	    };
	
	    t.confirmCommentDelete = function (fn) {
	        var i18n = t.i18nManager ? t.i18nManager.get() : {};
	        (0, _ConfirmWindow.ConfirmWindow)(refs, i18n.are_you_sure, i18n.this_comment_will_be_deleted_continue, null, fn).show();
	    };
	
	    // redirect
	    t.redirectCtrl = function (url, e) {
	        if (e.button === 0 && !e.ctrlKey) {
	            window.location.href = url;
	        } else if (e.ctrlKey && arrayContains([0, 1], e.button) || !e.ctrlKey && e.button === 1) {
	            window.open(url, '_blank');
	        }
	    };
	
	    // plugin
	    t.getTitleHtml = function (text) {
	        return text ? '<div style="' + 'height:19px;' + 'line-height:14px;' + 'width:100%;' + 'font:bold 12px LiberationSans,arial,sans-serif;' + 'color:#333;' + 'text-align:center;' + 'letter-spacing:-0.1px">' + text + '</div>' : '';
	    };
	
	    t.getEmbedHtml = function () {
	        var text = '',
	            version = 'v' + parseFloat(t.appManager.systemInfo.version.split('.').join('')),
	            resource = t.instanceManager.apiResource,
	            divId = resource + '1',
	            pluginName = resource + 'Plugin',
	            pluginFileName = (resource || '').toLowerCase(),
	            layout = t.instanceManager.getStateCurrent();
	
	        text += '<html>\n<head>\n';
	        text += '<script src="//code.jquery.com/jquery-2.2.4.min.js"></script>\n';
	        text += '<script src="//dhis2-cdn.org/' + version + '/plugin/' + pluginFileName + '.js"></script>\n';
	        text += '</head>\n\n<body>\n';
	        text += '<div id="' + divId + '"></div>\n\n';
	        text += '<script>\n\n';
	        text += pluginName + '.url = "<url to server>";\n';
	        text += pluginName + '.username = "<username>";\n';
	        text += pluginName + '.password = "<password>";\n\n';
	        text += resource + 'Plugin.load([' + JSON.stringify(layout.toPlugin(divId), null, 2) + ']);\n\n';
	        text += '</script>\n\n';
	        text += '</body>\n</html>';
	
	        return text;
	    };
	
	    t.renderLoadingIndicator = function (el) {
	        $('#' + el).append('<div class="spinner"></div>');
	    };
	
	    // resize
	    t.onResize = function (fn) {
	        resizeHandlers.push(fn);
	    };
	
	    t.resize = function (params) {
	        resizeHandlers.run(params);
	    };
	
	    // redirect
	    t.openTableLayoutTab = function (layout, type, isNewTab) {
	        layout = layout || t.instanceManager.getStateCurrent();
	        type = type || 'xls';
	
	        var url = layout.req(null, type, false, true).url();
	        var target = isNewTab ? '_blank' : '_top';
	
	        window.open(url, target);
	    };
	
	    t.openPlainDataSource = function (url, extraParamString, isNewTab) {
	        url = ((0, _isString2.default)(url) ? url : url.url()) + (extraParamString || '');
	        var target = isNewTab ? '_blank' : '_top';
	
	        window.open(url, target);
	    };
	
	    t.openDataDump = function (layout, format, scheme, isNewTab) {
	        layout = layout || t.instanceManager.getLayout();
	
	        var includeFilter = false;
	
	        if (layout) {
	            var extraParams = [];
	
	            layout.toRows(includeFilter);
	
	            format = format || 'csv';
	
	            if (layout.showHierarchy) {
	                extraParams.push('showHierarchy=true');
	            }
	
	            extraParams.push('rows=' + layout.getDimensionNames(includeFilter).join(';'));
	
	            var url = layout.req(null, format).url(extraParams);
	            var target = isNewTab ? '_blank' : '_top';
	
	            window.open(url, target);
	        }
	    };
	
	    // svg
	    t.getSvg = function () {
	        var svg = Ext.query('svg');
	
	        if (!((0, _isArray2.default)(svg) && svg.length)) {
	            alert('Browser does not support SVG');
	            return;
	        }
	
	        svg = Ext.get(svg[0]);
	        svg = svg.parent().dom.innerHTML;
	
	        return svg;
	    };
	
	    t.submitSvgForm = function (type, filename) {
	        var form = Ext.query('#exportForm')[0];
	        var chart = this.get('chart');
	
	        var svg = chart && (0, _isFunction2.default)(chart.getSVGForExport) ? chart.getSVGForExport() : this.getSvg();
	
	        if (!svg) {
	            return;
	        }
	
	        Ext.query('#svgField')[0].value = svg;
	        Ext.query('#filenameField')[0].value = filename || 'Untitled';
	
	        form.action = t.appManager.getPath() + '/api/svg.' + type;
	        form.submit();
	    };
	
	    // helpers
	    t.hexToRgb = function (hex) {
	        var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
	
	        return result ? [parseInt(result[1], 16), parseInt(result[2], 16), parseInt(result[3], 16)] : null;
	    };
	
	    t.calculateColorBrightness = function (rgb) {
	        return Math.round((parseInt(rgb[0]) * 299 + parseInt(rgb[1]) * 587 + parseInt(rgb[2]) * 114) / 1000);
	    };
	
	    t.isColorBright = function (rgbColor) {
	        return t.calculateColorBrightness(rgbColor) > 125;
	    };
	};
	
	UiManager.prototype.applyTo = function (modules) {
	    var t = this;
	
	    (0, _arrayTo2.default)(modules).forEach(function (module) {
	        module.uiManager = t;
	    });
	};
	
	UiManager.prototype.getWidth = function (cmpName) {
	    var t = this;
	
	    var cmp = cmpName ? t.componentFrom(cmpName) : t.getUpdateComponent();
	
	    return cmp.getWidth();
	};
	
	UiManager.prototype.getHeight = function (cmpName) {
	    var t = this;
	
	    var cmp = cmpName ? t.componentFrom(cmpName) : t.getUpdateComponent();
	
	    return cmp.getHeight();
	};
	
	UiManager.prototype.getUiState = function () {
	    return this.get('viewport').getUiState();
	};
	
	UiManager.prototype.enableConfirmUnload = function () {
	    var t = this;
	
	    window.onbeforeunload = function (event) {
	        return t.instanceManager && t.instanceManager.isStateUnsaved() ? ((typeof event === 'undefined' ? 'undefined' : _typeof(event)) ? event : window.event).returnValue = 'You have unsaved changes.' : null;
	    };
	};
	
	UiManager.prototype.disableConfirmUnload = function () {
	    window.onbeforeunload = function (event) {
	        return null;
	    };
	};
	//# sourceMappingURL=UiManager.js.map
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 150 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var extChartOverrides = exports.extChartOverrides = function extChartOverrides() {
	
	    Ext.override(Ext.chart.Chart, {
	        insetPaddingObject: {},
	
	        alignAxes: function alignAxes() {
	            var me = this,
	                axes = me.axes,
	                legend = me.legend,
	                edges = ['top', 'right', 'bottom', 'left'],
	                chartBBox,
	                insetPadding = me.insetPadding,
	                insetPaddingObject = me.insetPaddingObject,
	                insets = {
	                top: insetPaddingObject.top || insetPadding,
	                right: insetPaddingObject.right || insetPadding,
	                bottom: insetPaddingObject.bottom || insetPadding,
	                left: insetPaddingObject.left || insetPadding
	            };
	
	            function getAxis(edge) {
	                var i = axes.findIndex('position', edge);
	                return i < 0 ? null : axes.getAt(i);
	            }
	
	            Ext.each(edges, function (edge) {
	                var isVertical = edge === 'left' || edge === 'right',
	                    axis = getAxis(edge),
	                    bbox;
	
	                if (legend !== false) {
	                    if (legend.position === edge) {
	                        bbox = legend.getBBox();
	                        insets[edge] += (isVertical ? bbox.width : bbox.height) + insets[edge];
	                    }
	                }
	
	                if (axis && axis.bbox) {
	                    bbox = axis.bbox;
	                    insets[edge] += isVertical ? bbox.width : bbox.height;
	                }
	            });
	
	            chartBBox = {
	                x: insets.left,
	                y: insets.top,
	                width: me.curWidth - insets.left - insets.right,
	                height: me.curHeight - insets.top - insets.bottom
	            };
	            me.chartBBox = chartBBox;
	
	            axes.each(function (axis) {
	                var pos = axis.position,
	                    isVertical = pos === 'left' || pos === 'right';
	
	                axis.x = pos === 'right' ? chartBBox.x + chartBBox.width : chartBBox.x;
	                axis.y = pos === 'top' ? chartBBox.y : chartBBox.y + chartBBox.height;
	                axis.width = isVertical ? chartBBox.width : chartBBox.height;
	                axis.length = isVertical ? chartBBox.height : chartBBox.width;
	            });
	        }
	    });
	
	    Ext.override(Ext.chart.series.Line, {
	        drawSeries: function drawSeries() {
	            var ak = this,
	                au = ak.chart,
	                S = au.axes,
	                ao = au.getChartStore(),
	                V = ao.getCount(),
	                u = ak.chart.surface,
	                am = {},
	                R = ak.group,
	                K = ak.showMarkers,
	                aA = ak.markerGroup,
	                D = au.shadow,
	                C = ak.shadowGroups,
	                X = ak.shadowAttributes,
	                O = ak.smooth,
	                q = C.length,
	                ar = ["M"],
	                T = ["M"],
	                d = ["M"],
	                b = ["M"],
	                J = au.markerIndex,
	                ai = [].concat(ak.axis),
	                ah,
	                av = [],
	                ag = {},
	                aa = [],
	                v = {},
	                I = false,
	                Q = [],
	                az = ak.markerStyle,
	                Z = ak.style,
	                t = ak.colorArrayStyle,
	                P = t && t.length || 0,
	                L = Ext.isNumber,
	                aw = ak.seriesIdx,
	                g = ak.getAxesForXAndYFields(),
	                l = g.xAxis,
	                ay = g.yAxis,
	                ac,
	                h,
	                ab,
	                ad,
	                A,
	                c,
	                ae,
	                H,
	                G,
	                f,
	                e,
	                s,
	                r,
	                W,
	                N,
	                M,
	                at,
	                m,
	                F,
	                E,
	                aB,
	                n,
	                p,
	                B,
	                a,
	                Y,
	                af,
	                z,
	                aq,
	                w,
	                ap,
	                o,
	                ax,
	                an,
	                al,
	                U,
	                k,
	                aj;if (ak.fireEvent("beforedraw", ak) === false) {
	                return;
	            }if (!V || ak.seriesIsHidden) {
	                aj = this.items;if (aj) {
	                    for (N = 0, at = aj.length; N < at; ++N) {
	                        if (aj[N].sprite) {
	                            aj[N].sprite.hide(true);
	                        }
	                    }
	                }return;
	            }an = Ext.apply(az || {}, ak.markerConfig);U = an.type;delete an.type;al = Z;if (!al["stroke-width"]) {
	                al["stroke-width"] = 0.5;
	            }if (J && aA && aA.getCount()) {
	                for (N = 0; N < J; N++) {
	                    E = aA.getAt(N);aA.remove(E);aA.add(E);aB = aA.getAt(aA.getCount() - 2);E.setAttributes({ x: 0, y: 0, translate: { x: aB.attr.translation.x, y: aB.attr.translation.y } }, true);
	                }
	            }ak.unHighlightItem();ak.cleanHighlights();ak.setBBox();am = ak.bbox;ak.clipRect = [am.x, am.y, am.width, am.height];for (N = 0, at = ai.length; N < at; N++) {
	                m = S.get(ai[N]);if (m) {
	                    F = m.calcEnds();if (m.position == "top" || m.position == "bottom") {
	                        z = F.from;aq = F.to;
	                    } else {
	                        w = F.from;ap = F.to;
	                    }
	                }
	            }if (ak.xField && !L(z) && (l == "bottom" || l == "top") && !S.get(l)) {
	                m = Ext.create("Ext.chart.axis.Axis", { chart: au, fields: [].concat(ak.xField) }).calcEnds();z = m.from;aq = m.to;
	            }if (ak.yField && !L(w) && (ay == "right" || ay == "left") && !S.get(ay)) {
	                m = Ext.create("Ext.chart.axis.Axis", { chart: au, fields: [].concat(ak.yField) }).calcEnds();w = m.from;ap = m.to;
	            }if (isNaN(z)) {
	                z = 0;Y = am.width / (V - 1 || 1);
	            } else {
	                Y = am.width / (aq - z || V - 1 || 1);
	            }if (isNaN(w)) {
	                w = 0;af = am.height / (V - 1 || 1);
	            } else {
	                af = am.height / (ap - w || V - 1 || 1);
	            }ak.eachRecord(function (j, x) {
	                p = j.get(ak.xField);if (typeof p == "string" || (typeof p === 'undefined' ? 'undefined' : _typeof(p)) == "object" && !Ext.isDate(p) || l && S.get(l) && S.get(l).type == "Category") {
	                    if (p in ag) {
	                        p = ag[p];
	                    } else {
	                        p = ag[p] = x;
	                    }
	                }B = j.get(ak.yField);if (typeof B == "undefined" || typeof B == "string" && !B) {
	                    if (Ext.isDefined(Ext.global.console)) {
	                        Ext.global.console.warn("[Ext.chart.series.Line]  Skipping a store element with an undefined value at ", j, p, B);
	                    }return;
	                }if ((typeof B === 'undefined' ? 'undefined' : _typeof(B)) == "object" && !Ext.isDate(B) || ay && S.get(ay) && S.get(ay).type == "Category") {
	                    B = x;
	                }Q.push(x);av.push(p);aa.push(B);
	            });at = av.length;if (at > am.width) {
	                a = ak.shrink(av, aa, am.width);av = a.x;aa = a.y;
	            }ak.items = [];k = 0;at = av.length;for (N = 0; N < at; N++) {
	                p = av[N];B = aa[N];if (B === false) {
	                    if (T.length == 1) {
	                        T = [];
	                    }I = true;ak.items.push(false);continue;
	                } else {
	                    H = (am.x + (p - z) * Y).toFixed(2);G = (am.y + am.height - (B - w) * af).toFixed(2);if (I) {
	                        I = false;T.push("M");
	                    }T = T.concat([H, G]);
	                }if (typeof r == "undefined" && typeof G != "undefined") {
	                    r = G;s = H;
	                }if (!ak.line || au.resizing) {
	                    ar = ar.concat([H, am.y + am.height / 2]);
	                }if (au.animate && au.resizing && ak.line) {
	                    ak.line.setAttributes({ path: ar }, true);if (ak.fillPath) {
	                        ak.fillPath.setAttributes({ path: ar, opacity: 0.2 }, true);
	                    }if (ak.line.shadows) {
	                        ac = ak.line.shadows;for (M = 0, q = ac.length; M < q; M++) {
	                            h = ac[M];h.setAttributes({ path: ar }, true);
	                        }
	                    }
	                }if (K) {
	                    E = aA.getAt(k++);if (!E) {
	                        E = Ext.chart.Shape[U](u, Ext.apply({ group: [R, aA], x: 0, y: 0, translate: { x: +(f || H), y: e || am.y + am.height / 2 }, value: '"' + p + ", " + B + '"', zIndex: 4000 }, an));E._to = { translate: { x: +H, y: +G } };
	                    } else {
	                        E.setAttributes({ value: '"' + p + ", " + B + '"', x: 0, y: 0, hidden: false }, true);E._to = { translate: { x: +H, y: +G } };
	                    }
	                }ak.items.push({ series: ak, value: [p, B], point: [H, G], sprite: E, storeItem: ao.getAt(Q[N]) });f = H;e = G;
	            }if (T.length <= 1) {
	                return;
	            }if (ak.smooth) {
	                b = Ext.draw.Draw.smooth(T, L(O) ? O : ak.defaultSmoothness);
	            }d = O ? b : T;if (au.markerIndex && ak.previousPath) {
	                ad = ak.previousPath;if (!O) {
	                    Ext.Array.erase(ad, 1, 2);
	                }
	            } else {
	                ad = T;
	            }if (!ak.line) {
	                ak.line = u.add(Ext.apply({ type: "path", group: R, path: ar, stroke: al.stroke || al.fill }, al || {}));if (D) {
	                    ak.line.setAttributes(Ext.apply({}, ak.shadowOptions), true);
	                }ak.line.setAttributes({ fill: "none", zIndex: 3000 });if (!al.stroke && P) {
	                    ak.line.setAttributes({ stroke: t[aw % P] }, true);
	                }if (D) {
	                    ac = ak.line.shadows = [];for (ab = 0; ab < q; ab++) {
	                        ah = X[ab];ah = Ext.apply({}, ah, { path: ar });h = u.add(Ext.apply({}, { type: "path", group: C[ab] }, ah));ac.push(h);
	                    }
	                }
	            }if (ak.fill) {
	                c = d.concat([["L", H, am.y + am.height], ["L", s, am.y + am.height], ["L", s, r]]);if (!ak.fillPath) {
	                    ak.fillPath = u.add({ group: R, type: "path", opacity: al.opacity || 0.3, fill: al.fill || t[aw % P], path: ar });
	                }
	            }W = K && aA.getCount();if (au.animate) {
	                A = ak.fill;o = ak.line;ae = ak.renderer(o, false, { path: d }, N, ao);Ext.apply(ae, al || {}, { stroke: al.stroke || al.fill });delete ae.fill;o.show(true);if (au.markerIndex && ak.previousPath) {
	                    ak.animation = ax = ak.onAnimate(o, { to: ae, from: { path: ad } });
	                } else {
	                    ak.animation = ax = ak.onAnimate(o, { to: ae });
	                }if (D) {
	                    ac = o.shadows;for (M = 0; M < q; M++) {
	                        ac[M].show(true);if (au.markerIndex && ak.previousPath) {
	                            ak.onAnimate(ac[M], { to: { path: d }, from: { path: ad } });
	                        } else {
	                            ak.onAnimate(ac[M], { to: { path: d } });
	                        }
	                    }
	                }if (A) {
	                    ak.fillPath.show(true);ak.onAnimate(ak.fillPath, { to: Ext.apply({}, { path: c, fill: al.fill || t[aw % P], "stroke-width": 0 }, al || {}) });
	                }if (K) {
	                    k = 0;for (N = 0; N < at; N++) {
	                        if (ak.items[N]) {
	                            n = aA.getAt(k++);if (n) {
	                                ae = ak.renderer(n, ao.getAt(N), n._to, N, ao);ak.onAnimate(n, { to: Ext.apply(ae, an || {}) });n.show(true);
	                            }
	                        }
	                    }for (; k < W; k++) {
	                        n = aA.getAt(k);n.hide(true);
	                    }
	                }
	            } else {
	                ae = ak.renderer(ak.line, false, { path: d, hidden: false }, N, ao);Ext.apply(ae, al || {}, { stroke: al.stroke || al.fill });delete ae.fill;ak.line.setAttributes(ae, true);if (D) {
	                    ac = ak.line.shadows;for (M = 0; M < q; M++) {
	                        ac[M].setAttributes({ path: d, hidden: false }, true);
	                    }
	                }if (ak.fill) {
	                    ak.fillPath.setAttributes({ path: c, hidden: false }, true);
	                }if (K) {
	                    k = 0;for (N = 0; N < at; N++) {
	                        if (ak.items[N]) {
	                            n = aA.getAt(k++);if (n) {
	                                ae = ak.renderer(n, ao.getAt(N), n._to, N, ao);n.setAttributes(Ext.apply(an || {}, ae || {}), true);n.show(true);
	                            }
	                        }
	                    }for (; k < W; k++) {
	                        n = aA.getAt(k);n.hide(true);
	                    }
	                }
	            }if (au.markerIndex) {
	                if (ak.smooth) {
	                    Ext.Array.erase(T, 1, 2);
	                } else {
	                    Ext.Array.splice(T, 1, 0, T[1], T[2]);
	                }ak.previousPath = T;
	            }ak.renderLabels();ak.renderCallouts();ak.fireEvent("draw", ak);
	        }
	    });
	
	    Ext.override(Ext.chart.Legend, {
	        updatePosition: function updatePosition() {
	            var me = this,
	                x,
	                y,
	                legendWidth = me.width,
	                legendHeight = me.height,
	                padding = me.padding,
	                chart = me.chart,
	                chartBBox = chart.chartBBox,
	                insets = chart.insetPadding,
	                chartWidth = chartBBox.width - insets * 2,
	                chartHeight = chartBBox.height - insets * 2,
	                chartX = chartBBox.x + insets,
	                chartY = chartBBox.y + insets,
	                surface = chart.surface,
	                mfloor = Math.floor;
	
	            if (me.isDisplayed()) {
	                // Find the position based on the dimensions
	                switch (me.position) {
	                    case "left":
	                        x = insets;
	                        y = mfloor(chartY + chartHeight / 2 - legendHeight / 2);
	                        break;
	                    case "right":
	                        x = mfloor(surface.width - legendWidth) - insets;
	                        y = mfloor(chartY + chartHeight / 2 - legendHeight / 2);
	                        break;
	                    case "top":
	                        x = mfloor((chartX + chartBBox.width) / 2 - legendWidth / 2) - 7;
	                        y = insets;
	                        break;
	                    case "bottom":
	                        x = mfloor(chartX + chartWidth / 2 - legendWidth / 2);
	                        y = mfloor(surface.height - legendHeight) - insets;
	                        break;
	                    default:
	                        x = mfloor(me.origX) + insets;
	                        y = mfloor(me.origY) + insets;
	                }
	                me.x = x;
	                me.y = y;
	
	                // Update the position of each item
	                Ext.each(me.items, function (item) {
	                    item.updatePosition();
	                });
	                // Update the position of the outer box
	                me.boxSprite.setAttributes(me.getBBox(), true);
	            }
	        }
	    });
	
	    Ext.override(Ext.chart.LegendItem, {
	        createLegend: function createLegend(config) {
	            var me = this,
	                index = config.yFieldIndex,
	                series = me.series,
	                seriesType = series.type,
	                idx = me.yFieldIndex,
	                legend = me.legend,
	                surface = me.surface,
	                refX = legend.x + me.x,
	                refY = legend.y + me.y,
	                bbox,
	                z = me.zIndex,
	                markerConfig,
	                label,
	                mask,
	                radius,
	                toggle = false,
	                seriesStyle = Ext.apply(series.seriesStyle, series.style),
	                labelMarkerSize = legend.labelMarkerSize || 10;
	
	            function getSeriesProp(name) {
	                var val = series[name];
	                return Ext.isArray(val) ? val[idx] : val;
	            }
	
	            label = me.add('label', surface.add({
	                type: 'text',
	                x: 30,
	                y: 0,
	                zIndex: z || 0,
	                font: legend.labelFont,
	                fill: legend.labelColor || '#000',
	                text: getSeriesProp('title') || getSeriesProp('yField')
	            }));
	
	            if (seriesType === 'line' || seriesType === 'scatter') {
	                if (seriesType === 'line') {
	                    me.add('line', surface.add({
	                        type: 'path',
	                        path: 'M0.5,0.5L16.5,0.5',
	                        zIndex: z,
	                        "stroke-width": series.lineWidth,
	                        "stroke-linejoin": "round",
	                        "stroke-dasharray": series.dash,
	                        stroke: seriesStyle.stroke || '#000',
	                        style: {
	                            cursor: 'pointer'
	                        }
	                    }));
	                }
	                if (series.showMarkers || seriesType === 'scatter') {
	                    markerConfig = Ext.apply(series.markerStyle, series.markerConfig || {});
	                    me.add('marker', Ext.chart.Shape[markerConfig.type](surface, {
	                        fill: markerConfig.fill,
	                        x: 8.5,
	                        y: 0.5,
	                        zIndex: z,
	                        radius: markerConfig.radius || markerConfig.size,
	                        style: {
	                            cursor: 'pointer'
	                        }
	                    }));
	                }
	            } else {
	                me.add('box', surface.add({
	                    type: 'rect',
	                    zIndex: z,
	                    x: 6,
	                    y: 0,
	                    width: labelMarkerSize,
	                    height: labelMarkerSize,
	                    fill: series.getLegendColor(index),
	                    style: {
	                        cursor: 'pointer'
	                    }
	                }));
	            }
	
	            me.setAttributes({
	                hidden: false
	            }, true);
	
	            bbox = me.getBBox();
	
	            mask = me.add('mask', surface.add({
	                type: 'rect',
	                x: bbox.x,
	                y: bbox.y,
	                width: bbox.width || 20,
	                height: bbox.height || 20,
	                zIndex: (z || 0) + 1000,
	                fill: '#f00',
	                opacity: 0,
	                style: {
	                    'cursor': 'pointer'
	                }
	            }));
	
	            me.on('mouseover', function () {
	                label.setStyle({
	                    'font-weight': 'bold'
	                });
	                mask.setStyle({
	                    'cursor': 'pointer'
	                });
	                series._index = index;
	                series.highlightItem();
	            }, me);
	
	            me.on('mouseout', function () {
	                label.setStyle({
	                    'font-weight': 'normal'
	                });
	                series._index = index;
	                series.unHighlightItem();
	            }, me);
	
	            if (!series.visibleInLegend(index)) {
	                toggle = true;
	                label.setAttributes({
	                    opacity: 0.5
	                }, true);
	            }
	
	            me.on('mousedown', function () {
	                if (!toggle) {
	                    series.hideAll();
	                    label.setAttributes({
	                        opacity: 0.5
	                    }, true);
	                } else {
	                    series.showAll();
	                    label.setAttributes({
	                        opacity: 1
	                    }, true);
	                }
	                toggle = !toggle;
	            }, me);
	            me.updatePosition({ x: 0, y: 0 });
	        }
	    });
	
	    Ext.override(Ext.chart.axis.Axis, {
	        drawHorizontalLabels: function drawHorizontalLabels() {
	            var me = this,
	                labelConf = me.label,
	                floor = Math.floor,
	                max = Math.max,
	                axes = me.chart.axes,
	                position = me.position,
	                inflections = me.inflections,
	                ln = inflections.length,
	                labels = me.labels,
	                labelGroup = me.labelGroup,
	                maxHeight = 0,
	                ratio,
	                gutterY = me.chart.maxGutter[1],
	                ubbox,
	                bbox,
	                point,
	                prevX,
	                prevLabel,
	                projectedWidth = 0,
	                textLabel,
	                attr,
	                textRight,
	                text,
	                label,
	                last,
	                x,
	                y,
	                i,
	                firstLabel;
	
	            last = ln - 1;
	            // get a reference to the first text label dimensions
	            point = inflections[0];
	            firstLabel = me.getOrCreateLabel(0, me.label.renderer(labels[0]));
	            ratio = Math.floor(Math.abs(Math.sin(labelConf.rotate && labelConf.rotate.degrees * Math.PI / 180 || 0)));
	
	            for (i = 0; i < ln; i++) {
	                point = inflections[i];
	                text = me.label.renderer(labels[i]) || '';
	                textLabel = me.getOrCreateLabel(i, text);
	                bbox = textLabel._bbox;
	                maxHeight = max(maxHeight, bbox.height + me.dashSize + me.label.padding);
	                x = floor(point[0] - (ratio ? bbox.height : bbox.width) / 2);
	                if (me.chart.maxGutter[0] == 0) {
	                    if (i == 0 && axes.findIndex('position', 'left') == -1) {
	                        x = point[0];
	                    } else if (i == last && axes.findIndex('position', 'right') == -1) {
	                        x = point[0] - bbox.width;
	                    }
	                }
	                if (position == 'top') {
	                    y = point[1] - me.dashSize * 2 - me.label.padding - bbox.height / 2;
	                } else {
	                    y = point[1] + me.dashSize * 2 + me.label.padding + bbox.height / 2;
	                }
	
	                var moveLabels = labelConf.rotate && labelConf.rotate.degrees && !Ext.Array.contains([0, 90, 180, 270, 360], labelConf.rotate.degrees),
	                    adjust = Math.floor((textLabel.text.length - 12) * -1 * 0.75),
	                    newX = moveLabels ? point[0] - textLabel._bbox.width + adjust : x;
	
	                textLabel.setAttributes({
	                    hidden: false,
	                    x: newX,
	                    y: y
	                }, true);
	
	                // skip label if there isn't available minimum space
	                if (i != 0 && (me.intersect(textLabel, prevLabel) || me.intersect(textLabel, firstLabel))) {
	                    textLabel.hide(true);
	                    continue;
	                }
	
	                prevLabel = textLabel;
	            }
	
	            return maxHeight;
	        }
	    });
	
	    Ext.override(Ext.chart.axis.Radial, {
	        drawLabel: function drawLabel() {
	            var chart = this.chart,
	                surface = chart.surface,
	                bbox = chart.chartBBox,
	                store = chart.store,
	                centerX = bbox.x + bbox.width / 2,
	                centerY = bbox.y + bbox.height / 2,
	                rho = Math.min(bbox.width, bbox.height) / 2,
	                max = Math.max,
	                round = Math.round,
	                labelArray = [],
	                label,
	                fields = [],
	                nfields,
	                categories = [],
	                xField,
	                aggregate = !this.maximum,
	                maxValue = this.maximum || 0,
	                steps = this.steps,
	                i = 0,
	                j,
	                dx,
	                dy,
	                pi2 = Math.PI * 2,
	                cos = Math.cos,
	                sin = Math.sin,
	                display = this.label.display,
	                draw = display !== 'none',
	                margin = 10,
	                labelColor = '#333',
	                labelFont = 'normal 9px sans-serif',
	                seriesStyle = chart.seriesStyle;
	
	            labelColor = seriesStyle ? seriesStyle.labelColor : labelColor;
	            labelFont = seriesStyle ? seriesStyle.labelFont : labelFont;
	
	            if (!draw) {
	                return;
	            }
	
	            //get all rendered fields
	            chart.series.each(function (series) {
	                fields.push(series.yField);
	                xField = series.xField;
	            });
	
	            //get maxValue to interpolate
	            store.each(function (record, i) {
	                if (aggregate) {
	                    for (i = 0, nfields = fields.length; i < nfields; i++) {
	                        maxValue = max(+record.get(fields[i]), maxValue);
	                    }
	                }
	                categories.push(record.get(xField));
	            });
	            if (!this.labelArray) {
	                if (display != 'categories') {
	                    //draw scale
	                    for (i = 1; i <= steps; i++) {
	                        label = surface.add({
	                            type: 'text',
	                            text: round(i / steps * maxValue),
	                            x: centerX,
	                            y: centerY - rho * i / steps,
	                            'text-anchor': 'middle',
	                            'stroke-width': 0.1,
	                            stroke: '#333',
	                            fill: labelColor,
	                            font: labelFont
	                        });
	                        label.setAttributes({
	                            hidden: false
	                        }, true);
	                        labelArray.push(label);
	                    }
	                }
	                if (display != 'scale') {
	                    //draw text
	                    for (j = 0, steps = categories.length; j < steps; j++) {
	                        dx = cos(j / steps * pi2) * (rho + margin);
	                        dy = sin(j / steps * pi2) * (rho + margin);
	                        label = surface.add({
	                            type: 'text',
	                            text: categories[j],
	                            x: centerX + dx,
	                            y: centerY + dy,
	                            'text-anchor': dx * dx <= 0.001 ? 'middle' : dx < 0 ? 'end' : 'start',
	                            fill: labelColor,
	                            font: labelFont
	                        });
	                        label.setAttributes({
	                            hidden: false
	                        }, true);
	                        labelArray.push(label);
	                    }
	                }
	            } else {
	                labelArray = this.labelArray;
	                if (display != 'categories') {
	                    //draw values
	                    for (i = 0; i < steps; i++) {
	                        labelArray[i].setAttributes({
	                            text: round((i + 1) / steps * maxValue),
	                            x: centerX,
	                            y: centerY - rho * (i + 1) / steps,
	                            'text-anchor': 'middle',
	                            'stroke-width': 0.1,
	                            stroke: '#333',
	                            fill: labelColor,
	                            font: labelFont
	                        }, true);
	                    }
	                }
	                if (display != 'scale') {
	                    //draw text
	                    for (j = 0, steps = categories.length; j < steps; j++) {
	                        dx = cos(j / steps * pi2) * (rho + margin);
	                        dy = sin(j / steps * pi2) * (rho + margin);
	                        if (labelArray[i + j]) {
	                            labelArray[i + j].setAttributes({
	                                type: 'text',
	                                text: categories[j],
	                                x: centerX + dx,
	                                y: centerY + dy,
	                                'text-anchor': dx * dx <= 0.001 ? 'middle' : dx < 0 ? 'end' : 'start',
	                                fill: labelColor,
	                                font: labelFont
	                            }, true);
	                        }
	                    }
	                }
	            }
	            this.labelArray = labelArray;
	        }
	    });
	};
	//# sourceMappingURL=extChartOverrides.js.map

/***/ },
/* 151 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var extOverrides = exports.extOverrides = undefined;
	
	exports.extOverrides = extOverrides = function extOverrides() {
	
	    Ext.QuickTips.init();
	};
	//# sourceMappingURL=extOverrides.js.map

/***/ },
/* 152 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.EventDataTable = undefined;
	
	var _arrayContains = __webpack_require__(4);
	
	var _arrayContains2 = _interopRequireDefault(_arrayContains);
	
	var _arrayClean = __webpack_require__(9);
	
	var _arrayClean2 = _interopRequireDefault(_arrayClean);
	
	var _uuid = __webpack_require__(31);
	
	var _uuid2 = _interopRequireDefault(_uuid);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EventDataTable = exports.EventDataTable = undefined;
	
	exports.EventDataTable = EventDataTable = function EventDataTable(refs, layout, response) {
	    var t = this;
	
	    var appManager = refs.appManager,
	        uiManager = refs.uiManager,
	        i18nManager = refs.i18nManager,
	        dimensionConfig = refs.dimensionConfig,
	        optionConfig = refs.optionConfig;
	    var ResponseRowIdCombination = refs.api.ResponseRowIdCombination;
	
	
	    var i18n = i18nManager.get();
	
	    var FIXED_HEADERS = ['eventdate'];
	
	    var filteredHeaders = response.getFilteredHeaders([].concat(FIXED_HEADERS, layout.getDimensionNames()));
	
	    var rows = response.rows;
	    var items = response.metaData.items;
	    var cls = [];
	    var html = '';
	
	    var pager = response.metaData.pager;
	    var count = pager.page * pager.pageSize - pager.pageSize;
	
	    var sortableIdObjects = [];
	
	    cls.push('pivot');
	    cls.push(layout.displayDensity !== optionConfig.getDisplayDensity('normal') ? ' displaydensity-' + layout.displayDensity : null);
	    cls.push(layout.fontSize !== optionConfig.getFontSize('normal') ? ' fontsize-' + layout.fontSize : null);
	
	    html += '<table class="' + (0, _arrayClean2.default)(cls).join(' ') + '"><tr>';
	    html += '<td class="pivot-dim pivot-dim-subtotal">' + '#' + '</td>';
	
	    // get header indexes
	    filteredHeaders.forEach(function (header) {
	        var uid = (0, _uuid2.default)();
	
	        html += '<td id="' + uid + '" class="pivot-dim td-sortable">' + header.column + '</td>';
	
	        sortableIdObjects.push({
	            id: header.name,
	            uuid: uid
	        });
	    });
	
	    html += '</tr>';
	
	    // rows
	    for (var i = 0, row, rowHtml; i < rows.length; i++) {
	        row = rows[i];
	        rowHtml = '';
	
	        for (var ii = 0, header, rowValue, itemKey, name; ii < filteredHeaders.length; ii++) {
	            header = filteredHeaders[ii];
	            rowValue = row[header.index];
	
	            itemKey = (header.isPrefix ? header.name + '_' : '') + rowValue;
	
	            name = (items[itemKey] || {}).name || rowValue;
	
	            //isBoolean = header.type === 'java.lang.Boolean';
	            //str = row[header.index];
	            //str = optionNames[header.name + str] || optionNames[str] || (isBoolean ? booleanNames[str] : null) || names[str] || str;
	            //name = web.report.query.format(str);
	
	            //if (header.name === 'ouname' && layout.showHierarchy) {
	            //var a = Ext.Array.clean(name.split('/'));
	            //name = '';
	
	            //for (var k = 0, isLast; k < a.length; k++) {
	            //isLast = !!(i === a.length - 1);
	
	            //name += (!isLast ? '<span class="text-weak">' : '') + a[i] + (!isLast ? '</span>' : '') + (!isLast ? ' / ' : '');
	            //}
	            //}
	
	            rowHtml += '<td class="pivot-value align-left">' + name + '</td>';
	        }
	
	        html += '<tr><td class="pivot-value align-right">' + (count + (i + 1)) + '</td>' + rowHtml + '</tr>';
	    }
	
	    html += '</table>';
	
	    return {
	        sortableIdObjects: sortableIdObjects,
	        html: html
	    };
	};
	//# sourceMappingURL=EventDataTable.js.map

/***/ },
/* 153 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.PivotTable = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _isString = __webpack_require__(3);
	
	var _isString2 = _interopRequireDefault(_isString);
	
	var _isNumber = __webpack_require__(7);
	
	var _isNumber2 = _interopRequireDefault(_isNumber);
	
	var _isObject = __webpack_require__(2);
	
	var _isObject2 = _interopRequireDefault(_isObject);
	
	var _isBoolean = __webpack_require__(15);
	
	var _isBoolean2 = _interopRequireDefault(_isBoolean);
	
	var _isEmpty = __webpack_require__(30);
	
	var _isEmpty2 = _interopRequireDefault(_isEmpty);
	
	var _numberConstrain = __webpack_require__(68);
	
	var _numberConstrain2 = _interopRequireDefault(_numberConstrain);
	
	var _objectApplyIf = __webpack_require__(69);
	
	var _objectApplyIf2 = _interopRequireDefault(_objectApplyIf);
	
	var _arrayContains = __webpack_require__(4);
	
	var _arrayContains2 = _interopRequireDefault(_arrayContains);
	
	var _arrayClean = __webpack_require__(9);
	
	var _arrayClean2 = _interopRequireDefault(_arrayClean);
	
	var _uuid = __webpack_require__(31);
	
	var _uuid2 = _interopRequireDefault(_uuid);
	
	var _ResponseRowIdCombination = __webpack_require__(38);
	
	var _colorUtils = __webpack_require__(174);
	
	var _PivotTableUtils = __webpack_require__(60);
	
	var _PivotTableCells = __webpack_require__(155);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	/**
	 * 
	 * 
	 * @param {object} refs 
	 * @param {object} layout 
	 * @param {object} response 
	 * @param {object} colAxis 
	 * @param {object} rowAxis 
	 * @param {object} [options={}] 
	 */
	var PivotTable = exports.PivotTable = function PivotTable(refs, layout, response, colAxis, rowAxis) {
	    var options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
	
	
	    this.options = _extends({
	        renderLimit: 100000,
	        forceDynamic: false,
	        showColTotals: !!layout.showColTotals,
	        showRowTotals: !!layout.showRowTotals,
	        showColSubTotals: !!layout.showColSubTotals,
	        showRowSubTotals: !!layout.showRowSubTotals,
	        hideEmptyRows: !!layout.hideEmptyRows,
	        hideEmptyColumns: !!layout.hideEmptyColumns,
	        showDimensionLabels: !!layout.showDimensionLabels,
	        stickyColumnDimension: !!layout.stickyColumnDimension,
	        stickyRowDimension: !!layout.stickyRowDimension,
	        showHierarchy: !!layout.showHierarchy,
	        numberType: layout.numberType,
	        trueTotals: true
	    }, options);
	
	    this.cellHeight = 25;
	    this.cellWidth = 120;
	    this.renderOffset = 1;
	
	    this.title = layout.title;
	    this.digitGroupSeparator = layout.digitGroupSeparator;
	
	    this.fontSize = layout.fontSize;
	    this.displayDensity = layout.displayDensity;
	
	    this.uuidDimUuidsMap = {};
	
	    this.valueUuids = [];
	    this.dimensionUuids = [];
	    this.sortableIdObjects = [];
	
	    this.filters = layout.filters;
	    this.layout = layout;
	    this.response = response;
	    this.appManager = refs.appManager;
	    this.optionConfig = refs.optionConfig;
	    this.uiManager = refs.uiManager;
	
	    this.legendSet = (0, _isObject2.default)(layout.legendSet) ? this.appManager.getLegendSetById(layout.legendSet.id) : null;
	
	    this.colAxis = colAxis;
	    this.rowAxis = rowAxis;
	
	    this.legendDisplayStyle = layout.legendDisplayStyle;
	    this.legendDisplayStrategy = layout.legendDisplayStrategy;
	
	    this.numberOfEmptyRows = 0;
	    this.numberOfEmptyColumns = 0;
	};
	
	/**
	 * @description Pivot table initialization function, does most of the heavy lifting.
	 * 
	 */
	PivotTable.prototype.initialize = function () {
	
	    // number of dimensions for each axis
	    this.columnDimensionSize = this.colAxis.dims || 1;
	    this.rowDimensionSize = this.rowAxis.dims || 1;
	
	    this.idValueMap = this.response.getIdMap(this.layout, 'value', 'idValueMap');
	
	    if (this.options.trueTotals) {
	        this.idFactorMap = this.response.getIdMap(this.layout, 'factor', 'idFactorMap');
	        this.idNumeratorMap = this.response.getIdMap(this.layout, 'numerator', 'idNumeratorMap');
	        this.idDenominatorMap = this.response.getIdMap(this.layout, 'denominator', 'idDenominatorMap');
	    } else {
	        this.idFactorMap = {};
	        this.idNumeratorMap = {};
	        this.idDenominatorMap = {};
	    }
	
	    this.colUniqueFactor = (0, _PivotTableUtils.getUniqueFactor)(this.colAxis);
	    this.rowUniqueFactor = (0, _PivotTableUtils.getUniqueFactor)(this.rowAxis);
	
	    this.columnDimensionNames = this.colAxis.type ? this.layout.columns.getDimensionNames(this.response) : [];
	    this.rowDimensionNames = this.rowAxis.type ? this.layout.rows.getDimensionNames(this.response) : [];
	
	    // size size of table
	    this.rowSize = this.getRowSize();
	
	    // size of column axis not including corner axis
	    this.columnSize = this.getColumnSize();
	
	    // size of row axis not including corner axis
	    this.tableSize = this.getTableSize();
	
	    // lookup for changed column spans (used to calculate new spans when rows/columns are hidden).
	    this.rowAxisSpanMap = this.createRowSpanMap();
	    this.columnAxisSpanMap = this.createColumnSpanMap();
	
	    // lookup for values
	    this.valueLookup = {};
	    this.rowTotalLookup = (0, _PivotTableUtils.defaultProxyGenerator)(0);
	    this.columnTotalLookup = (0, _PivotTableUtils.defaultProxyGenerator)(0);
	
	    // initialize lookup tables
	    this.initializeLookups();
	
	    // lookup for rows/columns to render (used to determine what rows/columns are hidden).
	    if (this.doHideEmptyRows()) {
	        this.rowAxisLookup = this.createRowRenderMap();
	    }
	
	    if (this.doHideEmptyColumns()) {
	        this.columnAxisLookup = this.createColumnRenderMap();
	    }
	};
	
	// setters
	/**
	 * Sets the cell width of each cell in the  table.
	 * 
	 * @param {number} width The width of each cell in pixels
	 */
	PivotTable.prototype.setCellWidth = function (width) {
	    this.cellWidth = width;
	};
	
	/**
	 * Sets the cell height of each cell in the table.
	 * 
	 * @param {number} height The height of each cell in pixels
	 */
	PivotTable.prototype.setCellHeight = function (height) {
	    this.cellHeight = height;
	};
	
	/**
	 * Sets the width of the viewport used to render the table.
	 * 
	 * @param {number} width The width of the viewport in pixels
	 */
	PivotTable.prototype.setViewportWidth = function (width) {
	    this.viewportWidth = width;
	};
	
	/**
	 * Sets the height of the viewport used to render the table.
	 * 
	 * @param {number} height The height of the viewport in pixels
	 */
	PivotTable.prototype.setViewportHeight = function (height) {
	    this.viewportHeight = height;
	};
	
	/**
	 * Sets the index of where the table will start rendering columns.
	 * 
	 * @param {number} columnIndex The index of the column to render
	 */
	PivotTable.prototype.setColumnStart = function (columnIndex) {
	    this.columnStart = Math.max(0, columnIndex);
	};
	
	/**
	 * Sets the index of where the table will start rendering rows.
	 * 
	 * @param {number} rowIndex The index of the row to render
	 */
	PivotTable.prototype.setRowStart = function (rowIndex) {
	    this.rowStart = Math.max(0, rowIndex);
	};
	
	/**
	 * Sets the index of where the table will end rendering columns.
	 * 
	 * @param {number} columnIndex The index of the column to render
	 */
	PivotTable.prototype.setColumnEnd = function (columnIndex) {
	    this.columnEnd = this.constrainWidth(Math.min(this.columnSize + this.rowDimensionSize - 1, columnIndex));
	};
	
	/**
	 * Sets the index of where the table will end rendering rows.
	 * 
	 * @param {number} rowIndex The index of the row to render
	 */
	PivotTable.prototype.setRowEnd = function (rowIndex) {
	    this.rowEnd = this.constrainHeight(Math.min(this.rowSize + this.columnDimensionSize - 1, rowIndex));
	};
	
	/**
	 * Sets the index of where the table will start rendering columns and calculates and sets
	 * the index of where the table will stop rendering columns based on the start index and
	 * width of the viewport.
	 * 
	 * @param {number} columnStartIndex The index of the column to render
	 */
	PivotTable.prototype.setColumnStartAndEnd = function (columnStartIndex) {
	    this.setColumnStart(columnStartIndex);
	    this.columnEnd = this.getColumnEnd(columnStartIndex);
	};
	
	/**
	 * Sets the index of where the table will start rendering rows and calculates and sets
	 * the index of where the table will stop rendering rows based on the start index and
	 * height of the viewport.
	 * 
	 * @param {number} rowStartIndex The index of the row to render
	 */
	PivotTable.prototype.setRowStartAndEnd = function (rowStartIndex) {
	    this.setRowStart(rowStartIndex);
	    this.rowEnd = this.getRowEnd(rowStartIndex);
	};
	
	/**
	 * Sets the size of the viewport and rebuilds the table.
	 * 
	 * @param {number} [width=0] 
	 * @param {number} [height=0] 
	 */
	PivotTable.prototype.setViewportSize = function () {
	    var width = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	    var height = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	
	    this.setViewportWidth(width);
	    this.setViewportHeight(height);
	};
	
	// options
	/**
	 * Checks the size of the table compared to the render limit set by options.
	 * 
	 * @returns {boolean}
	 */
	PivotTable.prototype.doRender = function () {
	    return this.rowAxis.size * this.colAxis.size > this.options.renderLimit;
	};
	
	/**
	 * Checks if show total columns option is enabled.
	 * 
	 * @returns {boolean}
	 */
	PivotTable.prototype.doColTotals = function () {
	    return this.options.showColTotals && !!this.rowAxis.size;
	};
	
	/**
	 * Checks if show total rows option is enabled.
	 * 
	 * @returns {boolean}
	 */
	PivotTable.prototype.doRowTotals = function () {
	    return this.options.showRowTotals && !!this.colAxis.size;
	};
	
	/**
	 * Checks if show sub total columns option is enabled.
	 * 
	 * @returns {boolean}
	 */
	PivotTable.prototype.doColSubTotals = function () {
	    return this.options.showColSubTotals && this.rowAxis.type && this.rowDimensionSize > 1;
	};
	
	/**
	 * Checks if show sub total rows option is enabled.
	 * 
	 * @returns {boolean}
	 */
	PivotTable.prototype.doRowSubTotals = function () {
	    return this.options.showRowSubTotals && this.colAxis.type && this.columnDimensionSize > 1;
	};
	
	/**
	 * Checks if column percentage option is enabled.
	 * 
	 * @returns {boolean}
	 */
	PivotTable.prototype.doColPercentage = function () {
	    return this.options.numberType === this.optionConfig.getNumberType().percentofcolumn.id;
	};
	
	/**
	 * Checks if row percentage option is enabled.
	 * 
	 * @returns {boolean}
	 */
	PivotTable.prototype.doRowPercentage = function () {
	    return this.options.numberType === this.optionConfig.getNumberType().percentofrow.id;
	};
	
	/**
	 * Checks if sortable column headers option is enabled.
	 * 
	 * @returns 
	 */
	PivotTable.prototype.doSortableColumnHeaders = function () {
	    return this.rowAxis.type && this.rowDimensionSize === 1;
	};
	
	/**
	 * Checks if hide empty columns option is enabled.
	 * 
	 * @returns {boolean}
	 */
	PivotTable.prototype.doHideEmptyRows = function () {
	    return this.options.hideEmptyRows && this.colAxis.type && this.rowAxis.type;
	};
	
	/**
	 * Checks if hide empty rows option is enabled.
	 * 
	 * @returns {boolean}
	 */
	PivotTable.prototype.doHideEmptyColumns = function () {
	    return this.options.hideEmptyColumns && this.colAxis.type && this.rowAxis.type;
	};
	
	/**
	 * Checks if show dimension labels option is enabled.
	 * 
	 * @returns {boolean}
	 */
	PivotTable.prototype.doShowDimensionLabels = function () {
	    return this.options.showDimensionLabels;
	};
	
	/**
	 * Checks if dynamic table rendering option should be enabled.
	 * 
	 * @returns {boolean}
	 */
	PivotTable.prototype.doDynamicRendering = function () {
	    return this.doRender() || this.options.forceDynamic;
	};
	
	/**
	 * Checks if sticky columns option should be enabled.
	 * 
	 * @returns {boolean}
	 */
	PivotTable.prototype.doStickyColumns = function () {
	    return this.options.stickyColumnDimension;
	};
	
	/**
	 * Checks if sticky rows option should be enabled.
	 * 
	 * @returns {boolean}
	 */
	PivotTable.prototype.doStickyRows = function () {
	    return this.options.stickyRowDimension;
	};
	
	/**
	 * Checks if show hierarchy option should be enabled.
	 * 
	 * @returns {boolean}
	 */
	PivotTable.prototype.doShowHierarchy = function () {
	    return this.options.showHierarchy;
	};
	
	/**
	 * Checks if legend display by data item option is enabled
	 * 
	 * @returns {boolean}
	 */
	PivotTable.prototype.doLegendDisplayByDataItem = function () {
	    return this.legendDisplayStrategy === this.getLegendDisplayStrategyId('by_data_item');
	};
	
	/**
	 * Checks if legend display option is enbalied
	 * 
	 * @returns {boolean}
	 */
	PivotTable.prototype.doLegendDisplay = function () {
	    return this.legendDisplayStrategy !== this.getLegendDisplayStrategyId('fixed');
	};
	
	/**
	 * Checks if legend display style fill option is enabled
	 * 
	 * @returns {boolean}
	 */
	PivotTable.prototype.doLegendDisplayStyleFill = function () {
	    return this.legendDisplayStyle === this.getLegendDisplayStyleId('fill');
	};
	
	/**
	 * Checks if legend display style text option is enabled
	 * 
	 * @returns {boolean}
	 */
	PivotTable.prototype.doLegendDisplayStyleText = function () {
	    return this.legendDisplayStyle === this.getLegendDisplayStyleId('text');
	};
	
	// checkers
	/**
	 * Checks if column located at given column index is a sub total column.
	 * 
	 * @param {number} columnIndex index of column to be checked
	 * @returns {boolean}
	 */
	PivotTable.prototype.isColumnSubTotal = function (columnIndex) {
	    return this.doRowSubTotals() && (columnIndex + 1) % (this.colUniqueFactor + 1) === 0;
	};
	
	/**
	 * Checks if column located at given column index is a total column.
	 * 
	 * @param {number} columnIndex index of column to be checked
	 * @returns {boolean}
	 */
	PivotTable.prototype.isColumnGrandTotal = function (columnIndex) {
	    return this.doRowTotals() && columnIndex === this.getColumnSize() - 1;
	};
	
	/**
	 * Checks if row located at given row index is a sub total row.
	 * 
	 * @param {number} rowIndex index of column to be checked
	 * @returns {boolean}
	 */
	PivotTable.prototype.isRowSubTotal = function (rowIndex) {
	    return this.doColSubTotals() && (rowIndex + 1) % (this.rowUniqueFactor + 1) === 0;
	};
	
	/**
	 * Checks if row located at given row index is a sub total row.
	 * 
	 * @param {number} rowIndex index of row to be checked
	 * @returns {boolean}
	 */
	PivotTable.prototype.isRowGrandTotal = function (rowIndex) {
	    return this.doColTotals() && rowIndex === this.rowSize - 1;
	};
	
	/**
	 * Checks if row located at row index is empty.
	 * 
	 * @param {number} rowIndex 
	 * @returns {boolean}
	 */
	PivotTable.prototype.isRowEmpty = function (rowIndex) {
	    return this.rowTotalLookup[rowIndex] <= 0;
	};
	
	/**
	 * Checks if column located at column index is empty.
	 * 
	 * @param {number} columnIndex 
	 * @returns {boolean}
	 */
	PivotTable.prototype.isColumnEmpty = function (columnIndex) {
	    return this.columnTotalLookup[columnIndex] <= 0;
	};
	
	/**
	 * Checks if row located at row index is part of column axis.
	 * 
	 * @param {number} columnIndex 
	 * @returns {boolean}
	 */
	PivotTable.prototype.isColumnDimensionRow = function (rowIndex) {
	    return rowIndex < this.columnDimensionSize;
	};
	
	/**
	 * Checks if column located at column index is part of row axis.
	 * 
	 * @param {number} columnIndex 
	 * @returns {boolean}
	 */
	PivotTable.prototype.isRowDimensionColumn = function (columnIndex) {
	    return columnIndex < this.rowDimensionSize;
	};
	
	/**
	 * Checks if given cell is of type text field.
	 * 
	 * @param {string} type 
	 * @returns 
	 */
	PivotTable.prototype.isTextField = function (type) {
	    return !(0, _arrayContains2.default)(['dimension', 'filter'], type);
	};
	
	// getters
	PivotTable.prototype.getBaseCellStyling = function (cell) {
	    if (this.doDynamicRendering()) {
	        return '\n            min-width:' + cell.width + 'px!important;\n            min-height:' + cell.height + 'px!important;\n            max-width:' + cell.width + 'px!important;\n            max-height:' + cell.height + 'px!important;\n            width:' + cell.width + 'px!important;\n            height:' + cell.height + 'px!important;\n            white-space: nowrap!important;\n            overflow: hidden!important;\n            text-overflow: ellipsis!important;\n        ';
	    }
	    return '';
	};
	
	PivotTable.prototype.getColumnIndexWithHidden = function (columnIndex) {
	
	    if (this.doHideEmptyColumns()) {
	        return this.columnAxisLookup[columnIndex];
	    }
	
	    return columnIndex;
	};
	
	PivotTable.prototype.getRowIndexWithHidden = function (rowIndex) {
	
	    if (this.doHideEmptyRows()) {
	        return this.rowAxisLookup[rowIndex];
	    }
	
	    return rowIndex;
	};
	
	/**
	 * Get width of value table (table without axis).
	 * 
	 * @returns 
	 */
	PivotTable.prototype.getValueTableWidth = function () {
	    return Object.keys(this.valueLookup[0]).length - 1;
	};
	/**
	 * Get height of value table (table without axis).
	 * 
	 * @returns 
	 */
	PivotTable.prototype.getValueTableHeigth = function () {
	    return Object.keys(this.valueLookup).length - 1;
	};
	
	// TODO: REMOVE
	PivotTable.prototype.getAdjustedAxisSpan = function (cell, index, axisType, spanType) {
	    if (cell.children) {
	        return cell.oldestSibling.children * this[axisType].span[index + 1] - cell.siblingPosition;
	    }
	
	    return cell[spanType];
	};
	
	PivotTable.prototype.getAdjustedColSpan = function (cell, rowIndex) {
	    return this.getAdjustedAxisSpan(cell, rowIndex, 'colAxis', 'colSpan');
	};
	
	PivotTable.prototype.getAdjustedRowSpan = function (cell, columnIndex) {
	    return this.getAdjustedAxisSpan(cell, columnIndex, 'rowAxis', 'rowSpan');
	};
	
	/**
	 * Gets the row index of where the value table starts relative to the
	 * current state of the table.
	 * Mostly used to offset the row index to skip over column
	 * axis dimensions.
	 * 
	 * @returns {number}
	 */
	PivotTable.prototype.getValueRowStartOffset = function () {
	    return Math.max(0, this.columnDimensionSize - this.rowStart);
	};
	
	/**
	 * Gets the column index of where the value table starts relative to the
	 * current state of the table.
	 * Mostly used to offset the column index to skip over row
	 * axis dimensions.
	 * @returns {number}
	 */
	PivotTable.prototype.getValueColumnStartOffset = function () {
	    return Math.max(0, this.rowDimensionSize - this.columnStart);
	};
	
	/**
	 * Gets the amount of offset needed to get to row values,
	 * this is used to get values out of the value lookup table.
	 * 
	 * @returns {number}
	 */
	PivotTable.prototype.getValueOffsetRow = function () {
	    return Math.max(0, this.rowStart - this.columnDimensionSize);
	};
	
	/**
	 * Gets the amount of offset needed to get to column values,
	 * this is used to get values out of the value lookup table.
	 * 
	 * @returns {number}
	 */
	PivotTable.prototype.getValueOffsetColumn = function () {
	    return Math.max(0, this.columnStart - this.rowDimensionSize);
	};
	
	/**
	 * Gets the row span of a given dimension based on the current
	 * state of the table.
	 * 
	 * @param {number} rowIndex index of row axis
	 * @param {number} dimensionIndex dimension of row axis
	 * @returns {number}
	 */
	PivotTable.prototype.getRowAxisSpan = function (rowIndex, dimensionIndex) {
	    return this.rowAxisSpanMap[dimensionIndex][Math.floor(rowIndex / this.rowAxis.span[dimensionIndex])];
	};
	
	/**
	 * Gets normalized row index offset by hidden rows based on the current
	 * state of the table.
	 * 
	 * @param {number} rowIndex 
	 * @param {number} dimensionIndex 
	 * @returns {number}
	 */
	PivotTable.prototype.normalizeRowIndexOffset = function (rowIndex, dimensionIndex) {
	    if (this.doColSubTotals()) {
	        return rowIndex - Math.floor(this.getRowIndexWithHidden(rowIndex) / (this.rowUniqueFactor + 1));
	    }
	    return rowIndex;
	};
	
	/**
	 * Gets the distance from last row axis dimension unit based on the current
	 * state of the table.
	 * 
	 * @param {number} rowIndex 
	 * @param {number} dimensionIndex 
	 * @returns {number}
	 */
	PivotTable.prototype.getDistanceFromLastRowDimensionUnitActual = function (rowIndex, dimensionIndex) {
	    var normalized = this.normalizeRowIndex(this.getRowIndexWithHidden(rowIndex));
	    return this.normalizeRowIndexOffset(rowIndex) - (this.sumRowAxisSpanUpToIndex(normalized, dimensionIndex) - this.getRowAxisSpan(normalized, dimensionIndex));
	};
	
	/**
	 * Gets distance from last row axis dimension unit based on the current
	 * state of the table.
	 * 
	 * @param {number} rowIndex 
	 * @param {number} dimensionIndex 
	 * @returns {number}
	 */
	PivotTable.prototype.getDistanceFromLastRowDimensionUnitOffset = function (rowIndex, dimensionIndex) {
	    var normalized = this.normalizeRowIndex(this.getRowIndexWithHidden(rowIndex));
	    return normalized % this.rowAxis.span[dimensionIndex];
	};
	
	/**
	 * Gets distance to next row axis dimension unit based on the current
	 * state of the table.
	 * 
	 * @param {number} rowIndex 
	 * @param {number} dimensionIndex 
	 * @returns {number}
	 */
	PivotTable.prototype.getDistanceToNextRowDimensionUnitActual = function (rowIndex, dimensionIndex) {
	    var normalized = this.normalizeRowIndex(this.getRowIndexWithHidden(rowIndex));
	    return this.getRowAxisSpan(normalized, dimensionIndex) - (this.normalizeRowIndexOffset(rowIndex) - (this.sumRowAxisSpanUpToIndex(normalized, dimensionIndex) - this.getRowAxisSpan(normalized, dimensionIndex)));
	};
	
	/**
	 * Gets distance to next row axis dimension unit based on the current
	 * state of the table.
	 * 
	 * @param {number} rowIndex 
	 * @param {number} dimensionIndex 
	 * @returns {number}
	 */
	PivotTable.prototype.getDistanceToNextRowDimensionUnitOffset = function (rowIndex, dimensionIndex) {
	    var normalized = this.normalizeRowIndex(this.getRowIndexWithHidden(rowIndex));
	    return this.rowAxis.span[dimensionIndex] - normalized % this.rowAxis.span[dimensionIndex];
	};
	
	/**
	 * Gets number of hidden rows above given row index up to start of current
	 * dimension unit.
	 * 
	 * @param {number} rowIndex 
	 * @param {number} dimensionIndex 
	 * @returns {number}
	 */
	PivotTable.prototype.getHiddenRowsAbove = function (rowIndex, dimensionIndex) {
	    return this.getDistanceFromLastRowDimensionUnitOffset(rowIndex, dimensionIndex) - this.getDistanceFromLastRowDimensionUnitActual(rowIndex, dimensionIndex);
	};
	
	/**
	 * Gets number of hidden rows below given row index up to end of current
	 * dimension unit.
	 * 
	 * @param {number} rowIndex 
	 * @param {number} dimensionIndex 
	 * @returns {number}
	 */
	PivotTable.prototype.getHiddenRowsBelow = function (rowIndex, dimensionIndex) {
	    return this.getDistanceToNextRowDimensionUnitOffset(rowIndex, dimensionIndex) - this.getDistanceToNextRowDimensionUnitActual(rowIndex, dimensionIndex);
	};
	
	/**
	 * Gets updated row dimension span based on given parameters.
	 * 
	 * @param {number} rowIndex 
	 * @param {number} dimensionIndex 
	 * @returns {number}
	 */
	PivotTable.prototype.getUpdatedRowSpan = function (rowIndex, dimensionIndex) {
	    return this.rowAxis.span[dimensionIndex] - this.getHiddenRowsAbove(rowIndex, dimensionIndex) - this.getHiddenRowsBelow(rowIndex, dimensionIndex) - this.getDistanceFromLastRowDimensionUnitActual(rowIndex, dimensionIndex);
	};
	
	/**
	 * Gets normalized row index offset by hidden columns.
	 * 
	 * @param {number} columnIndex 
	 * @param {number} dimensionIndex 
	 * @returns {number}
	 */
	PivotTable.prototype.normalizeColumnIndexOffset = function (columnIndex, dimensionIndex) {
	    if (this.doRowSubTotals()) {
	        return columnIndex - Math.floor(this.getColumnIndexWithHidden(columnIndex) / (this.colUniqueFactor + 1));
	    }
	    return columnIndex;
	};
	/**
	 * Gets the distance from last column axis dimension unit based on the current
	 * state of the table.
	 * 
	 * @param {number} columnIndex 
	 * @param {number} dimensionIndex 
	 * @returns {number}
	 */
	PivotTable.prototype.getDistanceFromLastColumnDimensionUnitActual = function (columnIndex, dimensionIndex) {
	    var normalized = this.normalizeColumnIndex(this.getColumnIndexWithHidden(columnIndex));
	    return this.normalizeColumnIndexOffset(columnIndex) - (this.sumColumnAxisSpanUpToIndex(normalized, dimensionIndex) - this.getColumnAxisSpan(normalized, dimensionIndex));
	};
	
	/**
	 * Gets distance from last column axis dimension unit based on the current
	 * state of the table.
	 * 
	 * @param {number} columnIndex 
	 * @param {number} dimensionIndex 
	 * @returns {number}
	 */
	PivotTable.prototype.getDistanceFromLastColumnDimensionUnitOffset = function (columnIndex, dimensionIndex) {
	    var normalized = this.normalizeColumnIndex(this.getColumnIndexWithHidden(columnIndex));
	    return normalized % this.colAxis.span[dimensionIndex];
	};
	
	/**
	 * Gets the distance to next column axis dimension based on the current
	 * state of the table.
	 * 
	 * @param {number} columnIndex 
	 * @param {number} dimensionIndex 
	 * @returns {number}
	 */
	PivotTable.prototype.getDistanceToNextColumnDimensionUnitActual = function (columnIndex, dimensionIndex) {
	    var normalized = this.normalizeColumnIndex(this.getColumnIndexWithHidden(columnIndex));
	    return this.getColumnAxisSpan(normalized, dimensionIndex) - (this.normalizeColumnIndexOffset(columnIndex) - (this.sumColumnAxisSpanUpToIndex(normalized, dimensionIndex) - this.getColumnAxisSpan(normalized, dimensionIndex)));
	};
	
	/**
	 * Gets distance to next column axis dimension unit based on the current
	 * state of the table.
	 * 
	 * @param {number} columnIndex 
	 * @param {number} dimensionIndex 
	 * @returns {number}
	 */
	PivotTable.prototype.getDistanceToNextColumnDimensionUnitOffset = function (columnIndex, dimensionIndex) {
	    var normalized = this.normalizeColumnIndex(this.getColumnIndexWithHidden(columnIndex));
	    return this.colAxis.span[dimensionIndex] - normalized % this.colAxis.span[dimensionIndex];
	};
	
	/**
	 * Gets number of hidden columns to the left of given column index up to start of 
	 * current dimension unit.
	 * 
	 * @param {number} columnIndex 
	 * @param {number} dimensionIndex 
	 * @returns {number}
	 */
	PivotTable.prototype.getHiddenColumnsLeft = function (columnIndex, dimensionIndex) {
	    return this.getDistanceFromLastColumnDimensionUnitOffset(columnIndex, dimensionIndex) - this.getDistanceFromLastColumnDimensionUnitActual(columnIndex, dimensionIndex);
	};
	
	/**
	 * Gets number of hidden columns to the right of given column index up to end of 
	 * current dimension unit.
	 * 
	 * @param {number} columnIndex 
	 * @param {number} dimensionIndex 
	 * @returns {number}
	 */
	PivotTable.prototype.getHiddenColumnsRight = function (columnIndex, dimensionIndex) {
	    return this.getDistanceToNextColumnDimensionUnitOffset(columnIndex, dimensionIndex) - this.getDistanceToNextColumnDimensionUnitActual(columnIndex, dimensionIndex);
	};
	
	/**
	 * Gets updated column axis span based on given parameters.
	 * 
	 * @param {number} columnIndex 
	 * @param {number} dimensionIndex 
	 * @returns {number}
	 */
	PivotTable.prototype.getUpdatedColumnSpan = function (columnIndex, dimensionIndex) {
	    return this.colAxis.span[dimensionIndex] - this.getHiddenColumnsLeft(columnIndex, dimensionIndex) - this.getHiddenColumnsRight(columnIndex, dimensionIndex) - this.getDistanceFromLastColumnDimensionUnitActual(columnIndex, dimensionIndex);
	};
	
	/**
	 * Sums the column axis spans up to given column index.
	 * 
	 * @param {number} columnIndex 
	 * @param {number} dimensionIndex 
	 * @returns {number}
	 */
	PivotTable.prototype.sumColumnAxisSpanUpToIndex = function (columnIndex, dimensionIndex) {
	    var sum = 0;
	    for (var i = 0; i < Math.floor(columnIndex / this.colAxis.span[dimensionIndex]) + 1; i++) {
	        sum += this.columnAxisSpanMap[dimensionIndex][i];
	    }
	    return sum;
	};
	
	/**
	 * Sums the row axis spans up to given row index.
	 * 
	 * @param {number} rowIndex 
	 * @param {number} dimensionIndex 
	 * @returns {number}
	 */
	PivotTable.prototype.sumRowAxisSpanUpToIndex = function (rowIndex, dimensionIndex) {
	    var sum = 0;
	    for (var i = 0; i < Math.floor(rowIndex / this.rowAxis.span[dimensionIndex]) + 1; i++) {
	        sum += this.rowAxisSpanMap[dimensionIndex][i];
	    }
	    return sum;
	};
	
	/**
	 * Gets the column span of a given dimension.
	 * 
	 * @param {number} columnIndex index of column axis
	 * @param {number} dimensionIndex dimension of column axis
	 * @returns {number}
	 */
	PivotTable.prototype.getColumnAxisSpan = function (columnIndex, dimensionIndex) {
	    return this.columnAxisSpanMap[dimensionIndex][Math.floor(columnIndex / this.colAxis.span[dimensionIndex])];
	};
	
	/**
	 * Calculates true total values.
	 * 
	 * @param {number} numerator 
	 * @param {number} denominator 
	 * @param {number} factor 
	 * @returns 
	 */
	PivotTable.prototype.getTrueTotal = function (numerator, denominator, factor) {
	    return numerator * factor / denominator;
	};
	
	/**
	 * Gets record names.
	 * 
	 * @returns {array}
	 */
	PivotTable.prototype.getRecordNames = function () {
	    return this.filters.getRecordNames(false, this.response, true);
	};
	
	/**
	 * Gets the row axis object at given column/row index.
	 * 
	 * @param {number} columnIndex column index of axis object
	 * @param {number} rowIndex row index of axis object
	 * @returns {object}
	 */
	PivotTable.prototype.getRowAxisObject = function (columnIndex, rowIndex) {
	    return this.rowAxis.objects.all[columnIndex][rowIndex];
	};
	
	/**
	 * Gets the column axis object at given column/row index.
	 * 
	 * @param {number} rowIndex row index of axis object
	 * @param {number} columnIndex column index of axis object
	 * @returns {object}
	 */
	PivotTable.prototype.getColumnAxisObject = function (rowIndex, columnIndex) {
	    return this.colAxis.objects.all[rowIndex][columnIndex];
	};
	
	/**
	 * Gets the total of the row at given row index.
	 * 
	 * @param {number} rowIndex index of row to find total
	 * @returns {number}
	 */
	PivotTable.prototype.getRowTotal = function (rowIndex) {
	    return this.rowTotalLookup[rowIndex];
	};
	
	/**
	 * Gets the total of the column at given column index.
	 * 
	 * @param {number} columnIndex index of column to find total
	 * @returns {number}
	 */
	PivotTable.prototype.getColumnTotal = function (columnIndex) {
	    return this.columnTotalLookup[columnIndex];
	};
	
	/**
	 * Gets the html value of a table cell.
	 * 
	 * @param {object} cell 
	 * @returns {string}
	 */
	PivotTable.prototype.getHtmlValue = function (cell) {
	    if (cell.collapsed) {
	        return '';
	    }
	
	    return this.isTextField(cell.type) ? this.getPrettyHtml(cell.htmlValue) : cell.htmlValue;
	};
	
	/**
	 * gets pretty print of given string.
	 * 
	 * @param {string} htmlValue 
	 * @returns {string}
	 */
	PivotTable.prototype.getPrettyHtml = function (htmlValue) {
	    return this.optionConfig.prettyPrint(htmlValue, this.digitGroupSeparator);
	};
	
	/**
	 * Gets legend display strategy id.
	 * 
	 * @param {string} type 
	 * @returns {number}
	 */
	PivotTable.prototype.getLegendDisplayStrategyId = function (type) {
	    return this.optionConfig.getLegendDisplayStrategy(type).id;
	};
	
	/**
	 * Gets legend display style id.
	 * 
	 * @param {string} type 
	 * @returns {number}
	 */
	PivotTable.prototype.getLegendDisplayStyleId = function (type) {
	    return this.optionConfig.getLegendDisplayStyle(type).id;
	};
	
	/**
	 * Gets the next total column index.
	 * 
	 * @returns {number}
	 */
	PivotTable.prototype.getNextTotalColumnIndex = function () {
	
	    if (!this.doRowTotals()) {
	        return this.columnSize;
	    }
	
	    return this.columnSize - 1;
	};
	
	/**
	 * Gets the next total row index.
	 * 
	 * @returns {number}
	 */
	PivotTable.prototype.getNextTotalRowIndex = function () {
	
	    if (!this.doColTotals()) {
	        return this.rowSize;
	    }
	
	    return this.rowSize - 1;
	};
	
	/**
	 * Gets the width of the viewport used to render the table.
	 * 
	 * @returns {number}
	 */
	PivotTable.prototype.getViewportWidth = function () {
	    return this.viewportWidth;
	};
	
	/**
	 *  Gets the height of the viewport used to render the table.
	 * 
	 * @returns {number}
	 */
	PivotTable.prototype.getViewportHeight = function () {
	    return this.viewportHeight;
	};
	
	/**
	 * Gets the number of cells that can be rendered horizontally within the viewport
	 * with offset for additional cells.
	 * 
	 * @returns {number}
	 */
	PivotTable.prototype.getViewportWidthIndex = function () {
	    return Math.floor(this.viewportWidth / this.cellWidth) + this.renderOffset;
	};
	
	/**
	 * Gets the number of cells that can be rendered vertically within the viewport
	 * with offset for additional cells.
	 * @returns {number}
	 */
	PivotTable.prototype.getViewportHeightIndex = function () {
	    return Math.floor(this.viewportHeight / this.cellHeight) + this.renderOffset;
	};
	
	/**
	 * Gets the height of the entire table in number of cells
	 * including total and sub total rows.
	 * 
	 * @returns {number}
	 */
	PivotTable.prototype.getRowAxisSize = function () {
	    return this.rowSize + this.columnDimensionSize - 1;
	};
	
	/**
	 * Gets the width of the entire table in number of cells
	 * including total and sub total columns.
	 * 
	 * @returns {number}
	 */
	PivotTable.prototype.getColumnAxisSize = function () {
	    return this.columnSize + this.rowDimensionSize - 1;
	};
	
	/**
	 * Gets the number of row axis dimensions.
	 * 
	 * @returns {number}
	 */
	PivotTable.prototype.getRowDimensionSize = function () {
	    return this.rowDimensionSize || 0;
	};
	
	/**
	 * Gets the number of column axis dimensions.
	 * 
	 * @returns {number}
	 */
	PivotTable.prototype.getColumnDimensionSize = function () {
	    return this.columnDimensionSize || 0;
	};
	
	/**
	 * Gets the amount of padding needed to finish the unrendered 
	 * top of the table. Padding is returned in number of pixels.
	 * 
	 * @returns {number}
	 */
	PivotTable.prototype.getTopPadding = function () {
	    var padding = this.rowStart * this.cellHeight;
	
	    if (!this.options.skipTitle && this.rowStart > 0) {
	        padding += this.cellHeight;
	    }
	
	    return padding;
	};
	
	/**
	 * Gets the amount of padding needed to finish the unrendered 
	 * left of the table. Padding is returned in number of pixels.
	 * 
	 * @returns {number}
	 */
	PivotTable.prototype.getLeftPadding = function () {
	    return this.columnStart * this.cellWidth;
	};
	
	/**
	 * Gets the amount of padding needed to finish the unrendered 
	 * right of the table. Padding is returned in number of pixels.
	 * 
	 * @returns {number}
	 */
	PivotTable.prototype.getBottomPadding = function () {
	    return (this.rowSize - this.rowEnd - this.numberOfEmptyRows) * this.cellHeight;
	};
	
	/**
	 * Gets the amount of padding needed to finish the unrendered 
	 * bottom of the table. Padding is returned in number of pixels.
	 * 
	 * @returns {number}
	 */
	PivotTable.prototype.getRightPadding = function () {
	    return (this.columnSize - this.columnEnd - this.numberOfEmptyColumns) * this.cellWidth;
	};
	
	/**
	 * Gets the legend set id.
	 * 
	 * @param {string} dxId 
	 * @returns {string}
	 */
	PivotTable.prototype.getLegendSetId = function (dxId) {
	    return this.response.metaData.items[dxId].legendSet;
	};
	
	/**
	 * Gets a value object used to calcualte correct totals
	 * and fill up the value lookup table.
	 * 
	 * @param {number} rowIndex row index of value
	 * @param {number} columnIndex column index of value
	 * @returns {object}
	 */
	PivotTable.prototype.getValueObject = function (rowIndex, columnIndex) {
	    var id = this.getRRIC(rowIndex, columnIndex).get();
	
	    var value = this.getValue(id),
	        empty = value === null;
	
	    return {
	        empty: empty,
	        value: empty ? 0 : value,
	        numerator: this.getNumeratorValue(id),
	        denominator: this.getDenominatorValue(id),
	        factor: this.getFactorValue(id)
	    };
	};
	
	/**
	 * Gets value id value map.
	 * 
	 * @param {string} id 
	 * @returns {number}
	 */
	PivotTable.prototype.getValue = function (id) {
	
	    var value = this.idValueMap[id],
	        n = parseFloat(value);
	
	    if ((0, _isBoolean2.default)(value)) {
	        return 1;
	    }
	
	    if (!(0, _isNumber2.default)(n) || n != value) {
	        return null;
	    }
	
	    return n;
	};
	/**
	 * Gets factor value from id factor map
	 * 
	 * @param {string} id 
	 * @returns {number}
	 */
	PivotTable.prototype.getFactorValue = function (id) {
	    return parseFloat(this.idFactorMap[id]) || 1;
	};
	/**
	 * Gets numerator value from id numerator map
	 * 
	 * @param {string} id 
	 * @returns {number}
	 */
	PivotTable.prototype.getNumeratorValue = function (id) {
	    return parseFloat(this.idNumeratorMap[id]) || this.getValue(id);
	};
	/**
	 * Gets denominator value from id denominator map
	 * 
	 * @param {string} id 
	 * @returns {number}
	 */
	PivotTable.prototype.getDenominatorValue = function (id) {
	    return parseFloat(this.idDenominatorMap[id]) || 0;
	};
	
	/**
	 * Gets number of rows in table in number of cells.
	 * 
	 * @returns {number}
	 */
	PivotTable.prototype.getRowSize = function () {
	
	    var size = this.rowAxis.size;
	
	    if (!size) {
	        size = 1;
	        return size;
	    }
	
	    if (this.doColSubTotals()) {
	        size += this.rowAxis.size / this.rowUniqueFactor;
	    }
	
	    if (this.doColTotals()) {
	        size += 1;
	    }
	
	    return size;
	};
	/**
	 * Gets number of columns in table in number of cells.
	 * 
	 * @returns {number}
	 */
	PivotTable.prototype.getColumnSize = function () {
	
	    var size = this.colAxis.size;
	
	    if (!size) {
	        size = 1;
	        return size;
	    }
	
	    if (this.doRowSubTotals()) {
	        size += this.colAxis.size / this.colUniqueFactor;
	    }
	
	    if (this.doRowTotals()) {
	        size += 1;
	    }
	
	    return size;
	};
	
	/**
	 * Gets the size of the entire table in number of cells.
	 * 
	 * @returns {nubmer}
	 */
	PivotTable.prototype.getTableSize = function () {
	    return this.rowSize * this.columnSize;
	};
	
	/**
	 * Gets the next sub column index from given column index.
	 * 
	 * @param {number} columnIndex 
	 * @returns {number}
	 */
	PivotTable.prototype.getNextSubColumnIndex = function (columnIndex) {
	    return columnIndex + Math.floor(columnIndex / this.colUniqueFactor) + (this.colUniqueFactor - columnIndex % this.colUniqueFactor);
	};
	
	/**
	 * Gets the next sub row index from given row index.
	 * 
	 * @param {number} rowIndex 
	 * @returns {number}
	 */
	PivotTable.prototype.getNextSubRowIndex = function (rowIndex) {
	    return rowIndex + Math.floor(rowIndex / this.rowUniqueFactor) + (this.rowUniqueFactor - rowIndex % this.rowUniqueFactor);
	};
	
	/**
	 * Gets uuids object map.
	 * 
	 * @returns {object}
	 */
	PivotTable.prototype.getUuidObjectMap = function () {
	    return (0, _objectApplyIf2.default)(this.colAxis ? this.colAxis.uuidObjectMap || {} : {}, this.rowAxis ? this.rowAxis.uuidObjectMap || {} : {});
	};
	
	/**
	 * Gets the index of the last cell to be rendered in column.
	 * 
	 * @param {number} columnIndex 
	 * @returns {number}
	 */
	PivotTable.prototype.getColumnEnd = function (columnIndex) {
	    if (this.doDynamicRendering()) {
	        return this.constrainWidth(this.getViewportWidthIndex() + columnIndex);
	    }
	    return this.getColumnAxisSize() - this.numberOfEmptyColumns;
	};
	
	/**
	 * Gets the index of the last cell to be rendered in row.
	 * 
	 * @param {number}
	 * @returns {number}
	 */
	PivotTable.prototype.getRowEnd = function (rowIndex) {
	    if (this.doDynamicRendering()) {
	        return this.constrainHeight(this.getViewportHeightIndex() + rowIndex);
	    }
	    return this.getRowAxisSize() - this.numberOfEmptyRows;
	};
	
	/**
	 * Gets the row sort id
	 * 
	 * @param {number} rowIndex 
	 * @returns {string}
	 */
	PivotTable.prototype.getRowSortId = function (rowIndex) {
	    if (this.doSortableColumnHeaders() && rowIndex === this.columnDimensionSize - 1) {
	        return this.colAxis.ids[rowIndex];
	    }
	    return null;
	};
	
	/**
	 * Gets the label for the column axis at given index.
	 * 
	 * @param {number} index 
	 * @returns {string}
	 */
	PivotTable.prototype.getColumnAxisLabel = function (index) {
	    if (this.columnDimensionSize) {
	        return this.response.getNameById(this.columnDimensionNames[index]);
	    }
	    return null;
	};
	
	/**
	 * Gets the dimension label for the row axis at given index
	 * 
	 * @param {number} index 
	 * @returns {string}
	 */
	PivotTable.prototype.getRowAxisLabel = function (index) {
	    if (this.rowDimensionSize) {
	        return this.response.getNameById(this.rowDimensionNames[index]);
	    }
	    return null;
	};
	
	/**
	 * Gets the dimension label for the shared column/row.
	 * 
	 * @returns {string}
	 */
	PivotTable.prototype.getCrossAxisLabel = function () {
	    var colAxisLabel = this.getColumnAxisLabel(this.columnDimensionSize - 1),
	        rowAxisLabel = this.getRowAxisLabel(this.rowDimensionSize - 1);
	
	    if (!this.rowAxis.type) {
	        return colAxisLabel;
	    }
	
	    if (!this.colAxis.type) {
	        return rowAxisLabel;
	    }
	
	    if (colAxisLabel) {
	        rowAxisLabel += '&nbsp;/&nbsp;' + colAxisLabel;
	    }
	
	    return rowAxisLabel;
	};
	
	/**
	 * Gets the span for the top title bar.
	 * 
	 * @param {number} span 
	 * @returns {number}
	 */
	PivotTable.prototype.getTopBarSpan = function (span) {
	    var rowDims = this.rowDimensionSize || 0;
	
	    if (!this.colAxis.type && this.rowAxis.type) {
	        return rowDims + 1;
	    }
	
	    return span;
	};
	
	/**
	 * Retrueves the ResponseRowIdCombination for given row and column index pair.
	 * 
	 * @param {number} rowIndex 
	 * @param {number} columnIndex 
	 * @returns {number}
	 */
	PivotTable.prototype.getRRIC = function (rowIndex, columnIndex) {
	    var rric = new _ResponseRowIdCombination.ResponseRowIdCombination();
	
	    if (this.colAxis.type) rric.add(this.colAxis.ids[columnIndex]);
	    if (this.rowAxis.type) rric.add(this.rowAxis.ids[rowIndex]);
	
	    return rric;
	};
	
	/**
	 * Gets associated uuids for given row and column index pair.
	 * 
	 * @param {number} rowIndex 
	 * @param {number} columnIndex 
	 * @returns {number}
	 */
	PivotTable.prototype.getCellUuids = function (rowIndex, columnIndex) {
	    var uuids = [];
	
	    if (this.colAxis.type) {
	        uuids = uuids.concat(this.colAxis.objects.all[this.colAxis.dims - 1][rowIndex].uuids);
	    }
	
	    if (this.rowAxis.type) {
	        uuids = uuids.concat(this.rowAxis.objects.all[this.rowAxis.dims - 1][columnIndex].uuids);
	    }
	
	    return uuids;
	};
	
	/**
	 * Gets percentage of value based on given row index.
	 * 
	 * @param {number} value 
	 * @param {number} rowIndex 
	 * @returns {number}
	 */
	PivotTable.prototype.getRowPercentage = function (value, rowIndex) {
	    return (0, _PivotTableUtils.getPercentageHtml)(value, this.getRowTotal(rowIndex));
	};
	/**
	 * Gets percentage of value based on given column index.
	 * 
	 * @param {number} value 
	 * @param {number} columnIndex 
	 * @returns {number}
	 */
	PivotTable.prototype.getColumnPercentage = function (value, columnIndex) {
	    return (0, _PivotTableUtils.getPercentageHtml)(value, this.getColumnTotal(columnIndex));
	};
	
	// Table Modifiers
	/**
	 * Adds a column to the right side of the table.
	 * 
	 * @param {number} columnIndex index of column to render
	 * @param {number} rowStart index of the first row of the column
	 * @param {number} rowEnd  index of the last row of the column
	 */
	PivotTable.prototype.addRight = function (columnIndex, rowStart, rowEnd) {
	    var column = this.buildColumn(columnIndex, rowStart, rowEnd);
	    for (var i = 0; i < column.length; i++) {
	        this.table[i].push(column[i]);
	    }
	};
	
	/**
	 * Adds a column to the left side of the table.
	 * 
	 * @param {number} columnIndex index of column to render
	 * @param {number} rowStart index of the first row of the column
	 * @param {number} rowEnd index of the last row of the column
	 */
	PivotTable.prototype.addLeft = function (columnIndex, rowStart, rowEnd) {
	    var column = this.buildColumn(columnIndex, rowStart, rowEnd);
	    for (var i = 0; i < column.length; i++) {
	        this.table[i].unshift(column[i]);
	    }
	};
	
	/**
	 * Adds a row to the top side of the table.
	 * 
	 * @param {number} rowIndex index of row to render
	 * @param {number} columnStart index of the first column of the row
	 * @param {number} columnEnd index of the last column of the row
	 */
	PivotTable.prototype.addTop = function (rowIndex, columnStart, columnEnd) {
	    this.table.unshift(this.buildRow(rowIndex, columnStart, columnEnd));
	};
	
	/**
	 * Adds a row to the bottom side of the table.
	 * 
	 * @param {number} rowIndex index of row to render
	 * @param {number} columnStart index of the first column of the row
	 * @param {number} columnEnd index of the last column of the row
	 */
	PivotTable.prototype.addBottom = function (rowIndex, columnStart, columnEnd) {
	    this.table.push(this.buildRow(rowIndex, columnStart, columnEnd));
	};
	
	/**
	 * Removes a column from the left side of the table.
	 * 
	 */
	PivotTable.prototype.deleteLeft = function () {
	    for (var i = 0; i < this.table.length; i++) {
	        this.table[i].shift();
	    }
	};
	
	/**
	 * Removes a column from the right side of the table.
	 * 
	 */
	PivotTable.prototype.deleteRight = function () {
	    for (var i = 0; i < this.table.length; i++) {
	        this.table[i].pop();
	    }
	};
	
	/**
	 * Removes a column from the top side of the table.
	 * 
	 */
	PivotTable.prototype.deleteTop = function () {
	    this.table.shift();
	};
	
	/**
	 * Removes a column from the bottom side of the table.
	 * 
	 */
	PivotTable.prototype.deleteBottom = function () {
	    this.table.pop();
	};
	
	/**
	 * Removes row of given index from the table.
	 * 
	 * @param {number} rowIndex index of row to be removed
	 */
	PivotTable.prototype.deleteRow = function (rowIndex) {
	    this.table.splice(rowIndex, 1);
	};
	
	/**
	 * Removes column of given index from the table.
	 * 
	 * @param {number} columnIndex index of column to be removed
	 */
	PivotTable.prototype.deleteColumn = function (columnIndex) {
	    for (var i = 0; i < this.table.length; i++) {
	        this.table[i].splice(columnIndex, 1);
	    }
	};
	
	/**
	 * Builds a table row based on given parameters.
	 * 
	 * @param {number} rowIndex 
	 * @param {number} columnStart 
	 * @param {number} columnEnd 
	 * @returns {array}
	 */
	PivotTable.prototype.buildRow = function (rowIndex, columnStart, columnEnd) {
	    var rowAxisRow = [];
	
	    if (this.isColumnDimensionRow(rowIndex)) {
	        return this.buildColumnAxisRow(rowIndex, columnStart, columnEnd + 1); // TODO: why + 1?
	    }
	
	    rowIndex -= this.columnDimensionSize;
	
	    if (this.isRowDimensionColumn(columnStart)) {
	        rowAxisRow = this.buildRowAxisRow(rowIndex, columnStart);
	        columnStart = 0;
	    } else {
	        columnStart -= this.rowDimensionSize;
	    }
	
	    columnEnd -= this.rowDimensionSize - 1; // TODO: why - 1?
	
	    return rowAxisRow.concat(this.buildValueRow(rowIndex, columnStart, columnEnd));
	};
	
	/**
	 * Builds a table column based on given parameters
	 * 
	 * @param {number} columnIndex 
	 * @param {number} rowStart 
	 * @param {number} rowEnd 
	 * @returns {array}
	 */
	PivotTable.prototype.buildColumn = function (columnIndex, rowStart, rowEnd) {
	    var columnAxis = this.buildColumnAxisColumn(columnIndex, rowStart);
	
	    if (this.isColumnDimensionRow(rowStart)) {
	        rowEnd -= columnAxis.length - 1; // TODO: why - 1?
	    } else {
	        rowStart -= this.columnDimensionSize;
	        rowEnd -= this.columnDimensionSize - 1; // TODO: why - 1?
	    }
	
	    if (this.isRowDimensionColumn(columnIndex)) {
	        return columnAxis.concat(this.buildRowAxisColumn(columnIndex, rowStart, rowEnd));
	    }
	
	    columnIndex -= this.rowDimensionSize;
	
	    return columnAxis.concat(this.buildValueColumn(columnIndex, rowStart, rowEnd));
	};
	
	/**
	 * Builds value portion of table row based on given parameters.
	 * 
	 * @param {number} rowIndex 
	 * @param {number} columnStart 
	 * @param {number} columnEnd 
	 * @returns {array}
	 */
	PivotTable.prototype.buildValueRow = function (rowIndex, columnStart, columnEnd) {
	    var row = [];
	
	    for (var i = 0, columnIndex = columnStart, cell; columnIndex < columnEnd; i++, columnIndex++) {
	        cell = this.buildValueCell(columnIndex, rowIndex);
	        if (cell) {
	            // TODO: Is this needed?
	            row[i] = cell;
	        }
	    }
	
	    return row;
	};
	
	/**
	 * Builds value portion of table column based on given parameters.
	 * 
	 * @param {number} columnIndex 
	 * @param {number} rowStart 
	 * @param {number} rowEnd 
	 * @returns {array}
	 */
	PivotTable.prototype.buildValueColumn = function (columnIndex, rowStart, rowEnd) {
	    var column = [];
	
	    for (var i = 0, rowIndex = rowStart; rowIndex < rowEnd; i++, rowIndex++) {
	        column[i] = this.buildValueCell(columnIndex, rowIndex);
	    }
	
	    return column;
	};
	
	/**
	 * Builds value cell based on row and column index pair.
	 * 
	 * @param {number} columnIndex 
	 * @param {number} rowIndex 
	 * @returns {object}
	 */
	PivotTable.prototype.buildValueCell = function (columnIndex, rowIndex) {
	
	    rowIndex = this.getRowIndexWithHidden(rowIndex);
	    columnIndex = this.getColumnIndexWithHidden(columnIndex);
	
	    var value = this.valueLookup[rowIndex][columnIndex],
	        htmlValue = null;
	
	    if (this.doColPercentage()) {
	        htmlValue = this.getColumnPercentage(value, columnIndex);
	    }
	
	    if (this.doRowPercentage()) {
	        htmlValue = this.getRowPercentage(value, rowIndex);
	    }
	
	    if (this.isRowGrandTotal(rowIndex) || this.isColumnGrandTotal(columnIndex)) {
	        return (0, _PivotTableCells.ValueTotalCell)(value, htmlValue);
	    }
	
	    if (this.isColumnSubTotal(columnIndex) || this.isRowSubTotal(rowIndex)) {
	        return (0, _PivotTableCells.ValueSubTotalCell)(value, htmlValue);
	    }
	
	    if (value === null || typeof value === 'undefined') {
	        return (0, _PivotTableCells.PlainValueCell)(value);
	    }
	
	    rowIndex = this.normalizeRowIndex(rowIndex);
	    columnIndex = this.normalizeColumnIndex(columnIndex);
	
	    var cell = (0, _PivotTableCells.ValueCell)(value, this.response, this.getRRIC(rowIndex, columnIndex), this.getCellUuids(columnIndex, rowIndex), htmlValue);
	
	    this.uuidDimUuidsMap[cell.uuid] = cell.uuids;
	
	    return cell;
	};
	
	/**
	 * Builds row axis dimension based on given parameters.
	 * 
	 * @returns {array}
	 */
	PivotTable.prototype.buildRowAxis = function () {
	    var axis = [];
	
	    if (!this.rowAxis.type) {
	        if (this.doShowDimensionLabels()) {
	            axis[0] = [(0, _PivotTableCells.DimensionEmptyCell)(1, 1, false, 'visibility: hidden;')];
	        }
	        return axis;
	    }
	
	    for (var i = 0, rowIndex = this.rowStart; rowIndex <= this.rowEnd - this.columnDimensionSize; i++, rowIndex++) {
	        axis[i] = this.buildRowAxisRow(rowIndex, this.columnStart);
	    }
	
	    return axis;
	};
	
	/**
	 * Builds row axis dimension row based on given parameters.
	 * 
	 * @param {number} rowIndex 
	 * @param {number} columnStart 
	 * @returns {array}
	 */
	PivotTable.prototype.buildRowAxisRow = function (rowIndex, columnStart) {
	    if (this.rowDimensionSize < columnStart) {
	        return [];
	    }
	
	    if (!this.rowAxis.type) {
	        return [(0, _PivotTableCells.DimensionEmptyCell)(1, 1, false, 'visibility: hidden;')];
	    }
	
	    var row = [];
	
	    for (var i = 0, columnIndex = columnStart; columnIndex < this.rowDimensionSize; i++, columnIndex++) {
	        row[i] = this.buildRowAxisCell(columnIndex, rowIndex);
	    }
	
	    return row;
	};
	
	/**
	 * Builds column axis dimension row based on given parameters.
	 * 
	 * @param {number} rowIndex 
	 * @param {number} columnStart 
	 * @param {number} columnEnd 
	 * @returns {array}
	 */
	PivotTable.prototype.buildColumnAxisRow = function (rowIndex, columnStart, columnEnd) {
	    if (this.columnDimensionSize < rowIndex) {
	        return [];
	    }
	
	    var row = [];
	
	    if (this.isRowDimensionColumn(columnStart)) {
	        _extends(row, this.buildCornerAxisRow(rowIndex, columnStart));
	    }
	
	    columnStart += row.length;
	
	    columnStart -= this.rowDimensionSize;
	    columnEnd -= this.rowDimensionSize;
	
	    for (var i = row.length; columnStart < columnEnd; i++, columnStart++) {
	        row[i] = this.buildColumnAxisCell(rowIndex, columnStart);
	    }
	
	    return row;
	};
	
	/**
	 * Builds row axis dimension column based on given parameters.
	 * 
	 * @param {number} columnIndex 
	 * @param {number} rowStart 
	 * @param {number} rowEnd 
	 * @returns {array}
	 */
	PivotTable.prototype.buildRowAxisColumn = function (columnIndex, rowStart, rowEnd) {
	
	    var column = [];
	
	    if (this.rowDimensionSize < columnIndex) {
	        return column;
	    }
	
	    if (!this.rowAxis.type) {
	        for (var i = 0; i < rowEnd - rowStart; i++) {
	            column[i] = (0, _PivotTableCells.DimensionEmptyCell)(1, 1, false, 'visibility: hidden;');
	        }
	        return column;
	    }
	
	    for (var _i = 0, rowIndex = rowStart; rowIndex < rowEnd; _i++, rowIndex++) {
	        column[_i] = this.buildRowAxisCell(columnIndex, rowIndex);
	    }
	
	    return column;
	};
	
	/**
	 * Builds row axis cell based on row and column index pair.
	 * 
	 * @param {number} columnIndex 
	 * @param {number} rowIndex 
	 * @returns {object}
	 */
	PivotTable.prototype.buildRowAxisCell = function (columnIndex, rowIndex) {
	
	    rowIndex = this.getRowIndexWithHidden(rowIndex);
	
	    if (this.isRowSubTotal(rowIndex)) {
	        return (0, _PivotTableCells.DimensionSubTotalCell)('&nbsp;', this.rowDimensionSize - columnIndex, 1, true, columnIndex !== this.columnStart);
	    }
	
	    if (this.isRowGrandTotal(rowIndex)) {
	        return (0, _PivotTableCells.DimensionGrandTotalCell)(columnIndex === 0 ? 'Total' : '&nbsp;', this.rowDimensionSize - columnIndex, 1, columnIndex !== 0, columnIndex !== 0, columnIndex !== 0);
	    }
	
	    return (0, _PivotTableCells.RowAxisCell)(this.getRowAxisObject(columnIndex, this.normalizeRowIndex(rowIndex)), this.response, this.doShowHierarchy());
	};
	
	/**
	 * Builds column axis cell based on row and column index pair
	 * 
	 * @param {number} rowIndex 
	 * @param {number} columnIndex 
	 * @returns {object}
	 */
	PivotTable.prototype.buildColumnAxisCell = function (rowIndex, columnIndex) {
	
	    columnIndex = this.getColumnIndexWithHidden(columnIndex);
	
	    if (this.isColumnSubTotal(columnIndex)) {
	        return (0, _PivotTableCells.DimensionSubTotalCell)('&nbsp;', 1, this.columnDimensionSize - rowIndex, true, rowIndex !== this.rowStart);
	    }
	
	    if (this.isColumnGrandTotal(columnIndex)) {
	        return (0, _PivotTableCells.DimensionGrandTotalCell)(rowIndex === 0 ? 'Total' : '&nbsp;', 1, this.columnDimensionSize - rowIndex, rowIndex === this.rowStart && this.doSortableColumnHeaders(), rowIndex !== 0, rowIndex !== 0);
	    }
	
	    return (0, _PivotTableCells.ColumnAxisCell)(this.getColumnAxisObject(rowIndex, this.normalizeColumnIndex(columnIndex)), this.response, this.doShowHierarchy(), this.getRowSortId(rowIndex));
	};
	
	/**
	 * Builds column axis dimension based on given parameters
	 * 
	 * @param {number} columnStart 
	 * @param {number} columnEnd 
	 * @param {number} rowStart 
	 * @returns {array}
	 */
	PivotTable.prototype.buildColumnAxis = function () {
	    if (!this.colAxis.type) {
	        return this.buildCornerAxisRow(0, 0);
	    }
	
	    var axis = [];
	
	    for (var i = 0, columnIndex = this.columnStart; columnIndex <= this.columnEnd; i++, columnIndex++) {
	        axis[i] = this.buildColumnAxisColumn(columnIndex, this.rowStart);
	    }
	
	    return axis;
	};
	
	/**
	 * Builds column axis dimension column based on given parameters
	 * 
	 * @param {number} columnIndex 
	 * @param {number} rowStart 
	 * @returns {array}
	 */
	PivotTable.prototype.buildColumnAxisColumn = function (columnIndex, rowStart) {
	    if (this.columnDimensionSize < rowStart) {
	        return [];
	    }
	
	    if (this.isRowDimensionColumn(columnIndex)) {
	        return this.buildCornerAxisColumn(columnIndex, rowStart);
	    }
	
	    columnIndex -= this.rowDimensionSize;
	
	    var column = [];
	
	    for (var i = 0, rowIndex = rowStart; rowIndex < this.columnDimensionSize; i++, rowIndex++) {
	        column[i] = this.buildColumnAxisCell(rowIndex, columnIndex);
	    }
	
	    return column;
	};
	
	/**
	 * Builds corner axis dimension.
	 * 
	 * @returns {array}
	 */
	PivotTable.prototype.buildCornerAxis = function () {
	    var cornerAxis = [];
	
	    for (var i = 0; i < this.columnDimensionSize; i++) {
	        cornerAxis[i] = this.buildCornerAxisRow(i, 0);
	    }
	
	    return cornerAxis;
	};
	
	/**
	 * Builds corner axis dimension column based on given parameters.
	 * 
	 * @param {number} columnIndex 
	 * @param {number} rowStart 
	 * @returns {array}
	 */
	PivotTable.prototype.buildCornerAxisColumn = function (columnIndex, rowStart) {
	    var column = [];
	
	    if (!this.doShowDimensionLabels()) {
	        column[0] = (0, _PivotTableCells.DimensionEmptyCell)(this.rowDimensionSize - columnIndex, this.columnDimensionSize - rowStart, columnIndex !== this.columnStart);
	        for (var i = 1, rowIndex = rowStart + 1; rowIndex < this.columnDimensionSize; i++, rowIndex++) {
	            column[i] = (0, _PivotTableCells.DimensionEmptyCell)(this.rowDimensionSize - columnIndex, this.columnDimensionSize - rowIndex, true);
	        }
	        return column;
	    }
	
	    if (columnIndex === this.rowDimensionSize - 1) {
	        for (var _i2 = rowStart; _i2 < this.columnDimensionSize - 1; _i2++) {
	            column[_i2] = (0, _PivotTableCells.DimensionLabelCell)(this.getColumnAxisLabel(_i2));
	        }
	        column.push((0, _PivotTableCells.DimensionLabelCell)(this.getCrossAxisLabel()));
	        return column;
	    }
	
	    for (var _i3 = rowStart; _i3 < this.columnDimensionSize - 1; _i3++) {
	        column[_i3] = (0, _PivotTableCells.DimensionLabelCell)('&nbsp;');
	    }
	
	    column[this.columnDimensionSize - 1] = (0, _PivotTableCells.DimensionLabelCell)(this.getRowAxisLabel(columnIndex));
	
	    return column;
	};
	
	/**
	 * Builds corner axis dimension row based on given parameters.
	 * 
	 * @param {number} rowIndex 
	 * @param {number} columnStart 
	 * @returns {array}
	 */
	PivotTable.prototype.buildCornerAxisRow = function (rowIndex, columnStart) {
	    var row = [];
	
	    if (!this.doShowDimensionLabels()) {
	        row[0] = (0, _PivotTableCells.DimensionEmptyCell)(this.rowDimensionSize - columnStart, this.columnDimensionSize - rowIndex, columnStart === this.columnStart);
	        for (var i = 1, columnIndex = columnStart + 1; columnIndex < this.rowDimensionSize; i++, columnIndex++) {
	            row[i] = (0, _PivotTableCells.DimensionEmptyCell)(this.rowDimensionSize - columnIndex, this.columnDimensionSize - rowIndex, true);
	        }
	        return row;
	    }
	
	    if (rowIndex === this.columnDimensionSize - 1 || this.columnDimensionSize === 0) {
	        for (var _i4 = 0, _columnIndex = columnStart; _columnIndex < this.rowDimensionSize - 1; _i4++, _columnIndex++) {
	            row[_i4] = (0, _PivotTableCells.DimensionLabelCell)(this.getRowAxisLabel(_i4));
	        }
	        row.push((0, _PivotTableCells.DimensionLabelCell)(this.getCrossAxisLabel()));
	        return row;
	    }
	
	    for (var _i5 = 0, _columnIndex2 = columnStart; _columnIndex2 < this.rowDimensionSize - 1; _i5++, _columnIndex2++) {
	        row[_i5] = (0, _PivotTableCells.DimensionLabelCell)('&nbsp;');
	    }
	
	    row.push((0, _PivotTableCells.DimensionLabelCell)(this.getColumnAxisLabel(rowIndex)));
	
	    return row;
	};
	
	/**
	 * Creates axis dimension span map.
	 * 
	 * @param {array} spanValues 
	 * @returns {array}
	 */
	PivotTable.prototype.createSpanMap = function (spanValues) {
	    if (!spanValues) {
	        spanValues = [];
	    }
	    return Array.from(spanValues, function (value) {
	        return (0, _PivotTableUtils.defaultProxyGenerator)(value);
	    });
	};
	
	/**
	 * Creates row axis dimension span map
	 * 
	 * @returns {array}
	 */
	PivotTable.prototype.createRowSpanMap = function () {
	    return this.createSpanMap(this.rowAxis.span);
	};
	
	/**
	 * Creates column axis dimension span map.
	 * 
	 * @returns {array}
	 */
	PivotTable.prototype.createColumnSpanMap = function () {
	    return this.createSpanMap(this.colAxis.span);
	};
	
	/**
	 * Update value of total object.
	 * 
	 * @param {number} rowIndex 
	 * @param {number} columnIndex 
	 * @param {object} valueObject 
	 * @param {object} totalObject 
	 */
	PivotTable.prototype.updateValueTotal = function (rowIndex, columnIndex, valueObject, totalObject) {
	
	    if (!totalObject[rowIndex]) {
	        totalObject[rowIndex] = {};
	    }
	
	    if (!totalObject[rowIndex][columnIndex]) {
	        totalObject[rowIndex][columnIndex] = {
	            numerator: 0,
	            denominator: 0,
	            factor: 0,
	            counter: 0,
	            empty: 0
	        };
	    }
	
	    if (valueObject.value === null) {
	        totalObject[rowIndex][columnIndex].empty++;
	    }
	
	    totalObject[rowIndex][columnIndex].counter++;
	
	    (0, _PivotTableUtils.addMerge)(totalObject[rowIndex][columnIndex], valueObject);
	};
	
	/**
	 * Increments value lookup iterator offset by row sub total columns.
	 * 
	 * @param {number} columnIndex 
	 * @returns 
	 */
	PivotTable.prototype.columnAxisOffsetIncrement = function (columnIndex) {
	    if (this.doRowSubTotals() && (columnIndex + 2) % (this.colUniqueFactor + 1) === 0) {
	        return 2;
	    }
	    return 1;
	};
	
	/**
	 * Increments value lookup iterator offset by column sub total rows.
	 * 
	 * @param {number} rowIndex 
	 * @returns 
	 */
	PivotTable.prototype.rowAxisOffsetIncrement = function (rowIndex) {
	    if (this.doColSubTotals() && (rowIndex + 2) % (this.rowUniqueFactor + 1) === 0) {
	        return 2;
	    }
	    return 1;
	};
	
	/**
	 * Initializes lookup tables.
	 */
	PivotTable.prototype.initializeLookups = function () {
	
	    var tableRowSize = this.rowSize,
	        tableColumnSize = this.columnSize;
	
	    var totalMap = {};
	
	    for (var i = 0, rowIndex = 0; rowIndex < tableRowSize; i++, rowIndex += this.rowAxisOffsetIncrement(rowIndex)) {
	        for (var j = 0, columnIndex = 0; columnIndex < tableColumnSize; j++, columnIndex += this.columnAxisOffsetIncrement(columnIndex)) {
	
	            var valueObject = this.getValueObject(i, j);
	
	            if (valueObject) {
	
	                if (!this.valueLookup[rowIndex]) {
	                    this.valueLookup[rowIndex] = {};
	                }
	
	                this.valueLookup[rowIndex][columnIndex] = valueObject.empty ? null : valueObject.value;
	            }
	
	            this.rowTotalLookup[rowIndex] += valueObject.value;
	            this.columnTotalLookup[columnIndex] += valueObject.value;
	
	            this.rowTotalLookup[this.getNextTotalRowIndex()] += valueObject.value;
	            this.columnTotalLookup[this.getNextTotalColumnIndex()] += valueObject.value;
	
	            if (this.doColSubTotals()) {
	                this.rowTotalLookup[this.getNextSubRowIndex(i)] += valueObject.value;
	            }
	
	            if (this.doRowSubTotals()) {
	                this.columnTotalLookup[this.getNextSubColumnIndex(j)] += valueObject.value;
	            }
	
	            // calculate grand totals
	            if (this.doColTotals()) this.updateValueTotal(this.getNextTotalRowIndex(), columnIndex, valueObject, totalMap);
	            if (this.doRowTotals()) this.updateValueTotal(rowIndex, this.getNextTotalColumnIndex(), valueObject, totalMap);
	
	            // calculate sub totals
	            if (this.doColSubTotals()) this.updateValueTotal(this.getNextSubRowIndex(i), columnIndex, valueObject, totalMap);
	            if (this.doRowSubTotals()) this.updateValueTotal(rowIndex, this.getNextSubColumnIndex(j), valueObject, totalMap);
	
	            // calculate intersection totals
	            if (this.doRowTotals() && this.doColTotals()) this.updateValueTotal(this.getNextTotalRowIndex(), this.getNextTotalColumnIndex(), valueObject, totalMap);
	            if (this.doColSubTotals() && this.doRowSubTotals()) this.updateValueTotal(this.getNextSubRowIndex(i), this.getNextSubColumnIndex(j), valueObject, totalMap);
	
	            if (this.doColTotals() && this.doRowSubTotals()) this.updateValueTotal(this.getNextTotalRowIndex(), this.getNextSubColumnIndex(j), valueObject, totalMap);
	            if (this.doRowTotals() && this.doColSubTotals()) this.updateValueTotal(this.getNextSubRowIndex(i), this.getNextTotalColumnIndex(), valueObject, totalMap);
	        }
	    }
	
	    var rowTotalIndices = Object.keys(totalMap);
	
	    for (var _i6 = 0; _i6 < rowTotalIndices.length; _i6++) {
	
	        var columnTotalIndicies = Object.keys(totalMap[rowTotalIndices[_i6]]);
	
	        for (var _j = 0; _j < columnTotalIndicies.length; _j++) {
	
	            var _rowIndex = rowTotalIndices[_i6],
	                _columnIndex3 = columnTotalIndicies[_j];
	
	            if (!this.valueLookup[_rowIndex]) {
	                this.valueLookup[_rowIndex] = {};
	            }
	
	            if (totalMap[_rowIndex][_columnIndex3].counter !== totalMap[_rowIndex][_columnIndex3].empty) {
	                var total = this.getTrueTotal(totalMap[_rowIndex][_columnIndex3].numerator, totalMap[_rowIndex][_columnIndex3].denominator || 1, totalMap[_rowIndex][_columnIndex3].factor / totalMap[_rowIndex][_columnIndex3].counter);
	
	                this.valueLookup[_rowIndex][_columnIndex3] = total;
	            }
	        }
	    }
	};
	
	/**
	 * Creates a row axis render map.
	 * 
	 * @returns {object}
	 */
	PivotTable.prototype.createRowRenderMap = function () {
	    var map = [];
	
	    for (var i = 0; i < this.rowSize; i++) {
	
	        if (!this.isRowEmpty(i) || !this.doHideEmptyRows()) {
	            map.push(i);
	            continue;
	        }
	
	        this.numberOfEmptyRows += 1;
	
	        for (var j = 0; j < this.rowAxis.span.length; j++) {
	            this.decremenetRowAxisSpan(this.normalizeRowIndex(i), j);
	        }
	    }
	    return map;
	};
	
	/**
	 * Creates a column axis render map.
	 * 
	 * @returns {object}
	 */
	PivotTable.prototype.createColumnRenderMap = function () {
	    var map = [];
	
	    for (var i = 0; i < this.columnSize; i++) {
	
	        if (!this.isColumnEmpty(i) || !this.doHideEmptyColumns()) {
	            map.push(i);
	            continue;
	        }
	
	        this.numberOfEmptyColumns += 1;
	        for (var j = 0; j < this.colAxis.span.length - 1; j++) {
	            this.decrementColumnAxisSpan(this.normalizeColumnIndex(i), j);
	        }
	    }
	    return map;
	};
	
	/**
	 * Returns row index constrained against the height of the table.
	 * 
	 * @param {number} rowIndex 
	 * @returns {number}
	 */
	PivotTable.prototype.constrainHeight = function (rowIndex) {
	    return Math.min(this.getRowAxisSize() - this.numberOfEmptyRows, rowIndex);
	};
	/**
	 * Returns column index constrained against the width of the table.
	 * 
	 * @param {number} columnIndex 
	 * @returns {number}
	 */
	PivotTable.prototype.constrainWidth = function (columnIndex) {
	    return Math.min(this.getColumnAxisSize() - this.numberOfEmptyColumns, columnIndex);
	};
	/**
	 * Normalizes given row index based on previous sub column rows.
	 * 
	 * @param {number} rowIndex 
	 * @returns {number}
	 */
	PivotTable.prototype.normalizeRowIndex = function (rowIndex) {
	    if (this.doColSubTotals()) {
	        rowIndex = Math.max(0, rowIndex - Math.floor(rowIndex / (this.rowUniqueFactor + 1)));
	    }
	    return rowIndex;
	};
	/**
	 * Normalizes given column index based on previous sub row columns.
	 * 
	 * @param {number} columnIndex 
	 * @returns {number}
	 */
	PivotTable.prototype.normalizeColumnIndex = function (columnIndex) {
	    if (this.doRowSubTotals()) {
	        return Math.max(0, columnIndex - Math.floor(columnIndex / (this.colUniqueFactor + 1)));
	    }
	    return columnIndex;
	};
	
	/**
	 * Builds table filter.
	 * 
	 * @param {number} span 
	 * @returns {array}
	 */
	PivotTable.prototype.buildTableFilter = function (span) {
	    if (!this.filters) {
	        return [];
	    }
	
	    return [[this.buildHtmlCell((0, _PivotTableCells.FilterCell)(this.getRecordNames(), this.getTopBarSpan(span)))]];
	};
	
	/**
	 * Builds table title.
	 * 
	 * @param {number} span 
	 * @returns 
	 */
	PivotTable.prototype.buildTableTitle = function (span) {
	    if (!this.title) {
	        return [];
	    }
	
	    return [[this.buildHtmlCell((0, _PivotTableCells.FilterCell)(this.title, this.getTopBarSpan(span)))]];
	};
	
	/**
	 * Gets legends.
	 * 
	 * @param {string} dxId 
	 * @returns
	 */
	PivotTable.prototype.getLegends = function (dxId) {
	    return this.appManager.getLegendSetById(this.getLegendSetId(dxId)).legends;
	};
	
	/**
	 * Gets legend set.
	 * 
	 * @param {string} dxId 
	 * @returns 
	 */
	PivotTable.prototype.getLegendSet = function (dxId) {
	    if (!dxId) {
	        return null;
	    }
	
	    return this.response.metaData.items[dxId].legendSet;
	};
	
	/**
	 * Converts table cell to html string
	 * 
	 * @param {object} config 
	 * @returns {string}
	 */
	PivotTable.prototype.buildHtmlCell = function (cell) {
	
	    // validation
	    if (!(0, _isObject2.default)(cell) || cell.hidden || cell.collapsed) {
	        return '';
	    }
	
	    if ((0, _isString2.default)(cell.sort)) {
	        this.sortableIdObjects.push({
	            id: cell.sort,
	            uuid: cell.uuid
	        });
	    }
	
	    if (cell.type === 'value') {
	        this.valueUuids.push(cell.uuid);
	    }
	
	    if (cell.type === 'dimension') {
	        this.dimensionUuids.push(cell.uuid);
	    }
	
	    var style = this.getBaseCellStyling(cell);
	
	    if (cell.isValue) {
	
	        if (!this.options.unclickable) {
	            cell.cls += ' pointer';
	        }
	
	        var legends = this.legendSet ? this.legendSet.legends || [] : [],
	            bgColor = void 0;
	
	        if (this.doLegendDisplayByDataItem() && this.getLegendSet(cell.dxId)) {
	            legends = this.getLegends(cell.dxId);
	        }
	
	        for (var i = 0; i < legends.length; i++) {
	            if ((0, _numberConstrain2.default)(cell.value, legends[i].startValue, legends[i].endValue) === cell.value) {
	                bgColor = legends[i].color;
	            }
	        }
	
	        if (this.doLegendDisplayStyleFill() && bgColor) {
	            style += '\n                background-color:' + bgColor + ';\n                color:' + ((0, _colorUtils.isColorBright)(bgColor) ? 'black' : 'white') + ';\n            ';
	        }
	
	        if (this.doLegendDisplayStyleText() && bgColor) {
	            style += 'color:' + bgColor + ';';
	        }
	    }
	
	    style += cell.style ? cell.style : '';
	
	    return '\n        <td data-ou-id="' + (cell.ouId || '') + '"\n            data-period-id="' + (cell.peId || '') + '"\n            class="' + cell.cls + '"\n            id="' + (cell.uuid || '') + '"\n            title="' + (cell.title || '') + '"\n            style="' + style + '"\n            colspan="' + (cell.colSpan || '') + '"\n            rowSpan="' + (cell.rowSpan || '') + '"\n        >\n            ' + this.getHtmlValue(cell) + '\n        </td>\n    ';
	};
	
	/**
	 * Converts array of table cells to array of html strings
	 * 
	 * @param {array} rows 
	 * @returns {array}
	 */
	PivotTable.prototype.buildHtmlRows = function (rows) {
	    var _this = this;
	
	    return rows.map(function (row) {
	        return _this.buildHtmlRow(row);
	    });
	};
	
	/**
	 * Converts array of table cells to array of html strings
	 * 
	 * @param {array} row 
	 * @returns {array}
	 */
	PivotTable.prototype.buildHtmlRow = function (row) {
	    var _this2 = this;
	
	    return row.map(function (cell) {
	        return _this2.buildHtmlCell(cell);
	    });
	};
	
	/**
	 * Converts array of table cells to html strings
	 * 
	 * @param {any} htmlArray 
	 * @returns {array}
	 */
	PivotTable.prototype.buildHtmlTableRows = function (htmlArray) {
	    var _this3 = this;
	
	    return htmlArray.reduce(function (rows, row) {
	        return rows + _this3.buildHtmlTableRow(row.join(''));
	    }, '');
	};
	
	PivotTable.prototype.buildHtmlTableRow = function (htmlRow) {
	    return htmlRow ? '\n        <tr> \n            ' + (this.doDynamicRendering() ? this.buildLeftPaddingHtmlCell() : '') + '\n            ' + htmlRow + '\n            ' + (this.doDynamicRendering() ? this.buildRightPaddingHtmlCell() : '') + '\n        </tr>\n    ' : '';
	};
	
	/**
	 * Builds top padding row
	 * 
	 * @returns {string}
	 */
	PivotTable.prototype.buildTopPaddingHtmlRow = function () {
	    var cell = this.buildTopPaddingHtmlCell();
	
	    if (cell) {
	        return '<tr>' + cell + '</tr>';
	    }
	
	    return '';
	};
	
	/**
	 * Builds bottom padding row
	 * 
	 * @returns {string}
	 */
	PivotTable.prototype.buildBottomPaddingHtmlRow = function () {
	    var cell = this.buildBottomPaddingHtmlCell();
	
	    if (cell) {
	        return '<tr>' + cell + '</tr>';
	    }
	
	    return '';
	};
	
	/**
	 * Builds top padding cell
	 * 
	 * @returns {string}
	 */
	PivotTable.prototype.buildTopPaddingHtmlCell = function () {
	    var padding = this.getTopPadding(),
	        cell = (0, _PivotTableCells.VerticalPaddingCell)(padding, 'top-padding');
	
	    return this.buildHtmlCell(cell);
	};
	
	/**
	 * Builds bottom padding cell
	 * 
	 * @returns {string}
	 */
	PivotTable.prototype.buildBottomPaddingHtmlCell = function () {
	    var padding = this.getBottomPadding(),
	        cell = (0, _PivotTableCells.VerticalPaddingCell)(padding, 'bottom-padding');
	
	    return this.buildHtmlCell(cell);
	};
	
	/**
	 * Builds left padding cell
	 * 
	 * @returns {string}
	 */
	PivotTable.prototype.buildLeftPaddingHtmlCell = function () {
	    var padding = this.getLeftPadding(),
	        cell = (0, _PivotTableCells.HorizontalPaddingCell)(padding, 'left-padding');
	
	    return this.buildHtmlCell(cell);
	};
	
	/**
	 * Builds right padding cell
	 * 
	 * @returns {string}
	 */
	PivotTable.prototype.buildRightPaddingHtmlCell = function () {
	    var padding = this.getRightPadding(),
	        cell = (0, _PivotTableCells.HorizontalPaddingCell)(padding, 'right-padding');
	
	    return this.buildHtmlCell(cell);
	};
	
	/**
	 * Buidlds html table body
	 * 
	 * @param {array} htmlArray 
	 * @returns {string}
	 */
	PivotTable.prototype.buildHtmlTableBody = function (htmlArray) {
	    return '\n        <tbody>\n            ' + (this.doDynamicRendering() ? this.buildTopPaddingHtmlRow() : '') + '\n            ' + this.buildHtmlTableRows(htmlArray) + '\n            ' + (this.doDynamicRendering() ? this.buildBottomPaddingHtmlRow() : '') + '\n        </tbody>\n    ';
	};
	
	/**
	 * Build html table
	 * 
	 * @param {array} htmlArray 
	 * @returns {string}
	 */
	PivotTable.prototype.buildHtmlTable = function () {
	    var cls = 'pivot user-select',
	        style = 'display:flex!important;overflow:visible;';
	
	    cls += this.displayDensity ? ' displaydensity-' + this.displayDensity : '';
	    cls += this.fontSize ? ' fontsize-' + this.fontSize : '';
	
	    var htmlArray = (0, _arrayClean2.default)([].concat(this.options.skipTitle || this.rowStart > 0 ? [] : this.buildTableTitle(this.table[0].length), this.buildTableFilter(this.table[0].length), this.buildHtmlRows(this.table)));
	
	    return '\n        <div style="' + style + '">\n            <table class="' + cls + '">\n                ' + this.buildHtmlTableBody(htmlArray) + '\n            </table>\n        </div>\n    ';
	};
	
	// table actions
	/**
	 * Builds the initial table.
	 * 
	 * @param {number} [columnStart=0] 
	 * @param {number} [rowStart=0] 
	 */
	PivotTable.prototype.build = function () {
	    var columnStart = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	    var rowStart = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	
	
	    this.setColumnStartAndEnd(columnStart);
	    this.setRowStartAndEnd(rowStart);
	
	    var rowAxis = this.buildRowAxis(),
	        colAxis = this.buildColumnAxis(),
	        values = this.buildValueTable();
	
	    for (var i = 0; i < rowAxis.length; i++) {
	        var _rowAxis$i;
	
	        (_rowAxis$i = rowAxis[i]).push.apply(_rowAxis$i, _toConsumableArray(values[i]));
	    }
	
	    this.table = (0, _PivotTableUtils.toRow)(colAxis).concat(rowAxis);
	};
	
	/**
	 * Renders table in form of html string.
	 * 
	 * @returns {string}
	 */
	PivotTable.prototype.render = function () {
	
	    this.valueUuids = [];
	    this.dimensionUuids = [];
	    this.sortableIdObjects = [];
	
	    if (this.doHideEmptyRows() && (0, _isEmpty2.default)(this.rowAxisLookup) && this.doHideEmptyColumns() && (0, _isEmpty2.default)(this.columnAxisLookup)) {
	        return "There is no data to display, and empty rows and columns are hidden.";
	    }
	
	    if (this.doHideEmptyRows() && (0, _isEmpty2.default)(this.rowAxisLookup)) {
	        return "There is no data to display, and empty rows are hidden.";
	    }
	
	    if (this.doHideEmptyColumns() && (0, _isEmpty2.default)(this.columnAxisLookup)) {
	        return "There is no data to display, and empty columns are hidden.";
	    }
	
	    this.updateDimensionSpan();
	
	    return this.buildHtmlTable();
	};
	
	/**
	 * Updates the table given a new column start and row start.
	 * 
	 * @param {number} columnStart 
	 * @param {number} rowStart 
	 * @returns {string}
	 */
	PivotTable.prototype.update = function (columnStart, rowStart) {
	
	    // decrease rowStart by one if top title is present
	    if (rowStart > 0 && !this.options.skipTitle) {
	        rowStart -= 1;
	    }
	
	    var columnEnd = this.getColumnEnd(columnStart),
	        rowEnd = this.getRowEnd(rowStart);
	
	    while (columnStart !== this.columnStart || rowStart !== this.rowStart || columnEnd !== this.columnEnd || rowEnd !== this.rowEnd) {
	        this.applyChange(columnStart, columnEnd, rowStart, rowEnd);
	    }
	
	    return this.render();
	};
	
	/**
	 * Applies incremental changes to the table.
	 * 
	 * @param {number} columnStart new start column index
	 * @param {number} columnEnd new end column index
	 * @param {number} rowStart new start row index
	 * @param {number} rowEnd new end row index
	 */
	PivotTable.prototype.applyChange = function (columnStart, columnEnd, rowStart, rowEnd) {
	
	    if (this.columnStart > columnStart) {
	        this.columnStart--;
	        this.addLeft(this.columnStart, this.rowStart, this.rowEnd);
	    }
	
	    if (this.columnEnd < columnEnd) {
	        this.setColumnEnd(this.columnEnd + 1);
	        this.addRight(this.columnEnd, this.rowStart, this.rowEnd);
	    }
	
	    if (this.rowStart > rowStart) {
	        this.rowStart--;
	        this.addTop(this.rowStart, this.columnStart, this.columnEnd);
	    }
	
	    if (this.rowEnd < rowEnd) {
	        this.setRowEnd(this.rowEnd + 1);
	        this.addBottom(this.rowEnd, this.columnStart, this.columnEnd);
	    }
	
	    if (this.rowStart < rowStart) {
	        this.rowStart++;
	        this.deleteTop();
	    }
	
	    if (this.rowEnd > rowEnd) {
	        this.setRowEnd(this.rowEnd - 1);
	        this.deleteBottom();
	    }
	
	    if (this.columnStart < columnStart) {
	        this.columnStart++;
	        this.deleteLeft();
	    }
	
	    if (this.columnEnd > columnEnd) {
	        this.setColumnEnd(this.columnEnd - 1);
	        this.deleteRight();
	    }
	};
	
	/**
	 * Decreses the row span by 1 of the associated dimension at 
	 * given row index.
	 * 
	 * @param {number} rowIndex index of row dimension
	 * @param {number} dimensionIndex dimension id
	 */
	PivotTable.prototype.decremenetRowAxisSpan = function (rowIndex, dimensionIndex) {
	    this.rowAxisSpanMap[dimensionIndex][Math.floor(rowIndex / this.rowAxis.span[dimensionIndex])] -= 1;
	};
	
	/**
	 * Decreses the column span by 1 of the associated dimension at 
	 * given column index.
	 * 
	 * @param {number} columnIndex index of column dimension
	 * @param {number} dimensionIndex dimension id
	 */
	PivotTable.prototype.decrementColumnAxisSpan = function (columnIndex, dimensionIndex) {
	    this.columnAxisSpanMap[dimensionIndex][Math.floor(columnIndex / this.colAxis.span[dimensionIndex])] -= 1;
	};
	
	/**
	 * Builds value table based on given parameters
	 * 
	 * @param {number} rowStart 
	 * @param {number} rowEnd 
	 * @param {number} columnStart 
	 * @param {number} columnEnd 
	 * @returns {array}
	 */
	PivotTable.prototype.buildValueTable = function () {
	
	    var rowEnd = this.rowEnd - this.getValueRowStartOffset(),
	        columnEnd = this.columnEnd - this.getValueColumnStartOffset();
	
	    var rowSize = rowEnd - this.rowStart + 1,
	        // TODO: why + 1?
	    colSize = columnEnd - this.columnStart + 1; // TODO: why + 1?
	
	    if (!this.doHideEmptyColumns() && colSize === 0) {
	        colSize = 1;
	    }
	
	    if (!this.doHideEmptyRows() && rowSize === 0) {
	        rowSize = 1;
	    }
	
	    var table = [];
	
	    if (this.doDynamicRendering()) {
	        rowSize = Math.min(rowSize, this.rowSize);
	        colSize = Math.min(colSize, this.columnSize);
	    }
	
	    for (var i = 0, rowIndex = this.rowStart; i < rowSize; i++, rowIndex++) {
	        table.push([]);
	        for (var j = 0, columnIndex = this.columnStart; j < colSize; j++, columnIndex++) {
	            if (this.doSortableColumnHeaders()) {
	                var totalIdComb = new _ResponseRowIdCombination.ResponseRowIdCombination(this.refs, ['total', this.rowAxis.ids[rowIndex]]);
	                this.idValueMap[totalIdComb.get()] = this.isRowEmpty(rowIndex) ? null : this.getRowTotal(rowIndex);
	            }
	            table[i][j] = this.buildValueCell(columnIndex, rowIndex);
	        }
	    }
	
	    return table;
	};
	
	/**
	 * Updates row axis dimension spans based on current render area.
	 * 
	 */
	PivotTable.prototype.updateRowAxisDimensionSpan = function () {
	    if (!this.rowAxis.type) return;
	
	    var rowSpanLimit = this.rowEnd - this.rowStart + 1 - Math.max(0, this.columnDimensionSize - this.rowStart);
	
	    for (var i = 0, columnIndex = this.columnStart; i < this.rowDimensionSize - this.columnStart; i++, columnIndex++) {
	        for (var j = this.getValueRowStartOffset(), rowIndex = this.getValueOffsetRow(), rowSpanCounter = 0, currentRowSpan = 0; j < this.table.length; j++, rowIndex++) {
	
	            var cell = this.table[j][i];
	            if (cell.collapsed || this.doHideEmptyRows() && this.isRowEmpty(this.getRowIndexWithHidden(rowIndex))) {
	                continue;
	            }
	
	            if (cell.type === 'dimensionSubtotal' || cell.type === 'dimensionTotal') {
	                rowSpanCounter += 1;
	                cell.hidden = i !== 0;
	                continue;
	            }
	
	            currentRowSpan -= 1;
	            cell.hidden = !(currentRowSpan <= 0);
	
	            if (currentRowSpan <= 0 && this.rowAxis.span[columnIndex] !== 1) {
	                currentRowSpan = this.getUpdatedRowSpan(rowIndex, columnIndex);
	            }
	
	            if (this.rowAxis.span[columnIndex] === 1) {
	                currentRowSpan = 1;
	            }
	
	            cell.rowSpan = currentRowSpan;
	
	            if (cell.hidden) {
	                continue;
	            }
	
	            if (cell.rowSpan + rowSpanCounter > rowSpanLimit) {
	                cell.rowSpan = rowSpanLimit - rowSpanCounter;
	            }
	
	            rowSpanCounter += cell.rowSpan;
	        }
	    }
	};
	
	/**
	 * Updates column axis dimension span based on current render area.
	 * 
	 */
	PivotTable.prototype.updateColumnAxisDimensionSpan = function () {
	    if (!this.colAxis.type) return;
	
	    var colSpanLimit = this.columnEnd - this.columnStart + 1 - Math.max(0, this.rowDimensionSize - this.columnStart);
	
	    for (var i = 0, rowIndex = this.rowStart; i < this.columnDimensionSize - this.rowStart; i++, rowIndex++) {
	        for (var j = this.getValueColumnStartOffset(), columnIndex = this.getValueOffsetColumn(), colSpanCounter = 0, currentColSpan = 0; j < this.table[i].length; j++, columnIndex++) {
	
	            var cell = this.table[i][j];
	
	            if (cell.collapsed || this.doHideEmptyColumns() && this.isColumnEmpty(this.getColumnIndexWithHidden(columnIndex))) {
	                continue;
	            }
	
	            if (cell.type === 'dimensionSubtotal' || cell.type === 'dimensionTotal') {
	                colSpanCounter += 1;
	                cell.hidden = i !== 0;
	                continue;
	            }
	
	            currentColSpan -= 1;
	            cell.hidden = !(currentColSpan <= 0);
	
	            if (currentColSpan <= 0 && this.colAxis.span[rowIndex] !== 1) {
	                currentColSpan = this.getUpdatedColumnSpan(columnIndex, rowIndex);
	            }
	
	            if (this.colAxis.span[rowIndex] === 1) {
	                currentColSpan = 1;
	            }
	
	            cell.colSpan = currentColSpan;
	
	            if (cell.hidden) {
	                continue;
	            }
	
	            if (cell.colSpan + colSpanCounter > colSpanLimit) {
	                cell.colSpan = colSpanLimit - colSpanCounter;
	            }
	
	            colSpanCounter += cell.colSpan;
	        }
	    }
	};
	
	/**
	 * Updates corner axis dimension span based on current render area.
	 * 
	 */
	PivotTable.prototype.updateCornerAxisDimensionSpan = function () {
	    var rowSpanLimit = this.rowEnd - this.rowStart + 1;
	
	    for (var i = 0, columnIndex = this.columnStart, cell; i < this.rowDimensionSize - this.columnStart; i++, columnIndex++) {
	        for (var j = 0, rowSpanCounter = 0; j < this.columnDimensionSize - this.rowStart; j++) {
	
	            cell = this.table[j][i];
	
	            if (cell.collapsed) continue;
	
	            cell.rowSpan = this.getAdjustedRowSpan(cell, columnIndex);
	
	            if (cell.type === 'labeled') {
	                cell.hidden = false;
	            }
	
	            if (cell.type === 'empty') {
	                cell.hidden = !(i === 0 && j === 0);
	                if (this.doHideEmptyColumns() && this.columnEnd - this.columnStart - 1 === 0) {
	                    cell.hidden = i !== 0;
	                }
	
	                if (j === 0) {
	                    rowSpanCounter += Math.max(0, this.columnDimensionSize - this.rowStart);
	                    continue;
	                }
	            }
	
	            if (rowSpanCounter >= rowSpanLimit || cell.hidden) {
	                cell.hidden = true;
	                continue;
	            }
	
	            if (cell.rowSpan + rowSpanCounter > rowSpanLimit) {
	                cell.rowSpan = rowSpanLimit - rowSpanCounter;
	            }
	
	            rowSpanCounter += cell.rowSpan;
	        }
	    }
	};
	
	/**
	 * Utility function for updating dimension span.
	 * 
	 */
	PivotTable.prototype.updateDimensionSpan = function () {
	    this.updateCornerAxisDimensionSpan();
	    this.updateColumnAxisDimensionSpan();
	    this.updateRowAxisDimensionSpan();
	};
	
	/**
	 * Returns some table statistics in form of string.
	 * 
	 * @returns {string}
	 */
	PivotTable.prototype.statistics = function () {
	    return {
	        "rows:": Object.keys(this.valueLookup).length,
	        "columns:": Object.keys(this.valueLookup[0]).length,
	        "cells": Object.keys(this.valueLookup).length * Object.keys(this.valueLookup[0]).length
	    };
	};
	
	/**
	 * Prints statistics
	 * 
	 * @returns {string}
	 */
	PivotTable.prototype.printStatistics = function () {
	    console.log(this.statistics());
	};
	//# sourceMappingURL=PivotTable.js.map

/***/ },
/* 154 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.PivotTableAxis = undefined;
	
	var _isArray = __webpack_require__(1);
	
	var _isArray2 = _interopRequireDefault(_isArray);
	
	var _arrayContains = __webpack_require__(4);
	
	var _arrayContains2 = _interopRequireDefault(_arrayContains);
	
	var _arrayPluck = __webpack_require__(28);
	
	var _arrayPluck2 = _interopRequireDefault(_arrayPluck);
	
	var _arraySort = __webpack_require__(10);
	
	var _arraySort2 = _interopRequireDefault(_arraySort);
	
	var _arrayUnique = __webpack_require__(14);
	
	var _arrayUnique2 = _interopRequireDefault(_arrayUnique);
	
	var _arrayRepeat = __webpack_require__(185);
	
	var _arrayRepeat2 = _interopRequireDefault(_arrayRepeat);
	
	var _uuid = __webpack_require__(31);
	
	var _uuid2 = _interopRequireDefault(_uuid);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var PivotTableAxis = exports.PivotTableAxis = function PivotTableAxis(refs, layout, response, type) {
	
	    var ignoreKeys = ['dy', 'longitude', 'latitude'];
	
	    var spanType = void 0,
	        aDimensions = [],
	        nAxisWidth = 1,
	        nAxisHeight = void 0,
	        aUniqueFloorWidth = [],
	        aAccFloorWidth = [],
	        aFloorSpan = [],
	        aCondoId = [],
	        uuidObjectMap = {};
	
	    if (type === 'col') {
	        aDimensions = (layout.columns || []).filter(function (dim) {
	            return !(0, _arrayContains2.default)(ignoreKeys, dim.dimension);
	        });
	        spanType = 'colSpan';
	    } else if (type === 'row') {
	        aDimensions = (layout.rows || []).filter(function (dim) {
	            return !(0, _arrayContains2.default)(ignoreKeys, dim.dimension);
	        });
	        spanType = 'rowSpan';
	    }
	
	    if (!((0, _isArray2.default)(aDimensions) && aDimensions.length)) {
	        return;
	    }
	
	    var dimensionNameIdsMap = layout.getDimensionNameIdsMap(response),
	        tableSize = Object.keys(dimensionNameIdsMap).reduce(function (sum, id) {
	        return sum * dimensionNameIdsMap[id].length;
	    }, 1);
	
	    var aaUniqueFloorIds = function () {
	        var dims = void 0;
	
	        return aDimensions.map(function (dimension, index) {
	            if (dimension.sorted) dims = (0, _arrayPluck2.default)(dimension.items, 'id');else dims = dimensionNameIdsMap[dimension.dimension];
	
	            nAxisWidth *= dims.length;
	            aUniqueFloorWidth.push(dims.length);
	            aAccFloorWidth.push(nAxisWidth);
	
	            return dims;
	        });
	    }();
	
	    nAxisHeight = aaUniqueFloorIds.length;
	
	    for (var i = 0; i < nAxisHeight; i++) {
	        aFloorSpan.push(nAxisWidth / aAccFloorWidth[i]);
	    }
	
	    var aaGuiFloorIds = aaUniqueFloorIds.map(function (ids, index) {
	        return (0, _arrayRepeat2.default)(ids, aAccFloorWidth[index - 1]);
	    });
	
	    var aaAllFloorIds = aaGuiFloorIds.map(function (id, index) {
	        return (0, _arrayRepeat2.default)(id, aFloorSpan[index], true);
	    });
	
	    var aaAllFloorObjects = aaAllFloorIds.map(function (ids, i) {
	
	        var siblingPosition = 0,
	            oldestObj = void 0;
	
	        return ids.map(function (id, j) {
	
	            var obj = {
	                id: aaAllFloorIds[i][j],
	                uuid: (0, _uuid2.default)(),
	                dim: i,
	                leaf: i === aaAllFloorIds.length - 1,
	                axis: type,
	                isOrganisationUnit: response.hasIdByDimensionName(aaAllFloorIds[i][j], 'ou')
	            };
	
	            uuidObjectMap[obj.uuid] = obj;
	
	            if (j % aFloorSpan[i] === 0) {
	                obj[spanType] = aFloorSpan[i];
	                obj.children = obj.leaf ? 0 : null;
	                obj.oldest = true;
	                obj.root = i === 0;
	                oldestObj = obj;
	                siblingPosition = 0;
	            }
	
	            obj.oldestSibling = oldestObj;
	            obj.siblingPosition = siblingPosition++;
	
	            if (aaUniqueFloorIds.length - 1 > i) {
	                obj.children = aaUniqueFloorIds[i + 1].length;
	            }
	
	            return obj;
	        });
	    });
	
	    // add parents if more than 1 floor
	    if (nAxisHeight > 1) {
	        for (var _i = 1, aAllFloor; _i < nAxisHeight; _i++) {
	            aAllFloor = aaAllFloorObjects[_i];
	
	            //for (let j = 0, obj, doorCount = 0, span = aFloorSpan[i - 1], parentObj = aaAllFloorObjects[i - 1][0]; j < aAllFloor.length; j++) {
	            for (var j = 0, doorCount = 0, span = aFloorSpan[_i - 1]; j < aAllFloor.length; j++) {
	                aAllFloor[j].parent = aaAllFloorObjects[_i - 1][j];
	            }
	        }
	    }
	
	    var _loop = function _loop(_ids, _i2) {
	        _ids = aaAllFloorIds.map(function (id) {
	            return id[_i2];
	        });
	
	        if (_ids.length) {
	            aCondoId.push(_ids.join('-'));
	        }
	        ids = _ids;
	    };
	
	    for (var _i2 = 0, ids; _i2 < nAxisWidth; _i2++) {
	        _loop(ids, _i2);
	    }
	
	    // add uuids array to leaves
	    if (aaAllFloorObjects.length) {
	
	        // set span to second lowest span number: if aFloorSpan == [15,3,15,1], set span to 3
	        var nSpan = nAxisHeight > 1 ? (0, _arraySort2.default)(aFloorSpan.slice())[1] : nAxisWidth,
	            aAllFloorObjectsLast = aaAllFloorObjects[aaAllFloorObjects.length - 1];
	
	        for (var _i3 = 0, leaf, parentUuids, obj, leafUuids = []; _i3 < aAllFloorObjectsLast.length; _i3++) {
	            leaf = aAllFloorObjectsLast[_i3];
	            leafUuids.push(leaf.uuid);
	            obj = leaf;
	            parentUuids = [];
	
	            // get the uuid of the oldest sibling
	            while (obj = obj.parent) {
	                parentUuids.push(!obj.root && obj.oldestSibling ? obj.oldestSibling.uuid : obj.uuid);
	            }
	
	            // add parent uuids to leaf
	            leaf.uuids = parentUuids.slice();
	
	            // add uuid for all leaves
	            if (leafUuids.length === nSpan) {
	                for (var _j = _i3 - nSpan + 1, _leaf; _j <= _i3; _j++) {
	                    var _leaf$uuids;
	
	                    _leaf = aAllFloorObjectsLast[_j];
	                    (_leaf$uuids = _leaf.uuids).push.apply(_leaf$uuids, _toConsumableArray(leafUuids));
	                }
	
	                leafUuids = [];
	            }
	        }
	    }
	
	    return {
	        type: type,
	        items: aDimensions,
	        xItems: {
	            unique: aaUniqueFloorIds,
	            gui: aaGuiFloorIds,
	            all: aaAllFloorIds
	        },
	        objects: {
	            all: aaAllFloorObjects
	        },
	        ids: aCondoId,
	        span: aFloorSpan,
	        dims: nAxisHeight,
	        size: nAxisWidth,
	        uuidObjectMap: uuidObjectMap
	    };
	};
	//# sourceMappingURL=PivotTableAxis.js.map

/***/ },
/* 155 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.FilterCell = exports.VerticalPaddingCell = exports.HorizontalPaddingCell = exports.PaddingCell = exports.DimensionLabelCell = exports.DimensionEmptyCell = exports.DimensionGrandTotalCell = exports.DimensionSubTotalCell = exports.ColumnAxisCell = exports.RowAxisCell = exports.ValueTotalCell = exports.ValueSubTotalCell = exports.PlainValueCell = exports.ValueCell = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _ResponseRowIdCombination = __webpack_require__(38);
	
	var _PivotTableUtils = __webpack_require__(60);
	
	var _uuid = __webpack_require__(31);
	
	var _uuid2 = _interopRequireDefault(_uuid);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** @description factory function for cell with default options.
	 *  @returns {object}
	 */
	var DefaultCell = function DefaultCell() {
	    return {
	        htmlValue: '&nbsp;',
	
	        collapsed: false,
	        hidden: false,
	        empty: false,
	
	        colSpan: 1,
	        rowSpan: 1,
	
	        width: 120,
	        height: 25,
	
	        style: ''
	    };
	};
	
	var ValueCell = exports.ValueCell = function ValueCell(value, response, rric, uuids, htmlValue) {
	    var cell = DefaultCell();
	
	    cell.uuid = (0, _uuid2.default)();
	    cell.uuids = uuids;
	
	    cell.value = value;
	    cell.htmlValue = value === null || typeof value === 'undefined' ? '&nbsp;' : htmlValue ? htmlValue : value;
	
	    cell.isValue = !cell.empty;
	
	    cell.type = 'value';
	    cell.cls = 'pivot-value' + (cell.empty ? ' cursor-default' : '');
	
	    cell.dxId = rric.getIdByIds(response.metaData.dimensions.dx);
	    cell.peId = rric.getIdByIds(response.metaData.dimensions.pe);
	    cell.ouId = rric.getIdByIds(response.metaData.dimensions.ou);
	
	    return cell;
	};
	
	var PlainValueCell = exports.PlainValueCell = function PlainValueCell(value, rric, response) {
	    var cell = DefaultCell();
	
	    cell.value = value;
	    cell.type = 'value';
	    cell.cls = 'pivot-value' + (cell.empty ? ' cursor-default' : ' pointer');
	
	    cell.htmlValue = _typeof(!value) ? '&nbsp;' : value;
	
	    return cell;
	};
	
	var ValueSubTotalCell = exports.ValueSubTotalCell = function ValueSubTotalCell(value, htmlValue) {
	    var cell = DefaultCell();
	
	    cell.value = value;
	    cell.type = 'valueSubtotal';
	    cell.cls = 'pivot-value-subtotal';
	
	    cell.empty = value === null || typeof value === 'undefined';
	
	    if (typeof value === 'string') {
	        cell.htmlValue = value;
	    } else {
	        cell.htmlValue = cell.empty ? '&nbsp;' : htmlValue ? htmlValue : (0, _PivotTableUtils.getRoundedHtmlValue)(value);
	    }
	
	    return cell;
	};
	
	var ValueTotalCell = exports.ValueTotalCell = function ValueTotalCell(value, htmlValue) {
	    var cell = DefaultCell();
	
	    cell.value = value;
	    cell.type = 'valueTotal';
	    cell.cls = 'pivot-value-total-subgrandtotal';
	
	    cell.empty = value === null || typeof value === 'undefined';;
	
	    if (typeof value === 'string') {
	        cell.htmlValue = value;
	    } else {
	        cell.htmlValue = cell.empty ? '&nbsp;' : htmlValue ? htmlValue : (0, _PivotTableUtils.getRoundedHtmlValue)(value);
	    }
	
	    return cell;
	};
	
	var RowAxisCell = exports.RowAxisCell = function RowAxisCell(axisObject, response, showHierarchy, hidden) {
	
	    if (!axisObject) {
	        return null;
	    }
	
	    var cell = axisObject;
	
	    cell.collapsed = false;
	    cell.hidden = false;
	    cell.empty = false;
	    cell.width = 120;
	    cell.height = 25;
	
	    cell.type = 'dimension';
	    cell.axis = 'row';
	    cell.cls = 'pivot-dim pivot-row-dim td-nobreak';
	
	    if (showHierarchy) {
	        cell.csl += ' align-left';
	    }
	
	    cell.noBreak = true;
	    cell.hidden = typeof hidden === 'undefined' ? !(axisObject.rowSpan || axisObject.colSpan) : hidden;
	
	    var htmlValue = response.getItemName(cell.id, showHierarchy, true);
	
	    cell.htmlValue = htmlValue;
	    cell.title = htmlValue;
	
	    return cell;
	};
	
	var ColumnAxisCell = exports.ColumnAxisCell = function ColumnAxisCell(axisObject, response, showHierarchy, sort, hidden) {
	
	    if (!axisObject) {
	        return null;
	    }
	
	    var cell = axisObject;
	
	    cell.collapsed = false;
	    cell.hidden = false;
	    cell.empty = false;
	
	    cell.width = 120;
	    cell.height = 25;
	
	    cell.type = 'dimension';
	    cell.axis = 'column';
	    cell.cls = 'pivot-dim pivot-col-dim';
	
	    cell.noBreak = false;
	    cell.hidden = typeof hidden === 'undefined' ? !(axisObject.rowSpan || axisObject.colSpan) : hidden;
	
	    if (sort) {
	        cell.sort = sort;
	        cell.cls += ' td-sortable';
	    }
	
	    var htmlValue = response.getItemName(cell.id, showHierarchy, true);
	
	    cell.htmlValue = htmlValue;
	    cell.title = htmlValue;
	
	    return cell;
	};
	
	var DimensionSubTotalCell = exports.DimensionSubTotalCell = function DimensionSubTotalCell(value, colSpan, rowSpan, empty, hidden) {
	    var cell = DefaultCell();
	
	    cell.value = value;
	    cell.type = 'dimensionSubtotal';
	    cell.cls = 'pivot-dim-subtotal';
	
	    cell.colSpan = colSpan;
	    cell.rowSpan = rowSpan;
	
	    cell.empty = empty;
	    cell.hidden = hidden;
	
	    return cell;
	};
	
	var DimensionGrandTotalCell = exports.DimensionGrandTotalCell = function DimensionGrandTotalCell(value, colSpan, rowSpan, sort, generateUuid) {
	    var hidden = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;
	
	    var cell = DefaultCell();
	
	    cell.value = value;
	    cell.type = 'dimensionTotal';
	    cell.cls = 'pivot-dim-total';
	
	    cell.colSpan = colSpan;
	    cell.rowSpan = rowSpan;
	
	    cell.sort = sort ? 'total' : null;
	    cell.uuid = generateUuid ? (0, _uuid2.default)() : null;
	
	    cell.htmlValue = value;
	    cell.hidden = hidden;
	
	    return cell;
	};
	
	var DimensionEmptyCell = exports.DimensionEmptyCell = function DimensionEmptyCell(colSpan, rowSpan, hidden, style) {
	    var cell = DefaultCell();
	
	    cell.value = '&nbsp;';
	    cell.type = 'empty';
	    cell.cls = 'pivot-empty';
	
	    cell.colSpan = colSpan;
	    cell.rowSpan = rowSpan;
	
	    cell.width = colSpan * 120;
	    cell.height = rowSpan * 25;
	
	    cell.hidden = hidden;
	
	    cell.style = style;
	
	    return cell;
	};
	
	var DimensionLabelCell = exports.DimensionLabelCell = function DimensionLabelCell(value, dim) {
	    var cell = DefaultCell();
	
	    cell.value = value;
	    cell.type = 'labeled';
	    cell.cls = 'pivot-dim-label';
	
	    cell.dim = dim;
	    cell.axis = 'row';
	
	    cell.htmlValue = value;
	
	    return cell;
	};
	
	var PaddingCell = exports.PaddingCell = function PaddingCell() {
	    var width = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	    var height = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	    var colSpan = arguments[2];
	    var rowSpan = arguments[3];
	    var hidden = arguments[4];
	
	    var cell = DefaultCell();
	
	    cell.value = '&nbsp;';
	    cell.type = 'padding';
	    cell.cls = 'pivot-padding';
	
	    cell.width = width;
	    cell.height = height;
	
	    cell.colSpan = colSpan;
	    cell.rowSpan = rowSpan;
	
	    cell.hidden = hidden;
	
	    return cell;
	};
	
	var HorizontalPaddingCell = exports.HorizontalPaddingCell = function HorizontalPaddingCell() {
	    var width = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	    var cls = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	    var hidden = arguments[2];
	
	    var cell = DefaultCell();
	
	    if (typeof hidden === 'undefined') {
	        hidden = width <= 0;
	    }
	
	    cell.value = '&nbsp;';
	    cell.type = 'padding';
	    cell.cls = 'pivot-padding ';
	
	    cell.cls += cls;
	
	    cell.width = width;
	
	    cell.hidden = hidden;
	
	    return cell;
	};
	
	var VerticalPaddingCell = exports.VerticalPaddingCell = function VerticalPaddingCell() {
	    var height = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	    var cls = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	    var hidden = arguments[2];
	
	    var cell = DefaultCell();
	
	    if (typeof hidden === 'undefined') {
	        hidden = height <= 0;
	    }
	
	    cell.value = '&nbsp;';
	    cell.type = 'padding';
	    cell.cls = 'pivot-padding ';
	
	    cell.cls += cls;
	
	    cell.height = height;
	
	    cell.hidden = hidden;
	
	    return cell;
	};
	
	var FilterCell = exports.FilterCell = function FilterCell(text, colSpan) {
	    var cell = DefaultCell();
	
	    cell.cls = 'pivot-filter cursor-default', cell.type = 'filter', cell.colSpan = colSpan, cell.title = text, cell.htmlValue = text;
	
	    return cell;
	};
	//# sourceMappingURL=PivotTableCells.js.map

/***/ },
/* 156 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var ChartDownloadButtonItems = exports.ChartDownloadButtonItems = undefined;
	
	exports.ChartDownloadButtonItems = ChartDownloadButtonItems = function ChartDownloadButtonItems(refs) {
	    var uiManager = refs.uiManager,
	        instanceManager = refs.instanceManager,
	        i18n = refs.i18nManager.get();
	
	    var getFilename = function getFilename() {
	        return instanceManager.getStateFavoriteName() || instanceManager.getStateCurrent().title || i18n.untitled;
	    };
	
	    return [{
	        xtype: 'label',
	        text: i18n.graphics,
	        style: 'padding:7px 5px 5px 7px; font-weight:bold'
	    }, {
	        text: i18n.image_png + ' (.png)',
	        iconCls: 'ns-menu-item-image',
	        handler: function handler() {
	            uiManager.submitSvgForm('png', getFilename());
	        }
	    }, {
	        text: 'PDF (.pdf)',
	        iconCls: 'ns-menu-item-image',
	        handler: function handler() {
	            uiManager.submitSvgForm('pdf', getFilename());
	        }
	    }];
	};
	//# sourceMappingURL=ChartDownloadButtonItems.js.map

/***/ },
/* 157 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var ChartTypeToolbar = exports.ChartTypeToolbar = undefined;
	
	exports.ChartTypeToolbar = ChartTypeToolbar = function ChartTypeToolbar(refs) {
	    var appManager = refs.appManager,
	        uiManager = refs.uiManager,
	        instanceManager = refs.instanceManager,
	        i18n = refs.i18nManager.get(),
	        dimensionConfig = refs.dimensionConfig,
	        confData = dimensionConfig.get('data'),
	        confPeriod = dimensionConfig.get('period'),
	        confOrganisationUnit = dimensionConfig.get('organisationUnit'),
	        confCategory = dimensionConfig.get('category'),
	        chartConf = refs.chartConfig,
	        i18n = refs.i18nManager.get(),
	        buttons = [];
	
	    var buttonAddedListener = function buttonAddedListener(b) {
	        buttons.push(b);
	    };
	
	    var column = Ext.create('Ext.button.Button', {
	        xtype: 'button',
	        chartType: chartConf.client.column,
	        iconCls: 'ns-button-icon-type-column',
	        name: chartConf.client.column,
	        tooltipText: i18n.column_chart,
	        pressed: true,
	        listeners: {
	            added: buttonAddedListener
	        }
	    });
	
	    var stackedcolumn = Ext.create('Ext.button.Button', {
	        xtype: 'button',
	        chartType: chartConf.client.stackedcolumn,
	        iconCls: 'ns-button-icon-type-columnstacked',
	        name: chartConf.client.stackedcolumn,
	        tooltipText: i18n.stacked_column_chart,
	        listeners: {
	            added: buttonAddedListener
	        }
	    });
	
	    var bar = Ext.create('Ext.button.Button', {
	        xtype: 'button',
	        chartType: chartConf.client.bar,
	        iconCls: 'ns-button-icon-type-bar',
	        name: chartConf.client.bar,
	        tooltipText: i18n.bar_chart,
	        listeners: {
	            added: buttonAddedListener
	        }
	    });
	
	    var stackedbar = Ext.create('Ext.button.Button', {
	        xtype: 'button',
	        chartType: chartConf.client.stackedbar,
	        iconCls: 'ns-button-icon-type-barstacked',
	        name: chartConf.client.stackedbar,
	        tooltipText: i18n.stacked_bar_chart,
	        listeners: {
	            added: buttonAddedListener
	        }
	    });
	
	    var line = Ext.create('Ext.button.Button', {
	        xtype: 'button',
	        chartType: chartConf.client.line,
	        iconCls: 'ns-button-icon-type-line',
	        name: chartConf.client.line,
	        tooltipText: i18n.line_chart,
	        listeners: {
	            added: buttonAddedListener
	        }
	    });
	
	    var area = Ext.create('Ext.button.Button', {
	        xtype: 'button',
	        chartType: chartConf.client.area,
	        iconCls: 'ns-button-icon-type-area',
	        name: chartConf.client.area,
	        tooltipText: i18n.area_chart,
	        listeners: {
	            added: buttonAddedListener
	        }
	    });
	
	    var pie = Ext.create('Ext.button.Button', {
	        xtype: 'button',
	        chartType: chartConf.client.pie,
	        iconCls: 'ns-button-icon-type-pie',
	        name: chartConf.client.pie,
	        tooltipText: i18n.pie_chart,
	        listeners: {
	            added: buttonAddedListener
	        }
	    });
	
	    var radar = Ext.create('Ext.button.Button', {
	        xtype: 'button',
	        chartType: chartConf.client.radar,
	        iconCls: 'ns-button-icon-type-radar',
	        name: chartConf.client.radar,
	        tooltipText: i18n.radar_chart,
	        listeners: {
	            added: buttonAddedListener
	        }
	    });
	
	    var gauge = Ext.create('Ext.button.Button', {
	        xtype: 'button',
	        chartType: chartConf.client.gauge,
	        iconCls: 'ns-button-icon-type-gauge',
	        name: chartConf.client.gauge,
	        tooltipText: i18n.meter_chart,
	        listeners: {
	            added: buttonAddedListener
	        }
	    });
	
	    var chartType = Ext.create('Ext.toolbar.Toolbar', {
	        height: 45,
	        style: 'padding-top:1px; border:0 none; border-top:1px solid #dadada',
	        reset: function reset() {
	            this.setChartType();
	        },
	        getChartType: function getChartType() {
	            for (var i = 0; i < buttons.length; i++) {
	                if (buttons[i].pressed) {
	                    return buttons[i].chartType;
	                }
	            }
	        },
	        setChartType: function setChartType(type) {
	            if (!type) {
	                buttons[0].toggle(true);
	                return;
	            }
	
	            for (var i = 0; i < buttons.length; i++) {
	                if (buttons[i].chartType === type) {
	                    buttons[i].toggle(true);
	                }
	            }
	        },
	        defaults: {
	            height: 40,
	            toggleGroup: 'charttype',
	            handler: function handler(b) {
	                if (!b.pressed) {
	                    b.toggle();
	                }
	            },
	            listeners: {
	                afterrender: function afterrender(b) {
	                    if (b.xtype === 'button') {
	                        Ext.create('Ext.tip.ToolTip', {
	                            target: b.getEl(),
	                            html: b.tooltipText,
	                            'anchor': 'bottom'
	                        });
	                    }
	                }
	            }
	        },
	        items: [{
	            xtype: 'label',
	            text: i18n.type,
	            style: 'font-size:11px; font-weight:bold; padding:13px 8px 0 6px'
	        }, column, stackedcolumn, bar, stackedbar, line, area, pie, radar, gauge]
	    });
	
	    return chartType;
	};
	//# sourceMappingURL=ChartTypeToolbar.js.map

/***/ },
/* 158 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var ConfirmButton = exports.ConfirmButton = undefined;
	
	exports.ConfirmButton = ConfirmButton = function ConfirmButton(refs, _ref) {
	    var _ref$type = _ref.type,
	        type = _ref$type === undefined ? 'confirm' : _ref$type,
	        _ref$text = _ref.text,
	        text = _ref$text === undefined ? 'OK' : _ref$text,
	        _ref$fn = _ref.fn,
	        fn = _ref$fn === undefined ? Function.prototype : _ref$fn,
	        _ref$closeFn = _ref.closeFn,
	        closeFn = _ref$closeFn === undefined ? Function.prototype : _ref$closeFn,
	        _ref$applyConfig = _ref.applyConfig,
	        applyConfig = _ref$applyConfig === undefined ? {} : _ref$applyConfig;
	
	    var i18n = refs.i18nManager.get();
	
	    var defaults = {
	        padding: '0 3px',
	        borderRadius: '2px',
	        fontWeight: 'bold',
	        btnHeight: 29
	        //btnWidth: text ? null : 72
	    };
	
	    var typeStyle = {
	        'confirm': {
	            color: '#fff',
	            borderColor: '#3079ed',
	            background: '#619dff'
	        },
	        'close': {
	            color: '#555',
	            borderColor: '#ccc'
	        }
	    };
	
	    var style = _extends(defaults, typeStyle[type]);
	
	    return Ext.create('Ext.button.Button', _extends({
	        xtype: 'button',
	        //width: defaults.btnWidth,
	        height: defaults.btnHeight,
	        minWidth: 72,
	        text: '<span style="color:' + style.color + '; font-weight:' + style.fontWeight + '; padding:' + style.padding + '">' + text + '</span>',
	        style: 'border-color:' + style.borderColor + '; background:' + style.background + '; border-radius:' + style.borderRadius,
	        handler: function handler() {
	            fn();
	            closeFn();
	        }
	    }, applyConfig));
	};
	//# sourceMappingURL=ConfirmButton.js.map

/***/ },
/* 159 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.ConfirmWindow = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _ConfirmButton = __webpack_require__(158);
	
	var ConfirmWindow = exports.ConfirmWindow = undefined;
	
	exports.ConfirmWindow = ConfirmWindow = function ConfirmWindow(refs, title, msg, btnText, fn, applyConfig) {
	    var cancelFn = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : Function.prototype;
	    var closeOnAccept = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : false;
	
	    applyConfig = applyConfig || {};
	
	    var i18n = refs.i18nManager.get();
	
	    var confirmButtonText = btnText || 'OK';
	    var cancelButtonText = i18n.cancel || 'Cancel';
	
	    var defaults = {
	        bodyStyle: 'background:#fff; border:0 none'
	    };
	
	    var closeFn = function closeFn() {
	        return window.destroy();
	    };
	
	    var confirmFn = function confirmFn() {
	        if (closeOnAccept) {
	            closeFn();
	            setTimeout(fn, 0);
	        } else {
	            fn();
	        }
	    };
	
	    var confirmButton = new _ConfirmButton.ConfirmButton(refs, { text: confirmButtonText, fn: confirmFn, closeFn: closeFn });
	    var cancelButton = new _ConfirmButton.ConfirmButton(refs, { type: 'close', text: cancelButtonText, fn: cancelFn, closeFn: closeFn });
	
	    var window = Ext.create('Ext.window.Window', _extends({
	        bodyStyle: 'background:#fff; padding:30px 60px 26px 42px',
	        defaults: defaults,
	        modal: true,
	        preventHeader: true,
	        resizable: false,
	        closeable: false,
	        items: [{
	            html: title,
	            bodyStyle: 'padding:0; border:0 none; font-size:16px',
	            style: 'margin-bottom:20px'
	        }, {
	            html: msg,
	            bodyStyle: 'padding:0; border:0 none; font-size:13px',
	            style: 'margin-bottom:16px'
	        }, {
	            layout: 'hbox',
	            defaults: defaults,
	            items: [confirmButton, {
	                width: 10
	            }, cancelButton]
	        }],
	        listeners: {
	            afterrender: function afterrender() {
	                this.setPosition(this.getPosition()[0], this.getPosition()[1] / 2);
	            },
	            show: function show() {
	                confirmButton.focus(false, 50);
	            }
	        }
	    }, applyConfig));
	
	    return window;
	};
	//# sourceMappingURL=ConfirmWindow.js.map

/***/ },
/* 160 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.EmbedButton = undefined;
	
	var _EmbedWindow = __webpack_require__(161);
	
	var EmbedButton = exports.EmbedButton = undefined;
	
	exports.EmbedButton = EmbedButton = function EmbedButton(c) {
	    var i18n = c.i18nManager.get();
	
	    return Ext.create('Ext.button.Button', {
	        text: i18n.embed,
	        disabled: true,
	        menu: {},
	        handler: function handler(b) {
	            (0, _EmbedWindow.EmbedWindow)(c).show();
	        }
	    });
	};
	//# sourceMappingURL=EmbedButton.js.map

/***/ },
/* 161 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var EmbedWindow = exports.EmbedWindow = undefined;
	
	exports.EmbedWindow = EmbedWindow = function EmbedWindow(c) {
	    var appManager = c.appManager,
	        uiManager = c.uiManager,
	        instanceManager = c.instanceManager,
	        i18n = c.i18nManager.get();
	
	    var textArea = Ext.create('Ext.form.field.TextArea', {
	        width: 700,
	        height: 400,
	        readOnly: true,
	        cls: 'ns-textarea monospaced',
	        value: uiManager.getEmbedHtml()
	    });
	
	    var window = Ext.create('Ext.window.Window', {
	        title: i18n.embed_in_web_page,
	        layout: 'fit',
	        modal: true,
	        resizable: false,
	        items: textArea,
	        destroyOnBlur: true,
	        bbar: ['->', {
	            text: i18n.select,
	            handler: function handler() {
	                textArea.selectText();
	            }
	        }],
	        listeners: {
	            show: function show(w) {
	                uiManager.setAnchorPosition(w, 'favoriteButton');
	
	                uiManager.enableRightClick();
	
	                if (!w.hasDestroyOnBlurHandler) {
	                    uiManager.addDestroyOnBlurHandler(w);
	                }
	            },
	            hide: function hide() {
	                uiManager.disableRightClick();
	            }
	        }
	    });
	    uiManager.reg(window, 'embedWindow');
	
	    return window;
	};
	//# sourceMappingURL=EmbedWindow.js.map

/***/ },
/* 162 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var IntegrationButton = exports.IntegrationButton = undefined;
	
	exports.IntegrationButton = IntegrationButton = function IntegrationButton(refs, _ref) {
	    var isDefaultButton = _ref.isDefaultButton,
	        objectName = _ref.objectName,
	        moduleName = _ref.moduleName,
	        btnIconCls = _ref.btnIconCls,
	        btnText = _ref.btnText,
	        menuItem1Text = _ref.menuItem1Text,
	        menuItem2Text = _ref.menuItem2Text,
	        menuItem3Text = _ref.menuItem3Text;
	
	    var appManager = refs.appManager,
	        uiManager = refs.uiManager,
	        instanceManager = refs.instanceManager,
	        sessionStorageManager = refs.sessionStorageManager,
	        i18n = refs.i18nManager.get(),
	        path = appManager.getPath(),
	        config;
	
	    if (isDefaultButton) {
	        config = {
	            text: btnText,
	            iconCls: btnIconCls,
	            toggleGroup: 'module',
	            pressed: true,
	            handler: function handler() {
	                if (!this.pressed) {
	                    this.toggle();
	                }
	            }
	        };
	    } else {
	        config = {
	            text: btnText,
	            iconCls: btnIconCls,
	            toggleGroup: 'module',
	            menu: {},
	            handler: function handler(b) {
	                b.menu = Ext.create('Ext.menu.Menu', {
	                    closeAction: 'destroy',
	                    shadow: false,
	                    showSeparator: false,
	                    items: [{
	                        text: menuItem1Text + '&nbsp;&nbsp;',
	                        cls: 'ns-menu-item-noicon',
	                        listeners: {
	                            render: function render(b) {
	                                this.getEl().dom.addEventListener('click', function (e) {
	                                    if (!b.disabled) {
	                                        uiManager.redirectCtrl(path + '/' + moduleName, e);
	                                    }
	                                });
	                            }
	                        }
	                    }, '-', {
	                        text: menuItem2Text + '&nbsp;&nbsp;',
	                        cls: 'ns-menu-item-noicon',
	                        disabled: !instanceManager.isStateCurrent(),
	                        listeners: {
	                            render: function render(b) {
	                                this.getEl().dom.addEventListener('click', function (e) {
	                                    if (!b.disabled) {
	                                        var layout = instanceManager.getStateCurrent().toSession();
	                                        layout.parentGraphMap = uiManager.get('treePanel').getParentGraphMap();
	
	                                        sessionStorageManager.set(layout, 'analytical');
	
	                                        if (sessionStorageManager.supported) {
	                                            uiManager.redirectCtrl(path + '/' + moduleName + '/index.html?s=analytical', e);
	                                        }
	                                    }
	                                });
	                            }
	                        }
	                    }, {
	                        text: menuItem3Text + '&nbsp;&nbsp;',
	                        cls: 'ns-menu-item-noicon',
	                        disabled: !sessionStorageManager.get(objectName),
	                        listeners: {
	                            render: function render(b) {
	                                this.getEl().dom.addEventListener('click', function (e) {
	                                    if (!b.disabled) {
	                                        uiManager.redirectCtrl(path + '/' + moduleName + '/index.html?s=' + objectName, e);
	                                    }
	                                });
	                            }
	                        }
	                    }],
	                    listeners: {
	                        show: function show() {
	                            uiManager.setAnchorPosition(b.menu, b);
	                        },
	                        hide: function hide() {
	                            b.menu.destroy();
	                            uiManager.get('defaultIntegrationButton').toggle();
	                        },
	                        destroy: function destroy(m) {
	                            b.menu = null;
	                        }
	                    }
	                });
	
	                b.menu.show();
	            }
	        };
	    }
	
	    return Ext.create('Ext.button.Button', config);
	};
	//# sourceMappingURL=IntegrationButton.js.map

/***/ },
/* 163 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var LayoutButton = exports.LayoutButton = undefined;
	
	exports.LayoutButton = LayoutButton = function LayoutButton(refs) {
	    var uiManager = refs.uiManager;
	
	    var i18n = refs.i18nManager.get();
	
	    return Ext.create('Ext.button.Button', {
	        text: i18n.layout,
	        menu: {},
	        handler: function handler() {
	            uiManager.get('viewport').getLayoutWindow().show();
	        }
	    });
	};
	//# sourceMappingURL=LayoutButton.js.map

/***/ },
/* 164 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var LinkWindow = exports.LinkWindow = undefined;
	
	exports.LinkWindow = LinkWindow = function LinkWindow(c) {
	    var appManager = c.appManager,
	        uiManager = c.uiManager,
	        instanceManager = c.instanceManager,
	        i18n = c.i18nManager.get(),
	        path = appManager.getPath(),
	        apiPath = appManager.getApiPath(),
	        apiEndpoint = instanceManager.apiEndpoint,
	        apiModule = instanceManager.apiModule;
	
	    var window = Ext.create('Ext.window.Window', {
	        title: i18n.favorite_link,
	        layout: 'fit',
	        modal: true,
	        resizable: false,
	        destroyOnBlur: true,
	        bodyStyle: 'padding:12px 12px 15px; background-color:#fff; font-size:11px',
	        html: function () {
	            var layout = instanceManager.getStateFavorite(),
	                appUrl = path + '/' + apiModule + '/index.html?id=' + layout.id,
	                apiUrl = apiPath + '/' + apiEndpoint + '/' + layout.id + '/data.html+css',
	                hStyle = 'padding-bottom:10px; font-weight:bold; color:#444',
	                html = '';
	
	            html += '<div style="' + hStyle + '">Open in this app</div>';
	            html += '<a class="user-select td-nobreak" target="_blank" href="' + appUrl + '">' + appUrl + '</a>';
	            html += '<br/><br/><br/>';
	            html += '<div style="' + hStyle + '">Open in web api</div>';
	            html += '<a class="user-select td-nobreak" target="_blank" href="' + apiUrl + '">' + apiUrl + '</a>';
	
	            return html;
	        }(),
	        listeners: {
	            show: function show(w) {
	                uiManager.setAnchorPosition(w, 'favoriteButton');
	
	                uiManager.enableRightClick();
	
	                if (!w.hasDestroyOnBlurHandler) {
	                    uiManager.addDestroyOnBlurHandler(w);
	                }
	            },
	            hide: function hide() {
	                uiManager.disableRightClick();
	            }
	        }
	    });
	    uiManager.reg(window, 'linkWindow');
	
	    return window;
	};
	//# sourceMappingURL=LinkWindow.js.map

/***/ },
/* 165 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.NorthRegion = undefined;
	
	var _AboutWindow = __webpack_require__(61);
	
	var _DateManager = __webpack_require__(24);
	
	var NorthRegion = exports.NorthRegion = undefined;
	
	exports.NorthRegion = NorthRegion = function NorthRegion(c, cmpConfig) {
	    var appManager = c.appManager,
	        instanceManager = c.instanceManager,
	        uiManager = c.uiManager,
	        i18nManager = c.i18nManager,
	        i18n = i18nManager.get(),
	        path = appManager.getPath();
	
	    // component
	    cmpConfig = cmpConfig || {};
	
	    cmpConfig.appName = appManager.appName || '';
	
	    cmpConfig.i18n = cmpConfig.i18n || {};
	    cmpConfig.i18n.about = cmpConfig.i18n.about || i18n.about || 'about';
	    cmpConfig.i18n.home = cmpConfig.i18n.home || i18n.home || 'home';
	    cmpConfig.i18n.untitled = cmpConfig.i18n.untitled || i18n.untitled || 'Untitled';
	
	    cmpConfig.theme = cmpConfig.theme || uiManager.getTheme();
	    cmpConfig.systemTitle = cmpConfig.systemTitle || appManager.systemSettings.systemTitle || 'DHIS 2';
	    cmpConfig.logoWidth = cmpConfig.logoWidth ? parseFloat(cmpConfig.logoWidth) : 418;
	    cmpConfig.aboutFn = cmpConfig.aboutFn || function () {
	        (0, _AboutWindow.AboutWindow)(c).getData();
	    };
	    cmpConfig.homeFn = cmpConfig.homeFn || function () {
	        var dest = path + '/dhis-web-commons-about/redirect.action';
	
	        if (instanceManager.isStateUnsaved()) {
	            uiManager.confirmUnsaved(i18n.leave_application, function () {
	                uiManager.disableConfirmUnload();
	                window.location.href = dest;
	            });
	        } else {
	            window.location.href = dest;
	        }
	    };
	
	    var cmp = {};
	
	    var setLogoWidth = function setLogoWidth(width, append) {
	        width = width || cmpConfig.logoWidth;
	        append = append || 0;
	
	        cmp.logo.setWidth(width + append);
	    };
	
	    var setState = function setState(layout, isFavorite) {
	        cmp.title.setState(layout, isFavorite);
	    };
	
	    return Ext.create('Ext.toolbar.Toolbar', {
	        componentCls: 'toolbar-north',
	        region: 'north',
	        cls: cmpConfig.theme + ' ' + cmpConfig.cls,
	        cmp: cmp,
	        setLogoWidth: setLogoWidth,
	        setState: setState,
	        items: function () {
	            var defaultTitleText = cmpConfig.i18n.untitled;
	
	            cmp.logo = Ext.create('Ext.toolbar.TextItem', {
	                cls: 'logo',
	                width: cmpConfig.logoWidth,
	                html: '<span class="brand">' + cmpConfig.systemTitle + '</span> ' + cmpConfig.appName
	            });
	
	            cmp.title = Ext.create('Ext.toolbar.TextItem', {
	                cls: 'title untitled user-select',
	                titleText: '',
	                appendixText: '',
	                text: defaultTitleText,
	                updateTitle: function updateTitle() {
	                    this.update(this.titleText ? this.titleText + this.appendixText : defaultTitleText);
	                },
	                setTitle: function setTitle(name) {
	                    this.titleText = name || '';
	                    //this.updateTitle();
	                },
	                setTitleAppendix: function setTitleAppendix(text) {
	                    this.appendixText = text ? '<span class="appendix">[' + _DateManager.DateManager.getYYYYMMDD(text, true) + ']</span>' : '';
	                    //this.updateTitle();
	                },
	                setStateSaved: function setStateSaved() {
	                    this.getEl().removeCls('unsaved');
	                    this.getEl().removeCls('untitled');
	                },
	                setStateUnsaved: function setStateUnsaved() {
	                    if (this.titleText) {
	                        this.getEl().removeCls('untitled');
	                        this.getEl().addCls('unsaved');
	                    }
	                },
	                setStateNew: function setStateNew() {
	                    this.getEl().removeCls('unsaved');
	                    this.getEl().addCls('untitled');
	                },
	                setState: function setState(layout, isFavorite) {
	                    if (layout) {
	                        if (isFavorite && layout.displayName) {
	                            this.setTitle(layout.displayName);
	                            this.setTitleAppendix(layout.relativePeriodDate);
	                            this.setStateSaved();
	                        } else {
	                            this.setTitleAppendix();
	                            this.setStateUnsaved();
	                        }
	                    } else {
	                        this.setTitle();
	                        this.setTitleAppendix();
	                        this.setStateNew();
	                    }
	
	                    this.updateTitle();
	                }
	            });
	
	            uiManager.reg(cmp.about = Ext.create('Ext.toolbar.TextItem', {
	                cls: 'about',
	                html: cmpConfig.i18n.about,
	                listeners: {
	                    render: function render(ti) {
	                        var el = ti.getEl();
	
	                        el.on('mouseover', function () {
	                            el.addCls('hover');
	                        });
	
	                        el.on('mouseout', function () {
	                            el.removeCls('hover');
	                        });
	
	                        el.on('click', function () {
	                            cmpConfig.aboutFn();
	                        });
	
	                        el.rendered = true;
	                    }
	                }
	            }), 'aboutButton');
	
	            uiManager.reg(cmp.home = Ext.create('Ext.toolbar.TextItem', {
	                cls: 'about home',
	                html: cmpConfig.i18n.home,
	                listeners: {
	                    render: function render(ti) {
	                        var el = ti.getEl();
	
	                        el.on('mouseover', function () {
	                            el.addCls('hover');
	                        });
	
	                        el.on('mouseout', function () {
	                            el.removeCls('hover');
	                        });
	
	                        el.on('click', function () {
	                            cmpConfig.homeFn();
	                        });
	
	                        el.rendered = true;
	                    }
	                }
	            }), 'homeButton');
	
	            return [cmp.logo, cmp.title, '->', cmp.about, cmp.home, ' ', ' '];
	        }()
	    });
	};
	//# sourceMappingURL=NorthRegion.js.map

/***/ },
/* 166 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var OptionsButton = exports.OptionsButton = undefined;
	
	exports.OptionsButton = OptionsButton = function OptionsButton(refs) {
	    var uiManager = refs.uiManager;
	
	    var i18n = refs.i18nManager.get();
	
	    return Ext.create('Ext.button.Button', {
	        text: i18n.options,
	        menu: {},
	        handler: function handler() {
	            uiManager.get('viewport').getOptionsWindow().show();
	        }
	    });
	};
	//# sourceMappingURL=OptionsButton.js.map

/***/ },
/* 167 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = function (_ref) {
	    var layout = _ref.layout,
	        i18n = _ref.i18n;
	
	    // Load Favorite textfield
	    var _getFavoriteTextCmp = (0, _FavoriteTextCmp2.default)({ layout: layout, i18n: i18n }),
	        nameTextField = _getFavoriteTextCmp.nameTextField,
	        descriptionTextField = _getFavoriteTextCmp.descriptionTextField,
	        titleTextField = _getFavoriteTextCmp.titleTextField;
	
	    // Customise them for translate Panel
	
	
	    delete nameTextField.height;
	    delete titleTextField.height;
	    delete descriptionTextField.height;
	
	    nameTextField.emptyText = i18n.no_translation_for_name;
	
	    if (!layout.title) {
	        titleTextField['disabled'] = true;
	        titleTextField.emptyText = i18n.no_title;
	    } else {
	        titleTextField.emptyText = i18n.no_translation_for_title;
	    }
	
	    if (!layout.description) {
	        descriptionTextField['disabled'] = true;
	        descriptionTextField.emptyText = i18n.no_description;
	    } else {
	        descriptionTextField.emptyText = i18n.no_translation_for_description;
	    }
	
	    // Create labels for keys
	    var getLabelKey = function getLabelKey(text) {
	        return Ext.create('Ext.panel.Panel', {
	            style: 'margin-bottom:0',
	            bodyStyle: 'font-size:11px; color:#666; padding-left:6px; padding-top:3px; border:0 none',
	            html: text
	        });
	    };
	
	    var nameLabelKey = getLabelKey(layout.name);
	    var titleLabelKey = getLabelKey(layout.title);
	    var descriptionLabelKey = getLabelKey(layout.description);
	
	    return {
	        nameTextField: nameTextField,
	        nameLabelKey: nameLabelKey,
	        titleTextField: titleTextField,
	        titleLabelKey: titleLabelKey,
	        descriptionTextField: descriptionTextField,
	        descriptionLabelKey: descriptionLabelKey
	    };
	};
	
	var _FavoriteTextCmp = __webpack_require__(39);
	
	var _FavoriteTextCmp2 = _interopRequireDefault(_FavoriteTextCmp);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	//# sourceMappingURL=TranslateTextCmp.js.map

/***/ },
/* 168 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.TranslateWindow = undefined;
	
	var _isArray = __webpack_require__(1);
	
	var _isArray2 = _interopRequireDefault(_isArray);
	
	var _TranslateTextCmp = __webpack_require__(167);
	
	var _TranslateTextCmp2 = _interopRequireDefault(_TranslateTextCmp);
	
	var _FavoriteStyle = __webpack_require__(25);
	
	var _FavoriteStyle2 = _interopRequireDefault(_FavoriteStyle);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TranslateWindow = exports.TranslateWindow = undefined;
	
	exports.TranslateWindow = TranslateWindow = function TranslateWindow(refs, layout, fn, listeners) {
	    var t = this,
	        appManager = refs.appManager,
	        uiManager = refs.uiManager,
	        instanceManager = refs.instanceManager,
	        i18n = refs.i18nManager.get(),
	        api = refs.api,
	        path = appManager.getPath(),
	        apiEndpoint = instanceManager.apiEndpoint;
	
	    listeners = listeners || {};
	
	    var _getTranslateTextCmp = (0, _TranslateTextCmp2.default)({ layout: layout, i18n: i18n }),
	        nameTextField = _getTranslateTextCmp.nameTextField,
	        nameLabelKey = _getTranslateTextCmp.nameLabelKey,
	        titleTextField = _getTranslateTextCmp.titleTextField,
	        titleLabelKey = _getTranslateTextCmp.titleLabelKey,
	        descriptionTextField = _getTranslateTextCmp.descriptionTextField,
	        descriptionLabelKey = _getTranslateTextCmp.descriptionLabelKey;
	
	    var translations = {};
	    var textfieldPropertyMapping = {};
	
	    var onEventLocaleSelect = function onEventLocaleSelect() {
	
	        var locale = localeComboBox.getValue();
	
	        // Initialise map between db property and textfield
	        textfieldPropertyMapping = {
	            'NAME': nameTextField,
	            'SHORT_NAME': titleTextField,
	            'DESCRIPTION': descriptionTextField
	        };
	
	        // By default set them to empty
	        for (var property in textfieldPropertyMapping) {
	            textfieldPropertyMapping[property].setValue("");
	        }
	
	        // If any value is found, change textfield value
	        translations.forEach(function (trn) {
	            if (trn.locale === locale) {
	                if (trn.property in textfieldPropertyMapping) {
	                    textfieldPropertyMapping[trn.property].setValue(trn.value);
	                }
	            }
	        });
	
	        // Display translate Panel
	        translatePanel.show();
	    };
	
	    var localeStore = Ext.create('Ext.data.Store', {
	        fields: ['locale', 'name'],
	        proxy: {
	            type: 'ajax',
	            url: encodeURI(path + '/api/locales/db.json?paging=false'),
	            reader: {
	                type: 'json'
	            },
	            pageParam: false,
	            startParam: false,
	            limitParam: false
	        }
	    });
	
	    var localeComboBox = Ext.create('Ext.form.ComboBox', {
	        cls: 'ns-combo',
	        width: _FavoriteStyle2.default.windowCmpWidth,
	        height: 45,
	        style: 'margin:2px 5px 0',
	        fieldStyle: 'padding-right:0; padding-left:5px; margin-bottom:3px; font-size:11px; line-height:13px;',
	        fieldLabel: i18n.select_a_locale_to_enter_translations_for,
	        labelAlign: 'top',
	        labelStyle: 'font-size:11px;font-weight:bold;color:#111;padding-top:4px;margin-bottom:2px',
	        labelSeparator: '',
	        store: localeStore,
	        queryMode: 'local',
	        displayField: 'name',
	        valueField: 'locale',
	        emptyText: i18n.select_locale,
	        listeners: {
	            select: function select(locale) {
	                onEventLocaleSelect();
	            }
	        }
	    });
	
	    var translatePanel = Ext.create('Ext.form.Panel', {
	        bodyStyle: 'border-style:none',
	        style: 'margin-bottom:0',
	        hidden: true,
	        defaults: {
	            bodyStyle: 'border-style:none',
	            style: 'margin-bottom:15px'
	        },
	        items: [{
	            items: [nameTextField, nameLabelKey]
	        }, {
	            items: [titleTextField, titleLabelKey]
	        }, {
	            items: [descriptionTextField, descriptionLabelKey]
	        }]
	    });
	
	    var saveButton = Ext.create('Ext.button.Button', {
	        text: i18n.save,
	        handler: function handler() {
	
	            var locale = localeComboBox.getValue();
	
	            // Remove existing translation for this locale
	            var i = translations.length;
	            while (i--) {
	                if (translations[i].locale == locale) {
	                    if (translations[i].property in textfieldPropertyMapping) {
	                        translations.splice(i, 1);
	                    }
	                }
	            }
	
	            // Add translation if value is not empyty
	            var newTranslations = [].concat(translations);
	            for (var property in textfieldPropertyMapping) {
	                if (textfieldPropertyMapping[property].getValue() != '') {
	                    newTranslations.push({
	                        property: property,
	                        locale: locale,
	                        value: textfieldPropertyMapping[property].getValue()
	                    });
	                }
	            }
	
	            // Update server with translations
	            $.ajax({
	                url: encodeURI(path + '/api/' + apiEndpoint + '/' + layout.id + '/translations/'),
	                type: 'PUT',
	                data: JSON.stringify({ 'translations': newTranslations }),
	                dataType: 'json',
	                headers: appManager.defaultRequestHeaders,
	                success: function success(obj, _success, r) {
	                    window.destroy();
	                }
	            });
	        }
	    });
	
	    var cancelButton = Ext.create('Ext.button.Button', {
	        text: i18n.cancel,
	        handler: function handler() {
	            window.destroy();
	        }
	    });
	
	    var window = Ext.create('Ext.window.Window', {
	        cls: 'ns-accordion',
	        title: 'Translate',
	        bodyStyle: 'padding:1px; background:#fff',
	        resizable: false,
	        modal: true,
	        items: [localeComboBox, translatePanel],
	        destroyOnBlur: true,
	        bbar: [cancelButton, '->', saveButton],
	        listeners: {
	            show: function show(w) {
	                // Load locales
	                localeStore.load();
	
	                // Load translations for all languages
	                Ext.Ajax.request({
	                    url: encodeURI(path + '/api/' + apiEndpoint + '/' + layout.id + '/translations.json?paging=false'),
	                    disableCaching: false,
	                    success: function success(r) {
	                        translations = Ext.decode(r.responseText).translations;
	                    }
	                });
	
	                var favoriteButton = uiManager.get('favoriteButton') || {};
	
	                if (favoriteButton.rendered) {
	                    uiManager.setAnchorPosition(w, favoriteButton);
	
	                    if (!w.hasDestroyOnBlurHandler) {
	                        uiManager.addDestroyOnBlurHandler(w);
	                    }
	                }
	
	                localeComboBox.focus(false, 500);
	
	                if (listeners.show) {
	                    listeners.show();
	                }
	            },
	            destroy: function destroy() {
	                if (listeners.destroy) {
	                    listeners.destroy();
	                }
	            }
	        }
	    });
	
	    return window;
	};
	//# sourceMappingURL=TranslateWindow.js.map

/***/ },
/* 169 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.Viewport = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _isString = __webpack_require__(3);
	
	var _isString2 = _interopRequireDefault(_isString);
	
	var _isNumber = __webpack_require__(7);
	
	var _isNumber2 = _interopRequireDefault(_isNumber);
	
	var _isObject = __webpack_require__(2);
	
	var _isObject2 = _interopRequireDefault(_isObject);
	
	var _isIE = __webpack_require__(187);
	
	var _isIE2 = _interopRequireDefault(_isIE);
	
	var _arrayFrom = __webpack_require__(5);
	
	var _arrayFrom2 = _interopRequireDefault(_arrayFrom);
	
	var _arrayContains = __webpack_require__(4);
	
	var _arrayContains2 = _interopRequireDefault(_arrayContains);
	
	var _arrayClean = __webpack_require__(9);
	
	var _arrayClean2 = _interopRequireDefault(_arrayClean);
	
	var _arraySort = __webpack_require__(10);
	
	var _arraySort2 = _interopRequireDefault(_arraySort);
	
	var _clone = __webpack_require__(29);
	
	var _clone2 = _interopRequireDefault(_clone);
	
	var _FavoriteWindow = __webpack_require__(40);
	
	var _InterpretationItem = __webpack_require__(65);
	
	var _PluginItem = __webpack_require__(66);
	
	var _FavoriteButton = __webpack_require__(63);
	
	var _EmbedButton = __webpack_require__(160);
	
	var _EastRegion = __webpack_require__(62);
	
	var _LayoutButton = __webpack_require__(163);
	
	var _OptionsButton = __webpack_require__(166);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var Viewport = exports.Viewport = undefined;
	
	exports.Viewport = Viewport = function Viewport(refs, cmp, config) {
	    var uiManager = refs.uiManager,
	        appManager = refs.appManager,
	        i18nManager = refs.i18nManager,
	        sessionStorageManager = refs.sessionStorageManager,
	        instanceManager = refs.instanceManager,
	        calendarManager = refs.calendarManager,
	        dimensionConfig = refs.dimensionConfig,
	        periodConfig = refs.periodConfig,
	        uiConfig = refs.uiConfig,
	        optionConfig = refs.optionConfig,
	        api = refs.api,
	        apiPath = appManager.getApiPath(),
	        i18n = i18nManager.get(),
	        dataObjectName = dimensionConfig.get('data').objectName,
	        indicatorObjectName = dimensionConfig.get('indicator').objectName,
	        dataElementObjectName = dimensionConfig.get('dataElement').objectName,
	        operandObjectName = dimensionConfig.get('operand').objectName,
	        dataSetObjectName = dimensionConfig.get('dataSet').objectName,
	        eventDataItemObjectName = dimensionConfig.get('eventDataItem').objectName,
	        programIndicatorObjectName = dimensionConfig.get('programIndicator').objectName,
	        periodObjectName = dimensionConfig.get('period').objectName,
	        organisationUnitObjectName = dimensionConfig.get('organisationUnit').objectName,
	        treePanel = uiManager.get('treePanel'),
	        layoutWindow = uiManager.get('layoutWindow'),
	        optionsWindow = uiManager.get('optionsWindow'),
	        favoriteWindow = uiManager.get('favoriteWindow'),
	        displayProperty = appManager.getDisplayProperty(),
	        displayPropertyUrl = appManager.getDisplayPropertyUrl(),
	        dimensionPanelMap = {};
	
	    cmp = cmp || {};
	
	    var northRegion = cmp.northRegion;
	
	    var eastRegion = cmp.eastRegion;
	
	    var westRegionItems = cmp.westRegionItems;
	
	    var chartTypeToolbar = cmp.chartTypeToolbar;
	
	    var getChartType = function getChartType() {
	        return chartTypeToolbar ? chartTypeToolbar.getChartType() : null;
	    };
	
	    var dataTypeToolbar = cmp.dataTypeToolbar;
	
	    var getDataType = function getDataType() {
	        return dataTypeToolbar ? dataTypeToolbar.getDataType() : null;
	    };
	
	    var statusBar = cmp.statusBar;
	
	    var favoriteButton = uiManager.reg((0, _FavoriteButton.FavoriteButton)(refs), 'favoriteButton');
	
	    var layoutButton = uiManager.reg((0, _LayoutButton.LayoutButton)(refs), 'layoutButton');
	
	    var optionsButton = uiManager.reg((0, _OptionsButton.OptionsButton)(refs), 'optionsButton');
	
	    var embedButton = uiManager.reg((0, _EmbedButton.EmbedButton)(refs), 'embedButton', 'onCurrent');
	
	    var integrationButtons = cmp.integrationButtons;
	
	    var DownloadButtonItems = cmp.DownloadButtonItems;
	
	    var detailsButton = Ext.create('Ext.Button', {
	        id: "toggleEastRegionButton",
	        text: ' ',
	        width: 26,
	        padding: '3',
	        iconCls: 'ns-button-icon-arrowlefttriple',
	        iconState: 1,
	        setIconState: function setIconState() {
	            switch (this.iconState++ % 2) {
	                case 1:
	                    this.el.dom.style.visibility = "hidden";break;
	                case 0:
	                    this.el.dom.style.visibility = "visible";break;
	            }
	        },
	        handler: function handler(b) {
	            eastRegion.toggleCollapse();
	            this.setIconState();
	        }
	    });
	
	    // viewport
	
	    //var accordionBody = Ext.create('Ext.panel.Panel', {
	    //layout: 'accordion',
	    //activeOnTop: true,
	    //cls: 'ns-accordion',
	    //bodyStyle: 'border:0 none; margin-bottom:2px',
	    //height: 700,
	    //dimensionPanels: null,
	    //items: westRegionItems
	    //});
	    //uiManager.reg(accordionBody, 'accordionBody');
	
	    //var accordion = Ext.create('Ext.panel.Panel', {
	    //bodyStyle: 'border-style:none; border-top:1px solid #d6d6d6; padding:1px; padding-bottom:0; overflow-y:scroll;',
	    //items: accordionBody,
	    //setThisHeight: function(mx) {
	    //var panelHeight = westRegionItems.length * 28,
	    //height;
	
	    //if (westRegion.hasScrollbar) {
	    //height = panelHeight + mx;
	    //this.setHeight(westRegion.getHeight() - 2);
	    //accordionBody.setHeight(height - 2);
	    //}
	    //else {
	    //height = westRegion.getHeight() - uiConfig.west_fill;
	    //mx += panelHeight;
	    //accordion.setHeight((height > mx ? mx : height) - 2);
	    //accordionBody.setHeight((height > mx ? mx : height) - 4);
	    //}
	    //},
	    //getExpandedPanel: function() {
	    //for (var i = 0, panel; i < westRegionItems.length; i++) {
	    //if (!westRegionItems[i].collapsed) {
	    //return westRegionItems[i];
	    //}
	    //}
	
	    //return null;
	    //},
	    //getFirstPanel: function() {
	    //return accordionBody.items.items[0];
	    //}
	    //});
	    //uiManager.reg(accordion, 'accordion');
	
	    var westRegion = Ext.create('Ext.panel.Panel', {
	        region: 'west',
	        preventHeader: true,
	        collapsible: true,
	        collapseMode: 'mini',
	        border: false,
	        hasScrollbar: false,
	        hasChartTypeToolbar: function hasChartTypeToolbar() {
	            return !!chartTypeToolbar;
	        },
	        width: uiConfig.west_width + uiManager.getScrollbarSize().width,
	        items: (0, _arrayClean2.default)([chartTypeToolbar, dataTypeToolbar, westRegionItems]),
	        onScrollbar: function onScrollbar() {
	            this.hasScrollbar = true;
	
	            if (dataTypeToolbar) {
	                dataTypeToolbar.setButtonWidth(uiManager.getScrollbarSize().width, true);
	            }
	        },
	        setState: function setState(layout) {
	            westRegionItems.setUiState(layout);
	        }
	    });
	    uiManager.reg(westRegion, 'westRegion');
	
	    var updateButton = Ext.create('Ext.button.Split', {
	        text: '<b>' + i18n.update + '</b>&nbsp;',
	        handler: function handler() {
	            instanceManager.getReport();
	        },
	        arrowHandler: function arrowHandler(b) {
	            b.menu = Ext.create('Ext.menu.Menu', {
	                closeAction: 'destroy',
	                shadow: false,
	                showSeparator: false,
	                items: [{
	                    xtype: 'label',
	                    text: i18n.download_data,
	                    style: 'padding:7px 40px 5px 7px; font-weight:bold; color:#111; border:0 none'
	                }, {
	                    text: 'CSV',
	                    iconCls: 'ns-menu-item-datasource',
	                    handler: function handler() {
	                        uiManager.openDataDump(null, 'csv');
	                    }
	                }],
	                listeners: {
	                    show: function show() {
	                        uiManager.setAnchorPosition(b.menu, b);
	                    },
	                    hide: function hide() {
	                        b.menu.destroy();
	                    },
	                    destroy: function destroy(m) {
	                        b.menu = null;
	                    }
	                }
	            });
	
	            this.menu.show();
	        }
	    });
	    uiManager.reg(updateButton, 'updateButton');
	
	    var downloadButton = Ext.create('Ext.button.Button', {
	        text: i18n.download,
	        disabled: true,
	        menu: {},
	        handler: function handler(b) {
	            b.menu = Ext.create('Ext.menu.Menu', {
	                closeAction: 'destroy',
	                shadow: false,
	                showSeparator: false,
	                items: function () {
	                    var layout = instanceManager.getStateCurrent();
	
	                    var jsonReq = layout.req();
	                    var xmlReq = layout.req(null, 'xml');
	                    var xlsReq = layout.req(null, 'xls');
	                    var csvReq = layout.req(null, 'csv');
	                    var jrxmlReq = layout.req(null, 'jrxml');
	                    var sqlReq = layout.req('/analytics/debug/sql', 'sql');
	                    var dataValueSetJsonReq = layout.req('/analytics/dataValueSet', 'json', null, null, true);
	                    var dataValueSetXmlReq = layout.req('/analytics/dataValueSet', 'xml', null, null, true);
	
	                    var items = [].concat(_toConsumableArray(DownloadButtonItems(refs)), [{
	                        xtype: 'menuseparator'
	                    }, {
	                        xtype: 'label',
	                        text: i18n.plain_data_sources,
	                        style: 'padding:7px 5px 5px 7px; font-weight:bold'
	                    }, {
	                        text: 'JSON',
	                        iconCls: 'ns-menu-item-datasource',
	                        handler: function handler() {
	                            uiManager.openPlainDataSource(jsonReq, null, true);
	                        },
	                        menu: [{
	                            xtype: 'label',
	                            text: i18n.metadata_id_scheme,
	                            style: 'padding:7px 18px 5px 7px; font-weight:bold; color:#333'
	                        }, {
	                            text: 'ID',
	                            iconCls: 'ns-menu-item-scheme',
	                            handler: function handler() {
	                                uiManager.openPlainDataSource(jsonReq, '&outputIdScheme=UID', true);
	                            }
	                        }, {
	                            text: 'Code',
	                            iconCls: 'ns-menu-item-scheme',
	                            handler: function handler() {
	                                uiManager.openPlainDataSource(jsonReq, '&outputIdScheme=CODE', true);
	                            }
	                        }, {
	                            text: 'Name',
	                            iconCls: 'ns-menu-item-scheme',
	                            handler: function handler() {
	                                uiManager.openPlainDataSource(jsonReq, '&outputIdScheme=NAME', true);
	                            }
	                        }]
	                    }, {
	                        text: 'XML',
	                        iconCls: 'ns-menu-item-datasource',
	                        handler: function handler() {
	                            uiManager.openPlainDataSource(xmlReq, null, true);
	                        },
	                        menu: [{
	                            xtype: 'label',
	                            text: i18n.metadata_id_scheme,
	                            style: 'padding:7px 18px 5px 7px; font-weight:bold; color:#333'
	                        }, {
	                            text: 'ID',
	                            iconCls: 'ns-menu-item-scheme',
	                            handler: function handler() {
	                                uiManager.openPlainDataSource(xmlReq, '&outputIdScheme=UID', true);
	                            }
	                        }, {
	                            text: 'Code',
	                            iconCls: 'ns-menu-item-scheme',
	                            handler: function handler() {
	                                uiManager.openPlainDataSource(xmlReq, '&outputIdScheme=CODE', true);
	                            }
	                        }, {
	                            text: 'Name',
	                            iconCls: 'ns-menu-item-scheme',
	                            handler: function handler() {
	                                uiManager.openPlainDataSource(xmlReq, '&outputIdScheme=NAME', true);
	                            }
	                        }]
	                    }, {
	                        text: 'Microsoft Excel',
	                        iconCls: 'ns-menu-item-datasource',
	                        handler: function handler() {
	                            uiManager.openPlainDataSource(xlsReq);
	                        },
	                        menu: [{
	                            xtype: 'label',
	                            text: i18n.metadata_id_scheme,
	                            style: 'padding:7px 18px 5px 7px; font-weight:bold; color:#333'
	                        }, {
	                            text: 'ID',
	                            iconCls: 'ns-menu-item-scheme',
	                            handler: function handler() {
	                                uiManager.openPlainDataSource(xlsReq, '&outputIdScheme=UID');
	                            }
	                        }, {
	                            text: 'Code',
	                            iconCls: 'ns-menu-item-scheme',
	                            handler: function handler() {
	                                uiManager.openPlainDataSource(xlsReq, '&outputIdScheme=CODE');
	                            }
	                        }, {
	                            text: 'Name',
	                            iconCls: 'ns-menu-item-scheme',
	                            handler: function handler() {
	                                uiManager.openPlainDataSource(xlsReq, '&outputIdScheme=NAME');
	                            }
	                        }]
	                    }, {
	                        text: 'CSV',
	                        iconCls: 'ns-menu-item-datasource',
	                        handler: function handler() {
	                            uiManager.openPlainDataSource(csvReq);
	                        },
	                        menu: [{
	                            xtype: 'label',
	                            text: i18n.metadata_id_scheme,
	                            style: 'padding:7px 18px 5px 7px; font-weight:bold; color:#333'
	                        }, {
	                            text: 'ID',
	                            iconCls: 'ns-menu-item-scheme',
	                            handler: function handler() {
	                                uiManager.openPlainDataSource(csvReq, '&outputIdScheme=UID');
	                            }
	                        }, {
	                            text: 'Code',
	                            iconCls: 'ns-menu-item-scheme',
	                            handler: function handler() {
	                                uiManager.openPlainDataSource(csvReq, '&outputIdScheme=CODE');
	                            }
	                        }, {
	                            text: 'Name',
	                            iconCls: 'ns-menu-item-scheme',
	                            handler: function handler() {
	                                uiManager.openPlainDataSource(csvReq, '&outputIdScheme=NAME');
	                            }
	                        }]
	                    }, {
	                        text: i18n.advanced,
	                        iconCls: 'ns-menu-item-advanced',
	                        menu: [{
	                            xtype: 'label',
	                            text: i18n.data_value_set,
	                            style: 'padding:7px 18px 5px 7px; font-weight:bold; color:#333'
	                        }, {
	                            text: 'JSON',
	                            iconCls: 'ns-menu-item-datasource',
	                            handler: function handler() {
	                                uiManager.openPlainDataSource(dataValueSetJsonReq, null, true);
	                            }
	                        }, {
	                            text: 'XML',
	                            iconCls: 'ns-menu-item-datasource',
	                            handler: function handler() {
	                                uiManager.openPlainDataSource(dataValueSetXmlReq, null, true);
	                            }
	                        }, {
	                            xtype: 'menuseparator'
	                        }, {
	                            xtype: 'label',
	                            text: i18n.other_formats,
	                            style: 'padding:7px 18px 5px 7px; font-weight:bold; color:#333'
	                        }, {
	                            text: 'JRXML',
	                            iconCls: 'ns-menu-item-datasource',
	                            handler: function handler() {
	                                uiManager.openPlainDataSource(jrxmlReq, null, true);
	                            }
	                        }, {
	                            text: i18n.raw_data + ' SQL',
	                            iconCls: 'ns-menu-item-datasource',
	                            handler: function handler() {
	                                uiManager.openPlainDataSource(sqlReq, null, true);
	                            }
	                        }]
	                    }]);
	
	                    if (layout && !!layout.showHierarchy && layout.hasDimension('ou')) {
	                        items.push({
	                            xtype: 'label',
	                            text: i18n.plain_data_sources + ' w/ hierarchy',
	                            style: 'padding:7px 8px 5px 7px; font-weight:bold'
	                        });
	
	                        items.push({
	                            text: 'CSV',
	                            iconCls: 'ns-menu-item-datasource',
	                            handler: function handler() {
	                                layout.getResponse().clone().addOuHierarchyDimensions().printResponseCSV();
	                            }
	                        });
	                    }
	
	                    return items;
	                }(),
	                listeners: {
	                    show: function show() {
	                        uiManager.setAnchorPosition(b.menu, b);
	                    },
	                    hide: function hide() {
	                        b.menu.destroy();
	                    },
	                    destroy: function destroy(m) {
	                        b.menu = null;
	                    }
	                }
	            });
	
	            this.menu.show();
	        }
	    });
	    uiManager.reg(downloadButton, 'downloadButton', 'onCurrent');
	
	    var defaultButton = Ext.create('Ext.button.Button', {
	        text: i18n.table,
	        iconCls: 'ns-button-icon-table',
	        toggleGroup: 'module',
	        pressed: true
	    });
	
	    var centerRegion = Ext.create('Ext.panel.Panel', {
	        region: 'center',
	        bodyStyle: 'padding:1px',
	        autoScroll: true,
	        fullSize: true,
	        cmp: [defaultButton],
	        toggleCmp: function toggleCmp(show) {
	            integrationButtons.forEach(function (cmp) {
	                if (cmp && cmp.show && cmp.hide) {
	                    if (show) {
	                        cmp.show();
	                    } else {
	                        cmp.hide();
	                    }
	                }
	            });
	        },
	        subscribed: [],
	        subscribe: function subscribe(fn) {
	            this.subscribed.push(fn);
	        },
	        renew: function renew(html) {
	            this.update(html);
	            this.subscribed.forEach(function (fn) {
	                fn();
	            });
	        },
	        setScroll: function setScroll(fn) {
	            this.onScroll = fn;
	        },
	        removeScroll: function removeScroll() {
	            this.onScroll = Function.prototype;
	        },
	        setOnResize: function setOnResize(fn) {
	            this.onResize = fn;
	        },
	        removeOnResize: function removeOnResize() {
	            this.onResize = Function.prototype;;
	        },
	        setSidePanelsUIState: function setSidePanelsUIState(favoriteId, interpretationId) {
	            // If there is an interpretation loaded, collapse left panel and expand right panel
	            if (interpretationId) {
	                Ext.getCmp('toggleEastRegionButton').handler();
	                Ext.getCmp('toggleWestRegionButton').handler();
	
	                if (favoriteId && interpretationId == "new") {
	                    eastRegion.openInterpretationWindow(favoriteId);
	                }
	            }
	        },
	        scrollTo: function scrollTo(x, y) {
	            this.body.dom.scrollTo(x, y);
	        },
	        toggleEastRegion: function toggleEastRegion() {
	            detailsButton.setIconState();
	        },
	        onScroll: Function.prototype,
	        tbar: {
	            defaults: {
	                height: 26
	            },
	            items: [{
	                id: "toggleWestRegionButton",
	                text: ' ',
	                width: 26,
	                padding: '3',
	                iconCls: 'ns-button-icon-arrowlefttriple',
	                iconClsLeft: 'ns-button-icon-arrowlefttriple',
	                iconClsRight: 'ns-button-icon-arrowrighttriple',
	                iconState: 0,
	                setIconState: function setIconState() {
	                    this.setIconCls(this.iconState++ % 2 ? this.iconClsLeft : this.iconClsRight);
	                },
	                handler: function handler(b) {
	                    westRegion.toggleCollapse();
	                    this.setIconState();
	                }
	            }, ' ', updateButton, favoriteButton, {
	                xtype: 'tbseparator',
	                height: 24,
	                style: 'border-color:transparent; border-right-color:#d1d1d1; margin-right:4px'
	            }, layoutButton, optionsButton, {
	                xtype: 'tbseparator',
	                height: 24,
	                style: 'border-color:transparent; border-right-color:#d1d1d1; margin-right:4px'
	            }, downloadButton, embedButton, '->'].concat(_toConsumableArray(integrationButtons), [detailsButton])
	        },
	        bbar: statusBar,
	        listeners: {
	            render: function render(p) {
	                p.body.on('scroll', function (e) {
	                    this.onScroll(e);
	                }, p);
	            },
	            resize: {
	                fn: function fn(e) {
	                    this.onResize(e);
	                }
	            }
	        }
	    });
	    uiManager.reg(centerRegion, 'centerRegion');
	
	    var setUiState = function setUiState(layout) {
	        westRegion.setUiState(layout);
	    };
	
	    var getUiState = function getUiState() {
	        var viewport = uiManager.get('viewport'),
	            accordion = uiManager.get('accordion');
	
	        var layoutWindow = viewport.getLayoutWindow(),
	            optionsWindow = viewport.getOptionsWindow(),
	            chartType = getChartType(),
	            dataType = getDataType();
	
	        var config = _extends({}, accordion.getUiState(layoutWindow, optionsWindow), optionsWindow.getOptions());
	
	        if (chartType) {
	            config.type = chartType;
	        }
	
	        if (dataType) {
	            config.dataType = dataType;
	        }
	
	        return config;
	    };
	
	    var viewport = Ext.create('Ext.container.Viewport', _extends({
	        layout: 'border',
	        getUiState: getUiState,
	        setUiState: setUiState,
	        westRegion: westRegion,
	        eastRegion: eastRegion,
	        centerRegion: centerRegion,
	        northRegion: northRegion,
	        items: (0, _arrayClean2.default)([eastRegion, westRegion, centerRegion, northRegion]),
	        getLayoutWindow: null,
	        getOptionsWindow: null
	    }, config, {
	        listeners: {
	            afterrender: function afterrender() {
	
	                // west resize
	                westRegion.on('resize', function () {
	                    var panel = westRegionItems.getExpandedPanel();
	
	                    if (panel) {
	                        panel.onExpand();
	                    }
	                });
	
	                // update cmp resize
	                uiManager.getUpdateComponent().on('resize', function (cmp, width, height, eOpts) {
	                    uiManager.resize({
	                        cmp: cmp,
	                        width: width,
	                        height: height,
	                        eOpts: eOpts
	                    });
	                });
	
	                uiManager.onResize(function (cmp, width) {
	                    if (width < 700 && cmp.fullSize) {
	                        cmp.toggleCmp();
	                        cmp.fullSize = false;
	                    } else if (width >= 700 && !cmp.fullSize) {
	                        cmp.toggleCmp(true);
	                        cmp.fullSize = true;
	                    }
	                });
	
	                // left gui
	                var viewportHeight = uiManager.getHeight(),
	                    numberOfTabs = appManager.dimensions.length + 3,
	                    tabHeight = 28,
	                    minPeriodHeight = 380;
	
	                if (viewportHeight > numberOfTabs * tabHeight + minPeriodHeight) {
	                    if (!_isIE2.default) {
	                        accordion.setAutoScroll(false);
	                        //westRegion.setWidth(uiConfig.west_width + 100);
	                        accordion.doLayout();
	                    }
	                } else {
	                    westRegion.onScrollbar();
	                }
	
	                // north
	                if (northRegion) {
	                    northRegion.setLogoWidth(centerRegion.getPosition()[0]);
	                }
	
	                // expand to make sure treepanel is rendered
	                uiManager.get('organisationUnit').expand();
	                uiManager.get('data').expand();
	
	                // look for url params
	                var id = appManager.getUrlParam('id'),
	                    session = appManager.getUrlParam('s'),
	                    interpretationId = appManager.getUrlParam('interpretationid'),
	                    layout;
	
	                if (id) {
	                    if (interpretationId && interpretationId != "new") {
	                        instanceManager.getById(id, function (layout) {
	                            instanceManager.getInterpretationById(interpretationId, function (interpretation) {
	                                uiManager.updateInterpretation(interpretation, layout);
	                            });
	                        });
	                    } else {
	                        instanceManager.getById(id);
	                    }
	                } else if ((0, _isString2.default)(session) && sessionStorageManager.get(session)) {
	                    layout = new api.Layout(refs, sessionStorageManager.get(session)).val();
	
	                    if (layout) {
	                        instanceManager.getReport(layout, false, false, true);
	                    }
	                } else {
	                    uiManager.update();
	                }
	
	                var initEl = document.getElementById('init');
	                initEl.parentNode.removeChild(initEl);
	
	                Ext.getBody().setStyle('background', '#fff');
	                Ext.getBody().setStyle('opacity', 0);
	
	                centerRegion.setSidePanelsUIState(id, interpretationId);
	
	                // fade in
	                Ext.defer(function () {
	                    Ext.getBody().fadeIn({
	                        duration: 600
	                    });
	                }, 300);
	            }
	        }
	    }));
	
	    return viewport;
	};
	//# sourceMappingURL=Viewport.js.map

/***/ },
/* 170 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.WestRegionAggregateItems = undefined;
	
	var _clone = __webpack_require__(29);
	
	var _clone2 = _interopRequireDefault(_clone);
	
	var _arrayClean = __webpack_require__(9);
	
	var _arrayClean2 = _interopRequireDefault(_arrayClean);
	
	var _arrayContains = __webpack_require__(4);
	
	var _arrayContains2 = _interopRequireDefault(_arrayContains);
	
	var _arrayFrom = __webpack_require__(5);
	
	var _arrayFrom2 = _interopRequireDefault(_arrayFrom);
	
	var _arraySort = __webpack_require__(10);
	
	var _arraySort2 = _interopRequireDefault(_arraySort);
	
	var _isArray = __webpack_require__(1);
	
	var _isArray2 = _interopRequireDefault(_isArray);
	
	var _isBoolean = __webpack_require__(15);
	
	var _isBoolean2 = _interopRequireDefault(_isBoolean);
	
	var _isNumber = __webpack_require__(7);
	
	var _isNumber2 = _interopRequireDefault(_isNumber);
	
	var _isObject = __webpack_require__(2);
	
	var _isObject2 = _interopRequireDefault(_isObject);
	
	var _isString = __webpack_require__(3);
	
	var _isString2 = _interopRequireDefault(_isString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var WestRegionAggregateItems = exports.WestRegionAggregateItems = undefined;
	
	exports.WestRegionAggregateItems = WestRegionAggregateItems = function WestRegionAggregateItems(c) {
	    var _Ext$create;
	
	    var t = this,
	        uiManager = c.uiManager,
	        instanceManager = c.instanceManager,
	        appManager = c.appManager,
	        i18nManager = c.i18nManager,
	        sessionStorageManager = refs.sessionStorageManager,
	        calendarManager = refs.calendarManager,
	        dimensionConfig = refs.dimensionConfig,
	        periodConfig = refs.periodConfig,
	        uiConfig = refs.uiConfig,
	        optionConfig = refs.optionConfig,
	        api = refs.api;
	
	    var dataObjectName = dimensionConfig.get('data').objectName,
	        indicatorObjectName = dimensionConfig.get('indicator').objectName,
	        dataElementObjectName = dimensionConfig.get('dataElement').objectName,
	        operandObjectName = dimensionConfig.get('operand').objectName,
	        dataSetObjectName = dimensionConfig.get('dataSet').objectName,
	        eventDataItemObjectName = dimensionConfig.get('eventDataItem').objectName,
	        programIndicatorObjectName = dimensionConfig.get('programIndicator').objectName,
	        periodObjectName = dimensionConfig.get('period').objectName,
	        organisationUnitObjectName = dimensionConfig.get('organisationUnit').objectName,
	        i18n = i18nManager.get(),
	        path = appManager.getPath(),
	        apiPath = appManager.getApiPath(),
	        displayProperty = appManager.getDisplayProperty(),
	        displayPropertyUrl = appManager.getDisplayPropertyUrl(),
	        dimensionPanelMap = {},
	        accordionPanels = [],
	        periodCheckboxes = [],
	        baseWidth = uiConfig.west_fieldset_width - uiConfig.west_width_padding,
	        accBaseWidth = baseWidth;
	
	    // stores
	
	    var indicatorAvailableStore = Ext.create('Ext.data.Store', {
	        fields: ['id', 'name'],
	        lastPage: null,
	        nextPage: 1,
	        isPending: false,
	        reset: function reset() {
	            this.removeAll();
	            this.lastPage = null;
	            this.nextPage = 1;
	            this.isPending = false;
	            indicatorSearch.hideFilter();
	        },
	        loadDataAndUpdate: function loadDataAndUpdate(data, append) {
	            this.clearFilter(); // work around
	
	            if (!append) {
	                this.removeAll();
	            }
	
	            this.loadData(data, append);
	
	            this.updateFilter();
	        },
	        getRecordsByIds: function getRecordsByIds(ids) {
	            var records = [];
	
	            ids = (0, _arrayFrom2.default)(ids);
	
	            for (var i = 0, index; i < ids.length; i++) {
	                index = this.findExact('id', ids[i]);
	
	                if (index !== -1) {
	                    records.push(this.getAt(index));
	                }
	            }
	
	            return records;
	        },
	        updateFilter: function updateFilter() {
	            var selectedStoreIds = dataSelectedStore.getIds();
	
	            this.clearFilter();
	
	            this.filterBy(function (record) {
	                return !(0, _arrayContains2.default)(selectedStoreIds, record.data.id);
	            });
	        },
	        loadPage: function loadPage(uid, filter, append, noPaging, fn) {
	            var store = this,
	                params = {},
	                baseUrl = apiPath + '/indicators.json?',
	                fieldsUrl = 'fields=dimensionItem~rename(id),' + displayPropertyUrl,
	                filterUrl = filter ? '&filter=' + displayProperty + ':ilike:' + filter : '';
	
	            var url = baseUrl + fieldsUrl + filterUrl;
	
	            uid = (0, _isString2.default)(uid) || (0, _isNumber2.default)(uid) ? uid : indicatorGroup.getValue();
	            filter = filter || indicatorFilter.getValue() || null;
	
	            if (!append) {
	                this.lastPage = null;
	                this.nextPage = 1;
	            }
	
	            if (store.nextPage === store.lastPage) {
	                return;
	            }
	
	            if ((0, _isString2.default)(uid)) {
	                url += '&filter=indicatorGroups.id:eq:' + uid;
	            }
	
	            if (noPaging) {
	                params.paging = false;
	            } else {
	                params.page = store.nextPage;
	                params.pageSize = 50;
	            }
	
	            store.isPending = true;
	            uiManager.mask(indicatorAvailable.boundList);
	
	            $.getJSON(encodeURI(url), params, function (response) {
	                var data = response.indicators || [],
	                    pager = response.pager;
	
	                store.loadStore(data, pager, append, fn);
	            }).complete(function () {
	                store.isPending = false;
	                uiManager.unmask(indicatorAvailable.boundList);
	            });
	        },
	        loadStore: function loadStore(data, pager, append, fn) {
	            pager = pager || {};
	
	            this.loadDataAndUpdate(data, append);
	            this.sortStore();
	
	            this.lastPage = this.nextPage;
	
	            if (pager.pageCount > this.nextPage) {
	                this.nextPage++;
	            }
	
	            this.isPending = false;
	
	            //uiManager.msFilterAvailable({store: this}, {store: indicatorSelectedStore});
	
	            if (fn) {
	                fn();
	            }
	        },
	        storage: {},
	        parent: null,
	        sortStore: function sortStore() {
	            this.sort('name', 'ASC');
	        }
	    });
	
	    var indicatorGroupStore = Ext.create('Ext.data.Store', {
	        fields: ['id', 'name', 'index'],
	        proxy: {
	            type: 'ajax',
	            url: encodeURI(apiPath + '/indicatorGroups.json?fields=id,displayName~rename(name)&paging=false'),
	            reader: {
	                type: 'json',
	                root: 'indicatorGroups'
	            },
	            pageParam: false,
	            startParam: false,
	            limitParam: false
	        },
	        listeners: {
	            load: function load(s) {
	                s.add({
	                    id: 0,
	                    name: '[ ' + i18n['all_indicators'] + ' ]',
	                    index: -1
	                });
	                s.sort([{
	                    property: 'index',
	                    direction: 'ASC'
	                }, {
	                    property: 'name',
	                    direction: 'ASC'
	                }]);
	            }
	        }
	    });
	
	    var dataElementAvailableStore = Ext.create('Ext.data.Store', {
	        fields: ['id', 'name'],
	        lastPage: null,
	        nextPage: 1,
	        isPending: false,
	        reset: function reset() {
	            this.removeAll();
	            this.lastPage = null;
	            this.nextPage = 1;
	            this.isPending = false;
	            dataElementSearch.hideFilter();
	        },
	        loadDataAndUpdate: function loadDataAndUpdate(data, append) {
	            this.clearFilter(); // work around
	
	            if (!append) {
	                this.removeAll();
	            }
	
	            this.loadData(data, append);
	
	            this.updateFilter();
	        },
	        getRecordsByIds: function getRecordsByIds(ids) {
	            var records = [];
	
	            ids = (0, _arrayFrom2.default)(ids);
	
	            for (var i = 0, index; i < ids.length; i++) {
	                index = this.findExact('id', ids[i]);
	
	                if (index !== -1) {
	                    records.push(this.getAt(index));
	                }
	            }
	
	            return records;
	        },
	        updateFilter: function updateFilter() {
	            var selectedStoreIds = dataSelectedStore.getIds();
	
	            this.clearFilter();
	
	            if (selectedStoreIds.length) {
	                this.filterBy(function (record) {
	                    return !(0, _arrayContains2.default)(selectedStoreIds, record.data.id);
	                });
	            }
	        },
	        loadPage: function loadPage(uid, filter, append, noPaging, fn) {
	            uid = (0, _isString2.default)(uid) || (0, _isNumber2.default)(uid) ? uid : dataElementGroup.getValue();
	            filter = filter || dataElementFilter.getValue() || null;
	
	            if (!append) {
	                this.lastPage = null;
	                this.nextPage = 1;
	            }
	
	            if (dataElementDetailLevel.getValue() === dataElementObjectName) {
	                this.loadTotalsPage(uid, filter, append, noPaging, fn);
	            } else if (dataElementDetailLevel.getValue() === operandObjectName) {
	                this.loadDetailsPage(uid, filter, append, noPaging, fn);
	            }
	        },
	        loadTotalsPage: function loadTotalsPage(uid, filter, append, noPaging, fn) {
	            var store = this,
	                params = {},
	                baseUrl = apiPath + '/dataElements.json?',
	                fieldsUrl = 'fields=dimensionItem~rename(id),' + displayPropertyUrl,
	                filterUrl = '&filter=domainType:eq:AGGREGATE' + (filter ? '&filter=' + displayProperty + ':ilike:' + filter : '');
	
	            var url = baseUrl + fieldsUrl + filterUrl;
	
	            if (store.nextPage === store.lastPage) {
	                return;
	            }
	
	            if ((0, _isString2.default)(uid)) {
	                url += '&filter=dataElementGroups.id:eq:' + uid;
	            }
	
	            if (noPaging) {
	                params.paging = false;
	            } else {
	                params.page = store.nextPage;
	                params.pageSize = 50;
	            }
	
	            store.isPending = true;
	            uiManager.mask(dataElementAvailable.boundList);
	
	            $.getJSON(encodeURI(url), params, function (response) {
	                var data = response.dataElements || [],
	                    pager = response.pager;
	
	                store.loadStore(data, pager, append, fn);
	            }).complete(function () {
	                store.isPending = false;
	                uiManager.unmask(dataElementAvailable.boundList);
	            });
	        },
	        loadDetailsPage: function loadDetailsPage(uid, filter, append, noPaging, fn) {
	            var store = this,
	                params = {},
	                baseUrl = apiPath + '/dataElementOperands.json?',
	                fieldsUrl = 'fields=dimensionItem~rename(id),' + displayPropertyUrl,
	                filterUrl = filter ? '&filter=' + displayProperty + ':ilike:' + filter : '';
	
	            var url = baseUrl + fieldsUrl + filterUrl;
	
	            if (store.nextPage === store.lastPage) {
	                return;
	            }
	
	            if ((0, _isString2.default)(uid)) {
	                url += '&filter=dataElement.dataElementGroups.id:eq:' + uid;
	            }
	
	            if (noPaging) {
	                params.paging = false;
	            } else {
	                params.page = store.nextPage;
	                params.pageSize = 50;
	            }
	
	            store.isPending = true;
	            uiManager.mask(dataElementAvailable.boundList);
	
	            $.getJSON(encodeURI(url), params, function (response) {
	                var data = response.objects || response.dataElementOperands || [],
	                    pager = response.pager;
	
	                store.loadStore(data, pager, append, fn);
	            }).complete(function () {
	                store.isPending = false;
	                uiManager.unmask(dataElementAvailable.boundList);
	            });
	        },
	        loadStore: function loadStore(data, pager, append, fn) {
	            pager = pager || {};
	
	            this.loadDataAndUpdate(data, append);
	            this.sortStore();
	
	            this.lastPage = this.nextPage;
	
	            if (pager.pageCount > this.nextPage) {
	                this.nextPage++;
	            }
	
	            this.isPending = false;
	
	            //uiManager.msFilterAvailable({store: dataElementAvailableStore}, {store: dataElementSelectedStore});
	
	            if (fn) {
	                fn();
	            }
	        },
	        sortStore: function sortStore() {
	            this.sort('name', 'ASC');
	        }
	    });
	
	    var dataElementGroupStore = Ext.create('Ext.data.Store', {
	        fields: ['id', 'name', 'index'],
	        proxy: {
	            type: 'ajax',
	            url: encodeURI(apiPath + '/dataElementGroups.json?fields=id,' + displayPropertyUrl + '&paging=false'),
	            reader: {
	                type: 'json',
	                root: 'dataElementGroups'
	            },
	            pageParam: false,
	            startParam: false,
	            limitParam: false
	        },
	        listeners: {
	            load: function load(s) {
	                s.add({
	                    id: 0,
	                    name: '[ ' + i18n['all_data_elements'] + ' ]',
	                    index: -1
	                });
	
	                s.sort([{ property: 'index', direction: 'ASC' }, { property: 'name', direction: 'ASC' }]);
	            }
	        }
	    });
	
	    var dataSetAvailableStore = Ext.create('Ext.data.Store', {
	        fields: ['id', 'name'],
	        lastPage: null,
	        nextPage: 1,
	        isPending: false,
	        reset: function reset() {
	            this.removeAll();
	            this.lastPage = null;
	            this.nextPage = 1;
	            this.isPending = false;
	            dataSetSearch.hideFilter();
	        },
	        loadDataAndUpdate: function loadDataAndUpdate(data, append) {
	            this.clearFilter(); // work around
	            this.loadData(data, append);
	            this.updateFilter();
	        },
	        getRecordsByIds: function getRecordsByIds(ids) {
	            var records = [];
	
	            ids = (0, _arrayFrom2.default)(ids);
	
	            for (var i = 0, index; i < ids.length; i++) {
	                index = this.findExact('id', ids[i]);
	
	                if (index !== -1) {
	                    records.push(this.getAt(index));
	                }
	            }
	
	            return records;
	        },
	        updateFilter: function updateFilter() {
	            var selectedStoreIds = dataSelectedStore.getIds();
	            this.clearFilter();
	
	            var metric = dataSetMetric.getValue();
	
	            this.filterBy(function (record) {
	                return !(0, _arrayContains2.default)(selectedStoreIds, record.data.id) && (metric ? record.data.id.split('.')[1] === metric : true);
	            });
	        },
	        loadPage: function loadPage(filter, append, noPaging, fn) {
	            var store = this,
	                params = {},
	                baseUrl = apiPath + '/dataSets.json?',
	                fieldsUrl = 'fields=dimensionItem~rename(id),' + displayPropertyUrl,
	                filterUrl = filter ? '&filter=' + displayProperty + ':ilike:' + filter : '';
	
	            var url = baseUrl + fieldsUrl + filterUrl;
	
	            filter = filter || dataSetFilter.getValue() || null;
	
	            if (!append) {
	                this.lastPage = null;
	                this.nextPage = 1;
	            }
	
	            if (store.nextPage === store.lastPage) {
	                return;
	            }
	
	            if (noPaging) {
	                params.paging = false;
	            } else {
	                params.page = store.nextPage;
	                params.pageSize = 50;
	            }
	
	            store.isPending = true;
	            uiManager.mask(dataSetAvailable.boundList);
	
	            $.getJSON(encodeURI(url), params, function (response) {
	                var data = response.dataSets || [],
	                    pager = response.pager;
	
	                store.loadStore(data, pager, append, fn);
	            }).complete(function () {
	                store.isPending = false;
	                uiManager.unmask(dataSetAvailable.boundList);
	            });
	        },
	        getProcessedData: function getProcessedData(data) {
	            var metricRecords = optionConfig.getDataSetMetricRecords(),
	                processedData = [];
	
	            data.forEach(function (item) {
	                metricRecords.forEach(function (record) {
	                    processedData.push({
	                        id: item.id + '.' + record.id,
	                        name: item.name + ' (' + record.name + ')'
	                    });
	                });
	            });
	
	            return processedData;
	        },
	        loadStore: function loadStore(data, pager, append, fn) {
	            pager = pager || {};
	
	            data = this.getProcessedData(data);
	
	            this.loadDataAndUpdate(data, append);
	
	            this.sortStore();
	
	            this.lastPage = this.nextPage;
	
	            if (pager.pageCount > this.nextPage) {
	                this.nextPage++;
	            }
	
	            this.isPending = false;
	
	            //uiManager.msFilterAvailable({store: dataSetAvailableStore}, {store: dataSetSelectedStore});
	
	            if (fn) {
	                fn();
	            }
	        },
	        storage: {},
	        parent: null,
	        isLoaded: false,
	        sortStore: function sortStore() {
	            this.sort('name', 'ASC');
	        }
	    });
	
	    var eventDataItemAvailableStore = Ext.create('Ext.data.Store', {
	        fields: ['id', 'name'],
	        data: [],
	        sortStore: function sortStore() {
	            this.sort('name', 'ASC');
	        },
	        loadDataAndUpdate: function loadDataAndUpdate(data, append) {
	            this.clearFilter(); // work around
	
	            if (!append) {
	                this.removeAll();
	            }
	
	            this.loadData(data, append);
	
	            this.updateFilter();
	        },
	        getRecordsByIds: function getRecordsByIds(ids) {
	            var records = [];
	
	            ids = (0, _arrayFrom2.default)(ids);
	
	            for (var i = 0, index; i < ids.length; i++) {
	                index = this.findExact('id', ids[i]);
	
	                if (index !== -1) {
	                    records.push(this.getAt(index));
	                }
	            }
	
	            return records;
	        },
	        updateFilter: function updateFilter() {
	            var selectedStoreIds = dataSelectedStore.getIds();
	
	            this.clearFilter();
	
	            this.filterBy(function (record) {
	                return !(0, _arrayContains2.default)(selectedStoreIds, record.data.id);
	            });
	        }
	    });
	
	    var programIndicatorAvailableStore = Ext.create('Ext.data.Store', {
	        fields: ['id', 'name'],
	        data: [],
	        sortStore: function sortStore() {
	            this.sort('name', 'ASC');
	        },
	        loadDataAndUpdate: function loadDataAndUpdate(data, append) {
	            this.clearFilter(); // work around
	
	            if (!append) {
	                this.removeAll();
	            }
	
	            this.loadData(data, append);
	
	            this.updateFilter();
	        },
	        getRecordsByIds: function getRecordsByIds(ids) {
	            var records = [];
	
	            ids = (0, _arrayFrom2.default)(ids);
	
	            for (var i = 0, index; i < ids.length; i++) {
	                index = this.findExact('id', ids[i]);
	
	                if (index !== -1) {
	                    records.push(this.getAt(index));
	                }
	            }
	
	            return records;
	        },
	        updateFilter: function updateFilter() {
	            var selectedStoreIds = dataSelectedStore.getIds();
	
	            this.clearFilter();
	
	            this.filterBy(function (record) {
	                return !(0, _arrayContains2.default)(selectedStoreIds, record.data.id);
	            });
	        }
	    });
	
	    var programStore = Ext.create('Ext.data.Store', {
	        fields: ['id', 'name'],
	        proxy: {
	            type: 'ajax',
	            url: encodeURI(apiPath + '/programs.json?fields=id,displayName~rename(name)&paging=false'),
	            reader: {
	                type: 'json',
	                root: 'programs'
	            },
	            pageParam: false,
	            startParam: false,
	            limitParam: false
	        }
	    });
	
	    var dataSelectedStore = Ext.create('Ext.data.Store', {
	        fields: ['id', 'name'],
	        data: [],
	        getIds: function getIds() {
	            var records = this.getRange(),
	                ids = [];
	
	            for (var i = 0; i < records.length; i++) {
	                ids.push(records[i].data.id);
	            }
	
	            return ids;
	        },
	        addRecords: function addRecords(records, objectName) {
	            var prop = 'objectName',
	                recordsToAdd = [],
	                objectsToAdd = [];
	
	            records = (0, _arrayFrom2.default)(records);
	
	            if (records.length) {
	                for (var i = 0, record; i < records.length; i++) {
	                    record = records[i];
	
	                    // record
	                    if (record.data) {
	                        if (objectName) {
	                            record.set(prop, objectName);
	                        }
	                        recordsToAdd.push(record);
	                    }
	                    // object
	                    else {
	                            if (objectName) {
	                                record[prop] = objectName;
	                            }
	                            objectsToAdd.push(record);
	                        }
	                }
	
	                if (recordsToAdd.length) {
	                    this.add(recordsToAdd);
	                }
	
	                if (objectsToAdd.length) {
	                    this.loadData(objectsToAdd, true);
	                }
	            }
	        },
	        removeByIds: function removeByIds(ids) {
	            ids = (0, _arrayFrom2.default)(ids);
	
	            for (var i = 0, index; i < ids.length; i++) {
	                index = this.findExact('id', ids[i]);
	
	                if (index !== -1) {
	                    this.removeAt(index);
	                }
	            }
	        },
	        removeByProperty: function removeByProperty(property, values) {
	            if (!(property && values)) {
	                return;
	            }
	
	            var recordsToRemove = [];
	
	            values = (0, _arrayFrom2.default)(values);
	
	            this.each(function (record) {
	                if ((0, _arrayContains2.default)(values, record.data[property])) {
	                    recordsToRemove.push(record);
	                }
	            });
	
	            this.remove(recordsToRemove);
	        },
	        listeners: {
	            add: function add() {
	                data.updateStoreFilters();
	            },
	            remove: function remove() {
	                data.updateStoreFilters();
	            },
	            clear: function clear() {
	                data.updateStoreFilters();
	            }
	        }
	    });
	
	    var periodTypeStore = Ext.create('Ext.data.Store', {
	        fields: ['id', 'name'],
	        data: periodConfig.getPeriodTypeRecords()
	    });
	
	    var fixedPeriodAvailableStore = Ext.create('Ext.data.Store', {
	        fields: ['id', 'name', 'index'],
	        data: [],
	        setIndex: function setIndex(periods) {
	            for (var i = 0; i < periods.length; i++) {
	                periods[i].index = i;
	            }
	        },
	        sortStore: function sortStore() {
	            this.sort('index', 'ASC');
	        }
	    });
	
	    var fixedPeriodSelectedStore = Ext.create('Ext.data.Store', {
	        fields: ['id', 'name'],
	        data: []
	    });
	
	    var organisationUnitLevelStore = Ext.create('Ext.data.Store', {
	        fields: ['id', 'name', 'level'],
	        data: appManager.organisationUnitLevels,
	        sorters: [{
	            property: 'level',
	            direction: 'ASC'
	        }]
	    });
	
	    var organisationUnitGroupStore = Ext.create('Ext.data.Store', {
	        fields: ['id', 'name'],
	        proxy: {
	            type: 'ajax',
	            url: encodeURI(apiPath + '/organisationUnitGroups.json?fields=id,' + displayPropertyUrl + '&paging=false'),
	            reader: {
	                type: 'json',
	                root: 'organisationUnitGroups'
	            },
	            pageParam: false,
	            startParam: false,
	            limitParam: false
	        }
	    });
	
	    var legendSetStore = Ext.create('Ext.data.Store', {
	        fields: ['id', 'name', 'index'],
	        data: function () {
	            var data = appManager.legendSets;
	            data.unshift({ id: 0, name: i18n['none'], index: -1 });
	            return data;
	        }(),
	        sorters: [{ property: 'index', direction: 'ASC' }, { property: 'name', direction: 'ASC' }]
	    });
	
	    // data
	
	    var onDataTypeSelect = function onDataTypeSelect(type) {
	        type = type || 'in';
	
	        if (type === 'in') {
	            indicator.show();
	            dataElement.hide();
	            dataSet.hide();
	            eventDataItem.hide();
	            programIndicator.hide();
	        } else if (type === 'de') {
	            indicator.hide();
	            dataElement.show();
	            dataSet.hide();
	            eventDataItem.hide();
	            programIndicator.hide();
	        } else if (type === 'ds') {
	            indicator.hide();
	            dataElement.hide();
	            dataSet.show();
	            eventDataItem.hide();
	            programIndicator.hide();
	
	            if (!dataSetAvailableStore.isLoaded) {
	                dataSetAvailableStore.isLoaded = true;
	                dataSetAvailableStore.loadPage();
	            }
	        } else if (type === 'di') {
	            indicator.hide();
	            dataElement.hide();
	            dataSet.hide();
	            eventDataItem.show();
	            programIndicator.hide();
	
	            if (!programStore.isLoaded) {
	                programStore.isLoaded = true;
	                programStore.load();
	            }
	        } else if (type === 'pi') {
	            indicator.hide();
	            dataElement.hide();
	            dataSet.hide();
	            eventDataItem.hide();
	            programIndicator.show();
	
	            if (!programStore.isLoaded) {
	                programStore.isLoaded = true;
	                programStore.load();
	            }
	        }
	    };
	
	    var dataType = Ext.create('Ext.form.field.ComboBox', {
	        cls: 'ns-combo',
	        style: 'margin-bottom:1px',
	        width: accBaseWidth,
	        valueField: 'id',
	        displayField: 'name',
	        //emptyText: i18n.data_type,
	        editable: false,
	        queryMode: 'local',
	        value: 'in',
	        store: {
	            fields: ['id', 'name'],
	            data: [{ id: 'in', name: i18n['indicators'] }, { id: 'de', name: i18n['data_elements'] }, { id: 'ds', name: i18n['data_sets'] }, { id: 'di', name: i18n['event_data_items'] }, { id: 'pi', name: i18n['program_indicators'] }]
	        },
	        listeners: {
	            select: function select(cb) {
	                onDataTypeSelect(cb.getValue());
	            }
	        }
	    });
	
	    // indicator
	    var indicatorLabel = Ext.create('Ext.form.Label', {
	        text: i18n['available'],
	        cls: 'ns-toolbar-multiselect-left-label',
	        style: 'margin-right:5px'
	    });
	
	    var indicatorSearch = Ext.create('Ext.button.Button', {
	        width: 22,
	        height: 22,
	        cls: 'ns-button-icon',
	        iconCls: 'ns-button-icon-search',
	        disabled: true,
	        showFilter: function showFilter() {
	            indicatorLabel.hide();
	            this.hide();
	            indicatorFilter.show();
	            indicatorFilter.reset();
	        },
	        hideFilter: function hideFilter() {
	            indicatorLabel.show();
	            this.show();
	            indicatorFilter.hide();
	            indicatorFilter.reset();
	        },
	        handler: function handler() {
	            this.showFilter();
	        }
	    });
	
	    var indicatorFilter = Ext.create('Ext.form.field.Trigger', {
	        cls: 'ns-trigger-filter',
	        emptyText: 'Filter available..',
	        height: 22,
	        hidden: true,
	        enableKeyEvents: true,
	        fieldStyle: 'height:22px; border-right:0 none',
	        style: 'height:22px',
	        onTriggerClick: function onTriggerClick() {
	            this.reset();
	            this.onKeyUpHandler();
	
	            indicatorSearch.hideFilter();
	        },
	        onKeyUpHandler: function onKeyUpHandler() {
	            var value = indicatorGroup.getValue(),
	                store = indicatorAvailableStore;
	
	            if ((0, _isString2.default)(value) || (0, _isNumber2.default)(value)) {
	                store.loadPage(null, this.getValue(), false);
	            }
	        },
	        listeners: {
	            keyup: {
	                fn: function fn(cmp) {
	                    cmp.onKeyUpHandler();
	                },
	                buffer: 100
	            },
	            show: function show(cmp) {
	                cmp.focus(false, 50);
	            },
	            focus: function focus(cmp) {
	                cmp.addCls('ns-trigger-filter-focused');
	            },
	            blur: function blur(cmp) {
	                cmp.removeCls('ns-trigger-filter-focused');
	            }
	        }
	    });
	
	    var indicatorGroup = Ext.create('Ext.form.field.ComboBox', {
	        cls: 'ns-combo',
	        style: 'margin-bottom:1px; margin-top:0px',
	        width: accBaseWidth,
	        valueField: 'id',
	        displayField: 'name',
	        emptyText: i18n['select_indicator_group'],
	        editable: false,
	        store: indicatorGroupStore,
	        loadAvailable: function loadAvailable(reset) {
	            var store = indicatorAvailableStore,
	                id = this.getValue();
	
	            if (id !== null) {
	                if (reset) {
	                    store.reset();
	                }
	
	                store.loadPage(id, null, false);
	            }
	        },
	        listeners: {
	            select: function select(cb) {
	                cb.loadAvailable(true);
	
	                indicatorSearch.enable();
	            }
	        }
	    });
	
	    var indicatorAvailable = Ext.create('Ext.ux.form.MultiSelect', {
	        cls: 'ns-toolbar-multiselect-left',
	        width: accBaseWidth / 2,
	        valueField: 'id',
	        displayField: 'name',
	        store: indicatorAvailableStore,
	        tbar: [indicatorLabel, indicatorSearch, indicatorFilter, '->', {
	            xtype: 'button',
	            iconCls: 'ns-button-icon-arrowright',
	            width: 22,
	            handler: function handler() {
	                if (indicatorAvailable.getValue().length) {
	                    var records = indicatorAvailableStore.getRecordsByIds(indicatorAvailable.getValue());
	                    dataSelectedStore.addRecords(records, 'in');
	                }
	            }
	        }, {
	            xtype: 'button',
	            iconCls: 'ns-button-icon-arrowrightdouble',
	            width: 22,
	            handler: function handler() {
	                indicatorAvailableStore.loadPage(null, null, null, true, function () {
	                    dataSelectedStore.addRecords(indicatorAvailableStore.getRange(), 'in');
	                });
	            }
	        }],
	        listeners: {
	            render: function render(ms) {
	                var el = Ext.get(ms.boundList.getEl().id + '-listEl').dom;
	
	                el.addEventListener('scroll', function (e) {
	                    if (uiManager.isScrolled(e) && !indicatorAvailableStore.isPending) {
	                        indicatorAvailableStore.loadPage(null, null, true);
	                    }
	                });
	
	                ms.boundList.on('itemdblclick', function (bl, record) {
	                    dataSelectedStore.addRecords(record, 'in');
	                }, ms);
	            }
	        }
	    });
	
	    var indicatorSelected = Ext.create('Ext.ux.form.MultiSelect', {
	        cls: 'ns-toolbar-multiselect-right',
	        width: accBaseWidth / 2,
	        valueField: 'id',
	        displayField: 'name',
	        ddReorder: true,
	        store: dataSelectedStore,
	        tbar: [{
	            xtype: 'button',
	            iconCls: 'ns-button-icon-arrowleftdouble',
	            width: 22,
	            handler: function handler() {
	                if (dataSelectedStore.getRange().length) {
	                    dataSelectedStore.removeAll();
	                }
	            }
	        }, {
	            xtype: 'button',
	            iconCls: 'ns-button-icon-arrowleft',
	            width: 22,
	            handler: function handler() {
	                if (indicatorSelected.getValue().length) {
	                    dataSelectedStore.removeByIds(indicatorSelected.getValue());
	                }
	            }
	        }, '->', {
	            xtype: 'label',
	            text: i18n['selected'],
	            cls: 'ns-toolbar-multiselect-right-label'
	        }],
	        listeners: {
	            afterrender: function afterrender() {
	                this.boundList.on('itemdblclick', function (bl, record) {
	                    dataSelectedStore.removeByIds(record.data.id);
	                }, this);
	            }
	        }
	    });
	
	    var indicator = Ext.create('Ext.panel.Panel', {
	        xtype: 'panel',
	        //title: '<div class="ns-panel-title-data">' + i18n.indicators + '</div>',
	        preventHeader: true,
	        hideCollapseTool: true,
	        dimension: indicatorObjectName,
	        bodyStyle: 'border:0 none',
	        items: [indicatorGroup, {
	            xtype: 'panel',
	            layout: 'column',
	            bodyStyle: 'border-style:none',
	            items: [indicatorAvailable, indicatorSelected]
	        }],
	        listeners: {
	            expand: function expand(p) {
	                //p.onExpand();
	            }
	        }
	    });
	
	    // data element
	    var dataElementLabel = Ext.create('Ext.form.Label', {
	        text: i18n['available'],
	        cls: 'ns-toolbar-multiselect-left-label',
	        style: 'margin-right:5px'
	    });
	
	    var dataElementSearch = Ext.create('Ext.button.Button', {
	        width: 22,
	        height: 22,
	        cls: 'ns-button-icon',
	        iconCls: 'ns-button-icon-search',
	        disabled: true,
	        showFilter: function showFilter() {
	            dataElementLabel.hide();
	            this.hide();
	            dataElementFilter.show();
	            dataElementFilter.reset();
	        },
	        hideFilter: function hideFilter() {
	            dataElementLabel.show();
	            this.show();
	            dataElementFilter.hide();
	            dataElementFilter.reset();
	        },
	        handler: function handler() {
	            this.showFilter();
	        }
	    });
	
	    var dataElementFilter = Ext.create('Ext.form.field.Trigger', {
	        cls: 'ns-trigger-filter',
	        emptyText: 'Filter available..',
	        height: 22,
	        hidden: true,
	        enableKeyEvents: true,
	        fieldStyle: 'height:22px; border-right:0 none',
	        style: 'height:22px',
	        onTriggerClick: function onTriggerClick() {
	            this.reset();
	            this.onKeyUpHandler();
	
	            dataElementSearch.hideFilter();
	        },
	        onKeyUpHandler: function onKeyUpHandler() {
	            var value = dataElementGroup.getValue(),
	                store = dataElementAvailableStore;
	
	            if ((0, _isString2.default)(value) || (0, _isNumber2.default)(value)) {
	                store.loadPage(null, this.getValue(), false);
	            }
	        },
	        listeners: {
	            keyup: {
	                fn: function fn(cmp) {
	                    cmp.onKeyUpHandler();
	                },
	                buffer: 100
	            },
	            show: function show(cmp) {
	                cmp.focus(false, 50);
	            },
	            focus: function focus(cmp) {
	                cmp.addCls('ns-trigger-filter-focused');
	            },
	            blur: function blur(cmp) {
	                cmp.removeCls('ns-trigger-filter-focused');
	            }
	        }
	    });
	
	    var dataElementAvailable = Ext.create('Ext.ux.form.MultiSelect', {
	        cls: 'ns-toolbar-multiselect-left',
	        width: accBaseWidth / 2,
	        valueField: 'id',
	        displayField: 'name',
	        isPending: false,
	        page: 1,
	        store: dataElementAvailableStore,
	        tbar: [dataElementLabel, dataElementSearch, dataElementFilter, '->', {
	            xtype: 'button',
	            iconCls: 'ns-button-icon-arrowright',
	            width: 22,
	            handler: function handler() {
	                if (dataElementAvailable.getValue().length) {
	                    var records = dataElementAvailableStore.getRecordsByIds(dataElementAvailable.getValue());
	                    dataSelectedStore.addRecords(records, 'de');
	                }
	            }
	        }, {
	            xtype: 'button',
	            iconCls: 'ns-button-icon-arrowrightdouble',
	            width: 22,
	            handler: function handler() {
	                dataElementAvailableStore.loadPage(null, null, null, true, function () {
	                    dataSelectedStore.addRecords(dataElementAvailableStore.getRange(), 'de');
	                });
	            }
	        }],
	        listeners: {
	            render: function render(ms) {
	                var el = Ext.get(ms.boundList.getEl().id + '-listEl').dom;
	
	                el.addEventListener('scroll', function (e) {
	                    if (uiManager.isScrolled(e) && !dataElementAvailableStore.isPending) {
	                        dataElementAvailableStore.loadPage(null, null, true);
	                    }
	                });
	
	                ms.boundList.on('itemdblclick', function (bl, record) {
	                    dataSelectedStore.addRecords(record, 'de');
	                }, ms);
	            }
	        }
	    });
	
	    var dataElementSelected = Ext.create('Ext.ux.form.MultiSelect', {
	        cls: 'ns-toolbar-multiselect-right',
	        width: accBaseWidth / 2,
	        valueField: 'id',
	        displayField: 'name',
	        ddReorder: true,
	        store: dataSelectedStore,
	        tbar: [{
	            xtype: 'button',
	            iconCls: 'ns-button-icon-arrowleftdouble',
	            width: 22,
	            handler: function handler() {
	                if (dataSelectedStore.getRange().length) {
	                    dataSelectedStore.removeAll();
	                }
	            }
	        }, {
	            xtype: 'button',
	            iconCls: 'ns-button-icon-arrowleft',
	            width: 22,
	            handler: function handler() {
	                if (dataElementSelected.getValue().length) {
	                    dataSelectedStore.removeByIds(dataElementSelected.getValue());
	                }
	            }
	        }, '->', {
	            xtype: 'label',
	            text: i18n['selected'],
	            cls: 'ns-toolbar-multiselect-right-label'
	        }],
	        listeners: {
	            afterrender: function afterrender() {
	                this.boundList.on('itemdblclick', function (bl, record) {
	                    dataSelectedStore.removeByIds(record.data.id);
	                }, this);
	            }
	        }
	    });
	
	    var dataElementGroup = Ext.create('Ext.form.field.ComboBox', {
	        cls: 'ns-combo',
	        style: 'margin:0 1px 1px 0',
	        width: accBaseWidth - 90,
	        valueField: 'id',
	        displayField: 'name',
	        emptyText: i18n['select_data_element_group'],
	        editable: false,
	        store: dataElementGroupStore,
	        loadAvailable: function loadAvailable(reset) {
	            var store = dataElementAvailableStore,
	                id = this.getValue();
	
	            if (id !== null) {
	                if (reset) {
	                    store.reset();
	                }
	
	                store.loadPage(id, null, false);
	            }
	        },
	        listeners: {
	            select: function select(cb) {
	                cb.loadAvailable(true);
	
	                dataElementSearch.enable();
	            }
	        }
	    });
	
	    var dataElementDetailLevel = Ext.create('Ext.form.field.ComboBox', {
	        cls: 'ns-combo',
	        style: 'margin-bottom:1px',
	        baseBodyCls: 'small',
	        queryMode: 'local',
	        editable: false,
	        valueField: 'id',
	        displayField: 'text',
	        width: 90 - 1,
	        value: dataElementObjectName,
	        store: {
	            fields: ['id', 'text'],
	            data: [{ id: dataElementObjectName, text: i18n['totals'] }, { id: operandObjectName, text: i18n['details'] }]
	        },
	        listeners: {
	            select: function select(cb) {
	                dataElementGroup.loadAvailable(true);
	            }
	        }
	    });
	
	    var dataElement = Ext.create('Ext.panel.Panel', {
	        xtype: 'panel',
	        preventHeader: true,
	        hidden: true,
	        hideCollapseTool: true,
	        bodyStyle: 'border:0 none',
	        dimension: dataElementObjectName,
	        items: [{
	            xtype: 'container',
	            layout: 'column',
	            items: [dataElementGroup, dataElementDetailLevel]
	        }, {
	            xtype: 'panel',
	            layout: 'column',
	            bodyStyle: 'border-style:none',
	            items: [dataElementAvailable, dataElementSelected]
	        }]
	    });
	
	    // data set
	    var dataSetLabel = Ext.create('Ext.form.Label', {
	        text: i18n['available'],
	        cls: 'ns-toolbar-multiselect-left-label',
	        style: 'margin-right:5px'
	    });
	
	    var dataSetSearch = Ext.create('Ext.button.Button', {
	        width: 22,
	        height: 22,
	        cls: 'ns-button-icon',
	        iconCls: 'ns-button-icon-search',
	        showFilter: function showFilter() {
	            dataSetLabel.hide();
	            this.hide();
	            dataSetFilter.show();
	            dataSetFilter.reset();
	        },
	        hideFilter: function hideFilter() {
	            dataSetLabel.show();
	            this.show();
	            dataSetFilter.hide();
	            dataSetFilter.reset();
	        },
	        handler: function handler() {
	            this.showFilter();
	        }
	    });
	
	    var dataSetFilter = Ext.create('Ext.form.field.Trigger', {
	        cls: 'ns-trigger-filter',
	        emptyText: 'Filter available..',
	        height: 22,
	        hidden: true,
	        enableKeyEvents: true,
	        fieldStyle: 'height:22px; border-right:0 none',
	        style: 'height:22px',
	        onTriggerClick: function onTriggerClick() {
	            this.reset();
	            this.onKeyUpHandler();
	
	            dataSetSearch.hideFilter();
	        },
	        onKeyUpHandler: function onKeyUpHandler() {
	            var store = dataSetAvailableStore;
	            store.loadPage(this.getValue(), false);
	        },
	        listeners: {
	            keyup: {
	                fn: function fn(cmp) {
	                    cmp.onKeyUpHandler();
	                },
	                buffer: 100
	            },
	            show: function show(cmp) {
	                cmp.focus(false, 50);
	            },
	            focus: function focus(cmp) {
	                cmp.addCls('ns-trigger-filter-focused');
	            },
	            blur: function blur(cmp) {
	                cmp.removeCls('ns-trigger-filter-focused');
	            }
	        }
	    });
	
	    var dataSetAvailable = Ext.create('Ext.ux.form.MultiSelect', {
	        cls: 'ns-toolbar-multiselect-left',
	        width: accBaseWidth / 2,
	        valueField: 'id',
	        displayField: 'name',
	        store: dataSetAvailableStore,
	        tbar: [dataSetLabel, dataSetSearch, dataSetFilter, '->', {
	            xtype: 'button',
	            iconCls: 'ns-button-icon-arrowright',
	            width: 22,
	            handler: function handler() {
	                if (dataSetAvailable.getValue().length) {
	                    var records = dataSetAvailableStore.getRecordsByIds(dataSetAvailable.getValue());
	                    dataSelectedStore.addRecords(records, 'ds');
	                }
	            }
	        }, {
	            xtype: 'button',
	            iconCls: 'ns-button-icon-arrowrightdouble',
	            width: 22,
	            handler: function handler() {
	                dataSetAvailableStore.loadPage(null, null, true, function () {
	                    dataSelectedStore.addRecords(dataSetAvailableStore.getRange(), 'ds');
	                });
	            }
	        }],
	        listeners: {
	            render: function render(ms) {
	                var el = Ext.get(ms.boundList.getEl().id + '-listEl').dom;
	
	                el.addEventListener('scroll', function (e) {
	                    if (uiManager.isScrolled(e) && !dataSetAvailableStore.isPending) {
	                        dataSetAvailableStore.loadPage(null, true);
	                    }
	                });
	
	                ms.boundList.on('itemdblclick', function (bl, record) {
	                    dataSelectedStore.addRecords(record, 'ds');
	                }, ms);
	            }
	        }
	    });
	
	    var dataSetSelected = Ext.create('Ext.ux.form.MultiSelect', {
	        cls: 'ns-toolbar-multiselect-right',
	        width: accBaseWidth / 2,
	        valueField: 'id',
	        displayField: 'name',
	        ddReorder: true,
	        store: dataSelectedStore,
	        tbar: [{
	            xtype: 'button',
	            iconCls: 'ns-button-icon-arrowleftdouble',
	            width: 22,
	            handler: function handler() {
	                if (dataSelectedStore.getRange().length) {
	                    dataSelectedStore.removeAll();
	                }
	            }
	        }, {
	            xtype: 'button',
	            iconCls: 'ns-button-icon-arrowleft',
	            width: 22,
	            handler: function handler() {
	                if (dataSetSelected.getValue().length) {
	                    dataSelectedStore.removeByIds(dataSetSelected.getValue());
	                }
	            }
	        }, '->', {
	            xtype: 'label',
	            text: i18n.selected,
	            cls: 'ns-toolbar-multiselect-right-label'
	        }],
	        listeners: {
	            afterrender: function afterrender() {
	                this.boundList.on('itemdblclick', function (bl, record) {
	                    dataSelectedStore.removeByIds(record.data.id);
	                }, this);
	            }
	        }
	    });
	
	    var dataSetMetric = Ext.create('Ext.form.field.ComboBox', {
	        cls: 'ns-combo',
	        style: 'margin-bottom:1px; margin-top:0px',
	        width: accBaseWidth,
	        valueField: 'id',
	        displayField: 'name',
	        emptyText: i18n['select_indicator_group'],
	        editable: false,
	        value: optionConfig.getDataSetMetric('reportingRates').id,
	        store: {
	            fields: ['id', 'name'],
	            data: [{ id: 0, name: '[ ' + i18n.all_metrics + ' ]' }].concat(optionConfig.getDataSetMetricRecords())
	        },
	        listeners: {
	            select: function select(cmp) {
	                dataSetAvailableStore.updateFilter();
	            }
	        }
	    });
	
	    var dataSet = Ext.create('Ext.panel.Panel', {
	        xtype: 'panel',
	        //title: '<div class="ns-panel-title-data">' + i18n.reporting_rates + '</div>',
	        preventHeader: true,
	        hidden: true,
	        hideCollapseTool: true,
	        bodyStyle: 'border:0 none',
	        dimension: dataSetObjectName,
	        items: [dataSetMetric, {
	            xtype: 'panel',
	            layout: 'column',
	            bodyStyle: 'border-style:none',
	            items: [dataSetAvailable, dataSetSelected]
	        }]
	    });
	
	    // event data item
	    var onEventDataItemProgramSelect = function onEventDataItemProgramSelect(programId, skipSync) {
	        if (!skipSync) {
	            //dataSelectedStore.removeByProperty('objectName', ['di','pi']);
	            programIndicatorProgram.setValue(programId);
	            onProgramIndicatorProgramSelect(programId, true);
	        }
	
	        Ext.Ajax.request({
	            url: encodeURI(apiPath + '/programDataElements.json?program=' + programId + '&fields=dimensionItem~rename(id),name,valueType&paging=false'),
	            disableCaching: false,
	            success: function success(r) {
	                var types = dimensionConfig.valueType['aggregate_aggregatable_types'],
	                    elements = Ext.decode(r.responseText).programDataElements.filter(function (item) {
	                    return (0, _arrayContains2.default)(types, (item || {}).valueType);
	                });
	
	                Ext.Ajax.request({
	                    url: encodeURI(apiPath + '/programs.json?filter=id:eq:' + programId + '&fields=programTrackedEntityAttributes[dimensionItem~rename(id),' + displayPropertyUrl + '~rename(name),valueType]&paging=false'),
	                    disableCaching: false,
	                    success: function success(r) {
	                        var attributes = ((Ext.decode(r.responseText).programs[0] || {}).programTrackedEntityAttributes || []).filter(function (item) {
	                            return (0, _arrayContains2.default)(types, (item || {}).valueType);
	                        }),
	                            data = (0, _arraySort2.default)((0, _arrayClean2.default)([].concat(elements, attributes))) || [];
	
	                        eventDataItemAvailableStore.loadDataAndUpdate(data);
	                    }
	                });
	            }
	        });
	    };
	
	    var eventDataItemProgram = Ext.create('Ext.form.field.ComboBox', {
	        cls: 'ns-combo',
	        style: 'margin:0 1px 1px 0',
	        width: accBaseWidth,
	        valueField: 'id',
	        displayField: 'name',
	        emptyText: i18n.select_program,
	        editable: false,
	        queryMode: 'local',
	        store: programStore,
	        listeners: {
	            select: function select(cb) {
	                onEventDataItemProgramSelect(cb.getValue());
	            }
	        }
	    });
	
	    var eventDataItemLabel = Ext.create('Ext.form.Label', {
	        text: i18n.available,
	        cls: 'ns-toolbar-multiselect-left-label',
	        style: 'margin-right:5px'
	    });
	
	    var eventDataItemSearch = Ext.create('Ext.button.Button', {
	        width: 22,
	        height: 22,
	        cls: 'ns-button-icon',
	        iconCls: 'ns-button-icon-search',
	        //disabled: true,
	        showFilter: function showFilter() {
	            eventDataItemLabel.hide();
	            this.hide();
	            eventDataItemFilter.show();
	            eventDataItemFilter.reset();
	        },
	        hideFilter: function hideFilter() {
	            eventDataItemLabel.show();
	            this.show();
	            eventDataItemFilter.hide();
	            eventDataItemFilter.reset();
	        },
	        handler: function handler() {
	            this.showFilter();
	        }
	    });
	
	    var eventDataItemFilter = Ext.create('Ext.form.field.Trigger', {
	        cls: 'ns-trigger-filter',
	        emptyText: 'Filter available..',
	        height: 22,
	        hidden: true,
	        enableKeyEvents: true,
	        fieldStyle: 'height:22px; border-right:0 none',
	        style: 'height:22px',
	        onTriggerClick: function onTriggerClick() {
	            this.reset();
	            this.onKeyUpHandler();
	
	            eventDataItemSearch.hideFilter();
	        },
	        onKeyUpHandler: function onKeyUpHandler() {
	            var value = this.getValue() || '',
	                store = eventDataItemAvailableStore,
	                str;
	
	            store.filterBy(function (record) {
	                str = record.data.name || '';
	
	                return str.toLowerCase().indexOf(value.toLowerCase()) !== -1;
	            });
	        },
	        listeners: {
	            keyup: {
	                fn: function fn(cmp) {
	                    cmp.onKeyUpHandler();
	                },
	                buffer: 100
	            },
	            show: function show(cmp) {
	                cmp.focus(false, 50);
	            },
	            focus: function focus(cmp) {
	                cmp.addCls('ns-trigger-filter-focused');
	            },
	            blur: function blur(cmp) {
	                cmp.removeCls('ns-trigger-filter-focused');
	            }
	        }
	    });
	
	    var eventDataItemAvailable = Ext.create('Ext.ux.form.MultiSelect', {
	        cls: 'ns-toolbar-multiselect-left',
	        width: accBaseWidth / 2,
	        valueField: 'id',
	        displayField: 'name',
	        store: eventDataItemAvailableStore,
	        tbar: [eventDataItemLabel, eventDataItemSearch, eventDataItemFilter, '->', {
	            xtype: 'button',
	            iconCls: 'ns-button-icon-arrowright',
	            width: 22,
	            handler: function handler() {
	                if (eventDataItemAvailable.getValue().length) {
	                    var records = eventDataItemAvailableStore.getRecordsByIds(eventDataItemAvailable.getValue());
	                    dataSelectedStore.addRecords(records, 'di');
	                }
	            }
	        }, {
	            xtype: 'button',
	            iconCls: 'ns-button-icon-arrowrightdouble',
	            width: 22,
	            handler: function handler() {
	                //eventDataItemAvailableStore.loadPage(null, null, null, true, function() {
	                dataSelectedStore.addRecords(eventDataItemAvailableStore.getRange(), 'di');
	                //});
	            }
	        }],
	        listeners: {
	            render: function render(ms) {
	                var el = Ext.get(ms.boundList.getEl().id + '-listEl').dom;
	
	                //el.addEventListener('scroll', function(e) {
	                //if (uiManager.isScrolled(e) && !eventDataItemAvailableStore.isPending) {
	                //eventDataItemAvailableStore.loadPage(null, null, true);
	                //}
	                //});
	
	                ms.boundList.on('itemdblclick', function (bl, record) {
	                    dataSelectedStore.addRecords(record, 'di');
	                }, ms);
	            }
	        }
	    });
	
	    var eventDataItemSelected = Ext.create('Ext.ux.form.MultiSelect', {
	        cls: 'ns-toolbar-multiselect-right',
	        width: accBaseWidth / 2,
	        valueField: 'id',
	        displayField: 'name',
	        ddReorder: true,
	        store: dataSelectedStore,
	        tbar: [{
	            xtype: 'button',
	            iconCls: 'ns-button-icon-arrowleftdouble',
	            width: 22,
	            handler: function handler() {
	                if (dataSelectedStore.getRange().length) {
	                    dataSelectedStore.removeAll();
	                }
	            }
	        }, {
	            xtype: 'button',
	            iconCls: 'ns-button-icon-arrowleft',
	            width: 22,
	            handler: function handler() {
	                if (eventDataItemSelected.getValue().length) {
	                    dataSelectedStore.removeByIds(eventDataItemSelected.getValue());
	                }
	            }
	        }, '->', {
	            xtype: 'label',
	            text: i18n.selected,
	            cls: 'ns-toolbar-multiselect-right-label'
	        }],
	        listeners: {
	            afterrender: function afterrender() {
	                this.boundList.on('itemdblclick', function (bl, record) {
	                    dataSelectedStore.removeByIds(record.data.id);
	                }, this);
	            }
	        }
	    });
	
	    var eventDataItem = Ext.create('Ext.panel.Panel', {
	        xtype: 'panel',
	        //title: '<div class="ns-panel-title-data">' + i18n.eventDataItems + '</div>',
	        preventHeader: true,
	        hidden: true,
	        hideCollapseTool: true,
	        dimension: eventDataItemObjectName,
	        bodyStyle: 'border:0 none',
	        items: [eventDataItemProgram, {
	            xtype: 'panel',
	            layout: 'column',
	            bodyStyle: 'border-style:none',
	            items: [eventDataItemAvailable, eventDataItemSelected]
	        }]
	    });
	
	    // program indicator
	    var onProgramIndicatorProgramSelect = function onProgramIndicatorProgramSelect(programId, skipSync) {
	        if (!skipSync) {
	            //dataSelectedStore.removeByProperty('objectName', ['di','pi']);
	            eventDataItemProgram.setValue(programId);
	            onEventDataItemProgramSelect(programId, true);
	        }
	
	        Ext.Ajax.request({
	            url: encodeURI(apiPath + '/programs.json?filter=id:eq:' + programId + '&fields=programIndicators[dimensionItem~rename(id),' + displayPropertyUrl + ']&paging=false'),
	            disableCaching: false,
	            success: function success(r) {
	                var indicators = (Ext.decode(r.responseText).programs[0] || {}).programIndicators || [],
	                    data = (0, _arraySort2.default)(indicators);
	
	                programIndicatorAvailableStore.loadDataAndUpdate(data);
	            }
	        });
	    };
	
	    var programIndicatorProgram = Ext.create('Ext.form.field.ComboBox', {
	        cls: 'ns-combo',
	        style: 'margin:0 1px 1px 0',
	        width: accBaseWidth,
	        valueField: 'id',
	        displayField: 'name',
	        emptyText: i18n.select_program,
	        editable: false,
	        queryMode: 'local',
	        store: programStore,
	        listeners: {
	            select: function select(cb) {
	                onProgramIndicatorProgramSelect(cb.getValue());
	            }
	        }
	    });
	
	    var programIndicatorLabel = Ext.create('Ext.form.Label', {
	        text: i18n.available,
	        cls: 'ns-toolbar-multiselect-left-label',
	        style: 'margin-right:5px'
	    });
	
	    var programIndicatorSearch = Ext.create('Ext.button.Button', {
	        width: 22,
	        height: 22,
	        cls: 'ns-button-icon',
	        iconCls: 'ns-button-icon-search',
	        //disabled: true,
	        showFilter: function showFilter() {
	            programIndicatorLabel.hide();
	            this.hide();
	            programIndicatorFilter.show();
	            programIndicatorFilter.reset();
	        },
	        hideFilter: function hideFilter() {
	            programIndicatorLabel.show();
	            this.show();
	            programIndicatorFilter.hide();
	            programIndicatorFilter.reset();
	        },
	        handler: function handler() {
	            this.showFilter();
	        }
	    });
	
	    var programIndicatorFilter = Ext.create('Ext.form.field.Trigger', {
	        cls: 'ns-trigger-filter',
	        emptyText: 'Filter available..',
	        height: 22,
	        hidden: true,
	        enableKeyEvents: true,
	        fieldStyle: 'height:22px; border-right:0 none',
	        style: 'height:22px',
	        onTriggerClick: function onTriggerClick() {
	            this.reset();
	            this.onKeyUpHandler();
	
	            programIndicatorSearch.hideFilter();
	        },
	        onKeyUpHandler: function onKeyUpHandler() {
	            var value = this.getValue() || '',
	                store = programIndicatorAvailableStore,
	                str;
	
	            store.filterBy(function (record) {
	                str = record.data.name || '';
	
	                return str.toLowerCase().indexOf(value.toLowerCase()) !== -1;
	            });
	        },
	        listeners: {
	            keyup: {
	                fn: function fn(cmp) {
	                    cmp.onKeyUpHandler();
	                },
	                buffer: 100
	            },
	            show: function show(cmp) {
	                cmp.focus(false, 50);
	            },
	            focus: function focus(cmp) {
	                cmp.addCls('ns-trigger-filter-focused');
	            },
	            blur: function blur(cmp) {
	                cmp.removeCls('ns-trigger-filter-focused');
	            }
	        }
	    });
	
	    var programIndicatorAvailable = Ext.create('Ext.ux.form.MultiSelect', {
	        cls: 'ns-toolbar-multiselect-left',
	        width: accBaseWidth / 2,
	        valueField: 'id',
	        displayField: 'name',
	        store: programIndicatorAvailableStore,
	        tbar: [programIndicatorLabel, programIndicatorSearch, programIndicatorFilter, '->', {
	            xtype: 'button',
	            iconCls: 'ns-button-icon-arrowright',
	            width: 22,
	            handler: function handler() {
	                if (programIndicatorAvailable.getValue().length) {
	                    var records = programIndicatorAvailableStore.getRecordsByIds(programIndicatorAvailable.getValue());
	                    dataSelectedStore.addRecords(records, 'pi');
	                }
	            }
	        }, {
	            xtype: 'button',
	            iconCls: 'ns-button-icon-arrowrightdouble',
	            width: 22,
	            handler: function handler() {
	                //programIndicatorAvailableStore.loadPage(null, null, null, true, function() {
	                dataSelectedStore.addRecords(programIndicatorAvailableStore.getRange(), 'pi');
	                //});
	            }
	        }],
	        listeners: {
	            render: function render(ms) {
	                var el = Ext.get(ms.boundList.getEl().id + '-listEl').dom;
	
	                //el.addEventListener('scroll', function(e) {
	                //if (uiManager.isScrolled(e) && !programIndicatorAvailableStore.isPending) {
	                //programIndicatorAvailableStore.loadPage(null, null, true);
	                //}
	                //});
	
	                ms.boundList.on('itemdblclick', function (bl, record) {
	                    dataSelectedStore.addRecords(record, 'pi');
	                }, ms);
	            }
	        }
	    });
	
	    var programIndicatorSelected = Ext.create('Ext.ux.form.MultiSelect', {
	        cls: 'ns-toolbar-multiselect-right',
	        width: accBaseWidth / 2,
	        valueField: 'id',
	        displayField: 'name',
	        ddReorder: true,
	        store: dataSelectedStore,
	        tbar: [{
	            xtype: 'button',
	            iconCls: 'ns-button-icon-arrowleftdouble',
	            width: 22,
	            handler: function handler() {
	                if (dataSelectedStore.getRange().length) {
	                    dataSelectedStore.removeAll();
	                }
	            }
	        }, {
	            xtype: 'button',
	            iconCls: 'ns-button-icon-arrowleft',
	            width: 22,
	            handler: function handler() {
	                if (programIndicatorSelected.getValue().length) {
	                    dataSelectedStore.removeByIds(programIndicatorSelected.getValue());
	                }
	            }
	        }, '->', {
	            xtype: 'label',
	            text: i18n.selected,
	            cls: 'ns-toolbar-multiselect-right-label'
	        }],
	        listeners: {
	            afterrender: function afterrender() {
	                this.boundList.on('itemdblclick', function (bl, record) {
	                    dataSelectedStore.removeByIds(record.data.id);
	                }, this);
	            }
	        }
	    });
	
	    var programIndicator = Ext.create('Ext.panel.Panel', {
	        xtype: 'panel',
	        //title: '<div class="ns-panel-title-data">' + i18n.programIndicators + '</div>',
	        preventHeader: true,
	        hidden: true,
	        hideCollapseTool: true,
	        dimension: programIndicatorObjectName,
	        bodyStyle: 'border:0 none',
	        items: [programIndicatorProgram, {
	            xtype: 'panel',
	            layout: 'column',
	            bodyStyle: 'border-style:none',
	            items: [programIndicatorAvailable, programIndicatorSelected]
	        }]
	    });
	
	    var data = Ext.create('Ext.panel.Panel', {
	        title: '<div class="ns-panel-title-data">' + i18n.data + '</div>',
	        cls: 'ns-accordion-first',
	        bodyStyle: 'padding:1px',
	        hideCollapseTool: true,
	        dimension: dataObjectName,
	        updateStoreFilters: function updateStoreFilters() {
	            indicatorAvailableStore.updateFilter();
	            dataElementAvailableStore.updateFilter();
	            dataSetAvailableStore.updateFilter();
	            eventDataItemAvailableStore.updateFilter();
	            programIndicatorAvailableStore.updateFilter();
	        },
	        getDimension: function getDimension() {
	            var config = {
	                dimension: dataObjectName,
	                items: []
	            };
	
	            dataSelectedStore.each(function (r) {
	                config.items.push({
	                    id: r.data.id,
	                    name: r.data.name
	                });
	            });
	
	            // TODO program
	            if (eventDataItemProgram.getValue() || programIndicatorProgram.getValue()) {
	                config.program = { id: eventDataItemProgram.getValue() || programIndicatorProgram.getValue() };
	            }
	
	            return config.items.length ? config : null;
	        },
	        clearDimension: function clearDimension() {
	            dataSelectedStore.removeAll();
	
	            indicatorAvailableStore.removeAll();
	            indicatorGroup.clearValue();
	
	            dataElementAvailableStore.removeAll();
	            dataElementGroup.clearValue();
	            dataElementDetailLevel.reset();
	
	            dataSetAvailableStore.removeAll();
	
	            eventDataItemAvailableStore.removeAll();
	            programIndicatorAvailableStore.removeAll();
	        },
	        setDimension: function setDimension(layout) {
	            if ((0, _isObject2.default)(layout.program) && (0, _isString2.default)(layout.program.id)) {
	                eventDataItemProgram.setValue(layout.program.id);
	                onEventDataItemProgramSelect(layout.program.id);
	            }
	
	            if (layout.hasDimension(this.dimension, true)) {
	                dataSelectedStore.addRecords(layout.getDimension(this.dimension).getRecords());
	            }
	        },
	        getHeightValue: function getHeightValue() {
	            var westRegion = uiManager.get('westRegion');
	
	            return westRegion.hasScrollbar ? uiConfig.west_scrollbarheight_accordion_indicator : uiConfig.west_maxheight_accordion_indicator;
	        },
	        onExpand: function onExpand() {
	            accordion.setThisHeight(this.getHeightValue());
	
	            uiManager.msSetHeight([indicatorAvailable, indicatorSelected], this, uiConfig.west_fill_accordion_indicator);
	            uiManager.msSetHeight([dataElementAvailable, dataElementSelected], this, uiConfig.west_fill_accordion_dataelement);
	            uiManager.msSetHeight([dataSetAvailable, dataSetSelected], this, uiConfig.west_fill_accordion_dataset);
	            uiManager.msSetHeight([eventDataItemAvailable, eventDataItemSelected], this, uiConfig.west_fill_accordion_eventdataitem);
	            uiManager.msSetHeight([programIndicatorAvailable, programIndicatorSelected], this, uiConfig.west_fill_accordion_programindicator);
	        },
	        items: [dataType, indicator, dataElement, dataSet, eventDataItem, programIndicator],
	        listeners: {
	            expand: function expand(p) {
	                p.onExpand();
	            }
	        }
	    });
	    accordionPanels.push(uiManager.reg(data, 'data'));
	
	    // period
	
	    var rewind = Ext.create('Ext.form.field.Checkbox', {
	        relativePeriodId: 'rewind',
	        boxLabel: i18n.rewind_one_period,
	        xable: function xable() {
	            this.setDisabled(period.isNoRelativePeriods());
	        }
	    });
	
	    var relativePeriodDefaults = {
	        labelSeparator: '',
	        style: 'margin-bottom:0',
	        listeners: {
	            added: function added(chb) {
	                if (chb.xtype === 'checkbox') {
	                    periodCheckboxes[chb.index] = chb;
	                    relativePeriod.valueComponentMap[chb.relativePeriodId] = chb;
	
	                    if (chb.relativePeriodId === appManager.getRelativePeriod()) {
	                        chb.setValue(true);
	                    }
	                }
	            }
	        }
	    };
	
	    var relativePeriod = {
	        xtype: 'panel',
	        layout: 'column',
	        hideCollapseTool: true,
	        autoScroll: true,
	        bodyStyle: 'border:0 none',
	        valueComponentMap: {},
	        items: [{
	            xtype: 'container',
	            columnWidth: 0.34,
	            bodyStyle: 'border-style:none',
	            items: [{
	                xtype: 'panel',
	                bodyStyle: 'border-style:none; padding:0 0 0 8px',
	                defaults: relativePeriodDefaults,
	                items: [{
	                    xtype: 'label',
	                    text: i18n['days'],
	                    cls: 'ns-label-period-heading'
	                }, {
	                    xtype: 'checkbox',
	                    relativePeriodId: 'TODAY',
	                    boxLabel: i18n['today'],
	                    index: 0
	                }, {
	                    xtype: 'checkbox',
	                    relativePeriodId: 'YESTERDAY',
	                    boxLabel: i18n['yesterday'],
	                    index: 1
	                }, {
	                    xtype: 'checkbox',
	                    relativePeriodId: 'LAST_3_DAYS',
	                    boxLabel: i18n['last_3_days'],
	                    index: 2
	                }, {
	                    xtype: 'checkbox',
	                    relativePeriodId: 'LAST_7_DAYS',
	                    boxLabel: i18n['last_7_days'],
	                    index: 3
	                }, {
	                    xtype: 'checkbox',
	                    relativePeriodId: 'LAST_14_DAYS',
	                    boxLabel: i18n['last_14_days'],
	                    index: 4
	                }]
	            }, {
	                xtype: 'panel',
	                bodyStyle: 'border-style:none; padding:5px 0 0 8px',
	                defaults: relativePeriodDefaults,
	                items: [{
	                    xtype: 'label',
	                    text: i18n['bimonths'],
	                    cls: 'ns-label-period-heading'
	                }, {
	                    xtype: 'checkbox',
	                    relativePeriodId: 'THIS_BIMONTH',
	                    boxLabel: i18n['this_bimonth'],
	                    index: 17
	                }, {
	                    xtype: 'checkbox',
	                    relativePeriodId: 'LAST_BIMONTH',
	                    boxLabel: i18n['last_bimonth'],
	                    index: 18
	                }, {
	                    xtype: 'checkbox',
	                    relativePeriodId: 'LAST_6_BIMONTHS',
	                    boxLabel: i18n['last_6_bimonths'],
	                    index: 19
	                }, {
	                    xtype: 'checkbox',
	                    relativePeriodId: 'BIMONTHS_THIS_YEAR',
	                    boxLabel: i18n['bimonths_this_year'],
	                    index: 20
	                }]
	            }, {
	                xtype: 'panel',
	                bodyStyle: 'border-style:none; padding:5px 0 0 8px',
	                defaults: relativePeriodDefaults,
	                items: [{
	                    xtype: 'label',
	                    text: i18n['financial_years'],
	                    cls: 'ns-label-period-heading'
	                }, {
	                    xtype: 'checkbox',
	                    relativePeriodId: 'THIS_FINANCIAL_YEAR',
	                    boxLabel: i18n['this_financial_year'],
	                    index: 28
	                }, {
	                    xtype: 'checkbox',
	                    relativePeriodId: 'LAST_FINANCIAL_YEAR',
	                    boxLabel: i18n['last_financial_year'],
	                    index: 29
	                }, {
	                    xtype: 'checkbox',
	                    relativePeriodId: 'LAST_5_FINANCIAL_YEARS',
	                    boxLabel: i18n['last_5_financial_years'],
	                    index: 30
	                }]
	            }]
	        }, {
	            xtype: 'container',
	            columnWidth: 0.33,
	            bodyStyle: 'border-style:none',
	            items: [{
	                xtype: 'panel',
	                bodyStyle: 'border-style:none; padding:0 0 0 8px',
	                defaults: relativePeriodDefaults,
	                items: [{
	                    xtype: 'label',
	                    text: i18n['weeks'],
	                    cls: 'ns-label-period-heading'
	                }, {
	                    xtype: 'checkbox',
	                    relativePeriodId: 'THIS_WEEK',
	                    boxLabel: i18n['this_week'],
	                    index: 5
	                }, {
	                    xtype: 'checkbox',
	                    relativePeriodId: 'LAST_WEEK',
	                    boxLabel: i18n['last_week'],
	                    index: 6
	                }, {
	                    xtype: 'checkbox',
	                    relativePeriodId: 'LAST_4_WEEKS',
	                    boxLabel: i18n['last_4_weeks'],
	                    index: 7
	                }, {
	                    xtype: 'checkbox',
	                    relativePeriodId: 'LAST_12_WEEKS',
	                    boxLabel: i18n['last_12_weeks'],
	                    index: 8
	                }, {
	                    xtype: 'checkbox',
	                    relativePeriodId: 'LAST_52_WEEKS',
	                    boxLabel: i18n['last_52_weeks'],
	                    index: 9
	                }, {
	                    xtype: 'checkbox',
	                    relativePeriodId: 'WEEKS_THIS_YEAR',
	                    boxLabel: i18n['weeks_this_year'],
	                    index: 10
	                }]
	            }, {
	                xtype: 'panel',
	                bodyStyle: 'border-style:none; padding:5px 0 0 8px',
	                defaults: relativePeriodDefaults,
	                items: [{
	                    xtype: 'label',
	                    text: i18n['quarters'],
	                    cls: 'ns-label-period-heading'
	                }, {
	                    xtype: 'checkbox',
	                    relativePeriodId: 'THIS_QUARTER',
	                    boxLabel: i18n['this_quarter'],
	                    index: 21
	                }, {
	                    xtype: 'checkbox',
	                    relativePeriodId: 'LAST_QUARTER',
	                    boxLabel: i18n['last_quarter'],
	                    index: 22
	                }, {
	                    xtype: 'checkbox',
	                    relativePeriodId: 'LAST_4_QUARTERS',
	                    boxLabel: i18n['last_4_quarters'],
	                    index: 23
	                }, {
	                    xtype: 'checkbox',
	                    relativePeriodId: 'QUARTERS_THIS_YEAR',
	                    boxLabel: i18n['quarters_this_year'],
	                    index: 24
	                }]
	            }, {
	                xtype: 'panel',
	                bodyStyle: 'border-style:none; padding:5px 0 0 8px',
	                defaults: relativePeriodDefaults,
	                items: [{
	                    xtype: 'label',
	                    text: i18n['years'],
	                    cls: 'ns-label-period-heading'
	                }, {
	                    xtype: 'checkbox',
	                    relativePeriodId: 'THIS_YEAR',
	                    boxLabel: i18n['this_year'],
	                    index: 31
	                }, {
	                    xtype: 'checkbox',
	                    relativePeriodId: 'LAST_YEAR',
	                    boxLabel: i18n['last_year'],
	                    index: 32
	                }, {
	                    xtype: 'checkbox',
	                    relativePeriodId: 'LAST_5_YEARS',
	                    boxLabel: i18n['last_5_years'],
	                    index: 33
	                }]
	            }]
	        }, {
	            xtype: 'container',
	            columnWidth: 0.33,
	            bodyStyle: 'border-style:none',
	            items: [{
	                xtype: 'panel',
	                bodyStyle: 'border-style:none; padding:0 0 0 8px',
	                defaults: relativePeriodDefaults,
	                items: [{
	                    xtype: 'label',
	                    text: i18n['months'],
	                    cls: 'ns-label-period-heading'
	                }, {
	                    xtype: 'checkbox',
	                    relativePeriodId: 'THIS_MONTH',
	                    boxLabel: i18n['this_month'],
	                    index: 11
	                }, {
	                    xtype: 'checkbox',
	                    relativePeriodId: 'LAST_MONTH',
	                    boxLabel: i18n['last_month'],
	                    index: 12
	                }, {
	                    xtype: 'checkbox',
	                    relativePeriodId: 'LAST_3_MONTHS',
	                    boxLabel: i18n['last_3_months'],
	                    index: 13
	                }, {
	                    xtype: 'checkbox',
	                    relativePeriodId: 'LAST_6_MONTHS',
	                    boxLabel: i18n['last_6_months'],
	                    index: 14
	                }, {
	                    xtype: 'checkbox',
	                    relativePeriodId: 'LAST_12_MONTHS',
	                    boxLabel: i18n['last_12_months'],
	                    index: 15
	                }, {
	                    xtype: 'checkbox',
	                    relativePeriodId: 'MONTHS_THIS_YEAR',
	                    boxLabel: i18n['months_this_year'],
	                    index: 16
	                }]
	            }, {
	                xtype: 'panel',
	                bodyStyle: 'border-style:none; padding:5px 0 0 8px',
	                defaults: relativePeriodDefaults,
	                items: [{
	                    xtype: 'label',
	                    text: i18n['sixmonths'],
	                    cls: 'ns-label-period-heading'
	                }, {
	                    xtype: 'checkbox',
	                    relativePeriodId: 'THIS_SIX_MONTH',
	                    boxLabel: i18n['this_sixmonth'],
	                    index: 25
	                }, {
	                    xtype: 'checkbox',
	                    relativePeriodId: 'LAST_SIX_MONTH',
	                    boxLabel: i18n['last_sixmonth'],
	                    index: 26
	                }, {
	                    xtype: 'checkbox',
	                    relativePeriodId: 'LAST_2_SIXMONTHS',
	                    boxLabel: i18n['last_2_sixmonths'],
	                    index: 27
	                }]
	            }]
	        }]
	    };
	
	    var fixedPeriodAvailable = Ext.create('Ext.ux.form.MultiSelect', {
	        cls: 'ns-toolbar-multiselect-left',
	        width: accBaseWidth / 2,
	        height: 180,
	        valueField: 'id',
	        displayField: 'name',
	        store: fixedPeriodAvailableStore,
	        tbar: [{
	            xtype: 'label',
	            text: i18n.available,
	            cls: 'ns-toolbar-multiselect-left-label'
	        }, '->', {
	            xtype: 'button',
	            iconCls: 'ns-button-icon-arrowright',
	            width: 22,
	            handler: function handler() {
	                uiManager.msSelect(fixedPeriodAvailable, fixedPeriodSelected);
	            }
	        }, {
	            xtype: 'button',
	            iconCls: 'ns-button-icon-arrowrightdouble',
	            width: 22,
	            handler: function handler() {
	                uiManager.msSelectAll(fixedPeriodAvailable, fixedPeriodSelected, true);
	            }
	        }],
	        listeners: {
	            afterrender: function afterrender() {
	                this.boundList.on('itemdblclick', function () {
	                    uiManager.msSelect(fixedPeriodAvailable, fixedPeriodSelected);
	                }, this);
	            }
	        }
	    });
	
	    var fixedPeriodSelected = Ext.create('Ext.ux.form.MultiSelect', {
	        cls: 'ns-toolbar-multiselect-right',
	        width: accBaseWidth / 2,
	        height: 180,
	        valueField: 'id',
	        displayField: 'name',
	        ddReorder: true,
	        store: fixedPeriodSelectedStore,
	        tbar: [{
	            xtype: 'button',
	            iconCls: 'ns-button-icon-arrowleftdouble',
	            width: 22,
	            handler: function handler() {
	                uiManager.msUnselectAll(fixedPeriodAvailable, fixedPeriodSelected);
	            }
	        }, {
	            xtype: 'button',
	            iconCls: 'ns-button-icon-arrowleft',
	            width: 22,
	            handler: function handler() {
	                uiManager.msUnselect(fixedPeriodAvailable, fixedPeriodSelected);
	            }
	        }, '->', {
	            xtype: 'label',
	            text: i18n.selected,
	            cls: 'ns-toolbar-multiselect-right-label'
	        }],
	        listeners: {
	            afterrender: function afterrender() {
	                this.boundList.on('itemdblclick', function () {
	                    uiManager.msUnselect(fixedPeriodAvailable, fixedPeriodSelected);
	                }, this);
	            }
	        }
	    });
	
	    var onPeriodTypeSelect = function onPeriodTypeSelect() {
	        var type = periodType.getValue(),
	            periodOffset = periodType.periodOffset,
	            gen = calendarManager.periodGenerator,
	            periods = gen.generateReversedPeriods(type, type === 'Yearly' ? periodOffset - 5 : periodOffset);
	
	        for (var i = 0; i < periods.length; i++) {
	            periods[i].id = periods[i].iso;
	        }
	
	        fixedPeriodAvailableStore.setIndex(periods);
	        fixedPeriodAvailableStore.loadData(periods);
	        uiManager.msFilterAvailable(fixedPeriodAvailable, fixedPeriodSelected);
	    };
	
	    var periodType = Ext.create('Ext.form.field.ComboBox', {
	        cls: 'ns-combo',
	        style: 'margin-bottom:1px',
	        width: accBaseWidth - 62 - 62 - 2,
	        valueField: 'id',
	        displayField: 'name',
	        emptyText: i18n.select_period_type,
	        editable: false,
	        queryMode: 'remote',
	        store: periodTypeStore,
	        periodOffset: 0,
	        listeners: {
	            select: function select() {
	                periodType.periodOffset = 0;
	                onPeriodTypeSelect();
	            }
	        }
	    });
	
	    var period = Ext.create('Ext.panel.Panel', {
	        title: '<div class="ns-panel-title-period">Periods</div>',
	        hideCollapseTool: true,
	        dimension: periodObjectName,
	        checkboxes: periodCheckboxes,
	        clearDimension: function clearDimension(all) {
	            fixedPeriodSelectedStore.removeAll();
	            period.resetRelativePeriods();
	
	            if (!all) {
	                relativePeriod.valueComponentMap[appManager.getRelativePeriod()].setValue(true);
	            }
	        },
	        setDimension: function setDimension(layout) {
	            if (layout.hasDimension(this.dimension, true)) {
	                //var records = layout.getDimension(this.dimension).getRecords(null, layout.getResponse()),
	                var records = layout.getDimension(this.dimension).extendRecords(layout.getResponse()),
	                    fixedRecords = [],
	                    checkbox;
	
	                records.forEach(function (record) {
	                    checkbox = relativePeriod.valueComponentMap[record.id];
	
	                    if (checkbox) {
	                        checkbox.setValue(true);
	                    } else {
	                        fixedRecords.push(record);
	                    }
	                });
	
	                fixedPeriodSelectedStore.add(fixedRecords);
	
	                uiManager.msFilterAvailable({ store: fixedPeriodAvailableStore }, { store: fixedPeriodSelectedStore });
	            }
	        },
	        getDimension: function getDimension() {
	            var config = {
	                dimension: periodObjectName,
	                items: []
	            };
	
	            fixedPeriodSelectedStore.each(function (r) {
	                config.items.push({
	                    id: r.data.id,
	                    name: r.data.name
	                });
	            });
	
	            for (var i = 0, chb; i < this.checkboxes.length; i++) {
	                chb = this.checkboxes[i];
	
	                if (chb && chb.getValue()) {
	                    config.items.push({
	                        id: chb.relativePeriodId,
	                        name: ''
	                    });
	                }
	            }
	
	            return config.items.length ? config : null;
	        },
	        getHeightValue: function getHeightValue() {
	            var westRegion = uiManager.get('westRegion');
	
	            return westRegion.hasScrollbar ? uiConfig.west_scrollbarheight_accordion_period : uiConfig.west_maxheight_accordion_period;
	        },
	        onExpand: function onExpand() {
	            accordion.setThisHeight(this.getHeightValue());
	
	            uiManager.msSetHeight([fixedPeriodAvailable, fixedPeriodSelected], this, uiConfig.west_fill_accordion_period);
	        },
	        resetRelativePeriods: function resetRelativePeriods() {
	            var a = this.checkboxes;
	            for (var i = 0; i < a.length; i++) {
	                a[i].setValue(false);
	            }
	        },
	        isNoRelativePeriods: function isNoRelativePeriods() {
	            var a = this.checkboxes;
	            for (var i = 0; i < a.length; i++) {
	                if (a[i].getValue()) {
	                    return false;
	                }
	            }
	            return true;
	        },
	        items: [{
	            xtype: 'panel',
	            layout: 'column',
	            bodyStyle: 'border-style:none',
	            style: 'margin-top:0px',
	            items: [periodType, {
	                xtype: 'button',
	                text: i18n.prev_year,
	                style: 'margin-left:1px; border-radius:2px',
	                height: 24,
	                width: 62,
	                handler: function handler() {
	                    if (periodType.getValue()) {
	                        periodType.periodOffset--;
	                        onPeriodTypeSelect();
	                    }
	                }
	            }, {
	                xtype: 'button',
	                text: i18n.next_year,
	                style: 'margin-left:1px; border-radius:2px',
	                height: 24,
	                width: 62,
	                handler: function handler() {
	                    if (periodType.getValue()) {
	                        periodType.periodOffset++;
	                        onPeriodTypeSelect();
	                    }
	                }
	            }]
	        }, {
	            xtype: 'panel',
	            layout: 'column',
	            bodyStyle: 'border-style:none; padding-bottom:2px',
	            items: [fixedPeriodAvailable, fixedPeriodSelected]
	        }, relativePeriod],
	        listeners: {
	            expand: function expand(p) {
	                p.onExpand();
	            }
	        }
	    });
	    accordionPanels.push(uiManager.reg(period, 'period'));
	
	    // organisation unit
	
	    var treePanel = Ext.create('Ext.tree.Panel', {
	        cls: 'ns-tree',
	        style: 'border-top: 1px solid #ddd; padding-top: 1px',
	        width: accBaseWidth,
	        displayField: 'name',
	        rootVisible: false,
	        autoScroll: true,
	        multiSelect: true,
	        rendered: false,
	        reset: function reset() {
	            var rootNode = this.getRootNode().findChild('id', appManager.rootNodes[0].id);
	            this.collapseAll();
	            this.expandPath(rootNode.getPath());
	            this.getSelectionModel().select(rootNode);
	        },
	        selectRootIf: function selectRootIf() {
	            if (this.getSelectionModel().getSelection().length < 1) {
	                var node = this.getRootNode().findChild('id', appManager.rootNodes[0].id);
	                if (this.rendered) {
	                    this.getSelectionModel().select(node);
	                }
	                return node;
	            }
	        },
	        isPending: false,
	        recordsToSelect: [],
	        recordsToRestore: [],
	        multipleSelectIf: function multipleSelectIf(map, doUpdate) {
	            this.recordsToSelect = (0, _arrayClean2.default)(this.recordsToSelect);
	
	            if (this.recordsToSelect.length === Object.keys(map).length) {
	                this.getSelectionModel().select(this.recordsToSelect);
	                this.recordsToSelect = [];
	                this.isPending = false;
	
	                if (doUpdate) {
	                    update();
	                }
	            }
	        },
	        multipleExpand: function multipleExpand(id, map, doUpdate) {
	            var t = this,
	                rootId = appManager.rootNodeId,
	                path = map[id];
	
	            if (path.substr(0, rootId.length + 1) !== '/' + rootId) {
	                path = '/' + rootId + '/' + path;
	            }
	
	            t.expandPath(path, 'id', '/', function () {
	                var record = t.getRootNode().findChild('id', id, true);
	                t.recordsToSelect.push(record);
	                t.multipleSelectIf(map, doUpdate);
	            });
	        },
	        select: function select(url, params) {
	            if (!params) {
	                params = {};
	            }
	            Ext.Ajax.request({
	                url: encodeURI(url),
	                method: 'GET',
	                params: params,
	                scope: this,
	                success: function success(r) {
	                    var a = Ext.decode(r.responseText).organisationUnits;
	                    this.numberOfRecords = a.length;
	                    for (var i = 0; i < a.length; i++) {
	                        this.multipleExpand(a[i].id, a[i].path);
	                    }
	                }
	            });
	        },
	        getParentGraphMap: function getParentGraphMap() {
	            var selection = this.getSelectionModel().getSelection(),
	                map = {};
	
	            if ((0, _isArray2.default)(selection) && selection.length) {
	                for (var i = 0, pathArray, key; i < selection.length; i++) {
	                    pathArray = selection[i].getPath().split('/');
	                    map[pathArray.pop()] = pathArray.join('/');
	                }
	            }
	
	            return map;
	        },
	        selectGraphMap: function selectGraphMap(map, update) {
	            if (!Object.keys(map).length) {
	                return;
	            }
	
	            this.isPending = true;
	
	            for (var key in map) {
	                if (map.hasOwnProperty(key)) {
	                    treePanel.multipleExpand(key, map, update);
	                }
	            }
	        },
	        store: Ext.create('Ext.data.TreeStore', {
	            fields: ['id', 'name', 'hasChildren'],
	            proxy: {
	                type: 'rest',
	                format: 'json',
	                noCache: false,
	                extraParams: {
	                    fields: 'children[id,' + displayPropertyUrl + ',children::isNotEmpty~rename(hasChildren)&paging=false'
	                },
	                url: apiPath + '/organisationUnits',
	                reader: {
	                    type: 'json',
	                    root: 'children'
	                },
	                sortParam: false
	            },
	            sorters: [{
	                property: 'name',
	                direction: 'ASC'
	            }],
	            root: {
	                id: appManager.rootNodeId,
	                expanded: true,
	                children: appManager.getRootNodes()
	            },
	            listeners: {
	                beforeload: function beforeload(store, operation) {
	                    if (!store.proxy._url) {
	                        store.proxy._url = store.proxy.url;
	                    }
	
	                    store.proxy.url = store.proxy._url + '/' + operation.node.data.id;
	                },
	                load: function load(store, node, records) {
	                    records.forEach(function (record) {
	                        if ((0, _isBoolean2.default)(record.data.hasChildren)) {
	                            record.set('leaf', !record.data.hasChildren);
	                        }
	                    });
	                }
	            }
	        }),
	        xable: function xable(values) {
	            for (var i = 0; i < values.length; i++) {
	                if (!!values[i]) {
	                    this.disable();
	                    return;
	                }
	            }
	
	            this.enable();
	        },
	        listeners: {
	            beforeitemexpand: function beforeitemexpand() {
	                if (!treePanel.isPending) {
	                    treePanel.recordsToRestore = treePanel.getSelectionModel().getSelection();
	                }
	            },
	            itemexpand: function itemexpand() {
	                if (!treePanel.isPending && treePanel.recordsToRestore.length) {
	                    treePanel.getSelectionModel().select(treePanel.recordsToRestore);
	                    treePanel.recordsToRestore = [];
	                }
	            },
	            render: function render() {
	                this.rendered = true;
	            },
	            afterrender: function afterrender() {
	                this.getSelectionModel().select(0);
	            },
	            itemcontextmenu: function itemcontextmenu(v, r, h, i, e) {
	                v.getSelectionModel().select(r, false);
	
	                if (v.menu) {
	                    v.menu.destroy();
	                }
	                v.menu = Ext.create('Ext.menu.Menu', {
	                    id: 'treepanel-contextmenu',
	                    showSeparator: false,
	                    shadow: false
	                });
	                if (!r.data.leaf) {
	                    v.menu.add({
	                        id: 'treepanel-contextmenu-item',
	                        text: i18n.select_sub_units,
	                        iconCls: 'ns-button-icon-nodeselectchild',
	                        handler: function handler() {
	                            r.expand(false, function () {
	                                v.getSelectionModel().select(r.childNodes, true);
	                                v.getSelectionModel().deselect(r);
	                            });
	                        }
	                    });
	                } else {
	                    return;
	                }
	
	                v.menu.showAt(e.xy);
	            }
	        }
	    });
	    uiManager.reg(treePanel, 'treePanel');
	
	    var userOrganisationUnit = Ext.create('Ext.form.field.Checkbox', {
	        columnWidth: 0.25,
	        style: 'padding-top: 3px; padding-left: 5px; margin-bottom: 0',
	        boxLabel: i18n.user_organisation_unit,
	        labelWidth: uiConfig.form_label_width,
	        handler: function handler(chb, checked) {
	            treePanel.xable([checked, userOrganisationUnitChildren.getValue(), userOrganisationUnitGrandChildren.getValue()]);
	        }
	    });
	
	    var userOrganisationUnitChildren = Ext.create('Ext.form.field.Checkbox', {
	        columnWidth: 0.26,
	        style: 'padding-top: 3px; margin-bottom: 0',
	        boxLabel: i18n.user_sub_units,
	        labelWidth: uiConfig.form_label_width,
	        handler: function handler(chb, checked) {
	            treePanel.xable([checked, userOrganisationUnit.getValue(), userOrganisationUnitGrandChildren.getValue()]);
	        }
	    });
	
	    var userOrganisationUnitGrandChildren = Ext.create('Ext.form.field.Checkbox', {
	        columnWidth: 0.4,
	        style: 'padding-top: 3px; margin-bottom: 0',
	        boxLabel: i18n.user_sub_x2_units,
	        labelWidth: uiConfig.form_label_width,
	        handler: function handler(chb, checked) {
	            treePanel.xable([checked, userOrganisationUnit.getValue(), userOrganisationUnitChildren.getValue()]);
	        }
	    });
	
	    var organisationUnitLevel = Ext.create('Ext.form.field.ComboBox', {
	        cls: 'ns-combo',
	        multiSelect: true,
	        style: 'margin-bottom:0',
	        width: accBaseWidth - 37,
	        valueField: 'level',
	        displayField: 'name',
	        emptyText: i18n.select_organisation_unit_levels,
	        editable: false,
	        hidden: true,
	        store: organisationUnitLevelStore
	    });
	
	    var organisationUnitGroup = Ext.create('Ext.form.field.ComboBox', {
	        cls: 'ns-combo',
	        multiSelect: true,
	        style: 'margin-bottom:0',
	        width: accBaseWidth - 37,
	        valueField: 'id',
	        displayField: 'name',
	        emptyText: i18n.select_organisation_unit_groups,
	        editable: false,
	        hidden: true,
	        store: organisationUnitGroupStore
	    });
	
	    var toolMenu = Ext.create('Ext.menu.Menu', {
	        shadow: false,
	        showSeparator: false,
	        menuValue: 'orgunit',
	        clickHandler: function clickHandler(param) {
	            if (!param) {
	                return;
	            }
	
	            var items = this.items.items;
	            this.menuValue = param;
	
	            // Menu item icon cls
	            for (var i = 0; i < items.length; i++) {
	                if (items[i].setIconCls) {
	                    if (items[i].param === param) {
	                        items[i].setIconCls('ns-menu-item-selected');
	                    } else {
	                        items[i].setIconCls('ns-menu-item-unselected');
	                    }
	                }
	            }
	
	            // Gui
	            if (param === 'orgunit') {
	                userOrganisationUnit.show();
	                userOrganisationUnitChildren.show();
	                userOrganisationUnitGrandChildren.show();
	                organisationUnitLevel.hide();
	                organisationUnitGroup.hide();
	
	                if (userOrganisationUnit.getValue() || userOrganisationUnitChildren.getValue()) {
	                    treePanel.disable();
	                }
	            } else if (param === 'level') {
	                userOrganisationUnit.hide();
	                userOrganisationUnitChildren.hide();
	                userOrganisationUnitGrandChildren.hide();
	                organisationUnitLevel.show();
	                organisationUnitGroup.hide();
	                treePanel.enable();
	            } else if (param === 'group') {
	                // DHIS2-561: avoid showing the group ids in the combobox when
	                // loading a favorite and expanding the OU panel
	                organisationUnitGroupStore.load();
	
	                userOrganisationUnit.hide();
	                userOrganisationUnitChildren.hide();
	                userOrganisationUnitGrandChildren.hide();
	                organisationUnitLevel.hide();
	                organisationUnitGroup.show();
	                treePanel.enable();
	            }
	        },
	        items: [{
	            xtype: 'label',
	            text: 'Selection mode',
	            style: 'padding:7px 5px 5px 7px; font-weight:bold; border:0 none'
	        }, {
	            text: i18n.select_organisation_units + '&nbsp;&nbsp;',
	            param: 'orgunit',
	            iconCls: 'ns-menu-item-selected'
	        }, {
	            text: 'Select levels' + '&nbsp;&nbsp;',
	            param: 'level',
	            iconCls: 'ns-menu-item-unselected'
	        }, {
	            text: 'Select groups' + '&nbsp;&nbsp;',
	            param: 'group',
	            iconCls: 'ns-menu-item-unselected'
	        }],
	        listeners: {
	            afterrender: function afterrender() {
	                this.getEl().addCls('ns-btn-menu');
	            },
	            click: function click(menu, item) {
	                this.clickHandler(item.param);
	            }
	        }
	    });
	
	    var tool = Ext.create('Ext.button.Button', {
	        cls: 'ns-button-organisationunitselection',
	        iconCls: 'ns-button-icon-gear',
	        width: 36,
	        height: 24,
	        menu: toolMenu
	    });
	
	    var toolPanel = Ext.create('Ext.panel.Panel', {
	        width: 36,
	        bodyStyle: 'border:0 none; text-align:right',
	        style: 'margin-right:1px',
	        items: tool
	    });
	
	    var organisationUnit = Ext.create('Ext.panel.Panel', {
	        title: '<div class="ns-panel-title-organisationunit">' + i18n.organisation_units + '</div>',
	        bodyStyle: 'padding:1px',
	        hideCollapseTool: true,
	        dimension: organisationUnitObjectName,
	        collapsed: false,
	        clearDimension: function clearDimension(doClear) {
	            if (doClear) {
	                treePanel.reset();
	
	                userOrganisationUnit.setValue(false);
	                userOrganisationUnitChildren.setValue(false);
	                userOrganisationUnitGrandChildren.setValue(false);
	            }
	        },
	        setDimension: function setDimension(layout) {
	            if (layout.hasDimension(this.dimension, true)) {
	                var dimension = layout.getDimension(this.dimension, true),
	                    parentGraphMap = layout.parentGraphMap;
	
	                var records = dimension.getRecords(),
	                    ids = [],
	                    levels = [],
	                    groups = [],
	                    isOu,
	                    isOuc,
	                    isOugc;
	
	                records.forEach(function (record) {
	                    if (record.id === 'USER_ORGUNIT') {
	                        isOu = true;
	                    } else if (record.id === 'USER_ORGUNIT_CHILDREN') {
	                        isOuc = true;
	                    } else if (record.id === 'USER_ORGUNIT_GRANDCHILDREN') {
	                        isOugc = true;
	                    } else if (record.id.substr(0, 5) === 'LEVEL') {
	                        levels.push(parseInt(record.id.split('-')[1]));
	                    } else if (record.id.substr(0, 8) === 'OU_GROUP') {
	                        groups.push(record.id.split('-')[1]);
	                    } else {
	                        ids.push(record.id);
	                    }
	                });
	
	                if (levels.length) {
	                    toolMenu.clickHandler('level');
	                    organisationUnitLevel.setValue(levels);
	                } else if (groups.length) {
	                    toolMenu.clickHandler('group');
	                    organisationUnitGroup.setValue(groups);
	                } else {
	                    toolMenu.clickHandler('orgunit');
	                    userOrganisationUnit.setValue(isOu);
	                    userOrganisationUnitChildren.setValue(isOuc);
	                    userOrganisationUnitGrandChildren.setValue(isOugc);
	                }
	
	                if (!(isOu || isOuc || isOugc)) {
	                    if ((0, _isObject2.default)(parentGraphMap)) {
	                        treePanel.selectGraphMap(parentGraphMap);
	                    }
	                }
	            } else {
	                this.clearDimension(true);
	            }
	        },
	        getDimension: function getDimension() {
	            var r = treePanel.getSelectionModel().getSelection(),
	                config = {
	                dimension: organisationUnitObjectName,
	                items: []
	            };
	
	            if (toolMenu.menuValue === 'orgunit') {
	                if (userOrganisationUnit.getValue() || userOrganisationUnitChildren.getValue() || userOrganisationUnitGrandChildren.getValue()) {
	                    if (userOrganisationUnit.getValue()) {
	                        config.items.push({
	                            id: 'USER_ORGUNIT',
	                            name: ''
	                        });
	                    }
	                    if (userOrganisationUnitChildren.getValue()) {
	                        config.items.push({
	                            id: 'USER_ORGUNIT_CHILDREN',
	                            name: ''
	                        });
	                    }
	                    if (userOrganisationUnitGrandChildren.getValue()) {
	                        config.items.push({
	                            id: 'USER_ORGUNIT_GRANDCHILDREN',
	                            name: ''
	                        });
	                    }
	                } else {
	                    for (var i = 0; i < r.length; i++) {
	                        config.items.push({ id: r[i].data.id });
	                    }
	                }
	            } else if (toolMenu.menuValue === 'level') {
	                var levels = organisationUnitLevel.getValue();
	
	                for (var i = 0; i < levels.length; i++) {
	                    config.items.push({
	                        id: 'LEVEL-' + levels[i],
	                        name: ''
	                    });
	                }
	
	                for (var i = 0; i < r.length; i++) {
	                    config.items.push({
	                        id: r[i].data.id,
	                        name: ''
	                    });
	                }
	            } else if (toolMenu.menuValue === 'group') {
	                var groupIds = organisationUnitGroup.getValue();
	
	                for (var i = 0; i < groupIds.length; i++) {
	                    config.items.push({
	                        id: 'OU_GROUP-' + groupIds[i],
	                        name: ''
	                    });
	                }
	
	                for (var i = 0; i < r.length; i++) {
	                    config.items.push({
	                        id: r[i].data.id,
	                        name: ''
	                    });
	                }
	            }
	
	            return config.items.length ? config : null;
	        },
	        getHeightValue: function getHeightValue() {
	            var westRegion = uiManager.get('westRegion');
	
	            return westRegion.hasScrollbar ? uiConfig.west_scrollbarheight_accordion_organisationunit : uiConfig.west_maxheight_accordion_organisationunit;
	        },
	        onExpand: function onExpand() {
	            accordion.setThisHeight(this.getHeightValue);
	
	            treePanel.setHeight(this.getHeight() - uiConfig.west_fill_accordion_organisationunit);
	        },
	        items: [{
	            layout: 'column',
	            bodyStyle: 'border:0 none',
	            style: 'padding-bottom:1px',
	            items: [toolPanel, {
	                width: accBaseWidth - 37,
	                layout: 'column',
	                bodyStyle: 'border:0 none',
	                items: [userOrganisationUnit, userOrganisationUnitChildren, userOrganisationUnitGrandChildren, organisationUnitLevel, organisationUnitGroup]
	            }]
	        }, treePanel],
	        listeners: {
	            expand: function expand(p) {
	                p.onExpand();
	            }
	        }
	    });
	    accordionPanels.push(uiManager.reg(organisationUnit, 'organisationUnit'));
	
	    // dimensions
	
	    var getDimensionPanel = function getDimensionPanel(dimension, iconCls) {
	        var onSelect, availableStore, selectedStore, dataLabel, dataSearch, dataFilter, selectedAll, available, selected, onSelectAll, panel, createPanel, getPanels;
	
	        onSelect = function onSelect() {
	            var win = uiManager.get('layoutWindow');
	
	            if (selectedStore.getRange().length || selectedAll.getValue()) {
	                win.addDimension({ id: dimension.id, name: dimension.name });
	            } else if (win.hasDimension(dimension.id)) {
	                win.removeDimension(dimension.id);
	            }
	        };
	
	        availableStore = Ext.create('Ext.data.Store', {
	            fields: ['id', 'name'],
	            lastPage: null,
	            nextPage: 1,
	            isPending: false,
	            isLoaded: false,
	            reset: function reset() {
	                this.removeAll();
	                this.lastPage = null;
	                this.nextPage = 1;
	                this.isPending = false;
	                dataSearch.hideFilter();
	            },
	            storage: {},
	            addToStorage: function addToStorage(dimensionId, filter, data) {
	                filter = 'cache_' + ((0, _isString2.default)(filter) || (0, _isNumber2.default)(filter) ? filter : '');
	
	                if (!dimensionId) {
	                    return;
	                }
	
	                if (!this.storage.hasOwnProperty(dimensionId)) {
	                    this.storage[dimensionId] = {};
	                }
	
	                if (!this.storage[dimensionId][filter]) {
	                    this.storage[dimensionId][filter] = data;
	                }
	            },
	            getFromStorage: function getFromStorage(dimensionId, filter) {
	                filter = 'cache_' + ((0, _isString2.default)(filter) || (0, _isNumber2.default)(filter) ? filter : '');
	
	                if (this.storage.hasOwnProperty(dimensionId)) {
	                    if (this.storage[dimensionId].hasOwnProperty(filter)) {
	                        return this.storage[dimensionId][filter];
	                    }
	                }
	
	                return;
	            },
	            loadPage: function loadPage(filter, append, noPaging, fn) {
	                var store = this,
	                    params = {},
	                    url,
	                    cacheData;
	
	                filter = filter || dataFilter.getValue() || null;
	
	                // check session cache
	                cacheData = store.getFromStorage(dimension.id, filter);
	
	                if (!append && cacheData) {
	                    store.loadStore(cacheData, {}, append, fn);
	                } else {
	                    if (!append) {
	                        this.lastPage = null;
	                        this.nextPage = 1;
	                    }
	
	                    if (store.nextPage === store.lastPage) {
	                        return;
	                    }
	
	                    url = '/dimensions/' + dimension.id + '/items.json?fields=id,' + displayPropertyUrl + (filter ? '&filter=' + displayProperty + ':ilike:' + filter : '');
	
	                    if (noPaging) {
	                        params.paging = false;
	                    } else {
	                        params.page = store.nextPage;
	                        params.pageSize = 50;
	                    }
	
	                    store.isPending = true;
	                    uiManager.mask(available.boundList);
	
	                    Ext.Ajax.request({
	                        url: encodeURI(apiPath + url),
	                        method: 'GET',
	                        params: params,
	                        success: function success(r) {
	                            var response = Ext.decode(r.responseText),
	                                data = response.items || [],
	                                pager = response.pager;
	
	                            // add to session cache
	                            store.addToStorage(dimension.id, filter, data);
	
	                            store.loadStore(data, pager, append, fn);
	                        },
	                        callback: function callback() {
	                            store.isPending = false;
	                            uiManager.unmask(available.boundList);
	                        }
	                    });
	                }
	            },
	            loadStore: function loadStore(data, pager, append, fn) {
	                pager = pager || {};
	
	                this.loadData(data, append);
	                this.lastPage = this.nextPage;
	
	                if (pager.pageCount > this.nextPage) {
	                    this.nextPage++;
	                }
	
	                this.isPending = false;
	
	                uiManager.msFilterAvailable({ store: availableStore }, { store: selectedStore });
	
	                if (fn) {
	                    fn();
	                }
	            },
	            sortStore: function sortStore() {
	                this.sort('name', 'ASC');
	            }
	        });
	
	        selectedStore = Ext.create('Ext.data.Store', {
	            fields: ['id', 'name'],
	            data: [],
	            listeners: {
	                add: function add() {
	                    onSelect();
	                },
	                remove: function remove() {
	                    onSelect();
	                },
	                clear: function clear() {
	                    onSelect();
	                }
	            }
	        });
	
	        dataLabel = Ext.create('Ext.form.Label', {
	            text: i18n.available,
	            cls: 'ns-toolbar-multiselect-left-label',
	            style: 'margin-right:5px'
	        });
	
	        dataSearch = Ext.create('Ext.button.Button', {
	            width: 22,
	            height: 22,
	            cls: 'ns-button-icon',
	            iconCls: 'ns-button-icon-search',
	            showFilter: function showFilter() {
	                dataLabel.hide();
	                this.hide();
	                dataFilter.show();
	                dataFilter.reset();
	            },
	            hideFilter: function hideFilter() {
	                dataLabel.show();
	                this.show();
	                dataFilter.hide();
	                dataFilter.reset();
	            },
	            handler: function handler() {
	                this.showFilter();
	            }
	        });
	
	        dataFilter = Ext.create('Ext.form.field.Trigger', {
	            cls: 'ns-trigger-filter',
	            emptyText: 'Filter available..',
	            height: 22,
	            hidden: true,
	            enableKeyEvents: true,
	            fieldStyle: 'height:22px; border-right:0 none',
	            style: 'height:22px',
	            onTriggerClick: function onTriggerClick() {
	                this.reset();
	                this.onKeyUpHandler();
	
	                dataSearch.hideFilter();
	            },
	            onKeyUpHandler: function onKeyUpHandler() {
	                var value = this.getValue(),
	                    store = availableStore;
	
	                if ((0, _isString2.default)(value) || (0, _isNumber2.default)(value)) {
	                    store.loadPage(value, false, true);
	                }
	            },
	            listeners: {
	                keyup: {
	                    fn: function fn(cmp) {
	                        cmp.onKeyUpHandler();
	                    },
	                    buffer: 100
	                },
	                show: function show(cmp) {
	                    cmp.focus(false, 50);
	                },
	                focus: function focus(cmp) {
	                    cmp.addCls('ns-trigger-filter-focused');
	                },
	                blur: function blur(cmp) {
	                    cmp.removeCls('ns-trigger-filter-focused');
	                }
	            }
	        });
	
	        selectedAll = Ext.create('Ext.form.field.Checkbox', {
	            cls: 'ns-checkbox',
	            style: 'margin-left: 2px; margin-right: 5px',
	            boxLabel: 'All',
	            listeners: {
	                change: function change(chb, newVal) {
	                    onSelectAll(newVal);
	                }
	            }
	        });
	
	        available = Ext.create('Ext.ux.form.MultiSelect', {
	            cls: 'ns-toolbar-multiselect-left',
	            width: accBaseWidth / 2,
	            valueField: 'id',
	            displayField: 'name',
	            store: availableStore,
	            tbar: [dataLabel, dataSearch, dataFilter, '->', {
	                xtype: 'button',
	                iconCls: 'ns-button-icon-arrowright',
	                width: 22,
	                handler: function handler() {
	                    uiManager.msSelect(available, selected);
	                }
	            }, {
	                xtype: 'button',
	                iconCls: 'ns-button-icon-arrowrightdouble',
	                width: 22,
	                handler: function handler() {
	                    availableStore.loadPage(null, null, true, function () {
	                        uiManager.msSelectAll(available, selected);
	                    });
	                }
	            }],
	            listeners: {
	                render: function render(ms) {
	                    var el = Ext.get(ms.boundList.getEl().id + '-listEl').dom;
	
	                    el.addEventListener('scroll', function (e) {
	                        if (uiManager.isScrolled(e) && !availableStore.isPending) {
	                            availableStore.loadPage(null, true);
	                        }
	                    });
	
	                    ms.boundList.on('itemdblclick', function () {
	                        uiManager.msSelect(available, selected);
	                    }, ms);
	                }
	            }
	        });
	
	        selected = Ext.create('Ext.ux.form.MultiSelect', {
	            cls: 'ns-toolbar-multiselect-right',
	            width: accBaseWidth / 2,
	            valueField: 'id',
	            displayField: 'name',
	            ddReorder: true,
	            store: selectedStore,
	            tbar: [{
	                xtype: 'button',
	                iconCls: 'ns-button-icon-arrowleftdouble',
	                width: 22,
	                handler: function handler() {
	                    uiManager.msUnselectAll(available, selected);
	                }
	            }, {
	                xtype: 'button',
	                iconCls: 'ns-button-icon-arrowleft',
	                width: 22,
	                handler: function handler() {
	                    uiManager.msUnselect(available, selected);
	                }
	            }, '->', {
	                xtype: 'label',
	                text: i18n.selected,
	                cls: 'ns-toolbar-multiselect-right-label'
	            }, selectedAll],
	            listeners: {
	                afterrender: function afterrender() {
	                    this.boundList.on('itemdblclick', function () {
	                        uiManager.msUnselect(available, selected);
	                    }, this);
	                }
	            }
	        });
	
	        onSelectAll = function onSelectAll(value) {
	            if (available.boundList && selected.boundList) {
	                if (value) {
	                    available.boundList.disable();
	                    selected.boundList.disable();
	                } else {
	                    available.boundList.enable();
	                    selected.boundList.enable();
	                }
	            }
	
	            onSelect();
	        };
	
	        panel = Ext.create('Ext.panel.Panel', {
	            title: '<div class="' + iconCls + '">' + dimension.name + '</div>',
	            hideCollapseTool: true,
	            dimension: dimension.id,
	            availableStore: availableStore,
	            selectedStore: selectedStore,
	            selectedAll: selectedAll,
	            isDynamic: true,
	            clearDimension: function clearDimension() {
	                availableStore.reset();
	                selectedStore.removeAll();
	                selectedAll.setValue(false);
	            },
	            setDimension: function setDimension(layout) {
	                if (layout.hasDimension(this.dimension, true)) {
	                    var records = layout.getDimension(this.dimension).getRecords();
	
	                    if (records.length) {
	                        selectedStore.add(records);
	                        uiManager.msFilterAvailable({ store: availableStore }, { store: selectedStore });
	                    } else {
	                        selectedAll.setValue(true);
	                    }
	                }
	            },
	            getDimension: function getDimension() {
	                var config = {};
	
	                if (dimension.id) {
	                    config.dimension = dimension.id;
	                }
	
	                if (!selectedAll.getValue() && selectedStore.getRange().length) {
	                    config.items = [];
	
	                    selectedStore.each(function (r) {
	                        config.items.push({ id: r.data.id });
	                    });
	                }
	
	                return config.dimension ? config : null;
	            },
	            onExpand: function onExpand() {
	
	                // load items
	                if (!availableStore.isLoaded) {
	                    availableStore.loadPage();
	                }
	
	                // enable/disable ui
	                if (selectedAll.getValue()) {
	                    available.boundList.disable();
	                    selected.boundList.disable();
	                }
	
	                // set height
	                var westRegion = uiManager.get('westRegion');
	                var accordion = uiManager.get('accordion');
	
	                var accordionHeight = westRegion.hasScrollbar ? uiConfig.west_scrollbarheight_accordion_group : uiConfig.west_maxheight_accordion_group;
	
	                accordion.setThisHeight(accordionHeight);
	
	                uiManager.msSetHeight([available, selected], this, uiConfig.west_fill_accordion_group);
	            },
	            items: [{
	                xtype: 'panel',
	                layout: 'column',
	                bodyStyle: 'border-style:none',
	                items: [available, selected]
	            }],
	            listeners: {
	                expand: function expand(p) {
	                    p.onExpand();
	                }
	            }
	        });
	
	        return panel;
	    };
	
	    // accordion
	    var defaultItems = [data, period, organisationUnit].concat(_toConsumableArray(appManager.dimensions.map(function (dimension) {
	        var panel = getDimensionPanel(dimension, 'ns-panel-title-dimension');
	
	        accordionPanels.push(uiManager.reg(panel, panel.dimension));
	
	        return panel;
	    })));
	
	    var getItems = function getItems() {
	        var dimensions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
	        return dimensions.map(function (dimension) {
	            return getDimensionPanel(dimension, 'ns-panel-title-dimension');
	        });
	    };
	
	    var accordionBody = Ext.create('Ext.panel.Panel', {
	        layout: 'accordion',
	        activeOnTop: true,
	        cls: 'ns-accordion',
	        bodyStyle: 'border:0 none',
	        height: 700,
	        toBeRemoved: [],
	        addItems: function addItems(dimensions) {
	            this.toBeRemoved = this.add(getItems(dimensions));
	
	            accordion.setThisHeight();
	        },
	        removeItems: function removeItems() {
	            this.toBeRemoved.map(function (item) {
	                return (0, _isString2.default)(item) ? item : item.id;
	            }).forEach(function (id) {
	                accordionBody.remove(id);
	            });
	
	            accordion.setThisHeight();
	
	            this.toBeRemoved = [];
	        },
	        getExpandedPanel: function getExpandedPanel() {
	            var expandedPanel;
	
	            this.items.each(function (panel) {
	                if (!panel.collapsed) {
	                    expandedPanel = panel;
	                    return false;
	                }
	            });
	
	            return expandedPanel;
	        },
	        items: defaultItems
	    });
	
	    // state
	    var setUiState = function setUiState(layout) {
	        var layoutWindow = uiManager.get('layoutWindow'),
	            optionsWindow = uiManager.get('optionsWindow'),
	            chartTypeToolbar = uiManager.get('chartTypeToolbar');
	
	        if (chartTypeToolbar) {
	            chartTypeToolbar.reset();
	        }
	
	        // clear panels
	        accordion.clearDimensions(layout);
	
	        if (layout) {
	            var co = dimensionConfig.get('category');
	
	            // type
	            if (chartTypeToolbar) {
	                chartTypeToolbar.setChartType(layout.type);
	            }
	
	            // panels
	            accordion.setDimensions(layout);
	
	            // layout window
	            if (layoutWindow) {
	                layoutWindow.reset(true);
	                layoutWindow.setDimensions(layout);
	            }
	
	            // add assigned categories as dimension
	            if (!layoutWindow.hasDimension(co.dimensionName)) {
	                layoutWindow.addDimension({
	                    id: co.dimensionName,
	                    name: co.name
	                }, layoutWindow.dimensionStore);
	            }
	
	            // options window
	            if (optionsWindow) {
	                optionsWindow.setOptions(layout);
	            }
	        } else {
	            treePanel.reset();
	            layoutWindow.reset();
	            optionsWindow.reset();
	        }
	    };
	
	    var getUiState = function getUiState(layoutWindow, optionsWindow) {
	        var columnDimNames = layoutWindow.colStore.getDimensionNames(),
	            rowDimNames = layoutWindow.rowStore.getDimensionNames(),
	            filterDimNames = layoutWindow.filterStore.getDimensionNames(),
	            config = optionsWindow.getOptions(),
	            dx = dimensionConfig.get('data').dimensionName,
	            co = dimensionConfig.get('category').dimensionName,
	            nameDimArrayMap = {};
	
	        config.columns = [];
	        config.rows = [];
	        config.filters = [];
	
	        // all panels data
	        accordionBody.items.each(function (panel) {
	            if (panel.getDimension) {
	                var dim = panel.getDimension();
	
	                if (dim && dim.dimension) {
	                    nameDimArrayMap[dim.dimension] = [dim];
	                }
	            }
	        });
	
	        // columns, rows, filters
	        for (var i = 0, nameArrays = [columnDimNames, rowDimNames, filterDimNames], axes = [config.columns, config.rows, config.filters], dimNames; i < nameArrays.length; i++) {
	            dimNames = nameArrays[i];
	
	            for (var j = 0, dimName, dim; j < dimNames.length; j++) {
	                dimName = dimNames[j];
	
	                if (dimName === co) {
	                    axes[i].push({
	                        dimension: co,
	                        items: []
	                    });
	                } else if (dimName === dx && nameDimArrayMap.hasOwnProperty(dimName) && nameDimArrayMap[dimName]) {
	                    for (var k = 0; k < nameDimArrayMap[dx].length; k++) {
	                        axes[i].push(Ext.clone(nameDimArrayMap[dx][k]));
	
	                        // TODO program
	                        if (nameDimArrayMap[dx][k].program) {
	                            config.program = nameDimArrayMap[dx][k].program;
	                        }
	                    }
	                } else if (nameDimArrayMap.hasOwnProperty(dimName) && nameDimArrayMap[dimName]) {
	                    for (var k = 0; k < nameDimArrayMap[dimName].length; k++) {
	                        axes[i].push(Ext.clone(nameDimArrayMap[dimName][k]));
	                    }
	                }
	            }
	        }
	
	        return config;
	    };
	
	    // add listeners
	    (function () {
	        indicatorAvailableStore.on('load', function () {
	            uiManager.msFilterAvailable(indicatorAvailable, indicatorSelected);
	        });
	
	        dataElementAvailableStore.on('load', function () {
	            uiManager.msFilterAvailable(dataElementAvailable, dataElementSelected);
	        });
	
	        dataSetAvailableStore.on('load', function (store) {
	            uiManager.msFilterAvailable(dataSetAvailable, dataSetSelected);
	            store.sort('name', 'ASC');
	        });
	    })();
	
	    var accordion = Ext.create('Ext.panel.Panel', (_Ext$create = {
	        bodyStyle: 'border-style:none; border-top:1px solid #e1e1e1; padding:1px; padding-bottom:0; overflow-y:scroll;',
	        accordionBody: accordionBody,
	        items: accordionBody,
	        panels: accordionPanels,
	        expandInitPanels: function expandInitPanels() {
	            organisationUnit.expand();
	        },
	        clearDimensions: function clearDimensions(layout) {
	            accordionPanels.forEach(function (panel) {
	                panel.clearDimension(!!layout);
	            });
	        },
	        setDimensions: function setDimensions(layout) {
	            accordionPanels.forEach(function (panel) {
	                panel.setDimension(layout);
	            });
	        },
	        setThisHeight: function setThisHeight(mx) {
	            var westRegion = uiManager.get('westRegion'),
	                panelHeight = this.panels.length * 28,
	                chartTypeToolbarHeight = westRegion.hasChartTypeToolbar() ? 45 : 0,
	                height;
	
	            if (westRegion.hasScrollbar) {
	                height = panelHeight + mx;
	                this.setHeight(westRegion.getHeight() - chartTypeToolbarHeight - 2);
	                accordionBody.setHeight(height - 2);
	            } else {
	                height = westRegion.getHeight() - uiConfig.west_fill;
	                mx += panelHeight;
	                accordion.setHeight((height > mx ? mx : height) - 2);
	                accordionBody.setHeight((height > mx ? mx : height) - 4);
	            }
	        },
	        getExpandedPanel: function getExpandedPanel() {
	            return accordionBody.getExpandedPanel();
	        },
	        getFirstPanel: function getFirstPanel() {
	            return this.panels[0];
	        },
	        getParentGraphMap: function getParentGraphMap() {
	            return treePanel.getParentGraphMap();
	        },
	        getUxArray: function getUxArray(id) {
	            return dataElementSelected.getUxArrayById(id);
	        }
	
	    }, _defineProperty(_Ext$create, 'accordionBody', accordionBody), _defineProperty(_Ext$create, 'panels', accordionPanels), _defineProperty(_Ext$create, 'treePanel', treePanel), _defineProperty(_Ext$create, 'getUiState', getUiState), _defineProperty(_Ext$create, 'setUiState', setUiState), _Ext$create));
	
	    return accordion;
	};
	//# sourceMappingURL=WestRegionAggregateItems.js.map

/***/ },
/* 171 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.WestRegionTrackerItems = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _clone = __webpack_require__(29);
	
	var _clone2 = _interopRequireDefault(_clone);
	
	var _arrayClean = __webpack_require__(9);
	
	var _arrayClean2 = _interopRequireDefault(_arrayClean);
	
	var _arrayContains = __webpack_require__(4);
	
	var _arrayContains2 = _interopRequireDefault(_arrayContains);
	
	var _arrayFrom = __webpack_require__(5);
	
	var _arrayFrom2 = _interopRequireDefault(_arrayFrom);
	
	var _arrayPluck = __webpack_require__(28);
	
	var _arrayPluck2 = _interopRequireDefault(_arrayPluck);
	
	var _arraySort = __webpack_require__(10);
	
	var _arraySort2 = _interopRequireDefault(_arraySort);
	
	var _isArray = __webpack_require__(1);
	
	var _isArray2 = _interopRequireDefault(_isArray);
	
	var _isBoolean = __webpack_require__(15);
	
	var _isBoolean2 = _interopRequireDefault(_isBoolean);
	
	var _isNumber = __webpack_require__(7);
	
	var _isNumber2 = _interopRequireDefault(_isNumber);
	
	var _isObject = __webpack_require__(2);
	
	var _isObject2 = _interopRequireDefault(_isObject);
	
	var _isString = __webpack_require__(3);
	
	var _isString2 = _interopRequireDefault(_isString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var WestRegionTrackerItems = exports.WestRegionTrackerItems = undefined;
	
	exports.WestRegionTrackerItems = WestRegionTrackerItems = function WestRegionTrackerItems(refs) {
	    var _Ext$create;
	
	    var t = this,
	        uiManager = refs.uiManager,
	        instanceManager = refs.instanceManager,
	        appManager = refs.appManager,
	        i18nManager = refs.i18nManager,
	        sessionStorageManager = refs.sessionStorageManager,
	        calendarManager = refs.calendarManager,
	        dimensionConfig = refs.dimensionConfig,
	        periodConfig = refs.periodConfig,
	        uiConfig = refs.uiConfig,
	        optionConfig = refs.optionConfig,
	        api = refs.api;
	
	    var dataObjectName = dimensionConfig.get('data').objectName,
	        indicatorObjectName = dimensionConfig.get('indicator').objectName,
	        dataElementObjectName = dimensionConfig.get('dataElement').objectName,
	        operandObjectName = dimensionConfig.get('operand').objectName,
	        dataSetObjectName = dimensionConfig.get('dataSet').objectName,
	        eventDataItemObjectName = dimensionConfig.get('eventDataItem').objectName,
	        programIndicatorObjectName = dimensionConfig.get('programIndicator').objectName,
	        periodObjectName = dimensionConfig.get('period').objectName,
	        organisationUnitObjectName = dimensionConfig.get('organisationUnit').objectName,
	        i18n = i18nManager.get(),
	        path = appManager.getPath(),
	        apiPath = appManager.getApiPath(),
	        displayProperty = appManager.getDisplayProperty(),
	        displayPropertyUrl = appManager.getDisplayPropertyUrl(),
	        dimensionPanelMap = {},
	        dimensionIdAvailableStoreMap = {},
	        dimensionIdSelectedStoreMap = {},
	        accordionPanels = [],
	        programStorage = {},
	        stageStorage = {},
	        attributeStorage = {},
	        programIndicatorStorage = {},
	        dataElementStorage = {},
	        baseWidth = 448,
	        accBaseWidth = baseWidth - 2,
	        toolWidth = 36,
	        nextButtonWidth = 62;
	
	    // stores
	
	    var programStore = Ext.create('Ext.data.Store', {
	        fields: ['id', 'name'],
	        proxy: {
	            type: 'ajax',
	            url: encodeURI(apiPath + '/programs.json?fields=id,' + displayPropertyUrl + '&paging=false'),
	            reader: {
	                type: 'json',
	                root: 'programs'
	            },
	            pageParam: false,
	            startParam: false,
	            limitParam: false
	        },
	        sortInfo: { field: 'name', direction: 'ASC' },
	        isLoaded: false,
	        listeners: {
	            load: function load() {
	                if (!this.isLoaded) {
	                    this.isLoaded = true;
	                }
	            }
	        }
	    });
	
	    var stagesByProgramStore = Ext.create('Ext.data.Store', {
	        fields: ['id', 'name'],
	        isLoaded: false,
	        listeners: {
	            load: function load() {
	                if (!this.isLoaded) {
	                    this.isLoaded = true;
	                }
	                this.sort('name', 'ASC');
	            }
	        }
	    });
	
	    var dataElementsByStageStore = Ext.create('Ext.data.Store', {
	        fields: ['id', 'name', 'isAttribute', 'isProgramIndicator'],
	        data: [],
	        sorters: [{
	            property: 'name',
	            direction: 'ASC'
	        }],
	        onLoadData: function onLoadData() {
	            var layoutWindow = uiManager.get('aggregateLayoutWindow');
	            var numericValueTypes = dimensionConfig.valueType['numeric_types'];
	
	            // add to layout value store
	            this.each(function (record) {
	                if ((0, _arrayContains2.default)(numericValueTypes, record.data.valueType)) {
	                    layoutWindow.valueStore.add(record.data);
	                }
	            });
	
	            this.toggleProgramIndicators();
	        },
	        toggleProgramIndicators: function toggleProgramIndicators(type) {
	            var dataTypeToolbar = uiManager.get('dataTypeToolbar');
	
	            type = type || (dataTypeToolbar ? dataTypeToolbar.getDataType() : null);
	
	            this.clearFilter();
	
	            if (uiManager.disallowProgramIndicators || type === dimensionConfig.dataType['aggregated_values']) {
	                // reset to all to avoid the situation where in ER if PI is selected is shown
	                // as selected also when switching to the aggregate tab
	                dataElementType.select('all');
	                dataElementType.store.filterBy(function (record) {
	                    return record.data.id != 'pi';
	                });
	
	                this.filterBy(function (record) {
	                    return !record.data.isProgramIndicator;
	                });
	            } else {
	                dataElementType.store.clearFilter();
	            }
	        }
	    });
	
	    var organisationUnitGroupStore = Ext.create('Ext.data.Store', {
	        fields: ['id', 'name'],
	        proxy: {
	            type: 'ajax',
	            url: encodeURI(apiPath + '/organisationUnitGroups.json?fields=id,' + displayPropertyUrl + '&paging=false'),
	            reader: {
	                type: 'json',
	                root: 'organisationUnitGroups'
	            }
	        }
	    });
	
	    var periodTypeStore = Ext.create('Ext.data.Store', {
	        fields: ['id', 'name'],
	        data: periodConfig.getPeriodTypeRecords()
	    });
	
	    var fixedPeriodAvailableStore = Ext.create('Ext.data.Store', {
	        fields: ['id', 'name', 'index'],
	        data: [],
	        setIndex: function setIndex(periods) {
	            for (var i = 0; i < periods.length; i++) {
	                periods[i].index = i;
	            }
	        },
	        sortStore: function sortStore() {
	            this.sort('index', 'ASC');
	        }
	    });
	
	    var fixedPeriodSelectedStore = Ext.create('Ext.data.Store', {
	        fields: ['id', 'name'],
	        data: []
	    });
	
	    // components
	    var onTypeClick = function onTypeClick(type) {
	        // available
	        dataElementsByStageStore.toggleProgramIndicators(type);
	
	        // selected
	        dataElementSelected.toggleProgramIndicators(type);
	    };
	
	    var setData = function setData(layout) {
	        // wait, more dynamic dimensions could be added by program
	        //accordion.setDimensions(layout, true);
	
	        // data items
	        onProgramSelect(null, layout);
	    };
	
	    var program = Ext.create('Ext.form.field.ComboBox', {
	        editable: false,
	        valueField: 'id',
	        displayField: 'name',
	        fieldLabel: 'Program',
	        labelAlign: 'top',
	        labelCls: 'ns-form-item-label-top',
	        labelSeparator: '',
	        emptyText: 'Select program',
	        forceSelection: true,
	        queryMode: 'remote',
	        columnWidth: 0.5,
	        style: 'margin:1px 1px 1px 0',
	        storage: {},
	        store: programStore,
	        getRecord: function getRecord() {
	            return this.getValue ? {
	                id: this.getValue(),
	                name: this.getRawValue()
	            } : null;
	        },
	        listeners: {
	            select: function select(cb) {
	                onProgramSelect(cb.getValue());
	            }
	        }
	    });
	
	    var onProgramSelect = function onProgramSelect(programId, layout) {
	        var DEFAULT = 'default';
	        var ATTRIBUTE = 'ATTRIBUTE';
	
	        programId = programId || (layout ? layout.program.id : null);
	
	        if (!programId) {
	            return;
	        }
	
	        // reset
	        stage.clearValue();
	        dataElementsByStageStore.removeAll();
	        dataElementSelected.removeAllDataElements(true);
	        uiManager.get('aggregateLayoutWindow').value.resetData();
	
	        var getCategories = function getCategories(categoryCombo) {
	            if (!((0, _isObject2.default)(categoryCombo) && (0, _isArray2.default)(categoryCombo.categories) && categoryCombo.categories.length)) {
	                return;
	            }
	
	            var categories = categoryCombo.categories.filter(function (c) {
	                return c.name !== DEFAULT;
	            });
	
	            categories.forEach(function (c) {
	                c.items = c.categoryOptions;
	
	                if ((0, _isArray2.default)(c.items)) {
	                    (0, _arraySort2.default)(c.items);
	                }
	            });
	
	            return categories;
	        };
	
	        var load = function load(_program) {
	            var stages = _program.programStages;
	            var dimensions = [];
	
	            // categories
	            dimensions = dimensions.concat(getCategories(_program.categoryCombo) || []);
	
	            // categoryOptionGroupSets
	            if (_program.categoryCombo.name !== DEFAULT) {
	                dimensions = dimensions.concat(appManager.categoryOptionGroupSets.filter(function (groupSet) {
	                    return groupSet.dataDimensionType === ATTRIBUTE;
	                }) || []);
	            }
	
	            // remove and add dynamic program related dimensions
	            accordionBody.removeItems();
	            accordionBody.addItems((0, _arraySort2.default)((0, _arrayClean2.default)(dimensions)));
	
	            // restore dynamic dimensions
	            if (layout) {
	                accordion.setDimensions(layout, true);
	            }
	
	            // stages
	            stage.enable();
	            stage.clearValue();
	
	            stagesByProgramStore.removeAll();
	            stagesByProgramStore.loadData(stages);
	
	            var stageId = (layout ? layout.programStage.id : null) || (stages.length === 1 ? stages[0].id : null);
	
	            if (stageId) {
	                stage.setValue(stageId);
	                onStageSelect(stageId, layout);
	            }
	        };
	
	        if (programStorage[programId]) {
	            load(programStorage[programId]);
	        } else {
	            new api.Request(refs, {
	                baseUrl: appManager.getApiPath() + '/programs.json',
	                type: 'json',
	                params: ['filter=id:eq:' + programId, ['fields=programStages[id,displayName~rename(name)]', 'programIndicators[id,' + displayPropertyUrl + ']', 'programTrackedEntityAttributes[trackedEntityAttribute[id,' + displayPropertyUrl + ',valueType,confidential,optionSet[id,displayName~rename(name)],legendSets~rename(storageLegendSets)[id,displayName~rename(name)]]]', 'categoryCombo[id,name,categories[id,' + displayPropertyUrl + ',categoryOptions[id,' + displayPropertyUrl + ']]]'].join(''), 'paging=false'],
	                success: function success(r) {
	                    var _program = r.programs[0];
	
	                    if (!_program) {
	                        return;
	                    }
	
	                    // program stages
	                    _program.programStages.forEach(function (stage) {
	                        stage.isProgramStage = true;
	                    });
	
	                    // attributes
	                    _program.attributes = (0, _arrayPluck2.default)(_program.programTrackedEntityAttributes, 'trackedEntityAttribute').filter(function (attribute) {
	                        attribute.isAttribute = true;
	                        attribute.name = '[PA] ' + attribute.name;
	                        return !attribute.confidential;
	                    });
	
	                    // mark as program indicator
	                    _program.programIndicators.forEach(function (item) {
	                        item.name = '[PI] ' + item.name;
	                        item.isProgramIndicator = true;
	                    });
	
	                    if ((0, _isArray2.default)(_program.programStages) && _program.programStages.length) {
	                        // program cache
	                        programStorage[programId] = _program;
	
	                        load(_program);
	                    }
	                }
	            }).run();
	        }
	    };
	
	    var stage = Ext.create('Ext.form.field.ComboBox', {
	        editable: false,
	        valueField: 'id',
	        displayField: 'name',
	        fieldLabel: 'Stage',
	        labelAlign: 'top',
	        labelCls: 'ns-form-item-label-top',
	        labelSeparator: '',
	        emptyText: 'Select stage',
	        queryMode: 'local',
	        forceSelection: true,
	        columnWidth: 0.5,
	        style: 'margin:1px 0 1px 0',
	        disabled: true,
	        listConfig: { loadMask: false },
	        store: stagesByProgramStore,
	        getRecord: function getRecord() {
	            return this.getValue() ? {
	                id: this.getValue(),
	                name: this.getRawValue()
	            } : null;
	        },
	        listeners: {
	            select: function select(cb) {
	                onStageSelect(cb.getValue());
	            }
	        }
	    });
	
	    var onStageSelect = function onStageSelect(stageId, layout) {
	        if (!layout) {
	            dataElementSelected.removeAllDataElements(true);
	            uiManager.get('aggregateLayoutWindow').value.resetData();
	        }
	
	        dataElementType.enable();
	        dataElementSearch.enable();
	        dataElementSearch.hideFilter();
	
	        loadDataElements(stageId, layout);
	    };
	
	    var loadDataElements = function loadDataElements(stageId, layout) {
	        var programId = layout ? layout.program.id : program.getValue() || null;
	
	        var _program = programStorage[programId];
	
	        var dataItems = (0, _arrayClean2.default)([].concat(_program.attributes || [], _program.programIndicators || []));
	
	        stageId = stageId || layout.programStage.id;
	
	        var load = function load(dataElements) {
	            var data = (0, _arrayClean2.default)(dataItems.concat(dataElements || []));
	
	            dataElementsByStageStore.loadData(data);
	            dataElementsByStageStore.onLoadData();
	
	            if (layout) {
	                var dataDimensions = layout ? layout.getDimensions(true).filter(function (dim) {
	                    return !(0, _arrayContains2.default)(['pe', 'ou'], dim.dimension);
	                }) : [],
	                    records = [];
	
	                for (var i = 0, dim, row; i < dataDimensions.length; i++) {
	                    dim = dataDimensions[i];
	                    row = dataElementsByStageStore.getById(dim.dimension);
	
	                    if (row) {
	                        records.push(Ext.applyIf(dim, row.data));
	                    }
	                }
	
	                selectDataElements(records, layout);
	            }
	        };
	
	        // data elements
	        if (dataElementStorage.hasOwnProperty(stageId)) {
	            load(dataElementStorage[stageId]);
	        } else {
	            new api.Request(refs, {
	                baseUrl: appManager.getApiPath() + '/programStages.json',
	                type: 'json',
	                params: ['filter=id:eq:' + stageId, 'fields=programStageDataElements[dataElement[id,' + displayPropertyUrl + ',valueType,optionSet[id,displayName~rename(name)],legendSets~rename(storageLegendSets)[id,displayName~rename(name)]]]', 'paging=false'],
	                success: function success(r) {
	                    var stages = r.programStages,
	                        types = dimensionConfig.valueType['tracker_aggregatable_types'];
	
	                    if (!stages.length) {
	                        load();
	                        return;
	                    }
	
	                    var include = function include(element) {
	                        return (0, _arrayContains2.default)(types, element.valueType) || (0, _isObject2.default)(element.optionSet) || (0, _isArray2.default)(element.legendSets || element.storageLegendSets);
	                    };
	
	                    // filter by type
	                    var dataElements = (0, _arrayPluck2.default)(stages[0].programStageDataElements, 'dataElement').filter(function (dataElement) {
	                        dataElement.isDataElement = true;
	                        dataElement.name = '[DE] ' + dataElement.name;
	                        return include(dataElement);
	                    });
	
	                    // data elements cache
	                    dataElementStorage[stageId] = dataElements;
	
	                    load(dataElements);
	                }
	            }).run();
	        }
	    };
	
	    // DHIS2-1496: filter by data element, program attribute or program indicator
	    var dataElementType = Ext.create('Ext.form.field.ComboBox', {
	        editable: false,
	        valueField: 'id',
	        displayField: 'name',
	        queryMode: 'local',
	        lastQuery: '',
	        width: accBaseWidth / 2 - 32,
	        disabled: true,
	        listConfig: { loadMask: false },
	        style: 'padding-bottom:1px; border-bottom:1px solid #ddd; margin-bottom:1px',
	        value: 'all',
	        store: {
	            fields: ['id', 'name'],
	            data: [{ id: 'all', name: 'All' }, { id: 'de', name: 'Data elements' }, { id: 'pa', name: 'Program attributes' }, { id: 'pi', name: 'Program indicators' }]
	        },
	        reset: function reset() {
	            onDataElementTypeSelect('all');
	        },
	        listeners: {
	            select: function select(cmp) {
	                onDataElementTypeSelect(cmp.getValue());
	            }
	        }
	    });
	
	    var onDataElementTypeSelect = function onDataElementTypeSelect(type) {
	        dataElementType.setValue(type);
	
	        var store = dataElementsByStageStore;
	
	        switch (type) {
	            case 'all':
	                store.clearFilter();
	
	                // filter out PI if in aggregated tab
	                if (uiManager.disallowProgramIndicators || uiManager.get('dataTypeToolbar').getDataType() === dimensionConfig.dataType['aggregated_values']) {
	                    store.filterBy(function (record) {
	                        return !record.data.isProgramIndicator;
	                    });
	                }
	                break;
	            case 'de':
	                store.filterBy(function (record) {
	                    return !record.data.isAttribute && !record.data.isProgramIndicator;
	                });
	                break;
	            case 'pa':
	                store.filterBy(function (record) {
	                    return record.data.isAttribute;
	                });
	                break;
	            case 'pi':
	                store.filterBy(function (record) {
	                    return record.data.isProgramIndicator;
	                });
	                break;
	        }
	    };
	
	    var dataElementLabel = Ext.create('Ext.form.Label', {
	        width: accBaseWidth / 2 - 32,
	        text: i18n.available,
	        cls: 'ns-toolbar-multiselect-left-label',
	        style: 'margin-right:5px'
	    });
	
	    var dataElementSearch = Ext.create('Ext.button.Button', {
	        width: 22,
	        height: 22,
	        cls: 'ns-button-icon',
	        iconCls: 'ns-button-icon-search',
	        disabled: true,
	        showFilter: function showFilter() {
	            dataElementLabel.hide();
	            this.hide();
	            dataElementFilter.show();
	            dataElementFilter.reset();
	        },
	        hideFilter: function hideFilter() {
	            dataElementLabel.show();
	            this.show();
	            dataElementFilter.hide();
	            dataElementFilter.reset();
	        },
	        handler: function handler() {
	            this.showFilter();
	        }
	    });
	
	    var dataElementFilter = Ext.create('Ext.form.field.Trigger', {
	        cls: 'ns-trigger-filter',
	        emptyText: 'Filter available...',
	        height: 22,
	        width: accBaseWidth / 2 - 5,
	        hidden: true,
	        enableKeyEvents: true,
	        fieldStyle: 'height:22px; border-right:0 none',
	        style: 'height:22px',
	        onTriggerClick: function onTriggerClick() {
	            if (this.getValue()) {
	                this.reset();
	                this.onKeyUpHandler();
	            }
	
	            dataElementSearch.hideFilter();
	        },
	        onKeyUpHandler: function onKeyUpHandler() {
	            var store = dataElementsByStageStore,
	                value = this.getValue(),
	                name;
	
	            if (value === '') {
	                store.clearFilter();
	                return;
	            }
	
	            store.filterBy(function (r) {
	                name = r.data.name || '';
	                return name.toLowerCase().indexOf(value.toLowerCase()) !== -1;
	            });
	        },
	        listeners: {
	            keyup: {
	                fn: function fn(cmp) {
	                    cmp.onKeyUpHandler();
	                },
	                buffer: 100
	            },
	            show: function show(cmp) {
	                cmp.focus(false, 50);
	            },
	            focus: function focus(cmp) {
	                cmp.addCls('ns-trigger-filter-focused');
	            },
	            blur: function blur(cmp) {
	                cmp.removeCls('ns-trigger-filter-focused');
	            }
	        }
	    });
	
	    var dataElementAvailable = Ext.create('Ext.ux.form.MultiSelect', {
	        cls: 'ns-toolbar-multiselect-left',
	        width: accBaseWidth,
	        height: 180,
	        valueField: 'id',
	        displayField: 'name',
	        style: 'margin-bottom:1px',
	        store: dataElementsByStageStore,
	        tbar: [dataElementLabel, dataElementSearch, dataElementFilter, dataElementType, '->', {
	            xtype: 'button',
	            iconCls: 'ns-button-icon-arrowdown',
	            width: 22,
	            height: 22,
	            handler: function handler() {
	                if (dataElementAvailable.getValue().length) {
	                    selectDataElements(dataElementAvailable.getValue());
	                }
	            }
	        }],
	        listeners: {
	            afterrender: function afterrender(ms) {
	                this.boundList.on('itemdblclick', function () {
	                    if (ms.getValue().length) {
	                        selectDataElements(ms.getValue());
	                    }
	                });
	            }
	        }
	    });
	
	    var dataElementSelected = Ext.create('Ext.panel.Panel', {
	        width: accBaseWidth,
	        height: 242,
	        bodyStyle: 'padding-left:1px',
	        autoScroll: true,
	        tbar: [{
	            xtype: 'label',
	            text: 'Selected data items',
	            style: 'padding-left:6px; color:#333',
	            cls: 'ns-toolbar-multiselect-left-label'
	        }, '->', {
	            xtype: 'button',
	            iconCls: 'ns-button-icon-arrowupdouble',
	            width: 22,
	            height: 22,
	            handler: function handler() {
	                dataElementSelected.removeAllDataElements();
	            }
	        }],
	        getChildIndex: function getChildIndex(child) {
	            var items = this.items.items;
	
	            for (var i = 0; i < items.length; i++) {
	                if (items[i].id === child.id) {
	                    return i;
	                }
	            }
	
	            return items.length;
	        },
	        hasDataElement: function hasDataElement(dataElementId) {
	            var hasDataElement = false;
	
	            this.items.each(function (item) {
	                if (item.dataElement.id === dataElementId) {
	                    hasDataElement = true;
	                }
	            });
	
	            return hasDataElement;
	        },
	        getUxArrayById: function getUxArrayById(dataElementId) {
	            var uxArray = [];
	
	            this.items.each(function (item) {
	                if (item.dataElement.id === dataElementId) {
	                    uxArray.push(item);
	                }
	            });
	
	            return uxArray;
	        },
	        removeAllDataElements: function removeAllDataElements(reset) {
	            var items = this.items.items,
	                len = items.length;
	
	            for (var i = 0; i < len; i++) {
	                items[0].removeDataElement(reset);
	            }
	        },
	        toggleProgramIndicators: function toggleProgramIndicators(type) {
	            this.items.each(function (item) {
	                if (type === dimensionConfig.dataType['aggregated_values'] && item.isProgramIndicator) {
	                    item.disable();
	                } else {
	                    item.enable();
	                }
	            });
	        }
	    });
	
	    var addUxFromDataElement = function addUxFromDataElement(element, index) {
	        var aggWindow = uiManager.get('aggregateLayoutWindow'),
	            queryWindow = uiManager.get('queryLayoutWindow');
	
	        index = index || dataElementSelected.items.items.length;
	
	        var getUxType = function getUxType(element) {
	            var valueTypes = dimensionConfig.valueType;
	
	            if ((0, _isObject2.default)(element.optionSet) && (0, _isString2.default)(element.optionSet.id)) {
	                return 'Ext.ux.container.GroupSetContainer';
	            }
	
	            if ((0, _arrayContains2.default)(valueTypes['numeric_types'], element.valueType)) {
	                return 'Ext.ux.container.DataElementIntegerContainer';
	            }
	
	            if ((0, _arrayContains2.default)(valueTypes['text_types'], element.valueType)) {
	                return 'Ext.ux.container.DataElementStringContainer';
	            }
	
	            if ((0, _arrayContains2.default)(valueTypes['date_types'], element.valueType)) {
	                return 'Ext.ux.container.DataElementDateContainer';
	            }
	
	            if ((0, _arrayContains2.default)(valueTypes['boolean_types'], element.valueType)) {
	                return 'Ext.ux.container.DataElementBooleanContainer';
	            }
	
	            return 'Ext.ux.container.DataElementIntegerContainer';
	        };
	
	        // add
	        var ux = dataElementSelected.insert(index, Ext.create(getUxType(element), {
	            dataElement: element
	        }));
	
	        ux.isAttribute = element.isAttribute;
	        ux.isProgramIndicator = element.isProgramIndicator;
	        ux.isDataElement = element.isDataElement;
	
	        ux.removeDataElement = function (reset) {
	            dataElementSelected.remove(ux);
	
	            if (!dataElementSelected.hasDataElement(element.id)) {
	                if (!reset) {
	                    dataElementsByStageStore.add(element);
	                    dataElementsByStageStore.sort();
	                }
	
	                aggWindow.removeDimension(element.id, aggWindow.valueStore);
	
	                if (queryWindow) {
	                    queryWindow.removeDimension(element.id);
	                }
	            }
	        };
	
	        ux.duplicateDataElement = function () {
	            var index = dataElementSelected.getChildIndex(ux) + 1;
	            addUxFromDataElement(element, index);
	        };
	
	        dataElementsByStageStore.removeAt(dataElementsByStageStore.findExact('id', element.id));
	
	        return ux;
	    };
	
	    var selectDataElements = function selectDataElements(items, layout) {
	        var dataElements = [],
	            allElements = [],
	            aggWindow = uiManager.get('aggregateLayoutWindow'),
	            queryWindow = uiManager.get('queryLayoutWindow'),
	            includeKeys = dimensionConfig.valueType['tracker_aggregatable_types'],
	            ignoreKeys = ['pe', 'ou'],
	            recordMap = dimensionConfig.getObjectNameMap(),
	            extendDim = function extendDim(dim) {
	            dim.id = dim.id || dim.dimension;
	            dim.name = dim.name || layout ? layout.getResponse().getNameById(dim.dimension) : null || recordMap[dim.dimension].name;
	
	            return dim;
	        };
	
	        // data element objects
	        for (var i = 0, item; i < items.length; i++) {
	            item = items[i];
	
	            if ((0, _isString2.default)(item)) {
	                dataElements.push(dataElementsByStageStore.getById(item).data);
	            } else if ((0, _isObject2.default)(item)) {
	                if (item.data) {
	                    dataElements.push(item.data);
	                } else {
	                    dataElements.push(item);
	                }
	            }
	        }
	
	        // expand if multiple filter
	        for (var i = 0, element, a, numberOfElements; i < dataElements.length; i++) {
	            element = dataElements[i];
	            allElements.push(element);
	
	            if ((0, _arrayContains2.default)(dimensionConfig.valueType['numeric_types'], element.valueType) && element.filter) {
	                a = element.filter.split(':');
	                numberOfElements = a.length / 2;
	
	                if (numberOfElements > 1) {
	                    a.shift();
	                    a.shift();
	
	                    for (var j = 1, newElement; j < numberOfElements; j++) {
	                        //newElement = Ext.clone(element);
	                        newElement = _extends({}, element);
	                        newElement.filter = a.shift();
	                        newElement.filter += ':' + a.shift();
	
	                        allElements.push(newElement);
	                    }
	                }
	            }
	        }
	
	        // panel, store
	        for (var i = 0, element, ux, store; i < allElements.length; i++) {
	            element = allElements[i];
	            element.name = element.name || element.displayName;
	            recordMap[element.id] = element;
	
	            // dont create ux if dim is selected as value
	            if (element.id !== aggWindow.value.getValue()) {
	                ux = addUxFromDataElement(element);
	
	                if (layout) {
	                    ux.setRecord(element);
	                }
	            }
	
	            store = (0, _arrayContains2.default)(includeKeys, element.valueType) || element.optionSet ? aggWindow.getDefaultStore() : aggWindow.fixedFilterStore;
	
	            aggWindow.addDimension(element, store, aggWindow.valueStore);
	
	            if (queryWindow) {
	                queryWindow.colStore.add(element);
	            }
	        }
	
	        // favorite
	        if (layout && layout.dataType !== dimensionConfig.dataType['individual_cases']) {
	            aggWindow.reset(true, true);
	
	            // start end dates
	            if (layout.startDate && layout.endDate) {
	                aggWindow.fixedFilterStore.add({
	                    id: dimensionConfig.get('startEndDate').value,
	                    name: dimensionConfig.get('startEndDate').name
	                });
	            }
	
	            // columns
	            if (layout.columns) {
	                for (var i = 0, record, dim; i < layout.columns.length; i++) {
	                    dim = _extends({}, layout.columns[i]);
	                    record = recordMap[dim.dimension];
	
	                    aggWindow.colStore.add(record || extendDim(dim));
	                }
	            }
	
	            // rows
	            if (layout.rows) {
	                for (var i = 0, record, dim; i < layout.rows.length; i++) {
	                    dim = _extends({}, layout.rows[i]);
	                    record = recordMap[dim.dimension];
	
	                    aggWindow.rowStore.add(record || extendDim(dim));
	                }
	            }
	
	            // filters
	            if (layout.filters) {
	                for (var i = 0, store, record, dim; i < layout.filters.length; i++) {
	                    dim = _extends({}, layout.filters[i]);
	                    record = recordMap[dim.dimension];
	                    store = (0, _arrayContains2.default)(includeKeys, element.valueType) || element.optionSet ? aggWindow.filterStore : aggWindow.fixedFilterStore;
	
	                    store.add(record || extendDim(dim));
	                }
	            }
	
	            // value
	            if (layout.value && layout.aggregationType) {
	                aggWindow.setValueConfig(layout.value.id, layout.aggregationType);
	            }
	
	            // collapse data dimensions
	            if (aggWindow.collapseDataDimensions) {
	                aggWindow.collapseDataDimensions.setValue(layout.collapseDataDimensions);
	                aggWindow.onCollapseDataDimensionsChange(layout.collapseDataDimensions);
	            }
	        }
	    };
	
	    var programStagePanel = Ext.create('Ext.panel.Panel', {
	        layout: 'column',
	        bodyStyle: 'border:0 none',
	        style: 'margin-top:2px',
	        items: [program, stage]
	    });
	
	    var data = Ext.create('Ext.panel.Panel', {
	        title: '<div class="ns-panel-title-data">' + i18n.data + '</div>',
	        cls: 'ns-accordion-first',
	        bodyStyle: 'padding:1px',
	        hideCollapseTool: true,
	        dimension: dimensionConfig.get('data').objectName,
	        items: [programStagePanel, dataElementAvailable, dataElementSelected],
	        setDimension: function setDimension(layout) {
	            setData(layout);
	        },
	        clearDimension: function clearDimension() {
	            program.clearValue();
	            stage.clearValue();
	
	            dataElementsByStageStore.removeAll();
	            dataElementSelected.removeAll();
	
	            dataElementSearch.hideFilter();
	        },
	        getHeightValue: function getHeightValue() {
	            var westRegion = uiManager.get('westRegion');
	
	            return westRegion.hasScrollbar ? uiConfig.west_scrollbarheight_accordion_indicator : uiConfig.west_maxheight_accordion_indicator;
	        },
	        onExpand: function onExpand() {
	            accordion.setThisHeight(this.getHeightValue());
	
	            var msHeight = this.getHeight() - 28 - programStagePanel.getHeight() - 6;
	
	            dataElementAvailable.setHeight(msHeight * 0.4);
	            dataElementSelected.setHeight(msHeight * 0.6 - 1);
	        },
	        listeners: {
	            expand: function expand(cmp) {
	                cmp.onExpand();
	            }
	        }
	    });
	    accordionPanels.push(uiManager.reg(data, 'data'));
	
	    // dates
	    var periodMode = Ext.create('Ext.form.field.ComboBox', {
	        editable: false,
	        valueField: 'id',
	        displayField: 'name',
	        queryMode: 'local',
	        width: accBaseWidth,
	        listConfig: { loadMask: false },
	        style: 'padding-bottom:1px; border-bottom:1px solid #ddd; margin-bottom:1px',
	        value: 'periods',
	        store: {
	            fields: ['id', 'name'],
	            data: [{ id: 'periods', name: 'Fixed and relative periods' }, { id: 'dates', name: 'Start/end dates' }]
	        },
	        reset: function reset() {
	            onPeriodModeSelect('periods');
	        },
	        listeners: {
	            select: function select(cmp) {
	                onPeriodModeSelect(cmp.getValue());
	            }
	        }
	    });
	
	    var onPeriodModeSelect = function onPeriodModeSelect(mode) {
	        var aggregateLayoutWindow = uiManager.get('aggregateLayoutWindow');
	
	        periodMode.setValue(mode);
	
	        if (mode === 'dates') {
	            startEndDate.show();
	            periods.hide();
	
	            aggregateLayoutWindow.addDimension({
	                id: dimensionConfig.get('startEndDate').value,
	                name: dimensionConfig.get('startEndDate').name
	            }, aggregateLayoutWindow.fixedFilterStore);
	
	            aggregateLayoutWindow.removeDimension(dimensionConfig.get('period').dimensionName);
	        } else if (mode === 'periods') {
	            startEndDate.hide();
	            periods.show();
	
	            aggregateLayoutWindow.addDimension({
	                id: dimensionConfig.get('period').dimensionName,
	                name: dimensionConfig.get('period').name
	            }, aggregateLayoutWindow.colStore);
	
	            aggregateLayoutWindow.removeDimension(dimensionConfig.get('startEndDate').value);
	        }
	    };
	
	    var getDateLink = function getDateLink(text, fn, style) {
	        return Ext.create('Ext.form.Label', {
	            text: text,
	            style: 'padding-left: 5px; width: 100%; ' + style || '',
	            cls: 'ns-label-date',
	            updateValue: fn,
	            listeners: {
	                render: function render(cmp) {
	                    cmp.getEl().on('click', function () {
	                        cmp.updateValue();
	                    });
	                }
	            }
	        });
	    };
	
	    var onDateFieldRender = function onDateFieldRender(c) {
	        $('#' + c.inputEl.id).calendarsPicker({
	            calendar: calendarManager.calendar,
	            dateFormat: appManager.systemInfo.dateFormat
	        });
	    };
	
	    var startDate = Ext.create('Ext.form.field.Text', {
	        fieldLabel: 'Start date',
	        labelAlign: 'top',
	        labelCls: 'ns-form-item-label-top ns-form-item-label-top-padding',
	        labelSeparator: '',
	        columnWidth: 0.5,
	        height: 44,
	        value: calendarManager.calendar.formatDate(appManager.systemInfo.dateFormat, calendarManager.calendar.today().add(-3, 'm')),
	        listeners: {
	            render: function render(c) {
	                onDateFieldRender(c);
	            }
	        }
	    });
	
	    var endDate = Ext.create('Ext.form.field.Text', {
	        fieldLabel: 'End date',
	        labelAlign: 'top',
	        labelCls: 'ns-form-item-label-top ns-form-item-label-top-padding',
	        labelSeparator: '',
	        columnWidth: 0.5,
	        height: 44,
	        style: 'margin-left: 1px',
	        value: calendarManager.calendar.formatDate(appManager.systemInfo.dateFormat, calendarManager.calendar.today()),
	        listeners: {
	            render: function render(c) {
	                onDateFieldRender(c);
	            }
	        }
	    });
	
	    var startEndDate = Ext.create('Ext.container.Container', {
	        cls: 'ns-container-default',
	        layout: 'column',
	        hidden: true,
	        items: [startDate, endDate]
	    });
	
	    var onCheckboxAdd = function onCheckboxAdd(cmp) {
	        if (cmp.xtype === 'checkbox') {
	            uiManager.reg(cmp, cmp.relativePeriodId, null, 'relativePeriod');
	        }
	    };
	
	    var intervalListeners = {
	        added: function added(cmp) {
	            onCheckboxAdd(cmp);
	        }
	    };
	
	    var days = Ext.create('Ext.panel.Panel', {
	        bodyStyle: 'border-style:none; padding:0 0 0 8px',
	        defaults: {
	            labelSeparator: '',
	            style: 'margin-bottom:0',
	            listeners: intervalListeners
	        },
	        items: [{
	            xtype: 'label',
	            text: i18n['days'],
	            cls: 'ns-label-period-heading'
	        }, {
	            xtype: 'checkbox',
	            relativePeriodId: 'TODAY',
	            boxLabel: i18n['today'],
	            index: 0
	        }, {
	            xtype: 'checkbox',
	            relativePeriodId: 'YESTERDAY',
	            boxLabel: i18n['yesterday'],
	            index: 1
	        }, {
	            xtype: 'checkbox',
	            relativePeriodId: 'LAST_3_DAYS',
	            boxLabel: i18n['last_3_days'],
	            index: 2
	        }, {
	            xtype: 'checkbox',
	            relativePeriodId: 'LAST_7_DAYS',
	            boxLabel: i18n['last_7_days'],
	            index: 3
	        }, {
	            xtype: 'checkbox',
	            relativePeriodId: 'LAST_14_DAYS',
	            boxLabel: i18n['last_14_days'],
	            index: 4
	        }]
	    });
	
	    var weeks = Ext.create('Ext.panel.Panel', {
	        bodyStyle: 'border-style:none; padding:0 0 0 8px',
	        defaults: {
	            labelSeparator: '',
	            style: 'margin-bottom:0',
	            listeners: intervalListeners
	        },
	        items: [{
	            xtype: 'label',
	            text: i18n.weeks,
	            cls: 'ns-label-period-heading'
	        }, {
	            xtype: 'checkbox',
	            relativePeriodId: 'THIS_WEEK',
	            boxLabel: i18n.this_week
	        }, {
	            xtype: 'checkbox',
	            relativePeriodId: 'LAST_WEEK',
	            boxLabel: i18n.last_week
	        }, {
	            xtype: 'checkbox',
	            relativePeriodId: 'LAST_4_WEEKS',
	            boxLabel: i18n.last_4_weeks
	        }, {
	            xtype: 'checkbox',
	            relativePeriodId: 'LAST_12_WEEKS',
	            boxLabel: i18n.last_12_weeks
	        }, {
	            xtype: 'checkbox',
	            relativePeriodId: 'LAST_52_WEEKS',
	            boxLabel: i18n.last_52_weeks
	        }, {
	            xtype: 'checkbox',
	            relativePeriodId: 'WEEKS_THIS_YEAR',
	            boxLabel: i18n.weeks_this_year
	        }]
	    });
	
	    var months = Ext.create('Ext.panel.Panel', {
	        bodyStyle: 'border-style:none; padding:0 0 0 8px',
	        defaults: {
	            labelSeparator: '',
	            style: 'margin-bottom:0',
	            listeners: intervalListeners
	        },
	        items: [{
	            xtype: 'label',
	            text: i18n.months,
	            cls: 'ns-label-period-heading'
	        }, {
	            xtype: 'checkbox',
	            relativePeriodId: 'THIS_MONTH',
	            boxLabel: i18n.this_month
	        }, {
	            xtype: 'checkbox',
	            relativePeriodId: 'LAST_MONTH',
	            boxLabel: i18n.last_month
	        }, {
	            xtype: 'checkbox',
	            relativePeriodId: 'LAST_3_MONTHS',
	            boxLabel: i18n.last_3_months
	        }, {
	            xtype: 'checkbox',
	            relativePeriodId: 'LAST_6_MONTHS',
	            boxLabel: i18n.last_6_months
	        }, {
	            xtype: 'checkbox',
	            relativePeriodId: 'LAST_12_MONTHS',
	            boxLabel: i18n.last_12_months,
	            checked: true
	        }, {
	            xtype: 'checkbox',
	            relativePeriodId: 'MONTHS_THIS_YEAR',
	            boxLabel: i18n.months_this_year
	        }]
	    });
	
	    var biMonths = Ext.create('Ext.panel.Panel', {
	        bodyStyle: 'border-style:none; padding:5px 0 0 8px',
	        defaults: {
	            labelSeparator: '',
	            style: 'margin-bottom:0',
	            listeners: intervalListeners
	        },
	        items: [{
	            xtype: 'label',
	            text: i18n.bimonths,
	            cls: 'ns-label-period-heading'
	        }, {
	            xtype: 'checkbox',
	            relativePeriodId: 'THIS_BIMONTH',
	            boxLabel: i18n.this_bimonth
	        }, {
	            xtype: 'checkbox',
	            relativePeriodId: 'LAST_BIMONTH',
	            boxLabel: i18n.last_bimonth
	        }, {
	            xtype: 'checkbox',
	            relativePeriodId: 'LAST_6_BIMONTHS',
	            boxLabel: i18n.last_6_bimonths
	        }, {
	            xtype: 'checkbox',
	            relativePeriodId: 'BIMONTHS_THIS_YEAR',
	            boxLabel: i18n.bimonths_this_year
	        }]
	    });
	
	    var quarters = Ext.create('Ext.panel.Panel', {
	        bodyStyle: 'border-style:none; padding:5px 0 0 8px',
	        defaults: {
	            labelSeparator: '',
	            style: 'margin-bottom:0',
	            listeners: intervalListeners
	        },
	        items: [{
	            xtype: 'label',
	            text: i18n.quarters,
	            cls: 'ns-label-period-heading'
	        }, {
	            xtype: 'checkbox',
	            relativePeriodId: 'THIS_QUARTER',
	            boxLabel: i18n.this_quarter
	        }, {
	            xtype: 'checkbox',
	            relativePeriodId: 'LAST_QUARTER',
	            boxLabel: i18n.last_quarter
	        }, {
	            xtype: 'checkbox',
	            relativePeriodId: 'LAST_4_QUARTERS',
	            boxLabel: i18n.last_4_quarters
	        }, {
	            xtype: 'checkbox',
	            relativePeriodId: 'QUARTERS_THIS_YEAR',
	            boxLabel: i18n.quarters_this_year
	        }]
	    });
	
	    var sixMonths = Ext.create('Ext.panel.Panel', {
	        bodyStyle: 'border-style:none; padding:5px 0 0 8px',
	        defaults: {
	            labelSeparator: '',
	            style: 'margin-bottom:0',
	            listeners: intervalListeners
	        },
	        items: [{
	            xtype: 'label',
	            text: i18n.sixmonths,
	            cls: 'ns-label-period-heading'
	        }, {
	            xtype: 'checkbox',
	            relativePeriodId: 'THIS_SIX_MONTH',
	            boxLabel: i18n.this_sixmonth
	        }, {
	            xtype: 'checkbox',
	            relativePeriodId: 'LAST_SIX_MONTH',
	            boxLabel: i18n.last_sixmonth
	        }, {
	            xtype: 'checkbox',
	            relativePeriodId: 'LAST_2_SIXMONTHS',
	            boxLabel: i18n.last_2_sixmonths
	        }]
	    });
	
	    var financialYears = Ext.create('Ext.panel.Panel', {
	        bodyStyle: 'border-style:none; padding:5px 0 0 8px',
	        defaults: {
	            labelSeparator: '',
	            style: 'margin-bottom:0',
	            listeners: intervalListeners
	        },
	        items: [{
	            xtype: 'label',
	            text: i18n.financial_years,
	            cls: 'ns-label-period-heading'
	        }, {
	            xtype: 'checkbox',
	            relativePeriodId: 'THIS_FINANCIAL_YEAR',
	            boxLabel: i18n.this_financial_year
	        }, {
	            xtype: 'checkbox',
	            relativePeriodId: 'LAST_FINANCIAL_YEAR',
	            boxLabel: i18n.last_financial_year
	        }, {
	            xtype: 'checkbox',
	            relativePeriodId: 'LAST_5_FINANCIAL_YEARS',
	            boxLabel: i18n.last_5_financial_years
	        }]
	    });
	
	    var years = Ext.create('Ext.panel.Panel', {
	        bodyStyle: 'border-style:none; padding:5px 0 0 8px',
	        defaults: {
	            labelSeparator: '',
	            style: 'margin-bottom:0',
	            listeners: intervalListeners
	        },
	        items: [{
	            xtype: 'label',
	            text: i18n.years,
	            cls: 'ns-label-period-heading'
	        }, {
	            xtype: 'checkbox',
	            relativePeriodId: 'THIS_YEAR',
	            boxLabel: i18n.this_year
	        }, {
	            xtype: 'checkbox',
	            relativePeriodId: 'LAST_YEAR',
	            boxLabel: i18n.last_year
	        }, {
	            xtype: 'checkbox',
	            relativePeriodId: 'LAST_5_YEARS',
	            boxLabel: i18n.last_5_years
	        }]
	    });
	
	    var relativePeriod = Ext.create('Ext.panel.Panel', {
	        layout: 'column',
	        hideCollapseTool: true,
	        autoScroll: true,
	        bodyStyle: 'border:0 none',
	        items: [{
	            xtype: 'container',
	            columnWidth: 0.34,
	            bodyStyle: 'border-style:none',
	            items: [days, biMonths, financialYears]
	        }, {
	            xtype: 'container',
	            columnWidth: 0.33,
	            bodyStyle: 'border-style:none',
	            items: [weeks, quarters, years]
	        }, {
	            xtype: 'container',
	            columnWidth: 0.33,
	            bodyStyle: 'border-style:none',
	            items: [months, sixMonths]
	        }],
	        getRecords: function getRecords() {
	            return uiManager.getByGroup('relativePeriod').filter(function (cmp) {
	                return cmp.getValue();
	            }).map(function (cmp) {
	                return cmp.relativePeriodId;
	            });
	        }
	    });
	
	    // fixed periods
	    var fixedPeriodAvailable = Ext.create('Ext.ux.form.MultiSelect', {
	        cls: 'ns-toolbar-multiselect-left',
	        width: accBaseWidth / 2,
	        height: 160,
	        valueField: 'id',
	        displayField: 'name',
	        store: fixedPeriodAvailableStore,
	        tbar: [{
	            xtype: 'label',
	            text: i18n.available,
	            cls: 'ns-toolbar-multiselect-left-label'
	        }, '->', {
	            xtype: 'button',
	            iconCls: 'ns-button-icon-arrowright',
	            width: 22,
	            handler: function handler() {
	                uiManager.msSelect(fixedPeriodAvailable, fixedPeriodSelected);
	            }
	        }, {
	            xtype: 'button',
	            iconCls: 'ns-button-icon-arrowrightdouble',
	            width: 22,
	            handler: function handler() {
	                uiManager.msSelectAll(fixedPeriodAvailable, fixedPeriodSelected, true);
	            }
	        }, ' '],
	        listeners: {
	            afterrender: function afterrender() {
	                this.boundList.on('itemdblclick', function () {
	                    uiManager.msSelect(fixedPeriodAvailable, fixedPeriodSelected);
	                }, this);
	            }
	        }
	    });
	
	    var fixedPeriodSelected = Ext.create('Ext.ux.form.MultiSelect', {
	        cls: 'ns-toolbar-multiselect-right',
	        width: accBaseWidth / 2,
	        height: 160,
	        valueField: 'id',
	        displayField: 'name',
	        ddReorder: false,
	        store: fixedPeriodSelectedStore,
	        tbar: [' ', {
	            xtype: 'button',
	            iconCls: 'ns-button-icon-arrowleftdouble',
	            width: 22,
	            handler: function handler() {
	                uiManager.msUnselectAll(fixedPeriodAvailable, fixedPeriodSelected);
	            }
	        }, {
	            xtype: 'button',
	            iconCls: 'ns-button-icon-arrowleft',
	            width: 22,
	            handler: function handler() {
	                uiManager.msUnselect(fixedPeriodAvailable, fixedPeriodSelected);
	            }
	        }, '->', {
	            xtype: 'label',
	            text: i18n.selected,
	            cls: 'ns-toolbar-multiselect-right-label'
	        }],
	        listeners: {
	            afterrender: function afterrender() {
	                this.boundList.on('itemdblclick', function () {
	                    uiManager.msUnselect(fixedPeriodAvailable, fixedPeriodSelected);
	                }, this);
	            }
	        }
	    });
	
	    var onPeriodTypeSelect = function onPeriodTypeSelect() {
	        var type = periodType.getValue(),
	            periodOffset = periodType.periodOffset,
	            generator = calendarManager.periodGenerator,
	            periods = generator.generateReversedPeriods(type, type === 'Yearly' ? periodOffset - 5 : periodOffset);
	
	        periods.forEach(function (period) {
	            return period.id = period.iso;
	        });
	
	        fixedPeriodAvailableStore.setIndex(periods);
	        fixedPeriodAvailableStore.loadData(periods);
	        uiManager.msFilterAvailable(fixedPeriodAvailable, fixedPeriodSelected);
	    };
	
	    var periodType = Ext.create('Ext.form.field.ComboBox', {
	        cls: 'ns-combo',
	        style: 'margin-right:1px; margin-bottom:1px',
	        width: accBaseWidth - nextButtonWidth * 2 - 2,
	        valueField: 'id',
	        displayField: 'name',
	        emptyText: i18n.select_period_type,
	        editable: false,
	        queryMode: 'remote',
	        store: periodTypeStore,
	        periodOffset: 0,
	        listeners: {
	            select: function select(cmp) {
	                periodType.periodOffset = 0;
	                onPeriodTypeSelect();
	            }
	        }
	    });
	
	    var prevYear = Ext.create('Ext.button.Button', {
	        text: i18n.prev_year,
	        style: 'border-radius:1px; margin-right:1px',
	        height: 24,
	        width: nextButtonWidth,
	        handler: function handler() {
	            if (periodType.getValue()) {
	                periodType.periodOffset--;
	                onPeriodTypeSelect();
	            }
	        }
	    });
	
	    var nextYear = Ext.create('Ext.button.Button', {
	        text: i18n.next_year,
	        style: 'border-radius:1px',
	        height: 24,
	        width: nextButtonWidth,
	        handler: function handler() {
	            if (periodType.getValue()) {
	                periodType.periodOffset++;
	                onPeriodTypeSelect();
	            }
	        }
	    });
	
	    var fixedPeriodSettings = Ext.create('Ext.container.Container', {
	        layout: 'column',
	        bodyStyle: 'border-style:none',
	        style: 'margin-top:0px',
	        items: [periodType, prevYear, nextYear]
	    });
	
	    var fixedPeriodAvailableSelected = Ext.create('Ext.container.Container', {
	        layout: 'column',
	        bodyStyle: 'border-style:none; padding-bottom:2px',
	        items: [fixedPeriodAvailable, fixedPeriodSelected]
	    });
	
	    var periods = Ext.create('Ext.panel.Panel', {
	        bodyStyle: 'border-style:none',
	        getRecords: function getRecords() {
	            var selectedRecords = [],
	                records;
	
	            fixedPeriodSelectedStore.each(function (r) {
	                selectedRecords.push({ id: r.data.id });
	            });
	
	            records = [].concat(selectedRecords, _toConsumableArray(uiManager.getByGroup('relativePeriod').filter(function (cmp) {
	                return cmp.getValue();
	            }).map(function (cmp) {
	                return { id: cmp.relativePeriodId };
	            })));
	
	            return records.length ? records : null;
	        },
	        getDimension: function getDimension() {
	            return {
	                dimension: 'pe',
	                items: this.getRecords()
	            };
	        },
	        items: [{
	            xtype: 'panel',
	            layout: 'column',
	            bodyStyle: 'border-style:none; padding-bottom:2px',
	            items: [fixedPeriodSettings, fixedPeriodAvailableSelected]
	        }, relativePeriod]
	    });
	
	    var period = Ext.create('Ext.panel.Panel', {
	        title: '<div class="ns-panel-title-period">Periods</div>',
	        bodyStyle: 'padding:1px',
	        hideCollapseTool: true,
	        dimension: dimensionConfig.get('period').objectName,
	        width: accBaseWidth,
	        clearDimension: function clearDimension(all) {
	            this.resetFixedPeriods();
	            this.resetRelativePeriods();
	            this.resetStartEndDates();
	
	            periodMode.reset();
	
	            if (!all) {
	                uiManager.get(appManager.getRelativePeriod()).setValue(true);
	            }
	        },
	        setDimension: function setDimension(layout) {
	            if (!layout) {
	                return;
	            }
	
	            if (layout.startDate && layout.endDate) {
	                onPeriodModeSelect('dates');
	                startDate.setValue(layout.startDate);
	                endDate.setValue(layout.endDate);
	            } else {
	                onPeriodModeSelect('periods');
	            }
	
	            if (layout.hasDimension(this.dimension, true)) {
	                var records = layout.getDimension(this.dimension).extendRecords(layout.getResponse()),
	                    fixedRecords = [],
	                    checkbox;
	
	                records.forEach(function (record) {
	                    checkbox = uiManager.get(record.id);
	
	                    if (checkbox) {
	                        checkbox.setValue(true);
	                    } else {
	                        fixedRecords.push(record);
	                    }
	                });
	
	                fixedPeriodSelectedStore.add(fixedRecords);
	
	                uiManager.msFilterAvailable({ store: fixedPeriodAvailableStore }, { store: fixedPeriodSelectedStore });
	            }
	        },
	        getDimension: function getDimension() {
	            var config = {
	                dimension: periodObjectName,
	                items: periods.getRecords()
	            };
	
	            return config.items.length ? config : null;
	        },
	        getHeightValue: function getHeightValue() {
	            var westRegion = uiManager.get('westRegion');
	
	            return westRegion.hasScrollbar ? uiConfig.west_scrollbarheight_accordion_period : uiConfig.west_maxheight_accordion_period;
	        },
	        onExpand: function onExpand() {
	            accordion.setThisHeight(this.getHeightValue());
	
	            uiManager.msSetHeight([fixedPeriodAvailable, fixedPeriodSelected], this, uiConfig.west_fill_accordion_period);
	        },
	        reset: function reset() {
	            this.resetRelativePeriods();
	            this.resetFixedPeriods();
	            this.resetStartEndDates();
	
	            periodMode.reset();
	        },
	        isRelativePeriods: function isRelativePeriods() {
	            return uiManager.getByGroup('relativePeriod').some(function (chb) {
	                return chb.getValue();
	            });
	        },
	        resetRelativePeriods: function resetRelativePeriods() {
	            uiManager.getByGroup('relativePeriod').forEach(function (cmp) {
	                return cmp.setValue(false);
	            });
	        },
	        isNoRelativePeriods: function isNoRelativePeriods() {
	            return !uiManager.getByGroup('relativePeriod').some(function (cmp) {
	                return cmp.getValue();
	            });
	        },
	        resetFixedPeriods: function resetFixedPeriods() {
	            fixedPeriodAvailableStore.removeAll();
	            fixedPeriodSelectedStore.removeAll();
	            periodType.clearValue();
	        },
	        resetStartEndDates: function resetStartEndDates() {
	            startDate.reset();
	            endDate.reset();
	        },
	        items: [periodMode, startEndDate, periods],
	        listeners: {
	            expand: function expand(cmp) {
	                cmp.onExpand();
	            }
	        }
	    });
	    accordionPanels.push(uiManager.reg(period, 'period'));
	
	    // organisation unit
	    var treePanel = Ext.create('Ext.tree.Panel', {
	        cls: 'ns-tree',
	        height: 436,
	        width: accBaseWidth,
	        bodyStyle: 'border:0 none',
	        style: 'border-top: 1px solid #ddd; padding-top: 1px',
	        displayField: 'name',
	        rootVisible: false,
	        autoScroll: true,
	        multiSelect: true,
	        rendered: false,
	        reset: function reset() {
	            var rootNode = this.getRootNode().findChild('id', appManager.rootNodes[0].id);
	            this.collapseAll();
	            this.expandPath(rootNode.getPath());
	            this.getSelectionModel().select(rootNode);
	        },
	        selectRootIf: function selectRootIf() {
	            if (this.getSelectionModel().getSelection().length < 1) {
	                var node = this.getRootNode().findChild('id', appManager.rootNodes[0].id);
	                if (this.rendered) {
	                    this.getSelectionModel().select(node);
	                }
	                return node;
	            }
	        },
	        isPending: false,
	        recordsToSelect: [],
	        recordsToRestore: [],
	        multipleSelectIf: function multipleSelectIf(map, doUpdate) {
	            this.recordsToSelect = (0, _arrayClean2.default)(this.recordsToSelect);
	
	            if (this.recordsToSelect.length === Object.keys(map).length) {
	                this.getSelectionModel().select(this.recordsToSelect);
	                this.recordsToSelect = [];
	                this.isPending = false;
	
	                if (doUpdate) {
	                    update();
	                }
	            }
	        },
	        multipleExpand: function multipleExpand(id, map, doUpdate) {
	            var t = this,
	                rootId = appManager.rootNodeId,
	                path = map[id];
	
	            if (path.substr(0, rootId.length + 1) !== '/' + rootId) {
	                path = '/' + rootId + '/' + path;
	            }
	
	            t.expandPath(path, 'id', '/', function () {
	                var record = t.getRootNode().findChild('id', id, true);
	                t.recordsToSelect.push(record);
	                t.multipleSelectIf(map, doUpdate);
	            });
	        },
	        select: function select(url, params) {
	            if (!params) {
	                params = {};
	            }
	            Ext.Ajax.request({
	                url: url,
	                method: 'GET',
	                params: params,
	                scope: this,
	                success: function success(r) {
	                    var a = Ext.decode(r.responseText).organisationUnits;
	                    this.numberOfRecords = a.length;
	                    for (var i = 0; i < a.length; i++) {
	                        this.multipleExpand(a[i].id, a[i].path);
	                    }
	                }
	            });
	        },
	        getParentGraphMap: function getParentGraphMap() {
	            var selection = this.getSelectionModel().getSelection(),
	                map = {};
	
	            if ((0, _isArray2.default)(selection) && selection.length) {
	                for (var i = 0, pathArray, key; i < selection.length; i++) {
	                    pathArray = selection[i].getPath().split('/');
	                    map[pathArray.pop()] = pathArray.join('/');
	                }
	            }
	
	            return map;
	        },
	        selectGraphMap: function selectGraphMap(map, update) {
	            if (!Object.keys(map).length) {
	                return;
	            }
	
	            this.isPending = true;
	
	            for (var key in map) {
	                if (map.hasOwnProperty(key)) {
	                    treePanel.multipleExpand(key, map, update);
	                }
	            }
	        },
	        store: Ext.create('Ext.data.TreeStore', {
	            fields: ['id', 'name', 'hasChildren'],
	            proxy: {
	                type: 'rest',
	                format: 'json',
	                noCache: false,
	                extraParams: {
	                    fields: 'children[id,' + displayPropertyUrl + ',children::isNotEmpty~rename(hasChildren)&paging=false'
	                },
	                url: appManager.getApiPath() + '/organisationUnits',
	                reader: {
	                    type: 'json',
	                    root: 'children'
	                },
	                sortParam: false
	            },
	            sorters: [{
	                property: 'name',
	                direction: 'ASC'
	            }],
	            root: {
	                id: appManager.rootNodeId,
	                expanded: true,
	                children: appManager.getRootNodes()
	            },
	            listeners: {
	                beforeload: function beforeload(store, operation) {
	                    if (!store.proxy._url) {
	                        store.proxy._url = store.proxy.url;
	                    }
	
	                    store.proxy.url = store.proxy._url + '/' + operation.node.data.id;
	                },
	                load: function load(store, node, records) {
	                    records.forEach(function (record) {
	                        if ((0, _isBoolean2.default)(record.data.hasChildren)) {
	                            record.set('leaf', !record.data.hasChildren);
	                        }
	                    });
	                }
	            }
	        }),
	        xable: function xable(values) {
	            for (var i = 0; i < values.length; i++) {
	                if (!!values[i]) {
	                    this.disable();
	                    return;
	                }
	            }
	
	            this.enable();
	        },
	        getDimension: function getDimension() {
	            var r = treePanel.getSelectionModel().getSelection(),
	                config = {
	                dimension: organisationUnitObjectName,
	                items: []
	            };
	
	            if (toolMenu.menuValue === 'orgunit') {
	                if (userOrganisationUnit.getValue() || userOrganisationUnitChildren.getValue() || userOrganisationUnitGrandChildren.getValue()) {
	                    if (userOrganisationUnit.getValue()) {
	                        config.items.push({
	                            id: 'USER_ORGUNIT',
	                            name: ''
	                        });
	                    }
	                    if (userOrganisationUnitChildren.getValue()) {
	                        config.items.push({
	                            id: 'USER_ORGUNIT_CHILDREN',
	                            name: ''
	                        });
	                    }
	                    if (userOrganisationUnitGrandChildren.getValue()) {
	                        config.items.push({
	                            id: 'USER_ORGUNIT_GRANDCHILDREN',
	                            name: ''
	                        });
	                    }
	                } else {
	                    for (var i = 0; i < r.length; i++) {
	                        config.items.push({ id: r[i].data.id });
	                    }
	                }
	            } else if (toolMenu.menuValue === 'level') {
	                var levels = organisationUnitLevel.getValue();
	
	                for (var i = 0; i < levels.length; i++) {
	                    config.items.push({
	                        id: 'LEVEL-' + levels[i],
	                        name: ''
	                    });
	                }
	
	                for (var i = 0; i < r.length; i++) {
	                    config.items.push({
	                        id: r[i].data.id,
	                        name: ''
	                    });
	                }
	            } else if (toolMenu.menuValue === 'group') {
	                var groupIds = organisationUnitGroup.getValue();
	
	                for (var i = 0; i < groupIds.length; i++) {
	                    config.items.push({
	                        id: 'OU_GROUP-' + groupIds[i],
	                        name: ''
	                    });
	                }
	
	                for (var i = 0; i < r.length; i++) {
	                    config.items.push({
	                        id: r[i].data.id,
	                        name: ''
	                    });
	                }
	            }
	
	            return config.items.length ? config : null;
	        },
	        listeners: {
	            beforeitemexpand: function beforeitemexpand() {
	                var rts = treePanel.recordsToSelect;
	
	                if (!treePanel.isPending) {
	                    treePanel.recordsToRestore = treePanel.getSelectionModel().getSelection();
	                }
	            },
	            itemexpand: function itemexpand() {
	                if (!treePanel.isPending && treePanel.recordsToRestore.length) {
	                    treePanel.getSelectionModel().select(treePanel.recordsToRestore);
	                    treePanel.recordsToRestore = [];
	                }
	            },
	            render: function render() {
	                this.rendered = true;
	            },
	            afterrender: function afterrender() {
	                this.getSelectionModel().select(0);
	
	                Ext.defer(function () {
	                    data.expand();
	                }, 20);
	            },
	            itemcontextmenu: function itemcontextmenu(v, r, h, i, e) {
	                v.getSelectionModel().select(r, false);
	
	                if (v.menu) {
	                    v.menu.destroy();
	                }
	                v.menu = Ext.create('Ext.menu.Menu', {
	                    id: 'treepanel-contextmenu',
	                    showSeparator: false,
	                    shadow: false
	                });
	                if (!r.data.leaf) {
	                    v.menu.add({
	                        id: 'treepanel-contextmenu-item',
	                        text: i18n.select_sub_units,
	                        iconCls: 'ns-button-icon-nodeselectchild',
	                        handler: function handler() {
	                            r.expand(false, function () {
	                                v.getSelectionModel().select(r.childNodes, true);
	                                v.getSelectionModel().deselect(r);
	                            });
	                        }
	                    });
	                } else {
	                    return;
	                }
	
	                v.menu.showAt(e.xy);
	            }
	        }
	    });
	    uiManager.reg(treePanel, 'treePanel');
	
	    var userOrganisationUnit = Ext.create('Ext.form.field.Checkbox', {
	        columnWidth: 0.25,
	        style: 'padding-top: 3px; padding-left: 5px; margin-bottom: 0',
	        boxLabel: 'User org unit',
	        labelWidth: uiConfig.form_label_width,
	        handler: function handler(chb, checked) {
	            treePanel.xable([checked, userOrganisationUnitChildren.getValue(), userOrganisationUnitGrandChildren.getValue()]);
	        }
	    });
	
	    var userOrganisationUnitChildren = Ext.create('Ext.form.field.Checkbox', {
	        columnWidth: 0.26,
	        style: 'padding-top: 3px; margin-bottom: 0',
	        boxLabel: i18n.user_sub_units,
	        labelWidth: uiConfig.form_label_width,
	        handler: function handler(chb, checked) {
	            treePanel.xable([checked, userOrganisationUnit.getValue(), userOrganisationUnitGrandChildren.getValue()]);
	        }
	    });
	
	    var userOrganisationUnitGrandChildren = Ext.create('Ext.form.field.Checkbox', {
	        columnWidth: 0.4,
	        style: 'padding-top: 3px; margin-bottom: 0',
	        boxLabel: i18n.user_sub_x2_units,
	        labelWidth: uiConfig.form_label_width,
	        handler: function handler(chb, checked) {
	            treePanel.xable([checked, userOrganisationUnit.getValue(), userOrganisationUnitChildren.getValue()]);
	        }
	    });
	
	    var organisationUnitLevel = Ext.create('Ext.form.field.ComboBox', {
	        cls: 'ns-combo',
	        multiSelect: true,
	        style: 'margin-bottom:0',
	        width: accBaseWidth - toolWidth - 1,
	        valueField: 'level',
	        displayField: 'name',
	        emptyText: i18n.select_organisation_unit_levels,
	        editable: false,
	        hidden: true,
	        store: {
	            fields: ['id', 'name', 'level'],
	            data: appManager.organisationUnitLevels
	        }
	    });
	
	    var organisationUnitGroup = Ext.create('Ext.form.field.ComboBox', {
	        cls: 'ns-combo',
	        multiSelect: true,
	        style: 'margin-bottom:0',
	        width: accBaseWidth - toolWidth - 1,
	        valueField: 'id',
	        displayField: 'name',
	        emptyText: i18n.select_organisation_unit_groups,
	        editable: false,
	        hidden: true,
	        store: organisationUnitGroupStore
	    });
	
	    var organisationUnitPanel = Ext.create('Ext.panel.Panel', {
	        width: accBaseWidth - toolWidth - 1,
	        layout: 'column',
	        bodyStyle: 'border:0 none',
	        items: [userOrganisationUnit, userOrganisationUnitChildren, userOrganisationUnitGrandChildren, organisationUnitLevel, organisationUnitGroup]
	    });
	
	    var toolMenu = Ext.create('Ext.menu.Menu', {
	        shadow: false,
	        showSeparator: false,
	        menuValue: 'orgunit',
	        clickHandler: function clickHandler(param) {
	            if (!param) {
	                return;
	            }
	
	            var items = this.items.items;
	            this.menuValue = param;
	
	            // Menu item icon cls
	            for (var i = 0; i < items.length; i++) {
	                if (items[i].setIconCls) {
	                    if (items[i].param === param) {
	                        items[i].setIconCls('ns-menu-item-selected');
	                    } else {
	                        items[i].setIconCls('ns-menu-item-unselected');
	                    }
	                }
	            }
	
	            // Gui
	            if (param === 'orgunit') {
	                userOrganisationUnit.show();
	                userOrganisationUnitChildren.show();
	                userOrganisationUnitGrandChildren.show();
	                organisationUnitLevel.hide();
	                organisationUnitGroup.hide();
	
	                if (userOrganisationUnit.getValue() || userOrganisationUnitChildren.getValue()) {
	                    treePanel.disable();
	                }
	            } else if (param === 'level') {
	                userOrganisationUnit.hide();
	                userOrganisationUnitChildren.hide();
	                userOrganisationUnitGrandChildren.hide();
	                organisationUnitLevel.show();
	                organisationUnitGroup.hide();
	                treePanel.enable();
	            } else if (param === 'group') {
	                // DHIS2-561: avoid showing the group ids in the combobox when
	                // loading a favorite and expanding the OU panel
	                organisationUnitGroupStore.load();
	
	                userOrganisationUnit.hide();
	                userOrganisationUnitChildren.hide();
	                userOrganisationUnitGrandChildren.hide();
	                organisationUnitLevel.hide();
	                organisationUnitGroup.show();
	                treePanel.enable();
	            }
	        },
	        items: [{
	            xtype: 'label',
	            text: 'Selection mode',
	            style: 'padding:7px 5px 5px 7px; font-weight:bold; border:0 none'
	        }, {
	            text: i18n.select_organisation_units + '&nbsp;&nbsp;',
	            param: 'orgunit',
	            iconCls: 'ns-menu-item-selected'
	        }, {
	            text: 'Select levels' + '&nbsp;&nbsp;',
	            param: 'level',
	            iconCls: 'ns-menu-item-unselected'
	        }, {
	            text: 'Select groups' + '&nbsp;&nbsp;',
	            param: 'group',
	            iconCls: 'ns-menu-item-unselected'
	        }],
	        listeners: {
	            afterrender: function afterrender() {
	                this.getEl().addCls('ns-btn-menu');
	            },
	            click: function click(menu, item) {
	                this.clickHandler(item.param);
	            }
	        }
	    });
	
	    var tool = Ext.create('Ext.button.Button', {
	        cls: 'ns-button-organisationunitselection',
	        iconCls: 'ns-button-icon-gear',
	        width: toolWidth,
	        height: 24,
	        menu: toolMenu
	    });
	
	    var toolPanel = Ext.create('Ext.panel.Panel', {
	        width: toolWidth,
	        bodyStyle: 'border:0 none; text-align:right',
	        style: 'margin-right:1px',
	        items: tool
	    });
	
	    var organisationUnit = Ext.create('Ext.panel.Panel', {
	        title: '<div class="ns-panel-title-organisationunit">' + i18n.organisation_units + '</div>',
	        bodyStyle: 'padding:1px',
	        hideCollapseTool: true,
	        dimension: dimensionConfig.get('organisationUnit').objectName,
	        collapsed: false,
	        clearDimension: function clearDimension(doClear, skipTree) {
	            if (doClear) {
	                toolMenu.clickHandler(toolMenu.menuValue);
	
	                if (!skipTree) {
	                    treePanel.reset();
	                }
	
	                userOrganisationUnit.setValue(false);
	                userOrganisationUnitChildren.setValue(false);
	                userOrganisationUnitGrandChildren.setValue(false);
	
	                organisationUnitLevel.clearValue();
	                organisationUnitGroup.clearValue();
	            }
	        },
	        setDimension: function setDimension(layout) {
	            if (layout.hasDimension(this.dimension, true)) {
	                var dimension = layout.getDimension(this.dimension, true),
	                    parentGraphMap = layout.parentGraphMap;
	
	                var records = dimension.getRecords(),
	                    ids = [],
	                    levels = [],
	                    groups = [],
	                    isOu,
	                    isOuc,
	                    isOugc;
	
	                records.forEach(function (record) {
	                    if (record.id === 'USER_ORGUNIT') {
	                        isOu = true;
	                    } else if (record.id === 'USER_ORGUNIT_CHILDREN') {
	                        isOuc = true;
	                    } else if (record.id === 'USER_ORGUNIT_GRANDCHILDREN') {
	                        isOugc = true;
	                    } else if (record.id.substr(0, 5) === 'LEVEL') {
	                        levels.push(parseInt(record.id.split('-')[1]));
	                    } else if (record.id.substr(0, 8) === 'OU_GROUP') {
	                        groups.push(record.id.split('-')[1]);
	                    } else {
	                        ids.push(record.id);
	                    }
	                });
	
	                if (levels.length) {
	                    toolMenu.clickHandler('level');
	                    organisationUnitLevel.setValue(levels);
	                } else if (groups.length) {
	                    toolMenu.clickHandler('group');
	                    organisationUnitGroup.setValue(groups);
	                } else {
	                    toolMenu.clickHandler('orgunit');
	                    userOrganisationUnit.setValue(isOu);
	                    userOrganisationUnitChildren.setValue(isOuc);
	                    userOrganisationUnitGrandChildren.setValue(isOugc);
	                }
	
	                if (!(isOu || isOuc || isOugc)) {
	                    if ((0, _isObject2.default)(parentGraphMap)) {
	                        treePanel.selectGraphMap(parentGraphMap);
	                    }
	                }
	            } else {
	                this.clearDimension(true);
	            }
	        },
	        getDimension: function getDimension() {
	            var r = treePanel.getSelectionModel().getSelection(),
	                config = {
	                dimension: organisationUnitObjectName,
	                items: []
	            };
	
	            if (toolMenu.menuValue === 'orgunit') {
	                if (userOrganisationUnit.getValue() || userOrganisationUnitChildren.getValue() || userOrganisationUnitGrandChildren.getValue()) {
	                    if (userOrganisationUnit.getValue()) {
	                        config.items.push({
	                            id: 'USER_ORGUNIT',
	                            name: ''
	                        });
	                    }
	                    if (userOrganisationUnitChildren.getValue()) {
	                        config.items.push({
	                            id: 'USER_ORGUNIT_CHILDREN',
	                            name: ''
	                        });
	                    }
	                    if (userOrganisationUnitGrandChildren.getValue()) {
	                        config.items.push({
	                            id: 'USER_ORGUNIT_GRANDCHILDREN',
	                            name: ''
	                        });
	                    }
	                } else {
	                    for (var i = 0; i < r.length; i++) {
	                        config.items.push({ id: r[i].data.id });
	                    }
	                }
	            } else if (toolMenu.menuValue === 'level') {
	                var levels = organisationUnitLevel.getValue();
	
	                for (var i = 0; i < levels.length; i++) {
	                    config.items.push({
	                        id: 'LEVEL-' + levels[i],
	                        name: ''
	                    });
	                }
	
	                for (var i = 0; i < r.length; i++) {
	                    config.items.push({
	                        id: r[i].data.id,
	                        name: ''
	                    });
	                }
	            } else if (toolMenu.menuValue === 'group') {
	                var groupIds = organisationUnitGroup.getValue();
	
	                for (var i = 0; i < groupIds.length; i++) {
	                    config.items.push({
	                        id: 'OU_GROUP-' + groupIds[i],
	                        name: ''
	                    });
	                }
	
	                for (var i = 0; i < r.length; i++) {
	                    config.items.push({
	                        id: r[i].data.id,
	                        name: ''
	                    });
	                }
	            }
	
	            return config.items.length ? config : null;
	        },
	        getHeightValue: function getHeightValue() {
	            var westRegion = uiManager.get('westRegion');
	
	            return westRegion.hasScrollbar ? uiConfig.west_scrollbarheight_accordion_organisationunit : uiConfig.west_maxheight_accordion_organisationunit;
	        },
	        onExpand: function onExpand() {
	            accordion.setThisHeight(this.getHeightValue);
	
	            treePanel.setHeight(this.getHeight() - uiConfig.west_fill_accordion_organisationunit);
	        },
	        items: [{
	            layout: 'column',
	            bodyStyle: 'border:0 none',
	            style: 'padding-bottom:1px',
	            items: [toolPanel, {
	                width: accBaseWidth - 37,
	                layout: 'column',
	                bodyStyle: 'border:0 none',
	                items: [userOrganisationUnit, userOrganisationUnitChildren, userOrganisationUnitGrandChildren, organisationUnitLevel, organisationUnitGroup]
	            }]
	        }, treePanel],
	        listeners: {
	            expand: function expand(p) {
	                p.onExpand();
	            }
	        }
	    });
	    accordionPanels.push(uiManager.reg(organisationUnit, 'organisationUnit'));
	
	    // dimensions
	
	    var getDimensionPanel = function getDimensionPanel(dimension, iconCls) {
	        var onSelect, availableStore, selectedStore, dataLabel, dataSearch, dataFilter, selectedAll, available, selected, onSelectAll, panel, createPanel, getPanels;
	
	        onSelect = function onSelect() {
	            var win = uiManager.get('viewport').getLayoutWindow();
	
	            if (selectedStore.getRange().length || selectedAll.getValue()) {
	                win.addDimension({ id: dimension.id, name: dimension.name });
	            } else if (win.hasDimension(dimension.id)) {
	                win.removeDimension(dimension.id);
	            }
	        };
	
	        availableStore = Ext.create('Ext.data.Store', {
	            fields: ['id', 'name'],
	            lastPage: null,
	            nextPage: 1,
	            isPending: false,
	            isLoaded: false,
	            reset: function reset() {
	                this.removeAll();
	                this.lastPage = null;
	                this.nextPage = 1;
	                this.isPending = false;
	                dataSearch.hideFilter();
	            },
	            storage: {},
	            addToStorage: function addToStorage(dimensionId, filter, data) {
	                filter = 'cache_' + ((0, _isString2.default)(filter) || (0, _isNumber2.default)(filter) ? filter : '');
	
	                if (!dimensionId) {
	                    return;
	                }
	
	                if (!this.storage.hasOwnProperty(dimensionId)) {
	                    this.storage[dimensionId] = {};
	                }
	
	                if (!this.storage[dimensionId][filter]) {
	                    this.storage[dimensionId][filter] = data;
	                }
	            },
	            getFromStorage: function getFromStorage(dimensionId, filter) {
	                filter = 'cache_' + ((0, _isString2.default)(filter) || (0, _isNumber2.default)(filter) ? filter : '');
	
	                if (this.storage.hasOwnProperty(dimensionId)) {
	                    if (this.storage[dimensionId].hasOwnProperty(filter)) {
	                        return this.storage[dimensionId][filter];
	                    }
	                }
	
	                return;
	            },
	            loadPage: function loadPage(filter, append, noPaging, fn) {
	                var store = this,
	                    params = {},
	                    url,
	                    cacheData;
	
	                filter = filter || dataFilter.getValue() || null;
	
	                // check session cache
	                cacheData = store.getFromStorage(dimension.id, filter);
	
	                if (!append && cacheData) {
	                    store.loadStore(cacheData, {}, append, fn);
	                } else {
	                    if (!append) {
	                        this.lastPage = null;
	                        this.nextPage = 1;
	                    }
	
	                    if (store.nextPage === store.lastPage) {
	                        return;
	                    }
	
	                    url = '/dimensions/' + dimension.id + '/items.json?fields=id,' + displayPropertyUrl + (filter ? '&filter=' + displayProperty + ':ilike:' + filter : '');
	
	                    if (noPaging) {
	                        params.paging = false;
	                    } else {
	                        params.page = store.nextPage;
	                        params.pageSize = 50;
	                    }
	
	                    store.isPending = true;
	                    uiManager.mask(available.boundList);
	
	                    Ext.Ajax.request({
	                        url: encodeURI(apiPath + url),
	                        method: 'GET',
	                        params: params,
	                        success: function success(r) {
	                            var response = Ext.decode(r.responseText),
	                                data = response.items || [],
	                                pager = response.pager;
	
	                            // add to session cache
	                            store.addToStorage(dimension.id, filter, data);
	
	                            store.loadStore(data, pager, append, fn);
	                        },
	                        callback: function callback() {
	                            store.isPending = false;
	                            uiManager.unmask(available.boundList);
	                        }
	                    });
	                }
	            },
	            loadStore: function loadStore(data, pager, append, fn) {
	                pager = pager || {};
	
	                this.loadData(data, append);
	                this.lastPage = this.nextPage;
	
	                if (pager.pageCount > this.nextPage) {
	                    this.nextPage++;
	                }
	
	                this.isPending = false;
	
	                uiManager.msFilterAvailable({ store: availableStore }, { store: selectedStore });
	
	                if (fn) {
	                    fn();
	                }
	            },
	            sortStore: function sortStore() {
	                this.sort('name', 'ASC');
	            }
	        });
	
	        selectedStore = Ext.create('Ext.data.Store', {
	            fields: ['id', 'name'],
	            data: [],
	            listeners: {
	                add: function add() {
	                    onSelect();
	                },
	                remove: function remove() {
	                    onSelect();
	                },
	                clear: function clear() {
	                    onSelect();
	                }
	            }
	        });
	
	        dataLabel = Ext.create('Ext.form.Label', {
	            text: i18n.available,
	            cls: 'ns-toolbar-multiselect-left-label',
	            style: 'margin-right:5px'
	        });
	
	        dataSearch = Ext.create('Ext.button.Button', {
	            width: 22,
	            height: 22,
	            cls: 'ns-button-icon',
	            iconCls: 'ns-button-icon-search',
	            showFilter: function showFilter() {
	                dataLabel.hide();
	                this.hide();
	                dataFilter.show();
	                dataFilter.reset();
	            },
	            hideFilter: function hideFilter() {
	                dataLabel.show();
	                this.show();
	                dataFilter.hide();
	                dataFilter.reset();
	            },
	            handler: function handler() {
	                this.showFilter();
	            }
	        });
	
	        dataFilter = Ext.create('Ext.form.field.Trigger', {
	            width: accBaseWidth / 2,
	            cls: 'ns-trigger-filter',
	            emptyText: 'Filter available...',
	            height: 22,
	            hidden: true,
	            enableKeyEvents: true,
	            fieldStyle: 'height:22px; border-right:0 none',
	            style: 'height:22px',
	            onTriggerClick: function onTriggerClick() {
	                this.reset();
	                this.onKeyUpHandler();
	
	                dataSearch.hideFilter();
	            },
	            onKeyUpHandler: function onKeyUpHandler() {
	                var value = this.getValue(),
	                    store = availableStore;
	
	                if ((0, _isString2.default)(value) || (0, _isNumber2.default)(value)) {
	                    store.loadPage(value, false, true);
	                }
	            },
	            listeners: {
	                keyup: {
	                    fn: function fn(cmp) {
	                        cmp.onKeyUpHandler();
	                    },
	                    buffer: 100
	                },
	                show: function show(cmp) {
	                    cmp.focus(false, 50);
	                },
	                focus: function focus(cmp) {
	                    cmp.addCls('ns-trigger-filter-focused');
	                },
	                blur: function blur(cmp) {
	                    cmp.removeCls('ns-trigger-filter-focused');
	                }
	            }
	        });
	
	        selectedAll = Ext.create('Ext.form.field.Checkbox', {
	            cls: 'ns-checkbox',
	            style: 'margin-left: 2px; margin-right: 5px',
	            boxLabel: 'All',
	            listeners: {
	                change: function change(chb, newVal) {
	                    onSelectAll(newVal);
	                }
	            }
	        });
	
	        available = Ext.create('Ext.ux.form.MultiSelect', {
	            cls: 'ns-toolbar-multiselect-left',
	            width: accBaseWidth / 2,
	            valueField: 'id',
	            displayField: 'name',
	            store: availableStore,
	            tbar: [dataLabel, dataSearch, dataFilter, '->', {
	                xtype: 'button',
	                iconCls: 'ns-button-icon-arrowright',
	                width: 22,
	                handler: function handler() {
	                    uiManager.msSelect(available, selected);
	                }
	            }, {
	                xtype: 'button',
	                iconCls: 'ns-button-icon-arrowrightdouble',
	                width: 22,
	                handler: function handler() {
	                    availableStore.loadPage(null, null, true, function () {
	                        uiManager.msSelectAll(available, selected);
	                    });
	                }
	            }],
	            listeners: {
	                render: function render(ms) {
	                    var el = Ext.get(ms.boundList.getEl().id + '-listEl').dom;
	
	                    el.addEventListener('scroll', function (e) {
	                        if (uiManager.isScrolled(e) && !availableStore.isPending) {
	                            availableStore.loadPage(null, true);
	                        }
	                    });
	
	                    ms.boundList.on('itemdblclick', function () {
	                        uiManager.msSelect(available, selected);
	                    }, ms);
	                }
	            }
	        });
	
	        selected = Ext.create('Ext.ux.form.MultiSelect', {
	            cls: 'ns-toolbar-multiselect-right',
	            width: accBaseWidth / 2,
	            valueField: 'id',
	            displayField: 'name',
	            ddReorder: true,
	            store: selectedStore,
	            tbar: [{
	                xtype: 'button',
	                iconCls: 'ns-button-icon-arrowleftdouble',
	                width: 22,
	                handler: function handler() {
	                    uiManager.msUnselectAll(available, selected);
	                }
	            }, {
	                xtype: 'button',
	                iconCls: 'ns-button-icon-arrowleft',
	                width: 22,
	                handler: function handler() {
	                    uiManager.msUnselect(available, selected);
	                }
	            }, '->', {
	                xtype: 'label',
	                text: i18n.selected,
	                cls: 'ns-toolbar-multiselect-right-label'
	            }, selectedAll],
	            listeners: {
	                afterrender: function afterrender() {
	                    this.boundList.on('itemdblclick', function () {
	                        uiManager.msUnselect(available, selected);
	                    }, this);
	                }
	            }
	        });
	
	        onSelectAll = function onSelectAll(value) {
	            if (available.boundList && selected.boundList) {
	                if (value) {
	                    available.boundList.disable();
	                    selected.boundList.disable();
	                } else {
	                    available.boundList.enable();
	                    selected.boundList.enable();
	                }
	            }
	
	            onSelect();
	        };
	
	        panel = Ext.create('Ext.panel.Panel', {
	            title: '<div class="' + iconCls + '">' + dimension.name + '</div>',
	            hideCollapseTool: true,
	            dimension: dimension.id,
	            availableStore: availableStore,
	            selectedStore: selectedStore,
	            selectedAll: selectedAll,
	            isDynamic: true,
	            clearDimension: function clearDimension() {
	                availableStore.reset();
	                selectedStore.removeAll();
	                selectedAll.setValue(false);
	            },
	            setDimension: function setDimension(layout) {
	                if (layout.hasDimension(this.dimension, true)) {
	                    var records = layout.getDimension(this.dimension).getRecords();
	
	                    if (records.length) {
	                        selectedStore.add(records);
	                        uiManager.msFilterAvailable({ store: availableStore }, { store: selectedStore });
	                    } else {
	                        selectedAll.setValue(true);
	                    }
	                }
	            },
	            getDimension: function getDimension() {
	                var config = {};
	
	                if (dimension.id) {
	                    config.dimension = dimension.id;
	                }
	
	                if (!selectedAll.getValue() && selectedStore.getRange().length) {
	                    config.items = [];
	
	                    selectedStore.each(function (r) {
	                        config.items.push({ id: r.data.id });
	                    });
	                }
	
	                return config.dimension ? config : null;
	            },
	            getHeightValue: function getHeightValue() {
	                var westRegion = uiManager.get('westRegion');
	
	                return westRegion.hasScrollbar ? uiConfig.west_scrollbarheight_accordion_group : uiConfig.west_maxheight_accordion_group;
	            },
	            onExpand: function onExpand() {
	                // load items
	                if (!availableStore.isLoaded) {
	                    availableStore.loadPage();
	                }
	
	                // enable/disable ui
	                if (selectedAll.getValue()) {
	                    available.boundList.disable();
	                    selected.boundList.disable();
	                }
	
	                // set height
	                var westRegion = uiManager.get('westRegion');
	                var accordion = uiManager.get('accordion');
	
	                var accordionHeight = westRegion.hasScrollbar ? uiConfig.west_scrollbarheight_accordion_group : uiConfig.west_maxheight_accordion_group;
	
	                accordion.setThisHeight(accordionHeight);
	
	                uiManager.msSetHeight([available, selected], this, uiConfig.west_fill_accordion_group);
	            },
	            items: [{
	                xtype: 'panel',
	                layout: 'column',
	                bodyStyle: 'border-style:none',
	                items: [available, selected]
	            }],
	            listeners: {
	                expand: function expand(p) {
	                    p.onExpand();
	                }
	            }
	        });
	
	        return panel;
	    };
	
	    // accordion
	    var defaultItems = [data, period, organisationUnit].concat(_toConsumableArray(appManager.dimensions.map(function (dimension) {
	        var panel = getDimensionPanel(dimension, 'ns-panel-title-dimension');
	
	        accordionPanels.push(uiManager.reg(panel, panel.dimension));
	
	        return panel;
	    })));
	
	    var getItems = function getItems() {
	        var dimensions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
	        return dimensions.map(function (dimension) {
	            return getDimensionPanel(dimension, 'ns-panel-title-dimension');
	        });
	    };
	
	    var accordionBody = Ext.create('Ext.panel.Panel', {
	        layout: 'accordion',
	        activeOnTop: true,
	        cls: 'ns-accordion',
	        bodyStyle: 'border:0 none',
	        height: 700,
	        toBeRemoved: [],
	        addItems: function addItems(dimensions) {
	            this.toBeRemoved = this.add(getItems(dimensions));
	
	            accordion.setThisHeight();
	        },
	        removeItems: function removeItems() {
	            this.toBeRemoved.map(function (item) {
	                return (0, _isString2.default)(item) ? item : item.id;
	            }).forEach(function (id) {
	                accordionBody.remove(id);
	            });
	
	            accordion.setThisHeight();
	
	            this.toBeRemoved = [];
	        },
	        getExpandedPanel: function getExpandedPanel() {
	            var expandedPanel;
	
	            this.items.each(function (panel) {
	                if (!panel.collapsed) {
	                    expandedPanel = panel;
	                    return false;
	                }
	            });
	
	            return expandedPanel;
	        },
	        items: defaultItems
	    });
	
	    // functions
	
	    var setUiState = function setUiState(layout, response) {
	        var viewport = uiManager.get('viewport');
	
	        var dataTypeToolbar = uiManager.get('dataTypeToolbar'),
	            chartTypeToolbar = uiManager.get('chartTypeToolbar'),
	            aggLayoutWindow = uiManager.get('aggregateLayoutWindow'),
	            queryLayoutWindow = uiManager.get('queryLayoutWindow'),
	            aggOptionsWindow = uiManager.get('aggregateOptionsWindow'),
	            queryOptionsWindow = uiManager.get('queryOptionsWindow');
	
	        if (dataTypeToolbar) {
	            dataTypeToolbar.setDataType(layout ? layout.dataType : null);
	        }
	
	        if (chartTypeToolbar) {
	            chartTypeToolbar.setChartType(layout ? layout.type : null);
	        }
	
	        if (aggLayoutWindow) {
	            aggLayoutWindow.reset();
	        }
	
	        if (queryLayoutWindow) {
	            queryLayoutWindow.reset();
	        }
	
	        if (aggOptionsWindow) {
	            aggOptionsWindow.setOptions(layout);
	        }
	
	        if (queryOptionsWindow) {
	            queryOptionsWindow.setOptions(layout);
	        }
	
	        // dimensions
	        accordion.clearDimensions(layout);
	
	        if (layout) {
	            // data
	            programStore.add(layout.program);
	            program.setValue(layout.program.id);
	
	            // periods
	            period.setDimension(layout);
	
	            // organisation units
	            organisationUnit.setDimension(layout);
	
	            // data, dynamic dimensions and layout window
	            setData(layout);
	        }
	
	        //var statusBar = uiManager.get('statusBar');
	
	        // state
	        //uiManager.get('downloadButton').enable();
	
	        //if (layout.id) {
	        //uiManager.get('shareButton').enable();
	        //}
	
	        //statusBar.setStatus(layout, response);
	    };
	
	    var getUiState = function getUiState(layoutWindow, optionsWindow, chartType, dataType) {
	        var viewport = uiManager.get('viewport'),
	            panels = uiManager.get('accordion').panels,
	            dataTypeToolbar = uiManager.get('dataTypeToolbar'),
	            aggregateLayoutWindow = uiManager.get('aggregateLayoutWindow'),
	            aggregateOptionsWindow = uiManager.get('aggregateOptionsWindow'),
	            queryOptionsWindow = uiManager.get('queryOptionsWindow'),
	            statusBar = uiManager.get('statusBar'),
	            config = {},
	            map = {},
	            columns = [],
	            rows = [],
	            filters = [],
	            values = [],
	            addAxisDimension,
	            store,
	            data;
	
	        layoutWindow = layoutWindow || viewport.getLayoutWindow();
	
	        config.program = program.getRecord();
	        config.programStage = stage.getRecord();
	
	        if (!(config.program && config.programStage)) {
	            return;
	        }
	
	        if (dataTypeToolbar) {
	            var dataType = dataTypeToolbar.getDataType();
	        }
	
	        // dy
	        map['dy'] = [{ dimension: 'dy' }];
	
	        // pe
	        if (periodMode.getValue() === 'dates') {
	            config.startDate = startDate.getSubmitValue();
	            config.endDate = endDate.getSubmitValue();
	
	            if (!(config.startDate && config.endDate)) {
	                return;
	            }
	        } else if (periodMode.getValue() === 'periods') {
	            map['pe'] = [periods.getDimension()];
	        }
	
	        // ou
	        map['ou'] = [treePanel.getDimension()];
	
	        // data items
	        for (var i = 0, record; i < dataElementSelected.items.items.length; i++) {
	            record = dataElementSelected.items.items[i].getRecord();
	
	            map[record.dimension] = map[record.dimension] || [];
	
	            map[record.dimension].push(record);
	        }
	
	        // dynamic dimensions data
	        accordionBody.items.each(function (panel) {
	            if (panel.isDynamic && panel.getDimension) {
	                var dim = panel.getDimension();
	
	                if (dim && dim.dimension) {
	                    map[dim.dimension] = [dim];
	                }
	            }
	        });
	
	        // other
	        map['longitude'] = [{ dimension: 'longitude' }];
	        map['latitude'] = [{ dimension: 'latitude' }];
	
	        addAxisDimension = function addAxisDimension(a, axis) {
	            if (a.length) {
	                if (a.length === 1) {
	                    axis.push(a[0]);
	                } else {
	                    var dim;
	
	                    for (var i = 0; i < a.length; i++) {
	                        if (!dim) {
	                            //todo ??
	                            dim = a[i];
	                        } else {
	                            dim.filter += ':' + a[i].filter;
	                        }
	                    }
	
	                    axis.push(dim);
	                }
	            }
	        };
	
	        // columns
	        store = layoutWindow.colStore;
	
	        if (store) {
	            data = store.findExact('id', 'dy') === -1 ? store.data : store.snapshot;
	
	            data.each(function (item) {
	                addAxisDimension(map[item.data.id || item.data.dimensionName] || [], columns);
	            });
	        }
	
	        // rows
	        store = layoutWindow.rowStore;
	
	        if (store) {
	            data = store.findExact('id', 'dy') === -1 ? store.data : store.snapshot;
	
	            data.each(function (item) {
	                addAxisDimension(map[item.data.id || item.data.dimensionName] || [], rows);
	            });
	        }
	
	        // filters
	        store = layoutWindow.filterStore;
	
	        if (store) {
	            data = store.findExact('id', 'dy') === -1 ? store.data : store.snapshot;
	
	            data.each(function (item) {
	                addAxisDimension(map[item.data.id || item.data.dimensionName] || [], filters);
	            });
	        }
	
	        // fixed filters
	        store = layoutWindow.fixedFilterStore;
	
	        if (store) {
	            data = store.findExact('id', 'dy') === -1 ? store.data : store.snapshot;
	
	            data.each(function (item) {
	                addAxisDimension(map[item.data.id || item.data.dimensionName] || [], filters);
	            });
	        }
	
	        if (columns.length) {
	            config.columns = columns;
	        }
	        if (rows.length) {
	            config.rows = rows;
	        }
	        if (filters.length) {
	            config.filters = filters;
	        }
	
	        // value, aggregation type
	        Ext.apply(config, layoutWindow.getValueConfig());
	
	        if (dataType === dimensionConfig.dataType['aggregated_values']) {
	            Ext.applyIf(config, aggregateOptionsWindow.getOptions());
	            Ext.applyIf(config, aggregateLayoutWindow.getOptions());
	
	            // if order and limit -> sort
	            if (config.sortOrder && config.topLimit) {
	                config.sorting = {
	                    id: 1,
	                    direction: config.sortOrder == 1 ? 'DESC' : 'ASC'
	                };
	            }
	        }
	
	        if (dataType === dimensionConfig.dataType['individual_cases']) {
	            Ext.applyIf(config, queryOptionsWindow.getOptions());
	
	            if (statusBar) {
	                config.paging = {
	                    page: uiManager.get('statusBar').getCurrentPage(),
	                    pageSize: 100
	                };
	            }
	        }
	
	        return config;
	    };
	
	    var accordion = Ext.create('Ext.panel.Panel', (_Ext$create = {
	        bodyStyle: 'border-style:none; padding:1px; padding-bottom:0; overflow-y:scroll;',
	        accordionBody: accordionBody,
	        items: accordionBody,
	        panels: accordionPanels,
	        expandInitPanels: function expandInitPanels() {
	            organisationUnit.expand();
	        },
	        clearDimensions: function clearDimensions(layout) {
	            accordionPanels.forEach(function (panel) {
	                panel.clearDimension(!!layout);
	            });
	        },
	        setDimensions: function setDimensions(layout, dynamicOnly) {
	            accordionPanels.forEach(function (panel) {
	                if (dynamicOnly && !panel.isDynamic) {
	                    return;
	                }
	
	                panel.setDimension(layout);
	            });
	        },
	        setThisHeight: function setThisHeight(mx) {
	            mx = mx || this.getExpandedPanel().getHeightValue();
	
	            var settingsHeight = 41;
	
	            var containerHeight = settingsHeight + accordionBody.items.items.length * 28 + mx,
	                accordionHeight = uiManager.get('westRegion').getHeight() - settingsHeight - uiConfig.west_fill,
	                accordionBodyHeight;
	
	            if (uiManager.get('westRegion').hasScrollbar) {
	                accordionBodyHeight = containerHeight - settingsHeight - uiConfig.west_fill;
	            } else {
	                accordionBodyHeight = (accordionHeight > containerHeight ? containerHeight : accordionHeight) - uiConfig.west_fill;
	            }
	
	            this.setHeight(accordionHeight);
	            accordionBody.setHeight(accordionBodyHeight);
	        },
	        getExpandedPanel: function getExpandedPanel() {
	            return accordionBody.getExpandedPanel();
	        },
	        getFirstPanel: function getFirstPanel() {
	            return this.panels[0];
	        },
	        getParentGraphMap: function getParentGraphMap() {
	            return treePanel.getParentGraphMap();
	        },
	        getUxArray: function getUxArray(id) {
	            return dataElementSelected.getUxArrayById(id);
	        }
	
	    }, _defineProperty(_Ext$create, 'accordionBody', accordionBody), _defineProperty(_Ext$create, 'panels', accordionPanels), _defineProperty(_Ext$create, 'treePanel', treePanel), _defineProperty(_Ext$create, 'getUiState', getUiState), _defineProperty(_Ext$create, 'setUiState', setUiState), _defineProperty(_Ext$create, 'onTypeClick', onTypeClick), _Ext$create));
	
	    return accordion;
	};
	//# sourceMappingURL=WestRegionTrackerItems.js.map

/***/ },
/* 172 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.Plugin = undefined;
	
	var _isArray = __webpack_require__(1);
	
	var _isArray2 = _interopRequireDefault(_isArray);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var Plugin = exports.Plugin = undefined;
	
	exports.Plugin = Plugin = function Plugin(_ref) {
	    var refs = _ref.refs,
	        _ref$inits = _ref.inits,
	        inits = _ref$inits === undefined ? [] : _ref$inits,
	        renderFn = _ref.renderFn,
	        initializeFn = _ref.initializeFn,
	        type = _ref.type;
	
	    var t = this;
	
	    // public properties
	    t.url = null;
	    t.username = null;
	    t.password = null;
	    t.auth = null;
	    t.loadingIndicator = false;
	
	    // private properties
	    var _layouts = [];
	    var _isPending = false;
	    var _isReady = false;
	
	    // public functions
	    t.add = function () {
	        for (var _len = arguments.length, layouts = Array(_len), _key = 0; _key < _len; _key++) {
	            layouts[_key] = arguments[_key];
	        }
	
	        layouts = (0, _isArray2.default)(layouts[0]) ? layouts[0] : layouts;
	
	        if (layouts.length) {
	            _layouts = [].concat(_toConsumableArray(_layouts), _toConsumableArray(layouts));
	        }
	    };
	
	    t.load = function () {
	        for (var _len2 = arguments.length, layouts = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	            layouts[_key2] = arguments[_key2];
	        }
	
	        t.add((0, _isArray2.default)(layouts[0]) ? layouts[0] : layouts);
	
	        _runFn();
	    };
	
	    t.getType = function () {
	        return type;
	    };
	
	    // private functions
	    var _readyFn = function _readyFn() {
	        _isReady = true;
	        _isPending = false;
	    };
	
	    var _pendingFn = function _pendingFn() {
	        _isPending = true;
	    };
	
	    var _runFn = function _runFn() {
	        var initializeFn = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initializeFn || _initializeFn;
	
	        if (_isReady) {
	            while (_layouts.length) {
	                renderFn(t, _layouts.shift());
	            }
	        } else if (!_isPending) {
	            _pendingFn();
	
	            initializeFn();
	        }
	    };
	
	    var _initializeFn = function _initializeFn() {
	        var readyFn = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _readyFn;
	        var runFn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _runFn;
	        var appManager = refs.appManager,
	            requestManager = refs.requestManager,
	            init = refs.init;
	        var Request = refs.api.Request;
	
	
	        var credentials = t.username && t.password ? t.username + ':' + t.password : null;
	        var auth = t.auth;
	
	        appManager.setAuth(credentials, auth);
	        appManager.path = t.url;
	
	        // user account
	        new Request(refs, {
	            baseUrl: appManager.getApiPath() + '/me.json',
	            type: 'json',
	            param: ['fields=id,firstName,surname,userCredentials[username],settings'],
	            success: function success(response) {
	                appManager.userAccount = response;
	
	                // inits
	                inits.forEach(function (initFn) {
	                    return requestManager.add(new Request(refs, initFn(refs)));
	                });
	
	                readyFn();
	
	                requestManager.set(runFn);
	                requestManager.run();
	            }
	        }).run();
	    };
	};
	//# sourceMappingURL=Plugin.js.map

/***/ },
/* 173 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	/**
	 * Partial js port of commons math SimpleRegression class.
	 */
	
	var SimpleRegression = exports.SimpleRegression = undefined;
	
	exports.SimpleRegression = SimpleRegression = function SimpleRegression() {
	    var sumX = 0; // Sum of x values
	    var sumY = 0; // Sum of y values
	    var sumXX = 0; // Total variation in x
	    var sumXY = 0; // Sum of products
	    var n = 0; // Number of observations
	    var xbar = 0; // Mean of accumulated x values, used in updating formulas
	    var ybar = 0; // Mean of accumulated y values, used in updating formulas
	
	    this.addData = function (x, y) {
	        if (n == 0) {
	            xbar = x;
	            ybar = y;
	        } else {
	            var dx = x - xbar;
	            var dy = y - ybar;
	            sumXX += dx * dx * n / (n + 1);
	            sumXY += dx * dy * n / (n + 1);
	            xbar += dx / (n + 1);
	            ybar += dy / (n + 1);
	        }
	
	        sumX += x;
	        sumY += y;
	        n++;
	    };
	
	    this.predict = function (x) {
	        var b1 = this.getSlope();
	
	        return this.getIntercept(b1) + b1 * x;
	    };
	
	    this.getSlope = function () {
	        if (n < 2) {
	            return Number.NaN;
	        }
	
	        return sumXY / sumXX;
	    };
	
	    this.getIntercept = function (slope) {
	        return (sumY - slope * sumX) / n;
	    };
	};
	//# sourceMappingURL=SimpleRegression.js.map

/***/ },
/* 174 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var calculateColorBrightness = function calculateColorBrightness(rgb) {
	    return Math.round((parseInt(rgb[0]) * 299 + parseInt(rgb[1]) * 587 + parseInt(rgb[2]) * 114) / 1000);
	};
	
	var isHex = function isHex(color) {
	    return typeof color === 'string' && color.charAt(0) === "#";
	};
	
	var isColorBright = exports.isColorBright = function isColorBright(color) {
	
	    if (isHex(color)) {
	        color = hexToRgb(color);
	    }
	
	    return calculateColorBrightness(color) > 125;
	};
	
	var hexToRgb = exports.hexToRgb = function hexToRgb(hex) {
	    var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
	
	    return result ? [parseInt(result[1], 16), parseInt(result[2], 16), parseInt(result[3], 16)] : null;
	};
	//# sourceMappingURL=colorUtils.js.map

/***/ },
/* 175 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = function (type) {
	    switch (type) {
	        case 'STRING':
	        case 'TEXT':
	            return function (item) {
	                return '' + item;
	            };
	        case 'INTEGER':
	        case 'NUMBER':
	            return function (item) {
	                return (0, _isNumeric2.default)(item) ? parseFloat(item) : item;
	            };
	        default:
	            return function (item) {
	                return item;
	            };
	    }
	};
	
	var _isNumeric = __webpack_require__(22);
	
	var _isNumeric2 = _interopRequireDefault(_isNumeric);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	;
	//# sourceMappingURL=getParseMiddleware.js.map

/***/ },
/* 176 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.DataElementBooleanContainer = undefined;
	
	var _arrayDifference = __webpack_require__(42);
	
	var _arrayDifference2 = _interopRequireDefault(_arrayDifference);
	
	var _arrayFrom = __webpack_require__(5);
	
	var _arrayFrom2 = _interopRequireDefault(_arrayFrom);
	
	var _arrayContains = __webpack_require__(4);
	
	var _arrayContains2 = _interopRequireDefault(_arrayContains);
	
	var _isObject = __webpack_require__(2);
	
	var _isObject2 = _interopRequireDefault(_isObject);
	
	var _isString = __webpack_require__(3);
	
	var _isString2 = _interopRequireDefault(_isString);
	
	var _containerConfig = __webpack_require__(20);
	
	var _containerConfig2 = _interopRequireDefault(_containerConfig);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DataElementBooleanContainer = exports.DataElementBooleanContainer = undefined;
	
	exports.DataElementBooleanContainer = DataElementBooleanContainer = function DataElementBooleanContainer(refs) {
	    var i18n = refs.i18nManager.get();
	
	    Ext.define('Ext.ux.container.DataElementBooleanContainer', {
	        extend: 'Ext.container.Container',
	        alias: 'widget.dataelementbooleancontainer',
	        cls: 'ns-dxselector',
	        layout: 'column',
	        bodyStyle: 'border:0 none',
	        style: 'margin: ' + _containerConfig2.default.margin,
	        getRecord: function getRecord() {
	            var items = this.valueCmp.getValue(),
	                record = {
	                dimension: this.dataElement.id,
	                name: this.dataElement.name
	            };
	
	            // array or object
	            for (var i = 0; i < items.length; i++) {
	                if ((0, _isObject2.default)(items[i])) {
	                    items[i] = items[i].code;
	                }
	            }
	
	            if (items.length) {
	                record.filter = 'IN:' + items.join(';');
	            }
	
	            return record;
	        },
	        setRecord: function setRecord(record) {
	            if ((0, _isString2.default)(record.filter) && record.filter.length) {
	                var a = record.filter.split(':');
	                this.valueCmp.setOptionValues(a[1].split(';'));
	            }
	        },
	        getRecordsByCode: function getRecordsByCode(options, codeArray) {
	            var records = [];
	
	            for (var i = 0; i < options.length; i++) {
	                for (var j = 0; j < codeArray.length; j++) {
	                    if (options[i].code === codeArray[j]) {
	                        records.push(options[i]);
	                    }
	                }
	            }
	
	            return records;
	        },
	        initComponent: function initComponent() {
	            var container = this,
	                idProperty = 'id',
	                nameProperty = 'name';
	
	            this.nameCmp = Ext.create('Ext.form.Label', {
	                text: this.dataElement.name,
	                flex: 1,
	                style: 'padding:' + _containerConfig2.default.namePadding
	            });
	
	            this.addCmp = Ext.create('Ext.button.Button', {
	                cls: 'ns-linkbutton',
	                style: 'padding: 0',
	                height: 18,
	                text: 'Duplicate',
	                handler: function handler() {
	                    container.duplicateDataElement();
	                }
	            });
	
	            this.removeCmp = Ext.create('Ext.button.Button', {
	                cls: 'ns-linkbutton',
	                style: _containerConfig2.default.removeCmpStyle,
	                height: 18,
	                text: 'Remove',
	                handler: function handler() {
	                    container.removeDataElement();
	                }
	            });
	
	            this.operatorCmp = Ext.create('Ext.form.field.ComboBox', {
	                valueField: 'id',
	                displayField: 'name',
	                queryMode: 'local',
	                editable: false,
	                style: 'margin-bottom:0',
	                width: _containerConfig2.default.operatorCmpWidth,
	                value: 'IN',
	                store: {
	                    fields: ['id', 'name'],
	                    data: [{ id: 'IN', name: 'One of' }]
	                }
	            });
	
	            this.getData = function (idArray) {
	                var data = [],
	                    yes = {},
	                    no = {};
	
	                yes[idProperty] = '1';
	                yes[nameProperty] = i18n.yes;
	                no[idProperty] = '0';
	                no[nameProperty] = i18n.no;
	
	                for (var i = 0; i < idArray.length; i++) {
	                    if (idArray[i] === '1' || idArray[i] === 1) {
	                        data.push(yes);
	                    } else if (idArray[i] === '0' || idArray[i] === 0) {
	                        data.push(no);
	                    }
	                }
	
	                return data;
	            };
	
	            this.searchStore = Ext.create('Ext.data.Store', {
	                fields: [idProperty, nameProperty],
	                data: container.getData(['1', '0'])
	            });
	
	            // function
	            this.filterSearchStore = function (isLayout) {
	                var selected = container.valueCmp.getValue();
	
	                // hack, using internal method to activate dropdown before filtering
	                if (isLayout) {
	                    container.searchCmp.onTriggerClick();
	                    container.searchCmp.collapse();
	                }
	
	                // filter
	                container.searchStore.clearFilter();
	
	                container.searchStore.filterBy(function (record) {
	                    return !(0, _arrayContains2.default)(selected, record.data[idProperty]);
	                });
	            };
	
	            this.searchCmp = Ext.create('Ext.form.field.ComboBox', {
	                multiSelect: true,
	                width: _containerConfig2.default.operatorCmpWidth,
	                style: 'margin-bottom:0',
	                emptyText: 'Select..',
	                valueField: idProperty,
	                displayField: nameProperty,
	                queryMode: 'local',
	                listConfig: {
	                    minWidth: _containerConfig2.default.nameCmpWidth - _containerConfig2.default.operatorCmpWidth
	                },
	                store: this.searchStore,
	                listeners: {
	                    select: function select() {
	                        var id = (0, _arrayFrom2.default)(this.getValue())[0];
	
	                        // value
	                        if (container.valueStore.findExact(idProperty, id) === -1) {
	                            container.valueStore.add(container.searchStore.getAt(container.searchStore.findExact(idProperty, id)).data);
	                        }
	
	                        // search
	                        this.select([]);
	
	                        // filter
	                        container.filterSearchStore();
	                    },
	                    expand: function expand() {
	                        container.filterSearchStore();
	                    }
	                }
	            });
	
	            this.valueStore = Ext.create('Ext.data.Store', {
	                fields: [idProperty, nameProperty],
	                listeners: {
	                    add: function add() {
	                        container.valueCmp.select(this.getRange());
	                    },
	                    remove: function remove() {
	                        container.valueCmp.select(this.getRange());
	                    }
	                }
	            });
	
	            this.valueCmp = Ext.create('Ext.form.field.ComboBox', {
	                multiSelect: true,
	                style: 'margin-bottom:0',
	                width: _containerConfig2.default.nameCmpWidth - _containerConfig2.default.operatorCmpWidth - _containerConfig2.default.operatorCmpWidth,
	                valueField: idProperty,
	                displayField: nameProperty,
	                emptyText: 'No selected items',
	                editable: false,
	                hideTrigger: true,
	                store: container.valueStore,
	                queryMode: 'local',
	                listConfig: {
	                    minWidth: 266,
	                    cls: 'ns-optionselector'
	                },
	                setOptionValues: function setOptionValues(codeArray) {
	                    container.valueStore.removeAll();
	                    container.valueStore.loadData(container.getData(codeArray));
	
	                    this.setValue(codeArray);
	                    container.filterSearchStore(true);
	                    container.searchCmp.blur();
	                },
	                listeners: {
	                    change: function change(cmp, newVal, oldVal) {
	                        newVal = (0, _arrayFrom2.default)(newVal);
	                        oldVal = (0, _arrayFrom2.default)(oldVal);
	
	                        if (newVal.length < oldVal.length) {
	                            var id = (0, _arrayDifference2.default)(oldVal, newVal)[0];
	                            container.valueStore.removeAt(container.valueStore.findExact(idProperty, id));
	                        }
	                    }
	                }
	            });
	
	            this.items = [{
	                xtype: 'container',
	                layout: 'hbox',
	                width: _containerConfig2.default.nameCmpWidth,
	                items: [this.nameCmp,
	                //this.addCmp,
	                this.removeCmp]
	            }, this.operatorCmp, this.searchCmp, this.valueCmp];
	
	            this.self.superclass.initComponent.call(this);
	        }
	    });
	};
	//# sourceMappingURL=DataElementBooleanContainer.js.map

/***/ },
/* 177 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.DataElementDateContainer = undefined;
	
	var _isString = __webpack_require__(3);
	
	var _isString2 = _interopRequireDefault(_isString);
	
	var _containerConfig = __webpack_require__(20);
	
	var _containerConfig2 = _interopRequireDefault(_containerConfig);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DataElementDateContainer = exports.DataElementDateContainer = undefined;
	
	exports.DataElementDateContainer = DataElementDateContainer = function DataElementDateContainer(refs) {
	    Ext.define('Ext.ux.container.DataElementDateContainer', {
	        extend: 'Ext.container.Container',
	        alias: 'widget.dataelementdatecontainer',
	        cls: 'ns-dxselector',
	        layout: 'column',
	        bodyStyle: 'border:0 none',
	        style: 'margin: ' + _containerConfig2.default.margin,
	        getRecord: function getRecord() {
	            var record = {};
	
	            record.dimension = this.dataElement.id;
	            record.name = this.dataElement.name;
	
	            if (this.valueCmp.getValue()) {
	                record.filter = this.operatorCmp.getValue() + ':' + this.valueCmp.getSubmitValue();
	            }
	
	            return record;
	        },
	        setRecord: function setRecord(record) {
	            if (record.filter && (0, _isString2.default)(record.filter)) {
	                var a = record.filter.split(':');
	
	                this.operatorCmp.setValue(a[0]);
	                this.valueCmp.setValue(a[1]);
	            }
	        },
	        initComponent: function initComponent() {
	            var container = this;
	
	            this.nameCmp = Ext.create('Ext.form.Label', {
	                text: this.dataElement.name,
	                flex: 1,
	                style: 'padding:' + _containerConfig2.default.namePadding
	            });
	
	            this.addCmp = Ext.create('Ext.button.Button', {
	                cls: 'ns-linkbutton',
	                style: 'padding: 0',
	                height: 18,
	                text: 'Duplicate',
	                handler: function handler() {
	                    container.duplicateDataElement();
	                }
	            });
	
	            this.removeCmp = Ext.create('Ext.button.Button', {
	                cls: 'ns-linkbutton',
	                style: _containerConfig2.default.removeCmpStyle,
	                height: 18,
	                text: 'Remove',
	                handler: function handler() {
	                    container.removeDataElement();
	                }
	            });
	
	            this.operatorCmp = Ext.create('Ext.form.field.ComboBox', {
	                valueField: 'id',
	                displayField: 'name',
	                queryMode: 'local',
	                editable: false,
	                width: _containerConfig2.default.operatorCmpWidth,
	                style: 'margin-bottom:0',
	                value: 'EQ',
	                store: {
	                    fields: ['id', 'name'],
	                    data: [{ id: 'EQ', name: '=' }, { id: 'GT', name: '>' }, { id: 'GE', name: '>=' }, { id: 'LT', name: '<' }, { id: 'LE', name: '<=' }, { id: 'NE', name: '!=' }]
	                }
	            });
	
	            this.valueCmp = Ext.create('Ext.form.field.Date', {
	                width: _containerConfig2.default.nameCmpWidth - _containerConfig2.default.operatorCmpWidth,
	                style: 'margin-bottom:0',
	                format: 'Y-m-d'
	            });
	
	            this.items = [{
	                xtype: 'container',
	                layout: 'hbox',
	                width: _containerConfig2.default.nameCmpWidth,
	                items: [this.nameCmp, this.addCmp, this.removeCmp]
	            }, this.operatorCmp, this.valueCmp];
	
	            this.self.superclass.initComponent.call(this);
	        }
	    });
	};
	//# sourceMappingURL=DataElementDateContainer.js.map

/***/ },
/* 178 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.DataElementIntegerContainer = undefined;
	
	var _arrayDifference = __webpack_require__(42);
	
	var _arrayDifference2 = _interopRequireDefault(_arrayDifference);
	
	var _arrayFrom = __webpack_require__(5);
	
	var _arrayFrom2 = _interopRequireDefault(_arrayFrom);
	
	var _arrayContains = __webpack_require__(4);
	
	var _arrayContains2 = _interopRequireDefault(_arrayContains);
	
	var _isArray = __webpack_require__(1);
	
	var _isArray2 = _interopRequireDefault(_isArray);
	
	var _isObject = __webpack_require__(2);
	
	var _isObject2 = _interopRequireDefault(_isObject);
	
	var _isString = __webpack_require__(3);
	
	var _isString2 = _interopRequireDefault(_isString);
	
	var _containerConfig = __webpack_require__(20);
	
	var _containerConfig2 = _interopRequireDefault(_containerConfig);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DataElementIntegerContainer = exports.DataElementIntegerContainer = undefined;
	
	exports.DataElementIntegerContainer = DataElementIntegerContainer = function DataElementIntegerContainer(refs) {
	    var appManager = refs.appManager;
	
	    var i18n = refs.i18nManager.get();
	
	    Ext.define('Ext.ux.container.DataElementIntegerContainer', {
	        extend: 'Ext.container.Container',
	        alias: 'widget.dataelementintegercontainer',
	        cls: 'ns-dxselector',
	        layout: 'column',
	        bodyStyle: 'border:0 none',
	        style: 'margin: ' + _containerConfig2.default.margin,
	        getRecord: function getRecord() {
	            var record = {},
	                rangeSet = this.rangeSetCmp.getValue();
	
	            var isRange = rangeSet !== _containerConfig2.default.defaultRangeSetId;
	
	            record.dimension = this.dataElement.id;
	            record.name = this.dataElement.name;
	
	            if (isRange) {
	                record.legendSet = {
	                    id: rangeSet
	                };
	
	                var ranges = this.rangeValueCmp.getValue();
	
	                if (ranges.length) {
	                    record.filter = 'IN:' + ranges.join(';');
	                }
	            } else {
	                if (this.valueCmp.getValue()) {
	                    record.filter = this.operatorCmp.getValue() + ':' + this.valueCmp.getValue();
	                }
	            }
	
	            return record;
	        },
	        setRecord: function setRecord(record) {
	            if ((0, _isObject2.default)(record.legendSet) && record.legendSet.id) {
	                //this.rangeSetCmp.pendingValue = record.legendSet.id;
	                this.rangeSetCmp.store.add(appManager.getLegendSetById(record.legendSet.id));
	                this.rangeSetCmp.setValue(record.legendSet.id);
	
	                this.onRangeSetSelect(record.legendSet.id);
	
	                if (record.filter) {
	                    var a = record.filter.split(':');
	
	                    if (a.length > 1 && (0, _isString2.default)(a[1])) {
	                        this.onRangeSearchSelect(a[1].split(';'), true);
	                    }
	                }
	            } else {
	                this.rangeSetCmp.setValue(_containerConfig2.default.defaultRangeSetId);
	                this.onRangeSetSelect(_containerConfig2.default.defaultRangeSetId);
	
	                if (record.filter) {
	                    var a = record.filter.split(':');
	
	                    if (a.length > 1) {
	                        this.operatorCmp.setValue(a[0]);
	                        this.valueCmp.setValue(a[1]);
	                    }
	                }
	            }
	        },
	        initComponent: function initComponent() {
	            var container = this,
	                idProperty = 'id',
	                nameProperty = 'name',
	                displayProperty = 'displayName';
	
	            this.nameCmp = Ext.create('Ext.form.Label', {
	                text: this.dataElement.name,
	                flex: 1,
	                style: 'padding:' + _containerConfig2.default.namePadding
	            });
	
	            this.addCmp = Ext.create('Ext.button.Button', {
	                cls: 'ns-linkbutton',
	                style: 'padding: 0',
	                height: 18,
	                text: i18n.duplicate,
	                handler: function handler() {
	                    container.duplicateDataElement();
	                }
	            });
	
	            this.removeCmp = Ext.create('Ext.button.Button', {
	                cls: 'ns-linkbutton',
	                style: _containerConfig2.default.removeCmpStyle,
	                height: 18,
	                text: i18n.remove,
	                handler: function handler() {
	                    container.removeDataElement();
	                }
	            });
	
	            this.operatorCmp = Ext.create('Ext.form.field.ComboBox', {
	                valueField: idProperty,
	                displayField: nameProperty,
	                queryMode: 'local',
	                editable: false,
	                width: _containerConfig2.default.operatorCmpWidth,
	                style: 'margin-bottom:0',
	                value: 'EQ',
	                store: {
	                    fields: [idProperty, nameProperty],
	                    data: [{ id: 'EQ', name: '=' }, { id: 'GT', name: '>' }, { id: 'GE', name: '>=' }, { id: 'LT', name: '<' }, { id: 'LE', name: '<=' }, { id: 'NE', name: '!=' }]
	                }
	            });
	
	            this.valueCmp = Ext.create('Ext.form.field.Number', {
	                width: _containerConfig2.default.nameCmpWidth - _containerConfig2.default.operatorCmpWidth - _containerConfig2.default.rangeSetWidth,
	                style: 'margin-bottom:0'
	            });
	
	            this.rangeSearchStore = Ext.create('Ext.data.Store', {
	                fields: [idProperty, nameProperty]
	            });
	
	            // function
	            this.filterSearchStore = function (isLayout) {
	                var selected = container.rangeValueCmp.getValue();
	
	                // hack, using internal method to activate dropdown before filtering
	                if (isLayout) {
	                    container.rangeSearchCmp.onTriggerClick();
	                    container.rangeSearchCmp.collapse();
	                }
	
	                // filter
	                container.rangeSearchStore.clearFilter();
	
	                container.rangeSearchStore.filterBy(function (record) {
	                    return !(0, _arrayContains2.default)(selected, record.data[idProperty]);
	                });
	            };
	
	            // function
	            this.onRangeSearchSelect = function (ids, isLayout) {
	                ids = (0, _arrayFrom2.default)(ids);
	
	                // store
	                for (var i = 0, id; i < ids.length; i++) {
	                    id = ids[i];
	
	                    if (container.rangeValueStore.findExact(idProperty, id) === -1) {
	                        container.rangeValueStore.add(container.rangeSearchStore.getAt(container.rangeSearchStore.findExact(idProperty, id)).data);
	                    }
	                }
	
	                // search cmp
	                container.rangeSearchCmp.select([]);
	
	                // filter
	                container.filterSearchStore(isLayout);
	            };
	
	            this.rangeSearchCmp = Ext.create('Ext.form.field.ComboBox', {
	                multiSelect: true,
	                width: _containerConfig2.default.operatorCmpWidth,
	                style: 'margin-bottom: 0',
	                emptyText: i18n.select + '..',
	                valueField: idProperty,
	                displayField: displayProperty,
	                editable: false,
	                queryMode: 'local',
	                hidden: true,
	                store: this.rangeSearchStore,
	                listConfig: {
	                    minWidth: _containerConfig2.default.operatorCmpWidth + (_containerConfig2.default.nameCmpWidth - _containerConfig2.default.operatorCmpWidth - _containerConfig2.default.rangeSetWidth)
	                },
	                listeners: {
	                    select: function select() {
	                        container.onRangeSearchSelect((0, _arrayFrom2.default)(this.getValue())[0]);
	                    },
	                    expand: function expand() {
	                        container.filterSearchStore();
	                    }
	                }
	            });
	
	            this.rangeValueStore = Ext.create('Ext.data.Store', {
	                fields: [idProperty, nameProperty],
	                listeners: {
	                    add: function add() {
	                        container.rangeValueCmp.select(this.getRange());
	                    },
	                    remove: function remove() {
	                        container.rangeValueCmp.select(this.getRange());
	                    }
	                }
	            });
	
	            this.rangeValueCmp = Ext.create('Ext.form.field.ComboBox', {
	                multiSelect: true,
	                style: 'margin-bottom: 0',
	                width: _containerConfig2.default.nameCmpWidth - _containerConfig2.default.operatorCmpWidth - _containerConfig2.default.rangeSetWidth,
	                valueField: idProperty,
	                displayField: nameProperty,
	                emptyText: 'No selected items',
	                editable: false,
	                hideTrigger: true,
	                queryMode: 'local',
	                hidden: true,
	                store: container.rangeValueStore,
	                listConfig: {
	                    minWidth: _containerConfig2.default.valueCmpWidth,
	                    cls: 'ns-optionselector'
	                },
	                setOptionValues: function setOptionValues(records) {
	                    var me = this;
	
	                    container.rangeValueStore.removeAll();
	                    container.rangeValueStore.loadData(records);
	
	                    me.setValue(records);
	                },
	                listeners: {
	                    change: function change(cmp, newVal, oldVal) {
	                        newVal = (0, _arrayFrom2.default)(newVal);
	                        oldVal = (0, _arrayFrom2.default)(oldVal);
	
	                        if (newVal.length < oldVal.length) {
	                            var id = (0, _arrayDifference2.default)(oldVal, newVal)[0];
	                            container.rangeValueStore.removeAt(container.rangeValueStore.findExact(idProperty, id));
	                        }
	                    }
	                }
	            });
	
	            // function
	            this.onRangeSetSelect = function (id) {
	                if (!id || id === _containerConfig2.default.defaultRangeSetId) {
	                    container.operatorCmp.show();
	                    container.valueCmp.show();
	                    container.rangeSearchCmp.hide();
	                    container.rangeValueCmp.hide();
	                } else {
	                    container.operatorCmp.hide();
	                    container.valueCmp.hide();
	                    container.rangeSearchCmp.show();
	                    container.rangeValueCmp.show();
	
	                    // legend display name
	                    var legends = appManager.getLegendSetById(id).legends.slice();
	
	                    legends.forEach(function (legend) {
	                        legend.displayName = legend.name + ' (' + legend.startValue + ' - ' + legend.endValue + ')';
	                    });
	
	                    container.rangeSearchStore.loadData(legends);
	                    container.rangeSearchStore.sort('startValue', 'ASC');
	                }
	            };
	
	            this.rangeSetCmp = Ext.create('Ext.form.field.ComboBox', {
	                cls: 'ns-combo h22',
	                style: 'margin-bottom: 0',
	                width: _containerConfig2.default.rangeSetWidth,
	                height: 22,
	                fieldStyle: 'height: 22px',
	                queryMode: 'local',
	                valueField: idProperty,
	                displayField: nameProperty,
	                editable: false,
	                storage: {},
	                pendingValue: null,
	                setPendingValue: function setPendingValue() {
	                    if (this.pendingValue) {
	                        this.setValue(this.pendingValue);
	                        container.onRangeSetSelect(this.pendingValue);
	
	                        this.pendingValue = null;
	                    }
	
	                    if (!this.getValue()) {
	                        this.pendingValue = _containerConfig2.default.defaultRangeSetId;
	                        this.setPendingValue();
	                    }
	                },
	                store: Ext.create('Ext.data.Store', {
	                    fields: [idProperty, nameProperty]
	                }),
	                listeners: {
	                    added: function added(cb) {
	                        cb.store.add({
	                            id: _containerConfig2.default.defaultRangeSetId,
	                            name: 'No range set'
	                        });
	
	                        var legendSetRecords = container.dataElement.legendSets || container.dataElement.storageLegendSets;
	
	                        if ((0, _isArray2.default)(legendSetRecords) && legendSetRecords.length) {
	
	                            // add legendsets to store
	                            cb.store.add(legendSetRecords.map(function (record) {
	                                return appManager.getLegendSetById(record.id);
	                            }).filter(function (legendSet) {
	                                return (0, _isObject2.default)(legendSet);
	                            }));
	
	                            // select first legendset
	                            cb.setValue(legendSetRecords[0].id);
	                            container.onRangeSetSelect(legendSetRecords[0].id);
	                        }
	
	                        cb.setPendingValue();
	                    },
	                    select: function select(cb, r) {
	                        var id = (0, _arrayFrom2.default)(r)[0].data.id;
	                        container.onRangeSetSelect(id);
	                    }
	                }
	            });
	
	            this.items = [{
	                xtype: 'container',
	                layout: 'hbox',
	                width: _containerConfig2.default.nameCmpWidth,
	                items: [this.nameCmp, this.addCmp, this.removeCmp]
	            }, this.rangeSearchCmp, this.rangeValueCmp, this.operatorCmp, this.valueCmp, this.rangeSetCmp];
	
	            this.self.superclass.initComponent.call(this);
	        }
	    });
	};
	//# sourceMappingURL=DataElementIntegerContainer.js.map

/***/ },
/* 179 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.DataElementStringContainer = undefined;
	
	var _containerConfig = __webpack_require__(20);
	
	var _containerConfig2 = _interopRequireDefault(_containerConfig);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DataElementStringContainer = exports.DataElementStringContainer = undefined;
	
	exports.DataElementStringContainer = DataElementStringContainer = function DataElementStringContainer(refs) {
	    Ext.define('Ext.ux.container.DataElementStringContainer', {
	        extend: 'Ext.container.Container',
	        alias: 'widget.dataelementstringcontainer',
	        cls: 'ns-dxselector',
	        layout: 'column',
	        bodyStyle: 'border:0 none',
	        style: 'margin: ' + _containerConfig2.default.margin,
	        getRecord: function getRecord() {
	            var record = {};
	
	            record.dimension = this.dataElement.id;
	            record.name = this.dataElement.name;
	
	            if (this.valueCmp.getValue()) {
	                record.filter = this.operatorCmp.getValue() + ':' + this.valueCmp.getValue();
	            }
	
	            return record;
	        },
	        setRecord: function setRecord(record) {
	            this.operatorCmp.setValue(record.operator);
	            this.valueCmp.setValue(record.filter);
	        },
	        initComponent: function initComponent() {
	            var container = this;
	
	            this.nameCmp = Ext.create('Ext.form.Label', {
	                text: this.dataElement.name,
	                flex: 1,
	                style: 'padding:' + _containerConfig2.default.namePadding
	            });
	
	            this.addCmp = Ext.create('Ext.button.Button', {
	                cls: 'ns-linkbutton',
	                style: 'padding: 0',
	                height: 18,
	                text: 'Duplicate',
	                handler: function handler() {
	                    container.duplicateDataElement();
	                }
	            });
	
	            this.removeCmp = Ext.create('Ext.button.Button', {
	                cls: 'ns-linkbutton',
	                style: _containerConfig2.default.removeCmpStyle,
	                height: 18,
	                text: 'Remove',
	                handler: function handler() {
	                    container.removeDataElement();
	                }
	            });
	
	            this.operatorCmp = Ext.create('Ext.form.field.ComboBox', {
	                valueField: 'id',
	                displayField: 'name',
	                queryMode: 'local',
	                editable: false,
	                width: _containerConfig2.default.operatorCmpWidth,
	                style: 'margin-bottom:0',
	                value: 'LIKE',
	                store: {
	                    fields: ['id', 'name'],
	                    data: [{ id: 'LIKE', name: 'Contains' }, { id: 'EQ', name: 'Is exact' }]
	                }
	            });
	
	            this.valueCmp = Ext.create('Ext.form.field.Text', {
	                width: _containerConfig2.default.nameCmpWidth - _containerConfig2.default.operatorCmpWidth,
	                style: 'margin-bottom:0'
	            });
	
	            this.items = [{
	                xtype: 'container',
	                layout: 'hbox',
	                width: _containerConfig2.default.nameCmpWidth,
	                items: [this.nameCmp,
	                //this.addCmp,
	                this.removeCmp]
	            }, this.operatorCmp, this.valueCmp];
	
	            this.self.superclass.initComponent.call(this);
	        }
	    });
	};
	//# sourceMappingURL=DataElementStringContainer.js.map

/***/ },
/* 180 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.GroupSetContainer = undefined;
	
	var _arrayDifference = __webpack_require__(42);
	
	var _arrayDifference2 = _interopRequireDefault(_arrayDifference);
	
	var _arrayFrom = __webpack_require__(5);
	
	var _arrayFrom2 = _interopRequireDefault(_arrayFrom);
	
	var _arrayContains = __webpack_require__(4);
	
	var _arrayContains2 = _interopRequireDefault(_arrayContains);
	
	var _isArray = __webpack_require__(1);
	
	var _isArray2 = _interopRequireDefault(_isArray);
	
	var _isObject = __webpack_require__(2);
	
	var _isObject2 = _interopRequireDefault(_isObject);
	
	var _isString = __webpack_require__(3);
	
	var _isString2 = _interopRequireDefault(_isString);
	
	var _containerConfig = __webpack_require__(20);
	
	var _containerConfig2 = _interopRequireDefault(_containerConfig);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var GroupSetContainer = exports.GroupSetContainer = undefined;
	
	exports.GroupSetContainer = GroupSetContainer = function GroupSetContainer(refs) {
	    var api = refs.api,
	        appManager = refs.appManager;
	
	
	    var defaultPageSize = 100;
	
	    Ext.define('Ext.ux.container.GroupSetContainer', {
	        extend: 'Ext.container.Container',
	        alias: 'widget.groupsetcontainer',
	        cls: 'ns-dxselector',
	        layout: 'column',
	        bodyStyle: 'border:0 none',
	        style: 'margin: ' + _containerConfig2.default.margin,
	        getRecord: function getRecord() {
	            var items = this.valueCmp.getValue(),
	                record = {
	                dimension: this.dataElement.id,
	                name: this.dataElement.name
	            };
	
	            // array or object
	            for (var i = 0; i < items.length; i++) {
	                if ((0, _isObject2.default)(items[i])) {
	                    items[i] = items[i].code;
	                }
	            }
	
	            if (items.length) {
	                record.filter = 'IN:' + items.join(';');
	            }
	
	            return record;
	        },
	        setRecord: function setRecord(record) {
	            if ((0, _isString2.default)(record.filter) && record.filter.length) {
	                var a = record.filter.split(':');
	                this.valueCmp.setOptionValues(a[1].split(';'));
	            }
	        },
	        getOptionSetOptions: function getOptionSetOptions(optionSetId, filters, limit, callbackFn) {
	            var params = ['filter=optionSet.id:eq:' + optionSetId, 'fields=code,name'];
	
	            if (limit) {
	                params.push('pageSize=' + defaultPageSize);
	            }
	
	            if (filters) {
	                filters.forEach(function (filter) {
	                    return params.push('filter=' + filter);
	                });
	            }
	
	            new api.Request(refs, {
	                baseUrl: appManager.getApiPath() + '/options.json',
	                params: params,
	                success: callbackFn
	            }).run();
	        },
	        initComponent: function initComponent() {
	            var container = this,
	                idProperty = 'code',
	                nameProperty = 'name';
	
	            this.nameCmp = Ext.create('Ext.form.Label', {
	                text: this.dataElement.name,
	                flex: 1,
	                style: 'padding:' + _containerConfig2.default.namePadding
	            });
	
	            this.addCmp = Ext.create('Ext.button.Button', {
	                cls: 'ns-linkbutton',
	                style: 'padding: 0',
	                height: 18,
	                text: 'Duplicate',
	                handler: function handler() {
	                    container.duplicateDataElement();
	                }
	            });
	
	            this.removeCmp = Ext.create('Ext.button.Button', {
	                cls: 'ns-linkbutton',
	                style: _containerConfig2.default.removeCmpStyle,
	                height: 18,
	                text: 'Remove',
	                handler: function handler() {
	                    container.removeDataElement();
	                }
	            });
	
	            this.operatorCmp = Ext.create('Ext.form.field.ComboBox', {
	                valueField: 'id',
	                displayField: 'name',
	                queryMode: 'local',
	                editable: false,
	                style: 'margin-bottom:0',
	                width: _containerConfig2.default.operatorCmpWidth,
	                value: 'IN',
	                store: {
	                    fields: ['id', 'name'],
	                    data: [{ id: 'IN', name: 'One of' }]
	                }
	            });
	
	            this.searchStore = Ext.create('Ext.data.Store', {
	                fields: [idProperty, nameProperty],
	                data: [],
	                loadOptionSet: function loadOptionSet(optionSetId, filters, pageSize) {
	                    var store = this;
	
	                    optionSetId = optionSetId || container.dataElement.optionSet.id;
	                    pageSize = pageSize || defaultPageSize;
	
	                    container.getOptionSetOptions(optionSetId, filters, true, function (_ref) {
	                        var options = _ref.options;
	
	                        if ((0, _isArray2.default)(options) && options.length) {
	                            store.loadData(options.slice(0, pageSize));
	                        }
	                    });
	                },
	                listeners: {
	                    datachanged: function datachanged(s) {
	                        if (container.searchCmp && s.getRange().length) {
	                            container.searchCmp.expand();
	                        }
	                    }
	                }
	            });
	
	            // function
	            this.filterSearchStore = function () {
	                var selected = container.valueCmp.getValue();
	
	                container.searchStore.clearFilter();
	
	                container.searchStore.filterBy(function (record) {
	                    return !(0, _arrayContains2.default)(selected, record.data[idProperty]);
	                });
	            };
	
	            this.searchCmp = Ext.create('Ext.form.field.ComboBox', {
	                multiSelect: true,
	                width: _containerConfig2.default.operatorCmpWidth - _containerConfig2.default.triggerCmpWidth,
	                style: 'margin-bottom:0',
	                emptyText: 'Search..',
	                valueField: idProperty,
	                displayField: nameProperty,
	                hideTrigger: true,
	                enableKeyEvents: true,
	                queryMode: 'local',
	                lastQuery: '',
	                listConfig: {
	                    minWidth: _containerConfig2.default.nameCmpWidth - _containerConfig2.default.operatorCmpWidth
	                },
	                store: this.searchStore,
	                listeners: {
	                    keyup: function keyup() {
	                        var value = this.getValue(),
	                            optionSetId = container.dataElement.optionSet.id;
	
	                        // search
	                        container.searchStore.loadOptionSet(optionSetId, ['name:ilike:' + value]);
	
	                        // trigger
	                        if (!value || (0, _isString2.default)(value) && value.length === 1) {
	                            container.triggerCmp.setDisabled(!!value);
	                        }
	                    },
	                    select: function select() {
	                        var id = (0, _arrayFrom2.default)(this.getValue())[0];
	
	                        // value
	                        if (container.valueStore.findExact(idProperty, id) === -1) {
	                            container.valueStore.add(container.searchStore.getAt(container.searchStore.findExact(idProperty, id)).data);
	                        }
	
	                        // search
	                        this.select([]);
	
	                        // filter
	                        container.filterSearchStore();
	
	                        // trigger
	                        container.triggerCmp.enable();
	                    },
	                    expand: function expand() {
	                        container.filterSearchStore();
	                    }
	                }
	            });
	
	            this.triggerCmp = Ext.create('Ext.button.Button', {
	                cls: 'ns-button-combotrigger',
	                disabledCls: 'ns-button-combotrigger-disabled',
	                width: _containerConfig2.default.triggerCmpWidth,
	                height: 22,
	                handler: function handler(b) {
	                    container.searchStore.loadOptionSet();
	                }
	            });
	
	            this.valueStore = Ext.create('Ext.data.Store', {
	                fields: [idProperty, nameProperty],
	                listeners: {
	                    add: function add() {
	                        container.valueCmp.select(this.getRange());
	                    },
	                    remove: function remove() {
	                        container.valueCmp.select(this.getRange());
	                    }
	                }
	            });
	
	            this.valueCmp = Ext.create('Ext.form.field.ComboBox', {
	                multiSelect: true,
	                style: 'margin-bottom:0',
	                width: _containerConfig2.default.nameCmpWidth - _containerConfig2.default.operatorCmpWidth - _containerConfig2.default.operatorCmpWidth,
	                valueField: idProperty,
	                displayField: nameProperty,
	                emptyText: 'No selected items',
	                editable: false,
	                hideTrigger: true,
	                store: container.valueStore,
	                queryMode: 'local',
	                listConfig: {
	                    minWidth: 266,
	                    cls: 'ns-optionselector'
	                },
	                setOptionValues: function setOptionValues(codeArray) {
	                    var me = this,
	                        records = [];
	
	                    var filter = 'code:in:[' + codeArray.join(',') + ']';
	
	                    container.getOptionSetOptions(container.dataElement.optionSet.id, [filter], false, // no limit
	                    function (_ref2) {
	                        var options = _ref2.options;
	
	                        if ((0, _isArray2.default)(options) && options.length) {
	                            container.valueStore.loadData(options);
	
	                            me.setValue(options);
	                        }
	                    });
	                },
	                listeners: {
	                    change: function change(cmp, newVal, oldVal) {
	                        newVal = (0, _arrayFrom2.default)(newVal);
	                        oldVal = (0, _arrayFrom2.default)(oldVal);
	
	                        if (newVal.length < oldVal.length) {
	                            var id = (0, _arrayDifference2.default)(oldVal, newVal)[0];
	                            container.valueStore.removeAt(container.valueStore.findExact(idProperty, id));
	                        }
	                    }
	                }
	            });
	
	            this.items = [{
	                xtype: 'container',
	                layout: 'hbox',
	                width: _containerConfig2.default.nameCmpWidth,
	                items: [this.nameCmp,
	                //this.addCmp,
	                this.removeCmp]
	            }, this.operatorCmp, this.searchCmp, this.triggerCmp, this.valueCmp];
	
	            this.self.superclass.initComponent.call(this);
	        }
	    });
	};
	//# sourceMappingURL=GroupSetContainer.js.map

/***/ },
/* 181 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.LimitContainer = undefined;
	
	var _isNumber = __webpack_require__(7);
	
	var _isNumber2 = _interopRequireDefault(_isNumber);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LimitContainer = exports.LimitContainer = undefined;
	
	exports.LimitContainer = LimitContainer = function LimitContainer(refs) {
	    var i18n = refs.i18nManager.get();
	
	    Ext.define('Ext.ux.container.LimitContainer', {
	        extend: 'Ext.container.Container',
	        alias: 'widget.limitcontainer',
	        layout: 'hbox',
	        sortOrder: null,
	        topLimit: null,
	        comboboxWidth: null,
	        comboBottomMargin: null,
	        onCheckboxChange: function onCheckboxChange(value) {
	            this.sortOrderCmp.setDisabled(!value);
	            this.topLimitCmp.setDisabled(!value);
	        },
	        getSortOrder: function getSortOrder() {
	            return this.activateCmp.getValue() ? this.sortOrderCmp.getValue() : 0;
	        },
	        getTopLimit: function getTopLimit() {
	            return this.activateCmp.getValue() ? this.topLimitCmp.getValue() : 0;
	        },
	        setValues: function setValues(sortOrder, topLimit) {
	            sortOrder = parseInt(sortOrder);
	            topLimit = parseInt(topLimit);
	
	            if ((0, _isNumber2.default)(sortOrder)) {
	                this.sortOrderCmp.setValue(sortOrder);
	            } else {
	                this.sortOrderCmp.reset();
	            }
	
	            if ((0, _isNumber2.default)(topLimit)) {
	                this.topLimitCmp.setValue(topLimit);
	            } else {
	                this.topLimitCmp.reset();
	            }
	
	            this.activateCmp.setValue(!!(sortOrder > 0 && topLimit > 0));
	        },
	        initComponent: function initComponent() {
	            var container = this,
	                activateWidth = 135,
	                sortWidth = (this.comboboxWidth - activateWidth) / 2;
	
	            this.activateCmp = Ext.create('Ext.form.field.Checkbox', {
	                boxLabel: container.boxLabel,
	                width: activateWidth,
	                style: 'margin-bottom:4px',
	                listeners: {
	                    change: function change(cmp, newValue) {
	                        container.onCheckboxChange(newValue);
	                    }
	                }
	            });
	
	            this.sortOrderCmp = Ext.create('Ext.form.field.ComboBox', {
	                cls: 'ns-combo',
	                style: 'margin-bottom:' + container.comboBottomMargin + 'px',
	                width: sortWidth,
	                queryMode: 'local',
	                valueField: 'id',
	                editable: false,
	                value: container.sortOrder,
	                store: Ext.create('Ext.data.Store', {
	                    fields: ['id', 'text'],
	                    data: [{ id: -1, text: i18n.bottom }, { id: 1, text: i18n.top }]
	                })
	            });
	
	            this.topLimitCmp = Ext.create('Ext.form.field.Number', {
	                width: sortWidth - 1,
	                style: 'margin-bottom:' + container.comboBottomMargin + 'px; margin-left:1px',
	                minValue: 1,
	                maxValue: 10000,
	                value: container.topLimit,
	                allowBlank: false
	            });
	
	            this.items = [this.activateCmp, this.sortOrderCmp, this.topLimitCmp];
	
	            this.self.superclass.initComponent.call(this);
	        },
	        listeners: {
	            render: function render() {
	                this.onCheckboxChange(false);
	            }
	        }
	    });
	};
	//# sourceMappingURL=LimitContainer.js.map

/***/ },
/* 182 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.StatusBar = undefined;
	
	var _arrayMin = __webpack_require__(184);
	
	var _arrayMin2 = _interopRequireDefault(_arrayMin);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var StatusBar = exports.StatusBar = undefined;
	
	exports.StatusBar = StatusBar = function StatusBar(refs) {
	    var instanceManager = refs.instanceManager,
	        dimensionConfig = refs.dimensionConfig;
	
	
	    var aggregated_values = dimensionConfig.dataType['aggregated_values'];
	    var individual_cases = dimensionConfig.dataType['individual_cases'];
	
	    Ext.define('Ext.ux.toolbar.StatusBar', {
	        extend: 'Ext.toolbar.Toolbar',
	        alias: 'widget.statusbar',
	        queryCmps: [],
	        showHideQueryCmps: function showHideQueryCmps(fnName) {
	            this.queryCmps.forEach(function (cmp) {
	                cmp[fnName]();
	            });
	        },
	        setStatus: function setStatus(layout, response) {
	            this.pager = response.metaData.pager;
	
	            this.reset(layout.dataType);
	
	            if (layout.dataType === aggregated_values) {
	                this.statusCmp.setText(response.rows.length + ' values');
	                return;
	            }
	
	            if (layout.dataType === individual_cases) {
	                var maxVal = this.pager.page * this.pager.pageSize,
	                    from = maxVal - this.pager.pageSize + 1,
	                    to = (0, _arrayMin2.default)([maxVal, this.pager.total]);
	
	                this.pageCmp.setValue(this.pager.page);
	                this.pageCmp.setMaxValue(this.pager.pageCount);
	                this.totalPageCmp.setText(' of ' + this.pager.pageCount);
	                this.statusCmp.setText(from + '-' + to + ' of ' + this.pager.total + ' cases');
	                return;
	            }
	        },
	        reset: function reset(dataType) {
	            if (!dataType || dataType === aggregated_values) {
	                this.showHideQueryCmps('hide');
	                this.pageCmp.setValue(1);
	                this.totalPageCmp.setText('');
	                this.statusCmp.setText('');
	                return;
	            }
	
	            if (dataType === individual_cases) {
	                this.showHideQueryCmps('show');
	                this.pageCmp.setValue(1);
	                this.totalPageCmp.setText(' of 1');
	                this.statusCmp.setText('');
	            }
	        },
	        getCurrentPage: function getCurrentPage() {
	            return this.pageCmp.getValue();
	        },
	        getPageCount: function getPageCount() {
	            return this.pageCount;
	        },
	        onPageChange: function onPageChange(page, currentPage) {
	            currentPage = currentPage || this.getCurrentPage();
	
	            if (page && page >= 1 && page <= this.pager.pageCount && page != currentPage) {
	                var layout = instanceManager.getStateCurrent();
	
	                layout.paging.page = page;
	                layout.setResponse(null);
	
	                this.pageCmp.setValue(page);
	                instanceManager.getReport(layout);
	            }
	        },
	        initComponent: function initComponent() {
	            var container = this,
	                size = this.pageSize;
	
	            this.firstCmp = Ext.create('Ext.button.Button', {
	                text: '<<',
	                handler: function handler() {
	                    container.onPageChange(1);
	                }
	            });
	            this.queryCmps.push(this.firstCmp);
	
	            this.prevCmp = Ext.create('Ext.button.Button', {
	                text: '<',
	                handler: function handler() {
	                    container.onPageChange(container.getCurrentPage() - 1);
	                }
	            });
	            this.queryCmps.push(this.prevCmp);
	
	            this.pageTextCmp = Ext.create('Ext.toolbar.TextItem', {
	                text: 'Page ',
	                style: 'line-height:21px'
	            });
	            this.queryCmps.push(this.pageTextCmp);
	
	            this.pageCmp = Ext.create('Ext.form.field.Number', {
	                width: 34,
	                height: 21,
	                minValue: 1,
	                value: 1,
	                hideTrigger: true,
	                enableKeyEvents: true,
	                currentPage: 1,
	                listeners: {
	                    render: function render() {
	                        Ext.get(this.getInputId()).setStyle('padding-top', '2px');
	                    },
	                    keyup: {
	                        fn: function fn(cmp) {
	                            var currentPage = cmp.currentPage;
	
	                            cmp.currentPage = cmp.getValue();
	
	                            container.onPageChange(cmp.getValue(), currentPage);
	                        },
	                        buffer: 200
	                    }
	                }
	            });
	            this.queryCmps.push(this.pageCmp);
	
	            this.totalPageCmp = Ext.create('Ext.toolbar.TextItem', {
	                text: '',
	                style: 'line-height:21px'
	            });
	            this.queryCmps.push(this.totalPageCmp);
	
	            this.nextCmp = Ext.create('Ext.button.Button', {
	                text: '>',
	                handler: function handler() {
	                    container.onPageChange(container.getCurrentPage() + 1);
	                }
	            });
	            this.queryCmps.push(this.nextCmp);
	
	            this.lastCmp = Ext.create('Ext.button.Button', {
	                text: '>>',
	                handler: function handler() {
	                    container.onPageChange(container.pager.pageCount);
	                }
	            });
	            this.queryCmps.push(this.lastCmp);
	
	            this.statusCmp = Ext.create('Ext.toolbar.TextItem', {
	                text: '',
	                style: 'line-height:21px'
	            });
	
	            this.items = [this.statusCmp, this.firstCmp, this.prevCmp, this.pageTextCmp, this.pageCmp, this.totalPageCmp, this.nextCmp, this.lastCmp, '->', this.statusCmp];
	
	            this.self.superclass.initComponent.call(this);
	        }
	    });
	};
	//# sourceMappingURL=StatusBar.js.map

/***/ },
/* 183 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = arrayInsert;
	
	var _arrayReplace = __webpack_require__(186);
	
	var _arrayReplace2 = _interopRequireDefault(_arrayReplace);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Insert a value into an array
	 *
	 * @param {Array} array The array to insert the items into
	 * @param {number} index The index where to insert the values
	 * @param {*} items The item(s) to insert
	 * @returns {Array} The resulting array with the inserted `items`
	 *
	 * @example
	 * const sourceArray = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
	 * sourceArray, undefined, ['a', 'b', 'c']); // Returns: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 'a', 'b', 'c']
	 */
	function arrayInsert(array, index, items) {
	  return (0, _arrayReplace2.default)(array, index, 0, items);
	}
	//# sourceMappingURL=arrayInsert.js.map

/***/ },
/* 184 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = arrayMin;
	/**
	 * Return the lowest value (number) in the given array
	 *
	 * @param {Array} array The array to be scanned
	 * @returns {Array} The lowest value
	 *
	 * @throws {TypeError} When the passed array is not actually an array.
	 *
	 * @example
	 * const sourceArray = [3,1,2];
	 * arrayMax(sourceArray); // Returns: 1
	 *
	 * @example
	 * arrayClean() // throws: Cannot read property 'length' of undefined
	 */
	function arrayMin(array, comparisonFn) {
	    var i = 0,
	        ln = array.length,
	        item,
	        min = array[0];
	
	    for (; i < ln; i++) {
	        item = array[i];
	
	        if (comparisonFn) {
	            if (comparisonFn(min, item) === 1) {
	                min = item;
	            }
	        } else {
	            if (item < min) {
	                min = item;
	            }
	        }
	    }
	
	    return min;
	}
	//# sourceMappingURL=arrayMin.js.map

/***/ },
/* 185 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = arrayRepeat;
	/**
	 * 
	 * Repeats content of array by structure or by index, returns flattened array.
	 * 
	 * @param   {array}   array 
	 * @param   {number}  n 
	 * @param   {boolean} [byIndex=false] 
	 * @returns {array}
	 *
	 * @example
	 * const values = [1, 2, 3];
	 * arrayRepeat(values, 3) // returns: [1, 2, 3, 1, 2, 3, 1, 2, 3]
	 *
	 * @example
	 * const values = [1, 2, 3];
	 * arrayRepeat(values, 3, true) // returns: [1, 1, 1, 2, 2, 2, 3, 3, 3]
	 */
	function arrayRepeat(array) {
	    var n = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
	    var byIndex = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	    if (typeof array === 'undefined') {
	        throw 'Cannot repeat array of type undefined';
	    }
	
	    if (byIndex) {
	        return [].concat.apply([], array.map(function (item, i) {
	            return Array(n).fill(array[i]);
	        }));
	    }
	    return [].concat.apply([], Array.apply(null, Array(n)).map(function () {
	        return array;
	    }));
	};
	//# sourceMappingURL=arrayRepeat.js.map

/***/ },
/* 186 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = arrayReplace;
	/**
	 * Replace values in an array with given values or remove values from an array.
	 *
	 * @param {Array} array The array where the values should be replaced
	 * @param {number} index The index in the array where to start the replacement
	 * @param {number} removeCount The number of items to remove
	 * @param {*} insert The item(s) to be inserted
	 * @returns {Array} The array with the replaced values
	 *
	 * @example
	 * const sourceArray = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
	 * arrayReplace(sourceArray, 0, 5, ['a', 'b', 'c', 'd']); // Returns: ['a', 'b', 'c', 'd', 6, 7, 8, 9, 10]
	 */
	function arrayReplace(array, index, removeCount, insert) {
	    if (insert && insert.length) {
	        if (index < array.length) {
	            array.splice.apply(array, [index, removeCount].concat(insert));
	        } else {
	            array.push.apply(array, insert);
	        }
	    } else {
	        array.splice(index, removeCount);
	    }
	    return array;
	}
	//# sourceMappingURL=arrayReplace.js.map

/***/ },
/* 187 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = isIE;
	/**
	 * Check if the users browser is a version of Internet Explorer
	 *
	 * @param [ua] The users user-agent string.
	 * @returns {boolean|number} Returns the version number (10, 11, 12) when the browser is IE, otherwise `false`
	 *
	 * @example
	 * // When using IE10
	 * isIE(); // Returns: 10
	 *
	 * // When using FireFox
	 * isIE(); // Returns: false
	 *
	 * TODO: It is not very good practice to return two different types of values from a function. Perhaps we can return `true` on IE and have a secondary function to get the version?
	 */
	function isIE() {
	    var ua = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.navigator.userAgent;
	
	    // test values
	    // IE 10: ua = 'Mozilla/5.0 (compatible; MSIE 10.0; Windows NT 6.2; Trident/6.0)';
	    // IE 11: ua = 'Mozilla/5.0 (Windows NT 6.3; Trident/7.0; rv:11.0) like Gecko';
	    // IE 12 / Spartan: ua = 'Mozilla/5.0 (Windows NT 10.0; WOW64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/39.0.2171.71 Safari/537.36 Edge/12.0';
	
	    var msie = ua.indexOf('MSIE ');
	    if (msie > 0) {
	        // IE 10 or older => return version number
	        return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
	    }
	
	    var trident = ua.indexOf('Trident/');
	    if (trident > 0) {
	        // IE 11 => return version number
	        var rv = ua.indexOf('rv:');
	        return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
	    }
	
	    var edge = ua.indexOf('Edge/');
	    if (edge > 0) {
	        // IE 12 => return version number
	        return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10);
	    }
	
	    // other browser
	    return false;
	}
	//# sourceMappingURL=isIE.js.map

/***/ },
/* 188 */
78,
/* 189 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	/**
	 * Fixes the number to a certain amount of decimals
	 *
	 * @param {Number} value The value to apply the function to
	 * @param {Number} [precision=0] The amount of decimal digits to fix to
	 * @returns {String} The "fixed" number with the specified amount of decimals
	 */
	var numberToFixed = function () {
	    function fixedToFixed(value, precision) {
	        precision = precision || 0;
	
	        var pow = math.pow(10, precision);
	        return (math.round(value * pow) / pow).toFixed(precision);
	    }
	
	    function standardToFixed(value, precision) {
	        precision = precision || 0;
	
	        return value.toFixed(precision);
	    }
	
	    // TODO: The "broken" toFixed is not easy to test? Should check if still relevant.
	    // return ((0.9).toFixed() !== '1') ? fixedToFixed : standardToFixed;
	    return standardToFixed;
	}();
	
	exports.default = numberToFixed;
	//# sourceMappingURL=numberToFixed.js.map

/***/ },
/* 190 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = stringTrim;
	/**
	 * Removes all spaces before first after last text char.
	 *
	 * @param {string} str The string to operate on
	 * @returns {string} The resulting string.
	 */
	function stringTrim(str) {
	  return str.replace(/^[\x09\x0a\x0b\x0c\x0d\x20\xa0\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u2028\u2029\u202f\u205f\u3000]+|[\x09\x0a\x0b\x0c\x0d\x20\xa0\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u2028\u2029\u202f\u205f\u3000]+$/g, '');
	}
	//# sourceMappingURL=stringTrim.js.map

/***/ },
/* 191 */
/***/ function(module, exports, __webpack_require__) {

	var d2ChartsApi = __webpack_require__(75);
	
	module.exports = d2ChartsApi;


/***/ },
/* 192 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = function (regressionType, series, isStacked) {
	    var newSeries = [];
	
	    if (isStacked) {
	        newSeries.push.apply(newSeries, _toConsumableArray(series).concat([_extends({}, getRegressionObj((0, _getStackedData2.default)(series), regressionType))]));
	    } else {
	        series.forEach(function (seriesObj) {
	            newSeries.push(seriesObj, _extends({}, getRegressionObj(seriesObj.data, regressionType), {
	                name: seriesObj.name + ' (trend)',
	                color: getDarkerColor(seriesObj.color)
	            }));
	        });
	    }
	
	    return newSeries;
	};
	
	var _d3Color = __webpack_require__(229);
	
	var _getStackedData = __webpack_require__(74);
	
	var _getStackedData2 = _interopRequireDefault(_getStackedData);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var DEFAULT_TRENDLINE = {
	    type: 'spline',
	    name: 'Trend',
	    dashStyle: 'solid',
	    color: '#333',
	    lineWidth: 1,
	    marker: {
	        enabled: false,
	        symbol: 'circle',
	        radius: 2
	    }
	};
	
	function getColor(colors, index) {
	    return colors[index] || getColor(colors, index - colors.length);
	}
	
	function getDarkerColor(color) {
	    return (0, _d3Color.rgb)(color).darker(0.5).toString();
	}
	
	function getRegressionData(data) {
	    return data.map(function (value, index) {
	        return [index, value];
	    });
	}
	
	function getRegressionObj(data, regressionType) {
	    // LINEAR:
	    // - decimalPlaces (default = 2)
	    // LOESS:
	    // - loessSmooth (default = 25)
	    // POLYNOMIAL:
	    // - order (default = 2)
	    // - extrapolate (default = 0)
	
	    var regression = void 0;
	    var regressionTypeOptions = {};
	
	    switch (regressionType) {
	        case 'LINEAR':
	            // linear(data, decimalPlaces)
	            regression = linear(getRegressionData(data));
	            regressionTypeOptions.type = 'line';
	            break;
	        case 'POLYNOMIAL':
	            // polynomial(data, order, extrapolate)
	            regression = polynomial(getRegressionData(data), 2, 0);
	            break;
	        case 'LOESS':
	            // loess(data, smoothing)
	            regression = loess(getRegressionData(data), 0.25);
	            break;
	    };
	
	    return _extends({}, DEFAULT_TRENDLINE, regressionTypeOptions, {
	        data: regression.points
	    });
	}
	
	// Code extracted from https://github.com/Tom-Alexander/regression-js/
	function gaussianElimination(a, o) {
	    var maxrow = 0,
	        tmp = 0,
	        n = a.length - 1,
	        x = new Array(o);
	
	    for (var i = 0; i < n; i++) {
	        maxrow = i;
	
	        for (var j = i + 1; j < n; j++) {
	            if (Math.abs(a[i][j]) > Math.abs(a[i][maxrow])) {
	                maxrow = j;
	            }
	        }
	
	        for (var k = i; k < n + 1; k++) {
	            tmp = a[k][i];
	            a[k][i] = a[k][maxrow];
	            a[k][maxrow] = tmp;
	        }
	
	        for (var _j = i + 1; _j < n; _j++) {
	            for (var _k = n; _k >= i; _k--) {
	                a[_k][_j] -= a[_k][i] * a[i][_j] / a[i][i];
	            }
	        }
	    }
	
	    for (var _j2 = n - 1; _j2 >= 0; _j2--) {
	        tmp = 0;
	
	        for (var _k2 = _j2 + 1; _k2 < n; _k2++) {
	            tmp += a[_k2][_j2] * x[_k2];
	        }
	
	        x[_j2] = (a[n][_j2] - tmp) / a[_j2][_j2];
	    }
	
	    return x;
	}
	
	// Code extracted from https://github.com/Tom-Alexander/regression-js/
	// Human readable formulas:
	//
	//              N * Σ(XY) - Σ(X)
	// intercept = ---------------------
	//              N * Σ(X^2) - Σ(X)^2
	//
	// correlation = N * Σ(XY) - Σ(X) * Σ (Y) / √ (  N * Σ(X^2) - Σ(X) ) * ( N * Σ(Y^2) - Σ(Y)^2 ) ) )
	function linear(data, decimalPlaces) {
	    var sum = [0, 0, 0, 0, 0],
	        results = [],
	        N = data.length;
	
	    for (var _n = 0, len = data.length; _n < len; _n++) {
	        if (data[_n]['x'] != null) {
	            data[_n][0] = data[_n].x;
	            data[_n][1] = data[_n].y;
	        }
	        if (data[_n][1] != null) {
	            sum[0] += data[_n][0]; // Σ(X)
	            sum[1] += data[_n][1]; // Σ(Y)
	            sum[2] += data[_n][0] * data[_n][0]; // Σ(X^2)
	            sum[3] += data[_n][0] * data[_n][1]; // Σ(XY)
	            sum[4] += data[_n][1] * data[_n][1]; // Σ(Y^2)
	        } else {
	            N -= 1;
	        }
	    }
	
	    var gradient = (N * sum[3] - sum[0] * sum[1]) / (N * sum[2] - sum[0] * sum[0]);
	    var intercept = sum[1] / N - gradient * sum[0] / N;
	    // let correlation = (N * sum[3] - sum[0] * sum[1]) / Math.sqrt((N * sum[2] - sum[0] * sum[0]) * (N * sum[4] - sum[1] * sum[1]));
	
	    for (var i = 0, _len = data.length; i < _len; i++) {
	        var coorY = data[i][0] * gradient + intercept;
	
	        if (decimalPlaces) {
	            coorY = parseFloat(coorY.toFixed(decimalPlaces));
	        }
	
	        var coordinate = [data[i][0], coorY];
	        results.push(coordinate);
	    }
	
	    results.sort(function (a, b) {
	        if (a[0] > b[0]) {
	            return 1;
	        }
	        if (a[0] < b[0]) {
	            return -1;
	        }
	
	        return 0;
	    });
	
	    var string = 'y = ' + Math.round(gradient * 100) / 100 + 'x + ' + Math.round(intercept * 100) / 100;
	
	    return {
	        equation: [gradient, intercept],
	        points: results,
	        string: string
	    };
	}
	
	// Code extracted from https://github.com/Tom-Alexander/regression-js/
	function logarithmic(data) {
	    var sum = [0, 0, 0, 0],
	        results = [],
	        mean = 0;
	
	    for (var _n2 = 0, len = data.length; _n2 < len; _n2++) {
	        if (data[_n2].x != null) {
	            data[_n2][0] = data[_n2].x;
	            data[_n2][1] = data[_n2].y;
	        }
	        if (data[_n2][1] != null) {
	            sum[0] += Math.log(data[_n2][0]);
	            sum[1] += data[_n2][1] * Math.log(data[_n2][0]);
	            sum[2] += data[_n2][1];
	            sum[3] += Math.pow(Math.log(data[_n2][0]), 2);
	        }
	    }
	
	    var B = (n * sum[1] - sum[2] * sum[0]) / (n * sum[3] - sum[0] * sum[0]);
	    var A = (sum[2] - B * sum[0]) / n;
	
	    for (var i = 0, _len2 = data.length; i < _len2; i++) {
	        var coordinate = [data[i][0], A + B * Math.log(data[i][0])];
	
	        results.push(coordinate);
	    }
	
	    results.sort(function (a, b) {
	        if (a[0] > b[0]) {
	            return 1;
	        }
	        if (a[0] < b[0]) {
	            return -1;
	        }
	
	        return 0;
	    });
	
	    var string = 'y = ' + Math.round(A * 100) / 100 + ' + ' + Math.round(B * 100) / 100 + ' ln(x)';
	
	    return {
	        equation: [A, B],
	        points: results,
	        string: string
	    };
	}
	
	// Code extracted from https://github.com/Tom-Alexander/regression-js/
	function power(data) {
	    var sum = [0, 0, 0, 0],
	        results = [];
	
	    for (var _n3 = 0, len = data.length; _n3 < len; _n3++) {
	        if (data[_n3].x != null) {
	            data[_n3][0] = data[_n3].x;
	            data[_n3][1] = data[_n3].y;
	        }
	        if (data[_n3][1] != null) {
	            sum[0] += Math.log(data[_n3][0]);
	            sum[1] += Math.log(data[_n3][1]) * Math.log(data[_n3][0]);
	            sum[2] += Math.log(data[_n3][1]);
	            sum[3] += Math.pow(Math.log(data[_n3][0]), 2);
	        }
	    }
	
	    var B = (n * sum[1] - sum[2] * sum[0]) / (n * sum[3] - sum[0] * sum[0]);
	    var A = Math.pow(Math.E, (sum[2] - B * sum[0]) / n);
	
	    for (var i = 0, _len3 = data.length; i < _len3; i++) {
	        var coordinate = [data[i][0], A * Math.pow(data[i][0], B)];
	
	        results.push(coordinate);
	    }
	
	    results.sort(function (a, b) {
	        if (a[0] > b[0]) {
	            return 1;
	        }
	        if (a[0] < b[0]) {
	            return -1;
	        }
	
	        return 0;
	    });
	
	    var string = 'y = ' + Math.round(A * 100) / 100 + 'x^' + Math.round(B * 100) / 100;
	
	    return {
	        equation: [A, B],
	        points: results,
	        string: string
	    };
	}
	
	// Code extracted from https://github.com/Tom-Alexander/regression-js/
	function polynomial(data, order, extrapolate) {
	    if (typeof order == 'undefined') {
	        order = 2;
	    }
	
	    var lhs = [],
	        rhs = [],
	        results = [],
	        a = 0,
	        b = 0,
	        k = order + 1;
	
	    for (var i = 0; i < k; i++) {
	        for (var l = 0, len = data.length; l < len; l++) {
	            if (data[l].x != null) {
	                data[l][0] = data[l].x;
	                data[l][1] = data[l].y;
	            }
	            if (data[l][1] != null) {
	                a += Math.pow(data[l][0], i) * data[l][1];
	            }
	        }
	
	        lhs.push(a);
	
	        a = 0;
	
	        var c = [];
	
	        for (var j = 0; j < k; j++) {
	            for (var _l = 0, _len4 = data.length; _l < _len4; _l++) {
	                if (data[_l][1]) {
	                    b += Math.pow(data[_l][0], i + j);
	                }
	            }
	
	            c.push(b);
	
	            b = 0;
	        }
	
	        rhs.push(c);
	    }
	
	    rhs.push(lhs);
	
	    var equation = gaussianElimination(rhs, k);
	
	    var resultLength = data.length + extrapolate;
	    var step = data[data.length - 1][0] - data[data.length - 2][0];
	
	    for (var _i = 0, _len5 = resultLength; _i < _len5; _i++) {
	        var answer = 0,
	            x = 0;
	
	        if (typeof data[_i] !== 'undefined') {
	            x = data[_i][0];
	        } else {
	            x = data[data.length - 1][0] + (_i - data.length) * step;
	        }
	
	        for (var w = 0; w < equation.length; w++) {
	            answer += equation[w] * Math.pow(x, w);
	        }
	
	        results.push([x, answer]);
	    }
	
	    results.sort(function (a, b) {
	        if (a[0] > b[0]) {
	            return 1;
	        }
	        if (a[0] < b[0]) {
	            return -1;
	        }
	
	        return 0;
	    });
	
	    var string = 'y = ';
	
	    for (var _i2 = equation.length - 1; _i2 >= 0; _i2--) {
	        if (_i2 > 1) {
	            string += Math.round(equation[_i2] * 100) / 100 + 'x^' + _i2 + ' + ';
	        } else if (_i2 == 1) {
	            string += Math.round(equation[_i2] * 100) / 100 + 'x' + ' + ';
	        } else {
	            string += Math.round(equation[_i2] * 100) / 100;
	        }
	    }
	
	    return {
	        equation: equation,
	        points: results,
	        string: string
	    };
	}
	
	// @author: Ignacio Vazquez
	// Based on
	// - http://commons.apache.org/proper/commons-math/download_math.cgi LoesInterpolator.java
	// - https://gist.github.com/avibryant/1151823
	function loess(data, bandwidth) {
	    bandwidth = bandwidth || 0.25;
	
	    var xval = data.map(function (pair) {
	        return pair[0];
	    });
	
	    var distinctX = array_unique(xval);
	
	    if (2 / distinctX.length > bandwidth) {
	        bandwidth = Math.min(2 / distinctX.length, 1);
	
	        console.warn("updated bandwith to " + bandwidth);
	    }
	
	    var yval = data.map(function (pair) {
	        return pair[1];
	    });
	
	    function array_unique(values) {
	        var o = {},
	            i = void 0,
	            l = values.length,
	            r = [];
	
	        for (i = 0; i < l; i += 1) {
	            o[values[i]] = values[i];
	        }
	
	        for (i in o) {
	            r.push(o[i]);
	        }
	
	        return r;
	    }
	
	    function tricube(x) {
	        var tmp = 1 - x * x * x;
	
	        return tmp * tmp * tmp;
	    }
	
	    var res = [];
	
	    var left = 0;
	    var right = Math.floor(bandwidth * xval.length) - 1;
	
	    for (var i in xval) {
	        var x = xval[i];
	
	        if (i > 0) {
	            if (right < xval.length - 1 && xval[right + 1] - xval[i] < xval[i] - xval[left]) {
	                left++;
	                right++;
	            }
	        }
	        //console.debug("left: "+left  + " right: " + right );
	        var edge = void 0;
	
	        if (xval[i] - xval[left] > xval[right] - xval[i]) {
	            edge = left;
	        } else {
	            edge = right;
	        }
	
	        var denom = Math.abs(1.0 / (xval[edge] - x));
	        var sumWeights = 0;
	        var sumX = 0,
	            sumXSquared = 0,
	            sumY = 0,
	            sumXY = 0;
	
	        var k = left;
	
	        while (k <= right) {
	            var xk = xval[k];
	            var yk = yval[k];
	            var dist = void 0;
	
	            if (k < i) {
	                dist = x - xk;
	            } else {
	                dist = xk - x;
	            }
	
	            var w = tricube(dist * denom);
	            var xkw = xk * w;
	
	            sumWeights += w;
	            sumX += xkw;
	            sumXSquared += xk * xkw;
	            sumY += yk * w;
	            sumXY += yk * xkw;
	            k++;
	        }
	
	        var meanX = sumX / sumWeights;
	        //console.debug(meanX);
	
	        var meanY = sumY / sumWeights;
	        var meanXY = sumXY / sumWeights;
	        var meanXSquared = sumXSquared / sumWeights;
	        var beta = void 0;
	
	        if (meanXSquared == meanX * meanX) {
	            beta = 0;
	        } else {
	            beta = (meanXY - meanX * meanY) / (meanXSquared - meanX * meanX);
	        }
	
	        var alpha = meanY - beta * meanX;
	        res[i] = beta * x + alpha;
	    }
	    //console.debug(res);
	
	    return {
	        equation: "",
	        points: xval.map(function (x, i) {
	            return [x, res[i]];
	        }),
	        string: ""
	    };
	}
	//# sourceMappingURL=addTrendLines.js.map

/***/ },
/* 193 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = function (layout, el, dashboard) {
	    return _extends({}, (0, _type2.default)(layout.type), { renderTo: el || layout.el }, DEFAULT_CHART, dashboard ? DASHBOARD_CHART : undefined);
	};
	
	var _type = __webpack_require__(32);
	
	var _type2 = _interopRequireDefault(_type);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DEFAULT_CHART = {
	    fontFamily: 'Helvetica Neue,Helvetica,Arial,sans-serif !important',
	    spacingTop: 20
	};
	
	var DASHBOARD_CHART = {
	    spacingTop: 0,
	    spacingRight: 5,
	    spacingBottom: 2,
	    spacingLeft: 5
	};
	
	;
	//# sourceMappingURL=chart.js.map

/***/ },
/* 194 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = function (series) {
	    var decimals = 0;
	    var cumulativeValues = [];
	
	    series.forEach(function (seriesObj) {
	        cumulativeValues = seriesObj.data.reduce(function (accumulator, value, index) {
	            decimals = Math.max(decimals, (0, _numberDecimals2.default)(value));
	
	            if (index > 0) {
	                value += accumulator[index - 1];
	            }
	
	            accumulator.push(value);
	
	            return accumulator;
	        }, []);
	
	        // round values to the largest number of decimals found in the serie
	        // this is to avoid the floating-point problems in JavaScript
	        // the condition in the return statement is because sometimes value can be null
	        seriesObj.data = cumulativeValues.map(function (value) {
	            return value ? parseFloat(value.toFixed(decimals)) : value;
	        });
	
	        decimals = 0;
	    });
	
	    return series;
	};
	
	var _isInteger = __webpack_require__(77);
	
	var _isInteger2 = _interopRequireDefault(_isInteger);
	
	var _numberDecimals = __webpack_require__(228);
	
	var _numberDecimals2 = _interopRequireDefault(_numberDecimals);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	//# sourceMappingURL=getCumulativeData.js.map

/***/ },
/* 195 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = function (config, layout, isStacked) {
	    var direction = sortOrderMap.get(parseInt(layout.sortOrder));
	
	    return getSortedConfig(config, isStacked, direction);
	};
	
	var _arrayPluck = __webpack_require__(224);
	
	var _arrayPluck2 = _interopRequireDefault(_arrayPluck);
	
	var _arraySort = __webpack_require__(76);
	
	var _arraySort2 = _interopRequireDefault(_arraySort);
	
	var _getStackedData = __webpack_require__(74);
	
	var _getStackedData2 = _interopRequireDefault(_getStackedData);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var sortOrderMap = new Map([[-1, 'ASC'], [1, 'DESC']]);
	
	function getIndexOrder(config, isStacked, direction) {
	    var dataToBeSorted = isStacked ? (0, _getStackedData2.default)(config.series) : config.series[0].data.slice();
	
	    var dataObjectsToBeSorted = dataToBeSorted.map(function (value, index) {
	        return { index: index, value: value };
	    });
	
	    (0, _arraySort2.default)(dataObjectsToBeSorted, direction, 'value');
	
	    return (0, _arrayPluck2.default)(dataObjectsToBeSorted, 'index');
	}
	
	function getSortedConfig(config, isStacked, direction) {
	    var categories = config.xAxis.categories;
	    var series = config.series;
	    var indexOrder = getIndexOrder(config, isStacked, direction);
	    var sortedConfig = _extends({}, config);
	
	    sortedConfig.xAxis.categories = indexOrder.map(function (index) {
	        return categories[index];
	    });
	    sortedConfig.series = series.map(function (seriesObj) {
	        return _extends({}, seriesObj, {
	            data: seriesObj.data.map(function (value, index) {
	                return seriesObj.data[indexOrder[index]];
	            })
	        });
	    });
	
	    return sortedConfig;
	}
	//# sourceMappingURL=getSortedConfig.js.map

/***/ },
/* 196 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = function (config, hideEmptyRowItems) {
	    var emptySeriesIndexes = getEmptySeriesIndexes(config.series);
	
	    var _getFirstLastValueInd = getFirstLastValueIndexes(config.series),
	        firstValueIndex = _getFirstLastValueInd.firstValueIndex,
	        lastValueIndex = _getFirstLastValueInd.lastValueIndex;
	
	    return emptySeriesIndexes.length && config.xAxis && config.series ? _extends({}, config, getTrimmedXAxisObject(config.xAxis, emptySeriesIndexes, firstValueIndex, lastValueIndex, hideEmptyRowItems), getTrimmedSeriesObject(config.series, emptySeriesIndexes, firstValueIndex, lastValueIndex, hideEmptyRowItems)) : config;
	};
	
	var _arrayContains = __webpack_require__(45);
	
	var _arrayContains2 = _interopRequireDefault(_arrayContains);
	
	var _arrayUnique = __webpack_require__(226);
	
	var _arrayUnique2 = _interopRequireDefault(_arrayUnique);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function arrayCleanUndefined(array) {
	    return array.filter(function (item) {
	        return item !== undefined;
	    });
	}
	
	function arrayNullsOnly(array) {
	    return (0, _arrayContains2.default)(array, null) && (0, _arrayUnique2.default)(array).length === 1;
	}
	
	function getEmptySeriesIndexes(series) {
	    var emptyIndexes = [];
	    var seriesValues = void 0;
	
	    series[0].data.forEach(function (value, index) {
	        seriesValues = [];
	
	        series.forEach(function (seriesObj) {
	            seriesValues.push(seriesObj.data[index]);
	        });
	
	        if (arrayNullsOnly(seriesValues)) {
	            emptyIndexes.push(index);
	        }
	    });
	
	    return emptyIndexes;
	}
	
	function getFirstLastValueIndexes(series) {
	    var firstValueIndex = undefined;
	    var lastValueIndex = 0;
	    var data = void 0;
	    var i = void 0;
	
	    series.forEach(function (seriesObj) {
	        // make a copy of the array so we can reverse it
	        // without affecting the original
	        data = seriesObj.data.slice();
	
	        i = data.findIndex(function (value) {
	            return value != undefined;
	        });
	
	        if (i > -1) {
	            firstValueIndex = firstValueIndex !== undefined ? Math.min(firstValueIndex, i) : i;
	        }
	
	        i = data.reverse().findIndex(function (value) {
	            return value != undefined;
	        });
	
	        if (i > -1) {
	            lastValueIndex = Math.max(lastValueIndex, data.length - 1 - i);
	        }
	    });
	
	    return { firstValueIndex: firstValueIndex, lastValueIndex: lastValueIndex };
	}
	
	function cleanData(data, emptySeriesIndexes, firstValueIndex, lastValueIndex, hideEmptyRowItems) {
	    var cleanedData = void 0;
	
	    switch (hideEmptyRowItems) {
	        case 'ALL':
	            cleanedData = arrayCleanUndefined(data.map(function (value, index) {
	                return (0, _arrayContains2.default)(emptySeriesIndexes, index) ? undefined : value;
	            }));
	            break;
	        case 'BEFORE_FIRST':
	            cleanedData = data.slice(firstValueIndex);
	            break;
	        case 'AFTER_LAST':
	            cleanedData = data.slice(0, lastValueIndex + 1);
	            break;
	        case 'BEFORE_FIRST_AFTER_LAST':
	            cleanedData = data.slice(firstValueIndex, lastValueIndex + 1);
	            break;
	        default:
	            cleanedData = data;
	    }
	
	    return cleanedData;
	}
	
	function getTrimmedXAxisObject(xAxis, emptySeriesIndexes, firstValueIndex, lastValueIndex, hideEmptyRowItems) {
	    return {
	        xAxis: _extends({}, xAxis, {
	            categories: cleanData(xAxis.categories, emptySeriesIndexes, firstValueIndex, lastValueIndex, hideEmptyRowItems)
	        })
	    };
	}
	
	function getTrimmedSeriesObject(series, emptySeriesIndexes, firstValueIndex, lastValueIndex, hideEmptyRowItems) {
	    return {
	        series: series.map(function (seriesObj) {
	            return _extends({}, seriesObj, {
	                data: cleanData(seriesObj.data, emptySeriesIndexes, firstValueIndex, lastValueIndex, hideEmptyRowItems)
	            });
	        })
	    };
	}
	//# sourceMappingURL=getTrimmedConfig.js.map

/***/ },
/* 197 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = function (layout, dashboard) {
	    return layout.hideLegend ? {
	        enabled: false
	    } : _extends({}, getLegend(dashboard), getItemStyle(dashboard));
	};
	
	var DEFAULT_ITEM_STYLE = {
	    fontSize: '13px',
	    fontWeight: 'normal'
	};
	
	var DASHBOARD_ITEM_STYLE = {
	    fontSize: '11px',
	    fontWeight: 500
	};
	
	var DEFAULT_LEGEND = {
	    symbolWidth: 11,
	    symbolHeight: 11,
	    itemMarginBottom: 2
	};
	
	var DASHBOARD_LEGEND = {
	    symbolPadding: 3,
	    itemDistance: 10
	};
	
	function getItemStyle(dashboard) {
	    return {
	        itemStyle: _extends({}, DEFAULT_ITEM_STYLE, dashboard ? DASHBOARD_ITEM_STYLE : null)
	    };
	}
	
	function getLegend(dashboard) {
	    return _extends({}, DEFAULT_LEGEND, dashboard ? DASHBOARD_LEGEND : null);
	}
	//# sourceMappingURL=legend.js.map

/***/ },
/* 198 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = function () {
	    return {
	        style: {
	            fontSize: '13px',
	            fontWeight: 'normal'
	        }
	    };
	};
	//# sourceMappingURL=noData.js.map

/***/ },
/* 199 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = function () {
	    return {
	        center: ['50%', '85%'],
	        size: '90%',
	        startAngle: -90,
	        endAngle: 90,
	        background: {
	            backgroundColor: '#F1F1F1',
	            innerRadius: '60%',
	            outerRadius: '100%',
	            shape: 'arc'
	        }
	    };
	};
	//# sourceMappingURL=gauge.js.map

/***/ },
/* 200 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = function (type) {
	    switch (type) {
	        case _.CHART_TYPE_GAUGE:
	            return (0, _gauge2.default)();
	            break;
	        default:
	            return undefined;
	    }
	};
	
	var _gauge = __webpack_require__(199);
	
	var _gauge2 = _interopRequireDefault(_gauge);
	
	var _ = __webpack_require__(16);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	//# sourceMappingURL=index.js.map

/***/ },
/* 201 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = function (series, dashboard) {
	    var fontSize = dashboard ? DASHBOARD_FONT_SIZE : DEFAULT_FONT_SIZE;
	
	    return [{
	        name: series[0].name,
	        data: series[0].data.slice(0, 1),
	        enableMouseTracking: false,
	        dataLabels: {
	            y: 0,
	            borderWidth: 0,
	            verticalAlign: 'bottom',
	            style: {
	                fontSize: fontSize
	            }
	        }
	    }];
	};
	
	var DEFAULT_FONT_SIZE = '34px';
	
	var DASHBOARD_FONT_SIZE = '24px';
	//# sourceMappingURL=gauge.js.map

/***/ },
/* 202 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = function (series, store, layout, isStacked, extraOptions) {
	    switch (layout.type) {
	        case _.CHART_TYPE_PIE:
	            series = (0, _pie2.default)(series, store, layout, isStacked, extraOptions.colors);
	            break;
	        case _.CHART_TYPE_GAUGE:
	            series = (0, _gauge2.default)(series, extraOptions.dashboard);
	            break;
	        default:
	            series = getDefault(series, store, layout, isStacked, extraOptions.colors);
	    }
	
	    series.forEach(function (seriesObj) {
	
	        // animation
	        seriesObj.animation = {
	            duration: DEFAULT_ANIMATION_DURATION
	        };
	    });
	
	    return series;
	};
	
	var _getCumulativeData = __webpack_require__(194);
	
	var _getCumulativeData2 = _interopRequireDefault(_getCumulativeData);
	
	var _pie = __webpack_require__(203);
	
	var _pie2 = _interopRequireDefault(_pie);
	
	var _gauge = __webpack_require__(201);
	
	var _gauge2 = _interopRequireDefault(_gauge);
	
	var _type = __webpack_require__(32);
	
	var _type2 = _interopRequireDefault(_type);
	
	var _ = __webpack_require__(16);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DEFAULT_ANIMATION_DURATION = 300;
	
	function getColor(colors, index) {
	    return colors[index] || getColor(colors, index - colors.length);
	}
	
	function getDefault(series, store, layout, isStacked, colors) {
	    series.forEach(function (seriesObj, index) {
	        // show values
	        if (layout.showValues) {
	            seriesObj.dataLabels = {
	                enabled: true
	            };
	        }
	
	        // stacked
	        if (isStacked) {
	            // DHIS2-1060: stacked charts can optionally be shown as 100% stacked charts
	            seriesObj.stacking = layout.percentStackedValues === true ? 'percent' : 'normal';
	        }
	
	        // DHIS2-2101
	        // show bar/columm chart as EPI curve (basically remove spacing between bars/columns)
	        var chartType = (0, _type2.default)(layout.type).type;
	
	        if ((chartType === 'column' || chartType === 'bar') && layout.noSpaceBetweenColumns) {
	            seriesObj.pointPadding = 0;
	            seriesObj.groupPadding = 0;
	        }
	
	        // color
	        seriesObj.color = getColor(colors, index);
	    });
	
	    // DHIS2-701: use cumulative values
	    if (layout.cumulativeValues === true) {
	        series = (0, _getCumulativeData2.default)(series);
	    }
	
	    return series;
	}
	//# sourceMappingURL=index.js.map

/***/ },
/* 203 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = function (series, store, layout, isStacked, colors) {
	    return [{
	        name: series[0].name,
	        colorByPoint: true,
	        allowPointSelect: true,
	        cursor: 'pointer',
	        data: (0, _getCategories2.default)(store, layout).map(function (category, index) {
	            return {
	                name: category,
	                color: colors[index],
	                y: series[0].data[index]
	            };
	        }),
	        dataLabels: {
	            enabled: true,
	            formatter: function formatter() {
	                return '<span style="font-weight:normal">' + this.point.name + '</span><br/>' + this.y + '<span style="font-weight:normal"> (' + this.percentage.toFixed(1) + ' %)</span>';
	            }
	        }
	    }];
	};
	
	var _getCategories = __webpack_require__(72);
	
	var _getCategories2 = _interopRequireDefault(_getCategories);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	//# sourceMappingURL=pie.js.map

/***/ },
/* 204 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = function (series, layout, dashboard, filterTitle) {
	    var seriesName = series[0].name;
	
	    var mergedTitle = seriesName + ' - ' + filterTitle;
	
	    return {
	        text: dashboard || (0, _isString2.default)(layout.title) ? mergedTitle : seriesName
	    };
	};
	
	var _isString = __webpack_require__(8);
	
	var _isString2 = _interopRequireDefault(_isString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	//# sourceMappingURL=gauge.js.map

/***/ },
/* 205 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = function (series, layout, metaData, dashboard) {
	    if (layout.hideSubtitle) {
	        return null;
	    }
	
	    var subtitle = void 0;
	
	    // DHIS2-578: allow for optional custom subtitle
	    if ((0, _isString2.default)(layout.subtitle)) {
	        subtitle = { text: layout.subtitle };
	    } else {
	        var filterTitle = (0, _getFilterTitle2.default)(layout.filters, metaData);
	
	        switch (layout.type) {
	            case _.CHART_TYPE_PIE:
	            case _.CHART_TYPE_GAUGE:
	                subtitle = (0, _gauge2.default)(series, layout, dashboard, filterTitle);
	                break;
	            default:
	                subtitle = getDefault(layout, dashboard, filterTitle);
	        }
	    }
	
	    return subtitle ? _extends({}, DEFAULT_SUBTITLE, dashboard ? DASHBOARD_SUBTITLE : undefined, subtitle) : subtitle;
	};
	
	var _isString = __webpack_require__(8);
	
	var _isString2 = _interopRequireDefault(_isString);
	
	var _gauge = __webpack_require__(204);
	
	var _gauge2 = _interopRequireDefault(_gauge);
	
	var _getFilterTitle = __webpack_require__(73);
	
	var _getFilterTitle2 = _interopRequireDefault(_getFilterTitle);
	
	var _ = __webpack_require__(16);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DEFAULT_SUBTITLE = {
	    style: {
	        // DHIS2-578: dynamically truncate subtitle when it's taking more than 1 line
	        whiteSpace: 'nowrap',
	        overflow: 'hidden',
	        textOverflow: 'ellipsis',
	
	        fontSize: '14px',
	        color: '#555',
	        textShadow: '0 0 #999'
	    }
	};
	
	var DASHBOARD_SUBTITLE = {
	    style: {
	        // DHIS2-578: dynamically truncate subtitle when it's taking more than 1 line
	        whiteSpace: 'nowrap',
	        overflow: 'hidden',
	        textOverflow: 'ellipsis',
	
	        fontSize: '12px'
	    }
	};
	
	function getDefault(layout, dashboard, filterTitle) {
	    return {
	        text: dashboard || (0, _isString2.default)(layout.title) ? filterTitle : undefined
	    };
	}
	//# sourceMappingURL=index.js.map

/***/ },
/* 206 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = function (layout, metaData, dashboard) {
	    return _extends(getTextObject(layout, metaData, dashboard), DEFAULT_TITLE_STYLE, dashboard ? DASHBOARD_TITLE_STYLE : undefined);
	};
	
	var _isString = __webpack_require__(8);
	
	var _isString2 = _interopRequireDefault(_isString);
	
	var _getFilterTitle = __webpack_require__(73);
	
	var _getFilterTitle2 = _interopRequireDefault(_getFilterTitle);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DEFAULT_TITLE_STYLE = {
	    margin: 30,
	    y: 18,
	    style: {
	        color: '#111'
	    }
	};
	
	var DASHBOARD_TITLE_STYLE = {
	    margin: 15,
	    y: 12,
	    style: {
	        fontSize: '13px',
	        fontWeight: 'bold'
	    }
	};
	
	function getText(layout, metaData, dashboard) {
	
	    // title
	    if ((0, _isString2.default)(layout.title) && layout.title.length) {
	        return layout.title;
	    }
	
	    // name - REMOVED: APPS SHOULD HANDLE THIS
	    // if (dashboard && (isString(layout.name) && layout.name.length)) {
	    //     return layout.name;
	    // }
	
	    // filters
	    if (layout.filters && !dashboard) {
	        return (0, _getFilterTitle2.default)(layout.filters, metaData);
	    }
	
	    return null;
	}
	
	function getTextObject(layout, metaData, dashboard) {
	    return {
	        text: layout.hideTitle ? null : getText(layout, metaData, dashboard)
	    };
	}
	
	;
	//# sourceMappingURL=title.js.map

/***/ },
/* 207 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = function () {
	    return undefined;
	};
	//# sourceMappingURL=gauge.js.map

/***/ },
/* 208 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = function (store, layout) {
	    var xAxis = void 0;
	
	    switch (layout.type) {
	        case _.CHART_TYPE_GAUGE:
	            xAxis = (0, _gauge2.default)();
	            break;
	        default:
	            xAxis = getDefault(store, layout);
	    }
	
	    return xAxis;
	};
	
	var _objectClean = __webpack_require__(33);
	
	var _objectClean2 = _interopRequireDefault(_objectClean);
	
	var _getAxisTitle = __webpack_require__(71);
	
	var _getAxisTitle2 = _interopRequireDefault(_getAxisTitle);
	
	var _getCategories = __webpack_require__(72);
	
	var _getCategories2 = _interopRequireDefault(_getCategories);
	
	var _gauge = __webpack_require__(207);
	
	var _gauge2 = _interopRequireDefault(_gauge);
	
	var _ = __webpack_require__(16);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getDefault(store, layout) {
	    return (0, _objectClean2.default)({
	        categories: (0, _getCategories2.default)(store, layout),
	        title: (0, _getAxisTitle2.default)(layout.domainAxisTitle),
	        labels: {
	            style: {
	                color: '#666',
	                textShadow: '0 0 #ccc'
	            }
	        }
	    });
	}
	//# sourceMappingURL=index.js.map

/***/ },
/* 209 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = function (layout, legendSet) {
	    return (0, _objectClean2.default)({
	        min: 0,
	        max: DEFAULT_MAX_VALUE,
	        lineWidth: 0,
	        minorTickInterval: null,
	        tickLength: 0,
	        tickAmount: 0,
	        labels: {
	            y: 18,
	            style: {
	                fontSize: '13px'
	            }
	        },
	        stops: getStopsByLegendSet(legendSet)
	    });
	};
	
	var _arraySort = __webpack_require__(76);
	
	var _arraySort2 = _interopRequireDefault(_arraySort);
	
	var _isObject = __webpack_require__(17);
	
	var _isObject2 = _interopRequireDefault(_isObject);
	
	var _objectClean = __webpack_require__(33);
	
	var _objectClean2 = _interopRequireDefault(_objectClean);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DEFAULT_MAX_VALUE = 100;
	
	function getStopsByLegendSet(legendSet) {
	    return (0, _isObject2.default)(legendSet) ? (0, _arraySort2.default)(legendSet.legends, 'ASC', 'endValue').map(function (legend) {
	        return [parseFloat(legend.endValue) / DEFAULT_MAX_VALUE, legend.color];
	    }) : undefined;
	}
	//# sourceMappingURL=gauge.js.map

/***/ },
/* 210 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = function (layout, extraOptions) {
	    var series = void 0;
	
	    switch (layout.type) {
	        case _.CHART_TYPE_GAUGE:
	            series = (0, _gauge2.default)(layout, extraOptions.legendSet);
	            break;
	        default:
	            series = getDefault(layout);
	    }
	
	    return series;
	};
	
	var _arrayClean = __webpack_require__(223);
	
	var _arrayClean2 = _interopRequireDefault(_arrayClean);
	
	var _objectClean = __webpack_require__(33);
	
	var _objectClean2 = _interopRequireDefault(_objectClean);
	
	var _isNumeric = __webpack_require__(227);
	
	var _isNumeric2 = _interopRequireDefault(_isNumeric);
	
	var _isString = __webpack_require__(8);
	
	var _isString2 = _interopRequireDefault(_isString);
	
	var _getAxisTitle = __webpack_require__(71);
	
	var _getAxisTitle2 = _interopRequireDefault(_getAxisTitle);
	
	var _ = __webpack_require__(16);
	
	var _gauge = __webpack_require__(209);
	
	var _gauge2 = _interopRequireDefault(_gauge);
	
	var _type = __webpack_require__(32);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DEFAULT_MIN_VALUE = 0;
	
	var DEFAULT_GRIDLINE_COLOR = '#E1E1E1';
	
	var DEFAULT_PLOTLINE = {
	    color: '#000',
	    width: 2,
	    zIndex: 4
	};
	
	var DEFAULT_PLOTLINE_LABEL = {
	    y: -7,
	    style: {
	        fontSize: 13,
	        textShadow: '0 0 6px #FFF'
	    }
	};
	
	function getMinValue(layout) {
	    return (0, _isNumeric2.default)(layout.rangeAxisMinValue) ? layout.rangeAxisMinValue : DEFAULT_MIN_VALUE;
	}
	
	function getMaxValue(layout) {
	    return (0, _isNumeric2.default)(layout.rangeAxisMaxValue) ? layout.rangeAxisMaxValue : undefined;
	}
	
	function getSteps(layout) {
	    return (0, _isNumeric2.default)(layout.rangeAxisSteps) ? layout.rangeAxisSteps : undefined;
	}
	
	function getTargetLine(layout) {
	    return (0, _isNumeric2.default)(layout.targetLineValue) ? _extends({}, DEFAULT_PLOTLINE, (0, _objectClean2.default)({
	        value: layout.targetLineValue,
	        label: (0, _isString2.default)(layout.targetLineTitle) ? _extends({}, DEFAULT_PLOTLINE_LABEL, {
	            text: layout.targetLineTitle
	        }) : undefined
	    })) : undefined;
	}
	
	function getBaseLine(layout) {
	    return (0, _isNumeric2.default)(layout.baseLineValue) ? _extends({}, DEFAULT_PLOTLINE, (0, _objectClean2.default)({
	        value: layout.baseLineValue,
	        label: (0, _isString2.default)(layout.baseLineTitle) ? _extends({}, DEFAULT_PLOTLINE_LABEL, {
	            text: layout.baseLineTitle
	        }) : undefined
	    })) : undefined;
	}
	
	function getFormatter(layout) {
	    return {
	        formatter: function formatter() {
	            return this.value.toFixed(layout.rangeAxisDecimals);
	        }
	    };
	}
	
	function getLabels(layout) {
	    return (0, _isNumeric2.default)(layout.rangeAxisDecimals) ? getFormatter(layout) : undefined;
	}
	
	function getDefault(layout) {
	    return (0, _objectClean2.default)({
	        min: getMinValue(layout),
	        max: getMaxValue(layout),
	        tickAmount: getSteps(layout),
	        title: (0, _getAxisTitle2.default)(layout.rangeAxisTitle),
	        plotLines: (0, _arrayClean2.default)([getTargetLine(layout), getBaseLine(layout)]),
	        gridLineColor: DEFAULT_GRIDLINE_COLOR,
	        labels: getLabels(layout),
	
	        // DHIS2-649: put first serie at the bottom of the stack
	        // in this way the legend sequence matches the serie sequence
	        reversedStacks: (0, _type.getIsStacked)(layout.type) ? false : true
	    });
	}
	//# sourceMappingURL=index.js.map

/***/ },
/* 211 */
[609, 16],
/* 212 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = function (config, el) {
	    if (config) {
	        config.chart.renderTo = el || config.chart.renderTo;
	
	        return new _highcharts2.default.Chart(config);
	    }
	};
	
	var _highcharts = __webpack_require__(234);
	
	var _highcharts2 = _interopRequireDefault(_highcharts);
	
	var _highchartsMore = __webpack_require__(231);
	
	var _highchartsMore2 = _interopRequireDefault(_highchartsMore);
	
	var _highchartsSolidGauge = __webpack_require__(233);
	
	var _highchartsSolidGauge2 = _interopRequireDefault(_highchartsSolidGauge);
	
	var _highchartsNoDataToDisplay = __webpack_require__(232);
	
	var _highchartsNoDataToDisplay2 = _interopRequireDefault(_highchartsNoDataToDisplay);
	
	var _highchartsExporting = __webpack_require__(230);
	
	var _highchartsExporting2 = _interopRequireDefault(_highchartsExporting);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// apply
	(0, _highchartsMore2.default)(_highcharts2.default);
	(0, _highchartsSolidGauge2.default)(_highcharts2.default);
	(0, _highchartsNoDataToDisplay2.default)(_highcharts2.default);
	(0, _highchartsExporting2.default)(_highcharts2.default);
	
	;
	//# sourceMappingURL=index.js.map

/***/ },
/* 213 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _highcharts = __webpack_require__(212);
	
	var _highcharts2 = _interopRequireDefault(_highcharts);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    highcharts: _highcharts2.default
	};
	//# sourceMappingURL=index.js.map

/***/ },
/* 214 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = function (_ref) {
	    var _this = this;
	
	    var store = _ref.store,
	        layout = _ref.layout,
	        el = _ref.el,
	        _ref$inputFormat = _ref.inputFormat,
	        inputFormat = _ref$inputFormat === undefined ? 'dhis' : _ref$inputFormat,
	        _ref$outputFormat = _ref.outputFormat,
	        outputFormat = _ref$outputFormat === undefined ? 'highcharts' : _ref$outputFormat,
	        extraLayout = _ref.extraLayout,
	        extraOptions = _ref.extraOptions,
	        onError = _ref.onError,
	        onWarning = _ref.onWarning;
	
	    var _validator = _validators2.default[inputFormat] || _validators2.default.noValidation;
	    var _adapter = _adapters2.default[inputFormat + '_' + outputFormat];
	    var _generator = _generators2.default[outputFormat];
	
	    if (_validator === _validators2.default.noValidation) {
	        onWarning('No validation implementation for config input format "' + inputFormat + '"');
	    }
	
	    if (!_adapter) {
	        onError('No config tranformation implementation for format "' + inputFormat + '" to format "' + outputFormat + '"');
	    }
	
	    if (!_generator) {
	        onError('No chart implementation for format\xA0' + outputFormat);
	    }
	
	    this.getConfig = function () {
	        return _adapter({
	            layout: _validator({ layout: layout, onError: onError, onWarning: onWarning }),
	            extraOptions: _extends({}, DEFAULT_EXTRA_OPTIONS, extraOptions),
	            store: store,
	            el: el,
	            extraLayout: extraLayout
	        });
	    };
	
	    this.createChart = function () {
	        return _generator(_this.getConfig(), el);
	    };
	};
	
	var _validators = __webpack_require__(216);
	
	var _validators2 = _interopRequireDefault(_validators);
	
	var _adapters = __webpack_require__(211);
	
	var _adapters2 = _interopRequireDefault(_adapters);
	
	var _generators = __webpack_require__(213);
	
	var _generators2 = _interopRequireDefault(_generators);
	
	var _ = __webpack_require__(75);
	
	var _2 = _interopRequireDefault(_);
	
	var _colors = __webpack_require__(222);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DEFAULT_EXTRA_OPTIONS = {
	    colors: _colors.theme1
	};
	//# sourceMappingURL=index.js.map

/***/ },
/* 215 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = function (_ref) {
	    var layout = _ref.layout,
	        onError = _ref.onError,
	        onWarning = _ref.onWarning;
	
	    return layout;
	};
	//# sourceMappingURL=index.js.map

/***/ },
/* 216 */
[611, 215],
/* 217 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = function (_ref) {
	    var data = _ref.data,
	        _ref$seriesId = _ref.seriesId,
	        seriesId = _ref$seriesId === undefined ? data.headers[0].name : _ref$seriesId,
	        _ref$categoryId = _ref.categoryId,
	        categoryId = _ref$categoryId === undefined ? data.headers[1].name : _ref$categoryId;
	
	    var headers = data.headers;
	    var metaData = data.metaData;
	    var rows = data.rows;
	    var headerIdIndexMap = getHeaderIdIndexMap(headers);
	
	    var seriesIndex = headerIdIndexMap.get(seriesId);
	    var categoryIndex = headerIdIndexMap.get(categoryId);
	    var valueIndex = headerIdIndexMap.get(VALUE_ID);
	
	    var seriesHeader = headers[seriesIndex];
	    var categoryHeader = headers[categoryIndex];
	
	    var idValueMap = getIdValueMap(rows, seriesHeader, categoryHeader, valueIndex);
	
	    var seriesIds = metaData.dimensions[seriesId];
	    var categoryIds = metaData.dimensions[categoryId];
	
	    return getData(seriesIds, categoryIds, idValueMap, metaData.items);
	};
	
	var VALUE_ID = 'value';
	
	function getHeaderIdIndexMap(headers) {
	    var map = new Map();
	
	    headers.forEach(function (header, index) {
	        map.set(header.name, index);
	    });
	
	    return map;
	}
	
	function getPrefixedId(row, header) {
	    return (header.isPrefix ? header.name + '_' : '') + row[header.index];
	}
	
	function getIdValueMap(rows, seriesHeader, categoryHeader, valueIndex) {
	    var map = new Map();
	
	    var key = void 0;
	    var value = void 0;
	
	    rows.forEach(function (row) {
	        key = getPrefixedId(row, seriesHeader) + '-' + getPrefixedId(row, categoryHeader);
	        value = row[valueIndex];
	
	        map.set(key, value);
	    });
	
	    return map;
	}
	
	function getData(seriesIds, categoryIds, idValueMap, metaDataItems) {
	    var data = [];
	    var dataItem = void 0;
	    var value = void 0;
	
	    seriesIds.forEach(function (seriesId) {
	        dataItem = {
	            name: metaDataItems[seriesId].name,
	            data: []
	        };
	
	        categoryIds.forEach(function (categoryId) {
	            value = idValueMap.get(seriesId + '-' + categoryId);
	
	            // DHIS2-1261: 0 is a valid value
	            // undefined value means the key was not found within the rows
	            // in that case null is returned as value in the serie for highcharts
	            dataItem.data.push(value == undefined ? null : parseFloat(value));
	        });
	
	        data.push(dataItem);
	    });
	
	    return data;
	}
	//# sourceMappingURL=index.js.map

/***/ },
/* 218 */
[609, 217],
/* 219 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = function (_ref) {
	    var data = _ref.data,
	        _ref$inputFormat = _ref.inputFormat,
	        inputFormat = _ref$inputFormat === undefined ? 'dhis' : _ref$inputFormat,
	        _ref$outputFormat = _ref.outputFormat,
	        outputFormat = _ref$outputFormat === undefined ? 'highcharts' : _ref$outputFormat,
	        seriesId = _ref.seriesId,
	        categoryId = _ref.categoryId,
	        error = _ref.error,
	        warning = _ref.warning;
	
	    var _validator = _validators2.default[inputFormat] || _validators2.default.noValidation;
	    var _adapter = _adapters2.default[inputFormat + '_' + outputFormat];
	
	    if (_validator === _validators2.default.noValidation) {
	        warning('Validation not supported for data input format "' + inputFormat + '"');
	    }
	
	    if (!_adapter) {
	        error('Data tranformation from "' + inputFormat + '" to "' + outputFormat + '" is not supported');
	    }
	
	    this.data = data;
	
	    this.generateData = function (_ref2) {
	        var _ref2$seriesId = _ref2.seriesId,
	            seriesId = _ref2$seriesId === undefined ? seriesId : _ref2$seriesId,
	            _ref2$categoryId = _ref2.categoryId,
	            categoryId = _ref2$categoryId === undefined ? categoryId : _ref2$categoryId;
	
	        return _adapter({
	            data: _validator({ data: data, error: error, warning: warning }),
	            seriesId: seriesId,
	            categoryId: categoryId
	        });
	    };
	};
	
	var _validators = __webpack_require__(221);
	
	var _validators2 = _interopRequireDefault(_validators);
	
	var _adapters = __webpack_require__(218);
	
	var _adapters2 = _interopRequireDefault(_adapters);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	//# sourceMappingURL=index.js.map

/***/ },
/* 220 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = function (_ref) {
	    var data = _ref.data,
	        error = _ref.error,
	        warning = _ref.warning;
	
	    if (!(0, _isObject2.default)(data)) {
	        error(getMessage('Data is not an object'));
	    }
	
	    // headers
	
	    if (!(0, _isArray2.default)(data.headers)) {
	        error(getMessage('Response headers is not an array'));
	    }
	
	    if (!data.headers.length > 1) {
	        error(getMessage('At least two response headers required'));
	    }
	
	    data.headers.forEach(function (header) {
	        return validateHeader(header, error);
	    });
	
	    // meta data
	
	    if (!(0, _isObject2.default)(data.metaData)) {
	        error(getMessage('Metadata is not an object'));
	    }
	
	    if (!(0, _isObject2.default)(data.metaData.items)) {
	        error(getMessage('Metadata items is not an object'));
	    }
	
	    if (!(0, _isObject2.default)(data.metaData.dimensions)) {
	        error(getMessage('Metadata dimensions is not an object'));
	    }
	
	    // data
	
	    if (!(0, _isArray2.default)(data.rows)) {
	        warning(getMessage('Data rows is not an array'));
	    }
	
	    if (!data.rows.length) {
	        warning(getMessage('No data rows provided'));
	    }
	
	    data.rows.forEach(function (row) {
	        return validateRow(row, data.headers.length, error);
	    });
	
	    return data;
	};
	
	var _isArray = __webpack_require__(11);
	
	var _isArray2 = _interopRequireDefault(_isArray);
	
	var _isObject = __webpack_require__(17);
	
	var _isObject2 = _interopRequireDefault(_isObject);
	
	var _isString = __webpack_require__(8);
	
	var _isString2 = _interopRequireDefault(_isString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MODULE = 'Data validator: ';
	
	function getMessage(text) {
	    return MODULE + text;
	}
	
	function validateHeader(header, error) {
	    if (!(0, _isObject2.default)(header)) {
	        error(getMessage('Header is not an object'));
	    }
	
	    if (header.meta) {
	        if (!(0, _isString2.default)(header.name)) {
	            error(getMessage('Header name is not a string'));
	        }
	    }
	}
	
	function validateRowValue(rowValue, error) {
	    if (!(0, _isString2.default)(rowValue)) {
	        error(getMessage('Row value is not a string'));
	    }
	}
	
	function validateRow(row, headersLength, error) {
	    if (!(0, _isArray2.default)(row)) {
	        error(getMessage('Data row is not an array'));
	    }
	
	    if (row.length !== headersLength) {
	        error(getMessage('Data row length is invalid'));
	    }
	
	    row.forEach(function (rowValue) {
	        return validateRowValue(rowValue, error);
	    });
	}
	//# sourceMappingURL=index.js.map

/***/ },
/* 221 */
[611, 220],
/* 222 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var theme1 = '#a9be3b|#558cc0|#d34957|#ff9f3a|#968f8f|#b7409f|#ffda64|#4fbdae|#b78040|#676767|#6a33cf|#4a7833'.split('|');
	
	exports.theme1 = theme1;
	//# sourceMappingURL=index.js.map

/***/ },
/* 223 */
[597, 43],
/* 224 */
28,
/* 225 */
[602, 11, 17, 8],
/* 226 */
14,
/* 227 */
22,
/* 228 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = numberDecimals;
	
	var _numberIsFinite = __webpack_require__(78);
	
	var _numberIsFinite2 = _interopRequireDefault(_numberIsFinite);
	
	var _isInteger = __webpack_require__(77);
	
	var _isInteger2 = _interopRequireDefault(_isInteger);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Returns the number of decimal places in a number
	 *
	 * @param {Number} number The number to be checked
	 * @returns {Number} The number of decimal places in the given number
	 */
	function numberDecimals(number) {
	    var abs = Math.abs(number);
	    var tmp = abs;
	    var count = 1;
	
	    while (!(0, _isInteger2.default)(tmp) && (0, _numberIsFinite2.default)(tmp)) {
	        tmp = abs * Math.pow(10, count++);
	    }
	
	    return count - 1;
	}
	//# sourceMappingURL=numberDecimals.js.map

/***/ },
/* 229 */
/***/ function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-color/ Version 1.0.1. Copyright 2016 Mike Bostock.
	(function (global, factory) {
	   true ? factory(exports) :
	  typeof define === 'function' && define.amd ? define(['exports'], factory) :
	  (factory((global.d3 = global.d3 || {})));
	}(this, function (exports) { 'use strict';
	
	  function define(constructor, factory, prototype) {
	    constructor.prototype = factory.prototype = prototype;
	    prototype.constructor = constructor;
	  }
	
	  function extend(parent, definition) {
	    var prototype = Object.create(parent.prototype);
	    for (var key in definition) prototype[key] = definition[key];
	    return prototype;
	  }
	
	  function Color() {}
	
	  var darker = 0.7;
	  var brighter = 1 / darker;
	
	  var reHex3 = /^#([0-9a-f]{3})$/;
	  var reHex6 = /^#([0-9a-f]{6})$/;
	  var reRgbInteger = /^rgb\(\s*([-+]?\d+)\s*,\s*([-+]?\d+)\s*,\s*([-+]?\d+)\s*\)$/;
	  var reRgbPercent = /^rgb\(\s*([-+]?\d+(?:\.\d+)?)%\s*,\s*([-+]?\d+(?:\.\d+)?)%\s*,\s*([-+]?\d+(?:\.\d+)?)%\s*\)$/;
	  var reRgbaInteger = /^rgba\(\s*([-+]?\d+)\s*,\s*([-+]?\d+)\s*,\s*([-+]?\d+)\s*,\s*([-+]?\d+(?:\.\d+)?)\s*\)$/;
	  var reRgbaPercent = /^rgba\(\s*([-+]?\d+(?:\.\d+)?)%\s*,\s*([-+]?\d+(?:\.\d+)?)%\s*,\s*([-+]?\d+(?:\.\d+)?)%\s*,\s*([-+]?\d+(?:\.\d+)?)\s*\)$/;
	  var reHslPercent = /^hsl\(\s*([-+]?\d+(?:\.\d+)?)\s*,\s*([-+]?\d+(?:\.\d+)?)%\s*,\s*([-+]?\d+(?:\.\d+)?)%\s*\)$/;
	  var reHslaPercent = /^hsla\(\s*([-+]?\d+(?:\.\d+)?)\s*,\s*([-+]?\d+(?:\.\d+)?)%\s*,\s*([-+]?\d+(?:\.\d+)?)%\s*,\s*([-+]?\d+(?:\.\d+)?)\s*\)$/;
	  var named = {
	    aliceblue: 0xf0f8ff,
	    antiquewhite: 0xfaebd7,
	    aqua: 0x00ffff,
	    aquamarine: 0x7fffd4,
	    azure: 0xf0ffff,
	    beige: 0xf5f5dc,
	    bisque: 0xffe4c4,
	    black: 0x000000,
	    blanchedalmond: 0xffebcd,
	    blue: 0x0000ff,
	    blueviolet: 0x8a2be2,
	    brown: 0xa52a2a,
	    burlywood: 0xdeb887,
	    cadetblue: 0x5f9ea0,
	    chartreuse: 0x7fff00,
	    chocolate: 0xd2691e,
	    coral: 0xff7f50,
	    cornflowerblue: 0x6495ed,
	    cornsilk: 0xfff8dc,
	    crimson: 0xdc143c,
	    cyan: 0x00ffff,
	    darkblue: 0x00008b,
	    darkcyan: 0x008b8b,
	    darkgoldenrod: 0xb8860b,
	    darkgray: 0xa9a9a9,
	    darkgreen: 0x006400,
	    darkgrey: 0xa9a9a9,
	    darkkhaki: 0xbdb76b,
	    darkmagenta: 0x8b008b,
	    darkolivegreen: 0x556b2f,
	    darkorange: 0xff8c00,
	    darkorchid: 0x9932cc,
	    darkred: 0x8b0000,
	    darksalmon: 0xe9967a,
	    darkseagreen: 0x8fbc8f,
	    darkslateblue: 0x483d8b,
	    darkslategray: 0x2f4f4f,
	    darkslategrey: 0x2f4f4f,
	    darkturquoise: 0x00ced1,
	    darkviolet: 0x9400d3,
	    deeppink: 0xff1493,
	    deepskyblue: 0x00bfff,
	    dimgray: 0x696969,
	    dimgrey: 0x696969,
	    dodgerblue: 0x1e90ff,
	    firebrick: 0xb22222,
	    floralwhite: 0xfffaf0,
	    forestgreen: 0x228b22,
	    fuchsia: 0xff00ff,
	    gainsboro: 0xdcdcdc,
	    ghostwhite: 0xf8f8ff,
	    gold: 0xffd700,
	    goldenrod: 0xdaa520,
	    gray: 0x808080,
	    green: 0x008000,
	    greenyellow: 0xadff2f,
	    grey: 0x808080,
	    honeydew: 0xf0fff0,
	    hotpink: 0xff69b4,
	    indianred: 0xcd5c5c,
	    indigo: 0x4b0082,
	    ivory: 0xfffff0,
	    khaki: 0xf0e68c,
	    lavender: 0xe6e6fa,
	    lavenderblush: 0xfff0f5,
	    lawngreen: 0x7cfc00,
	    lemonchiffon: 0xfffacd,
	    lightblue: 0xadd8e6,
	    lightcoral: 0xf08080,
	    lightcyan: 0xe0ffff,
	    lightgoldenrodyellow: 0xfafad2,
	    lightgray: 0xd3d3d3,
	    lightgreen: 0x90ee90,
	    lightgrey: 0xd3d3d3,
	    lightpink: 0xffb6c1,
	    lightsalmon: 0xffa07a,
	    lightseagreen: 0x20b2aa,
	    lightskyblue: 0x87cefa,
	    lightslategray: 0x778899,
	    lightslategrey: 0x778899,
	    lightsteelblue: 0xb0c4de,
	    lightyellow: 0xffffe0,
	    lime: 0x00ff00,
	    limegreen: 0x32cd32,
	    linen: 0xfaf0e6,
	    magenta: 0xff00ff,
	    maroon: 0x800000,
	    mediumaquamarine: 0x66cdaa,
	    mediumblue: 0x0000cd,
	    mediumorchid: 0xba55d3,
	    mediumpurple: 0x9370db,
	    mediumseagreen: 0x3cb371,
	    mediumslateblue: 0x7b68ee,
	    mediumspringgreen: 0x00fa9a,
	    mediumturquoise: 0x48d1cc,
	    mediumvioletred: 0xc71585,
	    midnightblue: 0x191970,
	    mintcream: 0xf5fffa,
	    mistyrose: 0xffe4e1,
	    moccasin: 0xffe4b5,
	    navajowhite: 0xffdead,
	    navy: 0x000080,
	    oldlace: 0xfdf5e6,
	    olive: 0x808000,
	    olivedrab: 0x6b8e23,
	    orange: 0xffa500,
	    orangered: 0xff4500,
	    orchid: 0xda70d6,
	    palegoldenrod: 0xeee8aa,
	    palegreen: 0x98fb98,
	    paleturquoise: 0xafeeee,
	    palevioletred: 0xdb7093,
	    papayawhip: 0xffefd5,
	    peachpuff: 0xffdab9,
	    peru: 0xcd853f,
	    pink: 0xffc0cb,
	    plum: 0xdda0dd,
	    powderblue: 0xb0e0e6,
	    purple: 0x800080,
	    rebeccapurple: 0x663399,
	    red: 0xff0000,
	    rosybrown: 0xbc8f8f,
	    royalblue: 0x4169e1,
	    saddlebrown: 0x8b4513,
	    salmon: 0xfa8072,
	    sandybrown: 0xf4a460,
	    seagreen: 0x2e8b57,
	    seashell: 0xfff5ee,
	    sienna: 0xa0522d,
	    silver: 0xc0c0c0,
	    skyblue: 0x87ceeb,
	    slateblue: 0x6a5acd,
	    slategray: 0x708090,
	    slategrey: 0x708090,
	    snow: 0xfffafa,
	    springgreen: 0x00ff7f,
	    steelblue: 0x4682b4,
	    tan: 0xd2b48c,
	    teal: 0x008080,
	    thistle: 0xd8bfd8,
	    tomato: 0xff6347,
	    turquoise: 0x40e0d0,
	    violet: 0xee82ee,
	    wheat: 0xf5deb3,
	    white: 0xffffff,
	    whitesmoke: 0xf5f5f5,
	    yellow: 0xffff00,
	    yellowgreen: 0x9acd32
	  };
	
	  define(Color, color, {
	    displayable: function() {
	      return this.rgb().displayable();
	    },
	    toString: function() {
	      return this.rgb() + "";
	    }
	  });
	
	  function color(format) {
	    var m;
	    format = (format + "").trim().toLowerCase();
	    return (m = reHex3.exec(format)) ? (m = parseInt(m[1], 16), new Rgb((m >> 8 & 0xf) | (m >> 4 & 0x0f0), (m >> 4 & 0xf) | (m & 0xf0), ((m & 0xf) << 4) | (m & 0xf), 1)) // #f00
	        : (m = reHex6.exec(format)) ? rgbn(parseInt(m[1], 16)) // #ff0000
	        : (m = reRgbInteger.exec(format)) ? new Rgb(m[1], m[2], m[3], 1) // rgb(255, 0, 0)
	        : (m = reRgbPercent.exec(format)) ? new Rgb(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, 1) // rgb(100%, 0%, 0%)
	        : (m = reRgbaInteger.exec(format)) ? rgba(m[1], m[2], m[3], m[4]) // rgba(255, 0, 0, 1)
	        : (m = reRgbaPercent.exec(format)) ? rgba(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, m[4]) // rgb(100%, 0%, 0%, 1)
	        : (m = reHslPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, 1) // hsl(120, 50%, 50%)
	        : (m = reHslaPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, m[4]) // hsla(120, 50%, 50%, 1)
	        : named.hasOwnProperty(format) ? rgbn(named[format])
	        : format === "transparent" ? new Rgb(NaN, NaN, NaN, 0)
	        : null;
	  }
	
	  function rgbn(n) {
	    return new Rgb(n >> 16 & 0xff, n >> 8 & 0xff, n & 0xff, 1);
	  }
	
	  function rgba(r, g, b, a) {
	    if (a <= 0) r = g = b = NaN;
	    return new Rgb(r, g, b, a);
	  }
	
	  function rgbConvert(o) {
	    if (!(o instanceof Color)) o = color(o);
	    if (!o) return new Rgb;
	    o = o.rgb();
	    return new Rgb(o.r, o.g, o.b, o.opacity);
	  }
	
	  function rgb(r, g, b, opacity) {
	    return arguments.length === 1 ? rgbConvert(r) : new Rgb(r, g, b, opacity == null ? 1 : opacity);
	  }
	
	  function Rgb(r, g, b, opacity) {
	    this.r = +r;
	    this.g = +g;
	    this.b = +b;
	    this.opacity = +opacity;
	  }
	
	  define(Rgb, rgb, extend(Color, {
	    brighter: function(k) {
	      k = k == null ? brighter : Math.pow(brighter, k);
	      return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
	    },
	    darker: function(k) {
	      k = k == null ? darker : Math.pow(darker, k);
	      return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
	    },
	    rgb: function() {
	      return this;
	    },
	    displayable: function() {
	      return (0 <= this.r && this.r <= 255)
	          && (0 <= this.g && this.g <= 255)
	          && (0 <= this.b && this.b <= 255)
	          && (0 <= this.opacity && this.opacity <= 1);
	    },
	    toString: function() {
	      var a = this.opacity; a = isNaN(a) ? 1 : Math.max(0, Math.min(1, a));
	      return (a === 1 ? "rgb(" : "rgba(")
	          + Math.max(0, Math.min(255, Math.round(this.r) || 0)) + ", "
	          + Math.max(0, Math.min(255, Math.round(this.g) || 0)) + ", "
	          + Math.max(0, Math.min(255, Math.round(this.b) || 0))
	          + (a === 1 ? ")" : ", " + a + ")");
	    }
	  }));
	
	  function hsla(h, s, l, a) {
	    if (a <= 0) h = s = l = NaN;
	    else if (l <= 0 || l >= 1) h = s = NaN;
	    else if (s <= 0) h = NaN;
	    return new Hsl(h, s, l, a);
	  }
	
	  function hslConvert(o) {
	    if (o instanceof Hsl) return new Hsl(o.h, o.s, o.l, o.opacity);
	    if (!(o instanceof Color)) o = color(o);
	    if (!o) return new Hsl;
	    if (o instanceof Hsl) return o;
	    o = o.rgb();
	    var r = o.r / 255,
	        g = o.g / 255,
	        b = o.b / 255,
	        min = Math.min(r, g, b),
	        max = Math.max(r, g, b),
	        h = NaN,
	        s = max - min,
	        l = (max + min) / 2;
	    if (s) {
	      if (r === max) h = (g - b) / s + (g < b) * 6;
	      else if (g === max) h = (b - r) / s + 2;
	      else h = (r - g) / s + 4;
	      s /= l < 0.5 ? max + min : 2 - max - min;
	      h *= 60;
	    } else {
	      s = l > 0 && l < 1 ? 0 : h;
	    }
	    return new Hsl(h, s, l, o.opacity);
	  }
	
	  function hsl(h, s, l, opacity) {
	    return arguments.length === 1 ? hslConvert(h) : new Hsl(h, s, l, opacity == null ? 1 : opacity);
	  }
	
	  function Hsl(h, s, l, opacity) {
	    this.h = +h;
	    this.s = +s;
	    this.l = +l;
	    this.opacity = +opacity;
	  }
	
	  define(Hsl, hsl, extend(Color, {
	    brighter: function(k) {
	      k = k == null ? brighter : Math.pow(brighter, k);
	      return new Hsl(this.h, this.s, this.l * k, this.opacity);
	    },
	    darker: function(k) {
	      k = k == null ? darker : Math.pow(darker, k);
	      return new Hsl(this.h, this.s, this.l * k, this.opacity);
	    },
	    rgb: function() {
	      var h = this.h % 360 + (this.h < 0) * 360,
	          s = isNaN(h) || isNaN(this.s) ? 0 : this.s,
	          l = this.l,
	          m2 = l + (l < 0.5 ? l : 1 - l) * s,
	          m1 = 2 * l - m2;
	      return new Rgb(
	        hsl2rgb(h >= 240 ? h - 240 : h + 120, m1, m2),
	        hsl2rgb(h, m1, m2),
	        hsl2rgb(h < 120 ? h + 240 : h - 120, m1, m2),
	        this.opacity
	      );
	    },
	    displayable: function() {
	      return (0 <= this.s && this.s <= 1 || isNaN(this.s))
	          && (0 <= this.l && this.l <= 1)
	          && (0 <= this.opacity && this.opacity <= 1);
	    }
	  }));
	
	  /* From FvD 13.37, CSS Color Module Level 3 */
	  function hsl2rgb(h, m1, m2) {
	    return (h < 60 ? m1 + (m2 - m1) * h / 60
	        : h < 180 ? m2
	        : h < 240 ? m1 + (m2 - m1) * (240 - h) / 60
	        : m1) * 255;
	  }
	
	  var deg2rad = Math.PI / 180;
	  var rad2deg = 180 / Math.PI;
	
	  var Kn = 18;
	  var Xn = 0.950470;
	  var Yn = 1;
	  var Zn = 1.088830;
	  var t0 = 4 / 29;
	  var t1 = 6 / 29;
	  var t2 = 3 * t1 * t1;
	  var t3 = t1 * t1 * t1;
	  function labConvert(o) {
	    if (o instanceof Lab) return new Lab(o.l, o.a, o.b, o.opacity);
	    if (o instanceof Hcl) {
	      var h = o.h * deg2rad;
	      return new Lab(o.l, Math.cos(h) * o.c, Math.sin(h) * o.c, o.opacity);
	    }
	    if (!(o instanceof Rgb)) o = rgbConvert(o);
	    var b = rgb2xyz(o.r),
	        a = rgb2xyz(o.g),
	        l = rgb2xyz(o.b),
	        x = xyz2lab((0.4124564 * b + 0.3575761 * a + 0.1804375 * l) / Xn),
	        y = xyz2lab((0.2126729 * b + 0.7151522 * a + 0.0721750 * l) / Yn),
	        z = xyz2lab((0.0193339 * b + 0.1191920 * a + 0.9503041 * l) / Zn);
	    return new Lab(116 * y - 16, 500 * (x - y), 200 * (y - z), o.opacity);
	  }
	
	  function lab(l, a, b, opacity) {
	    return arguments.length === 1 ? labConvert(l) : new Lab(l, a, b, opacity == null ? 1 : opacity);
	  }
	
	  function Lab(l, a, b, opacity) {
	    this.l = +l;
	    this.a = +a;
	    this.b = +b;
	    this.opacity = +opacity;
	  }
	
	  define(Lab, lab, extend(Color, {
	    brighter: function(k) {
	      return new Lab(this.l + Kn * (k == null ? 1 : k), this.a, this.b, this.opacity);
	    },
	    darker: function(k) {
	      return new Lab(this.l - Kn * (k == null ? 1 : k), this.a, this.b, this.opacity);
	    },
	    rgb: function() {
	      var y = (this.l + 16) / 116,
	          x = isNaN(this.a) ? y : y + this.a / 500,
	          z = isNaN(this.b) ? y : y - this.b / 200;
	      y = Yn * lab2xyz(y);
	      x = Xn * lab2xyz(x);
	      z = Zn * lab2xyz(z);
	      return new Rgb(
	        xyz2rgb( 3.2404542 * x - 1.5371385 * y - 0.4985314 * z), // D65 -> sRGB
	        xyz2rgb(-0.9692660 * x + 1.8760108 * y + 0.0415560 * z),
	        xyz2rgb( 0.0556434 * x - 0.2040259 * y + 1.0572252 * z),
	        this.opacity
	      );
	    }
	  }));
	
	  function xyz2lab(t) {
	    return t > t3 ? Math.pow(t, 1 / 3) : t / t2 + t0;
	  }
	
	  function lab2xyz(t) {
	    return t > t1 ? t * t * t : t2 * (t - t0);
	  }
	
	  function xyz2rgb(x) {
	    return 255 * (x <= 0.0031308 ? 12.92 * x : 1.055 * Math.pow(x, 1 / 2.4) - 0.055);
	  }
	
	  function rgb2xyz(x) {
	    return (x /= 255) <= 0.04045 ? x / 12.92 : Math.pow((x + 0.055) / 1.055, 2.4);
	  }
	
	  function hclConvert(o) {
	    if (o instanceof Hcl) return new Hcl(o.h, o.c, o.l, o.opacity);
	    if (!(o instanceof Lab)) o = labConvert(o);
	    var h = Math.atan2(o.b, o.a) * rad2deg;
	    return new Hcl(h < 0 ? h + 360 : h, Math.sqrt(o.a * o.a + o.b * o.b), o.l, o.opacity);
	  }
	
	  function hcl(h, c, l, opacity) {
	    return arguments.length === 1 ? hclConvert(h) : new Hcl(h, c, l, opacity == null ? 1 : opacity);
	  }
	
	  function Hcl(h, c, l, opacity) {
	    this.h = +h;
	    this.c = +c;
	    this.l = +l;
	    this.opacity = +opacity;
	  }
	
	  define(Hcl, hcl, extend(Color, {
	    brighter: function(k) {
	      return new Hcl(this.h, this.c, this.l + Kn * (k == null ? 1 : k), this.opacity);
	    },
	    darker: function(k) {
	      return new Hcl(this.h, this.c, this.l - Kn * (k == null ? 1 : k), this.opacity);
	    },
	    rgb: function() {
	      return labConvert(this).rgb();
	    }
	  }));
	
	  var A = -0.14861;
	  var B = +1.78277;
	  var C = -0.29227;
	  var D = -0.90649;
	  var E = +1.97294;
	  var ED = E * D;
	  var EB = E * B;
	  var BC_DA = B * C - D * A;
	  function cubehelixConvert(o) {
	    if (o instanceof Cubehelix) return new Cubehelix(o.h, o.s, o.l, o.opacity);
	    if (!(o instanceof Rgb)) o = rgbConvert(o);
	    var r = o.r / 255,
	        g = o.g / 255,
	        b = o.b / 255,
	        l = (BC_DA * b + ED * r - EB * g) / (BC_DA + ED - EB),
	        bl = b - l,
	        k = (E * (g - l) - C * bl) / D,
	        s = Math.sqrt(k * k + bl * bl) / (E * l * (1 - l)), // NaN if l=0 or l=1
	        h = s ? Math.atan2(k, bl) * rad2deg - 120 : NaN;
	    return new Cubehelix(h < 0 ? h + 360 : h, s, l, o.opacity);
	  }
	
	  function cubehelix(h, s, l, opacity) {
	    return arguments.length === 1 ? cubehelixConvert(h) : new Cubehelix(h, s, l, opacity == null ? 1 : opacity);
	  }
	
	  function Cubehelix(h, s, l, opacity) {
	    this.h = +h;
	    this.s = +s;
	    this.l = +l;
	    this.opacity = +opacity;
	  }
	
	  define(Cubehelix, cubehelix, extend(Color, {
	    brighter: function(k) {
	      k = k == null ? brighter : Math.pow(brighter, k);
	      return new Cubehelix(this.h, this.s, this.l * k, this.opacity);
	    },
	    darker: function(k) {
	      k = k == null ? darker : Math.pow(darker, k);
	      return new Cubehelix(this.h, this.s, this.l * k, this.opacity);
	    },
	    rgb: function() {
	      var h = isNaN(this.h) ? 0 : (this.h + 120) * deg2rad,
	          l = +this.l,
	          a = isNaN(this.s) ? 0 : this.s * l * (1 - l),
	          cosh = Math.cos(h),
	          sinh = Math.sin(h);
	      return new Rgb(
	        255 * (l + a * (A * cosh + B * sinh)),
	        255 * (l + a * (C * cosh + D * sinh)),
	        255 * (l + a * (E * cosh)),
	        this.opacity
	      );
	    }
	  }));
	
	  exports.color = color;
	  exports.rgb = rgb;
	  exports.hsl = hsl;
	  exports.lab = lab;
	  exports.hcl = hcl;
	  exports.cubehelix = cubehelix;
	
	  Object.defineProperty(exports, '__esModule', { value: true });
	
	}));

/***/ },
/* 230 */
/***/ function(module, exports) {

	/*
	 Highcharts JS v4.2.3 (2016-02-08)
	 Exporting module
	
	 (c) 2010-2016 Torstein Honsi
	
	 License: www.highcharts.com/license
	*/
	(function(f){typeof module==="object"&&module.exports?module.exports=f:f(Highcharts)})(function(f){var r=f.win,m=r.document,A=f.Chart,t=f.addEvent,B=f.removeEvent,C=f.fireEvent,n=f.createElement,s=f.discardElement,v=f.css,l=f.merge,i=f.each,q=f.extend,F=f.splat,G=Math.max,H=f.isTouchDevice,I=f.Renderer.prototype.symbols,y=f.getOptions(),z;q(y.lang,{printChart:"Print chart",downloadPNG:"Download PNG image",downloadJPEG:"Download JPEG image",downloadPDF:"Download PDF document",downloadSVG:"Download SVG vector image",
	contextButtonTitle:"Chart context menu"});y.navigation={menuStyle:{border:"1px solid #A0A0A0",background:"#FFFFFF",padding:"5px 0"},menuItemStyle:{padding:"0 10px",background:"none",color:"#303030",fontSize:H?"14px":"11px"},menuItemHoverStyle:{background:"#4572A5",color:"#FFFFFF"},buttonOptions:{symbolFill:"#E0E0E0",symbolSize:14,symbolStroke:"#666",symbolStrokeWidth:3,symbolX:12.5,symbolY:10.5,align:"right",buttonSpacing:3,height:22,theme:{fill:"white",stroke:"none"},verticalAlign:"top",width:24}};
	y.exporting={type:"image/png",url:"http://export.highcharts.com/",buttons:{contextButton:{menuClassName:"highcharts-contextmenu",symbol:"menu",_titleKey:"contextButtonTitle",menuItems:[{textKey:"printChart",onclick:function(){this.print()}},{separator:!0},{textKey:"downloadPNG",onclick:function(){this.exportChart()}},{textKey:"downloadJPEG",onclick:function(){this.exportChart({type:"image/jpeg"})}},{textKey:"downloadPDF",onclick:function(){this.exportChart({type:"application/pdf"})}},{textKey:"downloadSVG",
	onclick:function(){this.exportChart({type:"image/svg+xml"})}}]}}};f.post=function(a,b,e){var c,a=n("form",l({method:"post",action:a,enctype:"multipart/form-data"},e),{display:"none"},m.body);for(c in b)n("input",{type:"hidden",name:c,value:b[c]},null,a);a.submit();s(a)};q(A.prototype,{sanitizeSVG:function(a){return a.replace(/zIndex="[^"]+"/g,"").replace(/isShadow="[^"]+"/g,"").replace(/symbolName="[^"]+"/g,"").replace(/jQuery[0-9]+="[^"]+"/g,"").replace(/url\([^#]+#/g,"url(#").replace(/<svg /,'<svg xmlns:xlink="http://www.w3.org/1999/xlink" ').replace(/ (NS[0-9]+\:)?href=/g,
	" xlink:href=").replace(/\n/," ").replace(/<\/svg>.*?$/,"</svg>").replace(/(fill|stroke)="rgba\(([ 0-9]+,[ 0-9]+,[ 0-9]+),([ 0-9\.]+)\)"/g,'$1="rgb($2)" $1-opacity="$3"').replace(/&nbsp;/g,"\u00a0").replace(/&shy;/g,"\u00ad").replace(/<IMG /g,"<image ").replace(/<(\/?)TITLE>/g,"<$1title>").replace(/height=([^" ]+)/g,'height="$1"').replace(/width=([^" ]+)/g,'width="$1"').replace(/hc-svg-href="([^"]+)">/g,'xlink:href="$1"/>').replace(/ id=([^" >]+)/g,' id="$1"').replace(/class=([^" >]+)/g,'class="$1"').replace(/ transform /g,
	" ").replace(/:(path|rect)/g,"$1").replace(/style="([^"]+)"/g,function(b){return b.toLowerCase()})},getChartHTML:function(){return this.container.innerHTML},getSVG:function(a){var b=this,e,c,g,j,k,d=l(b.options,a),J=d.exporting.allowHTML;if(!m.createElementNS)m.createElementNS=function(b,a){return m.createElement(a)};c=n("div",null,{position:"absolute",top:"-9999em",width:b.chartWidth+"px",height:b.chartHeight+"px"},m.body);g=b.renderTo.style.width;k=b.renderTo.style.height;g=d.exporting.sourceWidth||
	d.chart.width||/px$/.test(g)&&parseInt(g,10)||600;k=d.exporting.sourceHeight||d.chart.height||/px$/.test(k)&&parseInt(k,10)||400;q(d.chart,{animation:!1,renderTo:c,forExport:!0,renderer:"SVGRenderer",width:g,height:k});d.exporting.enabled=!1;delete d.data;d.series=[];i(b.series,function(a){j=l(a.userOptions,{animation:!1,enableMouseTracking:!1,showCheckbox:!1,visible:a.visible});j.isInternal||d.series.push(j)});a&&i(["xAxis","yAxis"],function(b){i(F(a[b]),function(a,c){d[b][c]=l(d[b][c],a)})});e=
	new f.Chart(d,b.callback);i(["xAxis","yAxis"],function(a){i(b[a],function(b,c){var d=e[a][c],f=b.getExtremes(),g=f.userMin,f=f.userMax;d&&(g!==void 0||f!==void 0)&&d.setExtremes(g,f,!0,!1)})});g=e.getChartHTML();d=null;e.destroy();s(c);if(J&&(c=g.match(/<\/svg>(.*?$)/)))c='<foreignObject x="0" y="0" width="200" height="200"><body xmlns="http://www.w3.org/1999/xhtml">'+c[1]+"</body></foreignObject>",g=g.replace("</svg>",c+"</svg>");g=this.sanitizeSVG(g);return g=g.replace(/(url\(#highcharts-[0-9]+)&quot;/g,
	"$1").replace(/&quot;/g,"'")},getSVGForExport:function(a,b){var e=this.options.exporting;return this.getSVG(l({chart:{borderRadius:0}},e.chartOptions,b,{exporting:{sourceWidth:a&&a.sourceWidth||e.sourceWidth,sourceHeight:a&&a.sourceHeight||e.sourceHeight}}))},exportChart:function(a,b){var e=this.getSVGForExport(a,b),a=l(this.options.exporting,a);f.post(a.url,{filename:a.filename||"chart",type:a.type,width:a.width||0,scale:a.scale||2,svg:e},a.formAttributes)},print:function(){var a=this,b=a.container,
	e=[],c=b.parentNode,f=m.body,j=f.childNodes;if(!a.isPrinting)a.isPrinting=!0,a.pointer.reset(null,0),C(a,"beforePrint"),i(j,function(a,b){if(a.nodeType===1)e[b]=a.style.display,a.style.display="none"}),f.appendChild(b),r.focus(),r.print(),setTimeout(function(){c.appendChild(b);i(j,function(a,b){if(a.nodeType===1)a.style.display=e[b]});a.isPrinting=!1;C(a,"afterPrint")},1E3)},contextMenu:function(a,b,e,c,f,j,k){var d=this,l=d.options.navigation,D=l.menuItemStyle,o=d.chartWidth,p=d.chartHeight,E="cache-"+
	a,h=d[E],u=G(f,j),w,x,r,s=function(b){d.pointer.inClass(b.target,a)||x()};if(!h)d[E]=h=n("div",{className:a},{position:"absolute",zIndex:1E3,padding:u+"px"},d.container),w=n("div",null,q({MozBoxShadow:"3px 3px 10px #888",WebkitBoxShadow:"3px 3px 10px #888",boxShadow:"3px 3px 10px #888"},l.menuStyle),h),x=function(){v(h,{display:"none"});k&&k.setState(0);d.openMenu=!1},t(h,"mouseleave",function(){r=setTimeout(x,500)}),t(h,"mouseenter",function(){clearTimeout(r)}),t(m,"mouseup",s),t(d,"destroy",function(){B(m,
	"mouseup",s)}),i(b,function(a){if(a){var b=a.separator?n("hr",null,null,w):n("div",{onmouseover:function(){v(this,l.menuItemHoverStyle)},onmouseout:function(){v(this,D)},onclick:function(b){b&&b.stopPropagation();x();a.onclick&&a.onclick.apply(d,arguments)},innerHTML:a.text||d.options.lang[a.textKey]},q({cursor:"pointer"},D),w);d.exportDivElements.push(b)}}),d.exportDivElements.push(w,h),d.exportMenuWidth=h.offsetWidth,d.exportMenuHeight=h.offsetHeight;b={display:"block"};e+d.exportMenuWidth>o?b.right=
	o-e-f-u+"px":b.left=e-u+"px";c+j+d.exportMenuHeight>p&&k.alignOptions.verticalAlign!=="top"?b.bottom=p-c-u+"px":b.top=c+j-u+"px";v(h,b);d.openMenu=!0},addButton:function(a){var b=this,e=b.renderer,c=l(b.options.navigation.buttonOptions,a),g=c.onclick,j=c.menuItems,k,d,m={stroke:c.symbolStroke,fill:c.symbolFill},i=c.symbolSize||12;if(!b.btnCount)b.btnCount=0;if(!b.exportDivElements)b.exportDivElements=[],b.exportSVGElements=[];if(c.enabled!==!1){var o=c.theme,p=o.states,n=p&&p.hover,p=p&&p.select,
	h;delete o.states;g?h=function(a){a.stopPropagation();g.call(b,a)}:j&&(h=function(){b.contextMenu(d.menuClassName,j,d.translateX,d.translateY,d.width,d.height,d);d.setState(2)});c.text&&c.symbol?o.paddingLeft=f.pick(o.paddingLeft,25):c.text||q(o,{width:c.width,height:c.height,padding:0});d=e.button(c.text,0,0,h,o,n,p).attr({title:b.options.lang[c._titleKey],"stroke-linecap":"round",zIndex:3});d.menuClassName=a.menuClassName||"highcharts-menu-"+b.btnCount++;c.symbol&&(k=e.symbol(c.symbol,c.symbolX-
	i/2,c.symbolY-i/2,i,i).attr(q(m,{"stroke-width":c.symbolStrokeWidth||1,zIndex:1})).add(d));d.add().align(q(c,{width:d.width,x:f.pick(c.x,z)}),!0,"spacingBox");z+=(d.width+c.buttonSpacing)*(c.align==="right"?-1:1);b.exportSVGElements.push(d,k)}},destroyExport:function(a){var a=a.target,b,e;for(b=0;b<a.exportSVGElements.length;b++)if(e=a.exportSVGElements[b])e.onclick=e.ontouchstart=null,a.exportSVGElements[b]=e.destroy();for(b=0;b<a.exportDivElements.length;b++)e=a.exportDivElements[b],B(e,"mouseleave"),
	a.exportDivElements[b]=e.onmouseout=e.onmouseover=e.ontouchstart=e.onclick=null,s(e)}});I.menu=function(a,b,e,c){return["M",a,b+2.5,"L",a+e,b+2.5,"M",a,b+c/2+0.5,"L",a+e,b+c/2+0.5,"M",a,b+c-1.5,"L",a+e,b+c-1.5]};A.prototype.callbacks.push(function(a){var b,e=a.options.exporting,c=e.buttons;z=0;if(e.enabled!==!1){for(b in c)a.addButton(c[b]);t(a,"destroy",a.destroyExport)}})});


/***/ },
/* 231 */
/***/ function(module, exports) {

	/*
	 Highcharts JS v4.2.3 (2016-02-08)
	
	 (c) 2009-2016 Torstein Honsi
	
	 License: www.highcharts.com/license
	*/
	(function(m){typeof module==="object"&&module.exports?module.exports=m:m(Highcharts)})(function(m){function J(a,b,c){this.init(a,b,c)}var O=m.arrayMin,P=m.arrayMax,s=m.each,F=m.extend,t=m.merge,Q=m.map,q=m.pick,A=m.pInt,o=m.getOptions().plotOptions,k=m.seriesTypes,u=m.extendClass,K=m.splat,v=m.wrap,L=m.Axis,y=m.Tick,G=m.Point,R=m.Pointer,S=m.CenteredSeriesMixin,B=m.TrackerMixin,w=m.Series,x=Math,E=x.round,C=x.floor,M=x.max,T=m.Color,r=function(){};F(J.prototype,{init:function(a,b,c){var d=this,g=
	d.defaultOptions;d.chart=b;d.options=a=t(g,b.angular?{background:{}}:void 0,a);(a=a.background)&&s([].concat(K(a)).reverse(),function(a){var g=a.backgroundColor,b=c.userOptions,a=t(d.defaultBackgroundOptions,a);if(g)a.backgroundColor=g;a.color=a.backgroundColor;c.options.plotBands.unshift(a);b.plotBands=b.plotBands||[];b.plotBands!==c.options.plotBands&&b.plotBands.unshift(a)})},defaultOptions:{center:["50%","50%"],size:"85%",startAngle:0},defaultBackgroundOptions:{shape:"circle",borderWidth:1,borderColor:"silver",
	backgroundColor:{linearGradient:{x1:0,y1:0,x2:0,y2:1},stops:[[0,"#FFF"],[1,"#DDD"]]},from:-Number.MAX_VALUE,innerRadius:0,to:Number.MAX_VALUE,outerRadius:"105%"}});var z=L.prototype,y=y.prototype,U={getOffset:r,redraw:function(){this.isDirty=!1},render:function(){this.isDirty=!1},setScale:r,setCategories:r,setTitle:r},N={isRadial:!0,defaultRadialGaugeOptions:{labels:{align:"center",x:0,y:null},minorGridLineWidth:0,minorTickInterval:"auto",minorTickLength:10,minorTickPosition:"inside",minorTickWidth:1,
	tickLength:10,tickPosition:"inside",tickWidth:2,title:{rotation:0},zIndex:2},defaultRadialXOptions:{gridLineWidth:1,labels:{align:null,distance:15,x:0,y:null},maxPadding:0,minPadding:0,showLastLabel:!1,tickLength:0},defaultRadialYOptions:{gridLineInterpolation:"circle",labels:{align:"right",x:-3,y:-2},showLastLabel:!1,title:{x:4,text:null,rotation:90}},setOptions:function(a){a=this.options=t(this.defaultOptions,this.defaultRadialOptions,a);if(!a.plotBands)a.plotBands=[]},getOffset:function(){z.getOffset.call(this);
	this.chart.axisOffset[this.side]=0;this.center=this.pane.center=S.getCenter.call(this.pane)},getLinePath:function(a,b){var c=this.center,b=q(b,c[2]/2-this.offset);return this.chart.renderer.symbols.arc(this.left+c[0],this.top+c[1],b,b,{start:this.startAngleRad,end:this.endAngleRad,open:!0,innerR:0})},setAxisTranslation:function(){z.setAxisTranslation.call(this);if(this.center)this.transA=this.isCircular?(this.endAngleRad-this.startAngleRad)/(this.max-this.min||1):this.center[2]/2/(this.max-this.min||
	1),this.minPixelPadding=this.isXAxis?this.transA*this.minPointOffset:0},beforeSetTickPositions:function(){this.autoConnect&&(this.max+=this.categories&&1||this.pointRange||this.closestPointRange||0)},setAxisSize:function(){z.setAxisSize.call(this);if(this.isRadial){this.center=this.pane.center=m.CenteredSeriesMixin.getCenter.call(this.pane);if(this.isCircular)this.sector=this.endAngleRad-this.startAngleRad;this.len=this.width=this.height=this.center[2]*q(this.sector,1)/2}},getPosition:function(a,
	b){return this.postTranslate(this.isCircular?this.translate(a):0,q(this.isCircular?b:this.translate(a),this.center[2]/2)-this.offset)},postTranslate:function(a,b){var c=this.chart,d=this.center,a=this.startAngleRad+a;return{x:c.plotLeft+d[0]+Math.cos(a)*b,y:c.plotTop+d[1]+Math.sin(a)*b}},getPlotBandPath:function(a,b,c){var d=this.center,g=this.startAngleRad,e=d[2]/2,j=[q(c.outerRadius,"100%"),c.innerRadius,q(c.thickness,10)],l=/%$/,i,f=this.isCircular;this.options.gridLineInterpolation==="polygon"?
	d=this.getPlotLinePath(a).concat(this.getPlotLinePath(b,!0)):(a=Math.max(a,this.min),b=Math.min(b,this.max),f||(j[0]=this.translate(a),j[1]=this.translate(b)),j=Q(j,function(a){l.test(a)&&(a=A(a,10)*e/100);return a}),c.shape==="circle"||!f?(a=-Math.PI/2,b=Math.PI*1.5,i=!0):(a=g+this.translate(a),b=g+this.translate(b)),d=this.chart.renderer.symbols.arc(this.left+d[0],this.top+d[1],j[0],j[0],{start:Math.min(a,b),end:Math.max(a,b),innerR:q(j[1],j[0]-j[2]),open:i}));return d},getPlotLinePath:function(a,
	b){var c=this,d=c.center,g=c.chart,e=c.getPosition(a),j,l,i;c.isCircular?i=["M",d[0]+g.plotLeft,d[1]+g.plotTop,"L",e.x,e.y]:c.options.gridLineInterpolation==="circle"?(a=c.translate(a))&&(i=c.getLinePath(0,a)):(s(g.xAxis,function(a){a.pane===c.pane&&(j=a)}),i=[],a=c.translate(a),d=j.tickPositions,j.autoConnect&&(d=d.concat([d[0]])),b&&(d=[].concat(d).reverse()),s(d,function(e,b){l=j.getPosition(e,a);i.push(b?"L":"M",l.x,l.y)}));return i},getTitlePosition:function(){var a=this.center,b=this.chart,
	c=this.options.title;return{x:b.plotLeft+a[0]+(c.x||0),y:b.plotTop+a[1]-{high:0.5,middle:0.25,low:0}[c.align]*a[2]+(c.y||0)}}};v(z,"init",function(a,b,c){var h;var d=b.angular,g=b.polar,e=c.isX,j=d&&e,l,i;i=b.options;var f=c.pane||0;if(d){if(F(this,j?U:N),l=!e)this.defaultRadialOptions=this.defaultRadialGaugeOptions}else if(g)F(this,N),this.defaultRadialOptions=(l=e)?this.defaultRadialXOptions:t(this.defaultYAxisOptions,this.defaultRadialYOptions);a.call(this,b,c);if(!j&&(d||g)){a=this.options;if(!b.panes)b.panes=
	[];this.pane=(h=b.panes[f]=b.panes[f]||new J(K(i.pane)[f],b,this),f=h);f=f.options;b.inverted=!1;i.chart.zoomType=null;this.startAngleRad=b=(f.startAngle-90)*Math.PI/180;this.endAngleRad=i=(q(f.endAngle,f.startAngle+360)-90)*Math.PI/180;this.offset=a.offset||0;if((this.isCircular=l)&&c.max===void 0&&i-b===2*Math.PI)this.autoConnect=!0}});v(z,"autoLabelAlign",function(a){if(!this.isRadial)return a.apply(this,[].slice.call(arguments,1))});v(y,"getPosition",function(a,b,c,d,g){var e=this.axis;return e.getPosition?
	e.getPosition(c):a.call(this,b,c,d,g)});v(y,"getLabelPosition",function(a,b,c,d,g,e,j,l,i){var f=this.axis,h=e.y,n=20,k=e.align,m=(f.translate(this.pos)+f.startAngleRad+Math.PI/2)/Math.PI*180%360;f.isRadial?(a=f.getPosition(this.pos,f.center[2]/2+q(e.distance,-25)),e.rotation==="auto"?d.attr({rotation:m}):h===null&&(h=f.chart.renderer.fontMetrics(d.styles.fontSize).b-d.getBBox().height/2),k===null&&(f.isCircular?(this.label.getBBox().width>f.len*f.tickInterval/(f.max-f.min)&&(n=0),k=m>n&&m<180-n?
	"left":m>180+n&&m<360-n?"right":"center"):k="center",d.attr({align:k})),a.x+=e.x,a.y+=h):a=a.call(this,b,c,d,g,e,j,l,i);return a});v(y,"getMarkPath",function(a,b,c,d,g,e,j){var l=this.axis;l.isRadial?(a=l.getPosition(this.pos,l.center[2]/2+d),b=["M",b,c,"L",a.x,a.y]):b=a.call(this,b,c,d,g,e,j);return b});o.arearange=t(o.area,{lineWidth:1,marker:null,threshold:null,tooltip:{pointFormat:'<span style="color:{series.color}">\u25cf</span> {series.name}: <b>{point.low}</b> - <b>{point.high}</b><br/>'},
	trackByArea:!0,dataLabels:{align:null,verticalAlign:null,xLow:0,xHigh:0,yLow:0,yHigh:0},states:{hover:{halo:!1}}});k.arearange=u(k.area,{type:"arearange",pointArrayMap:["low","high"],dataLabelCollections:["dataLabel","dataLabelUpper"],toYData:function(a){return[a.low,a.high]},pointValKey:"low",deferTranslatePolar:!0,highToXY:function(a){var b=this.chart,c=this.xAxis.postTranslate(a.rectPlotX,this.yAxis.len-a.plotHigh);a.plotHighX=c.x-b.plotLeft;a.plotHigh=c.y-b.plotTop},translate:function(){var a=
	this,b=a.yAxis;k.area.prototype.translate.apply(a);s(a.points,function(a){var d=a.low,g=a.high,e=a.plotY;g===null||d===null?a.isNull=!0:(a.plotLow=e,a.plotHigh=b.translate(g,0,1,0,1))});this.chart.polar&&s(this.points,function(b){a.highToXY(b)})},getGraphPath:function(){var a=this.points,b=[],c=[],d=a.length,g=w.prototype.getGraphPath,e,j,l;l=this.options;for(var i=l.step,d=a.length;d--;)e=a[d],!e.isNull&&(!a[d+1]||a[d+1].isNull)&&c.push({plotX:e.plotX,plotY:e.plotLow}),j={plotX:e.plotX,plotY:e.plotHigh,
	isNull:e.isNull},c.push(j),b.push(j),!e.isNull&&(!a[d-1]||a[d-1].isNull)&&c.push({plotX:e.plotX,plotY:e.plotLow});a=g.call(this,a);if(i)i===!0&&(i="left"),l.step={left:"right",center:"center",right:"left"}[i];b=g.call(this,b);c=g.call(this,c);l.step=i;l=[].concat(a,b);!this.chart.polar&&c[0]==="M"&&(c[0]="L");this.areaPath=this.areaPath.concat(a,c);return l},drawDataLabels:function(){var a=this.data,b=a.length,c,d=[],g=w.prototype,e=this.options.dataLabels,j=e.align,l=e.verticalAlign,i=e.inside,f,
	h,n=this.chart.inverted;if(e.enabled||this._hasPointLabels){for(c=b;c--;)if(f=a[c]){h=i?f.plotHigh<f.plotLow:f.plotHigh>f.plotLow;f.y=f.high;f._plotY=f.plotY;f.plotY=f.plotHigh;d[c]=f.dataLabel;f.dataLabel=f.dataLabelUpper;f.below=h;if(n){if(!j)e.align=h?"right":"left"}else if(!l)e.verticalAlign=h?"top":"bottom";e.x=e.xHigh;e.y=e.yHigh}g.drawDataLabels&&g.drawDataLabels.apply(this,arguments);for(c=b;c--;)if(f=a[c]){h=i?f.plotHigh<f.plotLow:f.plotHigh>f.plotLow;f.dataLabelUpper=f.dataLabel;f.dataLabel=
	d[c];f.y=f.low;f.plotY=f._plotY;f.below=!h;if(n){if(!j)e.align=h?"left":"right"}else if(!l)e.verticalAlign=h?"bottom":"top";e.x=e.xLow;e.y=e.yLow}g.drawDataLabels&&g.drawDataLabels.apply(this,arguments)}e.align=j;e.verticalAlign=l},alignDataLabel:function(){k.column.prototype.alignDataLabel.apply(this,arguments)},setStackedPoints:r,getSymbol:r,drawPoints:r});o.areasplinerange=t(o.arearange);k.areasplinerange=u(k.arearange,{type:"areasplinerange",getPointSpline:k.spline.prototype.getPointSpline});
	(function(){var a=k.column.prototype;o.columnrange=t(o.column,o.arearange,{lineWidth:1,pointRange:null});k.columnrange=u(k.arearange,{type:"columnrange",translate:function(){var b=this,c=b.yAxis,d=b.xAxis,g=b.chart,e;a.translate.apply(b);s(b.points,function(a){var l=a.shapeArgs,i=b.options.minPointLength,f,h;a.plotHigh=e=c.translate(a.high,0,1,0,1);a.plotLow=a.plotY;h=e;f=a.plotY-e;Math.abs(f)<i?(i-=f,f+=i,h-=i/2):f<0&&(f*=-1,h-=f);l.height=f;l.y=h;a.tooltipPos=g.inverted?[c.len+c.pos-g.plotLeft-
	h-f/2,d.len+d.pos-g.plotTop-l.x-l.width/2,f]:[d.left-g.plotLeft+l.x+l.width/2,c.pos-g.plotTop+h+f/2,f]})},directTouch:!0,trackerGroups:["group","dataLabelsGroup"],drawGraph:r,crispCol:a.crispCol,pointAttrToOptions:a.pointAttrToOptions,drawPoints:a.drawPoints,drawTracker:a.drawTracker,animate:a.animate,getColumnMetrics:a.getColumnMetrics})})();o.gauge=t(o.line,{dataLabels:{enabled:!0,defer:!1,y:15,borderWidth:1,borderColor:"silver",borderRadius:3,crop:!1,verticalAlign:"top",zIndex:2},dial:{},pivot:{},
	tooltip:{headerFormat:""},showInLegend:!1});B={type:"gauge",pointClass:u(G,{setState:function(a){this.state=a}}),angular:!0,drawGraph:r,fixedBox:!0,forceDL:!0,trackerGroups:["group","dataLabelsGroup"],translate:function(){var a=this.yAxis,b=this.options,c=a.center;this.generatePoints();s(this.points,function(d){var g=t(b.dial,d.dial),e=A(q(g.radius,80))*c[2]/200,j=A(q(g.baseLength,70))*e/100,l=A(q(g.rearLength,10))*e/100,i=g.baseWidth||3,f=g.topWidth||1,h=b.overshoot,n=a.startAngleRad+a.translate(d.y,
	null,null,null,!0);h&&typeof h==="number"?(h=h/180*Math.PI,n=Math.max(a.startAngleRad-h,Math.min(a.endAngleRad+h,n))):b.wrap===!1&&(n=Math.max(a.startAngleRad,Math.min(a.endAngleRad,n)));n=n*180/Math.PI;d.shapeType="path";d.shapeArgs={d:g.path||["M",-l,-i/2,"L",j,-i/2,e,-f/2,e,f/2,j,i/2,-l,i/2,"z"],translateX:c[0],translateY:c[1],rotation:n};d.plotX=c[0];d.plotY=c[1]})},drawPoints:function(){var a=this,b=a.yAxis.center,c=a.pivot,d=a.options,g=d.pivot,e=a.chart.renderer;s(a.points,function(b){var g=
	b.graphic,c=b.shapeArgs,f=c.d,h=t(d.dial,b.dial);g?(g.animate(c),c.d=f):b.graphic=e[b.shapeType](c).attr({stroke:h.borderColor||"none","stroke-width":h.borderWidth||0,fill:h.backgroundColor||"black",rotation:c.rotation,zIndex:1}).add(a.group)});c?c.animate({translateX:b[0],translateY:b[1]}):a.pivot=e.circle(0,0,q(g.radius,5)).attr({"stroke-width":g.borderWidth||0,stroke:g.borderColor||"silver",fill:g.backgroundColor||"black",zIndex:2}).translate(b[0],b[1]).add(a.group)},animate:function(a){var b=
	this;if(!a)s(b.points,function(a){var d=a.graphic;d&&(d.attr({rotation:b.yAxis.startAngleRad*180/Math.PI}),d.animate({rotation:a.shapeArgs.rotation},b.options.animation))}),b.animate=null},render:function(){this.group=this.plotGroup("group","series",this.visible?"visible":"hidden",this.options.zIndex,this.chart.seriesGroup);w.prototype.render.call(this);this.group.clip(this.chart.clipRect)},setData:function(a,b){w.prototype.setData.call(this,a,!1);this.processData();this.generatePoints();q(b,!0)&&
	this.chart.redraw()},drawTracker:B&&B.drawTrackerPoint};k.gauge=u(k.line,B);o.boxplot=t(o.column,{fillColor:"#FFFFFF",lineWidth:1,medianWidth:2,states:{hover:{brightness:-0.3}},threshold:null,tooltip:{pointFormat:'<span style="color:{point.color}">\u25cf</span> <b> {series.name}</b><br/>Maximum: {point.high}<br/>Upper quartile: {point.q3}<br/>Median: {point.median}<br/>Lower quartile: {point.q1}<br/>Minimum: {point.low}<br/>'},whiskerLength:"50%",whiskerWidth:2});k.boxplot=u(k.column,{type:"boxplot",
	pointArrayMap:["low","q1","median","q3","high"],toYData:function(a){return[a.low,a.q1,a.median,a.q3,a.high]},pointValKey:"high",pointAttrToOptions:{fill:"fillColor",stroke:"color","stroke-width":"lineWidth"},drawDataLabels:r,translate:function(){var a=this.yAxis,b=this.pointArrayMap;k.column.prototype.translate.apply(this);s(this.points,function(c){s(b,function(b){c[b]!==null&&(c[b+"Plot"]=a.translate(c[b],0,1,0,1))})})},drawPoints:function(){var a=this,b=a.options,c=a.chart.renderer,d,g,e,j,l,i,
	f,h,n,k,m,H,I,o,t,r,v,u,w,x,B,A,y=a.doQuartiles!==!1,z,D=a.options.whiskerLength;s(a.points,function(p){n=p.graphic;B=p.shapeArgs;m={};o={};r={};A=p.color||a.color;if(p.plotY!==void 0)if(d=p.pointAttr[p.selected?"selected":""],v=B.width,u=C(B.x),w=u+v,x=E(v/2),g=C(y?p.q1Plot:p.lowPlot),e=C(y?p.q3Plot:p.lowPlot),j=C(p.highPlot),l=C(p.lowPlot),m.stroke=p.stemColor||b.stemColor||A,m["stroke-width"]=q(p.stemWidth,b.stemWidth,b.lineWidth),m.dashstyle=p.stemDashStyle||b.stemDashStyle,o.stroke=p.whiskerColor||
	b.whiskerColor||A,o["stroke-width"]=q(p.whiskerWidth,b.whiskerWidth,b.lineWidth),r.stroke=p.medianColor||b.medianColor||A,r["stroke-width"]=q(p.medianWidth,b.medianWidth,b.lineWidth),f=m["stroke-width"]%2/2,h=u+x+f,k=["M",h,e,"L",h,j,"M",h,g,"L",h,l],y&&(f=d["stroke-width"]%2/2,h=C(h)+f,g=C(g)+f,e=C(e)+f,u+=f,w+=f,H=["M",u,e,"L",u,g,"L",w,g,"L",w,e,"L",u,e,"z"]),D&&(f=o["stroke-width"]%2/2,j+=f,l+=f,z=/%$/.test(D)?x*parseFloat(D)/100:D/2,I=["M",h-z,j,"L",h+z,j,"M",h-z,l,"L",h+z,l]),f=r["stroke-width"]%
	2/2,i=E(p.medianPlot)+f,t=["M",u,i,"L",w,i],n)p.stem.animate({d:k}),D&&p.whiskers.animate({d:I}),y&&p.box.animate({d:H}),p.medianShape.animate({d:t});else{p.graphic=n=c.g().add(a.group);p.stem=c.path(k).attr(m).add(n);if(D)p.whiskers=c.path(I).attr(o).add(n);if(y)p.box=c.path(H).attr(d).add(n);p.medianShape=c.path(t).attr(r).add(n)}})},setStackedPoints:r});o.errorbar=t(o.boxplot,{color:"#000000",grouping:!1,linkedTo:":previous",tooltip:{pointFormat:'<span style="color:{point.color}">\u25cf</span> {series.name}: <b>{point.low}</b> - <b>{point.high}</b><br/>'},
	whiskerWidth:null});k.errorbar=u(k.boxplot,{type:"errorbar",pointArrayMap:["low","high"],toYData:function(a){return[a.low,a.high]},pointValKey:"high",doQuartiles:!1,drawDataLabels:k.arearange?k.arearange.prototype.drawDataLabels:r,getColumnMetrics:function(){return this.linkedParent&&this.linkedParent.columnMetrics||k.column.prototype.getColumnMetrics.call(this)}});o.waterfall=t(o.column,{lineWidth:1,lineColor:"#333",dashStyle:"dot",borderColor:"#333",dataLabels:{inside:!0},states:{hover:{lineWidthPlus:0}}});
	k.waterfall=u(k.column,{type:"waterfall",upColorProp:"fill",pointValKey:"y",translate:function(){var a=this.options,b=this.yAxis,c,d,g,e,j,l,i,f,h,n=q(a.minPointLength,5),m=a.threshold,o=a.stacking;k.column.prototype.translate.apply(this);this.minPointLengthOffset=0;i=f=m;d=this.points;for(c=0,a=d.length;c<a;c++){g=d[c];l=this.processedYData[c];e=g.shapeArgs;h=(j=o&&b.stacks[(this.negStacks&&l<m?"-":"")+this.stackKey])?j[g.x].points[this.index+","+c]:[0,l];if(g.isSum)g.y=l;else if(g.isIntermediateSum)g.y=
	l-f;j=M(i,i+g.y)+h[0];e.y=b.translate(j,0,1);if(g.isSum)e.y=b.translate(h[1],0,1),e.height=Math.min(b.translate(h[0],0,1),b.len)-e.y+this.minPointLengthOffset;else if(g.isIntermediateSum)e.y=b.translate(h[1],0,1),e.height=Math.min(b.translate(f,0,1),b.len)-e.y+this.minPointLengthOffset,f=h[1];else{if(i!==0)e.height=l>0?b.translate(i,0,1)-e.y:b.translate(i,0,1)-b.translate(i-l,0,1);i+=l}e.height<0&&(e.y+=e.height,e.height*=-1);g.plotY=e.y=E(e.y)-this.borderWidth%2/2;e.height=M(E(e.height),0.001);g.yBottom=
	e.y+e.height;if(e.height<=n)e.height=n,this.minPointLengthOffset+=n;e.y-=this.minPointLengthOffset;e=g.plotY+(g.negative?e.height:0)-this.minPointLengthOffset;this.chart.inverted?g.tooltipPos[0]=b.len-e:g.tooltipPos[1]=e}},processData:function(a){var b=this.yData,c=this.options.data,d,g=b.length,e,j,l,i,f,h;j=e=l=i=this.options.threshold||0;for(h=0;h<g;h++)f=b[h],d=c&&c[h]?c[h]:{},f==="sum"||d.isSum?b[h]=j:f==="intermediateSum"||d.isIntermediateSum?b[h]=e:(j+=f,e+=f),l=Math.min(j,l),i=Math.max(j,
	i);w.prototype.processData.call(this,a);this.dataMin=l;this.dataMax=i},toYData:function(a){return a.isSum?a.x===0?null:"sum":a.isIntermediateSum?a.x===0?null:"intermediateSum":a.y},getAttribs:function(){k.column.prototype.getAttribs.apply(this,arguments);var a=this,b=a.options,c=b.states,d=b.upColor||a.color,b=m.Color(d).brighten(0.1).get(),g=t(a.pointAttr),e=a.upColorProp;g[""][e]=d;g.hover[e]=c.hover.upColor||b;g.select[e]=c.select.upColor||d;s(a.points,function(e){if(!e.options.color)e.y>0?(e.pointAttr=
	g,e.color=d):e.pointAttr=a.pointAttr})},getGraphPath:function(){var a=this.data,b=a.length,c=E(this.options.lineWidth+this.borderWidth)%2/2,d=[],g,e,j;for(j=1;j<b;j++)e=a[j].shapeArgs,g=a[j-1].shapeArgs,e=["M",g.x+g.width,g.y+c,"L",e.x,g.y+c],a[j-1].y<0&&(e[2]+=g.height,e[5]+=g.height),d=d.concat(e);return d},getExtremes:r,drawGraph:w.prototype.drawGraph});o.polygon=t(o.scatter,{marker:{enabled:!1}});k.polygon=u(k.scatter,{type:"polygon",fillGraph:!0,getSegmentPath:function(a){return w.prototype.getSegmentPath.call(this,
	a).concat("z")},drawGraph:w.prototype.drawGraph,drawLegendSymbol:m.LegendSymbolMixin.drawRectangle});o.bubble=t(o.scatter,{dataLabels:{formatter:function(){return this.point.z},inside:!0,verticalAlign:"middle"},marker:{lineColor:null,lineWidth:1},minSize:8,maxSize:"20%",softThreshold:!1,states:{hover:{halo:{size:5}}},tooltip:{pointFormat:"({point.x}, {point.y}), Size: {point.z}"},turboThreshold:0,zThreshold:0,zoneAxis:"z"});B=u(G,{haloPath:function(){return G.prototype.haloPath.call(this,this.shapeArgs.r+
	this.series.options.states.hover.halo.size)},ttBelow:!1});k.bubble=u(k.scatter,{type:"bubble",pointClass:B,pointArrayMap:["y","z"],parallelArrays:["x","y","z"],trackerGroups:["group","dataLabelsGroup"],bubblePadding:!0,zoneAxis:"z",pointAttrToOptions:{stroke:"lineColor","stroke-width":"lineWidth",fill:"fillColor"},applyOpacity:function(a){var b=this.options.marker,c=q(b.fillOpacity,0.5),a=a||b.fillColor||this.color;c!==1&&(a=T(a).setOpacity(c).get("rgba"));return a},convertAttribs:function(){var a=
	w.prototype.convertAttribs.apply(this,arguments);a.fill=this.applyOpacity(a.fill);return a},getRadii:function(a,b,c,d){var g,e,j,l=this.zData,i=[],f=this.options,h=f.sizeBy!=="width",n=f.zThreshold,k=b-a;for(e=0,g=l.length;e<g;e++)j=l[e],f.sizeByAbsoluteValue&&j!==null&&(j=Math.abs(j-n),b=Math.max(b-n,Math.abs(a-n)),a=0),j===null?j=null:j<a?j=c/2-1:(j=k>0?(j-a)/k:0.5,h&&j>=0&&(j=Math.sqrt(j)),j=x.ceil(c+j*(d-c))/2),i.push(j);this.radii=i},animate:function(a){var b=this.options.animation;if(!a)s(this.points,
	function(a){var d=a.graphic,a=a.shapeArgs;d&&a&&(d.attr("r",1),d.animate({r:a.r},b))}),this.animate=null},translate:function(){var a,b=this.data,c,d,g=this.radii;k.scatter.prototype.translate.call(this);for(a=b.length;a--;)c=b[a],d=g?g[a]:0,typeof d==="number"&&d>=this.minPxSize/2?(c.shapeType="circle",c.shapeArgs={x:c.plotX,y:c.plotY,r:d},c.dlBox={x:c.plotX-d,y:c.plotY-d,width:2*d,height:2*d}):c.shapeArgs=c.plotY=c.dlBox=void 0},drawLegendSymbol:function(a,b){var c=this.chart.renderer,d=c.fontMetrics(a.itemStyle.fontSize).f/
	2;b.legendSymbol=c.circle(d,a.baseline-d,d).attr({zIndex:3}).add(b.legendGroup);b.legendSymbol.isMarker=!0},drawPoints:k.column.prototype.drawPoints,alignDataLabel:k.column.prototype.alignDataLabel,buildKDTree:r,applyZones:r});L.prototype.beforePadding=function(){var a=this,b=this.len,c=this.chart,d=0,g=b,e=this.isXAxis,j=e?"xData":"yData",l=this.min,i={},f=x.min(c.plotWidth,c.plotHeight),h=Number.MAX_VALUE,n=-Number.MAX_VALUE,k=this.max-l,m=b/k,o=[];s(this.series,function(b){var g=b.options;if(b.bubblePadding&&
	(b.visible||!c.options.chart.ignoreHiddenSeries))if(a.allowZoomOutside=!0,o.push(b),e)s(["minSize","maxSize"],function(a){var b=g[a],e=/%$/.test(b),b=A(b);i[a]=e?f*b/100:b}),b.minPxSize=i.minSize,b.maxPxSize=i.maxSize,b=b.zData,b.length&&(h=q(g.zMin,x.min(h,x.max(O(b),g.displayNegative===!1?g.zThreshold:-Number.MAX_VALUE))),n=q(g.zMax,x.max(n,P(b))))});s(o,function(a){var b=a[j],c=b.length,f;e&&a.getRadii(h,n,a.minPxSize,a.maxPxSize);if(k>0)for(;c--;)typeof b[c]==="number"&&(f=a.radii[c],d=Math.min((b[c]-
	l)*m-f,d),g=Math.max((b[c]-l)*m+f,g))});o.length&&k>0&&!this.isLog&&(g-=b,m*=(b+d-g)/b,s([["min","userMin",d],["max","userMax",g]],function(b){q(a.options[b[0]],a[b[1]])===void 0&&(a[b[0]]+=b[2]/m)}))};(function(){function a(a,b){var c=this.chart,d=this.options.animation,i=this.group,f=this.markerGroup,h=this.xAxis.center,n=c.plotLeft,k=c.plotTop;if(c.polar){if(c.renderer.isSVG)d===!0&&(d={}),b?(c={translateX:h[0]+n,translateY:h[1]+k,scaleX:0.001,scaleY:0.001},i.attr(c),f&&f.attr(c)):(c={translateX:n,
	translateY:k,scaleX:1,scaleY:1},i.animate(c,d),f&&f.animate(c,d),this.animate=null)}else a.call(this,b)}var b=w.prototype,c=R.prototype,d;b.searchPointByAngle=function(a){var b=this.chart,c=this.xAxis.pane.center;return this.searchKDTree({clientX:180+Math.atan2(a.chartX-c[0]-b.plotLeft,a.chartY-c[1]-b.plotTop)*(-180/Math.PI)})};v(b,"buildKDTree",function(a){if(this.chart.polar)this.kdByAngle?this.searchPoint=this.searchPointByAngle:this.kdDimensions=2;a.apply(this)});b.toXY=function(a){var b,c=this.chart,
	d=a.plotX;b=a.plotY;a.rectPlotX=d;a.rectPlotY=b;b=this.xAxis.postTranslate(a.plotX,this.yAxis.len-b);a.plotX=a.polarPlotX=b.x-c.plotLeft;a.plotY=a.polarPlotY=b.y-c.plotTop;this.kdByAngle?(c=(d/Math.PI*180+this.xAxis.pane.options.startAngle)%360,c<0&&(c+=360),a.clientX=c):a.clientX=a.plotX};k.spline&&v(k.spline.prototype,"getPointSpline",function(a,b,c,d){var i,f,h,n,k,m,o;if(this.chart.polar){i=c.plotX;f=c.plotY;a=b[d-1];h=b[d+1];this.connectEnds&&(a||(a=b[b.length-2]),h||(h=b[1]));if(a&&h)n=a.plotX,
	k=a.plotY,b=h.plotX,m=h.plotY,n=(1.5*i+n)/2.5,k=(1.5*f+k)/2.5,h=(1.5*i+b)/2.5,o=(1.5*f+m)/2.5,b=Math.sqrt(Math.pow(n-i,2)+Math.pow(k-f,2)),m=Math.sqrt(Math.pow(h-i,2)+Math.pow(o-f,2)),n=Math.atan2(k-f,n-i),k=Math.atan2(o-f,h-i),o=Math.PI/2+(n+k)/2,Math.abs(n-o)>Math.PI/2&&(o-=Math.PI),n=i+Math.cos(o)*b,k=f+Math.sin(o)*b,h=i+Math.cos(Math.PI+o)*m,o=f+Math.sin(Math.PI+o)*m,c.rightContX=h,c.rightContY=o;d?(c=["C",a.rightContX||a.plotX,a.rightContY||a.plotY,n||i,k||f,i,f],a.rightContX=a.rightContY=null):
	c=["M",i,f]}else c=a.call(this,b,c,d);return c});v(b,"translate",function(a){var b=this.chart;a.call(this);if(b.polar&&(this.kdByAngle=b.tooltip&&b.tooltip.shared,!this.preventPostTranslate)){a=this.points;for(b=a.length;b--;)this.toXY(a[b])}});v(b,"getGraphPath",function(a,b){var c=this;if(this.chart.polar){b=b||this.points;if(this.options.connectEnds!==!1&&b[0].y!==null)this.connectEnds=!0,b.splice(b.length,0,b[0]);s(b,function(a){a.polarPlotY===void 0&&c.toXY(a)})}return a.apply(this,[].slice.call(arguments,
	1))});v(b,"animate",a);if(k.column)d=k.column.prototype,v(d,"animate",a),v(d,"translate",function(a){var b=this.xAxis,c=this.yAxis.len,d=b.center,i=b.startAngleRad,f=this.chart.renderer,h,k;this.preventPostTranslate=!0;a.call(this);if(b.isRadial){b=this.points;for(k=b.length;k--;)h=b[k],a=h.barX+i,h.shapeType="path",h.shapeArgs={d:f.symbols.arc(d[0],d[1],c-h.plotY,null,{start:a,end:a+h.pointWidth,innerR:c-q(h.yBottom,c)})},this.toXY(h),h.tooltipPos=[h.plotX,h.plotY],h.ttBelow=h.plotY>d[1]}}),v(d,
	"alignDataLabel",function(a,c,d,l,i,f){if(this.chart.polar){a=c.rectPlotX/Math.PI*180;if(l.align===null)l.align=a>20&&a<160?"left":a>200&&a<340?"right":"center";if(l.verticalAlign===null)l.verticalAlign=a<45||a>315?"bottom":a>135&&a<225?"top":"middle";b.alignDataLabel.call(this,c,d,l,i,f)}else a.call(this,c,d,l,i,f)});v(c,"getCoordinates",function(a,b){var c=this.chart,d={xAxis:[],yAxis:[]};c.polar?s(c.axes,function(a){var f=a.isXAxis,g=a.center,k=b.chartX-g[0]-c.plotLeft,g=b.chartY-g[1]-c.plotTop;
	d[f?"xAxis":"yAxis"].push({axis:a,value:a.translate(f?Math.PI-Math.atan2(k,g):Math.sqrt(Math.pow(k,2)+Math.pow(g,2)),!0)})}):d=a.call(this,b);return d})})()});


/***/ },
/* 232 */
/***/ function(module, exports) {

	/*
	 Highcharts JS v4.2.3 (2016-02-08)
	 Plugin for displaying a message when there is no data visible in chart.
	
	 (c) 2010-2016 Highsoft AS
	 Author: Oystein Moseng
	
	 License: www.highcharts.com/license
	*/
	(function(a){typeof module==="object"&&module.exports?module.exports=a:a(Highcharts)})(function(a){function h(){return!!this.points.length}function d(){this.hasData()?this.hideNoData():this.showNoData()}var e=a.seriesTypes,c=a.Chart.prototype,f=a.getOptions(),g=a.extend,i=a.each;g(f.lang,{noData:"No data to display"});f.noData={position:{x:0,y:0,align:"center",verticalAlign:"middle"},attr:{},style:{fontWeight:"bold",fontSize:"12px",color:"#60606a"}};i(["pie","gauge","waterfall","bubble"],function(b){if(e[b])e[b].prototype.hasData=
	h});a.Series.prototype.hasData=function(){return this.visible&&this.dataMax!==void 0&&this.dataMin!==void 0};c.showNoData=function(b){var a=this.options,b=b||a.lang.noData,a=a.noData;if(!this.noDataLabel)this.noDataLabel=this.renderer.label(b,0,0,null,null,null,a.useHTML,null,"no-data").attr(a.attr).css(a.style).add(),this.noDataLabel.align(g(this.noDataLabel.getBBox(),a.position),!1,"plotBox")};c.hideNoData=function(){if(this.noDataLabel)this.noDataLabel=this.noDataLabel.destroy()};c.hasData=function(){for(var a=
	this.series,c=a.length;c--;)if(a[c].hasData()&&!a[c].options.isInternal)return!0;return!1};c.callbacks.push(function(b){a.addEvent(b,"load",d);a.addEvent(b,"redraw",d)})});


/***/ },
/* 233 */
/***/ function(module, exports) {

	/*
	  Highcharts JS v4.2.3 (2016-02-08)
	 Solid angular gauge module
	
	 (c) 2010-2016 Torstein Honsi
	
	 License: www.highcharts.com/license
	*/
	(function(a){typeof module==="object"&&module.exports?module.exports=a:a(Highcharts)})(function(a){var q=a.getOptions().plotOptions,r=a.pInt,s=a.pick,k=a.each,l;q.solidgauge=a.merge(q.gauge,{colorByPoint:!0});l={initDataClasses:function(b){var e=this,i=this.chart,c,g=0,d=this.options;this.dataClasses=c=[];k(b.dataClasses,function(f,h){var p,f=a.merge(f);c.push(f);if(!f.color)d.dataClassColor==="category"?(p=i.options.colors,f.color=p[g++],g===p.length&&(g=0)):f.color=e.tweenColors(a.Color(d.minColor),
	a.Color(d.maxColor),h/(b.dataClasses.length-1))})},initStops:function(b){this.stops=b.stops||[[0,this.options.minColor],[1,this.options.maxColor]];k(this.stops,function(b){b.color=a.Color(b[1])})},toColor:function(b,e){var a,c=this.stops,g,d=this.dataClasses,f,h;if(d)for(h=d.length;h--;){if(f=d[h],g=f.from,c=f.to,(g===void 0||b>=g)&&(c===void 0||b<=c)){a=f.color;if(e)e.dataClass=h;break}}else{this.isLog&&(b=this.val2lin(b));a=1-(this.max-b)/(this.max-this.min);for(h=c.length;h--;)if(a>c[h][0])break;
	g=c[h]||c[h+1];c=c[h+1]||g;a=1-(c[0]-a)/(c[0]-g[0]||1);a=this.tweenColors(g.color,c.color,a)}return a},tweenColors:function(b,a,i){var c;!a.rgba.length||!b.rgba.length?b=a.input||"none":(b=b.rgba,a=a.rgba,c=a[3]!==1||b[3]!==1,b=(c?"rgba(":"rgb(")+Math.round(a[0]+(b[0]-a[0])*(1-i))+","+Math.round(a[1]+(b[1]-a[1])*(1-i))+","+Math.round(a[2]+(b[2]-a[2])*(1-i))+(c?","+(a[3]+(b[3]-a[3])*(1-i)):"")+")");return b}};k(["fill","stroke"],function(b){a.Fx.prototype[b+"Setter"]=function(){this.elem.attr(b,l.tweenColors(a.Color(this.start),
	a.Color(this.end),this.pos))}});a.seriesTypes.solidgauge=a.extendClass(a.seriesTypes.gauge,{type:"solidgauge",pointAttrToOptions:{},bindAxes:function(){var b;a.seriesTypes.gauge.prototype.bindAxes.call(this);b=this.yAxis;a.extend(b,l);b.options.dataClasses&&b.initDataClasses(b.options);b.initStops(b.options)},drawPoints:function(){var b=this,e=b.yAxis,i=e.center,c=b.options,g=b.chart.renderer,d=c.overshoot,f=d&&typeof d==="number"?d/180*Math.PI:0;a.each(b.points,function(a){var d=a.graphic,j=e.startAngleRad+
	e.translate(a.y,null,null,null,!0),k=r(s(a.options.radius,c.radius,100))*i[2]/200,m=r(s(a.options.innerRadius,c.innerRadius,60))*i[2]/200,n=e.toColor(a.y,a),o=Math.min(e.startAngleRad,e.endAngleRad),l=Math.max(e.startAngleRad,e.endAngleRad);n==="none"&&(n=a.color||b.color||"none");if(n!=="none")a.color=n;j=Math.max(o-f,Math.min(l+f,j));c.wrap===!1&&(j=Math.max(o,Math.min(l,j)));o=Math.min(j,e.startAngleRad);j=Math.max(j,e.startAngleRad);j-o>2*Math.PI&&(j=o+2*Math.PI);a.shapeArgs=m={x:i[0],y:i[1],
	r:k,innerR:m,start:o,end:j,fill:n};a.startR=k;if(d){if(a=m.d,d.animate(m),a)m.d=a}else d={stroke:c.borderColor||"none","stroke-width":c.borderWidth||0,fill:n,"sweep-flag":0},c.linecap!=="square"&&(d["stroke-linecap"]=d["stroke-linejoin"]="round"),a.graphic=g.arc(m).attr(d).add(b.group)})},animate:function(b){if(!b)this.startAngleRad=this.yAxis.startAngleRad,a.seriesTypes.pie.prototype.animate.call(this,b)}})});


/***/ },
/* 234 */
/***/ function(module, exports) {

	/*
	 Highcharts JS v5.0.10 (2017-03-31)
	
	 (c) 2009-2016 Torstein Honsi
	
	 License: www.highcharts.com/license
	*/
	(function(L,a){"object"===typeof module&&module.exports?module.exports=L.document?a(L):a:L.Highcharts=a(L)})("undefined"!==typeof window?window:this,function(L){L=function(){var a=window,B=a.document,A=a.navigator&&a.navigator.userAgent||"",H=B&&B.createElementNS&&!!B.createElementNS("http://www.w3.org/2000/svg","svg").createSVGRect,G=/(edge|msie|trident)/i.test(A)&&!window.opera,r=!H,f=/Firefox/.test(A),l=f&&4>parseInt(A.split("Firefox/")[1],10);return a.Highcharts?a.Highcharts.error(16,!0):{product:"Highcharts",
	version:"5.0.10",deg2rad:2*Math.PI/360,doc:B,hasBidiBug:l,hasTouch:B&&void 0!==B.documentElement.ontouchstart,isMS:G,isWebKit:/AppleWebKit/.test(A),isFirefox:f,isTouchDevice:/(Mobile|Android|Windows Phone)/.test(A),SVG_NS:"http://www.w3.org/2000/svg",chartCount:0,seriesTypes:{},symbolSizes:{},svg:H,vml:r,win:a,charts:[],marginNames:["plotTop","marginRight","marginBottom","plotLeft"],noop:function(){}}}();(function(a){var B=[],A=a.charts,H=a.doc,G=a.win;a.error=function(r,f){r=a.isNumber(r)?"Highcharts error #"+
	r+": www.highcharts.com/errors/"+r:r;if(f)throw Error(r);G.console&&console.log(r)};a.Fx=function(a,f,l){this.options=f;this.elem=a;this.prop=l};a.Fx.prototype={dSetter:function(){var a=this.paths[0],f=this.paths[1],l=[],q=this.now,k=a.length,u;if(1===q)l=this.toD;else if(k===f.length&&1>q)for(;k--;)u=parseFloat(a[k]),l[k]=isNaN(u)?a[k]:q*parseFloat(f[k]-u)+u;else l=f;this.elem.attr("d",l,null,!0)},update:function(){var a=this.elem,f=this.prop,l=this.now,q=this.options.step;if(this[f+"Setter"])this[f+
	"Setter"]();else a.attr?a.element&&a.attr(f,l,null,!0):a.style[f]=l+this.unit;q&&q.call(a,l,this)},run:function(a,f,l){var r=this,k=function(a){return k.stopped?!1:r.step(a)},u;this.startTime=+new Date;this.start=a;this.end=f;this.unit=l;this.now=this.start;this.pos=0;k.elem=this.elem;k.prop=this.prop;k()&&1===B.push(k)&&(k.timerId=setInterval(function(){for(u=0;u<B.length;u++)B[u]()||B.splice(u--,1);B.length||clearInterval(k.timerId)},13))},step:function(a){var f=+new Date,r,q=this.options;r=this.elem;
	var k=q.complete,u=q.duration,d=q.curAnim,c;if(r.attr&&!r.element)r=!1;else if(a||f>=u+this.startTime){this.now=this.end;this.pos=1;this.update();a=d[this.prop]=!0;for(c in d)!0!==d[c]&&(a=!1);a&&k&&k.call(r);r=!1}else this.pos=q.easing((f-this.startTime)/u),this.now=this.start+(this.end-this.start)*this.pos,this.update(),r=!0;return r},initPath:function(r,f,l){function q(a){var b,e;for(t=a.length;t--;)b="M"===a[t]||"L"===a[t],e=/[a-zA-Z]/.test(a[t+3]),b&&e&&a.splice(t+1,0,a[t+1],a[t+2],a[t+1],a[t+
	2])}function k(a,e){for(;a.length<p;){a[0]=e[p-a.length];var h=a.slice(0,b);[].splice.apply(a,[0,0].concat(h));D&&(h=a.slice(a.length-b),[].splice.apply(a,[a.length,0].concat(h)),t--)}a[0]="M"}function u(a,e){for(var c=(p-a.length)/b;0<c&&c--;)h=a.slice().splice(a.length/w-b,b*w),h[0]=e[p-b-c*b],z&&(h[b-6]=h[b-2],h[b-5]=h[b-1]),[].splice.apply(a,[a.length/w,0].concat(h)),D&&c--}f=f||"";var d,c=r.startX,n=r.endX,z=-1<f.indexOf("C"),b=z?7:3,p,h,t;f=f.split(" ");l=l.slice();var D=r.isArea,w=D?2:1,e;
	z&&(q(f),q(l));if(c&&n){for(t=0;t<c.length;t++)if(c[t]===n[0]){d=t;break}else if(c[0]===n[n.length-c.length+t]){d=t;e=!0;break}void 0===d&&(f=[])}f.length&&a.isNumber(d)&&(p=l.length+d*w*b,e?(k(f,l),u(l,f)):(k(l,f),u(f,l)));return[f,l]}};a.extend=function(a,f){var r;a||(a={});for(r in f)a[r]=f[r];return a};a.merge=function(){var r,f=arguments,l,q={},k=function(u,d){var c,n;"object"!==typeof u&&(u={});for(n in d)d.hasOwnProperty(n)&&(c=d[n],a.isObject(c,!0)&&"renderTo"!==n&&"number"!==typeof c.nodeType?
	u[n]=k(u[n]||{},c):u[n]=d[n]);return u};!0===f[0]&&(q=f[1],f=Array.prototype.slice.call(f,2));l=f.length;for(r=0;r<l;r++)q=k(q,f[r]);return q};a.pInt=function(a,f){return parseInt(a,f||10)};a.isString=function(a){return"string"===typeof a};a.isArray=function(a){a=Object.prototype.toString.call(a);return"[object Array]"===a||"[object Array Iterator]"===a};a.isObject=function(r,f){return r&&"object"===typeof r&&(!f||!a.isArray(r))};a.isNumber=function(a){return"number"===typeof a&&!isNaN(a)};a.erase=
	function(a,f){for(var r=a.length;r--;)if(a[r]===f){a.splice(r,1);break}};a.defined=function(a){return void 0!==a&&null!==a};a.attr=function(r,f,l){var q,k;if(a.isString(f))a.defined(l)?r.setAttribute(f,l):r&&r.getAttribute&&(k=r.getAttribute(f));else if(a.defined(f)&&a.isObject(f))for(q in f)r.setAttribute(q,f[q]);return k};a.splat=function(r){return a.isArray(r)?r:[r]};a.syncTimeout=function(a,f,l){if(f)return setTimeout(a,f,l);a.call(0,l)};a.pick=function(){var a=arguments,f,l,q=a.length;for(f=
	0;f<q;f++)if(l=a[f],void 0!==l&&null!==l)return l};a.css=function(r,f){a.isMS&&!a.svg&&f&&void 0!==f.opacity&&(f.filter="alpha(opacity\x3d"+100*f.opacity+")");a.extend(r.style,f)};a.createElement=function(r,f,l,q,k){r=H.createElement(r);var u=a.css;f&&a.extend(r,f);k&&u(r,{padding:0,border:"none",margin:0});l&&u(r,l);q&&q.appendChild(r);return r};a.extendClass=function(r,f){var l=function(){};l.prototype=new r;a.extend(l.prototype,f);return l};a.pad=function(a,f,l){return Array((f||2)+1-String(a).length).join(l||
	0)+a};a.relativeLength=function(a,f){return/%$/.test(a)?f*parseFloat(a)/100:parseFloat(a)};a.wrap=function(a,f,l){var q=a[f];a[f]=function(){var a=Array.prototype.slice.call(arguments),u=arguments,d=this;d.proceed=function(){q.apply(d,arguments.length?arguments:u)};a.unshift(q);a=l.apply(this,a);d.proceed=null;return a}};a.getTZOffset=function(r){var f=a.Date;return 6E4*(f.hcGetTimezoneOffset&&f.hcGetTimezoneOffset(r)||f.hcTimezoneOffset||0)};a.dateFormat=function(r,f,l){if(!a.defined(f)||isNaN(f))return a.defaultOptions.lang.invalidDate||
	"";r=a.pick(r,"%Y-%m-%d %H:%M:%S");var q=a.Date,k=new q(f-a.getTZOffset(f)),u,d=k[q.hcGetHours](),c=k[q.hcGetDay](),n=k[q.hcGetDate](),z=k[q.hcGetMonth](),b=k[q.hcGetFullYear](),p=a.defaultOptions.lang,h=p.weekdays,t=p.shortWeekdays,D=a.pad,q=a.extend({a:t?t[c]:h[c].substr(0,3),A:h[c],d:D(n),e:D(n,2," "),w:c,b:p.shortMonths[z],B:p.months[z],m:D(z+1),y:b.toString().substr(2,2),Y:b,H:D(d),k:d,I:D(d%12||12),l:d%12||12,M:D(k[q.hcGetMinutes]()),p:12>d?"AM":"PM",P:12>d?"am":"pm",S:D(k.getSeconds()),L:D(Math.round(f%
	1E3),3)},a.dateFormats);for(u in q)for(;-1!==r.indexOf("%"+u);)r=r.replace("%"+u,"function"===typeof q[u]?q[u](f):q[u]);return l?r.substr(0,1).toUpperCase()+r.substr(1):r};a.formatSingle=function(r,f){var l=/\.([0-9])/,q=a.defaultOptions.lang;/f$/.test(r)?(l=(l=r.match(l))?l[1]:-1,null!==f&&(f=a.numberFormat(f,l,q.decimalPoint,-1<r.indexOf(",")?q.thousandsSep:""))):f=a.dateFormat(r,f);return f};a.format=function(r,f){for(var l="{",q=!1,k,u,d,c,n=[],z;r;){l=r.indexOf(l);if(-1===l)break;k=r.slice(0,
	l);if(q){k=k.split(":");u=k.shift().split(".");c=u.length;z=f;for(d=0;d<c;d++)z=z[u[d]];k.length&&(z=a.formatSingle(k.join(":"),z));n.push(z)}else n.push(k);r=r.slice(l+1);l=(q=!q)?"}":"{"}n.push(r);return n.join("")};a.getMagnitude=function(a){return Math.pow(10,Math.floor(Math.log(a)/Math.LN10))};a.normalizeTickInterval=function(r,f,l,q,k){var u,d=r;l=a.pick(l,1);u=r/l;f||(f=k?[1,1.2,1.5,2,2.5,3,4,5,6,8,10]:[1,2,2.5,5,10],!1===q&&(1===l?f=a.grep(f,function(a){return 0===a%1}):.1>=l&&(f=[1/l])));
	for(q=0;q<f.length&&!(d=f[q],k&&d*l>=r||!k&&u<=(f[q]+(f[q+1]||f[q]))/2);q++);return d=a.correctFloat(d*l,-Math.round(Math.log(.001)/Math.LN10))};a.stableSort=function(a,f){var l=a.length,q,k;for(k=0;k<l;k++)a[k].safeI=k;a.sort(function(a,d){q=f(a,d);return 0===q?a.safeI-d.safeI:q});for(k=0;k<l;k++)delete a[k].safeI};a.arrayMin=function(a){for(var f=a.length,l=a[0];f--;)a[f]<l&&(l=a[f]);return l};a.arrayMax=function(a){for(var f=a.length,l=a[0];f--;)a[f]>l&&(l=a[f]);return l};a.destroyObjectProperties=
	function(a,f){for(var l in a)a[l]&&a[l]!==f&&a[l].destroy&&a[l].destroy(),delete a[l]};a.discardElement=function(r){var f=a.garbageBin;f||(f=a.createElement("div"));r&&f.appendChild(r);f.innerHTML=""};a.correctFloat=function(a,f){return parseFloat(a.toPrecision(f||14))};a.setAnimation=function(r,f){f.renderer.globalAnimation=a.pick(r,f.options.chart.animation,!0)};a.animObject=function(r){return a.isObject(r)?a.merge(r):{duration:r?500:0}};a.timeUnits={millisecond:1,second:1E3,minute:6E4,hour:36E5,
	day:864E5,week:6048E5,month:24192E5,year:314496E5};a.numberFormat=function(r,f,l,q){r=+r||0;f=+f;var k=a.defaultOptions.lang,u=(r.toString().split(".")[1]||"").length,d,c;-1===f?f=Math.min(u,20):a.isNumber(f)||(f=2);c=(Math.abs(r)+Math.pow(10,-Math.max(f,u)-1)).toFixed(f);u=String(a.pInt(c));d=3<u.length?u.length%3:0;l=a.pick(l,k.decimalPoint);q=a.pick(q,k.thousandsSep);r=(0>r?"-":"")+(d?u.substr(0,d)+q:"");r+=u.substr(d).replace(/(\d{3})(?=\d)/g,"$1"+q);f&&(r+=l+c.slice(-f));return r};Math.easeInOutSine=
	function(a){return-.5*(Math.cos(Math.PI*a)-1)};a.getStyle=function(r,f){return"width"===f?Math.min(r.offsetWidth,r.scrollWidth)-a.getStyle(r,"padding-left")-a.getStyle(r,"padding-right"):"height"===f?Math.min(r.offsetHeight,r.scrollHeight)-a.getStyle(r,"padding-top")-a.getStyle(r,"padding-bottom"):(r=G.getComputedStyle(r,void 0))&&a.pInt(r.getPropertyValue(f))};a.inArray=function(a,f){return f.indexOf?f.indexOf(a):[].indexOf.call(f,a)};a.grep=function(a,f){return[].filter.call(a,f)};a.find=function(a,
	f){return[].find.call(a,f)};a.map=function(a,f){for(var l=[],q=0,k=a.length;q<k;q++)l[q]=f.call(a[q],a[q],q,a);return l};a.offset=function(a){var f=H.documentElement;a=a.getBoundingClientRect();return{top:a.top+(G.pageYOffset||f.scrollTop)-(f.clientTop||0),left:a.left+(G.pageXOffset||f.scrollLeft)-(f.clientLeft||0)}};a.stop=function(a,f){for(var l=B.length;l--;)B[l].elem!==a||f&&f!==B[l].prop||(B[l].stopped=!0)};a.each=function(a,f,l){return Array.prototype.forEach.call(a,f,l)};a.addEvent=function(r,
	f,l){function q(a){a.target=a.srcElement||G;l.call(r,a)}var k=r.hcEvents=r.hcEvents||{};r.addEventListener?r.addEventListener(f,l,!1):r.attachEvent&&(r.hcEventsIE||(r.hcEventsIE={}),r.hcEventsIE[l.toString()]=q,r.attachEvent("on"+f,q));k[f]||(k[f]=[]);k[f].push(l);return function(){a.removeEvent(r,f,l)}};a.removeEvent=function(r,f,l){function q(a,c){r.removeEventListener?r.removeEventListener(a,c,!1):r.attachEvent&&(c=r.hcEventsIE[c.toString()],r.detachEvent("on"+a,c))}function k(){var a,c;if(r.nodeName)for(c in f?
	(a={},a[f]=!0):a=d,a)if(d[c])for(a=d[c].length;a--;)q(c,d[c][a])}var u,d=r.hcEvents,c;d&&(f?(u=d[f]||[],l?(c=a.inArray(l,u),-1<c&&(u.splice(c,1),d[f]=u),q(f,l)):(k(),d[f]=[])):(k(),r.hcEvents={}))};a.fireEvent=function(r,f,l,q){var k;k=r.hcEvents;var u,d;l=l||{};if(H.createEvent&&(r.dispatchEvent||r.fireEvent))k=H.createEvent("Events"),k.initEvent(f,!0,!0),a.extend(k,l),r.dispatchEvent?r.dispatchEvent(k):r.fireEvent(f,k);else if(k)for(k=k[f]||[],u=k.length,l.target||a.extend(l,{preventDefault:function(){l.defaultPrevented=
	!0},target:r,type:f}),f=0;f<u;f++)(d=k[f])&&!1===d.call(r,l)&&l.preventDefault();q&&!l.defaultPrevented&&q(l)};a.animate=function(r,f,l){var q,k="",u,d,c;a.isObject(l)||(q=arguments,l={duration:q[2],easing:q[3],complete:q[4]});a.isNumber(l.duration)||(l.duration=400);l.easing="function"===typeof l.easing?l.easing:Math[l.easing]||Math.easeInOutSine;l.curAnim=a.merge(f);for(c in f)a.stop(r,c),d=new a.Fx(r,l,c),u=null,"d"===c?(d.paths=d.initPath(r,r.d,f.d),d.toD=f.d,q=0,u=1):r.attr?q=r.attr(c):(q=parseFloat(a.getStyle(r,
	c))||0,"opacity"!==c&&(k="px")),u||(u=f[c]),u&&u.match&&u.match("px")&&(u=u.replace(/px/g,"")),d.run(q,u,k)};a.seriesType=function(r,f,l,q,k){var u=a.getOptions(),d=a.seriesTypes;u.plotOptions[r]=a.merge(u.plotOptions[f],l);d[r]=a.extendClass(d[f]||function(){},q);d[r].prototype.type=r;k&&(d[r].prototype.pointClass=a.extendClass(a.Point,k));return d[r]};a.uniqueKey=function(){var a=Math.random().toString(36).substring(2,9),f=0;return function(){return"highcharts-"+a+"-"+f++}}();G.jQuery&&(G.jQuery.fn.highcharts=
	function(){var r=[].slice.call(arguments);if(this[0])return r[0]?(new (a[a.isString(r[0])?r.shift():"Chart"])(this[0],r[0],r[1]),this):A[a.attr(this[0],"data-highcharts-chart")]});H&&!H.defaultView&&(a.getStyle=function(r,f){var l={width:"clientWidth",height:"clientHeight"}[f];if(r.style[f])return a.pInt(r.style[f]);"opacity"===f&&(f="filter");if(l)return r.style.zoom=1,Math.max(r[l]-2*a.getStyle(r,"padding"),0);r=r.currentStyle[f.replace(/\-(\w)/g,function(a,k){return k.toUpperCase()})];"filter"===
	f&&(r=r.replace(/alpha\(opacity=([0-9]+)\)/,function(a,k){return k/100}));return""===r?1:a.pInt(r)});Array.prototype.forEach||(a.each=function(a,f,l){for(var q=0,k=a.length;q<k;q++)if(!1===f.call(l,a[q],q,a))return q});Array.prototype.indexOf||(a.inArray=function(a,f){var l,q=0;if(f)for(l=f.length;q<l;q++)if(f[q]===a)return q;return-1});Array.prototype.filter||(a.grep=function(a,f){for(var l=[],q=0,k=a.length;q<k;q++)f(a[q],q)&&l.push(a[q]);return l});Array.prototype.find||(a.find=function(a,f){var l,
	q=a.length;for(l=0;l<q;l++)if(f(a[l],l))return a[l]})})(L);(function(a){var B=a.each,A=a.isNumber,H=a.map,G=a.merge,r=a.pInt;a.Color=function(f){if(!(this instanceof a.Color))return new a.Color(f);this.init(f)};a.Color.prototype={parsers:[{regex:/rgba\(\s*([0-9]{1,3})\s*,\s*([0-9]{1,3})\s*,\s*([0-9]{1,3})\s*,\s*([0-9]?(?:\.[0-9]+)?)\s*\)/,parse:function(a){return[r(a[1]),r(a[2]),r(a[3]),parseFloat(a[4],10)]}},{regex:/rgb\(\s*([0-9]{1,3})\s*,\s*([0-9]{1,3})\s*,\s*([0-9]{1,3})\s*\)/,parse:function(a){return[r(a[1]),
	r(a[2]),r(a[3]),1]}}],names:{white:"#ffffff",black:"#000000"},init:function(f){var l,q,k,u;if((this.input=f=this.names[f&&f.toLowerCase?f.toLowerCase():""]||f)&&f.stops)this.stops=H(f.stops,function(d){return new a.Color(d[1])});else if(f&&"#"===f[0]&&(l=f.length,f=parseInt(f.substr(1),16),7===l?q=[(f&16711680)>>16,(f&65280)>>8,f&255,1]:4===l&&(q=[(f&3840)>>4|(f&3840)>>8,(f&240)>>4|f&240,(f&15)<<4|f&15,1])),!q)for(k=this.parsers.length;k--&&!q;)u=this.parsers[k],(l=u.regex.exec(f))&&(q=u.parse(l));
	this.rgba=q||[]},get:function(a){var f=this.input,q=this.rgba,k;this.stops?(k=G(f),k.stops=[].concat(k.stops),B(this.stops,function(u,d){k.stops[d]=[k.stops[d][0],u.get(a)]})):k=q&&A(q[0])?"rgb"===a||!a&&1===q[3]?"rgb("+q[0]+","+q[1]+","+q[2]+")":"a"===a?q[3]:"rgba("+q.join(",")+")":f;return k},brighten:function(a){var f,q=this.rgba;if(this.stops)B(this.stops,function(k){k.brighten(a)});else if(A(a)&&0!==a)for(f=0;3>f;f++)q[f]+=r(255*a),0>q[f]&&(q[f]=0),255<q[f]&&(q[f]=255);return this},setOpacity:function(a){this.rgba[3]=
	a;return this}};a.color=function(f){return new a.Color(f)}})(L);(function(a){var B,A,H=a.addEvent,G=a.animate,r=a.attr,f=a.charts,l=a.color,q=a.css,k=a.createElement,u=a.defined,d=a.deg2rad,c=a.destroyObjectProperties,n=a.doc,z=a.each,b=a.extend,p=a.erase,h=a.grep,t=a.hasTouch,D=a.inArray,w=a.isArray,e=a.isFirefox,x=a.isMS,C=a.isObject,E=a.isString,m=a.isWebKit,y=a.merge,I=a.noop,K=a.pick,J=a.pInt,g=a.removeEvent,F=a.stop,Q=a.svg,N=a.SVG_NS,P=a.symbolSizes,O=a.win;B=a.SVGElement=function(){return this};
	B.prototype={opacity:1,SVG_NS:N,textProps:"direction fontSize fontWeight fontFamily fontStyle color lineHeight width textAlign textDecoration textOverflow textOutline".split(" "),init:function(a,g){this.element="span"===g?k(g):n.createElementNS(this.SVG_NS,g);this.renderer=a},animate:function(v,g,b){g=a.animObject(K(g,this.renderer.globalAnimation,!0));0!==g.duration?(b&&(g.complete=b),G(this,v,g)):(this.attr(v,null,b),g.step&&g.step.call(this));return this},colorGradient:function(v,g,b){var e=this.renderer,
	h,c,m,M,F,x,d,C,t,p,n,k=[],R;v.radialGradient?c="radialGradient":v.linearGradient&&(c="linearGradient");if(c){m=v[c];F=e.gradients;d=v.stops;p=b.radialReference;w(m)&&(v[c]=m={x1:m[0],y1:m[1],x2:m[2],y2:m[3],gradientUnits:"userSpaceOnUse"});"radialGradient"===c&&p&&!u(m.gradientUnits)&&(M=m,m=y(m,e.getRadialAttr(p,M),{gradientUnits:"userSpaceOnUse"}));for(n in m)"id"!==n&&k.push(n,m[n]);for(n in d)k.push(d[n]);k=k.join(",");F[k]?p=F[k].attr("id"):(m.id=p=a.uniqueKey(),F[k]=x=e.createElement(c).attr(m).add(e.defs),
	x.radAttr=M,x.stops=[],z(d,function(v){0===v[1].indexOf("rgba")?(h=a.color(v[1]),C=h.get("rgb"),t=h.get("a")):(C=v[1],t=1);v=e.createElement("stop").attr({offset:v[0],"stop-color":C,"stop-opacity":t}).add(x);x.stops.push(v)}));R="url("+e.url+"#"+p+")";b.setAttribute(g,R);b.gradient=k;v.toString=function(){return R}}},applyTextOutline:function(v){var g=this.element,b,e,c,h,m;-1!==v.indexOf("contrast")&&(v=v.replace(/contrast/g,this.renderer.getContrast(g.style.fill)));v=v.split(" ");e=v[v.length-1];
	if((c=v[0])&&"none"!==c&&a.svg){this.fakeTS=!0;v=[].slice.call(g.getElementsByTagName("tspan"));this.ySetter=this.xSetter;c=c.replace(/(^[\d\.]+)(.*?)$/g,function(a,v,g){return 2*v+g});for(m=v.length;m--;)b=v[m],"highcharts-text-outline"===b.getAttribute("class")&&p(v,g.removeChild(b));h=g.firstChild;z(v,function(a,v){0===v&&(a.setAttribute("x",g.getAttribute("x")),v=g.getAttribute("y"),a.setAttribute("y",v||0),null===v&&g.setAttribute("y",0));a=a.cloneNode(1);r(a,{"class":"highcharts-text-outline",
	fill:e,stroke:e,"stroke-width":c,"stroke-linejoin":"round"});g.insertBefore(a,h)})}},attr:function(a,g,b,e){var v,c=this.element,h,m=this,M;"string"===typeof a&&void 0!==g&&(v=a,a={},a[v]=g);if("string"===typeof a)m=(this[a+"Getter"]||this._defaultGetter).call(this,a,c);else{for(v in a)g=a[v],M=!1,e||F(this,v),this.symbolName&&/^(x|y|width|height|r|start|end|innerR|anchorX|anchorY)$/.test(v)&&(h||(this.symbolAttr(a),h=!0),M=!0),!this.rotation||"x"!==v&&"y"!==v||(this.doTransform=!0),M||(M=this[v+
	"Setter"]||this._defaultSetter,M.call(this,g,v,c),this.shadows&&/^(width|height|visibility|x|y|d|transform|cx|cy|r)$/.test(v)&&this.updateShadows(v,g,M));this.doTransform&&(this.updateTransform(),this.doTransform=!1)}b&&b();return m},updateShadows:function(a,g,b){for(var v=this.shadows,e=v.length;e--;)b.call(v[e],"height"===a?Math.max(g-(v[e].cutHeight||0),0):"d"===a?this.d:g,a,v[e])},addClass:function(a,g){var v=this.attr("class")||"";-1===v.indexOf(a)&&(g||(a=(v+(v?" ":"")+a).replace("  "," ")),
	this.attr("class",a));return this},hasClass:function(a){return-1!==r(this.element,"class").indexOf(a)},removeClass:function(a){r(this.element,"class",(r(this.element,"class")||"").replace(a,""));return this},symbolAttr:function(a){var v=this;z("x y r start end width height innerR anchorX anchorY".split(" "),function(g){v[g]=K(a[g],v[g])});v.attr({d:v.renderer.symbols[v.symbolName](v.x,v.y,v.width,v.height,v)})},clip:function(a){return this.attr("clip-path",a?"url("+this.renderer.url+"#"+a.id+")":
	"none")},crisp:function(a,g){var v,b={},e;g=g||a.strokeWidth||0;e=Math.round(g)%2/2;a.x=Math.floor(a.x||this.x||0)+e;a.y=Math.floor(a.y||this.y||0)+e;a.width=Math.floor((a.width||this.width||0)-2*e);a.height=Math.floor((a.height||this.height||0)-2*e);u(a.strokeWidth)&&(a.strokeWidth=g);for(v in a)this[v]!==a[v]&&(this[v]=b[v]=a[v]);return b},css:function(a){var v=this.styles,g={},e=this.element,c,h="",m=!v,F=["textOutline","textOverflow","width"];a&&a.color&&(a.fill=a.color);if(v)for(c in a)a[c]!==
	v[c]&&(g[c]=a[c],m=!0);if(m){v&&(a=b(v,g));v=this.textWidth=a&&a.width&&"auto"!==a.width&&"text"===e.nodeName.toLowerCase()&&J(a.width);this.styles=a;v&&!Q&&this.renderer.forExport&&delete a.width;if(x&&!Q)q(this.element,a);else{v=function(a,v){return"-"+v.toLowerCase()};for(c in a)-1===D(c,F)&&(h+=c.replace(/([A-Z])/g,v)+":"+a[c]+";");h&&r(e,"style",h)}this.added&&("text"===this.element.nodeName&&this.renderer.buildText(this),a&&a.textOutline&&this.applyTextOutline(a.textOutline))}return this},strokeWidth:function(){return this["stroke-width"]||
	0},on:function(a,g){var v=this,e=v.element;t&&"click"===a?(e.ontouchstart=function(a){v.touchEventFired=Date.now();a.preventDefault();g.call(e,a)},e.onclick=function(a){(-1===O.navigator.userAgent.indexOf("Android")||1100<Date.now()-(v.touchEventFired||0))&&g.call(e,a)}):e["on"+a]=g;return this},setRadialReference:function(a){var v=this.renderer.gradients[this.element.gradient];this.element.radialReference=a;v&&v.radAttr&&v.animate(this.renderer.getRadialAttr(a,v.radAttr));return this},translate:function(a,
	g){return this.attr({translateX:a,translateY:g})},invert:function(a){this.inverted=a;this.updateTransform();return this},updateTransform:function(){var a=this.translateX||0,g=this.translateY||0,e=this.scaleX,b=this.scaleY,c=this.inverted,h=this.rotation,m=this.element;c&&(a+=this.width,g+=this.height);a=["translate("+a+","+g+")"];c?a.push("rotate(90) scale(-1,1)"):h&&a.push("rotate("+h+" "+(m.getAttribute("x")||0)+" "+(m.getAttribute("y")||0)+")");(u(e)||u(b))&&a.push("scale("+K(e,1)+" "+K(b,1)+")");
	a.length&&m.setAttribute("transform",a.join(" "))},toFront:function(){var a=this.element;a.parentNode.appendChild(a);return this},align:function(a,g,e){var v,b,c,h,m={};b=this.renderer;c=b.alignedObjects;var F,x;if(a){if(this.alignOptions=a,this.alignByTranslate=g,!e||E(e))this.alignTo=v=e||"renderer",p(c,this),c.push(this),e=null}else a=this.alignOptions,g=this.alignByTranslate,v=this.alignTo;e=K(e,b[v],b);v=a.align;b=a.verticalAlign;c=(e.x||0)+(a.x||0);h=(e.y||0)+(a.y||0);"right"===v?F=1:"center"===
	v&&(F=2);F&&(c+=(e.width-(a.width||0))/F);m[g?"translateX":"x"]=Math.round(c);"bottom"===b?x=1:"middle"===b&&(x=2);x&&(h+=(e.height-(a.height||0))/x);m[g?"translateY":"y"]=Math.round(h);this[this.placed?"animate":"attr"](m);this.placed=!0;this.alignAttr=m;return this},getBBox:function(a,g){var v,e=this.renderer,c,h=this.element,m=this.styles,F,x=this.textStr,y,M=e.cache,C=e.cacheKeys,t;g=K(g,this.rotation);c=g*d;F=m&&m.fontSize;void 0!==x&&(t=x.toString(),-1===t.indexOf("\x3c")&&(t=t.replace(/[0-9]/g,
	"0")),t+=["",g||0,F,m&&m.width,m&&m.textOverflow].join());t&&!a&&(v=M[t]);if(!v){if(h.namespaceURI===this.SVG_NS||e.forExport){try{(y=this.fakeTS&&function(a){z(h.querySelectorAll(".highcharts-text-outline"),function(v){v.style.display=a})})&&y("none"),v=h.getBBox?b({},h.getBBox()):{width:h.offsetWidth,height:h.offsetHeight},y&&y("")}catch(X){}if(!v||0>v.width)v={width:0,height:0}}else v=this.htmlGetBBox();e.isSVG&&(a=v.width,e=v.height,m&&"11px"===m.fontSize&&17===Math.round(e)&&(v.height=e=14),
	g&&(v.width=Math.abs(e*Math.sin(c))+Math.abs(a*Math.cos(c)),v.height=Math.abs(e*Math.cos(c))+Math.abs(a*Math.sin(c))));if(t&&0<v.height){for(;250<C.length;)delete M[C.shift()];M[t]||C.push(t);M[t]=v}}return v},show:function(a){return this.attr({visibility:a?"inherit":"visible"})},hide:function(){return this.attr({visibility:"hidden"})},fadeOut:function(a){var v=this;v.animate({opacity:0},{duration:a||150,complete:function(){v.attr({y:-9999})}})},add:function(a){var v=this.renderer,g=this.element,
	e;a&&(this.parentGroup=a);this.parentInverted=a&&a.inverted;void 0!==this.textStr&&v.buildText(this);this.added=!0;if(!a||a.handleZ||this.zIndex)e=this.zIndexSetter();e||(a?a.element:v.box).appendChild(g);if(this.onAdd)this.onAdd();return this},safeRemoveChild:function(a){var v=a.parentNode;v&&v.removeChild(a)},destroy:function(){var a=this,g=a.element||{},e=a.renderer.isSVG&&"SPAN"===g.nodeName&&a.parentGroup,b,c;g.onclick=g.onmouseout=g.onmouseover=g.onmousemove=g.point=null;F(a);a.clipPath&&(z(a.element.ownerSVGElement.querySelectorAll("[clip-path]"),
	function(v){-1<v.getAttribute("clip-path").indexOf(a.clipPath.element.id)&&v.removeAttribute("clip-path")}),a.clipPath=a.clipPath.destroy());if(a.stops){for(c=0;c<a.stops.length;c++)a.stops[c]=a.stops[c].destroy();a.stops=null}a.safeRemoveChild(g);for(a.destroyShadows();e&&e.div&&0===e.div.childNodes.length;)g=e.parentGroup,a.safeRemoveChild(e.div),delete e.div,e=g;a.alignTo&&p(a.renderer.alignedObjects,a);for(b in a)delete a[b];return null},shadow:function(a,g,e){var v=[],b,c,h=this.element,m,F,
	x,y;if(!a)this.destroyShadows();else if(!this.shadows){F=K(a.width,3);x=(a.opacity||.15)/F;y=this.parentInverted?"(-1,-1)":"("+K(a.offsetX,1)+", "+K(a.offsetY,1)+")";for(b=1;b<=F;b++)c=h.cloneNode(0),m=2*F+1-2*b,r(c,{isShadow:"true",stroke:a.color||"#000000","stroke-opacity":x*b,"stroke-width":m,transform:"translate"+y,fill:"none"}),e&&(r(c,"height",Math.max(r(c,"height")-m,0)),c.cutHeight=m),g?g.element.appendChild(c):h.parentNode.insertBefore(c,h),v.push(c);this.shadows=v}return this},destroyShadows:function(){z(this.shadows||
	[],function(a){this.safeRemoveChild(a)},this);this.shadows=void 0},xGetter:function(a){"circle"===this.element.nodeName&&("x"===a?a="cx":"y"===a&&(a="cy"));return this._defaultGetter(a)},_defaultGetter:function(a){a=K(this[a],this.element?this.element.getAttribute(a):null,0);/^[\-0-9\.]+$/.test(a)&&(a=parseFloat(a));return a},dSetter:function(a,g,e){a&&a.join&&(a=a.join(" "));/(NaN| {2}|^$)/.test(a)&&(a="M 0 0");e.setAttribute(g,a);this[g]=a},dashstyleSetter:function(a){var v,g=this["stroke-width"];
	"inherit"===g&&(g=1);if(a=a&&a.toLowerCase()){a=a.replace("shortdashdotdot","3,1,1,1,1,1,").replace("shortdashdot","3,1,1,1").replace("shortdot","1,1,").replace("shortdash","3,1,").replace("longdash","8,3,").replace(/dot/g,"1,3,").replace("dash","4,3,").replace(/,$/,"").split(",");for(v=a.length;v--;)a[v]=J(a[v])*g;a=a.join(",").replace(/NaN/g,"none");this.element.setAttribute("stroke-dasharray",a)}},alignSetter:function(a){this.element.setAttribute("text-anchor",{left:"start",center:"middle",right:"end"}[a])},
	opacitySetter:function(a,g,e){this[g]=a;e.setAttribute(g,a)},titleSetter:function(a){var v=this.element.getElementsByTagName("title")[0];v||(v=n.createElementNS(this.SVG_NS,"title"),this.element.appendChild(v));v.firstChild&&v.removeChild(v.firstChild);v.appendChild(n.createTextNode(String(K(a),"").replace(/<[^>]*>/g,"")))},textSetter:function(a){a!==this.textStr&&(delete this.bBox,this.textStr=a,this.added&&this.renderer.buildText(this))},fillSetter:function(a,g,e){"string"===typeof a?e.setAttribute(g,
	a):a&&this.colorGradient(a,g,e)},visibilitySetter:function(a,g,e){"inherit"===a?e.removeAttribute(g):e.setAttribute(g,a)},zIndexSetter:function(a,g){var v=this.renderer,e=this.parentGroup,b=(e||v).element||v.box,c,h=this.element,m;c=this.added;var F;u(a)&&(h.zIndex=a,a=+a,this[g]===a&&(c=!1),this[g]=a);if(c){(a=this.zIndex)&&e&&(e.handleZ=!0);g=b.childNodes;for(F=0;F<g.length&&!m;F++)e=g[F],c=e.zIndex,e!==h&&(J(c)>a||!u(a)&&u(c)||0>a&&!u(c)&&b!==v.box)&&(b.insertBefore(h,e),m=!0);m||b.appendChild(h)}return m},
	_defaultSetter:function(a,g,e){e.setAttribute(g,a)}};B.prototype.yGetter=B.prototype.xGetter;B.prototype.translateXSetter=B.prototype.translateYSetter=B.prototype.rotationSetter=B.prototype.verticalAlignSetter=B.prototype.scaleXSetter=B.prototype.scaleYSetter=function(a,g){this[g]=a;this.doTransform=!0};B.prototype["stroke-widthSetter"]=B.prototype.strokeSetter=function(a,g,e){this[g]=a;this.stroke&&this["stroke-width"]?(B.prototype.fillSetter.call(this,this.stroke,"stroke",e),e.setAttribute("stroke-width",
	this["stroke-width"]),this.hasStroke=!0):"stroke-width"===g&&0===a&&this.hasStroke&&(e.removeAttribute("stroke"),this.hasStroke=!1)};A=a.SVGRenderer=function(){this.init.apply(this,arguments)};A.prototype={Element:B,SVG_NS:N,init:function(a,g,b,c,h,F){var v;c=this.createElement("svg").attr({version:"1.1","class":"highcharts-root"}).css(this.getStyle(c));v=c.element;a.appendChild(v);-1===a.innerHTML.indexOf("xmlns")&&r(v,"xmlns",this.SVG_NS);this.isSVG=!0;this.box=v;this.boxWrapper=c;this.alignedObjects=
	[];this.url=(e||m)&&n.getElementsByTagName("base").length?O.location.href.replace(/#.*?$/,"").replace(/<[^>]*>/g,"").replace(/([\('\)])/g,"\\$1").replace(/ /g,"%20"):"";this.createElement("desc").add().element.appendChild(n.createTextNode("Created with Highcharts 5.0.10"));this.defs=this.createElement("defs").add();this.allowHTML=F;this.forExport=h;this.gradients={};this.cache={};this.cacheKeys=[];this.imgCount=0;this.setSize(g,b,!1);var x;e&&a.getBoundingClientRect&&(g=function(){q(a,{left:0,top:0});
	x=a.getBoundingClientRect();q(a,{left:Math.ceil(x.left)-x.left+"px",top:Math.ceil(x.top)-x.top+"px"})},g(),this.unSubPixelFix=H(O,"resize",g))},getStyle:function(a){return this.style=b({fontFamily:'"Lucida Grande", "Lucida Sans Unicode", Arial, Helvetica, sans-serif',fontSize:"12px"},a)},setStyle:function(a){this.boxWrapper.css(this.getStyle(a))},isHidden:function(){return!this.boxWrapper.getBBox().width},destroy:function(){var a=this.defs;this.box=null;this.boxWrapper=this.boxWrapper.destroy();c(this.gradients||
	{});this.gradients=null;a&&(this.defs=a.destroy());this.unSubPixelFix&&this.unSubPixelFix();return this.alignedObjects=null},createElement:function(a){var g=new this.Element;g.init(this,a);return g},draw:I,getRadialAttr:function(a,g){return{cx:a[0]-a[2]/2+g.cx*a[2],cy:a[1]-a[2]/2+g.cy*a[2],r:g.r*a[2]}},getSpanWidth:function(a,g){var v=a.getBBox(!0).width;!Q&&this.forExport&&(v=this.measureSpanWidth(g.firstChild.data,a.styles));return v},applyEllipsis:function(a,g,e,b){var v=this.getSpanWidth(a,g),
	c=v>b,v=e,h,m=0,F=e.length,x=function(a){g.removeChild(g.firstChild);a&&g.appendChild(n.createTextNode(a))};if(c){for(;m<=F;)h=Math.ceil((m+F)/2),v=e.substring(0,h)+"\u2026",x(v),v=this.getSpanWidth(a,g),m===F?m=F+1:v>b?F=h-1:m=h;0===F&&x("")}return c},buildText:function(a){var g=a.element,e=this,v=e.forExport,b=K(a.textStr,"").toString(),c=-1!==b.indexOf("\x3c"),m=g.childNodes,F,x,y,t,d=r(g,"x"),C=a.styles,p=a.textWidth,k=C&&C.lineHeight,w=C&&C.textOutline,u=C&&"ellipsis"===C.textOverflow,f=C&&"nowrap"===
	C.whiteSpace,E=C&&C.fontSize,D,I,l=m.length,C=p&&!a.added&&this.box,P=function(a){var v;v=/(px|em)$/.test(a&&a.style.fontSize)?a.style.fontSize:E||e.style.fontSize||12;return k?J(k):e.fontMetrics(v,a.getAttribute("style")?a:g).h};D=[b,u,f,k,w,E,p].join();if(D!==a.textCache){for(a.textCache=D;l--;)g.removeChild(m[l]);c||w||u||p||-1!==b.indexOf(" ")?(F=/<.*class="([^"]+)".*>/,x=/<.*style="([^"]+)".*>/,y=/<.*href="(http[^"]+)".*>/,C&&C.appendChild(g),b=c?b.replace(/<(b|strong)>/g,'\x3cspan style\x3d"font-weight:bold"\x3e').replace(/<(i|em)>/g,
	'\x3cspan style\x3d"font-style:italic"\x3e').replace(/<a/g,"\x3cspan").replace(/<\/(b|strong|i|em|a)>/g,"\x3c/span\x3e").split(/<br.*?>/g):[b],b=h(b,function(a){return""!==a}),z(b,function(b,c){var m,h=0;b=b.replace(/^\s+|\s+$/g,"").replace(/<span/g,"|||\x3cspan").replace(/<\/span>/g,"\x3c/span\x3e|||");m=b.split("|||");z(m,function(b){if(""!==b||1===m.length){var C={},k=n.createElementNS(e.SVG_NS,"tspan"),w,E;F.test(b)&&(w=b.match(F)[1],r(k,"class",w));x.test(b)&&(E=b.match(x)[1].replace(/(;| |^)color([ :])/,
	"$1fill$2"),r(k,"style",E));y.test(b)&&!v&&(r(k,"onclick",'location.href\x3d"'+b.match(y)[1]+'"'),q(k,{cursor:"pointer"}));b=(b.replace(/<(.|\n)*?>/g,"")||" ").replace(/&lt;/g,"\x3c").replace(/&gt;/g,"\x3e");if(" "!==b){k.appendChild(n.createTextNode(b));h?C.dx=0:c&&null!==d&&(C.x=d);r(k,C);g.appendChild(k);!h&&I&&(!Q&&v&&q(k,{display:"block"}),r(k,"dy",P(k)));if(p){C=b.replace(/([^\^])-/g,"$1- ").split(" ");w=1<m.length||c||1<C.length&&!f;var D=[],M,z=P(k),l=a.rotation;for(u&&(t=e.applyEllipsis(a,
	k,b,p));!u&&w&&(C.length||D.length);)a.rotation=0,M=e.getSpanWidth(a,k),b=M>p,void 0===t&&(t=b),b&&1!==C.length?(k.removeChild(k.firstChild),D.unshift(C.pop())):(C=D,D=[],C.length&&!f&&(k=n.createElementNS(N,"tspan"),r(k,{dy:z,x:d}),E&&r(k,"style",E),g.appendChild(k)),M>p&&(p=M)),C.length&&k.appendChild(n.createTextNode(C.join(" ").replace(/- /g,"-")));a.rotation=l}h++}}});I=I||g.childNodes.length}),t&&a.attr("title",a.textStr),C&&C.removeChild(g),w&&a.applyTextOutline&&a.applyTextOutline(w)):g.appendChild(n.createTextNode(b.replace(/&lt;/g,
	"\x3c").replace(/&gt;/g,"\x3e")))}},getContrast:function(a){a=l(a).rgba;return 510<a[0]+a[1]+a[2]?"#000000":"#FFFFFF"},button:function(a,g,e,c,m,h,F,C,t){var v=this.label(a,g,e,t,null,null,null,null,"button"),d=0;v.attr(y({padding:8,r:2},m));var p,n,k,w;m=y({fill:"#f7f7f7",stroke:"#cccccc","stroke-width":1,style:{color:"#333333",cursor:"pointer",fontWeight:"normal"}},m);p=m.style;delete m.style;h=y(m,{fill:"#e6e6e6"},h);n=h.style;delete h.style;F=y(m,{fill:"#e6ebf5",style:{color:"#000000",fontWeight:"bold"}},
	F);k=F.style;delete F.style;C=y(m,{style:{color:"#cccccc"}},C);w=C.style;delete C.style;H(v.element,x?"mouseover":"mouseenter",function(){3!==d&&v.setState(1)});H(v.element,x?"mouseout":"mouseleave",function(){3!==d&&v.setState(d)});v.setState=function(a){1!==a&&(v.state=d=a);v.removeClass(/highcharts-button-(normal|hover|pressed|disabled)/).addClass("highcharts-button-"+["normal","hover","pressed","disabled"][a||0]);v.attr([m,h,F,C][a||0]).css([p,n,k,w][a||0])};v.attr(m).css(b({cursor:"default"},
	p));return v.on("click",function(a){3!==d&&c.call(v,a)})},crispLine:function(a,g){a[1]===a[4]&&(a[1]=a[4]=Math.round(a[1])-g%2/2);a[2]===a[5]&&(a[2]=a[5]=Math.round(a[2])+g%2/2);return a},path:function(a){var g={fill:"none"};w(a)?g.d=a:C(a)&&b(g,a);return this.createElement("path").attr(g)},circle:function(a,g,e){a=C(a)?a:{x:a,y:g,r:e};g=this.createElement("circle");g.xSetter=g.ySetter=function(a,g,e){e.setAttribute("c"+g,a)};return g.attr(a)},arc:function(a,g,e,b,c,m){C(a)?(b=a,g=b.y,e=b.r,a=b.x):
	b={innerR:b,start:c,end:m};a=this.symbol("arc",a,g,e,e,b);a.r=e;return a},rect:function(a,g,e,b,c,m){c=C(a)?a.r:c;var v=this.createElement("rect");a=C(a)?a:void 0===a?{}:{x:a,y:g,width:Math.max(e,0),height:Math.max(b,0)};void 0!==m&&(a.strokeWidth=m,a=v.crisp(a));a.fill="none";c&&(a.r=c);v.rSetter=function(a,g,e){r(e,{rx:a,ry:a})};return v.attr(a)},setSize:function(a,g,e){var b=this.alignedObjects,v=b.length;this.width=a;this.height=g;for(this.boxWrapper.animate({width:a,height:g},{step:function(){this.attr({viewBox:"0 0 "+
	this.attr("width")+" "+this.attr("height")})},duration:K(e,!0)?void 0:0});v--;)b[v].align()},g:function(a){var g=this.createElement("g");return a?g.attr({"class":"highcharts-"+a}):g},image:function(a,g,e,c,m){var v={preserveAspectRatio:"none"};1<arguments.length&&b(v,{x:g,y:e,width:c,height:m});v=this.createElement("image").attr(v);v.element.setAttributeNS?v.element.setAttributeNS("http://www.w3.org/1999/xlink","href",a):v.element.setAttribute("hc-svg-href",a);return v},symbol:function(a,g,e,c,m,
	h){var v=this,F,x=this.symbols[a],y=u(g)&&x&&this.symbols[a](Math.round(g),Math.round(e),c,m,h),C=/^url\((.*?)\)$/,d,t;x?(F=this.path(y),F.attr("fill","none"),b(F,{symbolName:a,x:g,y:e,width:c,height:m}),h&&b(F,h)):C.test(a)&&(d=a.match(C)[1],F=this.image(d),F.imgwidth=K(P[d]&&P[d].width,h&&h.width),F.imgheight=K(P[d]&&P[d].height,h&&h.height),t=function(){F.attr({width:F.width,height:F.height})},z(["width","height"],function(a){F[a+"Setter"]=function(a,g){var e={},b=this["img"+g],v="width"===g?"translateX":
	"translateY";this[g]=a;u(b)&&(this.element&&this.element.setAttribute(g,b),this.alignByTranslate||(e[v]=((this[g]||0)-b)/2,this.attr(e)))}}),u(g)&&F.attr({x:g,y:e}),F.isImg=!0,u(F.imgwidth)&&u(F.imgheight)?t():(F.attr({width:0,height:0}),k("img",{onload:function(){var a=f[v.chartIndex];0===this.width&&(q(this,{position:"absolute",top:"-999em"}),n.body.appendChild(this));P[d]={width:this.width,height:this.height};F.imgwidth=this.width;F.imgheight=this.height;F.element&&t();this.parentNode&&this.parentNode.removeChild(this);
	v.imgCount--;if(!v.imgCount&&a&&a.onload)a.onload()},src:d}),this.imgCount++));return F},symbols:{circle:function(a,g,e,b){return this.arc(a+e/2,g+b/2,e/2,b/2,{start:0,end:2*Math.PI,open:!1})},square:function(a,g,e,b){return["M",a,g,"L",a+e,g,a+e,g+b,a,g+b,"Z"]},triangle:function(a,g,e,b){return["M",a+e/2,g,"L",a+e,g+b,a,g+b,"Z"]},"triangle-down":function(a,g,e,b){return["M",a,g,"L",a+e,g,a+e/2,g+b,"Z"]},diamond:function(a,g,e,b){return["M",a+e/2,g,"L",a+e,g+b/2,a+e/2,g+b,a,g+b/2,"Z"]},arc:function(a,
	g,e,b,c){var v=c.start,m=c.r||e,h=c.r||b||e,F=c.end-.001;e=c.innerR;b=c.open;var x=Math.cos(v),y=Math.sin(v),C=Math.cos(F),F=Math.sin(F);c=c.end-v<Math.PI?0:1;m=["M",a+m*x,g+h*y,"A",m,h,0,c,1,a+m*C,g+h*F];u(e)&&m.push(b?"M":"L",a+e*C,g+e*F,"A",e,e,0,c,0,a+e*x,g+e*y);m.push(b?"":"Z");return m},callout:function(a,g,e,b,c){var m=Math.min(c&&c.r||0,e,b),h=m+6,v=c&&c.anchorX;c=c&&c.anchorY;var F;F=["M",a+m,g,"L",a+e-m,g,"C",a+e,g,a+e,g,a+e,g+m,"L",a+e,g+b-m,"C",a+e,g+b,a+e,g+b,a+e-m,g+b,"L",a+m,g+b,"C",
	a,g+b,a,g+b,a,g+b-m,"L",a,g+m,"C",a,g,a,g,a+m,g];v&&v>e?c>g+h&&c<g+b-h?F.splice(13,3,"L",a+e,c-6,a+e+6,c,a+e,c+6,a+e,g+b-m):F.splice(13,3,"L",a+e,b/2,v,c,a+e,b/2,a+e,g+b-m):v&&0>v?c>g+h&&c<g+b-h?F.splice(33,3,"L",a,c+6,a-6,c,a,c-6,a,g+m):F.splice(33,3,"L",a,b/2,v,c,a,b/2,a,g+m):c&&c>b&&v>a+h&&v<a+e-h?F.splice(23,3,"L",v+6,g+b,v,g+b+6,v-6,g+b,a+m,g+b):c&&0>c&&v>a+h&&v<a+e-h&&F.splice(3,3,"L",v-6,g,v,g-6,v+6,g,e-m,g);return F}},clipRect:function(g,e,b,c){var m=a.uniqueKey(),h=this.createElement("clipPath").attr({id:m}).add(this.defs);
	g=this.rect(g,e,b,c,0).add(h);g.id=m;g.clipPath=h;g.count=0;return g},text:function(a,g,e,b){var c=!Q&&this.forExport,m={};if(b&&(this.allowHTML||!this.forExport))return this.html(a,g,e);m.x=Math.round(g||0);e&&(m.y=Math.round(e));if(a||0===a)m.text=a;a=this.createElement("text").attr(m);c&&a.css({position:"absolute"});b||(a.xSetter=function(a,g,e){var b=e.getElementsByTagName("tspan"),c,m=e.getAttribute(g),h;for(h=0;h<b.length;h++)c=b[h],c.getAttribute(g)===m&&c.setAttribute(g,a);e.setAttribute(g,
	a)});return a},fontMetrics:function(a,g){a=a||g&&g.style&&g.style.fontSize||this.style&&this.style.fontSize;a=/px/.test(a)?J(a):/em/.test(a)?parseFloat(a)*(g?this.fontMetrics(null,g.parentNode).f:16):12;g=24>a?a+3:Math.round(1.2*a);return{h:g,b:Math.round(.8*g),f:a}},rotCorr:function(a,g,e){var b=a;g&&e&&(b=Math.max(b*Math.cos(g*d),4));return{x:-a/3*Math.sin(g*d),y:b}},label:function(e,c,m,h,F,x,C,d,t){var v=this,p=v.g("button"!==t&&"label"),n=p.text=v.text("",0,0,C).attr({zIndex:1}),k,w,E=0,f=3,
	D=0,I,q,l,Q,N,K={},J,r,M=/^url\((.*?)\)$/.test(h),P=M,R,S,O,U;t&&p.addClass("highcharts-"+t);P=M;R=function(){return(J||0)%2/2};S=function(){var a=n.element.style,g={};w=(void 0===I||void 0===q||N)&&u(n.textStr)&&n.getBBox();p.width=(I||w.width||0)+2*f+D;p.height=(q||w.height||0)+2*f;r=f+v.fontMetrics(a&&a.fontSize,n).b;P&&(k||(p.box=k=v.symbols[h]||M?v.symbol(h):v.rect(),k.addClass(("button"===t?"":"highcharts-label-box")+(t?" highcharts-"+t+"-box":"")),k.add(p),a=R(),g.x=a,g.y=(d?-r:0)+a),g.width=
	Math.round(p.width),g.height=Math.round(p.height),k.attr(b(g,K)),K={})};O=function(){var a=D+f,g;g=d?0:r;u(I)&&w&&("center"===N||"right"===N)&&(a+={center:.5,right:1}[N]*(I-w.width));if(a!==n.x||g!==n.y)n.attr("x",a),void 0!==g&&n.attr("y",g);n.x=a;n.y=g};U=function(a,g){k?k.attr(a,g):K[a]=g};p.onAdd=function(){n.add(p);p.attr({text:e||0===e?e:"",x:c,y:m});k&&u(F)&&p.attr({anchorX:F,anchorY:x})};p.widthSetter=function(g){I=a.isNumber(g)?g:null};p.heightSetter=function(a){q=a};p["text-alignSetter"]=
	function(a){N=a};p.paddingSetter=function(a){u(a)&&a!==f&&(f=p.padding=a,O())};p.paddingLeftSetter=function(a){u(a)&&a!==D&&(D=a,O())};p.alignSetter=function(a){a={left:0,center:.5,right:1}[a];a!==E&&(E=a,w&&p.attr({x:l}))};p.textSetter=function(a){void 0!==a&&n.textSetter(a);S();O()};p["stroke-widthSetter"]=function(a,g){a&&(P=!0);J=this["stroke-width"]=a;U(g,a)};p.strokeSetter=p.fillSetter=p.rSetter=function(a,g){"fill"===g&&a&&(P=!0);U(g,a)};p.anchorXSetter=function(a,g){F=a;U(g,Math.round(a)-
	R()-l)};p.anchorYSetter=function(a,g){x=a;U(g,a-Q)};p.xSetter=function(a){p.x=a;E&&(a-=E*((I||w.width)+2*f));l=Math.round(a);p.attr("translateX",l)};p.ySetter=function(a){Q=p.y=Math.round(a);p.attr("translateY",Q)};var W=p.css;return b(p,{css:function(a){if(a){var g={};a=y(a);z(p.textProps,function(e){void 0!==a[e]&&(g[e]=a[e],delete a[e])});n.css(g)}return W.call(p,a)},getBBox:function(){return{width:w.width+2*f,height:w.height+2*f,x:w.x-f,y:w.y-f}},shadow:function(a){a&&(S(),k&&k.shadow(a));return p},
	destroy:function(){g(p.element,"mouseenter");g(p.element,"mouseleave");n&&(n=n.destroy());k&&(k=k.destroy());B.prototype.destroy.call(p);p=v=S=O=U=null}})}};a.Renderer=A})(L);(function(a){var B=a.attr,A=a.createElement,H=a.css,G=a.defined,r=a.each,f=a.extend,l=a.isFirefox,q=a.isMS,k=a.isWebKit,u=a.pInt,d=a.SVGRenderer,c=a.win,n=a.wrap;f(a.SVGElement.prototype,{htmlCss:function(a){var b=this.element;if(b=a&&"SPAN"===b.tagName&&a.width)delete a.width,this.textWidth=b,this.updateTransform();a&&"ellipsis"===
	a.textOverflow&&(a.whiteSpace="nowrap",a.overflow="hidden");this.styles=f(this.styles,a);H(this.element,a);return this},htmlGetBBox:function(){var a=this.element;"text"===a.nodeName&&(a.style.position="absolute");return{x:a.offsetLeft,y:a.offsetTop,width:a.offsetWidth,height:a.offsetHeight}},htmlUpdateTransform:function(){if(this.added){var a=this.renderer,b=this.element,c=this.translateX||0,h=this.translateY||0,d=this.x||0,n=this.y||0,w=this.textAlign||"left",e={left:0,center:.5,right:1}[w],x=this.styles;
	H(b,{marginLeft:c,marginTop:h});this.shadows&&r(this.shadows,function(a){H(a,{marginLeft:c+1,marginTop:h+1})});this.inverted&&r(b.childNodes,function(e){a.invertChild(e,b)});if("SPAN"===b.tagName){var C=this.rotation,f=u(this.textWidth),m=x&&x.whiteSpace,y=[C,w,b.innerHTML,this.textWidth,this.textAlign].join();y!==this.cTT&&(x=a.fontMetrics(b.style.fontSize).b,G(C)&&this.setSpanRotation(C,e,x),H(b,{width:"",whiteSpace:m||"nowrap"}),b.offsetWidth>f&&/[ \-]/.test(b.textContent||b.innerText)&&H(b,{width:f+
	"px",display:"block",whiteSpace:m||"normal"}),this.getSpanCorrection(b.offsetWidth,x,e,C,w));H(b,{left:d+(this.xCorr||0)+"px",top:n+(this.yCorr||0)+"px"});k&&(x=b.offsetHeight);this.cTT=y}}else this.alignOnAdd=!0},setSpanRotation:function(a,b,p){var h={},d=q?"-ms-transform":k?"-webkit-transform":l?"MozTransform":c.opera?"-o-transform":"";h[d]=h.transform="rotate("+a+"deg)";h[d+(l?"Origin":"-origin")]=h.transformOrigin=100*b+"% "+p+"px";H(this.element,h)},getSpanCorrection:function(a,b,c){this.xCorr=
	-a*c;this.yCorr=-b}});f(d.prototype,{html:function(a,b,c){var h=this.createElement("span"),d=h.element,p=h.renderer,k=p.isSVG,e=function(a,e){r(["opacity","visibility"],function(b){n(a,b+"Setter",function(a,b,c,h){a.call(this,b,c,h);e[c]=b})})};h.textSetter=function(a){a!==d.innerHTML&&delete this.bBox;d.innerHTML=this.textStr=a;h.htmlUpdateTransform()};k&&e(h,h.element.style);h.xSetter=h.ySetter=h.alignSetter=h.rotationSetter=function(a,e){"align"===e&&(e="textAlign");h[e]=a;h.htmlUpdateTransform()};
	h.attr({text:a,x:Math.round(b),y:Math.round(c)}).css({fontFamily:this.style.fontFamily,fontSize:this.style.fontSize,position:"absolute"});d.style.whiteSpace="nowrap";h.css=h.htmlCss;k&&(h.add=function(a){var b,c=p.box.parentNode,m=[];if(this.parentGroup=a){if(b=a.div,!b){for(;a;)m.push(a),a=a.parentGroup;r(m.reverse(),function(a){var x,d=B(a.element,"class");d&&(d={className:d});b=a.div=a.div||A("div",d,{position:"absolute",left:(a.translateX||0)+"px",top:(a.translateY||0)+"px",display:a.display,
	opacity:a.opacity,pointerEvents:a.styles&&a.styles.pointerEvents},b||c);x=b.style;f(a,{on:function(){h.on.apply({element:m[0].div},arguments);return a},translateXSetter:function(e,g){x.left=e+"px";a[g]=e;a.doTransform=!0},translateYSetter:function(e,g){x.top=e+"px";a[g]=e;a.doTransform=!0}});e(a,x)})}}else b=c;b.appendChild(d);h.added=!0;h.alignOnAdd&&h.htmlUpdateTransform();return h});return h}})})(L);(function(a){var B,A,H=a.createElement,G=a.css,r=a.defined,f=a.deg2rad,l=a.discardElement,q=a.doc,
	k=a.each,u=a.erase,d=a.extend;B=a.extendClass;var c=a.isArray,n=a.isNumber,z=a.isObject,b=a.merge;A=a.noop;var p=a.pick,h=a.pInt,t=a.SVGElement,D=a.SVGRenderer,w=a.win;a.svg||(A={docMode8:q&&8===q.documentMode,init:function(a,b){var e=["\x3c",b,' filled\x3d"f" stroked\x3d"f"'],c=["position: ","absolute",";"],m="div"===b;("shape"===b||m)&&c.push("left:0;top:0;width:1px;height:1px;");c.push("visibility: ",m?"hidden":"visible");e.push(' style\x3d"',c.join(""),'"/\x3e');b&&(e=m||"span"===b||"img"===b?
	e.join(""):a.prepVML(e),this.element=H(e));this.renderer=a},add:function(a){var e=this.renderer,b=this.element,c=e.box,m=a&&a.inverted,c=a?a.element||a:c;a&&(this.parentGroup=a);m&&e.invertChild(b,c);c.appendChild(b);this.added=!0;this.alignOnAdd&&!this.deferUpdateTransform&&this.updateTransform();if(this.onAdd)this.onAdd();this.className&&this.attr("class",this.className);return this},updateTransform:t.prototype.htmlUpdateTransform,setSpanRotation:function(){var a=this.rotation,b=Math.cos(a*f),c=
	Math.sin(a*f);G(this.element,{filter:a?["progid:DXImageTransform.Microsoft.Matrix(M11\x3d",b,", M12\x3d",-c,", M21\x3d",c,", M22\x3d",b,", sizingMethod\x3d'auto expand')"].join(""):"none"})},getSpanCorrection:function(a,b,c,h,m){var e=h?Math.cos(h*f):1,x=h?Math.sin(h*f):0,d=p(this.elemHeight,this.element.offsetHeight),t;this.xCorr=0>e&&-a;this.yCorr=0>x&&-d;t=0>e*x;this.xCorr+=x*b*(t?1-c:c);this.yCorr-=e*b*(h?t?c:1-c:1);m&&"left"!==m&&(this.xCorr-=a*c*(0>e?-1:1),h&&(this.yCorr-=d*c*(0>x?-1:1)),G(this.element,
	{textAlign:m}))},pathToVML:function(a){for(var e=a.length,b=[];e--;)n(a[e])?b[e]=Math.round(10*a[e])-5:"Z"===a[e]?b[e]="x":(b[e]=a[e],!a.isArc||"wa"!==a[e]&&"at"!==a[e]||(b[e+5]===b[e+7]&&(b[e+7]+=a[e+7]>a[e+5]?1:-1),b[e+6]===b[e+8]&&(b[e+8]+=a[e+8]>a[e+6]?1:-1)));return b.join(" ")||"x"},clip:function(a){var e=this,b;a?(b=a.members,u(b,e),b.push(e),e.destroyClip=function(){u(b,e)},a=a.getCSS(e)):(e.destroyClip&&e.destroyClip(),a={clip:e.docMode8?"inherit":"rect(auto)"});return e.css(a)},css:t.prototype.htmlCss,
	safeRemoveChild:function(a){a.parentNode&&l(a)},destroy:function(){this.destroyClip&&this.destroyClip();return t.prototype.destroy.apply(this)},on:function(a,b){this.element["on"+a]=function(){var a=w.event;a.target=a.srcElement;b(a)};return this},cutOffPath:function(a,b){var e;a=a.split(/[ ,]/);e=a.length;if(9===e||11===e)a[e-4]=a[e-2]=h(a[e-2])-10*b;return a.join(" ")},shadow:function(a,b,c){var e=[],m,d=this.element,t=this.renderer,x,n=d.style,g,F=d.path,k,C,w,f;F&&"string"!==typeof F.value&&(F=
	"x");C=F;if(a){w=p(a.width,3);f=(a.opacity||.15)/w;for(m=1;3>=m;m++)k=2*w+1-2*m,c&&(C=this.cutOffPath(F.value,k+.5)),g=['\x3cshape isShadow\x3d"true" strokeweight\x3d"',k,'" filled\x3d"false" path\x3d"',C,'" coordsize\x3d"10 10" style\x3d"',d.style.cssText,'" /\x3e'],x=H(t.prepVML(g),null,{left:h(n.left)+p(a.offsetX,1),top:h(n.top)+p(a.offsetY,1)}),c&&(x.cutOff=k+1),g=['\x3cstroke color\x3d"',a.color||"#000000",'" opacity\x3d"',f*m,'"/\x3e'],H(t.prepVML(g),null,null,x),b?b.element.appendChild(x):
	d.parentNode.insertBefore(x,d),e.push(x);this.shadows=e}return this},updateShadows:A,setAttr:function(a,b){this.docMode8?this.element[a]=b:this.element.setAttribute(a,b)},classSetter:function(a){(this.added?this.element:this).className=a},dashstyleSetter:function(a,b,c){(c.getElementsByTagName("stroke")[0]||H(this.renderer.prepVML(["\x3cstroke/\x3e"]),null,null,c))[b]=a||"solid";this[b]=a},dSetter:function(a,b,c){var e=this.shadows;a=a||[];this.d=a.join&&a.join(" ");c.path=a=this.pathToVML(a);if(e)for(c=
	e.length;c--;)e[c].path=e[c].cutOff?this.cutOffPath(a,e[c].cutOff):a;this.setAttr(b,a)},fillSetter:function(a,b,c){var e=c.nodeName;"SPAN"===e?c.style.color=a:"IMG"!==e&&(c.filled="none"!==a,this.setAttr("fillcolor",this.renderer.color(a,c,b,this)))},"fill-opacitySetter":function(a,b,c){H(this.renderer.prepVML(["\x3c",b.split("-")[0],' opacity\x3d"',a,'"/\x3e']),null,null,c)},opacitySetter:A,rotationSetter:function(a,b,c){c=c.style;this[b]=c[b]=a;c.left=-Math.round(Math.sin(a*f)+1)+"px";c.top=Math.round(Math.cos(a*
	f))+"px"},strokeSetter:function(a,b,c){this.setAttr("strokecolor",this.renderer.color(a,c,b,this))},"stroke-widthSetter":function(a,b,c){c.stroked=!!a;this[b]=a;n(a)&&(a+="px");this.setAttr("strokeweight",a)},titleSetter:function(a,b){this.setAttr(b,a)},visibilitySetter:function(a,b,c){"inherit"===a&&(a="visible");this.shadows&&k(this.shadows,function(e){e.style[b]=a});"DIV"===c.nodeName&&(a="hidden"===a?"-999em":0,this.docMode8||(c.style[b]=a?"visible":"hidden"),b="top");c.style[b]=a},xSetter:function(a,
	b,c){this[b]=a;"x"===b?b="left":"y"===b&&(b="top");this.updateClipping?(this[b]=a,this.updateClipping()):c.style[b]=a},zIndexSetter:function(a,b,c){c.style[b]=a}},A["stroke-opacitySetter"]=A["fill-opacitySetter"],a.VMLElement=A=B(t,A),A.prototype.ySetter=A.prototype.widthSetter=A.prototype.heightSetter=A.prototype.xSetter,A={Element:A,isIE8:-1<w.navigator.userAgent.indexOf("MSIE 8.0"),init:function(a,b,c){var e,m;this.alignedObjects=[];e=this.createElement("div").css({position:"relative"});m=e.element;
	a.appendChild(e.element);this.isVML=!0;this.box=m;this.boxWrapper=e;this.gradients={};this.cache={};this.cacheKeys=[];this.imgCount=0;this.setSize(b,c,!1);if(!q.namespaces.hcv){q.namespaces.add("hcv","urn:schemas-microsoft-com:vml");try{q.createStyleSheet().cssText="hcv\\:fill, hcv\\:path, hcv\\:shape, hcv\\:stroke{ behavior:url(#default#VML); display: inline-block; } "}catch(y){q.styleSheets[0].cssText+="hcv\\:fill, hcv\\:path, hcv\\:shape, hcv\\:stroke{ behavior:url(#default#VML); display: inline-block; } "}}},
	isHidden:function(){return!this.box.offsetWidth},clipRect:function(a,b,c,h){var e=this.createElement(),p=z(a);return d(e,{members:[],count:0,left:(p?a.x:a)+1,top:(p?a.y:b)+1,width:(p?a.width:c)-1,height:(p?a.height:h)-1,getCSS:function(a){var b=a.element,c=b.nodeName,g=a.inverted,e=this.top-("shape"===c?b.offsetTop:0),m=this.left,b=m+this.width,h=e+this.height,e={clip:"rect("+Math.round(g?m:e)+"px,"+Math.round(g?h:b)+"px,"+Math.round(g?b:h)+"px,"+Math.round(g?e:m)+"px)"};!g&&a.docMode8&&"DIV"===c&&
	d(e,{width:b+"px",height:h+"px"});return e},updateClipping:function(){k(e.members,function(a){a.element&&a.css(e.getCSS(a))})}})},color:function(b,c,h,d){var e=this,p,t=/^rgba/,n,x,g="none";b&&b.linearGradient?x="gradient":b&&b.radialGradient&&(x="pattern");if(x){var F,w,f=b.linearGradient||b.radialGradient,C,u,v,D,q,l="";b=b.stops;var z,E=[],r=function(){n=['\x3cfill colors\x3d"'+E.join(",")+'" opacity\x3d"',v,'" o:opacity2\x3d"',u,'" type\x3d"',x,'" ',l,'focus\x3d"100%" method\x3d"any" /\x3e'];
	H(e.prepVML(n),null,null,c)};C=b[0];z=b[b.length-1];0<C[0]&&b.unshift([0,C[1]]);1>z[0]&&b.push([1,z[1]]);k(b,function(g,b){t.test(g[1])?(p=a.color(g[1]),F=p.get("rgb"),w=p.get("a")):(F=g[1],w=1);E.push(100*g[0]+"% "+F);b?(v=w,D=F):(u=w,q=F)});if("fill"===h)if("gradient"===x)h=f.x1||f[0]||0,b=f.y1||f[1]||0,C=f.x2||f[2]||0,f=f.y2||f[3]||0,l='angle\x3d"'+(90-180*Math.atan((f-b)/(C-h))/Math.PI)+'"',r();else{var g=f.r,A=2*g,B=2*g,G=f.cx,V=f.cy,L=c.radialReference,T,g=function(){L&&(T=d.getBBox(),G+=(L[0]-
	T.x)/T.width-.5,V+=(L[1]-T.y)/T.height-.5,A*=L[2]/T.width,B*=L[2]/T.height);l='src\x3d"'+a.getOptions().global.VMLRadialGradientURL+'" size\x3d"'+A+","+B+'" origin\x3d"0.5,0.5" position\x3d"'+G+","+V+'" color2\x3d"'+q+'" ';r()};d.added?g():d.onAdd=g;g=D}else g=F}else t.test(b)&&"IMG"!==c.tagName?(p=a.color(b),d[h+"-opacitySetter"](p.get("a"),h,c),g=p.get("rgb")):(g=c.getElementsByTagName(h),g.length&&(g[0].opacity=1,g[0].type="solid"),g=b);return g},prepVML:function(a){var b=this.isIE8;a=a.join("");
	b?(a=a.replace("/\x3e",' xmlns\x3d"urn:schemas-microsoft-com:vml" /\x3e'),a=-1===a.indexOf('style\x3d"')?a.replace("/\x3e",' style\x3d"display:inline-block;behavior:url(#default#VML);" /\x3e'):a.replace('style\x3d"','style\x3d"display:inline-block;behavior:url(#default#VML);')):a=a.replace("\x3c","\x3chcv:");return a},text:D.prototype.html,path:function(a){var b={coordsize:"10 10"};c(a)?b.d=a:z(a)&&d(b,a);return this.createElement("shape").attr(b)},circle:function(a,b,c){var e=this.symbol("circle");
	z(a)&&(c=a.r,b=a.y,a=a.x);e.isCircle=!0;e.r=c;return e.attr({x:a,y:b})},g:function(a){var b;a&&(b={className:"highcharts-"+a,"class":"highcharts-"+a});return this.createElement("div").attr(b)},image:function(a,b,c,h,m){var e=this.createElement("img").attr({src:a});1<arguments.length&&e.attr({x:b,y:c,width:h,height:m});return e},createElement:function(a){return"rect"===a?this.symbol(a):D.prototype.createElement.call(this,a)},invertChild:function(a,b){var c=this;b=b.style;var e="IMG"===a.tagName&&a.style;
	G(a,{flip:"x",left:h(b.width)-(e?h(e.top):1),top:h(b.height)-(e?h(e.left):1),rotation:-90});k(a.childNodes,function(b){c.invertChild(b,a)})},symbols:{arc:function(a,b,c,h,m){var e=m.start,d=m.end,p=m.r||c||h;c=m.innerR;h=Math.cos(e);var t=Math.sin(e),g=Math.cos(d),F=Math.sin(d);if(0===d-e)return["x"];e=["wa",a-p,b-p,a+p,b+p,a+p*h,b+p*t,a+p*g,b+p*F];m.open&&!c&&e.push("e","M",a,b);e.push("at",a-c,b-c,a+c,b+c,a+c*g,b+c*F,a+c*h,b+c*t,"x","e");e.isArc=!0;return e},circle:function(a,b,c,h,m){m&&r(m.r)&&
	(c=h=2*m.r);m&&m.isCircle&&(a-=c/2,b-=h/2);return["wa",a,b,a+c,b+h,a+c,b+h/2,a+c,b+h/2,"e"]},rect:function(a,b,c,h,m){return D.prototype.symbols[r(m)&&m.r?"callout":"square"].call(0,a,b,c,h,m)}}},a.VMLRenderer=B=function(){this.init.apply(this,arguments)},B.prototype=b(D.prototype,A),a.Renderer=B);D.prototype.measureSpanWidth=function(a,b){var c=q.createElement("span");a=q.createTextNode(a);c.appendChild(a);G(c,b);this.box.appendChild(c);b=c.offsetWidth;l(c);return b}})(L);(function(a){function B(){var k=
	a.defaultOptions.global,f=q.moment;if(k.timezone){if(f)return function(a){return-f.tz(a,k.timezone).utcOffset()};a.error(25)}return k.useUTC&&k.getTimezoneOffset}function A(){var k=a.defaultOptions.global,f,d=k.useUTC,c=d?"getUTC":"get",n=d?"setUTC":"set";a.Date=f=k.Date||q.Date;f.hcTimezoneOffset=d&&k.timezoneOffset;f.hcGetTimezoneOffset=B();f.hcMakeTime=function(a,b,c,h,t,n){var p;d?(p=f.UTC.apply(0,arguments),p+=r(p)):p=(new f(a,b,l(c,1),l(h,0),l(t,0),l(n,0))).getTime();return p};G("Minutes Hours Day Date Month FullYear".split(" "),
	function(a){f["hcGet"+a]=c+a});G("Milliseconds Seconds Minutes Hours Date Month FullYear".split(" "),function(a){f["hcSet"+a]=n+a})}var H=a.color,G=a.each,r=a.getTZOffset,f=a.merge,l=a.pick,q=a.win;a.defaultOptions={colors:"#7cb5ec #434348 #90ed7d #f7a35c #8085e9 #f15c80 #e4d354 #2b908f #f45b5b #91e8e1".split(" "),symbols:["circle","diamond","square","triangle","triangle-down"],lang:{loading:"Loading...",months:"January February March April May June July August September October November December".split(" "),
	shortMonths:"Jan Feb Mar Apr May Jun Jul Aug Sep Oct Nov Dec".split(" "),weekdays:"Sunday Monday Tuesday Wednesday Thursday Friday Saturday".split(" "),decimalPoint:".",numericSymbols:"kMGTPE".split(""),resetZoom:"Reset zoom",resetZoomTitle:"Reset zoom level 1:1",thousandsSep:" "},global:{useUTC:!0,VMLRadialGradientURL:"http://code.highcharts.com/5.0.10/gfx/vml-radial-gradient.png"},chart:{borderRadius:0,defaultSeriesType:"line",ignoreHiddenSeries:!0,spacing:[10,10,15,10],resetZoomButton:{theme:{zIndex:20},
	position:{align:"right",x:-10,y:10}},width:null,height:null,borderColor:"#335cad",backgroundColor:"#ffffff",plotBorderColor:"#cccccc"},title:{text:"Chart title",align:"center",margin:15,widthAdjust:-44},subtitle:{text:"",align:"center",widthAdjust:-44},plotOptions:{},labels:{style:{position:"absolute",color:"#333333"}},legend:{enabled:!0,align:"center",layout:"horizontal",labelFormatter:function(){return this.name},borderColor:"#999999",borderRadius:0,navigation:{activeColor:"#003399",inactiveColor:"#cccccc"},
	itemStyle:{color:"#333333",fontSize:"12px",fontWeight:"bold"},itemHoverStyle:{color:"#000000"},itemHiddenStyle:{color:"#cccccc"},shadow:!1,itemCheckboxStyle:{position:"absolute",width:"13px",height:"13px"},squareSymbol:!0,symbolPadding:5,verticalAlign:"bottom",x:0,y:0,title:{style:{fontWeight:"bold"}}},loading:{labelStyle:{fontWeight:"bold",position:"relative",top:"45%"},style:{position:"absolute",backgroundColor:"#ffffff",opacity:.5,textAlign:"center"}},tooltip:{enabled:!0,animation:a.svg,borderRadius:3,
	dateTimeLabelFormats:{millisecond:"%A, %b %e, %H:%M:%S.%L",second:"%A, %b %e, %H:%M:%S",minute:"%A, %b %e, %H:%M",hour:"%A, %b %e, %H:%M",day:"%A, %b %e, %Y",week:"Week from %A, %b %e, %Y",month:"%B %Y",year:"%Y"},footerFormat:"",padding:8,snap:a.isTouchDevice?25:10,backgroundColor:H("#f7f7f7").setOpacity(.85).get(),borderWidth:1,headerFormat:'\x3cspan style\x3d"font-size: 10px"\x3e{point.key}\x3c/span\x3e\x3cbr/\x3e',pointFormat:'\x3cspan style\x3d"color:{point.color}"\x3e\u25cf\x3c/span\x3e {series.name}: \x3cb\x3e{point.y}\x3c/b\x3e\x3cbr/\x3e',
	shadow:!0,style:{color:"#333333",cursor:"default",fontSize:"12px",pointerEvents:"none",whiteSpace:"nowrap"}},credits:{enabled:!0,href:"http://www.highcharts.com",position:{align:"right",x:-10,verticalAlign:"bottom",y:-5},style:{cursor:"pointer",color:"#999999",fontSize:"9px"},text:"Highcharts.com"}};a.setOptions=function(k){a.defaultOptions=f(!0,a.defaultOptions,k);A();return a.defaultOptions};a.getOptions=function(){return a.defaultOptions};a.defaultPlotOptions=a.defaultOptions.plotOptions;A()})(L);
	(function(a){var B=a.arrayMax,A=a.arrayMin,H=a.defined,G=a.destroyObjectProperties,r=a.each,f=a.erase,l=a.merge,q=a.pick;a.PlotLineOrBand=function(a,f){this.axis=a;f&&(this.options=f,this.id=f.id)};a.PlotLineOrBand.prototype={render:function(){var a=this,f=a.axis,d=f.horiz,c=a.options,n=c.label,z=a.label,b=c.to,p=c.from,h=c.value,t=H(p)&&H(b),D=H(h),w=a.svgElem,e=!w,x=[],C,E=c.color,m=q(c.zIndex,0),y=c.events,x={"class":"highcharts-plot-"+(t?"band ":"line ")+(c.className||"")},I={},r=f.chart.renderer,
	J=t?"bands":"lines",g=f.log2lin;f.isLog&&(p=g(p),b=g(b),h=g(h));D?(x={stroke:E,"stroke-width":c.width},c.dashStyle&&(x.dashstyle=c.dashStyle)):t&&(E&&(x.fill=E),c.borderWidth&&(x.stroke=c.borderColor,x["stroke-width"]=c.borderWidth));I.zIndex=m;J+="-"+m;(E=f.plotLinesAndBandsGroups[J])||(f.plotLinesAndBandsGroups[J]=E=r.g("plot-"+J).attr(I).add());e&&(a.svgElem=w=r.path().attr(x).add(E));if(D)x=f.getPlotLinePath(h,w.strokeWidth());else if(t)x=f.getPlotBandPath(p,b,c);else return;if(e&&x&&x.length){if(w.attr({d:x}),
	y)for(C in c=function(g){w.on(g,function(b){y[g].apply(a,[b])})},y)c(C)}else w&&(x?(w.show(),w.animate({d:x})):(w.hide(),z&&(a.label=z=z.destroy())));n&&H(n.text)&&x&&x.length&&0<f.width&&0<f.height&&!x.flat?(n=l({align:d&&t&&"center",x:d?!t&&4:10,verticalAlign:!d&&t&&"middle",y:d?t?16:10:t?6:-4,rotation:d&&!t&&90},n),this.renderLabel(n,x,t,m)):z&&z.hide();return a},renderLabel:function(a,f,d,c){var n=this.label,k=this.axis.chart.renderer;n||(n={align:a.textAlign||a.align,rotation:a.rotation,"class":"highcharts-plot-"+
	(d?"band":"line")+"-label "+(a.className||"")},n.zIndex=c,this.label=n=k.text(a.text,0,0,a.useHTML).attr(n).add(),n.css(a.style));c=[f[1],f[4],d?f[6]:f[1]];f=[f[2],f[5],d?f[7]:f[2]];d=A(c);k=A(f);n.align(a,!1,{x:d,y:k,width:B(c)-d,height:B(f)-k});n.show()},destroy:function(){f(this.axis.plotLinesAndBands,this);delete this.axis;G(this)}};a.AxisPlotLineOrBandExtension={getPlotBandPath:function(a,f){var d=this.getPlotLinePath(f,null,null,!0),c=this.getPlotLinePath(a,null,null,!0),n=this.horiz,k=1;a=
	a<this.min&&f<this.min||a>this.max&&f>this.max;c&&d?(a&&(c.flat=c.toString()===d.toString(),k=0),c.push(n&&d[4]===c[4]?d[4]+k:d[4],n||d[5]!==c[5]?d[5]:d[5]+k,n&&d[1]===c[1]?d[1]+k:d[1],n||d[2]!==c[2]?d[2]:d[2]+k)):c=null;return c},addPlotBand:function(a){return this.addPlotBandOrLine(a,"plotBands")},addPlotLine:function(a){return this.addPlotBandOrLine(a,"plotLines")},addPlotBandOrLine:function(f,q){var d=(new a.PlotLineOrBand(this,f)).render(),c=this.userOptions;d&&(q&&(c[q]=c[q]||[],c[q].push(f)),
	this.plotLinesAndBands.push(d));return d},removePlotBandOrLine:function(a){for(var k=this.plotLinesAndBands,d=this.options,c=this.userOptions,n=k.length;n--;)k[n].id===a&&k[n].destroy();r([d.plotLines||[],c.plotLines||[],d.plotBands||[],c.plotBands||[]],function(c){for(n=c.length;n--;)c[n].id===a&&f(c,c[n])})}}})(L);(function(a){var B=a.correctFloat,A=a.defined,H=a.destroyObjectProperties,G=a.isNumber,r=a.merge,f=a.pick,l=a.deg2rad;a.Tick=function(a,f,l,d){this.axis=a;this.pos=f;this.type=l||"";this.isNew=
	!0;l||d||this.addLabel()};a.Tick.prototype={addLabel:function(){var a=this.axis,k=a.options,l=a.chart,d=a.categories,c=a.names,n=this.pos,z=k.labels,b=a.tickPositions,p=n===b[0],h=n===b[b.length-1],c=d?f(d[n],c[n],n):n,d=this.label,b=b.info,t;a.isDatetimeAxis&&b&&(t=k.dateTimeLabelFormats[b.higherRanks[n]||b.unitName]);this.isFirst=p;this.isLast=h;k=a.labelFormatter.call({axis:a,chart:l,isFirst:p,isLast:h,dateTimeLabelFormat:t,value:a.isLog?B(a.lin2log(c)):c});A(d)?d&&d.attr({text:k}):(this.labelLength=
	(this.label=d=A(k)&&z.enabled?l.renderer.text(k,0,0,z.useHTML).css(r(z.style)).add(a.labelGroup):null)&&d.getBBox().width,this.rotation=0)},getLabelSize:function(){return this.label?this.label.getBBox()[this.axis.horiz?"height":"width"]:0},handleOverflow:function(a){var k=this.axis,q=a.x,d=k.chart.chartWidth,c=k.chart.spacing,n=f(k.labelLeft,Math.min(k.pos,c[3])),c=f(k.labelRight,Math.max(k.pos+k.len,d-c[1])),z=this.label,b=this.rotation,p={left:0,center:.5,right:1}[k.labelAlign],h=z.getBBox().width,
	t=k.getSlotWidth(),D=t,w=1,e,x={};if(b)0>b&&q-p*h<n?e=Math.round(q/Math.cos(b*l)-n):0<b&&q+p*h>c&&(e=Math.round((d-q)/Math.cos(b*l)));else if(d=q+(1-p)*h,q-p*h<n?D=a.x+D*(1-p)-n:d>c&&(D=c-a.x+D*p,w=-1),D=Math.min(t,D),D<t&&"center"===k.labelAlign&&(a.x+=w*(t-D-p*(t-Math.min(h,D)))),h>D||k.autoRotation&&(z.styles||{}).width)e=D;e&&(x.width=e,(k.options.labels.style||{}).textOverflow||(x.textOverflow="ellipsis"),z.css(x))},getPosition:function(a,f,l,d){var c=this.axis,n=c.chart,k=d&&n.oldChartHeight||
	n.chartHeight;return{x:a?c.translate(f+l,null,null,d)+c.transB:c.left+c.offset+(c.opposite?(d&&n.oldChartWidth||n.chartWidth)-c.right-c.left:0),y:a?k-c.bottom+c.offset-(c.opposite?c.height:0):k-c.translate(f+l,null,null,d)-c.transB}},getLabelPosition:function(a,f,u,d,c,n,z,b){var p=this.axis,h=p.transA,t=p.reversed,k=p.staggerLines,w=p.tickRotCorr||{x:0,y:0},e=c.y;A(e)||(e=0===p.side?u.rotation?-8:-u.getBBox().height:2===p.side?w.y+8:Math.cos(u.rotation*l)*(w.y-u.getBBox(!1,0).height/2));a=a+c.x+
	w.x-(n&&d?n*h*(t?-1:1):0);f=f+e-(n&&!d?n*h*(t?1:-1):0);k&&(u=z/(b||1)%k,p.opposite&&(u=k-u-1),f+=p.labelOffset/k*u);return{x:a,y:Math.round(f)}},getMarkPath:function(a,f,l,d,c,n){return n.crispLine(["M",a,f,"L",a+(c?0:-l),f+(c?l:0)],d)},renderGridLine:function(a,f,l){var d=this.axis,c=d.options,n=this.gridLine,k={},b=this.pos,p=this.type,h=d.tickmarkOffset,t=d.chart.renderer,D=p?p+"Grid":"grid",w=c[D+"LineWidth"],e=c[D+"LineColor"],c=c[D+"LineDashStyle"];n||(k.stroke=e,k["stroke-width"]=w,c&&(k.dashstyle=
	c),p||(k.zIndex=1),a&&(k.opacity=0),this.gridLine=n=t.path().attr(k).addClass("highcharts-"+(p?p+"-":"")+"grid-line").add(d.gridGroup));if(!a&&n&&(a=d.getPlotLinePath(b+h,n.strokeWidth()*l,a,!0)))n[this.isNew?"attr":"animate"]({d:a,opacity:f})},renderMark:function(a,k,l){var d=this.axis,c=d.options,n=d.chart.renderer,q=this.type,b=q?q+"Tick":"tick",p=d.tickSize(b),h=this.mark,t=!h,D=a.x;a=a.y;var w=f(c[b+"Width"],!q&&d.isXAxis?1:0),c=c[b+"Color"];p&&(d.opposite&&(p[0]=-p[0]),t&&(this.mark=h=n.path().addClass("highcharts-"+
	(q?q+"-":"")+"tick").add(d.axisGroup),h.attr({stroke:c,"stroke-width":w})),h[t?"attr":"animate"]({d:this.getMarkPath(D,a,p[0],h.strokeWidth()*l,d.horiz,n),opacity:k}))},renderLabel:function(a,k,l,d){var c=this.axis,n=c.horiz,q=c.options,b=this.label,p=q.labels,h=p.step,t=c.tickmarkOffset,D=!0,w=a.x;a=a.y;b&&G(w)&&(b.xy=a=this.getLabelPosition(w,a,b,n,p,t,d,h),this.isFirst&&!this.isLast&&!f(q.showFirstLabel,1)||this.isLast&&!this.isFirst&&!f(q.showLastLabel,1)?D=!1:!n||c.isRadial||p.step||p.rotation||
	k||0===l||this.handleOverflow(a),h&&d%h&&(D=!1),D&&G(a.y)?(a.opacity=l,b[this.isNew?"attr":"animate"](a)):b.attr("y",-9999),this.isNew=!1)},render:function(a,k,l){var d=this.axis,c=d.horiz,n=this.getPosition(c,this.pos,d.tickmarkOffset,k),q=n.x,b=n.y,d=c&&q===d.pos+d.len||!c&&b===d.pos?-1:1;l=f(l,1);this.isActive=!0;this.renderGridLine(k,l,d);this.renderMark(n,l,d);this.renderLabel(n,k,l,a)},destroy:function(){H(this,this.axis)}}})(L);(function(a){var B=a.addEvent,A=a.animObject,H=a.arrayMax,G=a.arrayMin,
	r=a.AxisPlotLineOrBandExtension,f=a.color,l=a.correctFloat,q=a.defaultOptions,k=a.defined,u=a.deg2rad,d=a.destroyObjectProperties,c=a.each,n=a.extend,z=a.fireEvent,b=a.format,p=a.getMagnitude,h=a.grep,t=a.inArray,D=a.isArray,w=a.isNumber,e=a.isString,x=a.merge,C=a.normalizeTickInterval,E=a.pick,m=a.PlotLineOrBand,y=a.removeEvent,I=a.splat,K=a.syncTimeout,J=a.Tick;a.Axis=function(){this.init.apply(this,arguments)};a.Axis.prototype={defaultOptions:{dateTimeLabelFormats:{millisecond:"%H:%M:%S.%L",second:"%H:%M:%S",
	minute:"%H:%M",hour:"%H:%M",day:"%e. %b",week:"%e. %b",month:"%b '%y",year:"%Y"},endOnTick:!1,labels:{enabled:!0,style:{color:"#666666",cursor:"default",fontSize:"11px"},x:0},minPadding:.01,maxPadding:.01,minorTickLength:2,minorTickPosition:"outside",startOfWeek:1,startOnTick:!1,tickLength:10,tickmarkPlacement:"between",tickPixelInterval:100,tickPosition:"outside",title:{align:"middle",style:{color:"#666666"}},type:"linear",minorGridLineColor:"#f2f2f2",minorGridLineWidth:1,minorTickColor:"#999999",
	lineColor:"#ccd6eb",lineWidth:1,gridLineColor:"#e6e6e6",tickColor:"#ccd6eb"},defaultYAxisOptions:{endOnTick:!0,tickPixelInterval:72,showLastLabel:!0,labels:{x:-8},maxPadding:.05,minPadding:.05,startOnTick:!0,title:{rotation:270,text:"Values"},stackLabels:{enabled:!1,formatter:function(){return a.numberFormat(this.total,-1)},style:{fontSize:"11px",fontWeight:"bold",color:"#000000",textOutline:"1px contrast"}},gridLineWidth:1,lineWidth:0},defaultLeftAxisOptions:{labels:{x:-15},title:{rotation:270}},
	defaultRightAxisOptions:{labels:{x:15},title:{rotation:90}},defaultBottomAxisOptions:{labels:{autoRotation:[-45],x:0},title:{rotation:0}},defaultTopAxisOptions:{labels:{autoRotation:[-45],x:0},title:{rotation:0}},init:function(a,b){var g=b.isX;this.chart=a;this.horiz=a.inverted?!g:g;this.isXAxis=g;this.coll=this.coll||(g?"xAxis":"yAxis");this.opposite=b.opposite;this.side=b.side||(this.horiz?this.opposite?0:2:this.opposite?1:3);this.setOptions(b);var c=this.options,e=c.type;this.labelFormatter=c.labels.formatter||
	this.defaultLabelFormatter;this.userOptions=b;this.minPixelPadding=0;this.reversed=c.reversed;this.visible=!1!==c.visible;this.zoomEnabled=!1!==c.zoomEnabled;this.hasNames="category"===e||!0===c.categories;this.categories=c.categories||this.hasNames;this.names=this.names||[];this.plotLinesAndBandsGroups={};this.isLog="logarithmic"===e;this.isDatetimeAxis="datetime"===e;this.positiveValuesOnly=this.isLog&&!this.allowNegativeLog;this.isLinked=k(c.linkedTo);this.ticks={};this.labelEdge=[];this.minorTicks=
	{};this.plotLinesAndBands=[];this.alternateBands={};this.len=0;this.minRange=this.userMinRange=c.minRange||c.maxZoom;this.range=c.range;this.offset=c.offset||0;this.stacks={};this.oldStacks={};this.stacksTouched=0;this.min=this.max=null;this.crosshair=E(c.crosshair,I(a.options.tooltip.crosshairs)[g?0:1],!1);var h;b=this.options.events;-1===t(this,a.axes)&&(g?a.axes.splice(a.xAxis.length,0,this):a.axes.push(this),a[this.coll].push(this));this.series=this.series||[];a.inverted&&g&&void 0===this.reversed&&
	(this.reversed=!0);this.removePlotLine=this.removePlotBand=this.removePlotBandOrLine;for(h in b)B(this,h,b[h]);this.lin2log=c.linearToLogConverter||this.lin2log;this.isLog&&(this.val2lin=this.log2lin,this.lin2val=this.lin2log)},setOptions:function(a){this.options=x(this.defaultOptions,"yAxis"===this.coll&&this.defaultYAxisOptions,[this.defaultTopAxisOptions,this.defaultRightAxisOptions,this.defaultBottomAxisOptions,this.defaultLeftAxisOptions][this.side],x(q[this.coll],a))},defaultLabelFormatter:function(){var g=
	this.axis,c=this.value,e=g.categories,h=this.dateTimeLabelFormat,m=q.lang,d=m.numericSymbols,m=m.numericSymbolMagnitude||1E3,v=d&&d.length,p,t=g.options.labels.format,g=g.isLog?Math.abs(c):g.tickInterval;if(t)p=b(t,this);else if(e)p=c;else if(h)p=a.dateFormat(h,c);else if(v&&1E3<=g)for(;v--&&void 0===p;)e=Math.pow(m,v+1),g>=e&&0===10*c%e&&null!==d[v]&&0!==c&&(p=a.numberFormat(c/e,-1)+d[v]);void 0===p&&(p=1E4<=Math.abs(c)?a.numberFormat(c,-1):a.numberFormat(c,-1,void 0,""));return p},getSeriesExtremes:function(){var a=
	this,b=a.chart;a.hasVisibleSeries=!1;a.dataMin=a.dataMax=a.threshold=null;a.softThreshold=!a.isXAxis;a.buildStacks&&a.buildStacks();c(a.series,function(g){if(g.visible||!b.options.chart.ignoreHiddenSeries){var c=g.options,e=c.threshold,m;a.hasVisibleSeries=!0;a.positiveValuesOnly&&0>=e&&(e=null);if(a.isXAxis)c=g.xData,c.length&&(g=G(c),w(g)||g instanceof Date||(c=h(c,function(a){return w(a)}),g=G(c)),a.dataMin=Math.min(E(a.dataMin,c[0]),g),a.dataMax=Math.max(E(a.dataMax,c[0]),H(c)));else if(g.getExtremes(),
	m=g.dataMax,g=g.dataMin,k(g)&&k(m)&&(a.dataMin=Math.min(E(a.dataMin,g),g),a.dataMax=Math.max(E(a.dataMax,m),m)),k(e)&&(a.threshold=e),!c.softThreshold||a.positiveValuesOnly)a.softThreshold=!1}})},translate:function(a,b,c,e,h,m){var g=this.linkedParent||this,F=1,p=0,d=e?g.oldTransA:g.transA;e=e?g.oldMin:g.min;var t=g.minPixelPadding;h=(g.isOrdinal||g.isBroken||g.isLog&&h)&&g.lin2val;d||(d=g.transA);c&&(F*=-1,p=g.len);g.reversed&&(F*=-1,p-=F*(g.sector||g.len));b?(a=(a*F+p-t)/d+e,h&&(a=g.lin2val(a))):
	(h&&(a=g.val2lin(a)),a=F*(a-e)*d+p+F*t+(w(m)?d*m:0));return a},toPixels:function(a,b){return this.translate(a,!1,!this.horiz,null,!0)+(b?0:this.pos)},toValue:function(a,b){return this.translate(a-(b?0:this.pos),!0,!this.horiz,null,!0)},getPlotLinePath:function(a,b,c,e,h){var g=this.chart,m=this.left,F=this.top,p,d,t=c&&g.oldChartHeight||g.chartHeight,f=c&&g.oldChartWidth||g.chartWidth,n;p=this.transB;var y=function(a,b,g){if(a<b||a>g)e?a=Math.min(Math.max(b,a),g):n=!0;return a};h=E(h,this.translate(a,
	null,null,c));a=c=Math.round(h+p);p=d=Math.round(t-h-p);w(h)?this.horiz?(p=F,d=t-this.bottom,a=c=y(a,m,m+this.width)):(a=m,c=f-this.right,p=d=y(p,F,F+this.height)):n=!0;return n&&!e?null:g.renderer.crispLine(["M",a,p,"L",c,d],b||1)},getLinearTickPositions:function(a,b,c){var g,e=l(Math.floor(b/a)*a);c=l(Math.ceil(c/a)*a);var h=[];if(this.single)return[b];for(b=e;b<=c;){h.push(b);b=l(b+a);if(b===g)break;g=b}return h},getMinorTickPositions:function(){var a=this,b=a.options,e=a.tickPositions,h=a.minorTickInterval,
	m=[],p=a.pointRangePadding||0,v=a.min-p,p=a.max+p,d=p-v;if(d&&d/h<a.len/3)if(a.isLog)c(this.paddedTicks,function(b,g,c){g&&m.push.apply(m,a.getLogTickPositions(h,c[g-1],c[g],!0))});else if(a.isDatetimeAxis&&"auto"===b.minorTickInterval)m=m.concat(a.getTimeTicks(a.normalizeTimeTickInterval(h),v,p,b.startOfWeek));else for(b=v+(e[0]-v)%h;b<=p&&b!==m[0];b+=h)m.push(b);0!==m.length&&a.trimTicks(m);return m},adjustForMinRange:function(){var a=this.options,b=this.min,e=this.max,h,m=this.dataMax-this.dataMin>=
	this.minRange,p,v,d,t,f,n;this.isXAxis&&void 0===this.minRange&&!this.isLog&&(k(a.min)||k(a.max)?this.minRange=null:(c(this.series,function(a){t=a.xData;for(v=f=a.xIncrement?1:t.length-1;0<v;v--)if(d=t[v]-t[v-1],void 0===p||d<p)p=d}),this.minRange=Math.min(5*p,this.dataMax-this.dataMin)));e-b<this.minRange&&(n=this.minRange,h=(n-e+b)/2,h=[b-h,E(a.min,b-h)],m&&(h[2]=this.isLog?this.log2lin(this.dataMin):this.dataMin),b=H(h),e=[b+n,E(a.max,b+n)],m&&(e[2]=this.isLog?this.log2lin(this.dataMax):this.dataMax),
	e=G(e),e-b<n&&(h[0]=e-n,h[1]=E(a.min,e-n),b=H(h)));this.min=b;this.max=e},getClosest:function(){var a;this.categories?a=1:c(this.series,function(b){var g=b.closestPointRange,c=b.visible||!b.chart.options.chart.ignoreHiddenSeries;!b.noSharedTooltip&&k(g)&&c&&(a=k(a)?Math.min(a,g):g)});return a},nameToX:function(a){var b=D(this.categories),g=b?this.categories:this.names,c=a.options.x,e;a.series.requireSorting=!1;k(c)||(c=!1===this.options.uniqueNames?a.series.autoIncrement():t(a.name,g));-1===c?b||
	(e=g.length):e=c;void 0!==e&&(this.names[e]=a.name);return e},updateNames:function(){var a=this;0<this.names.length&&(this.names.length=0,this.minRange=void 0,c(this.series||[],function(b){b.xIncrement=null;if(!b.points||b.isDirtyData)b.processData(),b.generatePoints();c(b.points,function(g,c){var e;g.options&&(e=a.nameToX(g),void 0!==e&&e!==g.x&&(g.x=e,b.xData[c]=e))})}))},setAxisTranslation:function(a){var b=this,g=b.max-b.min,h=b.axisPointRange||0,m,p=0,v=0,d=b.linkedParent,t=!!b.categories,f=
	b.transA,n=b.isXAxis;if(n||t||h)m=b.getClosest(),d?(p=d.minPointOffset,v=d.pointRangePadding):c(b.series,function(a){var g=t?1:n?E(a.options.pointRange,m,0):b.axisPointRange||0;a=a.options.pointPlacement;h=Math.max(h,g);b.single||(p=Math.max(p,e(a)?0:g/2),v=Math.max(v,"on"===a?0:g))}),d=b.ordinalSlope&&m?b.ordinalSlope/m:1,b.minPointOffset=p*=d,b.pointRangePadding=v*=d,b.pointRange=Math.min(h,g),n&&(b.closestPointRange=m);a&&(b.oldTransA=f);b.translationSlope=b.transA=f=b.options.staticScale||b.len/
	(g+v||1);b.transB=b.horiz?b.left:b.bottom;b.minPixelPadding=f*p},minFromRange:function(){return this.max-this.range},setTickInterval:function(b){var g=this,e=g.chart,h=g.options,m=g.isLog,d=g.log2lin,v=g.isDatetimeAxis,t=g.isXAxis,f=g.isLinked,n=h.maxPadding,y=h.minPadding,x=h.tickInterval,D=h.tickPixelInterval,I=g.categories,q=g.threshold,u=g.softThreshold,r,K,J,A;v||I||f||this.getTickAmount();J=E(g.userMin,h.min);A=E(g.userMax,h.max);f?(g.linkedParent=e[g.coll][h.linkedTo],e=g.linkedParent.getExtremes(),
	g.min=E(e.min,e.dataMin),g.max=E(e.max,e.dataMax),h.type!==g.linkedParent.options.type&&a.error(11,1)):(!u&&k(q)&&(g.dataMin>=q?(r=q,y=0):g.dataMax<=q&&(K=q,n=0)),g.min=E(J,r,g.dataMin),g.max=E(A,K,g.dataMax));m&&(g.positiveValuesOnly&&!b&&0>=Math.min(g.min,E(g.dataMin,g.min))&&a.error(10,1),g.min=l(d(g.min),15),g.max=l(d(g.max),15));g.range&&k(g.max)&&(g.userMin=g.min=J=Math.max(g.min,g.minFromRange()),g.userMax=A=g.max,g.range=null);z(g,"foundExtremes");g.beforePadding&&g.beforePadding();g.adjustForMinRange();
	!(I||g.axisPointRange||g.usePercentage||f)&&k(g.min)&&k(g.max)&&(d=g.max-g.min)&&(!k(J)&&y&&(g.min-=d*y),!k(A)&&n&&(g.max+=d*n));w(h.softMin)&&(g.min=Math.min(g.min,h.softMin));w(h.softMax)&&(g.max=Math.max(g.max,h.softMax));w(h.floor)&&(g.min=Math.max(g.min,h.floor));w(h.ceiling)&&(g.max=Math.min(g.max,h.ceiling));u&&k(g.dataMin)&&(q=q||0,!k(J)&&g.min<q&&g.dataMin>=q?g.min=q:!k(A)&&g.max>q&&g.dataMax<=q&&(g.max=q));g.tickInterval=g.min===g.max||void 0===g.min||void 0===g.max?1:f&&!x&&D===g.linkedParent.options.tickPixelInterval?
	x=g.linkedParent.tickInterval:E(x,this.tickAmount?(g.max-g.min)/Math.max(this.tickAmount-1,1):void 0,I?1:(g.max-g.min)*D/Math.max(g.len,D));t&&!b&&c(g.series,function(a){a.processData(g.min!==g.oldMin||g.max!==g.oldMax)});g.setAxisTranslation(!0);g.beforeSetTickPositions&&g.beforeSetTickPositions();g.postProcessTickInterval&&(g.tickInterval=g.postProcessTickInterval(g.tickInterval));g.pointRange&&!x&&(g.tickInterval=Math.max(g.pointRange,g.tickInterval));b=E(h.minTickInterval,g.isDatetimeAxis&&g.closestPointRange);
	!x&&g.tickInterval<b&&(g.tickInterval=b);v||m||x||(g.tickInterval=C(g.tickInterval,null,p(g.tickInterval),E(h.allowDecimals,!(.5<g.tickInterval&&5>g.tickInterval&&1E3<g.max&&9999>g.max)),!!this.tickAmount));this.tickAmount||(g.tickInterval=g.unsquish());this.setTickPositions()},setTickPositions:function(){var a=this.options,b,c=a.tickPositions,e=a.tickPositioner,h=a.startOnTick,m=a.endOnTick;this.tickmarkOffset=this.categories&&"between"===a.tickmarkPlacement&&1===this.tickInterval?.5:0;this.minorTickInterval=
	"auto"===a.minorTickInterval&&this.tickInterval?this.tickInterval/5:a.minorTickInterval;this.single=this.min===this.max&&k(this.min)&&!this.tickAmount&&!1!==a.allowDecimals;this.tickPositions=b=c&&c.slice();!b&&(b=this.isDatetimeAxis?this.getTimeTicks(this.normalizeTimeTickInterval(this.tickInterval,a.units),this.min,this.max,a.startOfWeek,this.ordinalPositions,this.closestPointRange,!0):this.isLog?this.getLogTickPositions(this.tickInterval,this.min,this.max):this.getLinearTickPositions(this.tickInterval,
	this.min,this.max),b.length>this.len&&(b=[b[0],b.pop()]),this.tickPositions=b,e&&(e=e.apply(this,[this.min,this.max])))&&(this.tickPositions=b=e);this.paddedTicks=b.slice(0);this.trimTicks(b,h,m);this.isLinked||(this.single&&(this.min-=.5,this.max+=.5),c||e||this.adjustTickAmount())},trimTicks:function(a,b,c){var g=a[0],e=a[a.length-1],h=this.minPointOffset||0;if(!this.isLinked){if(b&&-Infinity!==g)this.min=g;else for(;this.min-h>a[0];)a.shift();if(c)this.max=e;else for(;this.max+h<a[a.length-1];)a.pop();
	0===a.length&&k(g)&&a.push((e+g)/2)}},alignToOthers:function(){var a={},b,e=this.options;!1===this.chart.options.chart.alignTicks||!1===e.alignTicks||this.isLog||c(this.chart[this.coll],function(g){var c=g.options,c=[g.horiz?c.left:c.top,c.width,c.height,c.pane].join();g.series.length&&(a[c]?b=!0:a[c]=1)});return b},getTickAmount:function(){var a=this.options,b=a.tickAmount,c=a.tickPixelInterval;!k(a.tickInterval)&&this.len<c&&!this.isRadial&&!this.isLog&&a.startOnTick&&a.endOnTick&&(b=2);!b&&this.alignToOthers()&&
	(b=Math.ceil(this.len/c)+1);4>b&&(this.finalTickAmt=b,b=5);this.tickAmount=b},adjustTickAmount:function(){var a=this.tickInterval,b=this.tickPositions,c=this.tickAmount,e=this.finalTickAmt,h=b&&b.length;if(h<c){for(;b.length<c;)b.push(l(b[b.length-1]+a));this.transA*=(h-1)/(c-1);this.max=b[b.length-1]}else h>c&&(this.tickInterval*=2,this.setTickPositions());if(k(e)){for(a=c=b.length;a--;)(3===e&&1===a%2||2>=e&&0<a&&a<c-1)&&b.splice(a,1);this.finalTickAmt=void 0}},setScale:function(){var a,b;this.oldMin=
	this.min;this.oldMax=this.max;this.oldAxisLength=this.len;this.setAxisSize();b=this.len!==this.oldAxisLength;c(this.series,function(b){if(b.isDirtyData||b.isDirty||b.xAxis.isDirty)a=!0});b||a||this.isLinked||this.forceRedraw||this.userMin!==this.oldUserMin||this.userMax!==this.oldUserMax||this.alignToOthers()?(this.resetStacks&&this.resetStacks(),this.forceRedraw=!1,this.getSeriesExtremes(),this.setTickInterval(),this.oldUserMin=this.userMin,this.oldUserMax=this.userMax,this.isDirty||(this.isDirty=
	b||this.min!==this.oldMin||this.max!==this.oldMax)):this.cleanStacks&&this.cleanStacks()},setExtremes:function(a,b,e,h,m){var g=this,p=g.chart;e=E(e,!0);c(g.series,function(a){delete a.kdTree});m=n(m,{min:a,max:b});z(g,"setExtremes",m,function(){g.userMin=a;g.userMax=b;g.eventArgs=m;e&&p.redraw(h)})},zoom:function(a,b){var g=this.dataMin,c=this.dataMax,e=this.options,h=Math.min(g,E(e.min,g)),e=Math.max(c,E(e.max,c));if(a!==this.min||b!==this.max)this.allowZoomOutside||(k(g)&&(a<h&&(a=h),a>e&&(a=e)),
	k(c)&&(b<h&&(b=h),b>e&&(b=e))),this.displayBtn=void 0!==a||void 0!==b,this.setExtremes(a,b,!1,void 0,{trigger:"zoom"});return!0},setAxisSize:function(){var a=this.chart,b=this.options,c=b.offsets||[0,0,0,0],e=this.horiz,h=E(b.width,a.plotWidth-c[3]+c[1]),m=E(b.height,a.plotHeight-c[0]+c[2]),p=E(b.top,a.plotTop+c[0]),b=E(b.left,a.plotLeft+c[3]),c=/%$/;c.test(m)&&(m=Math.round(parseFloat(m)/100*a.plotHeight));c.test(p)&&(p=Math.round(parseFloat(p)/100*a.plotHeight+a.plotTop));this.left=b;this.top=p;
	this.width=h;this.height=m;this.bottom=a.chartHeight-m-p;this.right=a.chartWidth-h-b;this.len=Math.max(e?h:m,0);this.pos=e?b:p},getExtremes:function(){var a=this.isLog,b=this.lin2log;return{min:a?l(b(this.min)):this.min,max:a?l(b(this.max)):this.max,dataMin:this.dataMin,dataMax:this.dataMax,userMin:this.userMin,userMax:this.userMax}},getThreshold:function(a){var b=this.isLog,g=this.lin2log,c=b?g(this.min):this.min,b=b?g(this.max):this.max;null===a?a=c:c>a?a=c:b<a&&(a=b);return this.translate(a,0,
	1,0,1)},autoLabelAlign:function(a){a=(E(a,0)-90*this.side+720)%360;return 15<a&&165>a?"right":195<a&&345>a?"left":"center"},tickSize:function(a){var b=this.options,g=b[a+"Length"],c=E(b[a+"Width"],"tick"===a&&this.isXAxis?1:0);if(c&&g)return"inside"===b[a+"Position"]&&(g=-g),[g,c]},labelMetrics:function(){return this.chart.renderer.fontMetrics(this.options.labels.style&&this.options.labels.style.fontSize,this.ticks[0]&&this.ticks[0].label)},unsquish:function(){var a=this.options.labels,b=this.horiz,
	e=this.tickInterval,h=e,m=this.len/(((this.categories?1:0)+this.max-this.min)/e),p,d=a.rotation,t=this.labelMetrics(),f,n=Number.MAX_VALUE,y,w=function(a){a/=m||1;a=1<a?Math.ceil(a):1;return a*e};b?(y=!a.staggerLines&&!a.step&&(k(d)?[d]:m<E(a.autoRotationLimit,80)&&a.autoRotation))&&c(y,function(a){var b;if(a===d||a&&-90<=a&&90>=a)f=w(Math.abs(t.h/Math.sin(u*a))),b=f+Math.abs(a/360),b<n&&(n=b,p=a,h=f)}):a.step||(h=w(t.h));this.autoRotation=y;this.labelRotation=E(p,d);return h},getSlotWidth:function(){var a=
	this.chart,b=this.horiz,c=this.options.labels,e=Math.max(this.tickPositions.length-(this.categories?0:1),1),h=a.margin[3];return b&&2>(c.step||0)&&!c.rotation&&(this.staggerLines||1)*this.len/e||!b&&(h&&h-a.spacing[3]||.33*a.chartWidth)},renderUnsquish:function(){var a=this.chart,b=a.renderer,h=this.tickPositions,m=this.ticks,p=this.options.labels,d=this.horiz,v=this.getSlotWidth(),t=Math.max(1,Math.round(v-2*(p.padding||5))),f={},n=this.labelMetrics(),y=p.style&&p.style.textOverflow,k,w=0,D,l;e(p.rotation)||
	(f.rotation=p.rotation||0);c(h,function(a){(a=m[a])&&a.labelLength>w&&(w=a.labelLength)});this.maxLabelLength=w;if(this.autoRotation)w>t&&w>n.h?f.rotation=this.labelRotation:this.labelRotation=0;else if(v&&(k={width:t+"px"},!y))for(k.textOverflow="clip",D=h.length;!d&&D--;)if(l=h[D],t=m[l].label)t.styles&&"ellipsis"===t.styles.textOverflow?t.css({textOverflow:"clip"}):m[l].labelLength>v&&t.css({width:v+"px"}),t.getBBox().height>this.len/h.length-(n.h-n.f)&&(t.specCss={textOverflow:"ellipsis"});f.rotation&&
	(k={width:(w>.5*a.chartHeight?.33*a.chartHeight:a.chartHeight)+"px"},y||(k.textOverflow="ellipsis"));if(this.labelAlign=p.align||this.autoLabelAlign(this.labelRotation))f.align=this.labelAlign;c(h,function(a){var b=(a=m[a])&&a.label;b&&(b.attr(f),k&&b.css(x(k,b.specCss)),delete b.specCss,a.rotation=f.rotation)});this.tickRotCorr=b.rotCorr(n.b,this.labelRotation||0,0!==this.side)},hasData:function(){return this.hasVisibleSeries||k(this.min)&&k(this.max)&&!!this.tickPositions},addTitle:function(a){var b=
	this.chart.renderer,c=this.horiz,g=this.opposite,e=this.options.title,h;this.axisTitle||((h=e.textAlign)||(h=(c?{low:"left",middle:"center",high:"right"}:{low:g?"right":"left",middle:"center",high:g?"left":"right"})[e.align]),this.axisTitle=b.text(e.text,0,0,e.useHTML).attr({zIndex:7,rotation:e.rotation||0,align:h}).addClass("highcharts-axis-title").css(e.style).add(this.axisGroup),this.axisTitle.isNew=!0);this.axisTitle[a?"show":"hide"](!0)},generateTick:function(a){var b=this.ticks;b[a]?b[a].addLabel():
	b[a]=new J(this,a)},getOffset:function(){var a=this,b=a.chart,e=b.renderer,h=a.options,m=a.tickPositions,p=a.ticks,d=a.horiz,t=a.side,f=b.inverted?[1,0,3,2][t]:t,n,y,w=0,x,D=0,l=h.title,C=h.labels,q=0,I=b.axisOffset,b=b.clipOffset,u=[-1,1,1,-1][t],z,r=h.className,K=a.axisParent,J=this.tickSize("tick");n=a.hasData();a.showAxis=y=n||E(h.showEmpty,!0);a.staggerLines=a.horiz&&C.staggerLines;a.axisGroup||(a.gridGroup=e.g("grid").attr({zIndex:h.gridZIndex||1}).addClass("highcharts-"+this.coll.toLowerCase()+
	"-grid "+(r||"")).add(K),a.axisGroup=e.g("axis").attr({zIndex:h.zIndex||2}).addClass("highcharts-"+this.coll.toLowerCase()+" "+(r||"")).add(K),a.labelGroup=e.g("axis-labels").attr({zIndex:C.zIndex||7}).addClass("highcharts-"+a.coll.toLowerCase()+"-labels "+(r||"")).add(K));if(n||a.isLinked)c(m,function(b,c){a.generateTick(b,c)}),a.renderUnsquish(),!1===C.reserveSpace||0!==t&&2!==t&&{1:"left",3:"right"}[t]!==a.labelAlign&&"center"!==a.labelAlign||c(m,function(a){q=Math.max(p[a].getLabelSize(),q)}),
	a.staggerLines&&(q*=a.staggerLines,a.labelOffset=q*(a.opposite?-1:1));else for(z in p)p[z].destroy(),delete p[z];l&&l.text&&!1!==l.enabled&&(a.addTitle(y),y&&(w=a.axisTitle.getBBox()[d?"height":"width"],x=l.offset,D=k(x)?0:E(l.margin,d?5:10)));a.renderLine();a.offset=u*E(h.offset,I[t]);a.tickRotCorr=a.tickRotCorr||{x:0,y:0};e=0===t?-a.labelMetrics().h:2===t?a.tickRotCorr.y:0;D=Math.abs(q)+D;q&&(D=D-e+u*(d?E(C.y,a.tickRotCorr.y+8*u):C.x));a.axisTitleMargin=E(x,D);I[t]=Math.max(I[t],a.axisTitleMargin+
	w+u*a.offset,D,n&&m.length&&J?J[0]+u*a.offset:0);h=h.offset?0:2*Math.floor(a.axisLine.strokeWidth()/2);b[f]=Math.max(b[f],h)},getLinePath:function(a){var b=this.chart,c=this.opposite,g=this.offset,e=this.horiz,h=this.left+(c?this.width:0)+g,g=b.chartHeight-this.bottom-(c?this.height:0)+g;c&&(a*=-1);return b.renderer.crispLine(["M",e?this.left:h,e?g:this.top,"L",e?b.chartWidth-this.right:h,e?g:b.chartHeight-this.bottom],a)},renderLine:function(){this.axisLine||(this.axisLine=this.chart.renderer.path().addClass("highcharts-axis-line").add(this.axisGroup),
	this.axisLine.attr({stroke:this.options.lineColor,"stroke-width":this.options.lineWidth,zIndex:7}))},getTitlePosition:function(){var a=this.horiz,b=this.left,c=this.top,e=this.len,h=this.options.title,m=a?b:c,p=this.opposite,d=this.offset,t=h.x||0,f=h.y||0,n=this.chart.renderer.fontMetrics(h.style&&h.style.fontSize,this.axisTitle).f,e={low:m+(a?0:e),middle:m+e/2,high:m+(a?e:0)}[h.align],b=(a?c+this.height:b)+(a?1:-1)*(p?-1:1)*this.axisTitleMargin+(2===this.side?n:0);return{x:a?e+t:b+(p?this.width:
	0)+d+t,y:a?b+f-(p?this.height:0)+d:e+f}},renderMinorTick:function(a){var b=this.chart.hasRendered&&w(this.oldMin),c=this.minorTicks;c[a]||(c[a]=new J(this,a,"minor"));b&&c[a].isNew&&c[a].render(null,!0);c[a].render(null,!1,1)},renderTick:function(a,b){var c=this.isLinked,g=this.ticks,e=this.chart.hasRendered&&w(this.oldMin);if(!c||a>=this.min&&a<=this.max)g[a]||(g[a]=new J(this,a)),e&&g[a].isNew&&g[a].render(b,!0,.1),g[a].render(b)},render:function(){var a=this,b=a.chart,e=a.options,h=a.isLog,p=a.lin2log,
	d=a.isLinked,t=a.tickPositions,f=a.axisTitle,n=a.ticks,y=a.minorTicks,k=a.alternateBands,w=e.stackLabels,x=e.alternateGridColor,D=a.tickmarkOffset,l=a.axisLine,C=a.showAxis,q=A(b.renderer.globalAnimation),I,E;a.labelEdge.length=0;a.overlap=!1;c([n,y,k],function(a){for(var b in a)a[b].isActive=!1});if(a.hasData()||d)a.minorTickInterval&&!a.categories&&c(a.getMinorTickPositions(),function(b){a.renderMinorTick(b)}),t.length&&(c(t,function(b,c){a.renderTick(b,c)}),D&&(0===a.min||a.single)&&(n[-1]||(n[-1]=
	new J(a,-1,null,!0)),n[-1].render(-1))),x&&c(t,function(c,e){E=void 0!==t[e+1]?t[e+1]+D:a.max-D;0===e%2&&c<a.max&&E<=a.max+(b.polar?-D:D)&&(k[c]||(k[c]=new m(a)),I=c+D,k[c].options={from:h?p(I):I,to:h?p(E):E,color:x},k[c].render(),k[c].isActive=!0)}),a._addedPlotLB||(c((e.plotLines||[]).concat(e.plotBands||[]),function(b){a.addPlotBandOrLine(b)}),a._addedPlotLB=!0);c([n,y,k],function(a){var c,e,g=[],h=q.duration;for(c in a)a[c].isActive||(a[c].render(c,!1,0),a[c].isActive=!1,g.push(c));K(function(){for(e=
	g.length;e--;)a[g[e]]&&!a[g[e]].isActive&&(a[g[e]].destroy(),delete a[g[e]])},a!==k&&b.hasRendered&&h?h:0)});l&&(l[l.isPlaced?"animate":"attr"]({d:this.getLinePath(l.strokeWidth())}),l.isPlaced=!0,l[C?"show":"hide"](!0));f&&C&&(f[f.isNew?"attr":"animate"](a.getTitlePosition()),f.isNew=!1);w&&w.enabled&&a.renderStackTotals();a.isDirty=!1},redraw:function(){this.visible&&(this.render(),c(this.plotLinesAndBands,function(a){a.render()}));c(this.series,function(a){a.isDirty=!0})},keepProps:"extKey hcEvents names series userMax userMin".split(" "),
	destroy:function(a){var b=this,e=b.stacks,g,h=b.plotLinesAndBands,m,p;a||y(b);for(g in e)d(e[g]),e[g]=null;c([b.ticks,b.minorTicks,b.alternateBands],function(a){d(a)});if(h)for(a=h.length;a--;)h[a].destroy();c("stackTotalGroup axisLine axisTitle axisGroup gridGroup labelGroup cross".split(" "),function(a){b[a]&&(b[a]=b[a].destroy())});for(m in b.plotLinesAndBandsGroups)b.plotLinesAndBandsGroups[m]=b.plotLinesAndBandsGroups[m].destroy();for(p in b)b.hasOwnProperty(p)&&-1===t(p,b.keepProps)&&delete b[p]},
	drawCrosshair:function(a,b){var c,e=this.crosshair,g=E(e.snap,!0),h,m=this.cross;a||(a=this.cross&&this.cross.e);this.crosshair&&!1!==(k(b)||!g)?(g?k(b)&&(h=this.isXAxis?b.plotX:this.len-b.plotY):h=a&&(this.horiz?a.chartX-this.pos:this.len-a.chartY+this.pos),k(h)&&(c=this.getPlotLinePath(b&&(this.isXAxis?b.x:E(b.stackY,b.y)),null,null,null,h)||null),k(c)?(b=this.categories&&!this.isRadial,m||(this.cross=m=this.chart.renderer.path().addClass("highcharts-crosshair highcharts-crosshair-"+(b?"category ":
	"thin ")+e.className).attr({zIndex:E(e.zIndex,2)}).add(),m.attr({stroke:e.color||(b?f("#ccd6eb").setOpacity(.25).get():"#cccccc"),"stroke-width":E(e.width,1)}),e.dashStyle&&m.attr({dashstyle:e.dashStyle})),m.show().attr({d:c}),b&&!e.width&&m.attr({"stroke-width":this.transA}),this.cross.e=a):this.hideCrosshair()):this.hideCrosshair()},hideCrosshair:function(){this.cross&&this.cross.hide()}};n(a.Axis.prototype,r)})(L);(function(a){var B=a.Axis,A=a.Date,H=a.dateFormat,G=a.defaultOptions,r=a.defined,
	f=a.each,l=a.extend,q=a.getMagnitude,k=a.getTZOffset,u=a.normalizeTickInterval,d=a.pick,c=a.timeUnits;B.prototype.getTimeTicks=function(a,q,b,p){var h=[],t={},n=G.global.useUTC,w,e=new A(q-Math.abs(k(q))),x=A.hcMakeTime,C=a.unitRange,E=a.count,m;if(r(q)){e[A.hcSetMilliseconds](C>=c.second?0:E*Math.floor(e.getMilliseconds()/E));if(C>=c.second)e[A.hcSetSeconds](C>=c.minute?0:E*Math.floor(e.getSeconds()/E));if(C>=c.minute)e[A.hcSetMinutes](C>=c.hour?0:E*Math.floor(e[A.hcGetMinutes]()/E));if(C>=c.hour)e[A.hcSetHours](C>=
	c.day?0:E*Math.floor(e[A.hcGetHours]()/E));if(C>=c.day)e[A.hcSetDate](C>=c.month?1:E*Math.floor(e[A.hcGetDate]()/E));C>=c.month&&(e[A.hcSetMonth](C>=c.year?0:E*Math.floor(e[A.hcGetMonth]()/E)),w=e[A.hcGetFullYear]());if(C>=c.year)e[A.hcSetFullYear](w-w%E);if(C===c.week)e[A.hcSetDate](e[A.hcGetDate]()-e[A.hcGetDay]()+d(p,1));w=e[A.hcGetFullYear]();p=e[A.hcGetMonth]();var y=e[A.hcGetDate](),I=e[A.hcGetHours]();if(A.hcTimezoneOffset||A.hcGetTimezoneOffset)m=(!n||!!A.hcGetTimezoneOffset)&&(b-q>4*c.month||
	k(q)!==k(b)),e=e.getTime(),e=new A(e+k(e));n=e.getTime();for(q=1;n<b;)h.push(n),n=C===c.year?x(w+q*E,0):C===c.month?x(w,p+q*E):!m||C!==c.day&&C!==c.week?m&&C===c.hour?x(w,p,y,I+q*E):n+C*E:x(w,p,y+q*E*(C===c.day?1:7)),q++;h.push(n);C<=c.hour&&1E4>h.length&&f(h,function(a){0===a%18E5&&"000000000"===H("%H%M%S%L",a)&&(t[a]="day")})}h.info=l(a,{higherRanks:t,totalRange:C*E});return h};B.prototype.normalizeTimeTickInterval=function(a,d){var b=d||[["millisecond",[1,2,5,10,20,25,50,100,200,500]],["second",
	[1,2,5,10,15,30]],["minute",[1,2,5,10,15,30]],["hour",[1,2,3,4,6,8,12]],["day",[1,2]],["week",[1,2]],["month",[1,2,3,4,6]],["year",null]];d=b[b.length-1];var p=c[d[0]],h=d[1],t;for(t=0;t<b.length&&!(d=b[t],p=c[d[0]],h=d[1],b[t+1]&&a<=(p*h[h.length-1]+c[b[t+1][0]])/2);t++);p===c.year&&a<5*p&&(h=[1,2,5]);a=u(a/p,h,"year"===d[0]?Math.max(q(a/p),1):1);return{unitRange:p,count:a,unitName:d[0]}}})(L);(function(a){var B=a.Axis,A=a.getMagnitude,H=a.map,G=a.normalizeTickInterval,r=a.pick;B.prototype.getLogTickPositions=
	function(a,l,q,k){var f=this.options,d=this.len,c=this.lin2log,n=this.log2lin,z=[];k||(this._minorAutoInterval=null);if(.5<=a)a=Math.round(a),z=this.getLinearTickPositions(a,l,q);else if(.08<=a)for(var d=Math.floor(l),b,p,h,t,D,f=.3<a?[1,2,4]:.15<a?[1,2,4,6,8]:[1,2,3,4,5,6,7,8,9];d<q+1&&!D;d++)for(p=f.length,b=0;b<p&&!D;b++)h=n(c(d)*f[b]),h>l&&(!k||t<=q)&&void 0!==t&&z.push(t),t>q&&(D=!0),t=h;else l=c(l),q=c(q),a=f[k?"minorTickInterval":"tickInterval"],a=r("auto"===a?null:a,this._minorAutoInterval,
	f.tickPixelInterval/(k?5:1)*(q-l)/((k?d/this.tickPositions.length:d)||1)),a=G(a,null,A(a)),z=H(this.getLinearTickPositions(a,l,q),n),k||(this._minorAutoInterval=a/5);k||(this.tickInterval=a);return z};B.prototype.log2lin=function(a){return Math.log(a)/Math.LN10};B.prototype.lin2log=function(a){return Math.pow(10,a)}})(L);(function(a){var B=a.dateFormat,A=a.each,H=a.extend,G=a.format,r=a.isNumber,f=a.map,l=a.merge,q=a.pick,k=a.splat,u=a.syncTimeout,d=a.timeUnits;a.Tooltip=function(){this.init.apply(this,
	arguments)};a.Tooltip.prototype={init:function(a,d){this.chart=a;this.options=d;this.crosshairs=[];this.now={x:0,y:0};this.isHidden=!0;this.split=d.split&&!a.inverted;this.shared=d.shared||this.split},cleanSplit:function(a){A(this.chart.series,function(c){var d=c&&c.tt;d&&(!d.isActive||a?c.tt=d.destroy():d.isActive=!1)})},getLabel:function(){var a=this.chart.renderer,d=this.options;this.label||(this.split?this.label=a.g("tooltip"):(this.label=a.label("",0,0,d.shape||"callout",null,null,d.useHTML,
	null,"tooltip").attr({padding:d.padding,r:d.borderRadius}),this.label.attr({fill:d.backgroundColor,"stroke-width":d.borderWidth}).css(d.style).shadow(d.shadow)),this.label.attr({zIndex:8}).add());return this.label},update:function(a){this.destroy();this.init(this.chart,l(!0,this.options,a))},destroy:function(){this.label&&(this.label=this.label.destroy());this.split&&this.tt&&(this.cleanSplit(this.chart,!0),this.tt=this.tt.destroy());clearTimeout(this.hideTimer);clearTimeout(this.tooltipTimeout)},
	move:function(a,d,f,b){var c=this,h=c.now,t=!1!==c.options.animation&&!c.isHidden&&(1<Math.abs(a-h.x)||1<Math.abs(d-h.y)),n=c.followPointer||1<c.len;H(h,{x:t?(2*h.x+a)/3:a,y:t?(h.y+d)/2:d,anchorX:n?void 0:t?(2*h.anchorX+f)/3:f,anchorY:n?void 0:t?(h.anchorY+b)/2:b});c.getLabel().attr(h);t&&(clearTimeout(this.tooltipTimeout),this.tooltipTimeout=setTimeout(function(){c&&c.move(a,d,f,b)},32))},hide:function(a){var c=this;clearTimeout(this.hideTimer);a=q(a,this.options.hideDelay,500);this.isHidden||(this.hideTimer=
	u(function(){c.getLabel()[a?"fadeOut":"hide"]();c.isHidden=!0},a))},getAnchor:function(a,d){var c,b=this.chart,p=b.inverted,h=b.plotTop,t=b.plotLeft,n=0,w=0,e,x;a=k(a);c=a[0].tooltipPos;this.followPointer&&d&&(void 0===d.chartX&&(d=b.pointer.normalize(d)),c=[d.chartX-b.plotLeft,d.chartY-h]);c||(A(a,function(a){e=a.series.yAxis;x=a.series.xAxis;n+=a.plotX+(!p&&x?x.left-t:0);w+=(a.plotLow?(a.plotLow+a.plotHigh)/2:a.plotY)+(!p&&e?e.top-h:0)}),n/=a.length,w/=a.length,c=[p?b.plotWidth-w:n,this.shared&&
	!p&&1<a.length&&d?d.chartY-h:p?b.plotHeight-n:w]);return f(c,Math.round)},getPosition:function(a,d,f){var b=this.chart,c=this.distance,h={},t=f.h||0,n,k=["y",b.chartHeight,d,f.plotY+b.plotTop,b.plotTop,b.plotTop+b.plotHeight],e=["x",b.chartWidth,a,f.plotX+b.plotLeft,b.plotLeft,b.plotLeft+b.plotWidth],x=!this.followPointer&&q(f.ttBelow,!b.inverted===!!f.negative),l=function(a,b,e,g,m,d){var p=e<g-c,f=g+c+e<b,n=g-c-e;g+=c;if(x&&f)h[a]=g;else if(!x&&p)h[a]=n;else if(p)h[a]=Math.min(d-e,0>n-t?n:n-t);
	else if(f)h[a]=Math.max(m,g+t+e>b?g:g+t);else return!1},E=function(a,b,e,g){var m;g<c||g>b-c?m=!1:h[a]=g<e/2?1:g>b-e/2?b-e-2:g-e/2;return m},m=function(a){var b=k;k=e;e=b;n=a},y=function(){!1!==l.apply(0,k)?!1!==E.apply(0,e)||n||(m(!0),y()):n?h.x=h.y=0:(m(!0),y())};(b.inverted||1<this.len)&&m();y();return h},defaultFormatter:function(a){var c=this.points||k(this),d;d=[a.tooltipFooterHeaderFormatter(c[0])];d=d.concat(a.bodyFormatter(c));d.push(a.tooltipFooterHeaderFormatter(c[0],!0));return d},refresh:function(a,
	d){var c,b=this.options,p,h=a,t,f={},n=[];c=b.formatter||this.defaultFormatter;var f=this.shared,e;clearTimeout(this.hideTimer);this.followPointer=k(h)[0].series.tooltipOptions.followPointer;t=this.getAnchor(h,d);d=t[0];p=t[1];!f||h.series&&h.series.noSharedTooltip?f=h.getLabelConfig():(A(h,function(a){a.setState("hover");n.push(a.getLabelConfig())}),f={x:h[0].category,y:h[0].y},f.points=n,h=h[0]);this.len=n.length;f=c.call(f,this);e=h.series;this.distance=q(e.tooltipOptions.distance,16);!1===f?this.hide():
	(c=this.getLabel(),this.isHidden&&c.attr({opacity:1}).show(),this.split?this.renderSplit(f,a):(c.attr({text:f&&f.join?f.join(""):f}),c.removeClass(/highcharts-color-[\d]+/g).addClass("highcharts-color-"+q(h.colorIndex,e.colorIndex)),c.attr({stroke:b.borderColor||h.color||e.color||"#666666"}),this.updatePosition({plotX:d,plotY:p,negative:h.negative,ttBelow:h.ttBelow,h:t[2]||0})),this.isHidden=!1)},renderSplit:function(c,d){var f=this,b=[],p=this.chart,h=p.renderer,t=!0,n=this.options,k,e=this.getLabel();
	A(c.slice(0,d.length+1),function(a,c){c=d[c-1]||{isHeader:!0,plotX:d[0].plotX};var w=c.series||f,m=w.tt,y=c.series||{},x="highcharts-color-"+q(c.colorIndex,y.colorIndex,"none");m||(w.tt=m=h.label(null,null,null,"callout").addClass("highcharts-tooltip-box "+x).attr({padding:n.padding,r:n.borderRadius,fill:n.backgroundColor,stroke:c.color||y.color||"#333333","stroke-width":n.borderWidth}).add(e));m.isActive=!0;m.attr({text:a});m.css(n.style);a=m.getBBox();y=a.width+m.strokeWidth();c.isHeader?(k=a.height,
	y=Math.max(0,Math.min(c.plotX+p.plotLeft-y/2,p.chartWidth-y))):y=c.plotX+p.plotLeft-q(n.distance,16)-y;0>y&&(t=!1);a=(c.series&&c.series.yAxis&&c.series.yAxis.pos)+(c.plotY||0);a-=p.plotTop;b.push({target:c.isHeader?p.plotHeight+k:a,rank:c.isHeader?1:0,size:w.tt.getBBox().height+1,point:c,x:y,tt:m})});this.cleanSplit();a.distribute(b,p.plotHeight+k);A(b,function(a){var b=a.point,c=b.series;a.tt.attr({visibility:void 0===a.pos?"hidden":"inherit",x:t||b.isHeader?a.x:b.plotX+p.plotLeft+q(n.distance,
	16),y:a.pos+p.plotTop,anchorX:b.isHeader?b.plotX+p.plotLeft:b.plotX+c.xAxis.pos,anchorY:b.isHeader?a.pos+p.plotTop-15:b.plotY+c.yAxis.pos})})},updatePosition:function(a){var c=this.chart,d=this.getLabel(),d=(this.options.positioner||this.getPosition).call(this,d.width,d.height,a);this.move(Math.round(d.x),Math.round(d.y||0),a.plotX+c.plotLeft,a.plotY+c.plotTop)},getDateFormat:function(a,f,k,b){var c=B("%m-%d %H:%M:%S.%L",f),h,t,n={millisecond:15,second:12,minute:9,hour:6,day:3},w="millisecond";for(t in d){if(a===
	d.week&&+B("%w",f)===k&&"00:00:00.000"===c.substr(6)){t="week";break}if(d[t]>a){t=w;break}if(n[t]&&c.substr(n[t])!=="01-01 00:00:00.000".substr(n[t]))break;"week"!==t&&(w=t)}t&&(h=b[t]);return h},getXDateFormat:function(a,d,f){d=d.dateTimeLabelFormats;var b=f&&f.closestPointRange;return(b?this.getDateFormat(b,a.x,f.options.startOfWeek,d):d.day)||d.year},tooltipFooterHeaderFormatter:function(a,d){var c=d?"footer":"header";d=a.series;var b=d.tooltipOptions,p=b.xDateFormat,h=d.xAxis,t=h&&"datetime"===
	h.options.type&&r(a.key),c=b[c+"Format"];t&&!p&&(p=this.getXDateFormat(a,b,h));t&&p&&(c=c.replace("{point.key}","{point.key:"+p+"}"));return G(c,{point:a,series:d})},bodyFormatter:function(a){return f(a,function(a){var c=a.series.tooltipOptions;return(c.pointFormatter||a.point.tooltipFormatter).call(a.point,c.pointFormat)})}}})(L);(function(a){var B=a.addEvent,A=a.attr,H=a.charts,G=a.color,r=a.css,f=a.defined,l=a.doc,q=a.each,k=a.extend,u=a.fireEvent,d=a.offset,c=a.pick,n=a.removeEvent,z=a.splat,
	b=a.Tooltip,p=a.win;a.Pointer=function(a,b){this.init(a,b)};a.Pointer.prototype={init:function(a,d){this.options=d;this.chart=a;this.runChartClick=d.chart.events&&!!d.chart.events.click;this.pinchDown=[];this.lastValidTouch={};b&&d.tooltip.enabled&&(a.tooltip=new b(a,d.tooltip),this.followTouchMove=c(d.tooltip.followTouchMove,!0));this.setDOMEvents()},zoomOption:function(a){var b=this.chart,h=b.options.chart,d=h.zoomType||"",b=b.inverted;/touch/.test(a.type)&&(d=c(h.pinchType,d));this.zoomX=a=/x/.test(d);
	this.zoomY=d=/y/.test(d);this.zoomHor=a&&!b||d&&b;this.zoomVert=d&&!b||a&&b;this.hasZoom=a||d},normalize:function(a,b){var c,h;a=a||p.event;a.target||(a.target=a.srcElement);h=a.touches?a.touches.length?a.touches.item(0):a.changedTouches[0]:a;b||(this.chartPosition=b=d(this.chart.container));void 0===h.pageX?(c=Math.max(a.x,a.clientX-b.left),b=a.y):(c=h.pageX-b.left,b=h.pageY-b.top);return k(a,{chartX:Math.round(c),chartY:Math.round(b)})},getCoordinates:function(a){var b={xAxis:[],yAxis:[]};q(this.chart.axes,
	function(c){b[c.isXAxis?"xAxis":"yAxis"].push({axis:c,value:c.toValue(a[c.horiz?"chartX":"chartY"])})});return b},getKDPoints:function(a,b,d){var h=[],e,p,f;q(a,function(a){e=a.noSharedTooltip&&b;p=!b&&a.directTouch;a.visible&&!p&&c(a.options.enableMouseTracking,!0)&&(f=a.searchPoint(d,!e&&0>a.options.findNearestPointBy.indexOf("y")))&&f.series&&h.push(f)});h.sort(function(a,c){var e=a.distX-c.distX,h=a.dist-c.dist,m=(c.series.group&&c.series.group.zIndex)-(a.series.group&&a.series.group.zIndex);
	return 0!==e&&b?e:0!==h?h:0!==m?m:a.series.index>c.series.index?-1:1});if(b&&h[0]&&!h[0].series.noSharedTooltip)for(a=h.length;a--;)(h[a].x!==h[0].x||h[a].series.noSharedTooltip)&&h.splice(a,1);return h},getPointFromEvent:function(a){a=a.target;for(var b;a&&!b;)b=a.point,a=a.parentNode;return b},getHoverData:function(b,d,p,f,e,n){var h=b,t=d,m;f?e?(m=[],q(p,function(a){var b=a.noSharedTooltip&&e,d=!e&&a.directTouch;a.visible&&!b&&!d&&c(a.options.enableMouseTracking,!0)&&(a=a.searchKDTree({clientX:h.clientX,
	plotY:h.plotY},!b&&1===a.kdDimensions))&&a.series&&m.push(a)}),0===m.length&&(m=[h])):m=[h]:t&&!t.stickyTracking?(e||(p=[t]),m=this.getKDPoints(p,e,n),h=a.find(m,function(a){return a.series===t})):(b=a.grep(p,function(a){return a.stickyTracking}),m=this.getKDPoints(b,e,n),t=(h=m[0])&&h.series,e&&(m=this.getKDPoints(p,e,n)));m.sort(function(a,b){return a.series.index-b.series.index});return{hoverPoint:h,hoverSeries:t,hoverPoints:m}},runPointActions:function(b,d){var h=this.chart,p=h.tooltip,e=p?p.shared:
	!1,f=d||h.hoverPoint,t=f&&f.series||h.hoverSeries;d=this.getHoverData(f,t,h.series,!!d||!e&&t&&t.directTouch,e,b);var n,m,f=d.hoverPoint;n=(t=d.hoverSeries)&&t.tooltipOptions.followPointer;m=(e=e&&f&&!f.series.noSharedTooltip)?d.hoverPoints:f?[f]:[];if(f&&(f!==h.hoverPoint||p&&p.isHidden)){q(h.hoverPoints||[],function(b){-1===a.inArray(b,m)&&b.setState()});q(m||[],function(a){a.setState("hover")});if(h.hoverSeries!==t)t.onMouseOver();t&&!t.directTouch&&(h.hoverPoint&&h.hoverPoint.firePointEvent("mouseOut"),
	f.firePointEvent("mouseOver"));h.hoverPoints=m;h.hoverPoint=f;p&&p.refresh(e?m:f,b)}else n&&p&&!p.isHidden&&(f=p.getAnchor([{}],b),p.updatePosition({plotX:f[0],plotY:f[1]}));this.unDocMouseMove||(this.unDocMouseMove=B(l,"mousemove",function(b){var c=H[a.hoverChartIndex];if(c)c.pointer.onDocumentMouseMove(b)}));q(h.axes,function(a){c(a.crosshair.snap,!0)?q(m,function(c){c.series[a.coll]===a&&a.drawCrosshair(b,c)}):a.drawCrosshair(b)})},reset:function(a,b){var c=this.chart,h=c.hoverSeries,e=c.hoverPoint,
	d=c.hoverPoints,p=c.tooltip,f=p&&p.shared?d:e;a&&f&&q(z(f),function(b){b.series.isCartesian&&void 0===b.plotX&&(a=!1)});if(a)p&&f&&(p.refresh(f),e&&(e.setState(e.state,!0),q(c.axes,function(a){a.crosshair&&a.drawCrosshair(null,e)})));else{if(e)e.onMouseOut();d&&q(d,function(a){a.setState()});if(h)h.onMouseOut();p&&p.hide(b);this.unDocMouseMove&&(this.unDocMouseMove=this.unDocMouseMove());q(c.axes,function(a){a.hideCrosshair()});this.hoverX=c.hoverPoints=c.hoverPoint=null}},scaleGroups:function(a,
	b){var c=this.chart,h;q(c.series,function(e){h=a||e.getPlotBox();e.xAxis&&e.xAxis.zoomEnabled&&e.group&&(e.group.attr(h),e.markerGroup&&(e.markerGroup.attr(h),e.markerGroup.clip(b?c.clipRect:null)),e.dataLabelsGroup&&e.dataLabelsGroup.attr(h))});c.clipRect.attr(b||c.clipBox)},dragStart:function(a){var b=this.chart;b.mouseIsDown=a.type;b.cancelClick=!1;b.mouseDownX=this.mouseDownX=a.chartX;b.mouseDownY=this.mouseDownY=a.chartY},drag:function(a){var b=this.chart,c=b.options.chart,h=a.chartX,e=a.chartY,
	d=this.zoomHor,p=this.zoomVert,f=b.plotLeft,m=b.plotTop,n=b.plotWidth,k=b.plotHeight,l,q=this.selectionMarker,g=this.mouseDownX,u=this.mouseDownY,r=c.panKey&&a[c.panKey+"Key"];q&&q.touch||(h<f?h=f:h>f+n&&(h=f+n),e<m?e=m:e>m+k&&(e=m+k),this.hasDragged=Math.sqrt(Math.pow(g-h,2)+Math.pow(u-e,2)),10<this.hasDragged&&(l=b.isInsidePlot(g-f,u-m),b.hasCartesianSeries&&(this.zoomX||this.zoomY)&&l&&!r&&!q&&(this.selectionMarker=q=b.renderer.rect(f,m,d?1:n,p?1:k,0).attr({fill:c.selectionMarkerFill||G("#335cad").setOpacity(.25).get(),
	"class":"highcharts-selection-marker",zIndex:7}).add()),q&&d&&(h-=g,q.attr({width:Math.abs(h),x:(0<h?0:h)+g})),q&&p&&(h=e-u,q.attr({height:Math.abs(h),y:(0<h?0:h)+u})),l&&!q&&c.panning&&b.pan(a,c.panning)))},drop:function(a){var b=this,c=this.chart,h=this.hasPinched;if(this.selectionMarker){var e={originalEvent:a,xAxis:[],yAxis:[]},d=this.selectionMarker,p=d.attr?d.attr("x"):d.x,n=d.attr?d.attr("y"):d.y,m=d.attr?d.attr("width"):d.width,y=d.attr?d.attr("height"):d.height,l;if(this.hasDragged||h)q(c.axes,
	function(c){if(c.zoomEnabled&&f(c.min)&&(h||b[{xAxis:"zoomX",yAxis:"zoomY"}[c.coll]])){var d=c.horiz,g="touchend"===a.type?c.minPixelPadding:0,t=c.toValue((d?p:n)+g),d=c.toValue((d?p+m:n+y)-g);e[c.coll].push({axis:c,min:Math.min(t,d),max:Math.max(t,d)});l=!0}}),l&&u(c,"selection",e,function(a){c.zoom(k(a,h?{animation:!1}:null))});this.selectionMarker=this.selectionMarker.destroy();h&&this.scaleGroups()}c&&(r(c.container,{cursor:c._cursor}),c.cancelClick=10<this.hasDragged,c.mouseIsDown=this.hasDragged=
	this.hasPinched=!1,this.pinchDown=[])},onContainerMouseDown:function(a){a=this.normalize(a);this.zoomOption(a);a.preventDefault&&a.preventDefault();this.dragStart(a)},onDocumentMouseUp:function(b){H[a.hoverChartIndex]&&H[a.hoverChartIndex].pointer.drop(b)},onDocumentMouseMove:function(a){var b=this.chart,c=this.chartPosition;a=this.normalize(a,c);!c||this.inClass(a.target,"highcharts-tracker")||b.isInsidePlot(a.chartX-b.plotLeft,a.chartY-b.plotTop)||this.reset()},onContainerMouseLeave:function(b){var c=
	H[a.hoverChartIndex];c&&(b.relatedTarget||b.toElement)&&(c.pointer.reset(),c.pointer.chartPosition=null)},onContainerMouseMove:function(b){var c=this.chart;f(a.hoverChartIndex)&&H[a.hoverChartIndex]&&H[a.hoverChartIndex].mouseIsDown||(a.hoverChartIndex=c.index);b=this.normalize(b);b.returnValue=!1;"mousedown"===c.mouseIsDown&&this.drag(b);!this.inClass(b.target,"highcharts-tracker")&&!c.isInsidePlot(b.chartX-c.plotLeft,b.chartY-c.plotTop)||c.openMenu||this.runPointActions(b)},inClass:function(a,b){for(var c;a;){if(c=
	A(a,"class")){if(-1!==c.indexOf(b))return!0;if(-1!==c.indexOf("highcharts-container"))return!1}a=a.parentNode}},onTrackerMouseOut:function(a){var b=this.chart.hoverSeries;a=a.relatedTarget||a.toElement;if(!(!b||!a||b.stickyTracking||this.inClass(a,"highcharts-tooltip")||this.inClass(a,"highcharts-series-"+b.index)&&this.inClass(a,"highcharts-tracker")))b.onMouseOut()},onContainerClick:function(a){var b=this.chart,c=b.hoverPoint,h=b.plotLeft,e=b.plotTop;a=this.normalize(a);b.cancelClick||(c&&this.inClass(a.target,
	"highcharts-tracker")?(u(c.series,"click",k(a,{point:c})),b.hoverPoint&&c.firePointEvent("click",a)):(k(a,this.getCoordinates(a)),b.isInsidePlot(a.chartX-h,a.chartY-e)&&u(b,"click",a)))},setDOMEvents:function(){var b=this,c=b.chart.container;c.onmousedown=function(a){b.onContainerMouseDown(a)};c.onmousemove=function(a){b.onContainerMouseMove(a)};c.onclick=function(a){b.onContainerClick(a)};B(c,"mouseleave",b.onContainerMouseLeave);1===a.chartCount&&B(l,"mouseup",b.onDocumentMouseUp);a.hasTouch&&(c.ontouchstart=
	function(a){b.onContainerTouchStart(a)},c.ontouchmove=function(a){b.onContainerTouchMove(a)},1===a.chartCount&&B(l,"touchend",b.onDocumentTouchEnd))},destroy:function(){var b;this.unDocMouseMove&&this.unDocMouseMove();n(this.chart.container,"mouseleave",this.onContainerMouseLeave);a.chartCount||(n(l,"mouseup",this.onDocumentMouseUp),n(l,"touchend",this.onDocumentTouchEnd));clearInterval(this.tooltipTimeout);for(b in this)this[b]=null}}})(L);(function(a){var B=a.charts,A=a.each,H=a.extend,G=a.map,
	r=a.noop,f=a.pick;H(a.Pointer.prototype,{pinchTranslate:function(a,f,k,u,d,c){this.zoomHor&&this.pinchTranslateDirection(!0,a,f,k,u,d,c);this.zoomVert&&this.pinchTranslateDirection(!1,a,f,k,u,d,c)},pinchTranslateDirection:function(a,f,k,u,d,c,n,r){var b=this.chart,p=a?"x":"y",h=a?"X":"Y",t="chart"+h,l=a?"width":"height",w=b["plot"+(a?"Left":"Top")],e,q,C=r||1,E=b.inverted,m=b.bounds[a?"h":"v"],y=1===f.length,I=f[0][t],K=k[0][t],J=!y&&f[1][t],g=!y&&k[1][t],z;k=function(){!y&&20<Math.abs(I-J)&&(C=r||
	Math.abs(K-g)/Math.abs(I-J));q=(w-K)/C+I;e=b["plot"+(a?"Width":"Height")]/C};k();f=q;f<m.min?(f=m.min,z=!0):f+e>m.max&&(f=m.max-e,z=!0);z?(K-=.8*(K-n[p][0]),y||(g-=.8*(g-n[p][1])),k()):n[p]=[K,g];E||(c[p]=q-w,c[l]=e);c=E?1/C:C;d[l]=e;d[p]=f;u[E?a?"scaleY":"scaleX":"scale"+h]=C;u["translate"+h]=c*w+(K-c*I)},pinch:function(a){var l=this,k=l.chart,u=l.pinchDown,d=a.touches,c=d.length,n=l.lastValidTouch,z=l.hasZoom,b=l.selectionMarker,p={},h=1===c&&(l.inClass(a.target,"highcharts-tracker")&&k.runTrackerClick||
	l.runChartClick),t={};1<c&&(l.initiated=!0);z&&l.initiated&&!h&&a.preventDefault();G(d,function(a){return l.normalize(a)});"touchstart"===a.type?(A(d,function(a,b){u[b]={chartX:a.chartX,chartY:a.chartY}}),n.x=[u[0].chartX,u[1]&&u[1].chartX],n.y=[u[0].chartY,u[1]&&u[1].chartY],A(k.axes,function(a){if(a.zoomEnabled){var b=k.bounds[a.horiz?"h":"v"],c=a.minPixelPadding,h=a.toPixels(f(a.options.min,a.dataMin)),d=a.toPixels(f(a.options.max,a.dataMax)),p=Math.max(h,d);b.min=Math.min(a.pos,Math.min(h,d)-
	c);b.max=Math.max(a.pos+a.len,p+c)}}),l.res=!0):l.followTouchMove&&1===c?this.runPointActions(l.normalize(a)):u.length&&(b||(l.selectionMarker=b=H({destroy:r,touch:!0},k.plotBox)),l.pinchTranslate(u,d,p,b,t,n),l.hasPinched=z,l.scaleGroups(p,t),l.res&&(l.res=!1,this.reset(!1,0)))},touch:function(l,q){var k=this.chart,u,d;if(k.index!==a.hoverChartIndex)this.onContainerMouseLeave({relatedTarget:!0});a.hoverChartIndex=k.index;1===l.touches.length?(l=this.normalize(l),(d=k.isInsidePlot(l.chartX-k.plotLeft,
	l.chartY-k.plotTop))&&!k.openMenu?(q&&this.runPointActions(l),"touchmove"===l.type&&(q=this.pinchDown,u=q[0]?4<=Math.sqrt(Math.pow(q[0].chartX-l.chartX,2)+Math.pow(q[0].chartY-l.chartY,2)):!1),f(u,!0)&&this.pinch(l)):q&&this.reset()):2===l.touches.length&&this.pinch(l)},onContainerTouchStart:function(a){this.zoomOption(a);this.touch(a,!0)},onContainerTouchMove:function(a){this.touch(a)},onDocumentTouchEnd:function(f){B[a.hoverChartIndex]&&B[a.hoverChartIndex].pointer.drop(f)}})})(L);(function(a){var B=
	a.addEvent,A=a.charts,H=a.css,G=a.doc,r=a.extend,f=a.noop,l=a.Pointer,q=a.removeEvent,k=a.win,u=a.wrap;if(k.PointerEvent||k.MSPointerEvent){var d={},c=!!k.PointerEvent,n=function(){var a,c=[];c.item=function(a){return this[a]};for(a in d)d.hasOwnProperty(a)&&c.push({pageX:d[a].pageX,pageY:d[a].pageY,target:d[a].target});return c},z=function(b,c,h,d){"touch"!==b.pointerType&&b.pointerType!==b.MSPOINTER_TYPE_TOUCH||!A[a.hoverChartIndex]||(d(b),d=A[a.hoverChartIndex].pointer,d[c]({type:h,target:b.currentTarget,
	preventDefault:f,touches:n()}))};r(l.prototype,{onContainerPointerDown:function(a){z(a,"onContainerTouchStart","touchstart",function(a){d[a.pointerId]={pageX:a.pageX,pageY:a.pageY,target:a.currentTarget}})},onContainerPointerMove:function(a){z(a,"onContainerTouchMove","touchmove",function(a){d[a.pointerId]={pageX:a.pageX,pageY:a.pageY};d[a.pointerId].target||(d[a.pointerId].target=a.currentTarget)})},onDocumentPointerUp:function(a){z(a,"onDocumentTouchEnd","touchend",function(a){delete d[a.pointerId]})},
	batchMSEvents:function(a){a(this.chart.container,c?"pointerdown":"MSPointerDown",this.onContainerPointerDown);a(this.chart.container,c?"pointermove":"MSPointerMove",this.onContainerPointerMove);a(G,c?"pointerup":"MSPointerUp",this.onDocumentPointerUp)}});u(l.prototype,"init",function(a,c,h){a.call(this,c,h);this.hasZoom&&H(c.container,{"-ms-touch-action":"none","touch-action":"none"})});u(l.prototype,"setDOMEvents",function(a){a.apply(this);(this.hasZoom||this.followTouchMove)&&this.batchMSEvents(B)});
	u(l.prototype,"destroy",function(a){this.batchMSEvents(q);a.call(this)})}})(L);(function(a){var B,A=a.addEvent,H=a.css,G=a.discardElement,r=a.defined,f=a.each,l=a.isFirefox,q=a.marginNames,k=a.merge,u=a.pick,d=a.setAnimation,c=a.stableSort,n=a.win,z=a.wrap;B=a.Legend=function(a,c){this.init(a,c)};B.prototype={init:function(a,c){this.chart=a;this.setOptions(c);c.enabled&&(this.render(),A(this.chart,"endResize",function(){this.legend.positionCheckboxes()}))},setOptions:function(a){var b=u(a.padding,
	8);this.options=a;this.itemStyle=a.itemStyle;this.itemHiddenStyle=k(this.itemStyle,a.itemHiddenStyle);this.itemMarginTop=a.itemMarginTop||0;this.padding=b;this.initialItemY=b-5;this.itemHeight=this.maxItemWidth=0;this.symbolWidth=u(a.symbolWidth,16);this.pages=[]},update:function(a,c){var b=this.chart;this.setOptions(k(!0,this.options,a));this.destroy();b.isDirtyLegend=b.isDirtyBox=!0;u(c,!0)&&b.redraw()},colorizeItem:function(a,c){a.legendGroup[c?"removeClass":"addClass"]("highcharts-legend-item-hidden");
	var b=this.options,d=a.legendItem,f=a.legendLine,p=a.legendSymbol,e=this.itemHiddenStyle.color,b=c?b.itemStyle.color:e,n=c?a.color||e:e,k=a.options&&a.options.marker,l={fill:n},m;d&&d.css({fill:b,color:b});f&&f.attr({stroke:n});if(p){if(k&&p.isMarker&&(l=a.pointAttribs(),!c))for(m in l)l[m]=e;p.attr(l)}},positionItem:function(a){var b=this.options,c=b.symbolPadding,b=!b.rtl,d=a._legendItemPos,f=d[0],d=d[1],n=a.checkbox;(a=a.legendGroup)&&a.element&&a.translate(b?f:this.legendWidth-f-2*c-4,d);n&&(n.x=
	f,n.y=d)},destroyItem:function(a){var b=a.checkbox;f(["legendItem","legendLine","legendSymbol","legendGroup"],function(b){a[b]&&(a[b]=a[b].destroy())});b&&G(a.checkbox)},destroy:function(){function a(a){this[a]&&(this[a]=this[a].destroy())}f(this.getAllItems(),function(b){f(["legendItem","legendGroup"],a,b)});f("clipRect up down pager nav box title group".split(" "),a,this);this.display=null},positionCheckboxes:function(a){var b=this.group&&this.group.alignAttr,c,d=this.clipHeight||this.legendHeight,
	n=this.titleHeight;b&&(c=b.translateY,f(this.allItems,function(h){var e=h.checkbox,f;e&&(f=c+n+e.y+(a||0)+3,H(e,{left:b.translateX+h.checkboxOffset+e.x-20+"px",top:f+"px",display:f>c-6&&f<c+d-6?"":"none"}))}))},renderTitle:function(){var a=this.padding,c=this.options.title,h=0;c.text&&(this.title||(this.title=this.chart.renderer.label(c.text,a-3,a-4,null,null,null,null,null,"legend-title").attr({zIndex:1}).css(c.style).add(this.group)),a=this.title.getBBox(),h=a.height,this.offsetWidth=a.width,this.contentGroup.attr({translateY:h}));
	this.titleHeight=h},setText:function(b){var c=this.options;b.legendItem.attr({text:c.labelFormat?a.format(c.labelFormat,b):c.labelFormatter.call(b)})},renderItem:function(a){var b=this.chart,c=b.renderer,d=this.options,f="horizontal"===d.layout,n=this.symbolWidth,e=d.symbolPadding,l=this.itemStyle,q=this.itemHiddenStyle,r=this.padding,m=f?u(d.itemDistance,20):0,y=!d.rtl,I=d.width,K=d.itemMarginBottom||0,J=this.itemMarginTop,g=a.legendItem,z=!a.series,Q=!z&&a.series.drawLegendSymbol?a.series:a,A=Q.options,
	A=this.createCheckboxForItem&&A&&A.showCheckbox,B=d.useHTML,H=a.options.className;g||(a.legendGroup=c.g("legend-item").addClass("highcharts-"+Q.type+"-series highcharts-color-"+a.colorIndex+(H?" "+H:"")+(z?" highcharts-series-"+a.index:"")).attr({zIndex:1}).add(this.scrollGroup),a.legendItem=g=c.text("",y?n+e:-e,this.baseline||0,B).css(k(a.visible?l:q)).attr({align:y?"left":"right",zIndex:2}).add(a.legendGroup),this.baseline||(l=l.fontSize,this.fontMetrics=c.fontMetrics(l,g),this.baseline=this.fontMetrics.f+
	3+J,g.attr("y",this.baseline)),this.symbolHeight=d.symbolHeight||this.fontMetrics.f,Q.drawLegendSymbol(this,a),this.setItemEvents&&this.setItemEvents(a,g,B),A&&this.createCheckboxForItem(a));this.colorizeItem(a,a.visible);this.setText(a);c=g.getBBox();n=a.checkboxOffset=d.itemWidth||a.legendItemWidth||n+e+c.width+m+(A?20:0);this.itemHeight=e=Math.round(a.legendItemHeight||c.height||this.symbolHeight);f&&this.itemX-r+n>(I||b.spacingBox.width-2*r-d.x)&&(this.itemX=r,this.itemY+=J+this.lastLineHeight+
	K,this.lastLineHeight=0);this.maxItemWidth=Math.max(this.maxItemWidth,n);this.lastItemY=J+this.itemY+K;this.lastLineHeight=Math.max(e,this.lastLineHeight);a._legendItemPos=[this.itemX,this.itemY];f?this.itemX+=n:(this.itemY+=J+e+K,this.lastLineHeight=e);this.offsetWidth=I||Math.max((f?this.itemX-r-m:n)+r,this.offsetWidth)},getAllItems:function(){var a=[];f(this.chart.series,function(b){var c=b&&b.options;b&&u(c.showInLegend,r(c.linkedTo)?!1:void 0,!0)&&(a=a.concat(b.legendItems||("point"===c.legendType?
	b.data:b)))});return a},adjustMargins:function(a,c){var b=this.chart,d=this.options,p=d.align.charAt(0)+d.verticalAlign.charAt(0)+d.layout.charAt(0);d.floating||f([/(lth|ct|rth)/,/(rtv|rm|rbv)/,/(rbh|cb|lbh)/,/(lbv|lm|ltv)/],function(h,e){h.test(p)&&!r(a[e])&&(b[q[e]]=Math.max(b[q[e]],b.legend[(e+1)%2?"legendHeight":"legendWidth"]+[1,-1,-1,1][e]*d[e%2?"x":"y"]+u(d.margin,12)+c[e]))})},render:function(){var a=this,d=a.chart,h=d.renderer,n=a.group,l,q,e,x,u=a.box,r=a.options,m=a.padding;a.itemX=m;a.itemY=
	a.initialItemY;a.offsetWidth=0;a.lastItemY=0;n||(a.group=n=h.g("legend").attr({zIndex:7}).add(),a.contentGroup=h.g().attr({zIndex:1}).add(n),a.scrollGroup=h.g().add(a.contentGroup));a.renderTitle();l=a.getAllItems();c(l,function(a,b){return(a.options&&a.options.legendIndex||0)-(b.options&&b.options.legendIndex||0)});r.reversed&&l.reverse();a.allItems=l;a.display=q=!!l.length;a.lastLineHeight=0;f(l,function(b){a.renderItem(b)});e=(r.width||a.offsetWidth)+m;x=a.lastItemY+a.lastLineHeight+a.titleHeight;
	x=a.handleOverflow(x);x+=m;u||(a.box=u=h.rect().addClass("highcharts-legend-box").attr({r:r.borderRadius}).add(n),u.isNew=!0);u.attr({stroke:r.borderColor,"stroke-width":r.borderWidth||0,fill:r.backgroundColor||"none"}).shadow(r.shadow);0<e&&0<x&&(u[u.isNew?"attr":"animate"](u.crisp({x:0,y:0,width:e,height:x},u.strokeWidth())),u.isNew=!1);u[q?"show":"hide"]();a.legendWidth=e;a.legendHeight=x;f(l,function(b){a.positionItem(b)});q&&n.align(k(r,{width:e,height:x}),!0,"spacingBox");d.isResizing||this.positionCheckboxes()},
	handleOverflow:function(a){var b=this,c=this.chart,d=c.renderer,n=this.options,k=n.y,e=this.padding,c=c.spacingBox.height+("top"===n.verticalAlign?-k:k)-e,k=n.maxHeight,l,q=this.clipRect,r=n.navigation,m=u(r.animation,!0),y=r.arrowSize||12,I=this.nav,K=this.pages,J,g=this.allItems,z=function(a){a?q.attr({height:a}):q&&(b.clipRect=q.destroy(),b.contentGroup.clip());b.contentGroup.div&&(b.contentGroup.div.style.clip=a?"rect("+e+"px,9999px,"+(e+a)+"px,0)":"auto")};"horizontal"!==n.layout||"middle"===
	n.verticalAlign||n.floating||(c/=2);k&&(c=Math.min(c,k));K.length=0;a>c&&!1!==r.enabled?(this.clipHeight=l=Math.max(c-20-this.titleHeight-e,0),this.currentPage=u(this.currentPage,1),this.fullHeight=a,f(g,function(a,b){var c=a._legendItemPos[1];a=Math.round(a.legendItem.getBBox().height);var e=K.length;if(!e||c-K[e-1]>l&&(J||c)!==K[e-1])K.push(J||c),e++;b===g.length-1&&c+a-K[e-1]>l&&K.push(c);c!==J&&(J=c)}),q||(q=b.clipRect=d.clipRect(0,e,9999,0),b.contentGroup.clip(q)),z(l),I||(this.nav=I=d.g().attr({zIndex:1}).add(this.group),
	this.up=d.symbol("triangle",0,0,y,y).on("click",function(){b.scroll(-1,m)}).add(I),this.pager=d.text("",15,10).addClass("highcharts-legend-navigation").css(r.style).add(I),this.down=d.symbol("triangle-down",0,0,y,y).on("click",function(){b.scroll(1,m)}).add(I)),b.scroll(0),a=c):I&&(z(),this.nav=I.destroy(),this.scrollGroup.attr({translateY:1}),this.clipHeight=0);return a},scroll:function(a,c){var b=this.pages,f=b.length;a=this.currentPage+a;var p=this.clipHeight,n=this.options.navigation,e=this.pager,
	k=this.padding;a>f&&(a=f);0<a&&(void 0!==c&&d(c,this.chart),this.nav.attr({translateX:k,translateY:p+this.padding+7+this.titleHeight,visibility:"visible"}),this.up.attr({"class":1===a?"highcharts-legend-nav-inactive":"highcharts-legend-nav-active"}),e.attr({text:a+"/"+f}),this.down.attr({x:18+this.pager.getBBox().width,"class":a===f?"highcharts-legend-nav-inactive":"highcharts-legend-nav-active"}),this.up.attr({fill:1===a?n.inactiveColor:n.activeColor}).css({cursor:1===a?"default":"pointer"}),this.down.attr({fill:a===
	f?n.inactiveColor:n.activeColor}).css({cursor:a===f?"default":"pointer"}),c=-b[a-1]+this.initialItemY,this.scrollGroup.animate({translateY:c}),this.currentPage=a,this.positionCheckboxes(c))}};a.LegendSymbolMixin={drawRectangle:function(a,c){var b=a.symbolHeight,d=a.options.squareSymbol;c.legendSymbol=this.chart.renderer.rect(d?(a.symbolWidth-b)/2:0,a.baseline-b+1,d?b:a.symbolWidth,b,u(a.options.symbolRadius,b/2)).addClass("highcharts-point").attr({zIndex:3}).add(c.legendGroup)},drawLineMarker:function(a){var b=
	this.options,c=b.marker,d=a.symbolWidth,f=a.symbolHeight,n=f/2,e=this.chart.renderer,l=this.legendGroup;a=a.baseline-Math.round(.3*a.fontMetrics.b);var q;q={"stroke-width":b.lineWidth||0};b.dashStyle&&(q.dashstyle=b.dashStyle);this.legendLine=e.path(["M",0,a,"L",d,a]).addClass("highcharts-graph").attr(q).add(l);c&&!1!==c.enabled&&(b=Math.min(u(c.radius,n),n),0===this.symbol.indexOf("url")&&(c=k(c,{width:f,height:f}),b=0),this.legendSymbol=c=e.symbol(this.symbol,d/2-b,a-b,2*b,2*b,c).addClass("highcharts-point").add(l),
	c.isMarker=!0)}};(/Trident\/7\.0/.test(n.navigator.userAgent)||l)&&z(B.prototype,"positionItem",function(a,c){var b=this,d=function(){c._legendItemPos&&a.call(b,c)};d();setTimeout(d)})})(L);(function(a){var B=a.addEvent,A=a.animate,H=a.animObject,G=a.attr,r=a.doc,f=a.Axis,l=a.createElement,q=a.defaultOptions,k=a.discardElement,u=a.charts,d=a.css,c=a.defined,n=a.each,z=a.extend,b=a.find,p=a.fireEvent,h=a.getStyle,t=a.grep,D=a.isNumber,w=a.isObject,e=a.isString,x=a.Legend,C=a.marginNames,E=a.merge,
	m=a.Pointer,y=a.pick,I=a.pInt,K=a.removeEvent,J=a.seriesTypes,g=a.splat,F=a.svg,Q=a.syncTimeout,N=a.win,P=a.Renderer,O=a.Chart=function(){this.getArgs.apply(this,arguments)};a.chart=function(a,b,c){return new O(a,b,c)};O.prototype={callbacks:[],getArgs:function(){var a=[].slice.call(arguments);if(e(a[0])||a[0].nodeName)this.renderTo=a.shift();this.init(a[0],a[1])},init:function(b,c){var e,g=b.series;b.series=null;e=E(q,b);e.series=b.series=g;this.userOptions=b;b=e.chart;g=b.events;this.margin=[];
	this.spacing=[];this.bounds={h:{},v:{}};this.callback=c;this.isResizing=0;this.options=e;this.axes=[];this.series=[];this.hasCartesianSeries=b.showAxes;var d;this.index=u.length;u.push(this);a.chartCount++;if(g)for(d in g)B(this,d,g[d]);this.xAxis=[];this.yAxis=[];this.pointCount=this.colorCounter=this.symbolCounter=0;this.firstRender()},initSeries:function(b){var c=this.options.chart;(c=J[b.type||c.type||c.defaultSeriesType])||a.error(17,!0);c=new c;c.init(this,b);return c},orderSeries:function(a){var b=
	this.series;for(a=a||0;a<b.length;a++)b[a]&&(b[a].index=a,b[a].name=b[a].name||"Series "+(b[a].index+1))},isInsidePlot:function(a,b,c){var e=c?b:a;a=c?a:b;return 0<=e&&e<=this.plotWidth&&0<=a&&a<=this.plotHeight},redraw:function(b){var c=this.axes,e=this.series,g=this.pointer,d=this.legend,m=this.isDirtyLegend,h,f,v=this.hasCartesianSeries,k=this.isDirtyBox,y,l=this.renderer,t=l.isHidden(),q=[];this.setResponsive&&this.setResponsive(!1);a.setAnimation(b,this);t&&this.cloneRenderTo();this.layOutTitles();
	for(b=e.length;b--;)if(y=e[b],y.options.stacking&&(h=!0,y.isDirty)){f=!0;break}if(f)for(b=e.length;b--;)y=e[b],y.options.stacking&&(y.isDirty=!0);n(e,function(a){a.isDirty&&"point"===a.options.legendType&&(a.updateTotals&&a.updateTotals(),m=!0);a.isDirtyData&&p(a,"updatedData")});m&&d.options.enabled&&(d.render(),this.isDirtyLegend=!1);h&&this.getStacks();v&&n(c,function(a){a.updateNames();a.setScale()});this.getMargins();v&&(n(c,function(a){a.isDirty&&(k=!0)}),n(c,function(a){var b=a.min+","+a.max;
	a.extKey!==b&&(a.extKey=b,q.push(function(){p(a,"afterSetExtremes",z(a.eventArgs,a.getExtremes()));delete a.eventArgs}));(k||h)&&a.redraw()}));k&&this.drawChartBox();p(this,"predraw");n(e,function(a){(k||a.isDirty)&&a.visible&&a.redraw();a.isDirtyData=!1});g&&g.reset(!0);l.draw();p(this,"redraw");p(this,"render");t&&this.cloneRenderTo(!0);n(q,function(a){a.call()})},get:function(a){function c(b){return b.id===a||b.options&&b.options.id===a}var e,g=this.series,d;e=b(this.axes,c)||b(this.series,c);
	for(d=0;!e&&d<g.length;d++)e=b(g[d].points||[],c);return e},getAxes:function(){var a=this,b=this.options,c=b.xAxis=g(b.xAxis||{}),b=b.yAxis=g(b.yAxis||{});n(c,function(a,b){a.index=b;a.isX=!0});n(b,function(a,b){a.index=b});c=c.concat(b);n(c,function(b){new f(a,b)})},getSelectedPoints:function(){var a=[];n(this.series,function(b){a=a.concat(t(b.points||[],function(a){return a.selected}))});return a},getSelectedSeries:function(){return t(this.series,function(a){return a.selected})},setTitle:function(a,
	b,c){var e=this,g=e.options,d;d=g.title=E({style:{color:"#333333",fontSize:g.isStock?"16px":"18px"}},g.title,a);g=g.subtitle=E({style:{color:"#666666"}},g.subtitle,b);n([["title",a,d],["subtitle",b,g]],function(a,b){var c=a[0],g=e[c],d=a[1];a=a[2];g&&d&&(e[c]=g=g.destroy());a&&a.text&&!g&&(e[c]=e.renderer.text(a.text,0,0,a.useHTML).attr({align:a.align,"class":"highcharts-"+c,zIndex:a.zIndex||4}).add(),e[c].update=function(a){e.setTitle(!b&&a,b&&a)},e[c].css(a.style))});e.layOutTitles(c)},layOutTitles:function(a){var b=
	0,c,e=this.renderer,g=this.spacingBox;n(["title","subtitle"],function(a){var c=this[a],d=this.options[a],m;c&&(m=d.style.fontSize,m=e.fontMetrics(m,c).b,c.css({width:(d.width||g.width+d.widthAdjust)+"px"}).align(z({y:b+m+("title"===a?-3:2)},d),!1,"spacingBox"),d.floating||d.verticalAlign||(b=Math.ceil(b+c.getBBox(d.useHTML).height)))},this);c=this.titleOffset!==b;this.titleOffset=b;!this.isDirtyBox&&c&&(this.isDirtyBox=c,this.hasRendered&&y(a,!0)&&this.isDirtyBox&&this.redraw())},getChartSize:function(){var b=
	this.options.chart,e=b.width,b=b.height,g=this.renderToClone||this.renderTo;c(e)||(this.containerWidth=h(g,"width"));c(b)||(this.containerHeight=h(g,"height"));this.chartWidth=Math.max(0,e||this.containerWidth||600);this.chartHeight=Math.max(0,a.relativeLength(b,this.chartWidth)||this.containerHeight||400)},cloneRenderTo:function(a){var b=this.renderToClone,c=this.container;if(a){if(b){for(;b.childNodes.length;)this.renderTo.appendChild(b.firstChild);k(b);delete this.renderToClone}}else c&&c.parentNode===
	this.renderTo&&this.renderTo.removeChild(c),this.renderToClone=b=this.renderTo.cloneNode(0),d(b,{position:"absolute",top:"-9999px",display:"block"}),b.style.setProperty&&b.style.setProperty("display","block","important"),r.body.appendChild(b),c&&b.appendChild(c)},setClassName:function(a){this.container.className="highcharts-container "+(a||"")},getContainer:function(){var b,c=this.options,g=c.chart,d,m;b=this.renderTo;var h=a.uniqueKey(),f;b||(this.renderTo=b=g.renderTo);e(b)&&(this.renderTo=b=r.getElementById(b));
	b||a.error(13,!0);d=I(G(b,"data-highcharts-chart"));D(d)&&u[d]&&u[d].hasRendered&&u[d].destroy();G(b,"data-highcharts-chart",this.index);b.innerHTML="";g.skipClone||b.offsetWidth||this.cloneRenderTo();this.getChartSize();d=this.chartWidth;m=this.chartHeight;f=z({position:"relative",overflow:"hidden",width:d+"px",height:m+"px",textAlign:"left",lineHeight:"normal",zIndex:0,"-webkit-tap-highlight-color":"rgba(0,0,0,0)"},g.style);this.container=b=l("div",{id:h},f,this.renderToClone||b);this._cursor=b.style.cursor;
	this.renderer=new (a[g.renderer]||P)(b,d,m,null,g.forExport,c.exporting&&c.exporting.allowHTML);this.setClassName(g.className);this.renderer.setStyle(g.style);this.renderer.chartIndex=this.index},getMargins:function(a){var b=this.spacing,e=this.margin,g=this.titleOffset;this.resetMargins();g&&!c(e[0])&&(this.plotTop=Math.max(this.plotTop,g+this.options.title.margin+b[0]));this.legend.display&&this.legend.adjustMargins(e,b);this.extraMargin&&(this[this.extraMargin.type]=(this[this.extraMargin.type]||
	0)+this.extraMargin.value);this.extraTopMargin&&(this.plotTop+=this.extraTopMargin);a||this.getAxisMargins()},getAxisMargins:function(){var a=this,b=a.axisOffset=[0,0,0,0],e=a.margin;a.hasCartesianSeries&&n(a.axes,function(a){a.visible&&a.getOffset()});n(C,function(g,d){c(e[d])||(a[g]+=b[d])});a.setChartSize()},reflow:function(a){var b=this,e=b.options.chart,g=b.renderTo,d=c(e.width),m=e.width||h(g,"width"),e=e.height||h(g,"height"),g=a?a.target:N;if(!d&&!b.isPrinting&&m&&e&&(g===N||g===r)){if(m!==
	b.containerWidth||e!==b.containerHeight)clearTimeout(b.reflowTimeout),b.reflowTimeout=Q(function(){b.container&&b.setSize(void 0,void 0,!1)},a?100:0);b.containerWidth=m;b.containerHeight=e}},initReflow:function(){var a=this,b;b=B(N,"resize",function(b){a.reflow(b)});B(a,"destroy",b)},setSize:function(b,c,e){var g=this,m=g.renderer;g.isResizing+=1;a.setAnimation(e,g);g.oldChartHeight=g.chartHeight;g.oldChartWidth=g.chartWidth;void 0!==b&&(g.options.chart.width=b);void 0!==c&&(g.options.chart.height=
	c);g.getChartSize();b=m.globalAnimation;(b?A:d)(g.container,{width:g.chartWidth+"px",height:g.chartHeight+"px"},b);g.setChartSize(!0);m.setSize(g.chartWidth,g.chartHeight,e);n(g.axes,function(a){a.isDirty=!0;a.setScale()});g.isDirtyLegend=!0;g.isDirtyBox=!0;g.layOutTitles();g.getMargins();g.redraw(e);g.oldChartHeight=null;p(g,"resize");Q(function(){g&&p(g,"endResize",null,function(){--g.isResizing})},H(b).duration)},setChartSize:function(a){var b=this.inverted,c=this.renderer,e=this.chartWidth,g=
	this.chartHeight,d=this.options.chart,m=this.spacing,h=this.clipOffset,f,p,k,y;this.plotLeft=f=Math.round(this.plotLeft);this.plotTop=p=Math.round(this.plotTop);this.plotWidth=k=Math.max(0,Math.round(e-f-this.marginRight));this.plotHeight=y=Math.max(0,Math.round(g-p-this.marginBottom));this.plotSizeX=b?y:k;this.plotSizeY=b?k:y;this.plotBorderWidth=d.plotBorderWidth||0;this.spacingBox=c.spacingBox={x:m[3],y:m[0],width:e-m[3]-m[1],height:g-m[0]-m[2]};this.plotBox=c.plotBox={x:f,y:p,width:k,height:y};
	e=2*Math.floor(this.plotBorderWidth/2);b=Math.ceil(Math.max(e,h[3])/2);c=Math.ceil(Math.max(e,h[0])/2);this.clipBox={x:b,y:c,width:Math.floor(this.plotSizeX-Math.max(e,h[1])/2-b),height:Math.max(0,Math.floor(this.plotSizeY-Math.max(e,h[2])/2-c))};a||n(this.axes,function(a){a.setAxisSize();a.setAxisTranslation()})},resetMargins:function(){var a=this,b=a.options.chart;n(["margin","spacing"],function(c){var e=b[c],g=w(e)?e:[e,e,e,e];n(["Top","Right","Bottom","Left"],function(e,d){a[c][d]=y(b[c+e],g[d])})});
	n(C,function(b,c){a[b]=y(a.margin[c],a.spacing[c])});a.axisOffset=[0,0,0,0];a.clipOffset=[0,0,0,0]},drawChartBox:function(){var a=this.options.chart,b=this.renderer,c=this.chartWidth,e=this.chartHeight,g=this.chartBackground,d=this.plotBackground,m=this.plotBorder,h,f=this.plotBGImage,n=a.backgroundColor,p=a.plotBackgroundColor,k=a.plotBackgroundImage,y,l=this.plotLeft,t=this.plotTop,q=this.plotWidth,u=this.plotHeight,x=this.plotBox,r=this.clipRect,w=this.clipBox,I="animate";g||(this.chartBackground=
	g=b.rect().addClass("highcharts-background").add(),I="attr");h=a.borderWidth||0;y=h+(a.shadow?8:0);n={fill:n||"none"};if(h||g["stroke-width"])n.stroke=a.borderColor,n["stroke-width"]=h;g.attr(n).shadow(a.shadow);g[I]({x:y/2,y:y/2,width:c-y-h%2,height:e-y-h%2,r:a.borderRadius});I="animate";d||(I="attr",this.plotBackground=d=b.rect().addClass("highcharts-plot-background").add());d[I](x);d.attr({fill:p||"none"}).shadow(a.plotShadow);k&&(f?f.animate(x):this.plotBGImage=b.image(k,l,t,q,u).add());r?r.animate({width:w.width,
	height:w.height}):this.clipRect=b.clipRect(w);I="animate";m||(I="attr",this.plotBorder=m=b.rect().addClass("highcharts-plot-border").attr({zIndex:1}).add());m.attr({stroke:a.plotBorderColor,"stroke-width":a.plotBorderWidth||0,fill:"none"});m[I](m.crisp({x:l,y:t,width:q,height:u},-m.strokeWidth()));this.isDirtyBox=!1},propFromSeries:function(){var a=this,b=a.options.chart,c,e=a.options.series,g,d;n(["inverted","angular","polar"],function(m){c=J[b.type||b.defaultSeriesType];d=b[m]||c&&c.prototype[m];
	for(g=e&&e.length;!d&&g--;)(c=J[e[g].type])&&c.prototype[m]&&(d=!0);a[m]=d})},linkSeries:function(){var a=this,b=a.series;n(b,function(a){a.linkedSeries.length=0});n(b,function(b){var c=b.options.linkedTo;e(c)&&(c=":previous"===c?a.series[b.index-1]:a.get(c))&&c.linkedParent!==b&&(c.linkedSeries.push(b),b.linkedParent=c,b.visible=y(b.options.visible,c.options.visible,b.visible))})},renderSeries:function(){n(this.series,function(a){a.translate();a.render()})},renderLabels:function(){var a=this,b=a.options.labels;
	b.items&&n(b.items,function(c){var e=z(b.style,c.style),g=I(e.left)+a.plotLeft,d=I(e.top)+a.plotTop+12;delete e.left;delete e.top;a.renderer.text(c.html,g,d).attr({zIndex:2}).css(e).add()})},render:function(){var a=this.axes,b=this.renderer,c=this.options,e,g,d;this.setTitle();this.legend=new x(this,c.legend);this.getStacks&&this.getStacks();this.getMargins(!0);this.setChartSize();c=this.plotWidth;e=this.plotHeight-=21;n(a,function(a){a.setScale()});this.getAxisMargins();g=1.1<c/this.plotWidth;d=
	1.05<e/this.plotHeight;if(g||d)n(a,function(a){(a.horiz&&g||!a.horiz&&d)&&a.setTickInterval(!0)}),this.getMargins();this.drawChartBox();this.hasCartesianSeries&&n(a,function(a){a.visible&&a.render()});this.seriesGroup||(this.seriesGroup=b.g("series-group").attr({zIndex:3}).add());this.renderSeries();this.renderLabels();this.addCredits();this.setResponsive&&this.setResponsive();this.hasRendered=!0},addCredits:function(a){var b=this;a=E(!0,this.options.credits,a);a.enabled&&!this.credits&&(this.credits=
	this.renderer.text(a.text+(this.mapCredits||""),0,0).addClass("highcharts-credits").on("click",function(){a.href&&(N.location.href=a.href)}).attr({align:a.position.align,zIndex:8}).css(a.style).add().align(a.position),this.credits.update=function(a){b.credits=b.credits.destroy();b.addCredits(a)})},destroy:function(){var b=this,c=b.axes,e=b.series,g=b.container,d,m=g&&g.parentNode;p(b,"destroy");u[b.index]=void 0;a.chartCount--;b.renderTo.removeAttribute("data-highcharts-chart");K(b);for(d=c.length;d--;)c[d]=
	c[d].destroy();this.scroller&&this.scroller.destroy&&this.scroller.destroy();for(d=e.length;d--;)e[d]=e[d].destroy();n("title subtitle chartBackground plotBackground plotBGImage plotBorder seriesGroup clipRect credits pointer rangeSelector legend resetZoomButton tooltip renderer".split(" "),function(a){var c=b[a];c&&c.destroy&&(b[a]=c.destroy())});g&&(g.innerHTML="",K(g),m&&k(g));for(d in b)delete b[d]},isReadyToRender:function(){var a=this;return F||N!=N.top||"complete"===r.readyState?!0:(r.attachEvent("onreadystatechange",
	function(){r.detachEvent("onreadystatechange",a.firstRender);"complete"===r.readyState&&a.firstRender()}),!1)},firstRender:function(){var a=this,b=a.options;if(a.isReadyToRender()){a.getContainer();p(a,"init");a.resetMargins();a.setChartSize();a.propFromSeries();a.getAxes();n(b.series||[],function(b){a.initSeries(b)});a.linkSeries();p(a,"beforeRender");m&&(a.pointer=new m(a,b));a.render();if(!a.renderer.imgCount&&a.onload)a.onload();a.cloneRenderTo(!0)}},onload:function(){n([this.callback].concat(this.callbacks),
	function(a){a&&void 0!==this.index&&a.apply(this,[this])},this);p(this,"load");p(this,"render");c(this.index)&&!1!==this.options.chart.reflow&&this.initReflow();this.onload=null}}})(L);(function(a){var B,A=a.each,H=a.extend,G=a.erase,r=a.fireEvent,f=a.format,l=a.isArray,q=a.isNumber,k=a.pick,u=a.removeEvent;B=a.Point=function(){};B.prototype={init:function(a,c,f){this.series=a;this.color=a.color;this.applyOptions(c,f);a.options.colorByPoint?(c=a.options.colors||a.chart.options.colors,this.color=this.color||
	c[a.colorCounter],c=c.length,f=a.colorCounter,a.colorCounter++,a.colorCounter===c&&(a.colorCounter=0)):f=a.colorIndex;this.colorIndex=k(this.colorIndex,f);a.chart.pointCount++;return this},applyOptions:function(a,c){var d=this.series,f=d.options.pointValKey||d.pointValKey;a=B.prototype.optionsToObject.call(this,a);H(this,a);this.options=this.options?H(this.options,a):a;a.group&&delete this.group;f&&(this.y=this[f]);this.isNull=k(this.isValid&&!this.isValid(),null===this.x||!q(this.y,!0));this.selected&&
	(this.state="select");"name"in this&&void 0===c&&d.xAxis&&d.xAxis.hasNames&&(this.x=d.xAxis.nameToX(this));void 0===this.x&&d&&(this.x=void 0===c?d.autoIncrement(this):c);return this},optionsToObject:function(a){var c={},d=this.series,f=d.options.keys,b=f||d.pointArrayMap||["y"],p=b.length,h=0,k=0;if(q(a)||null===a)c[b[0]]=a;else if(l(a))for(!f&&a.length>p&&(d=typeof a[0],"string"===d?c.name=a[0]:"number"===d&&(c.x=a[0]),h++);k<p;)f&&void 0===a[h]||(c[b[k]]=a[h]),h++,k++;else"object"===typeof a&&
	(c=a,a.dataLabels&&(d._hasPointLabels=!0),a.marker&&(d._hasPointMarkers=!0));return c},getClassName:function(){return"highcharts-point"+(this.selected?" highcharts-point-select":"")+(this.negative?" highcharts-negative":"")+(this.isNull?" highcharts-null-point":"")+(void 0!==this.colorIndex?" highcharts-color-"+this.colorIndex:"")+(this.options.className?" "+this.options.className:"")+(this.zone&&this.zone.className?" "+this.zone.className.replace("highcharts-negative",""):"")},getZone:function(){var a=
	this.series,c=a.zones,a=a.zoneAxis||"y",f=0,k;for(k=c[f];this[a]>=k.value;)k=c[++f];k&&k.color&&!this.options.color&&(this.color=k.color);return k},destroy:function(){var a=this.series.chart,c=a.hoverPoints,f;a.pointCount--;c&&(this.setState(),G(c,this),c.length||(a.hoverPoints=null));if(this===a.hoverPoint)this.onMouseOut();if(this.graphic||this.dataLabel)u(this),this.destroyElements();this.legendItem&&a.legend.destroyItem(this);for(f in this)this[f]=null},destroyElements:function(){for(var a=["graphic",
	"dataLabel","dataLabelUpper","connector","shadowGroup"],c,f=6;f--;)c=a[f],this[c]&&(this[c]=this[c].destroy())},getLabelConfig:function(){return{x:this.category,y:this.y,color:this.color,colorIndex:this.colorIndex,key:this.name||this.category,series:this.series,point:this,percentage:this.percentage,total:this.total||this.stackTotal}},tooltipFormatter:function(a){var c=this.series,d=c.tooltipOptions,l=k(d.valueDecimals,""),b=d.valuePrefix||"",p=d.valueSuffix||"";A(c.pointArrayMap||["y"],function(c){c=
	"{point."+c;if(b||p)a=a.replace(c+"}",b+c+"}"+p);a=a.replace(c+"}",c+":,."+l+"f}")});return f(a,{point:this,series:this.series})},firePointEvent:function(a,c,f){var d=this,b=this.series.options;(b.point.events[a]||d.options&&d.options.events&&d.options.events[a])&&this.importEvents();"click"===a&&b.allowPointSelect&&(f=function(a){d.select&&d.select(null,a.ctrlKey||a.metaKey||a.shiftKey)});r(this,a,c,f)},visible:!0}})(L);(function(a){var B=a.addEvent,A=a.animObject,H=a.arrayMax,G=a.arrayMin,r=a.correctFloat,
	f=a.Date,l=a.defaultOptions,q=a.defaultPlotOptions,k=a.defined,u=a.each,d=a.erase,c=a.extend,n=a.fireEvent,z=a.grep,b=a.isArray,p=a.isNumber,h=a.isString,t=a.merge,D=a.pick,w=a.removeEvent,e=a.splat,x=a.SVGElement,C=a.syncTimeout,E=a.win;a.Series=a.seriesType("line",null,{lineWidth:2,allowPointSelect:!1,showCheckbox:!1,animation:{duration:1E3},events:{},marker:{lineWidth:0,lineColor:"#ffffff",radius:4,states:{hover:{animation:{duration:50},enabled:!0,radiusPlus:2,lineWidthPlus:1},select:{fillColor:"#cccccc",
	lineColor:"#000000",lineWidth:2}}},point:{events:{}},dataLabels:{align:"center",formatter:function(){return null===this.y?"":a.numberFormat(this.y,-1)},style:{fontSize:"11px",fontWeight:"bold",color:"contrast",textOutline:"1px contrast"},verticalAlign:"bottom",x:0,y:0,padding:5},cropThreshold:300,pointRange:0,softThreshold:!0,states:{hover:{animation:{duration:50},lineWidthPlus:1,marker:{},halo:{size:10,opacity:.25}},select:{marker:{}}},stickyTracking:!0,turboThreshold:1E3,findNearestPointBy:"x"},
	{isCartesian:!0,pointClass:a.Point,sorted:!0,requireSorting:!0,directTouch:!1,axisTypes:["xAxis","yAxis"],colorCounter:0,parallelArrays:["x","y"],coll:"series",init:function(a,b){var e=this,d,m,g=a.series,h;e.chart=a;e.options=b=e.setOptions(b);e.linkedSeries=[];e.bindAxes();c(e,{name:b.name,state:"",visible:!1!==b.visible,selected:!0===b.selected});m=b.events;for(d in m)B(e,d,m[d]);if(m&&m.click||b.point&&b.point.events&&b.point.events.click||b.allowPointSelect)a.runTrackerClick=!0;e.getColor();
	e.getSymbol();u(e.parallelArrays,function(a){e[a+"Data"]=[]});e.setData(b.data,!1);e.isCartesian&&(a.hasCartesianSeries=!0);g.length&&(h=g[g.length-1]);e._i=D(h&&h._i,-1)+1;a.orderSeries(this.insert(g))},insert:function(a){var b=this.options.index,c;if(p(b)){for(c=a.length;c--;)if(b>=D(a[c].options.index,a[c]._i)){a.splice(c+1,0,this);break}-1===c&&a.unshift(this);c+=1}else a.push(this);return D(c,a.length-1)},bindAxes:function(){var b=this,c=b.options,e=b.chart,d;u(b.axisTypes||[],function(m){u(e[m],
	function(a){d=a.options;if(c[m]===d.index||void 0!==c[m]&&c[m]===d.id||void 0===c[m]&&0===d.index)b.insert(a.series),b[m]=a,a.isDirty=!0});b[m]||b.optionalAxis===m||a.error(18,!0)})},updateParallelArrays:function(a,b){var c=a.series,e=arguments,d=p(b)?function(e){var g="y"===e&&c.toYData?c.toYData(a):a[e];c[e+"Data"][b]=g}:function(a){Array.prototype[b].apply(c[a+"Data"],Array.prototype.slice.call(e,2))};u(c.parallelArrays,d)},autoIncrement:function(){var a=this.options,b=this.xIncrement,c,e=a.pointIntervalUnit,
	b=D(b,a.pointStart,0);this.pointInterval=c=D(this.pointInterval,a.pointInterval,1);e&&(a=new f(b),"day"===e?a=+a[f.hcSetDate](a[f.hcGetDate]()+c):"month"===e?a=+a[f.hcSetMonth](a[f.hcGetMonth]()+c):"year"===e&&(a=+a[f.hcSetFullYear](a[f.hcGetFullYear]()+c)),c=a-b);this.xIncrement=b+c;return b},setOptions:function(a){var b=this.chart,c=b.options.plotOptions,b=b.userOptions||{},e=b.plotOptions||{},d=c[this.type];this.userOptions=a;c=t(d,c.series,a);this.tooltipOptions=t(l.tooltip,l.plotOptions[this.type].tooltip,
	b.tooltip,e.series&&e.series.tooltip,e[this.type]&&e[this.type].tooltip,a.tooltip);this.stickyTracking=D(a.stickyTracking,e[this.type]&&e[this.type].stickyTracking,e.series&&e.series.stickyTracking,this.tooltipOptions.shared&&!this.noSharedTooltip?!0:c.stickyTracking);null===d.marker&&delete c.marker;this.zoneAxis=c.zoneAxis;a=this.zones=(c.zones||[]).slice();!c.negativeColor&&!c.negativeFillColor||c.zones||a.push({value:c[this.zoneAxis+"Threshold"]||c.threshold||0,className:"highcharts-negative",
	color:c.negativeColor,fillColor:c.negativeFillColor});a.length&&k(a[a.length-1].value)&&a.push({color:this.color,fillColor:this.fillColor});return c},getCyclic:function(a,b,c){var e,d=this.chart,g=this.userOptions,m=a+"Index",h=a+"Counter",f=c?c.length:D(d.options.chart[a+"Count"],d[a+"Count"]);b||(e=D(g[m],g["_"+m]),k(e)||(d.series.length||(d[h]=0),g["_"+m]=e=d[h]%f,d[h]+=1),c&&(b=c[e]));void 0!==e&&(this[m]=e);this[a]=b},getColor:function(){this.options.colorByPoint?this.options.color=null:this.getCyclic("color",
	this.options.color||q[this.type].color,this.chart.options.colors)},getSymbol:function(){this.getCyclic("symbol",this.options.marker.symbol,this.chart.options.symbols)},drawLegendSymbol:a.LegendSymbolMixin.drawLineMarker,setData:function(c,e,d,f){var m=this,g=m.points,k=g&&g.length||0,n,l=m.options,y=m.chart,t=null,q=m.xAxis,x=l.turboThreshold,r=this.xData,w=this.yData,C=(n=m.pointArrayMap)&&n.length;c=c||[];n=c.length;e=D(e,!0);if(!1!==f&&n&&k===n&&!m.cropped&&!m.hasGroupedData&&m.visible)u(c,function(a,
	b){g[b].update&&a!==l.data[b]&&g[b].update(a,!1,null,!1)});else{m.xIncrement=null;m.colorCounter=0;u(this.parallelArrays,function(a){m[a+"Data"].length=0});if(x&&n>x){for(d=0;null===t&&d<n;)t=c[d],d++;if(p(t))for(d=0;d<n;d++)r[d]=this.autoIncrement(),w[d]=c[d];else if(b(t))if(C)for(d=0;d<n;d++)t=c[d],r[d]=t[0],w[d]=t.slice(1,C+1);else for(d=0;d<n;d++)t=c[d],r[d]=t[0],w[d]=t[1];else a.error(12)}else for(d=0;d<n;d++)void 0!==c[d]&&(t={series:m},m.pointClass.prototype.applyOptions.apply(t,[c[d]]),m.updateParallelArrays(t,
	d));h(w[0])&&a.error(14,!0);m.data=[];m.options.data=m.userOptions.data=c;for(d=k;d--;)g[d]&&g[d].destroy&&g[d].destroy();q&&(q.minRange=q.userMinRange);m.isDirty=y.isDirtyBox=!0;m.isDirtyData=!!g;d=!1}"point"===l.legendType&&(this.processData(),this.generatePoints());e&&y.redraw(d)},processData:function(b){var c=this.xData,e=this.yData,d=c.length,m;m=0;var g,h,f=this.xAxis,p,k=this.options;p=k.cropThreshold;var n=this.getExtremesFromAll||k.getExtremesFromAll,l=this.isCartesian,k=f&&f.val2lin,t=f&&
	f.isLog,q,x;if(l&&!this.isDirty&&!f.isDirty&&!this.yAxis.isDirty&&!b)return!1;f&&(b=f.getExtremes(),q=b.min,x=b.max);if(l&&this.sorted&&!n&&(!p||d>p||this.forceCrop))if(c[d-1]<q||c[0]>x)c=[],e=[];else if(c[0]<q||c[d-1]>x)m=this.cropData(this.xData,this.yData,q,x),c=m.xData,e=m.yData,m=m.start,g=!0;for(p=c.length||1;--p;)d=t?k(c[p])-k(c[p-1]):c[p]-c[p-1],0<d&&(void 0===h||d<h)?h=d:0>d&&this.requireSorting&&a.error(15);this.cropped=g;this.cropStart=m;this.processedXData=c;this.processedYData=e;this.closestPointRange=
	h},cropData:function(a,b,c,e){var d=a.length,g=0,m=d,h=D(this.cropShoulder,1),f;for(f=0;f<d;f++)if(a[f]>=c){g=Math.max(0,f-h);break}for(c=f;c<d;c++)if(a[c]>e){m=c+h;break}return{xData:a.slice(g,m),yData:b.slice(g,m),start:g,end:m}},generatePoints:function(){var a=this.options.data,b=this.data,c,d=this.processedXData,h=this.processedYData,g=this.pointClass,f=d.length,p=this.cropStart||0,k,n=this.hasGroupedData,l,t=[],q;b||n||(b=[],b.length=a.length,b=this.data=b);for(q=0;q<f;q++)k=p+q,n?(l=(new g).init(this,
	[d[q]].concat(e(h[q]))),l.dataGroup=this.groupMap[q]):(l=b[k])||void 0===a[k]||(b[k]=l=(new g).init(this,a[k],d[q])),l&&(l.index=k,t[q]=l);if(b&&(f!==(c=b.length)||n))for(q=0;q<c;q++)q!==p||n||(q+=f),b[q]&&(b[q].destroyElements(),b[q].plotX=void 0);this.data=b;this.points=t},getExtremes:function(a){var c=this.yAxis,e=this.processedXData,d,m=[],g=0;d=this.xAxis.getExtremes();var h=d.min,f=d.max,k,n,l,t;a=a||this.stackedYData||this.processedYData||[];d=a.length;for(t=0;t<d;t++)if(n=e[t],l=a[t],k=(p(l,
	!0)||b(l))&&(!c.positiveValuesOnly||l.length||0<l),n=this.getExtremesFromAll||this.options.getExtremesFromAll||this.cropped||(e[t]||n)>=h&&(e[t]||n)<=f,k&&n)if(k=l.length)for(;k--;)null!==l[k]&&(m[g++]=l[k]);else m[g++]=l;this.dataMin=G(m);this.dataMax=H(m)},translate:function(){this.processedXData||this.processData();this.generatePoints();var a=this.options,b=a.stacking,c=this.xAxis,e=c.categories,d=this.yAxis,g=this.points,h=g.length,f=!!this.modifyValue,n=a.pointPlacement,l="between"===n||p(n),
	t=a.threshold,q=a.startFromThreshold?t:0,x,u,w,C,E=Number.MAX_VALUE;"between"===n&&(n=.5);p(n)&&(n*=D(a.pointRange||c.pointRange));for(a=0;a<h;a++){var z=g[a],A=z.x,B=z.y;u=z.low;var H=b&&d.stacks[(this.negStacks&&B<(q?0:t)?"-":"")+this.stackKey],G;d.positiveValuesOnly&&null!==B&&0>=B&&(z.isNull=!0);z.plotX=x=r(Math.min(Math.max(-1E5,c.translate(A,0,0,0,1,n,"flags"===this.type)),1E5));b&&this.visible&&!z.isNull&&H&&H[A]&&(C=this.getStackIndicator(C,A,this.index),G=H[A],B=G.points[C.key],u=B[0],B=
	B[1],u===q&&C.key===H[A].base&&(u=D(t,d.min)),d.positiveValuesOnly&&0>=u&&(u=null),z.total=z.stackTotal=G.total,z.percentage=G.total&&z.y/G.total*100,z.stackY=B,G.setOffset(this.pointXOffset||0,this.barW||0));z.yBottom=k(u)?d.translate(u,0,1,0,1):null;f&&(B=this.modifyValue(B,z));z.plotY=u="number"===typeof B&&Infinity!==B?Math.min(Math.max(-1E5,d.translate(B,0,1,0,1)),1E5):void 0;z.isInside=void 0!==u&&0<=u&&u<=d.len&&0<=x&&x<=c.len;z.clientX=l?r(c.translate(A,0,0,0,1,n)):x;z.negative=z.y<(t||0);
	z.category=e&&void 0!==e[z.x]?e[z.x]:z.x;z.isNull||(void 0!==w&&(E=Math.min(E,Math.abs(x-w))),w=x);z.zone=this.zones.length&&z.getZone()}this.closestPointRangePx=E},getValidPoints:function(a,b){var c=this.chart;return z(a||this.points||[],function(a){return b&&!c.isInsidePlot(a.plotX,a.plotY,c.inverted)?!1:!a.isNull})},setClip:function(a){var b=this.chart,c=this.options,e=b.renderer,d=b.inverted,g=this.clipBox,h=g||b.clipBox,m=this.sharedClipKey||["_sharedClip",a&&a.duration,a&&a.easing,h.height,
	c.xAxis,c.yAxis].join(),f=b[m],p=b[m+"m"];f||(a&&(h.width=0,b[m+"m"]=p=e.clipRect(-99,d?-b.plotLeft:-b.plotTop,99,d?b.chartWidth:b.chartHeight)),b[m]=f=e.clipRect(h),f.count={length:0});a&&!f.count[this.index]&&(f.count[this.index]=!0,f.count.length+=1);!1!==c.clip&&(this.group.clip(a||g?f:b.clipRect),this.markerGroup.clip(p),this.sharedClipKey=m);a||(f.count[this.index]&&(delete f.count[this.index],--f.count.length),0===f.count.length&&m&&b[m]&&(g||(b[m]=b[m].destroy()),b[m+"m"]&&(b[m+"m"]=b[m+"m"].destroy())))},
	animate:function(a){var b=this.chart,c=A(this.options.animation),e;a?this.setClip(c):(e=this.sharedClipKey,(a=b[e])&&a.animate({width:b.plotSizeX},c),b[e+"m"]&&b[e+"m"].animate({width:b.plotSizeX+99},c),this.animate=null)},afterAnimate:function(){this.setClip();n(this,"afterAnimate")},drawPoints:function(){var a=this.points,b=this.chart,c,e,d,g,h=this.options.marker,f,n,k,l,t=this.markerGroup,q=D(h.enabled,this.xAxis.isRadial?!0:null,this.closestPointRangePx>=2*h.radius);if(!1!==h.enabled||this._hasPointMarkers)for(e=
	0;e<a.length;e++)d=a[e],c=d.plotY,g=d.graphic,f=d.marker||{},n=!!d.marker,k=q&&void 0===f.enabled||f.enabled,l=d.isInside,k&&p(c)&&null!==d.y?(c=D(f.symbol,this.symbol),d.hasImage=0===c.indexOf("url"),k=this.markerAttribs(d,d.selected&&"select"),g?g[l?"show":"hide"](!0).animate(k):l&&(0<k.width||d.hasImage)&&(d.graphic=g=b.renderer.symbol(c,k.x,k.y,k.width,k.height,n?f:h).add(t)),g&&g.attr(this.pointAttribs(d,d.selected&&"select")),g&&g.addClass(d.getClassName(),!0)):g&&(d.graphic=g.destroy())},markerAttribs:function(a,
	b){var c=this.options.marker,e=a.marker||{},d=D(e.radius,c.radius);b&&(c=c.states[b],b=e.states&&e.states[b],d=D(b&&b.radius,c&&c.radius,d+(c&&c.radiusPlus||0)));a.hasImage&&(d=0);a={x:Math.floor(a.plotX)-d,y:a.plotY-d};d&&(a.width=a.height=2*d);return a},pointAttribs:function(a,b){var c=this.options.marker,e=a&&a.options,d=e&&e.marker||{},g=this.color,h=e&&e.color,f=a&&a.color,e=D(d.lineWidth,c.lineWidth);a=a&&a.zone&&a.zone.color;g=h||a||f||g;a=d.fillColor||c.fillColor||g;g=d.lineColor||c.lineColor||
	g;b&&(c=c.states[b],b=d.states&&d.states[b]||{},e=D(b.lineWidth,c.lineWidth,e+D(b.lineWidthPlus,c.lineWidthPlus,0)),a=b.fillColor||c.fillColor||a,g=b.lineColor||c.lineColor||g);return{stroke:g,"stroke-width":e,fill:a}},destroy:function(){var a=this,b=a.chart,c=/AppleWebKit\/533/.test(E.navigator.userAgent),e,h=a.data||[],g,f,k;n(a,"destroy");w(a);u(a.axisTypes||[],function(b){(k=a[b])&&k.series&&(d(k.series,a),k.isDirty=k.forceRedraw=!0)});a.legendItem&&a.chart.legend.destroyItem(a);for(e=h.length;e--;)(g=
	h[e])&&g.destroy&&g.destroy();a.points=null;clearTimeout(a.animationTimeout);for(f in a)a[f]instanceof x&&!a[f].survive&&(e=c&&"group"===f?"hide":"destroy",a[f][e]());b.hoverSeries===a&&(b.hoverSeries=null);d(b.series,a);b.orderSeries();for(f in a)delete a[f]},getGraphPath:function(a,b,c){var e=this,d=e.options,g=d.step,h,f=[],m=[],p;a=a||e.points;(h=a.reversed)&&a.reverse();(g={right:1,center:2}[g]||g&&3)&&h&&(g=4-g);!d.connectNulls||b||c||(a=this.getValidPoints(a));u(a,function(h,n){var l=h.plotX,
	t=h.plotY,q=a[n-1];(h.leftCliff||q&&q.rightCliff)&&!c&&(p=!0);h.isNull&&!k(b)&&0<n?p=!d.connectNulls:h.isNull&&!b?p=!0:(0===n||p?n=["M",h.plotX,h.plotY]:e.getPointSpline?n=e.getPointSpline(a,h,n):g?(n=1===g?["L",q.plotX,t]:2===g?["L",(q.plotX+l)/2,q.plotY,"L",(q.plotX+l)/2,t]:["L",l,q.plotY],n.push("L",l,t)):n=["L",l,t],m.push(h.x),g&&m.push(h.x),f.push.apply(f,n),p=!1)});f.xMap=m;return e.graphPath=f},drawGraph:function(){var a=this,b=this.options,c=(this.gappedPath||this.getGraphPath).call(this),
	e=[["graph","highcharts-graph",b.lineColor||this.color,b.dashStyle]];u(this.zones,function(c,d){e.push(["zone-graph-"+d,"highcharts-graph highcharts-zone-graph-"+d+" "+(c.className||""),c.color||a.color,c.dashStyle||b.dashStyle])});u(e,function(e,d){var g=e[0],h=a[g];h?(h.endX=c.xMap,h.animate({d:c})):c.length&&(a[g]=a.chart.renderer.path(c).addClass(e[1]).attr({zIndex:1}).add(a.group),h={stroke:e[2],"stroke-width":b.lineWidth,fill:a.fillGraph&&a.color||"none"},e[3]?h.dashstyle=e[3]:"square"!==b.linecap&&
	(h["stroke-linecap"]=h["stroke-linejoin"]="round"),h=a[g].attr(h).shadow(2>d&&b.shadow));h&&(h.startX=c.xMap,h.isArea=c.isArea)})},applyZones:function(){var a=this,b=this.chart,c=b.renderer,e=this.zones,d,g,h=this.clips||[],f,k=this.graph,p=this.area,n=Math.max(b.chartWidth,b.chartHeight),l=this[(this.zoneAxis||"y")+"Axis"],t,q,x=b.inverted,w,r,C,E,z=!1;e.length&&(k||p)&&l&&void 0!==l.min&&(q=l.reversed,w=l.horiz,k&&k.hide(),p&&p.hide(),t=l.getExtremes(),u(e,function(e,m){d=q?w?b.plotWidth:0:w?0:
	l.toPixels(t.min);d=Math.min(Math.max(D(g,d),0),n);g=Math.min(Math.max(Math.round(l.toPixels(D(e.value,t.max),!0)),0),n);z&&(d=g=l.toPixels(t.max));r=Math.abs(d-g);C=Math.min(d,g);E=Math.max(d,g);l.isXAxis?(f={x:x?E:C,y:0,width:r,height:n},w||(f.x=b.plotHeight-f.x)):(f={x:0,y:x?E:C,width:n,height:r},w&&(f.y=b.plotWidth-f.y));x&&c.isVML&&(f=l.isXAxis?{x:0,y:q?C:E,height:f.width,width:b.chartWidth}:{x:f.y-b.plotLeft-b.spacingBox.x,y:0,width:f.height,height:b.chartHeight});h[m]?h[m].animate(f):(h[m]=
	c.clipRect(f),k&&a["zone-graph-"+m].clip(h[m]),p&&a["zone-area-"+m].clip(h[m]));z=e.value>t.max}),this.clips=h)},invertGroups:function(a){function b(){u(["group","markerGroup"],function(b){c[b]&&(e.renderer.isVML&&c[b].attr({width:c.yAxis.len,height:c.xAxis.len}),c[b].width=c.yAxis.len,c[b].height=c.xAxis.len,c[b].invert(a))})}var c=this,e=c.chart,d;c.xAxis&&(d=B(e,"resize",b),B(c,"destroy",d),b(a),c.invertGroups=b)},plotGroup:function(a,b,c,e,d){var g=this[a],h=!g;h&&(this[a]=g=this.chart.renderer.g(b).attr({zIndex:e||
	.1}).add(d),g.addClass("highcharts-series-"+this.index+" highcharts-"+this.type+"-series highcharts-color-"+this.colorIndex+" "+(this.options.className||"")));g.attr({visibility:c})[h?"attr":"animate"](this.getPlotBox());return g},getPlotBox:function(){var a=this.chart,b=this.xAxis,c=this.yAxis;a.inverted&&(b=c,c=this.xAxis);return{translateX:b?b.left:a.plotLeft,translateY:c?c.top:a.plotTop,scaleX:1,scaleY:1}},render:function(){var a=this,b=a.chart,c,e=a.options,d=!!a.animate&&b.renderer.isSVG&&A(e.animation).duration,
	g=a.visible?"inherit":"hidden",h=e.zIndex,f=a.hasRendered,k=b.seriesGroup,p=b.inverted;c=a.plotGroup("group","series",g,h,k);a.markerGroup=a.plotGroup("markerGroup","markers",g,h,k);d&&a.animate(!0);c.inverted=a.isCartesian?p:!1;a.drawGraph&&(a.drawGraph(),a.applyZones());a.drawDataLabels&&a.drawDataLabels();a.visible&&a.drawPoints();a.drawTracker&&!1!==a.options.enableMouseTracking&&a.drawTracker();a.invertGroups(p);!1===e.clip||a.sharedClipKey||f||c.clip(b.clipRect);d&&a.animate();f||(a.animationTimeout=
	C(function(){a.afterAnimate()},d));a.isDirty=!1;a.hasRendered=!0},redraw:function(){var a=this.chart,b=this.isDirty||this.isDirtyData,c=this.group,e=this.xAxis,d=this.yAxis;c&&(a.inverted&&c.attr({width:a.plotWidth,height:a.plotHeight}),c.animate({translateX:D(e&&e.left,a.plotLeft),translateY:D(d&&d.top,a.plotTop)}));this.translate();this.render();b&&delete this.kdTree},kdAxisArray:["clientX","plotY"],searchPoint:function(a,b){var c=this.xAxis,e=this.yAxis,d=this.chart.inverted;return this.searchKDTree({clientX:d?
	c.len-a.chartY+c.pos:a.chartX-c.pos,plotY:d?e.len-a.chartX+e.pos:a.chartY-e.pos},b)},buildKDTree:function(){function a(c,e,d){var g,h;if(h=c&&c.length)return g=b.kdAxisArray[e%d],c.sort(function(a,b){return a[g]-b[g]}),h=Math.floor(h/2),{point:c[h],left:a(c.slice(0,h),e+1,d),right:a(c.slice(h+1),e+1,d)}}this.buildingKdTree=!0;var b=this,c=-1<b.options.findNearestPointBy.indexOf("y")?2:1;delete b.kdTree;C(function(){b.kdTree=a(b.getValidPoints(null,!b.directTouch),c,c);b.buildingKdTree=!1},b.options.kdNow?
	0:1)},searchKDTree:function(a,b){function c(a,b,f,m){var p=b.point,n=e.kdAxisArray[f%m],l,t,q=p;t=k(a[d])&&k(p[d])?Math.pow(a[d]-p[d],2):null;l=k(a[g])&&k(p[g])?Math.pow(a[g]-p[g],2):null;l=(t||0)+(l||0);p.dist=k(l)?Math.sqrt(l):Number.MAX_VALUE;p.distX=k(t)?Math.sqrt(t):Number.MAX_VALUE;n=a[n]-p[n];l=0>n?"left":"right";t=0>n?"right":"left";b[l]&&(l=c(a,b[l],f+1,m),q=l[h]<q[h]?l:p);b[t]&&Math.sqrt(n*n)<q[h]&&(a=c(a,b[t],f+1,m),q=a[h]<q[h]?a:q);return q}var e=this,d=this.kdAxisArray[0],g=this.kdAxisArray[1],
	h=b?"distX":"dist";b=-1<e.options.findNearestPointBy.indexOf("y")?2:1;this.kdTree||this.buildingKdTree||this.buildKDTree();if(this.kdTree)return c(a,this.kdTree,b,b)}})})(L);(function(a){function B(a,d,c,f,l){var b=a.chart.inverted;this.axis=a;this.isNegative=c;this.options=d;this.x=f;this.total=null;this.points={};this.stack=l;this.rightCliff=this.leftCliff=0;this.alignOptions={align:d.align||(b?c?"left":"right":"center"),verticalAlign:d.verticalAlign||(b?"middle":c?"bottom":"top"),y:k(d.y,b?4:c?
	14:-6),x:k(d.x,b?c?-6:6:0)};this.textAlign=d.textAlign||(b?c?"right":"left":"center")}var A=a.Axis,H=a.Chart,G=a.correctFloat,r=a.defined,f=a.destroyObjectProperties,l=a.each,q=a.format,k=a.pick;a=a.Series;B.prototype={destroy:function(){f(this,this.axis)},render:function(a){var d=this.options,c=d.format,c=c?q(c,this):d.formatter.call(this);this.label?this.label.attr({text:c,visibility:"hidden"}):this.label=this.axis.chart.renderer.text(c,null,null,d.useHTML).css(d.style).attr({align:this.textAlign,
	rotation:d.rotation,visibility:"hidden"}).add(a)},setOffset:function(a,d){var c=this.axis,f=c.chart,k=f.inverted,b=c.reversed,b=this.isNegative&&!b||!this.isNegative&&b,p=c.translate(c.usePercentage?100:this.total,0,0,0,1),c=c.translate(0),c=Math.abs(p-c);a=f.xAxis[0].translate(this.x)+a;var h=f.plotHeight,k={x:k?b?p:p-c:a,y:k?h-a-d:b?h-p-c:h-p,width:k?c:d,height:k?d:c};if(d=this.label)d.align(this.alignOptions,null,k),k=d.alignAttr,d[!1===this.options.crop||f.isInsidePlot(k.x,k.y)?"show":"hide"](!0)}};
	H.prototype.getStacks=function(){var a=this;l(a.yAxis,function(a){a.stacks&&a.hasVisibleSeries&&(a.oldStacks=a.stacks)});l(a.series,function(d){!d.options.stacking||!0!==d.visible&&!1!==a.options.chart.ignoreHiddenSeries||(d.stackKey=d.type+k(d.options.stack,""))})};A.prototype.buildStacks=function(){var a=this.series,d,c=k(this.options.reversedStacks,!0),f=a.length,l;if(!this.isXAxis){this.usePercentage=!1;for(l=f;l--;)a[c?l:f-l-1].setStackedPoints();for(l=f;l--;)d=a[c?l:f-l-1],d.setStackCliffs&&
	d.setStackCliffs();if(this.usePercentage)for(l=0;l<f;l++)a[l].setPercentStacks()}};A.prototype.renderStackTotals=function(){var a=this.chart,d=a.renderer,c=this.stacks,f,k,b=this.stackTotalGroup;b||(this.stackTotalGroup=b=d.g("stack-labels").attr({visibility:"visible",zIndex:6}).add());b.translate(a.plotLeft,a.plotTop);for(f in c)for(k in a=c[f],a)a[k].render(b)};A.prototype.resetStacks=function(){var a=this.stacks,d,c;if(!this.isXAxis)for(d in a)for(c in a[d])a[d][c].touched<this.stacksTouched?(a[d][c].destroy(),
	delete a[d][c]):(a[d][c].total=null,a[d][c].cum=null)};A.prototype.cleanStacks=function(){var a,d,c;if(!this.isXAxis)for(d in this.oldStacks&&(a=this.stacks=this.oldStacks),a)for(c in a[d])a[d][c].cum=a[d][c].total};a.prototype.setStackedPoints=function(){if(this.options.stacking&&(!0===this.visible||!1===this.chart.options.chart.ignoreHiddenSeries)){var a=this.processedXData,d=this.processedYData,c=[],f=d.length,l=this.options,b=l.threshold,p=l.startFromThreshold?b:0,h=l.stack,l=l.stacking,t=this.stackKey,
	q="-"+t,w=this.negStacks,e=this.yAxis,x=e.stacks,C=e.oldStacks,E,m,y,A,K,J,g;e.stacksTouched+=1;for(K=0;K<f;K++)J=a[K],g=d[K],E=this.getStackIndicator(E,J,this.index),A=E.key,y=(m=w&&g<(p?0:b))?q:t,x[y]||(x[y]={}),x[y][J]||(C[y]&&C[y][J]?(x[y][J]=C[y][J],x[y][J].total=null):x[y][J]=new B(e,e.options.stackLabels,m,J,h)),y=x[y][J],null!==g&&(y.points[A]=y.points[this.index]=[k(y.cum,p)],r(y.cum)||(y.base=A),y.touched=e.stacksTouched,0<E.index&&!1===this.singleStacks&&(y.points[A][0]=y.points[this.index+
	","+J+",0"][0])),"percent"===l?(m=m?t:q,w&&x[m]&&x[m][J]?(m=x[m][J],y.total=m.total=Math.max(m.total,y.total)+Math.abs(g)||0):y.total=G(y.total+(Math.abs(g)||0))):y.total=G(y.total+(g||0)),y.cum=k(y.cum,p)+(g||0),null!==g&&(y.points[A].push(y.cum),c[K]=y.cum);"percent"===l&&(e.usePercentage=!0);this.stackedYData=c;e.oldStacks={}}};a.prototype.setPercentStacks=function(){var a=this,d=a.stackKey,c=a.yAxis.stacks,f=a.processedXData,k;l([d,"-"+d],function(b){for(var d=f.length,h,n;d--;)if(h=f[d],k=a.getStackIndicator(k,
	h,a.index,b),h=(n=c[b]&&c[b][h])&&n.points[k.key])n=n.total?100/n.total:0,h[0]=G(h[0]*n),h[1]=G(h[1]*n),a.stackedYData[d]=h[1]})};a.prototype.getStackIndicator=function(a,d,c,f){!r(a)||a.x!==d||f&&a.key!==f?a={x:d,index:0,key:f}:a.index++;a.key=[c,d,a.index].join();return a}})(L);(function(a){var B=a.addEvent,A=a.animate,H=a.Axis,G=a.createElement,r=a.css,f=a.defined,l=a.each,q=a.erase,k=a.extend,u=a.fireEvent,d=a.inArray,c=a.isNumber,n=a.isObject,z=a.merge,b=a.pick,p=a.Point,h=a.Series,t=a.seriesTypes,
	D=a.setAnimation,w=a.splat;k(a.Chart.prototype,{addSeries:function(a,c,d){var e,h=this;a&&(c=b(c,!0),u(h,"addSeries",{options:a},function(){e=h.initSeries(a);h.isDirtyLegend=!0;h.linkSeries();c&&h.redraw(d)}));return e},addAxis:function(a,c,d,h){var e=c?"xAxis":"yAxis",f=this.options;a=z(a,{index:this[e].length,isX:c});new H(this,a);f[e]=w(f[e]||{});f[e].push(a);b(d,!0)&&this.redraw(h)},showLoading:function(a){var b=this,c=b.options,e=b.loadingDiv,d=c.loading,h=function(){e&&r(e,{left:b.plotLeft+
	"px",top:b.plotTop+"px",width:b.plotWidth+"px",height:b.plotHeight+"px"})};e||(b.loadingDiv=e=G("div",{className:"highcharts-loading highcharts-loading-hidden"},null,b.container),b.loadingSpan=G("span",{className:"highcharts-loading-inner"},null,e),B(b,"redraw",h));e.className="highcharts-loading";b.loadingSpan.innerHTML=a||c.lang.loading;r(e,k(d.style,{zIndex:10}));r(b.loadingSpan,d.labelStyle);b.loadingShown||(r(e,{opacity:0,display:""}),A(e,{opacity:d.style.opacity||.5},{duration:d.showDuration||
	0}));b.loadingShown=!0;h()},hideLoading:function(){var a=this.options,b=this.loadingDiv;b&&(b.className="highcharts-loading highcharts-loading-hidden",A(b,{opacity:0},{duration:a.loading.hideDuration||100,complete:function(){r(b,{display:"none"})}}));this.loadingShown=!1},propsRequireDirtyBox:"backgroundColor borderColor borderWidth margin marginTop marginRight marginBottom marginLeft spacing spacingTop spacingRight spacingBottom spacingLeft borderRadius plotBackgroundColor plotBackgroundImage plotBorderColor plotBorderWidth plotShadow shadow".split(" "),
	propsRequireUpdateSeries:"chart.inverted chart.polar chart.ignoreHiddenSeries chart.type colors plotOptions".split(" "),update:function(a,h){var e,k={credits:"addCredits",title:"setTitle",subtitle:"setSubtitle"},m=a.chart,p,n;if(m){z(!0,this.options.chart,m);"className"in m&&this.setClassName(m.className);if("inverted"in m||"polar"in m)this.propFromSeries(),p=!0;"alignTicks"in m&&(p=!0);for(e in m)m.hasOwnProperty(e)&&(-1!==d("chart."+e,this.propsRequireUpdateSeries)&&(n=!0),-1!==d(e,this.propsRequireDirtyBox)&&
	(this.isDirtyBox=!0));"style"in m&&this.renderer.setStyle(m.style)}for(e in a){if(this[e]&&"function"===typeof this[e].update)this[e].update(a[e],!1);else if("function"===typeof this[k[e]])this[k[e]](a[e]);"chart"!==e&&-1!==d(e,this.propsRequireUpdateSeries)&&(n=!0)}a.colors&&(this.options.colors=a.colors);a.plotOptions&&z(!0,this.options.plotOptions,a.plotOptions);l(["xAxis","yAxis","series","colorAxis","pane"],function(b){a[b]&&l(w(a[b]),function(a,c){(c=f(a.id)&&this.get(a.id)||this[b][c])&&c.coll===
	b&&c.update(a,!1)},this)},this);p&&l(this.axes,function(a){a.update({},!1)});n&&l(this.series,function(a){a.update({},!1)});a.loading&&z(!0,this.options.loading,a.loading);e=m&&m.width;m=m&&m.height;c(e)&&e!==this.chartWidth||c(m)&&m!==this.chartHeight?this.setSize(e,m):b(h,!0)&&this.redraw()},setSubtitle:function(a){this.setTitle(void 0,a)}});k(p.prototype,{update:function(a,c,d,h){function e(){f.applyOptions(a);null===f.y&&p&&(f.graphic=p.destroy());n(a,!0)&&(p&&p.element&&a&&a.marker&&a.marker.symbol&&
	(f.graphic=p.destroy()),a&&a.dataLabels&&f.dataLabel&&(f.dataLabel=f.dataLabel.destroy()));l=f.index;k.updateParallelArrays(f,l);t.data[l]=n(t.data[l],!0)||n(a,!0)?f.options:a;k.isDirty=k.isDirtyData=!0;!k.fixedBox&&k.hasCartesianSeries&&(g.isDirtyBox=!0);"point"===t.legendType&&(g.isDirtyLegend=!0);c&&g.redraw(d)}var f=this,k=f.series,p=f.graphic,l,g=k.chart,t=k.options;c=b(c,!0);!1===h?e():f.firePointEvent("update",{options:a},e)},remove:function(a,b){this.series.removePoint(d(this,this.series.data),
	a,b)}});k(h.prototype,{addPoint:function(a,c,d,h){var e=this.options,f=this.data,k=this.chart,p=this.xAxis,p=p&&p.hasNames&&p.names,n=e.data,g,l,t=this.xData,q,w;c=b(c,!0);g={series:this};this.pointClass.prototype.applyOptions.apply(g,[a]);w=g.x;q=t.length;if(this.requireSorting&&w<t[q-1])for(l=!0;q&&t[q-1]>w;)q--;this.updateParallelArrays(g,"splice",q,0,0);this.updateParallelArrays(g,q);p&&g.name&&(p[w]=g.name);n.splice(q,0,a);l&&(this.data.splice(q,0,null),this.processData());"point"===e.legendType&&
	this.generatePoints();d&&(f[0]&&f[0].remove?f[0].remove(!1):(f.shift(),this.updateParallelArrays(g,"shift"),n.shift()));this.isDirtyData=this.isDirty=!0;c&&k.redraw(h)},removePoint:function(a,c,d){var e=this,h=e.data,f=h[a],k=e.points,p=e.chart,n=function(){k&&k.length===h.length&&k.splice(a,1);h.splice(a,1);e.options.data.splice(a,1);e.updateParallelArrays(f||{series:e},"splice",a,1);f&&f.destroy();e.isDirty=!0;e.isDirtyData=!0;c&&p.redraw()};D(d,p);c=b(c,!0);f?f.firePointEvent("remove",null,n):
	n()},remove:function(a,c,d){function e(){h.destroy();f.isDirtyLegend=f.isDirtyBox=!0;f.linkSeries();b(a,!0)&&f.redraw(c)}var h=this,f=h.chart;!1!==d?u(h,"remove",null,e):e()},update:function(a,c){var e=this,d=this.chart,h=this.userOptions,f=this.oldType||this.type,p=a.type||h.type||d.options.chart.type,n=t[f].prototype,q=["group","markerGroup","dataLabelsGroup"],g;if(p&&p!==f||void 0!==a.zIndex)q.length=0;l(q,function(a){q[a]=e[a];delete e[a]});a=z(h,{animation:!1,index:this.index,pointStart:this.xData[0]},
	{data:this.options.data},a);this.remove(!1,null,!1);for(g in n)this[g]=void 0;k(this,t[p||f].prototype);l(q,function(a){e[a]=q[a]});this.init(d,a);this.oldType=f;d.linkSeries();b(c,!0)&&d.redraw(!1)}});k(H.prototype,{update:function(a,c){var e=this.chart;a=e.options[this.coll][this.options.index]=z(this.userOptions,a);this.destroy(!0);this.init(e,k(a,{events:void 0}));e.isDirtyBox=!0;b(c,!0)&&e.redraw()},remove:function(a){for(var c=this.chart,e=this.coll,d=this.series,h=d.length;h--;)d[h]&&d[h].remove(!1);
	q(c.axes,this);q(c[e],this);c.options[e].splice(this.options.index,1);l(c[e],function(a,b){a.options.index=b});this.destroy();c.isDirtyBox=!0;b(a,!0)&&c.redraw()},setTitle:function(a,b){this.update({title:a},b)},setCategories:function(a,b){this.update({categories:a},b)}})})(L);(function(a){var B=a.color,A=a.each,H=a.map,G=a.pick,r=a.Series,f=a.seriesType;f("area","line",{softThreshold:!1,threshold:0},{singleStacks:!1,getStackPoints:function(){var a=[],f=[],k=this.xAxis,r=this.yAxis,d=r.stacks[this.stackKey],
	c={},n=this.points,z=this.index,b=r.series,p=b.length,h,t=G(r.options.reversedStacks,!0)?1:-1,D,w;if(this.options.stacking){for(D=0;D<n.length;D++)c[n[D].x]=n[D];for(w in d)null!==d[w].total&&f.push(w);f.sort(function(a,b){return a-b});h=H(b,function(){return this.visible});A(f,function(b,n){var e=0,l,m;if(c[b]&&!c[b].isNull)a.push(c[b]),A([-1,1],function(a){var e=1===a?"rightNull":"leftNull",k=0,q=d[f[n+a]];if(q)for(D=z;0<=D&&D<p;)l=q.points[D],l||(D===z?c[b][e]=!0:h[D]&&(m=d[b].points[D])&&(k-=
	m[1]-m[0])),D+=t;c[b][1===a?"rightCliff":"leftCliff"]=k});else{for(D=z;0<=D&&D<p;){if(l=d[b].points[D]){e=l[1];break}D+=t}e=r.translate(e,0,1,0,1);a.push({isNull:!0,plotX:k.translate(b,0,0,0,1),x:b,plotY:e,yBottom:e})}})}return a},getGraphPath:function(a){var f=r.prototype.getGraphPath,k=this.options,l=k.stacking,d=this.yAxis,c,n,z=[],b=[],p=this.index,h,t=d.stacks[this.stackKey],D=k.threshold,w=d.getThreshold(k.threshold),e,k=k.connectNulls||"percent"===l,x=function(c,e,f){var k=a[c];c=l&&t[k.x].points[p];
	var m=k[f+"Null"]||0;f=k[f+"Cliff"]||0;var n,q,k=!0;f||m?(n=(m?c[0]:c[1])+f,q=c[0]+f,k=!!m):!l&&a[e]&&a[e].isNull&&(n=q=D);void 0!==n&&(b.push({plotX:h,plotY:null===n?w:d.getThreshold(n),isNull:k,isCliff:!0}),z.push({plotX:h,plotY:null===q?w:d.getThreshold(q),doCurve:!1}))};a=a||this.points;l&&(a=this.getStackPoints());for(c=0;c<a.length;c++)if(n=a[c].isNull,h=G(a[c].rectPlotX,a[c].plotX),e=G(a[c].yBottom,w),!n||k)k||x(c,c-1,"left"),n&&!l&&k||(b.push(a[c]),z.push({x:c,plotX:h,plotY:e})),k||x(c,c+
	1,"right");c=f.call(this,b,!0,!0);z.reversed=!0;n=f.call(this,z,!0,!0);n.length&&(n[0]="L");n=c.concat(n);f=f.call(this,b,!1,k);n.xMap=c.xMap;this.areaPath=n;return f},drawGraph:function(){this.areaPath=[];r.prototype.drawGraph.apply(this);var a=this,f=this.areaPath,k=this.options,u=[["area","highcharts-area",this.color,k.fillColor]];A(this.zones,function(d,c){u.push(["zone-area-"+c,"highcharts-area highcharts-zone-area-"+c+" "+d.className,d.color||a.color,d.fillColor||k.fillColor])});A(u,function(d){var c=
	d[0],n=a[c];n?(n.endX=f.xMap,n.animate({d:f})):(n=a[c]=a.chart.renderer.path(f).addClass(d[1]).attr({fill:G(d[3],B(d[2]).setOpacity(G(k.fillOpacity,.75)).get()),zIndex:0}).add(a.group),n.isArea=!0);n.startX=f.xMap;n.shiftUnit=k.step?2:1})},drawLegendSymbol:a.LegendSymbolMixin.drawRectangle})})(L);(function(a){var B=a.pick;a=a.seriesType;a("spline","line",{},{getPointSpline:function(a,H,G){var r=H.plotX,f=H.plotY,l=a[G-1];G=a[G+1];var q,k,u,d;if(l&&!l.isNull&&!1!==l.doCurve&&!H.isCliff&&G&&!G.isNull&&
	!1!==G.doCurve&&!H.isCliff){a=l.plotY;u=G.plotX;G=G.plotY;var c=0;q=(1.5*r+l.plotX)/2.5;k=(1.5*f+a)/2.5;u=(1.5*r+u)/2.5;d=(1.5*f+G)/2.5;u!==q&&(c=(d-k)*(u-r)/(u-q)+f-d);k+=c;d+=c;k>a&&k>f?(k=Math.max(a,f),d=2*f-k):k<a&&k<f&&(k=Math.min(a,f),d=2*f-k);d>G&&d>f?(d=Math.max(G,f),k=2*f-d):d<G&&d<f&&(d=Math.min(G,f),k=2*f-d);H.rightContX=u;H.rightContY=d}H=["C",B(l.rightContX,l.plotX),B(l.rightContY,l.plotY),B(q,r),B(k,f),r,f];l.rightContX=l.rightContY=null;return H}})})(L);(function(a){var B=a.seriesTypes.area.prototype,
	A=a.seriesType;A("areaspline","spline",a.defaultPlotOptions.area,{getStackPoints:B.getStackPoints,getGraphPath:B.getGraphPath,setStackCliffs:B.setStackCliffs,drawGraph:B.drawGraph,drawLegendSymbol:a.LegendSymbolMixin.drawRectangle})})(L);(function(a){var B=a.animObject,A=a.color,H=a.each,G=a.extend,r=a.isNumber,f=a.merge,l=a.pick,q=a.Series,k=a.seriesType,u=a.svg;k("column","line",{borderRadius:0,crisp:!0,groupPadding:.2,marker:null,pointPadding:.1,minPointLength:0,cropThreshold:50,pointRange:null,
	states:{hover:{halo:!1,brightness:.1,shadow:!1},select:{color:"#cccccc",borderColor:"#000000",shadow:!1}},dataLabels:{align:null,verticalAlign:null,y:null},softThreshold:!1,startFromThreshold:!0,stickyTracking:!1,tooltip:{distance:6},threshold:0,borderColor:"#ffffff"},{cropShoulder:0,directTouch:!0,trackerGroups:["group","dataLabelsGroup"],negStacks:!0,init:function(){q.prototype.init.apply(this,arguments);var a=this,c=a.chart;c.hasRendered&&H(c.series,function(c){c.type===a.type&&(c.isDirty=!0)})},
	getColumnMetrics:function(){var a=this,c=a.options,f=a.xAxis,k=a.yAxis,b=f.reversed,p,h={},t=0;!1===c.grouping?t=1:H(a.chart.series,function(b){var c=b.options,e=b.yAxis,d;b.type===a.type&&b.visible&&k.len===e.len&&k.pos===e.pos&&(c.stacking?(p=b.stackKey,void 0===h[p]&&(h[p]=t++),d=h[p]):!1!==c.grouping&&(d=t++),b.columnIndex=d)});var q=Math.min(Math.abs(f.transA)*(f.ordinalSlope||c.pointRange||f.closestPointRange||f.tickInterval||1),f.len),w=q*c.groupPadding,e=(q-2*w)/(t||1),c=Math.min(c.maxPointWidth||
	f.len,l(c.pointWidth,e*(1-2*c.pointPadding)));a.columnMetrics={width:c,offset:(e-c)/2+(w+((a.columnIndex||0)+(b?1:0))*e-q/2)*(b?-1:1)};return a.columnMetrics},crispCol:function(a,c,f,k){var b=this.chart,d=this.borderWidth,h=-(d%2?.5:0),d=d%2?.5:1;b.inverted&&b.renderer.isVML&&(d+=1);this.options.crisp&&(f=Math.round(a+f)+h,a=Math.round(a)+h,f-=a);k=Math.round(c+k)+d;h=.5>=Math.abs(c)&&.5<k;c=Math.round(c)+d;k-=c;h&&k&&(--c,k+=1);return{x:a,y:c,width:f,height:k}},translate:function(){var a=this,c=
	a.chart,f=a.options,k=a.dense=2>a.closestPointRange*a.xAxis.transA,k=a.borderWidth=l(f.borderWidth,k?0:1),b=a.yAxis,p=a.translatedThreshold=b.getThreshold(f.threshold),h=l(f.minPointLength,5),t=a.getColumnMetrics(),r=t.width,w=a.barW=Math.max(r,1+2*k),e=a.pointXOffset=t.offset;c.inverted&&(p-=.5);f.pointPadding&&(w=Math.ceil(w));q.prototype.translate.apply(a);H(a.points,function(d){var f=l(d.yBottom,p),k=999+Math.abs(f),k=Math.min(Math.max(-k,d.plotY),b.len+k),m=d.plotX+e,n=w,t=Math.min(k,f),q,u=
	Math.max(k,f)-t;Math.abs(u)<h&&h&&(u=h,q=!b.reversed&&!d.negative||b.reversed&&d.negative,t=Math.abs(t-p)>h?f-h:p-(q?h:0));d.barX=m;d.pointWidth=r;d.tooltipPos=c.inverted?[b.len+b.pos-c.plotLeft-k,a.xAxis.len-m-n/2,u]:[m+n/2,k+b.pos-c.plotTop,u];d.shapeType="rect";d.shapeArgs=a.crispCol.apply(a,d.isNull?[d.plotX,b.len/2,0,0]:[m,t,n,u])})},getSymbol:a.noop,drawLegendSymbol:a.LegendSymbolMixin.drawRectangle,drawGraph:function(){this.group[this.dense?"addClass":"removeClass"]("highcharts-dense-data")},
	pointAttribs:function(a,c){var d=this.options,k,b=this.pointAttrToOptions||{};k=b.stroke||"borderColor";var p=b["stroke-width"]||"borderWidth",h=a&&a.color||this.color,l=a[k]||d[k]||this.color||h,q=a[p]||d[p]||this[p]||0,b=d.dashStyle;a&&this.zones.length&&(h=(h=a.getZone())&&h.color||a.options.color||this.color);c&&(a=f(d.states[c],a.options.states&&a.options.states[c]||{}),c=a.brightness,h=a.color||void 0!==c&&A(h).brighten(a.brightness).get()||h,l=a[k]||l,q=a[p]||q,b=a.dashStyle||b);k={fill:h,
	stroke:l,"stroke-width":q};d.borderRadius&&(k.r=d.borderRadius);b&&(k.dashstyle=b);return k},drawPoints:function(){var a=this,c=this.chart,k=a.options,l=c.renderer,b=k.animationLimit||250,p;H(a.points,function(d){var h=d.graphic;if(r(d.plotY)&&null!==d.y){p=d.shapeArgs;if(h)h[c.pointCount<b?"animate":"attr"](f(p));else d.graphic=h=l[d.shapeType](p).add(d.group||a.group);h.attr(a.pointAttribs(d,d.selected&&"select")).shadow(k.shadow,null,k.stacking&&!k.borderRadius);h.addClass(d.getClassName(),!0)}else h&&
	(d.graphic=h.destroy())})},animate:function(a){var c=this,d=this.yAxis,f=c.options,b=this.chart.inverted,k={};u&&(a?(k.scaleY=.001,a=Math.min(d.pos+d.len,Math.max(d.pos,d.toPixels(f.threshold))),b?k.translateX=a-d.len:k.translateY=a,c.group.attr(k)):(k[b?"translateX":"translateY"]=d.pos,c.group.animate(k,G(B(c.options.animation),{step:function(a,b){c.group.attr({scaleY:Math.max(.001,b.pos)})}})),c.animate=null))},remove:function(){var a=this,c=a.chart;c.hasRendered&&H(c.series,function(c){c.type===
	a.type&&(c.isDirty=!0)});q.prototype.remove.apply(a,arguments)}})})(L);(function(a){a=a.seriesType;a("bar","column",null,{inverted:!0})})(L);(function(a){var B=a.Series;a=a.seriesType;a("scatter","line",{lineWidth:0,findNearestPointBy:"xy",marker:{enabled:!0},tooltip:{headerFormat:'\x3cspan style\x3d"color:{point.color}"\x3e\u25cf\x3c/span\x3e \x3cspan style\x3d"font-size: 0.85em"\x3e {series.name}\x3c/span\x3e\x3cbr/\x3e',pointFormat:"x: \x3cb\x3e{point.x}\x3c/b\x3e\x3cbr/\x3ey: \x3cb\x3e{point.y}\x3c/b\x3e\x3cbr/\x3e"}},
	{sorted:!1,requireSorting:!1,noSharedTooltip:!0,trackerGroups:["group","markerGroup","dataLabelsGroup"],takeOrdinalPosition:!1,drawGraph:function(){this.options.lineWidth&&B.prototype.drawGraph.call(this)}})})(L);(function(a){var B=a.pick,A=a.relativeLength;a.CenteredSeriesMixin={getCenter:function(){var a=this.options,G=this.chart,r=2*(a.slicedOffset||0),f=G.plotWidth-2*r,G=G.plotHeight-2*r,l=a.center,l=[B(l[0],"50%"),B(l[1],"50%"),a.size||"100%",a.innerSize||0],q=Math.min(f,G),k,u;for(k=0;4>k;++k)u=
	l[k],a=2>k||2===k&&/%$/.test(u),l[k]=A(u,[f,G,q,l[2]][k])+(a?r:0);l[3]>l[2]&&(l[3]=l[2]);return l}}})(L);(function(a){var B=a.addEvent,A=a.defined,H=a.each,G=a.extend,r=a.inArray,f=a.noop,l=a.pick,q=a.Point,k=a.Series,u=a.seriesType,d=a.setAnimation;u("pie","line",{center:[null,null],clip:!1,colorByPoint:!0,dataLabels:{distance:30,enabled:!0,formatter:function(){return null===this.y?void 0:this.point.name},x:0},ignoreHiddenPoint:!0,legendType:"point",marker:null,size:null,showInLegend:!1,slicedOffset:10,
	stickyTracking:!1,tooltip:{followPointer:!0},borderColor:"#ffffff",borderWidth:1,states:{hover:{brightness:.1,shadow:!1}}},{isCartesian:!1,requireSorting:!1,directTouch:!0,noSharedTooltip:!0,trackerGroups:["group","dataLabelsGroup"],axisTypes:[],pointAttribs:a.seriesTypes.column.prototype.pointAttribs,animate:function(a){var c=this,d=c.points,b=c.startAngleRad;a||(H(d,function(a){var d=a.graphic,f=a.shapeArgs;d&&(d.attr({r:a.startR||c.center[3]/2,start:b,end:b}),d.animate({r:f.r,start:f.start,end:f.end},
	c.options.animation))}),c.animate=null)},updateTotals:function(){var a,d=0,f=this.points,b=f.length,k,h=this.options.ignoreHiddenPoint;for(a=0;a<b;a++)k=f[a],0>k.y&&(k.y=null),d+=h&&!k.visible?0:k.y;this.total=d;for(a=0;a<b;a++)k=f[a],k.percentage=0<d&&(k.visible||!h)?k.y/d*100:0,k.total=d},generatePoints:function(){k.prototype.generatePoints.call(this);this.updateTotals()},translate:function(a){this.generatePoints();var c=0,d=this.options,b=d.slicedOffset,f=b+(d.borderWidth||0),h,k,q,w=d.startAngle||
	0,e=this.startAngleRad=Math.PI/180*(w-90),w=(this.endAngleRad=Math.PI/180*(l(d.endAngle,w+360)-90))-e,r=this.points,u=d.dataLabels.distance,d=d.ignoreHiddenPoint,E,m=r.length,y;a||(this.center=a=this.getCenter());this.getX=function(b,c){q=Math.asin(Math.min((b-a[1])/(a[2]/2+u),1));return a[0]+(c?-1:1)*Math.cos(q)*(a[2]/2+u)};for(E=0;E<m;E++){y=r[E];h=e+c*w;if(!d||y.visible)c+=y.percentage/100;k=e+c*w;y.shapeType="arc";y.shapeArgs={x:a[0],y:a[1],r:a[2]/2,innerR:a[3]/2,start:Math.round(1E3*h)/1E3,end:Math.round(1E3*
	k)/1E3};q=(k+h)/2;q>1.5*Math.PI?q-=2*Math.PI:q<-Math.PI/2&&(q+=2*Math.PI);y.slicedTranslation={translateX:Math.round(Math.cos(q)*b),translateY:Math.round(Math.sin(q)*b)};h=Math.cos(q)*a[2]/2;k=Math.sin(q)*a[2]/2;y.tooltipPos=[a[0]+.7*h,a[1]+.7*k];y.half=q<-Math.PI/2||q>Math.PI/2?1:0;y.angle=q;f=Math.min(f,u/5);y.labelPos=[a[0]+h+Math.cos(q)*u,a[1]+k+Math.sin(q)*u,a[0]+h+Math.cos(q)*f,a[1]+k+Math.sin(q)*f,a[0]+h,a[1]+k,0>u?"center":y.half?"right":"left",q]}},drawGraph:null,drawPoints:function(){var a=
	this,d=a.chart.renderer,f,b,k,h,l=a.options.shadow;l&&!a.shadowGroup&&(a.shadowGroup=d.g("shadow").add(a.group));H(a.points,function(c){if(null!==c.y){b=c.graphic;h=c.shapeArgs;f=c.getTranslate();var p=c.shadowGroup;l&&!p&&(p=c.shadowGroup=d.g("shadow").add(a.shadowGroup));p&&p.attr(f);k=a.pointAttribs(c,c.selected&&"select");b?b.setRadialReference(a.center).attr(k).animate(G(h,f)):(c.graphic=b=d[c.shapeType](h).setRadialReference(a.center).attr(f).add(a.group),c.visible||b.attr({visibility:"hidden"}),
	b.attr(k).attr({"stroke-linejoin":"round"}).shadow(l,p));b.addClass(c.getClassName())}})},searchPoint:f,sortByAngle:function(a,d){a.sort(function(a,b){return void 0!==a.angle&&(b.angle-a.angle)*d})},drawLegendSymbol:a.LegendSymbolMixin.drawRectangle,getCenter:a.CenteredSeriesMixin.getCenter,getSymbol:f},{init:function(){q.prototype.init.apply(this,arguments);var a=this,d;a.name=l(a.name,"Slice");d=function(c){a.slice("select"===c.type)};B(a,"select",d);B(a,"unselect",d);return a},setVisible:function(a,
	d){var c=this,b=c.series,f=b.chart,h=b.options.ignoreHiddenPoint;d=l(d,h);a!==c.visible&&(c.visible=c.options.visible=a=void 0===a?!c.visible:a,b.options.data[r(c,b.data)]=c.options,H(["graphic","dataLabel","connector","shadowGroup"],function(b){if(c[b])c[b][a?"show":"hide"](!0)}),c.legendItem&&f.legend.colorizeItem(c,a),a||"hover"!==c.state||c.setState(""),h&&(b.isDirty=!0),d&&f.redraw())},slice:function(a,f,k){var b=this.series;d(k,b.chart);l(f,!0);this.sliced=this.options.sliced=A(a)?a:!this.sliced;
	b.options.data[r(this,b.data)]=this.options;this.graphic.animate(this.getTranslate());this.shadowGroup&&this.shadowGroup.animate(this.getTranslate())},getTranslate:function(){return this.sliced?this.slicedTranslation:{translateX:0,translateY:0}},haloPath:function(a){var c=this.shapeArgs;return this.sliced||!this.visible?[]:this.series.chart.renderer.symbols.arc(c.x,c.y,c.r+a,c.r+a,{innerR:this.shapeArgs.r,start:c.start,end:c.end})}})})(L);(function(a){var B=a.addEvent,A=a.arrayMax,H=a.defined,G=a.each,
	r=a.extend,f=a.format,l=a.map,q=a.merge,k=a.noop,u=a.pick,d=a.relativeLength,c=a.Series,n=a.seriesTypes,z=a.stableSort;a.distribute=function(a,c){function b(a,b){return a.target-b.target}var d,f=!0,k=a,e=[],p;p=0;for(d=a.length;d--;)p+=a[d].size;if(p>c){z(a,function(a,b){return(b.rank||0)-(a.rank||0)});for(p=d=0;p<=c;)p+=a[d].size,d++;e=a.splice(d-1,a.length)}z(a,b);for(a=l(a,function(a){return{size:a.size,targets:[a.target]}});f;){for(d=a.length;d--;)f=a[d],p=(Math.min.apply(0,f.targets)+Math.max.apply(0,
	f.targets))/2,f.pos=Math.min(Math.max(0,p-f.size/2),c-f.size);d=a.length;for(f=!1;d--;)0<d&&a[d-1].pos+a[d-1].size>a[d].pos&&(a[d-1].size+=a[d].size,a[d-1].targets=a[d-1].targets.concat(a[d].targets),a[d-1].pos+a[d-1].size>c&&(a[d-1].pos=c-a[d-1].size),a.splice(d,1),f=!0)}d=0;G(a,function(a){var b=0;G(a.targets,function(){k[d].pos=a.pos+b;b+=k[d].size;d++})});k.push.apply(k,e);z(k,b)};c.prototype.drawDataLabels=function(){var a=this,c=a.options,d=c.dataLabels,k=a.points,l,n,e=a.hasRendered||0,r,C,
	E=u(d.defer,!0),m=a.chart.renderer;if(d.enabled||a._hasPointLabels)a.dlProcessOptions&&a.dlProcessOptions(d),C=a.plotGroup("dataLabelsGroup","data-labels",E&&!e?"hidden":"visible",d.zIndex||6),E&&(C.attr({opacity:+e}),e||B(a,"afterAnimate",function(){a.visible&&C.show(!0);C[c.animation?"animate":"attr"]({opacity:1},{duration:200})})),n=d,G(k,function(b){var e,h=b.dataLabel,k,g,p,t=b.connector,w=!h,x;l=b.dlOptions||b.options&&b.options.dataLabels;if(e=u(l&&l.enabled,n.enabled)&&null!==b.y)for(g in d=
	q(n,l),k=b.getLabelConfig(),r=d.format?f(d.format,k):d.formatter.call(k,d),x=d.style,p=d.rotation,x.color=u(d.color,x.color,a.color,"#000000"),"contrast"===x.color&&(b.contrastColor=m.getContrast(b.color||a.color),x.color=d.inside||0>d.distance||c.stacking?b.contrastColor:"#000000"),c.cursor&&(x.cursor=c.cursor),k={fill:d.backgroundColor,stroke:d.borderColor,"stroke-width":d.borderWidth,r:d.borderRadius||0,rotation:p,padding:d.padding,zIndex:1},k)void 0===k[g]&&delete k[g];!h||e&&H(r)?e&&H(r)&&(h?
	k.text=r:(h=b.dataLabel=m[p?"text":"label"](r,0,-9999,d.shape,null,null,d.useHTML,null,"data-label"),h.addClass("highcharts-data-label-color-"+b.colorIndex+" "+(d.className||"")+(d.useHTML?"highcharts-tracker":""))),h.attr(k),h.css(x).shadow(d.shadow),h.added||h.add(C),a.alignDataLabel(b,h,d,null,w)):(b.dataLabel=h.destroy(),t&&(b.connector=t.destroy()))})};c.prototype.alignDataLabel=function(a,c,d,f,k){var b=this.chart,e=b.inverted,h=u(a.plotX,-9999),l=u(a.plotY,-9999),p=c.getBBox(),m,n=d.rotation,
	q=d.align,t=this.visible&&(a.series.forceDL||b.isInsidePlot(h,Math.round(l),e)||f&&b.isInsidePlot(h,e?f.x+1:f.y+f.height-1,e)),D="justify"===u(d.overflow,"justify");t&&(m=d.style.fontSize,m=b.renderer.fontMetrics(m,c).b,f=r({x:e?b.plotWidth-l:h,y:Math.round(e?b.plotHeight-h:l),width:0,height:0},f),r(d,{width:p.width,height:p.height}),n?(D=!1,e=b.renderer.rotCorr(m,n),e={x:f.x+d.x+f.width/2+e.x,y:f.y+d.y+{top:0,middle:.5,bottom:1}[d.verticalAlign]*f.height},c[k?"attr":"animate"](e).attr({align:q}),
	h=(n+720)%360,h=180<h&&360>h,"left"===q?e.y-=h?p.height:0:"center"===q?(e.x-=p.width/2,e.y-=p.height/2):"right"===q&&(e.x-=p.width,e.y-=h?0:p.height)):(c.align(d,null,f),e=c.alignAttr),D?a.isLabelJustified=this.justifyDataLabel(c,d,e,p,f,k):u(d.crop,!0)&&(t=b.isInsidePlot(e.x,e.y)&&b.isInsidePlot(e.x+p.width,e.y+p.height)),d.shape&&!n&&c.attr({anchorX:a.plotX,anchorY:a.plotY}));t||(c.attr({y:-9999}),c.placed=!1)};c.prototype.justifyDataLabel=function(a,c,d,f,k,l){var b=this.chart,h=c.align,p=c.verticalAlign,
	n,m,q=a.box?0:a.padding||0;n=d.x+q;0>n&&("right"===h?c.align="left":c.x=-n,m=!0);n=d.x+f.width-q;n>b.plotWidth&&("left"===h?c.align="right":c.x=b.plotWidth-n,m=!0);n=d.y+q;0>n&&("bottom"===p?c.verticalAlign="top":c.y=-n,m=!0);n=d.y+f.height-q;n>b.plotHeight&&("top"===p?c.verticalAlign="bottom":c.y=b.plotHeight-n,m=!0);m&&(a.placed=!l,a.align(c,null,k));return m};n.pie&&(n.pie.prototype.drawDataLabels=function(){var b=this,d=b.data,f,k=b.chart,n=b.options.dataLabels,q=u(n.connectorPadding,10),e=u(n.connectorWidth,
	1),r=k.plotWidth,C=k.plotHeight,E,m=n.distance,y=b.center,z=y[2]/2,B=y[1],H=0<m,g,F,L,N,P=[[],[]],O,v,M,R,S=[0,0,0,0];b.visible&&(n.enabled||b._hasPointLabels)&&(G(d,function(a){a.dataLabel&&a.visible&&a.dataLabel.shortened&&(a.dataLabel.attr({width:"auto"}).css({width:"auto",textOverflow:"clip"}),a.dataLabel.shortened=!1)}),c.prototype.drawDataLabels.apply(b),G(d,function(a){a.dataLabel&&a.visible&&(P[a.half].push(a),a.dataLabel._pos=null)}),G(P,function(c,e){var d,h,p=c.length,t,w,u;if(p)for(b.sortByAngle(c,
	e-.5),0<m&&(d=Math.max(0,B-z-m),h=Math.min(B+z+m,k.plotHeight),t=l(c,function(a){if(a.dataLabel)return u=a.dataLabel.getBBox().height||21,{target:a.labelPos[1]-d+u/2,size:u,rank:a.y}}),a.distribute(t,h+u-d)),R=0;R<p;R++)f=c[R],L=f.labelPos,g=f.dataLabel,M=!1===f.visible?"hidden":"inherit",w=L[1],t?void 0===t[R].pos?M="hidden":(N=t[R].size,v=d+t[R].pos):v=w,O=n.justify?y[0]+(e?-1:1)*(z+m):b.getX(v<d+2||v>h-2?w:v,e),g._attr={visibility:M,align:L[6]},g._pos={x:O+n.x+({left:q,right:-q}[L[6]]||0),y:v+
	n.y-10},L.x=O,L.y=v,null===b.options.size&&(F=g.getBBox().width,w=null,O-F<q?(w=Math.round(F-O+q),S[3]=Math.max(w,S[3])):O+F>r-q&&(w=Math.round(O+F-r+q),S[1]=Math.max(w,S[1])),0>v-N/2?S[0]=Math.max(Math.round(-v+N/2),S[0]):v+N/2>C&&(S[2]=Math.max(Math.round(v+N/2-C),S[2])),g.sideOverflow=w)}),0===A(S)||this.verifyDataLabelOverflow(S))&&(this.placeDataLabels(),H&&e&&G(this.points,function(a){var c;E=a.connector;if((g=a.dataLabel)&&g._pos&&a.visible){M=g._attr.visibility;if(c=!E)a.connector=E=k.renderer.path().addClass("highcharts-data-label-connector highcharts-color-"+
	a.colorIndex).add(b.dataLabelsGroup),E.attr({"stroke-width":e,stroke:n.connectorColor||a.color||"#666666"});E[c?"attr":"animate"]({d:b.connectorPath(a.labelPos)});E.attr("visibility",M)}else E&&(a.connector=E.destroy())}))},n.pie.prototype.connectorPath=function(a){var b=a.x,c=a.y;return u(this.options.dataLabels.softConnector,!0)?["M",b+("left"===a[6]?5:-5),c,"C",b,c,2*a[2]-a[4],2*a[3]-a[5],a[2],a[3],"L",a[4],a[5]]:["M",b+("left"===a[6]?5:-5),c,"L",a[2],a[3],"L",a[4],a[5]]},n.pie.prototype.placeDataLabels=
	function(){G(this.points,function(a){var b=a.dataLabel;b&&a.visible&&((a=b._pos)?(b.sideOverflow&&(b._attr.width=b.getBBox().width-b.sideOverflow,b.css({width:b._attr.width+"px",textOverflow:"ellipsis"}),b.shortened=!0),b.attr(b._attr),b[b.moved?"animate":"attr"](a),b.moved=!0):b&&b.attr({y:-9999}))},this)},n.pie.prototype.alignDataLabel=k,n.pie.prototype.verifyDataLabelOverflow=function(a){var b=this.center,c=this.options,f=c.center,k=c.minSize||80,l,e;null!==f[0]?l=Math.max(b[2]-Math.max(a[1],a[3]),
	k):(l=Math.max(b[2]-a[1]-a[3],k),b[0]+=(a[3]-a[1])/2);null!==f[1]?l=Math.max(Math.min(l,b[2]-Math.max(a[0],a[2])),k):(l=Math.max(Math.min(l,b[2]-a[0]-a[2]),k),b[1]+=(a[0]-a[2])/2);l<b[2]?(b[2]=l,b[3]=Math.min(d(c.innerSize||0,l),l),this.translate(b),this.drawDataLabels&&this.drawDataLabels()):e=!0;return e});n.column&&(n.column.prototype.alignDataLabel=function(a,d,f,k,l){var b=this.chart.inverted,e=a.series,h=a.dlBox||a.shapeArgs,n=u(a.below,a.plotY>u(this.translatedThreshold,e.yAxis.len)),p=u(f.inside,
	!!this.options.stacking);h&&(k=q(h),0>k.y&&(k.height+=k.y,k.y=0),h=k.y+k.height-e.yAxis.len,0<h&&(k.height-=h),b&&(k={x:e.yAxis.len-k.y-k.height,y:e.xAxis.len-k.x-k.width,width:k.height,height:k.width}),p||(b?(k.x+=n?0:k.width,k.width=0):(k.y+=n?k.height:0,k.height=0)));f.align=u(f.align,!b||p?"center":n?"right":"left");f.verticalAlign=u(f.verticalAlign,b||p?"middle":n?"top":"bottom");c.prototype.alignDataLabel.call(this,a,d,f,k,l);a.isLabelJustified&&a.contrastColor&&a.dataLabel.css({color:a.contrastColor})})})(L);
	(function(a){var B=a.Chart,A=a.each,H=a.pick,G=a.addEvent;B.prototype.callbacks.push(function(a){function f(){var f=[];A(a.series||[],function(a){var k=a.options.dataLabels,l=a.dataLabelCollections||["dataLabel"];(k.enabled||a._hasPointLabels)&&!k.allowOverlap&&a.visible&&A(l,function(d){A(a.points,function(a){a[d]&&(a[d].labelrank=H(a.labelrank,a.shapeArgs&&a.shapeArgs.height),f.push(a[d]))})})});a.hideOverlappingLabels(f)}f();G(a,"redraw",f)});B.prototype.hideOverlappingLabels=function(a){var f=
	a.length,l,q,k,r,d,c,n,z,b,p=function(a,b,c,d,e,f,k,l){return!(e>a+c||e+k<a||f>b+d||f+l<b)};for(q=0;q<f;q++)if(l=a[q])l.oldOpacity=l.opacity,l.newOpacity=1;a.sort(function(a,b){return(b.labelrank||0)-(a.labelrank||0)});for(q=0;q<f;q++)for(k=a[q],l=q+1;l<f;++l)if(r=a[l],k&&r&&k!==r&&k.placed&&r.placed&&0!==k.newOpacity&&0!==r.newOpacity&&(d=k.alignAttr,c=r.alignAttr,n=k.parentGroup,z=r.parentGroup,b=2*(k.box?0:k.padding),d=p(d.x+n.translateX,d.y+n.translateY,k.width-b,k.height-b,c.x+z.translateX,c.y+
	z.translateY,r.width-b,r.height-b)))(k.labelrank<r.labelrank?k:r).newOpacity=0;A(a,function(a){var b,c;a&&(c=a.newOpacity,a.oldOpacity!==c&&a.placed&&(c?a.show(!0):b=function(){a.hide()},a.alignAttr.opacity=c,a[a.isOld?"animate":"attr"](a.alignAttr,null,b)),a.isOld=!0)})}})(L);(function(a){var B=a.addEvent,A=a.Chart,H=a.createElement,G=a.css,r=a.defaultOptions,f=a.defaultPlotOptions,l=a.each,q=a.extend,k=a.fireEvent,u=a.hasTouch,d=a.inArray,c=a.isObject,n=a.Legend,z=a.merge,b=a.pick,p=a.Point,h=a.Series,
	t=a.seriesTypes,D=a.svg;a=a.TrackerMixin={drawTrackerPoint:function(){var a=this,b=a.chart.pointer,c=function(a){var c=b.getPointFromEvent(a);if(void 0!==c)c.onMouseOver(a)};l(a.points,function(a){a.graphic&&(a.graphic.element.point=a);a.dataLabel&&(a.dataLabel.div?a.dataLabel.div.point=a:a.dataLabel.element.point=a)});a._hasTracking||(l(a.trackerGroups,function(e){if(a[e]){a[e].addClass("highcharts-tracker").on("mouseover",c).on("mouseout",function(a){b.onTrackerMouseOut(a)});if(u)a[e].on("touchstart",
	c);a.options.cursor&&a[e].css(G).css({cursor:a.options.cursor})}}),a._hasTracking=!0)},drawTrackerGraph:function(){var a=this,b=a.options,c=b.trackByArea,d=[].concat(c?a.areaPath:a.graphPath),f=d.length,h=a.chart,k=h.pointer,n=h.renderer,p=h.options.tooltip.snap,q=a.tracker,g,r=function(){if(h.hoverSeries!==a)a.onMouseOver()},t="rgba(192,192,192,"+(D?.0001:.002)+")";if(f&&!c)for(g=f+1;g--;)"M"===d[g]&&d.splice(g+1,0,d[g+1]-p,d[g+2],"L"),(g&&"M"===d[g]||g===f)&&d.splice(g,0,"L",d[g-2]+p,d[g-1]);q?
	q.attr({d:d}):a.graph&&(a.tracker=n.path(d).attr({"stroke-linejoin":"round",visibility:a.visible?"visible":"hidden",stroke:t,fill:c?t:"none","stroke-width":a.graph.strokeWidth()+(c?0:2*p),zIndex:2}).add(a.group),l([a.tracker,a.markerGroup],function(a){a.addClass("highcharts-tracker").on("mouseover",r).on("mouseout",function(a){k.onTrackerMouseOut(a)});b.cursor&&a.css({cursor:b.cursor});if(u)a.on("touchstart",r)}))}};t.column&&(t.column.prototype.drawTracker=a.drawTrackerPoint);t.pie&&(t.pie.prototype.drawTracker=
	a.drawTrackerPoint);t.scatter&&(t.scatter.prototype.drawTracker=a.drawTrackerPoint);q(n.prototype,{setItemEvents:function(a,b,c){var d=this,e=d.chart.renderer.boxWrapper,f="highcharts-legend-"+(a.series?"point":"series")+"-active";(c?b:a.legendGroup).on("mouseover",function(){a.setState("hover");e.addClass(f);b.css(d.options.itemHoverStyle)}).on("mouseout",function(){b.css(a.visible?d.itemStyle:d.itemHiddenStyle);e.removeClass(f);a.setState()}).on("click",function(b){var c=function(){a.setVisible&&
	a.setVisible()};b={browserEvent:b};a.firePointEvent?a.firePointEvent("legendItemClick",b,c):k(a,"legendItemClick",b,c)})},createCheckboxForItem:function(a){a.checkbox=H("input",{type:"checkbox",checked:a.selected,defaultChecked:a.selected},this.options.itemCheckboxStyle,this.chart.container);B(a.checkbox,"click",function(b){k(a.series||a,"checkboxClick",{checked:b.target.checked,item:a},function(){a.select()})})}});r.legend.itemStyle.cursor="pointer";q(A.prototype,{showResetZoom:function(){var a=
	this,b=r.lang,c=a.options.chart.resetZoomButton,d=c.theme,f=d.states,h="chart"===c.relativeTo?null:"plotBox";this.resetZoomButton=a.renderer.button(b.resetZoom,null,null,function(){a.zoomOut()},d,f&&f.hover).attr({align:c.position.align,title:b.resetZoomTitle}).addClass("highcharts-reset-zoom").add().align(c.position,!1,h)},zoomOut:function(){var a=this;k(a,"selection",{resetSelection:!0},function(){a.zoom()})},zoom:function(a){var d,f=this.pointer,h=!1,k;!a||a.resetSelection?l(this.axes,function(a){d=
	a.zoom()}):l(a.xAxis.concat(a.yAxis),function(a){var b=a.axis;f[b.isXAxis?"zoomX":"zoomY"]&&(d=b.zoom(a.min,a.max),b.displayBtn&&(h=!0))});k=this.resetZoomButton;h&&!k?this.showResetZoom():!h&&c(k)&&(this.resetZoomButton=k.destroy());d&&this.redraw(b(this.options.chart.animation,a&&a.animation,100>this.pointCount))},pan:function(a,b){var c=this,d=c.hoverPoints,e;d&&l(d,function(a){a.setState()});l("xy"===b?[1,0]:[1],function(b){b=c[b?"xAxis":"yAxis"][0];var d=b.horiz,f=a[d?"chartX":"chartY"],d=d?
	"mouseDownX":"mouseDownY",h=c[d],k=(b.pointRange||0)/2,g=b.getExtremes(),l=b.toValue(h-f,!0)+k,k=b.toValue(h+b.len-f,!0)-k,m=k<l,h=m?k:l,l=m?l:k,m=b.toValue(b.toPixels(g.min)-b.minPixelPadding),k=b.toValue(b.toPixels(g.max)+b.minPixelPadding),m=Math.min(g.dataMin,m)-h,g=l-Math.max(g.dataMax,k);b.series.length&&0>m&&0>g&&(b.setExtremes(h,l,!1,!1,{trigger:"pan"}),e=!0);c[d]=f});e&&c.redraw(!1);G(c.container,{cursor:"move"})}});q(p.prototype,{select:function(a,c){var e=this,f=e.series,h=f.chart;a=b(a,
	!e.selected);e.firePointEvent(a?"select":"unselect",{accumulate:c},function(){e.selected=e.options.selected=a;f.options.data[d(e,f.data)]=e.options;e.setState(a&&"select");c||l(h.getSelectedPoints(),function(a){a.selected&&a!==e&&(a.selected=a.options.selected=!1,f.options.data[d(a,f.data)]=a.options,a.setState(""),a.firePointEvent("unselect"))})})},onMouseOver:function(a){var b=this.series.chart.pointer;this.firePointEvent("mouseOver");b.runPointActions(a,this)},onMouseOut:function(){var a=this.series.chart;
	this.firePointEvent("mouseOut");l(a.hoverPoints||[],function(a){a.setState()});a.hoverPoints=a.hoverPoint=null},importEvents:function(){if(!this.hasImportedEvents){var a=z(this.series.options.point,this.options).events,b;this.events=a;for(b in a)B(this,b,a[b]);this.hasImportedEvents=!0}},setState:function(a,c){var d=Math.floor(this.plotX),e=this.plotY,h=this.series,k=h.options.states[a]||{},l=f[h.type].marker&&h.options.marker,n=l&&!1===l.enabled,p=l&&l.states&&l.states[a]||{},r=!1===p.enabled,g=
	h.stateMarkerGraphic,t=this.marker||{},u=h.chart,w=h.halo,z,A=l&&h.markerAttribs;a=a||"";if(!(a===this.state&&!c||this.selected&&"select"!==a||!1===k.enabled||a&&(r||n&&!1===p.enabled)||a&&t.states&&t.states[a]&&!1===t.states[a].enabled)){A&&(z=h.markerAttribs(this,a));if(this.graphic)this.state&&this.graphic.removeClass("highcharts-point-"+this.state),a&&this.graphic.addClass("highcharts-point-"+a),this.graphic.attr(h.pointAttribs(this,a)),z&&this.graphic.animate(z,b(u.options.chart.animation,p.animation,
	l.animation)),g&&g.hide();else{if(a&&p){l=t.symbol||h.symbol;g&&g.currentSymbol!==l&&(g=g.destroy());if(g)g[c?"animate":"attr"]({x:z.x,y:z.y});else l&&(h.stateMarkerGraphic=g=u.renderer.symbol(l,z.x,z.y,z.width,z.height).add(h.markerGroup),g.currentSymbol=l);g&&g.attr(h.pointAttribs(this,a))}g&&(g[a&&u.isInsidePlot(d,e,u.inverted)?"show":"hide"](),g.element.point=this)}(d=k.halo)&&d.size?(w||(h.halo=w=u.renderer.path().add(A?h.markerGroup:h.group)),w[c?"animate":"attr"]({d:this.haloPath(d.size)}),
	w.attr({"class":"highcharts-halo highcharts-color-"+b(this.colorIndex,h.colorIndex)}),w.point=this,w.attr(q({fill:this.color||h.color,"fill-opacity":d.opacity,zIndex:-1},d.attributes))):w&&w.point&&w.point.haloPath&&w.animate({d:w.point.haloPath(0)});this.state=a}},haloPath:function(a){return this.series.chart.renderer.symbols.circle(Math.floor(this.plotX)-a,this.plotY-a,2*a,2*a)}});q(h.prototype,{onMouseOver:function(){var a=this.chart,b=a.hoverSeries;if(b&&b!==this)b.onMouseOut();this.options.events.mouseOver&&
	k(this,"mouseOver");this.setState("hover");a.hoverSeries=this},onMouseOut:function(){var a=this.options,b=this.chart,c=b.tooltip,d=b.hoverPoint;b.hoverSeries=null;if(d)d.onMouseOut();this&&a.events.mouseOut&&k(this,"mouseOut");!c||this.stickyTracking||c.shared&&!this.noSharedTooltip||c.hide();this.setState()},setState:function(a){var c=this,d=c.options,f=c.graph,h=d.states,k=d.lineWidth,d=0;a=a||"";if(c.state!==a&&(l([c.group,c.markerGroup,c.dataLabelsGroup],function(b){b&&(c.state&&b.removeClass("highcharts-series-"+
	c.state),a&&b.addClass("highcharts-series-"+a))}),c.state=a,!h[a]||!1!==h[a].enabled)&&(a&&(k=h[a].lineWidth||k+(h[a].lineWidthPlus||0)),f&&!f.dashstyle))for(k={"stroke-width":k},f.animate(k,b(c.chart.options.chart.animation,h[a]&&h[a].animation));c["zone-graph-"+d];)c["zone-graph-"+d].attr(k),d+=1},setVisible:function(a,b){var c=this,d=c.chart,e=c.legendItem,f,h=d.options.chart.ignoreHiddenSeries,n=c.visible;f=(c.visible=a=c.options.visible=c.userOptions.visible=void 0===a?!n:a)?"show":"hide";l(["group",
	"dataLabelsGroup","markerGroup","tracker","tt"],function(a){if(c[a])c[a][f]()});if(d.hoverSeries===c||(d.hoverPoint&&d.hoverPoint.series)===c)c.onMouseOut();e&&d.legend.colorizeItem(c,a);c.isDirty=!0;c.options.stacking&&l(d.series,function(a){a.options.stacking&&a.visible&&(a.isDirty=!0)});l(c.linkedSeries,function(b){b.setVisible(a,!1)});h&&(d.isDirtyBox=!0);!1!==b&&d.redraw();k(c,f)},show:function(){this.setVisible(!0)},hide:function(){this.setVisible(!1)},select:function(a){this.selected=a=void 0===
	a?!this.selected:a;this.checkbox&&(this.checkbox.checked=a);k(this,a?"select":"unselect")},drawTracker:a.drawTrackerGraph})})(L);(function(a){var B=a.Chart,A=a.each,H=a.inArray,G=a.isArray,r=a.isObject,f=a.pick,l=a.splat;B.prototype.setResponsive=function(f){var k=this.options.responsive,l=[],d=this.currentResponsive;k&&k.rules&&A(k.rules,function(c){void 0===c._id&&(c._id=a.uniqueKey());this.matchResponsiveRule(c,l,f)},this);var c=a.merge.apply(0,a.map(l,function(c){return a.find(k.rules,function(a){return a._id===
	c}).chartOptions})),l=l.toString()||void 0;l!==(d&&d.ruleIds)&&(d&&this.update(d.undoOptions,f),l?(this.currentResponsive={ruleIds:l,mergedOptions:c,undoOptions:this.currentOptions(c)},this.update(c,f)):this.currentResponsive=void 0)};B.prototype.matchResponsiveRule=function(a,k){var l=a.condition;(l.callback||function(){return this.chartWidth<=f(l.maxWidth,Number.MAX_VALUE)&&this.chartHeight<=f(l.maxHeight,Number.MAX_VALUE)&&this.chartWidth>=f(l.minWidth,0)&&this.chartHeight>=f(l.minHeight,0)}).call(this)&&
	k.push(a._id)};B.prototype.currentOptions=function(a){function f(a,c,k,q){var b,d;for(b in a)if(!q&&-1<H(b,["series","xAxis","yAxis"]))for(a[b]=l(a[b]),k[b]=[],d=0;d<a[b].length;d++)c[b][d]&&(k[b][d]={},f(a[b][d],c[b][d],k[b][d],q+1));else r(a[b])?(k[b]=G(a[b])?[]:{},f(a[b],c[b]||{},k[b],q+1)):k[b]=c[b]||null}var q={};f(a,this.options,q,0);return q}})(L);return L});


/***/ },
/* 235 */
/***/ function(module, exports) {

	/**
	 * lodash 3.0.8 (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright 2012-2016 The Dojo Foundation <http://dojofoundation.org/>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright 2009-2016 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 * Available under MIT license <https://lodash.com/license>
	 */
	
	/** `Object#toString` result references. */
	var funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 8 which returns 'object' for typed array constructors, and
	  // PhantomJS 1.9 which returns 'function' for `NodeList` instances.
	  var tag = isObject(value) ? objectToString.call(value) : '';
	  return tag == funcTag || tag == genTag;
	}
	
	/**
	 * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
	 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	module.exports = isFunction;


/***/ },
/* 236 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(114);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(47)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../node_modules/css-loader/index.js!./style.css", function() {
				var newContent = require("!!./../../node_modules/css-loader/index.js!./style.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAEAElEQVR42s2XbWxTVRjH/+eeu7a3ydYVur6sjjK6uenaYtnoyOi6qSHMyGQIMZJgNIERSfwiETqGRglEO5H4yQ9ESUwUP5gA29Cp3xYlRKPCYMki8QOJCUtMFgPdur7s9l6f225diWOjpNs8yblvvbe/3/Oc55zcy7DKjf1vBHp6el6IRCKDqyJA8DraHaX+IUncWg2BI7Srp/4HCZxecYFZiXME319swIWQ8WkIbGL3cGx0RQUutjhKIcx8JFmt3VKFtan97PC1FRO41OzeBiH1qeu5F12eg2Ho7JUPnG1FFbjk95eCa1Gv7fa/1cusjVsAVQUrL19cIBwOn2OMBUmg7lHh/b6tAUr5167O7a6GQ4dQIknZHzSBNWuWNwP9T2zTU+SjTScO1zqfac1Ac12DWCzLKzBQ33ncHnrqVOCDw/fD5wRsFcsnMOje6+ISG2v/6oRRsq2dBWNeIJGC4HYuo0D1axfrDnbsqn11+3/hKRmIJiBsWr90EdIu2NfXV1ARXq56o8NYZRoKffEm4yU8C1VmBZIEn0pljoXAuuJn4LL9mJ6qfnTzmZdrrc01uchVhQ5iBE/ISCgMY3ERN+I634FOU3FXwm+s7x23hapPNb7fNQ9PKohH0xiJCrg+LeK2XILHHRycqRu72ww3iybwreWMS9CpY61f7qXCK6V0K7g1oWLgb44/UxxPPsbRtJ7DU8mhFxmmU4pgM3G1aAJDlk/6a/b5dm54aSOlWsHoJHB6XMQrQT0C1VnoXC1qIyIwVSiThAcLPGwRDhnPu2ncdxsdhkjLxx1MEDlGYkBknOHoDgMaKGIlbwlQMrWowm4SHq0Iv+PfE1BuB8v0Nr1FV2X2mOHa4UbZhnJcn1JxclzBsU4JDU6eg2qhKnSSmYVxetFwFCDwg/iTT5WVI2AKAXlVubcMZo8J5gYzjA4p98i1qTTevSOjd6cBHqeYg2c6beIzWbgm419XgMAvvpteW7DihtlTxiS7YcG31t8I3nsngbe7JHidPA8MyHRwl8DTqfn7W9y8sCGYuaCSP8T8G7UI/6JqvxqVcXYihXd26QkuZsBpAqfphskEMnDtPL89W88LWwlJIEn/p7sdT+Pq3TR+JuivkzIEI8NmqvIuvw51dp4BaRHfi2fBM+mFIc97C8hAKBz1VUvC71f+kUXVQOmrEdHsFtHoElFZLlCkBKXNvUR2jGmpz2RhsbZnUwECW09GvXsCupEtNVxwEjChrao0IDEa01hSxVQyO75LQfPbvmaxsBr4/Ec5ITPoHx6xeDvQWqDAZ8NynAQMxRJ4vU3M//4YzP/4uU9goYdVVQ3S++KVYl2bbQNzn4FLfpxqM4Rmx/5iXFs0A6vV/gVNzBY/AtLbZQAAAABJRU5ErkJggg=="

/***/ },
/* 241 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAKCAYAAACNMs+9AAAAAXNSR0IArs4c6QAAAAZiS0dEAP8A/wD/oL2nkwAAAAlwSFlzAAALEwAACxMBAJqcGAAAAAd0SU1FB9wIFAoyLJQcQLkAAAAZdEVYdENvbW1lbnQAQ3JlYXRlZCB3aXRoIEdJTVBXgQ4XAAAATklEQVQY08XNsQnAQAxD0X+QUVx7gFvDAxmv6Nq7OFWOQMiViUrxhOC3DIDMfAWqCsBxFRHRVbWAiODu47HMTMys55xtZr17WXiL7vibnCFkHelcbNvXAAAAAElFTkSuQmCC"

/***/ },
/* 242 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAB3RJTUUH4AMdDAU5FCvBmQAAAKlJREFUOMtjYBj+QFle3lBJTj4QlzwTXs1yilYMDIznmBgZBciwWcFBSV7hv6KsXDHJmhXl5Z2U5RX+K8kpRpGsWUlO3kdRVu6/srwCUZpZ0AUYGRmTGBgYnzD/ZtpOjAEYgfjhz58QRoZ/F/+y/rslLysnTnb0KcorzFKWV3ijJC+nQYkhS5XlFT4rycmp4FLDjM+ADx8/rBPi52dgYGT0eP/x49ZhmlcASpkjnx2uzJ4AAAAASUVORK5CYII="

/***/ },
/* 243 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAB3RJTUUH4AMdDAADr1DsbgAAAP1JREFUOMvdk71KQ0EQhc8slsHGYOXumb2jCFoY7AWr3DqFCCJYpxMLbSxUfBXfQHwBfQQFEUS5PoS/2bW5QS2CW2e6gfnOYf6A6Y7Kxx0LrMe5kYsVdet3jZsERx9rkXyRBe8tvALIQxZ0C5x124LmiuyPYaO+Rerpv3AMsd/Cmy28ZNSk1LMCZw5auAYAU64b9TVS9ycxf2YgTvYgaPKnXAMARnkXwEhyuioSCL3VQQIaN4M7AHh8aQ4kpyMRd28MvfL1US8t6FNc0FkAMB+OjfwwhrVikej1xoI+z1fe/YhoMnK56A46nNvIwG3ny5207ZxLSkNkHE7Zv3wDP0BEJhOixVsAAAAASUVORK5CYII="

/***/ },
/* 244 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAB3RJTUUH4AMdDAcNB6lXrgAAAL1JREFUOMvdkKEOAjEQRLd3aNKe722vlQSHIXwACkfweBSaXwIHf0CCIcHgCAQEBtH2HIguigRxyVEcPDnZ2cwMwM+TVokacZQJQda5W92DpEqkACIQ7Q1i66sErvTbjPMHEMwF5yvr/fWrfloWYyMVacw7UQle2NLtBG+eibFlxvnaen/8aIN3WJpsEoI7A+hFV0CJbYOKdK5m0eYCi75BFTTiJN4ssWtQBZOrad1to7I3gwEjNjxcTgv4f56mOTVLblp90AAAAABJRU5ErkJggg=="

/***/ },
/* 245 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAB3RJTUUH4AMdDAA4HlsFSgAAARVJREFUOMvdULFKA0EUnN2kEry3FwtBuX2b3ULE2ko/QbBOoZBv8Cds/AYrIWIRSxFtRVKlVBBD0ig2dxvBwkTXIpcQ4cRr9XUzMPNmBvjzV5kHTpuGUvSaee8nuL4bU7Seen/3k4GcByFgWUI8GtY2Z8aAaDvmrVIJ0mF2W1uMFqQUx6So1Rv0OzWKuwG4VBF1s6G/L9XLaX3o2HzUmTmvtmM1h6IklSKD1PurJaJ3IdAiRe3eoH8zTRITdVLvHwo3+LYHxDmCkBJyDwCq47drAfEiIPd/rWC12XRsgk10c8YxPznmi3JibUY20QcAsLa6onLxWRnxhmPzORVvR1HVan4u9XliwCc20bOOjvnIMZ/if98XVR9SfNJ0yW0AAAAASUVORK5CYII="

/***/ },
/* 246 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAAAZiS0dEAP8A/wD/oL2nkwAAAAlwSFlzAAALEwAACxMBAJqcGAAAAAd0SU1FB9sKCg8qOaoSvZQAAAMjSURBVFjD7Ve/i1xVFP7Oj/vrvfueSxIxxQYLQXshqTalVSCSYYvo2mhAO7uw8yfsYmdnsaVYGCYmkCIYIkgKNcRGiGiTZhWbkDS6kJn3rsXMe5m32WRmx5AByYXDzBwu95z7ne9+5wzwck1Wv98/u4y4PAn+FoB3J58vPgEAZwEgpfTCUaCpEuw83KseVTU+bhIzqgjBI9tnNbvdy3fN8ZBl+krMURYRZZGjjBnKIk9FDIONk2F9ngR0+kdV49x7vTNcFhHM3JoxBjFGqCpEBD/8eHv13OnXYUI5hpGAE68GHCstMqd0+0/uzYuA7kfEaNdFRPDeg4haExFoWz1gJRpEr7DK8IY6yM7Fgc3NzZ2U0tpBG4wxbeAmoenjhYGV3MApwQrBKh+ehNvb2xeI6BaANByNuhCpdoODUFUVRlUNAMi9whmG1bFN9qaFSiCEy18Nrs0kYcVu95u7vz2VhDGGwSJCtLM0IVrmooaEANYe7tW/1Am9xv+UEqQHj/zuzXtuNXhHWXAI3iN4hxAcgnfIvG++18Hbrz84Fc7PJUT3/64+/Oj9HllrOzpQFAWyLIOIoK5rXL9xE/8cOQUV6Rz22orDkcIgekHuFEYZ39+j4cZJb+ctARljOg5rLZxz3VcBPBG8CIrgGMoEZYYwwepsTZjJgRBCR4SaJ9k5hIA8CFQYKtSaMB2ahGk4HHZuK5ObNsGrqkICMKqqdp+3AiMMw48Dj4PP1oSlk/ClDnSk+JNPL16aLoE1BkXMEGOOIs/SHpW7d+4fXc2Co+DDGO4J7E0JsuCSd3Zw/m17+HmgTuhd2Fgn58Y6ICLw3sN7DxDR9W+/O/HOG29CZQwcM2CVUWaKo9EiBoG3RD//RYebB6baMRnzOCcRadvxuCuiDd62ayHkTmGVYIThdYF5YKodPyFCz3r/AJB5hTUEowyjDFX6TyRMw+GovT0zd99/QjsHAIAyI1iGm8wCRghMvPg8wITBzpeXnk3Cn37vkPDXPw4m4UIJfPH5Z+v/ax3o9/sX9//5oRlKuAbg1nP0NevK1tbW1ZkZT3rEc/MdhMDS17/KPtrYN9+xbQAAAABJRU5ErkJggg=="

/***/ },
/* 247 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAAAZiS0dEAP8A/wD/oL2nkwAAAAlwSFlzAAALEwAACxMBAJqcGAAAAAd0SU1FB9sKCg8qFgHDgM0AAAIwSURBVFjD7Ze/b9NQEMe/d+/dOXHCry4wISQkGNiZIhaGbkWKMtAFCdiQqk4onpmSf4CKISysEAnEUKZKqCys/AOIgQEGJlji9jE8x3Ea0yrOox7gpCjyi6W73H3v46+B/5FFkiQbdeTlLPl1AHey79MvAMAGAKSHdOpdoMIIRnvfLp+bcNyNxJKqIFKBqkBFoGr9tSjy30Scqh0/uXutV7UAW7z4mUp3a/MWifhjZkAtQy1DLGGtrVhrC5pq0BAGM9HTd1+6IUaQd2Sa/GhEwmg3DCwTDBOYCZHwXBcrF9Dv90fOuc5xN55pWJ/cEAwDhgGmQCIcDocPiWgfgJtM0oWbxPh/65PPOnBwCABwqxQw1+/YTsbPXr1fToRix8EK+Pj8Ua8uDtQWNBUhgM7e9yufUm4uM4LCuWfC9vqlXmUQvf169f7W5u2FVTRMUMuIhKDCON8SXGhlPFBGZBnEhBcffrjt9YtcWQPHcWC2EYxYTbYNAJPfCDFUiQlLa6DVMLBmtoqc8YCJgoiwlAP5KAwhspyzwDDBEIGJcOBcJSbYIgkrcGBehKswIUmSUW2GpM6Yk/zNBzsvl+CAU7Hjwb0bvWAF/ErtH/3A2djmXqDp15B2dj93g4yg8Dgu5YAYQhz53Z/6gRBeoOxxXBpxZCCGFvzA3xDhAgcse/yaPLn/hPACq/oBJyt6gX/PDyRJ8vjoyw+dQMIOgP2AZ9N4PRgM3pxYcWZUgp2VdaD2+A05X5fMVjkjcQAAAABJRU5ErkJggg=="

/***/ },
/* 248 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 249 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAMCAYAAABWdVznAAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAB3RJTUUH3QkKCjk1VXnrCwAAAL1JREFUKM+t0D0uRAEUxfHfG5OMRGMFEtuQE9UkLIJSo2MBCh+d6EQsYQqxAwluqxTFVCorEIWC5pGXF8MUTnnu/9x7c5hDVdVUVQPNHPAIYzzjcfAHvIxTnGCU5GP4C7yES6xhK8kDDGfAi5hgHTtJbr9mw6pawC5Wk+y3/hU2cJ5k0l3WvbBXVSt4wSamOOhfbzr/XmC79d8xTnLXDwwgySuO8NT6hz/B34E2NMUxbnA2q71+S9e4x5v/0ieSsTVT+vpcFwAAAABJRU5ErkJggg=="

/***/ },
/* 250 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAMCAYAAABWdVznAAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAB3RJTUUH3QgNDTctfW5ZXwAAAI5JREFUKM+t0TEOAVEUheFPJsFQsAGlFehNaQkSe7ADa5CIHegkSkp7UIleqVMKGc2bRES8V8xJbnPvf25OckhTI4wsAW5hgiZuMbiPNU4YxeAutriiiMFt7HHH9PuYYY7lx+6AJ1a/vlWGEruQ+YULev/yboKpxAPjWO4hzsGwSOzHDEd0Ug05BlWrtegN2D8WOaohhiEAAAAASUVORK5CYII="

/***/ },
/* 251 */
/***/ function(module, exports) {

	module.exports = "data:image/gif;base64,R0lGODlhNAAnAOf1AAAAAIAAAACAAICAAAAAgIAAgACAgMDAwMDcwKbK8BMTEyoqKi4uLjIyMjU1NTk5OT09PQQicUJCQkZGRkhISExMTFJSUlVVVVlZWV1dXWJiYmRkZGlpaW1tbXJycnV1dXp6en5+fiI8gidBhSpEhy1GiCxUlTBJijBXlzNYlzZZmD9WkjpbmD1cmSxii0Vbk0lelkBkn0tgl0xhmFdqnUVqo0xwp1JwplRzqFZ4rF1womFzpGJ1pmR2pWd4p2h6qmt9q25/qlWGo1uCs3eGq3eTvXuWv1Sm1V6293+63Ge55Wi96WO692nA93XG93nG+XzI+YKCgoaGhoqKio2OjpGRkZWVlZmZmZ6enouZu4yZuoyavpCdvaGhoaampqioqK6urq6zubGxsbW1tbK3vLS5vbm5ubi7v729vYKbwZKfwYKjyYunyoC73ZWhw52nwJ6pyJex0Ju72YC+4qOuyKaxzam0z6+4z6W20aC616K82am71ru+wb6/wLC50ba+1bm/0ITF6IfL7orD44HM+YrQ+IzR+JbH45bR8JDU+ZzU8Z3V/J3Y+rLI37vC1avT6qLZ+6ra86rd+7fN47LZ77/b7bff9bHf/a3g/LHh+7Ti+7Xi/Lfl/Lzg87vk+8DAwcLDxMLExMXFxcbHyMbIysXJzcjIyMrLzMzMzMTL3svO1MnP3czQ1tHR0dXV1dHU2dXY3Nra29nb3drc3tzd3sXa68/U4svf79zf4sDj9sLk9sbl98Pm/MPo/Mjn98ro98zp98jq/M/q+M7s/d7h493h6dLl8tbo89Ps+dHu/dTs+dTu/drs9tvv+tzv+tXw/tnx/t3w+t3y/t75+uDh4uHi5ePk5eTl5eHl7ufn6Ojo6evr7Ovs7O3t7ers8u3u8ePz++Dz/uH0/uXy+eX1/uH5+uT6++j3/uz1++j7++z4/uz8/PDw8PLz9fT09Pb3+vP7/vH9/fj4+fn6/Pz8/f///////////////////////////////////////////ywAAAAANAAnAAAI/gBpfcFCsGDBL7QEGlyIUOHCg7RcSZxIceIXahgzaoz15aLGjxw9fszI0RW7kyhTsnOFhZq7lzBh0iPoMmbMmS1t3sRiUqVKljV1usMZVCdRoS9n9vTJrl07oEiH0ox6FKlSpk6dQrU6lWtOrktPZs26VWhVs13RLh07tqzRtG+/qhXL1p1WuXGL2jz71hXbrHaf4t0Ll/DgnX7rxnRrWO/OwzJ5/rXp6kssepgza+54WbNnzp4/JwZM2eFDLA0HnkadUPVphBVjSzT9MPVq1rQZ0rrGu7fv3iJHUgspnGTH4hg5XmOa8hpkd5cLw4z+PPpyn9y2nXTu2F0UCXxh/n4P/3I8lusqtWXbftiDhE/k3cOXLn8mepTdsmljr9cDADFSDeYfgOENKNV9J6nXDX/udFCFO6YA4EFSUzkIoYQU5mRhhBMeeFI33LDTjTb78RcCAAB4IYECaGRIzYkprthigC+iqCKLFF6nHjskLsggBwqgKEFkOQEpJJEuGQnAkDmiRCKJzeVEixdBToGkO1NWeWWWAFjZ5Enb9BhlUFVIEMuVL5V5poswqRnZfdto15xloW1GZ52YgYYnPV8g6NM1uRlk22qDvrbbb4gC6lptrd1WKKOJIhrcSMQhV2lxyjGHEndIUdcddOS9ZB07ppRqaiigmMIOpzqZB5mrnd2Zt5yppn7Sh6qsxlQffe/F1+t5pNIqSh+f4CrgfzTaZGCByNoXbK19iGKsSxtimGy1HR6FbZOmiBJKt58UOy2MN85IFLkyuogujh6aYqu7n0g7rTtKMplsvVfiyy284Zq6qpRUdrllwF4my2XBzpYKSrjyzpummWi64yabD6/ZrsKp+nvNnXjq2THHdfap6XaBQlQyQY/qFulvAQEAOw=="

/***/ },
/* 252 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAAUCAYAAABroNZJAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAB3RJTUUH3gEODxoaf0zN4AAAAPBJREFUOMvtktFqAjEQRc+km5J+VsR+dY2yVXT/Z5XVzSTjS10oWmnxoVB6YV4uw+HOZaQ/HIwH1Tjn+EOQJ3kc8jgBcOIEcYIWZb1ZU61y8UottO8tWfPk3RrnRHAidLsdfd+TUsJqpZZCSon9fk/XdVz2bo2YmQGoKouUGMeREAICDMcj3nte53OapvnynAkCUGslLZcMwwBACIFZjHcBV8WWUqi1/rjYKUnOmbfFAlXlJQQQYRiGb50zJVlvNqgq3ntijMxi5Nl7VJXtdns/in3odDrZcrWycRwvluWcrW1bU1W7p0/F/u7H/kOudAY1ua6xJgbfogAAAABJRU5ErkJggg=="

/***/ },
/* 253 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAAUBAMAAACZjst6AAAAG1BMVEXe4+bw8/Pz9fX19/f3+fn5+/v8/P39/v7///9kr4t5AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAB3RJTUUH3gEODiQjYE40ogAAAEtJREFUCNdjUIICBQZjKDBgcIECB4ZQKAhgSIOCBCRWeUF5OXt5eXkBQwcDRwNDR0cHkGhgYOCAsDoYQEKoLIQsko6ODpgOCCCDBQALNkfah4uKEgAAAABJRU5ErkJggg=="

/***/ },
/* 254 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAFOElEQVR42tWXC1AUdRzHf3tAE5XZSDnFhOWMBU0PHE0MB7W0HBkJ5TyRAxPiEQgJqcChYUqQ3oFGovKIR4chHHkciM9s1BHMZqgMHW2wfCWONZnmA7zH7u2/3/7vbrtlmLm1ccB+M//Zuf38Ht//b3+7t8vAMBtz3wjIy8uL1Gq17cMiAIsH4iEXVzGKODMcAnLwEISrBwWUDLkAp4haLJ40lMX/vwIauswGhmGUbvEEzbQoxDdmSARUd9y0R433VWBdsPMEbByB/T/b+JRpI73+kwCNRlOLOwpDAYFygsoO/EmiJz1Ki3N2h4jdJ/shc9bou36uDNoBw3GbcbAWx0x4QCX80O3sJQsmjxIFcDwPe7tvgWZuAPVv+N5sVCgU0nieN8VN8lXJEqD/ro8Pf8GH4QkPHLbXguvbi4QkhD6iEPia5l+J6rXRjuJUAF6C7mtQsPA5mq/y8HVeOeFhBkXj5eHBwhI42GMlaW+MUsgSUH7oGol42RdYTM5iAtbOQ+c5DtJn+FH/3PpTJGqyP7C0AzyYrTwcOX0ViuNfory4vZeoQ/1ocZvdIeLrk7cgNzKAkSVg454rZE7wCBooCBCG7Ng5C6yY40/9l1b+SCJDx1Bh/WY73DZz8NPZq7A5bSLl+Y1nSGzYUzTeirF9Fg4On7oORbGBgwsYOIRFLRfI7ODHMBiLY/v6rRx0/2aG/PljqX/yZ8fImxOfAYvNDtgEasdOXYaaD6ZQnll1nKhffxasLA83+lm40cfC8bN/QVnqBHkd+HB7D5n5ih+YbTzcQfXCpTjd2wefxAVR/zjtITLz1XGSRAd/OAvb82ZQnrChg0RMGQf9GItNotbRfRH02dPkCVhWc4JMHOdHp9tlJ87/DaXJwdQ/as0+8vbUFyWJdnWehtaCcAdfizxsAD+KfG24PAFpW7pISNCTEseunj+g8v0Q6j9b08YrZwQz3l6O5w5nt4Pp0AmyXzePTvns3BY2amqgt7eXwsl5aO08w+0vnu8jS0D8hiNk+vixEscj3RegPnu6Y8ormy/5jwRxpIUxuHITenPTFo4RflfqDb3+j4942ksQiNCOAn+/dvtyakJMgKwhXFB4gH8r5HnGfQffdP1CdqyeRU9U19XzyrkRjFBAuNc5joO2XXtJSmK8i5OoyAgqTeDC2rl7HyCXdwm05U2XnnjIHsA4KcbD1TtevXnparrDTVuryOLYaDG5YA0GI2RlpDIuHqOaJzLh+JWpXeQeBWACPloZKe6QxR22tO0mmIDucP2GTSQlIU4ioHZbE6zMzmJcfLFaJRYXVkOzSeQeBRQVl5Kkd2LEYGHpG3dAfu4y6r+6UEcyUuLFAlarFWq/bIbC1RqRJy/+N95isUCjsV3kHgXkfVREC7gSsCwLNdsMoP04n/qvWFVAlmck0+Eym81gs9lA32SCjevWiHxJYhydDSFWyFFvaBW5xyHMWL6KZC9NAR6fA0JyoVBFXSNs/XQd9U9ftpJkJC+iBVxWpTdAeel6kb8Xv1BS6PP6ZpF77EDK0hySlRpPC7tsS00DVG8uYVw8PTFWkqgcBbrzJe+qJbziiyaRyxLgqUBagvTtC+99CU8d0IEq7MDdCOCT4lSMj483ZSzLQe12I8EEChdPjFUi93FyFuoaTe7crlbOUfh4O+PxUjWZ9vDIvWQJSM3MMeK/nOSNRsGAqaqsRCWHp2XmVOD/V5Q7x2da68gHFedx1trdP34kAmAQwwkOw6Cj9+qc03a6PgM9vkQKd4hOp0u6F+ecX2CDd2C47B8J82xO/BKtugAAAABJRU5ErkJggg=="

/***/ },
/* 255 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAADFklEQVR42u2Xf0gTURzAv2/Of+rfoP4QQhC1hESTQLBJIPk76TQdEhqZlRUOQt3QEAmMmRaOKC2dpEQa6OlcmE7BFEUKKZSWpdAII6J/K1F3d693r93YK/FUhjPqsduD+9z3+/3c995xPAQBHmjHCJhMphNms7k/IAKkeASZKshxk0i8D4RAOZkiyfGOCNRvu4BHwkqKF21n8f8CO0fAaDRaEUIJRCDi3+zAXydgGfzSDQhxPvGY/HhD8r6cbRGot3+SLibtRUEIgYQxrIoYrKNfcXlmiGZLAptdhLW8C5emhNDiErl3ifw1j3yGKi500x+3LXWgumseG9L2gygLSEBFmh2LcF0fTvNVd86TRwS/PSLgCc/ZkICxw9mN4M9nbC6IoglMHW9xaUYoiBKmdy8SiQeOj2AuOIg8XKo4GYaCNEA7tOKWoNH+AROu2ZDAVeuMVMFF0ARycjmBxb6AbxdFazwcX0kPowLKYR12AeFI4VW5kV45eW7om/dyVYHLTdP4Wl6UJznQ+VbvHNwtiUMKv5QeTs8LZAEurYrQ+dzF8PXiVRdhsWUKV+oP/UpACghkbux1QoshHin8fFokrAgS/FgWwU2q2CZdDF8vXrUDhQ1j2JgX4w2WE93pm4X2skSkcE4XTrkybJMLDPeN/04kWwfeeLmqgP7GCC7LPUwLu+UWr4jQNjALXZVJSOFZCQeYRLaJOYbL8fLa+bYs0LlzxOnlqgJczSA2nIqDVRIoF5clHjtmga9JQQrP0kWxAuNOhhemRtM4ZfjGqwpkVNlxQWosbZ83wdBreFqbiRTOHYtmEvGjMwzPT45huG+86iI8Xs7j/NQ4NsGzaXDUc0jh+mSWdw2xfL141Q4kGp7gwsx45sJ2+xSMWfKQP7iqQHzJI1ycrWMubOkZh6mm08gfXFUg9txD6UK2DgUHaylzuwW43zOOX7We0fiDqwocOXuve0kIZr4Fu7QC/7KtJGerfLfWzR/ds/hCq8H9vpsfRgDWGBjjBLJAJ/x1zjNsyjZQ9fstvyF1dXVF/jjn2YGt3YFAjZ+464c/Sl6qmgAAAABJRU5ErkJggg=="

/***/ },
/* 256 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAAfSC3RAAAAAXNSR0IArs4c6QAAAAZiS0dEAP8A/wD/oL2nkwAAAAlwSFlzAAALEwAACxMBAJqcGAAAAAd0SU1FB9wGAwoFAEQ9XSkAAAF3SURBVCjPfZI/bvJAFMR/b73G0ACNhZApEQ0lBSeAu0RKlO8oFJGoaDgIEhVwAIRER0FBY4EowH92N5X5QrAy5WpmZ+a9J/P5vJLn+VuSJO+ABizlUEAeBMGX7/tTnWXZW5qmExHBGIO1FhF5UjjnUErheR5JkkwAdJqmHwB5ntNsNmm1WqV2p9OJ8/lciD+0iHjOOfI8p9/v0+v1OB6PD1fnHFEUsd/vWS6XeJ6HiHiPTiKCiLDdbtlsNiilALDWMhwOqVQqPytY/buLc47io7L3Ak/CYkDGmAfRWosx5mVgT0JrLWEYEkXRU8cwDLler+VCay1xHNPtdhmPx/xOcjgcsPb/inWRv9FocLvdWCwWr7G0fnDu9/vDURlj6HQ6jEajl/1lWcZqtWIwGLBer9ntdmitlQJM0aUMvu/Tbrep1Wo/OUZms9lnmqYTpRT1er38SJXCOcflcsEYQ7Va/ae11lOAJEne4zj+88hFJA+C4EtrPf0G1Yq+tSV2WzIAAAAASUVORK5CYII="

/***/ },
/* 257 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAAfSC3RAAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAB3RJTUUH3QMHCxAqJS/TXgAAAdBJREFUKM+FkrFKM1EQhb9Z597NrlhJUkSwsLTWLi9gZbFPIegz5BVCFEydIlVEUvkIaazstVARRLSRFffea8bmT1AQ/lMdBs5wzsyR8XjsY4xHIYRjEVFgwd/IzCx5789U9VxTSkchhIGZEWNERDAzRARgxc0MVSXGOADQpmlOlsOtrS1EhBACzjkAYox47zEznp+fSSkRQjjJRGQtpUSn06HX61EUBVVV0W63abfbVFVFURT0ej06nQ4pJURkbZVJRLi5uWEymbC/v89sNgNgd3eXyWSCqq7sAwsZjUa3IYSdbrdLVVW8v7+zvr7Ox8cHAGVZUtc1GxsbXFxc8PT0hPf+LluucM4xn8/p9/vUdc1wOGQ4HFLXNf1+n/l8vsoNoEtiZjjnKMsSEaEoCpYRyrLEOYeZrYQyGo1uU0o7m5ubHBwcYGZ8fn6S5zkATdPQarUQEa6urnh9fUVV7xQgyzLe3t6YTqe/tv6EiNA0DVmWraxmKSW2t7c5PDz8U3R9fc3e3h6z2Yz7+3u895ma2Zeq8vLywuXlJYvF3417eHhY2sTMvjTP89OmaQYxRh4fH3/+6heW7RIRvPen6pw7/3eEY+/9f0ue5/mZqp5/A8xa3c+cLpFDAAAAAElFTkSuQmCC"

/***/ },
/* 258 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAA/UlEQVQ4jZ2TPY6DMBCFPyMay42dbdPsibIXQByDhlQxEhwDcYHkYBtBgUyFt0iMvH/A7quex29+nkYjALquO43jWAIvwMw6EuBdKWWzLLuJtm1PzrnrRtKPUEq9pc65cwj0fY/3fjVJCIHWGoBxHM8pcAjJRVHs6tw0TShySHh63uocI9LOaWBaa8qy3GXheDwu76XAMAxYa3dNEFkgWWaZH9uz1i6FfuNB+2mCAOfcJo/xrUBVVZs8RvI1sMfC6gT/sZDAYz17LQQtkKTAHXg1xlDX9SLy3i/CmAMYYwK9p1LKyzRNV+99/LELSqmLAHhe5J/OWUpp8zy/fQAz3IWvDg2CYgAAAABJRU5ErkJggg=="

/***/ },
/* 259 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAABI0lEQVQ4jaWTQW7CMBBFX4wtxTJhkZ6gJ6IXQFlyCIoCAi7BDqHsy63YNItYkS0iQTeENoTQUv7K/uP/PWPPBADb7XZYluU78AIcuQ8BfBpjlqPRaBdsNpuhc+7jF9FNGGPehHNu+h8xQFmWUwnENWGtpaqq71yFYDAYIITo8ogl55qttYzHY6IoapxYrVb0ej2CIABASkm/36/DR1mvqqpqiQEmk0ljv9/vybLsYiKvBWmaEoZhowyA0+mE957ZbMbhcLjEWwZhGBLH8TUNQJ7nLa7zdf6Kpw1aJXjvb6ZaxzoNlFIURcF8Pr97o7UWpVTDQABEUcR6vW400i0opX5+t5BADrzWJg8iF1rrRd1lj8IYswgAzhP50DhrrZdJkuy+AGbsYBP6fSg2AAAAAElFTkSuQmCC"

/***/ },
/* 260 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAABQUlEQVQ4jZWTW2rCQBSGvxMHyTAYTbuCLsNV2A2I21CsCioYdBXiBnQLvgjupYpCGB8k6UM1TDRae97m57+cCyMAi8WiEcfxF/AOJDwvD/g2xoybzeZK5vN5w1q7/ENUWMaYT2Wt7bngfr8nTdMcUUTQWuP7fg6P47ingDdX3G63C9M2mw3r9ZparebCbwpn5mvyYDDI0tI0RUTodDoAbLdbt5PEK0rzfZ9SqYSIoJSiWq0ym82o1+tYa3NcVWRwPB6ZTCbZezqdcj6fc10+NQiCgH6/T5L8TlepVBCRIuprHQDZDl4yuO3A8zyCIHjd4HA4EEVRDnt03kKDcrlMt9u9wx4ZZKe8Lmo4HBaSXc6lPAXsgA+AMAyJoujuVK44DEMX2imt9eh0Oi2vohvC0zLGjATg8iP/9Z211uNWq7X6AfmVdrC4JzooAAAAAElFTkSuQmCC"

/***/ },
/* 261 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAABNElEQVQ4jZWTsW7CMBCGvziJiLFYrk/Qx8lEVwbEW4AilQmkIMQbMCFWFMHG4yAx15lMwgDqQlEpAZp/ujv7/2yfdR7AcrlsO+c+gTfgzHMp4MsYM+52uxtvsVi0i6JYvzBVyhjzERRFMQSw1tYyiwjOuWEAiLWWJElqAdI0RUQk4Neb+/3+v8zT6fQnPAdPFis1GAxuclW1aT6fM5vNKgFhGN7kdzcAyPOcw+FQCVDq9sxKwN9eTCYTlFJ0Oh08z3sN2O12bLdb4jhmv98TRRGNRoPVakUURY8Bvu8DkGUZYRiSZRm+76O1BqDZbFKW5WPA6XQiSRJarRbH4/Fad85d4zzP7wDXrrz6wgqpALAi8p6maS2niADYQGs9KstyfSnUkjFm5AFcJrLWOGutx71eb/MN+BNpUa4itgUAAAAASUVORK5CYII="

/***/ },
/* 262 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAB3RJTUUH3wMJDBcsK1UgEQAAAihJREFUOMuVk7FKI1EUhr+5907MzAhChjxFICDbW1nYaCKOpViYF7BfK30IxUosTCFkDMFHUJFd0EZsooXaZUGEzB0zN3O3Ma5Z48Ke7sLPd89/zvkdgMPDw1q/3/8OhEDOv0sAv4Ig2FlbWztxDg4Oalrr2BjzSem6LtbaL0lBENSV1nrLGIMQAtd1cRznXWCMwRjzJajf728poDT6rdFo0O12Mcbg+z4AnU6HNE0pFouTICUx8uw4Dt1ul2azyd3dHWdnZ/R6PaIoolgskiTJWHdvlYuPryzLmJ2dpVAoMD8/z+npKbe3t6yurjI9PT0RMgaYmZlBa021WmUwGADw8PDA5eUlURTh+z5pmo5B1Mh/lmVYa6lUKuzv72OtZXNzEyklzWaTq6srlpeXOT4+JssylFJ/OrDWMhwOieOYUqlEvV4nDEMcx2Fqaoooiri/v+fp6YnFxUWklKRpOm7BdV2MMcRxTLlcZm5ujr29PZ6fnwmCgGq1ysXFBeVyGaUUWutxgLX2fdqtVoswDKnVahwdHXF+fs719TVLS0s8Pj5ijKFQKHweorUW3/fRWtNqtVBKsbKyws3NDQsLC7y+vtLpdMjz/P1OxCSI53lkWUa73ebl5YWNjQ2SJKHdbqOUQko52oRwdnd3fwDfJt36cDhECIFSCmMMeZ4jpfwo+Sk8z9uecGEASCkZDAb0ej2SJEEI8XeYth2At0T+V5w9z9tZX18/+Q1Ru/9QUjFkiwAAAABJRU5ErkJggg=="

/***/ },
/* 263 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAABBklEQVQ4jdWTPW7CQBSEv7W28LKNTU6QK1jb+gzkApYlTkERKih8DFu+AJwBiQpxk+Bqva5wihBpITY/ZUbaZjQzb1Z6TwDUdT2z1n4Cb8CZ+wiAL631Osuyraiqauac2zwwDUJr/SGdc0ufbJqGvu+vhEIIlFKEYXjFW2uXEpj65sViMThtt9ux3++JosinpxLvz7eTfaRpCsDxePSbnINRx0iIc+6Kk0PCw+FAWZZMJhMA2rZlPp+TJMmfloMBxhiMMU+1ernBUwH/q0FwecDPxj3CjSaQwAl4B4jjmKIoRhdKCEEcxz51kkqpVdd1m1/TjeAutNYrAXC5yJfOWSm1zvN8+w1TaWzQr76JZwAAAABJRU5ErkJggg=="

/***/ },
/* 264 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAAfSC3RAAAAAXNSR0IArs4c6QAAAAZiS0dEAP8A/wD/oL2nkwAAAAlwSFlzAAALEwAACxMBAJqcGAAAAAd0SU1FB9wCFg0POu/We/kAAAJiSURBVCjPRdIxb1NXGIDh97vn3Gvn2jgEkqhY0CghoQNCRUJIFQOkI0FK11ZVh0gV6tR/wMTUCTF0aocOIDqjlgkpFWJgIBJSJ5TIEQSs2A6248S+9r3nnK8DSH3/wLs8AvAn8C3wABAwCgaI+FgQ8AH8D8Aj4DtAHgLfA78BJThbS9P1Urm8JsasoIqGsD0Zj58cjUaPJ/Dux/8H8CtwAq7Mzc/fqa+srH62tFQVEaOqqKrfbzSOm9vb/xx0OndHsPUTYP4ADJydnZv7Zfnq1Zu1er3S73ajeG2NsLhIf2srOnnmTDmt1ZaG/X49z7Ln38AgysGkabo+u7Cw6qxNDjod9vf2tL6xQX1jg/b799rt9WBqKjl17txqqVxed2CsA0Mc3ypNT1c77TZRFOlwOJSDZpPBYECj0RDbbmsURVKrVqtO5FaA320BUaG6rMaYyWRCdnQk/WaT3d1drLWELCMYIx7IwEycW3YQWQcUqhRZxrDVwo1GWOcwzpGWSpSBRARUiYsCr0oB2BzCxLmd42bzfGk4NGUR1UpF9m7fBhFmKhVEVRGRoii8U93JIVgPPiuKv3q93rV6HJ/0zsng8FCvt1pireWZtXpiZkYE2BuPj8ch/O3Amy9BQwj7zvuL09YunY4ik4jIMM/pbm5SevlSUmvpOpe/GY+f9kO414NDAVDgZ7g8a+2dC0ny9fk4rtk8NwAuSfxOng+283zzg/d378MrAcQAHmJgfhG+uCRyY0Hkq7LI5wBj1bdvVF/8q/psF14DLQOFfIJsPqpjKgGbQmQ/IXcQRhBy8MAIOAL8f7xJIc30s21fAAAAAElFTkSuQmCC"

/***/ },
/* 265 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAABMklEQVQ4jZWTMW/CMBCFvwsICXnBdGHvD4KFEbGxMYehbAzmH6BsUfYI/k87MhazWEFIhA6taRIZSt/0zr73zne2BSDLsqFz7g14AUoeIwI+lVKryWSykzRNh0VRbKsZ5/MZ5xzX6xUAEUEpRafTqTkppUbtoiiWTfFgMGA8HteS8zxnv9/XTJxzyzbQ9wvWWqy1zOdzZrMZvV4PgOPxSJIkxHGM1hqttZf0ZbPZvAOv1loWi8Uf7X/DGONNPqKnFA/Q9kRrjTEGa+1teE2ISLOFXwOP9Xr9sKIxphbXWqhWjuM4yJunuzuDy+US5E3cNYiiKMifNijLMshDBkGTVqsV5E19BBx8JCK3neptVHk1BzhImqbD0+m09dN95h14KKVGAvDzI//1nbvd7mo6ne6+AB+zf9f/5Fb9AAAAAElFTkSuQmCC"

/***/ },
/* 266 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAABwUlEQVQ4jZWTv2oiURSHv6uXGeU26mqrrA/gO/gEBuyEIGhjayMWCTapfArFys60Ymkh2grBgKBOKcYRHEbHOLPFrhITFfYHl8s58H33DxwB0Gq1MpZlPQG/AJf78QErpdTL4+Pjq2g2mxnbtjuWZbHf729SSik0TcO2baSUaJqGUupB2rb9bFkW2WyWRCJxUzAYDOj1euRyOd7e3phMJgDPEog4jkMikaBSqRAOh3/AnufhOA7VapVAIEAymcR1XWazWcQHuJ7nARAOh4lEIhcrFAohhDjDp6TTaRzHcX33fst1XUzTpFwuX8AAnU6HQCDATYHnedi2fRVuNBqsViuklLcFpmmSSqWuwpvN5ty/KrAsi2KxyGKxoN/vX8Dz+fxC+kPgeR6fn5/EYjEKhQLj8ZjhcEi73WY+n1Or1TBN87bgeDwSj8fPdalUotvtslwu0TQN+Pu5p8jvAiEEh8OB0WjE+/s7hmEQjUYRQlx7LfLrLdbr9XmfTqdIKfH7/Rf9b/FJ4EPX9d+GYVCv16+e8jWGYaDr+qn8EM1mM7Pb7Trb7fbuMJ2i6zpKKQCUUg8C4N9E/tc4B4PBl3w+//oHxnLOwBxtz8kAAAAASUVORK5CYII="

/***/ },
/* 267 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAACFklEQVQ4jZWTMUgjQRSGv53doLsxQZNeuWxjG6uksdVC0EKwEgWFQELAwvLExjKQIiGkDbETRBtrC9tACIjdXiUomJAiyWx0d+eKuyynEuX+cobv/9+8eU8DaDabm8Ph8CeQBAK+lgC60Wj0bHd391prNBqbUsqrrwjf95FSous6pmmG59FodEtIKU++gt/e3lBKcXh4yOrqKt1uN7wbDocnAkh8BxcKBeLxOCsrK+zs7PxrkhDT3uz7PgDFYpHBYMDp6SkXFxfYts36+jpSSoBATEsfjUbkcjn6/T63t7fE43E6nQ6e52HbdhhgfASDIEBKiVKKu7s7bNtmY2MDIQTZbBbDMDg/Pw+b+a4Cz/MYj8fs7++zvLxMKpVicXGRp6cnstksCwsLVCoVlFLouv7ewPM8pJQcHR0xOztLOp1maWmJx8dHHh4emJubo1qtomkakUgkDDUmZb++vnJ8fIzrutzc3LC9vc3z8zPtdpv7+3tarRaWZYXJE4lJww4ODvB9n1KphOM4XF5eEovFyGQyGIZBLBb7BIcGQgheXl7QdZ1kMomUkrW1NSzLotlsvpu+j9Lq9bqjlPrR6/XI5/PMz88zHo+ZmZmhVCphmiaG8emzJvolgJ6maSQSCWq1Go7j4Lou5XL5OxigpzUajU3Xda+UUiilkFISBAGWZSHE1DkD/iyTBvB3I/9rnU3TPNvb27v+DRPm60vlFQz6AAAAAElFTkSuQmCC"

/***/ },
/* 268 */
260,
/* 269 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAABDUlEQVQ4jd2TMW6DQBBFH+vdAg1QOA1tTuRcwKJGHIG4st3T0LizEH18Kzdx4RVCwgKliMFCcnCcMr/anZ15mr+acQCKolhUVfUOvAAd01LAp4hslsvlwdnv94u6rj8eFN2ViLypuq5XfykGqKpqpYF5H7DWcrlcbr0qRRAEKKV+Ysw1V8/WWuI4RkRGGdvtltlshuM4AGit8Tyvf+50f2rbFhEhSRJEBGstWZaRpukIeDweKctygAyArvv+/DzPJ32HYUjTNDebk9m/0H8CGGM4n88PC6y1GGOGu+4hvu+z2+1Gg3RPxhh83x8a0MAJeO0hT+qkXNdd91P2rERk7QBcN/KpdXZddxNF0eELyfhUxDkoad4AAAAASUVORK5CYII="

/***/ },
/* 270 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAABYUlEQVQ4jZXTTWrCQBjG8f+MJjiOEa1LF1IQV64E76ALScG1eJF24cfaO4gXaDeSkwjiygM0IBgGEky6aE1rS7S+ywd+DzMvvAJgtVq5QRA8AzUg5vpI4F1rPR+NRm9iuVy6xpjXG4jT6QRALpdLM631kzTGvNzCxhhKpRK2bWOMSfMgCF7ywMM1fDweaTabuK4LgOd5bLdbCoUCwIPkyp9/Y4BerwdAHMcAsbwHn6dcLpMkCfC50bvwer3mcDiky/xTEIYhrVYrE282G5RSaXZREEURvu8zGAwyseM4F7n8iev1OsPhkOl0+i98URCGIZ1Oh3a7Tb/fT0s8z8vEAPmfL2g0GgB0u12UUkwmE6rVaiY+F8gkSZDyex37/Z7dbketVsOyrEwMyDzgCyEeHcdhsVgQRRGWZWHb9i0M4Eul1EwIgRCCYrFIpVJBa/0fjNZ6JgC+LvKuc1ZKzcfj8dsHkpSPMXFgHGwAAAAASUVORK5CYII="

/***/ },
/* 271 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAB4ElEQVQ4jZWTv04iURSHv7lzh3Fy1ZDZisawPQmxIoSExsLSbSwJLQ+A3VppQngBWgK8gBY+AfAIRowmhM5GIUxGJpK5dxsHkN1g9leec37fPX9yLYBer3cWhuFv4Aeg2S0BvCqlriuVyq3V6XTOFovFzTemf0op9UssFovL7UQcx8zncz4+PnYCwjC8FIC/GXx/f8cYw8XFBblc7juIL/mcWWvNdDqlUChwcnICQBAEzOdzUqkUQghc18VxnE2AlolZa02tVsP31w2dnp5SLpeRUhIEAYPBgMlkwsHBwapGJDNns9kvZgDXdUmn0+zv75PJZDg/P6dYLBKG4VeA4zg8Pz/TarUwxqySw+GQdrtNt9ul3+8DUCqVUEoRx/EaALC3t4cxhkajwf39fbJlZrMZQRDQ7/d5eHgAIJ/Ps1wuAZCbLUsp8X2fu7s7np6eCMMQ13URQiClJIoiAGzbXnu276K1RgjB4+MjlmVh2zZxHHN0dMTx8TEAo9EIKeXfAK01Ukrq9fo2d6XxeMzLywuHh4crgNgsSJazLWMMw+GQwWBAOp1OwkICb8BPACEEWmuazeaXayS55KyWZSXhN+l53lUURTeJQQix+cJOKaWuLIDPH/lf39nzvOtqtXr7B1AExpQj6LP+AAAAAElFTkSuQmCC"

/***/ },
/* 272 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAABKklEQVQ4ja2TTY6CQBSEv9dxo20iMjdhDqIHkHgK4gYTFm6MF3DbgQPoPRxvMsSFLSwMzAbiIPgzyVTSSae6XnW9RQlAHMcTa20IfAAFz6GAb631yvf9vRhjJlmW7V4MdUJrPe1lWbasidPpRFmWT4dEBMdxALDWLnuAWw8vFou3fl6v17WJq6h2LopXq9/wS1v07h+PxyNxHDMYDBr85XLB9308z2vwLQPP81qiZ+hMkCRJZ4LZbPb/CdTbygdoJQCIoghrLSICQFmWjEYjwjB8bKDULYy1ls1m0xAGQdCZQFWH4XCIMaZlVqNOc3dXst1uD8AnwPV65Xw+4zgOaZo2DFzXJU1TRITxeFzTX2KMmeR5vnvVgS5oracCUDXyT3Xu9/ur+Xy+/wGfSHNWSZ5srQAAAABJRU5ErkJggg=="

/***/ },
/* 273 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAB3RJTUUH4AMRDxo071CyWwAAAeBJREFUOMuVk72K4mAYhZ/8GL6gEZytrOIW/hUqqbUVQQT3BsQ72CvY6eZGxBuYKe0jWKugjRArtdhZI4QEg8k2q6vrrsN+5ct3Duc9D68EMBwOu57nfQM+ARGPnwx8TyaTL71e700aDAZd3/dfPxBxPB45nU6oqkoikQAgmUx+kX3ff/5I7LoupVKJdrtNNpvF8zxOpxOe5z2rwNMjse/7NJtNLMvC8zwKhQKj0YjFYoGu60/y9c7H4xHf9wnD8GJQLpexLOscGYBisXj+E6nXMS3LwjRN1us1URRRq9UwDIPxeEy9Xr+Y2raNpmkAqP+Kud1uMQwD27aZz+dsNpuL+W63I5VK/TYIw/Au5lnsOA6pVIrtdovjOAghLuIzUzRNYzwePyQRxzGqqt7NVQAhBJPJ5BJzv99TqVRoNBoAzOdzqtUqpmkym81Yr9cIIVAUBaXT6XwFnjRN43A4sFqtcF2XMAzJZDLk83nS6TT1eh0hBLVajcPhwG63I5FI/LjJpCgKhmEA4DgOjuOQy+VotVp3GKfTKbquI597AJAk6Wa/KIpYLpd3/VxhlFXgHfj8NwNZlu/6+QPjuzQYDLpBELzGcfyQQhiGBEGAEOLmmCSAXxf5X+es6/pLv99/+wnRjuAwDaBEiAAAAABJRU5ErkJggg=="

/***/ },
/* 274 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAB3RJTUUH4AoLCyULNFXIDAAAABl0RVh0Q29tbWVudABDcmVhdGVkIHdpdGggR0lNUFeBDhcAAAJASURBVDjLlZPNSiNBFIW/bgu6O21sMJpIQMKo4CIkWYqCGBAE3ZgXEF9kXOmLiC8wgquA6MKNbpSOxIWRQHARCB0SkzbSla7MwpnGHyYwd3epuqfuOXWOBnBycrLr+/5PIAEoxpcOeLZtH+3t7Z1qx8fHu4PB4NfHG4VCgdfXVx4fH8ci2bZdEoPB4CCTyaDU+8NSSrLZLP1+nyAICMMQTdMYjUZ0Oh36/X4E4Pv+gQCmNzY2GA6H0YGUEtM0WV1dxXEcwjDk5eWF29vbr1tNC0CdnZ1FgwBCCAAmJyfZ2dnh4uICz/N4e3v7ykIJgHa7ja7r5HI5lFJUKhUA8vk8nufx9PQ0VtF3KKXwfZ98Ps/MzAzpdJrl5WWurq4AMAyDpaUlHMf5BCA+NrVajbm5OYrFIo7j4LouzWYTgGQyyebmJq7rcnNzQxiGnzf4W/V6HcMwEELgum6kSSaTASCVShGPx79TAJidnWVtbY1er0en06FUKhGLxTBNk3Q6zd3dHZqmkUgkvlNIpVKsr68TBAHlchmA7e1tFhcX8X0fIQTVahXLslhYWKDRaCClfAcwTZOVlRWklJyfn0ffVS6XUUqxtbWFYRiRwI7jEIvF6Ha7CEAPw5CHhwdardZXpzE1NUUymaRWqyGEoNlsEo/HmZ+fp9vt6gJoSyl//Mv3uVyOXq/H5eUlExMTDIdDlFJks1nu7+/bumVZh+MCEwQB19fXjEajyO7VapXn52ds2z7UAP4k8r/ibFnW0f7+/ulvOQ4B+OkIi0EAAAAASUVORK5CYII="

/***/ },
/* 275 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAAfSC3RAAAAAXNSR0IArs4c6QAAAAZiS0dEAP8A/wD/oL2nkwAAAAlwSFlzAAALEwAACxMBAJqcGAAAAAd0SU1FB9wLDwoAFwjfV6IAAAG6SURBVCjPdZK/iiJBGMR/3dP2jCBqoE5qqNmAiaEP4Iss7HL3KAYLRiY+iiL4J/EBFCYwMVEQFJ2x57vgHNFbrpJuurq6+itKjcdje7/fP26326dSyohIppRCRADI90opLSJ33/e/C4XC0KRp+pEkyUAp9XYxyzJez/L1drsNAHSSJF85kbtcLhdarRbtdpvL5fLGPcRfGvB4QCmVE3S7XbrdLtfr9c31AU8rpbIsyzidThwOB+I4JooigiDAWkun0yGOY47HI6fTKR8hMyKCMYZ+v0+pVMJaS6VSeTr0ej2iKCJJEs7nM9PpFOccBiBNU47HI+12m3/h+z5hGAKwWCxI0xStNTqfaz6fM5/P+R+WyyWz2eyZgxYRtNYUi0UmkwmbzeaHaLvdMplMCIIArTUi8tcxj7tarVIsFn8IgyCgXC7zmr4BNIBzjjAMqdfrnM9n1us1AFEU0Wg0qNVq7HY7PM8D0EZEXO5qrWW1WhHHMfv9HoA4jmk2m1hrefmdU6PR6FeapoNHH3HOISL5yzjnUErhed6zPb7v/zbGmCFAkiSfImK01tlrS4wxiAgiooG7tfbbGDP8A+jp21tjVFaRAAAAAElFTkSuQmCC"

/***/ },
/* 276 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 277 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAB3RJTUUH3QYZDBMrBGwJUgAAAuJJREFUOMttVL1O81gUnDm+dmykTUiI+BNSoGe1QoKvzQugFDQ8AUhbUi8lW/AINLwGBU2IhBBQhBqBvgJRBEEs/hTHis/ZIjYbvt1pfC2Nzp0zc+5hu93G3d3dSpqmfwH4QdLMDCRhZgAAkgDw7d/MSPLKOff3wsLCTx4fH6+kaXoDoFyQSUJVISL/KfArx/O8dxH5wyVJsk+ybGaak6mqVnxfX18BgJVKBZZXnORkWfabqu47EdkwM0h+vaoaABmNRjoajWRvbw8k9ejoiDIGzMxERFRVRYSquuGKW2wMOOewtrZmcRyz1+sZSYgI5+bmUKvVrF6v4+rqClmWGceGgqS5wtRcJlZXV219fZ1mpkmSSBAEUFVttVoMw5AAMBgMrNvtEkChCA4TIIm3tzeYGcwMURQhTVMAQBiGXyZ/fn5+nQu4IpHcPDw/P2MwGNjU1BQfHh6s0+kAAJvNJpaWlixJEnx8fACAAShagxSF+v2+7ezs2Pb2NsIwtOFwiHa7bXEcWxzHODs7Q5qmFgSBtVot7O7uWhzHX4pEREASJAWA5OYKACPHQeXngi9Fyp7nWeGxt7m5+aeZzUVRhJubGzw9PaHRaLBUKlmlUmGv10MURdZsNlmtVpmmKU5PT3F+fk4RMc/zaGY9p6rFyOtwOEQURSyVSmpmbDQaOj8/D5Is0vN9H9Vqlff39+r7PrMsw0QXY83OOZmdnUXeog0GAymVSuKcsyRJICJCUur1Onzfl3wwYWb/plYM5uXlJUhar9fjy8uLbW1tAQBPTk5QLpdtcXERFxcXUFUTka/U3MR0kiTSNLVOp8PRaKRhGEoeivb7fT4+PvL29hYAzPM8TjwROgDXAH4v5iJPEM45ZFmGw8NDAMD09DR83/+2DSZwLUEQHIjIu5mxeNy5QgGAmZkZ1Go1Kdr4H857EAQH7Ha76Ha7K2ma7gPYsPHG+raPimR/2UdU1eswDA+Wl5d//gM6T8wasEPinAAAAABJRU5ErkJggg=="

/***/ },
/* 278 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAAXNSR0IArs4c6QAAAAZiS0dEAP8A/wD/oL2nkwAAAAlwSFlzAAALEwAACxMBAJqcGAAAAAd0SU1FB9wLBggYKTUpSbQAAAJVSURBVDjLdZPLalRBEIa/qu6Zc5IJQcQ4QbwgKIqCCCrqRleC6AOIl3kAQV/BpeAu4iULVzFLQdCVGxeCC11IFPGy8IKXBHXEC8nMmZkz3eVizhwNam2a6qq/6u+/qwRgdnaWVqvF/yyEgKoiIuVdrVaj0WggMzMzZFn2T9DQkiSh2WySpilpmpaFarUafsfoXNWS/ul+d+kMIh6ImJXgGHNEHLJGFej7ZOyy+sr0g69beq1WCx/7vdOh155CBMyIMQdAxGEWGJvYRPvbe2LoIeLod5emPGOY2UURQUOvfRYRLOTEmJOOTzKx+SATmw7Q+bnAtiPn2H3yGpPbDmMWMIv0u0tnO50OAB4RZzFgGPWth1i36xjqq7Sab3j7cJaCDuv3nADg0/M7iKjrdDqkaYpiFs0CK9buZMPeBuqrAxHzDF9JBgUKTdbvPo5qBbMY6/U6MUYUQF2VDXtOLUsWVWLolQyG5+iqjWCRLMtwzuHNIs4nJOOrlyVbjCxlfe5fOYqoI+RtRBzJeL1gYYUGUDqYMfyN8TXb2X/sQhlzlRG+f3jE11f3+RPjB03lL6qYsXLjvmXDtfj5BWYBEcV7D4CKKKGX8eXl3WUalMUK30LOz4VnZWzYVBFRw5h/fJPsx/xfwKE//+QW7e/vUa0McIUpZkG1Qt5d5OWd87+ZFMDuYpPX966y8PT2n88rF8W76uilkGdTwyLvHl7n49yN38IWMyHiEHVghk/GLpEVy6S+Og0Qeu0z6qoesxjybgkW0QFtEcWs76qjl8X56ZGRERqNBr8Aj4kVcknv0xUAAAAASUVORK5CYII="

/***/ },
/* 279 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAAXNSR0IArs4c6QAAAAZiS0dEAP8A/wD/oL2nkwAAAAlwSFlzAAALEwAACxMBAJqcGAAAAAd0SU1FB9wKFgs1LApWJ6IAAAIKSURBVDjLlZM7S1xREMd/c865Dy+GfTSykJBOSCcpbAI2lhb7AQRF2EYxRL+E7a4g2PsdFMEurYTEysLKSgtxd0n27uvcOyn24fogkKkOZ2b+M/ObcwTg1/4+g1aL/7GwWGSpXkd+7u0xbLefOfNej0GzieY5AGIMYamEieNXIg6R0M7Nbfs03RURp6q5hCHRwsJTpAgiYlTVuyQ5snF8PGg2B4NWC5f3+9s+TRsiAoB6j0uSZ5WybhecQ0TwadoYXx8COJ+mX0WE3HvSuzsWVleJl5eJggCAvvf0Ly+5v7ggqVQwzjHOGQmIiM29JywUKK2s8KFa5frsDPP4OOJRLvNpawtbLtO5umLQbmOcs5PuHJDrcEhcqbBYqwHweXPzFfXFWo3rgwP6Dw/gXD4rgIlj/tzc8H19nd/tNox5TE2Vd4UCc2H4ahNOVRERhq0W79fW+LixAarkwyEAJghAhNuTE+5PTwmKRSY5AGZKXxWxFhsEnFeroAqqnFer2CBArEVVx1t96tC99crU2ukYau0/X6SZqD6zWQYveQCzGUZEzMuArNOZjpB1Om+0qGYWYjaZyUYRAF8aDYL5+el51jepMW3wx87Ot6zXa2iWjeBYixiDZqMYsXb0qbJsBFEElyR7Wbd7GBaLOBNFxwA+TXcVHN7nszNOhBAxiHiXJEcmio5NGLJUr/MXfYjXXyC9NRUAAAAASUVORK5CYII="

/***/ },
/* 280 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAAXNSR0IArs4c6QAAAAZiS0dEAP8A/wD/oL2nkwAAAAlwSFlzAAALEwAACxMBAJqcGAAAAAd0SU1FB9wKEwsVDwprgkAAAAHxSURBVDjLlZO/TipBFMZ/MzvMYvgjGmPCNr4AiQ0Fj0AHiTUPYKLv4o0m1sbKCrOFz0BHRS8dCX+XuMAOMnMLL3sFNTf3lCfz+3K+b84RAI+Pj8RxzP9ULpej1WohHh4eWC6X/wQ2mw0AnuftiCghhNZaXyZJciWEUID9DDrnAJBSSuBda32XyWTuARPHMWq9Xl8aY26EEOyDQgistamI53kkSXLz58kvAGmMuf4JNsaQzWY5Pz/n9PQ0tZEkyXWSJAAoIYS3D0spWSwW5PN56vU6QRCwXC5pt9tMp1O8T0HIz563cBzH5PN5Go0GQRDgnOPg4IByuby1kzJqH357e6NYLHJxccHR0VFqZzAY8Pr6ykeWf0vtez4+PqbZbFIqldL+eDzm5eWFOI7RWu8ISAAhBM45ZrMZ1WqVUqnEtj+bzQjDkCiK0FqnP7IjYK1FKUWz2aTT6dDr9QCIooh2u81kMiGXy6UTfbFgraVYLFKpVDg7O+Pp6QnnHN1ul8lkQqFQwFr7Bd4KSGstvu8DUCgUqNVqPD8/c3h4+BOcJqmccxulFKPRiDAMWa1WzOdzTk5O0k38ZtE224yk1vpWSokxhn6/z3A4ZL1ep8F+t6W+79/6vv9xTEqpewBjzJXWeueY9sd2zr1rre+2TKvV4jdODvduJgAq6AAAAABJRU5ErkJggg=="

/***/ },
/* 281 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAAXNSR0IArs4c6QAAAAZiS0dEAP8A/wD/oL2nkwAAAAlwSFlzAAALEwAACxMBAJqcGAAAAAd0SU1FB9wKGg8LDD0iC3MAAAHsSURBVDjLnZNBSxVRGIafc+a7M3ec2+Ze02gjqOEuoqJFi35IcJcFgraSFkEUBC6MQFOSVnJx229oHUGLKIokN1GJ5lWhGU8znjmnRTZ4US/Uu/w453m/9z0cBbC6ukqWZfyLkiSh3W6jOp0Oxhj+R0mSIK9G34Wlt5OpzaYUWgB3ynntcbYhyZLo2vLF92NFlmXIgSsm90sz77zH+hyNOvG2wyNKSG0235AEYAFA9ksz7bwnCkJG6yN4708EKKX49muDvCxIbTZdARQ6sD5ntD7Co2v3+ma+/3qWtXSdSEXB31mV2XtPajPmPj3lu9lEtABgneV8PMzdiTtHt3NHAZUakjA9fhvrbY+zKOEw9zH1ALrFDpNvZtja2ULX9B+rA8dQc4jnV5/0B3g8rbDJi+srp3bg8f03APiRd9kudnpmg2GTs1Gr/wbq8P0ffphjO9+uMqc241x9mIVLs6cCdKACdu0eqc3Iy5xnlx/TCptVLzNvH/SYALoyvvny1mdgzDpLK2qxW+wxXB8k1jEAxhk2zCYTZy7wxXwlLwu0Uus31q6MA8hAEC+aMp8XLXTzLqKFDbOJOyxMoxAtfPy5hihBK0VDksXqM9V0uAywX5qpmg4FcDUdHssa6Uh7nB0I4qVAyXIcx7TbbX4DeATFa3Lu/0cAAAAASUVORK5CYII="

/***/ },
/* 282 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAB3RJTUUH4AMRDyITXcW7ywAAAl5JREFUOMulk01IVFEYhp/zc++dOzbSCKOSVGZBEVKU5TIMom1BEAQVVBRUuGsVBGVBEoTClFIELQIXERFBblpUq4J2BUUuDDIJamyicWauc+85p8X4M6Gt+uBsDud7eN/3+w78ZwmAAxcrVBJJoeLXL1Yo55Y6cukazUHMo6sZ9KlrU37V/DxbS1R/exoNmAVwYz+ggCSbMvlMaEYni201AF2K1blSVQz9S2LNWprDBGMFlaqmUNHDKESh7A8DyFJV9C88lqJ+FiqqwfbOMsMnEwaPQXdnRJIkFMuqf8GRBpQUEBtBcc6iFQRCUEtgZ9cvbpxpQ3lZAC5lv3I8b0gipUQDwMwlAkeVE3sqlKqO4m/Hrq0t9G5u4cf3Eu0ddcD7LyFRVMWXGCGWACIM5rhyJGZL13qME/woFFm7ZjXPXnzm3stVnN8/QXPacmu8CWE1yKWQtbXghQE7utcteg98xZPnn7j/KoexgutPNdZBk1Z4+u+QpZSQRBEfPk7Mz9stm4SW4KmVN0QDVKIUZ+9KDvW8w9c1ere2cHDfJjz9mbHXaS4fjihVA0bGJV8KPqlAYt0SwAXaoYTHgzc5jHFMfPtNX/EXvdta2bs7pjm7AYCO1inO3I4xSeAaFSjrQErINQmkELyfzvJ20tKzcYbB062LcmdmQ2ITIUE1TsE0erIOPOXw0oJ306u5cOcnR/tmyYSGm499TKzQPiaXrtUBmdDly5EYssuzIyXh03QTAw9jHBKbSDwtyKZMvpzYOiBUboQUbn6ll30mTwtwvhOglCLJhC4fem50bCANwB8V8umz0lpU8gAAAABJRU5ErkJggg=="

/***/ },
/* 283 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAAfSC3RAAAAAXNSR0IArs4c6QAAAAZiS0dEAP8A/wD/oL2nkwAAAAlwSFlzAAALEwAACxMBAJqcGAAAAAd0SU1FB9wLDwoAIcdlwjsAAAF4SURBVCjPdZI9igJBEEZfdfXMMAqigXgBcxMzz+ERJljYNRK8huCCiZGxJxEPIHiCQURQUOanpzcaUXQ7rsf3qr+S9XodlmX5lWXZt4hYoOLD894boIyi6DcIgqUtiuIrz/O5iOCcwzn3AogIqooxBoAsy+YANs/znxpqNBq0Wi2qqnpO4nQ6URQFQRAgImRZ9mNFRAHu9zuDwYDRaPSmudvt2G63VFWFMQYRUVPvVKd+esPhkH6/T5ZltUVlnwdUlePxyGq1oixLAIIgIEkSms3mYwUR4QV0ztHtdpnNZnjvH0PGmDebt8Q0TVksFhRF8UicTCao6v+gc45er8d0On1JbLfb7Pf7/0FjDOfzmc1m81Cz1jIejx89PoOm7ktE6HQ6JEny9rMi8rAAjPXeOxEhjmMOhwNpmr4cQG1yuVyI47iuw9kwDBdFUcxVldvtxvV6/dilqqKqeO+JomhhrbVLgDzPv1XVqurHIweM974Mw/DXWrv8A5FtsjaW2MNCAAAAAElFTkSuQmCC"

/***/ },
/* 284 */
/***/ function(module, exports) {

	module.exports = "data:image/gif;base64,R0lGODlhEAAQAKUxAAAAADVJYzZKZC9iyDFlzTly4j5240B240Z75Ep940D/QE6B5FaG5ViH5WKO5myU526X52WV82qZ9Xab6Hqf6XGd9X+h6Xei9n2n+ICAgJOit5alupqpvp6uw4Sl6Yam6ouq6oSr+Yuw+pC1+5a5/Jq9/aOyyKe2zJ/A/qLC/9Dg8ODg8ODo8PDw8PDw//D4///4/////////////////////////////////////////////////////////////yH5BAEKAD8ALAAAAAAQABAAAAZiwJ9wSCwaj8hkEcT8WCYPR2NhKBBBKRRpJAphLpUIgXiKmc/ml0tANMUAcED6xQoQO+i5q07kmDOAgRkrdkMbeWdqhUIab3FzfEONeS9qkYxoMGotLCqLPxoBoqOkn0qnSUEAOw=="

/***/ },
/* 285 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAADAElEQVR42mNkGGDAOGgcUFFR4dfR0bFpQBwAtFwdSJUBcRfQETcHwgGlQEoDiG8AHdBNdwdAHTEXaHkyPS0fdcDgcUB5eflcRkZGG6AD1KltQdHK73yszAw+zEyMl9uCOC7TJQQS533lY2Nh9AVaHAqk7YH0QaAD6oAOuERTB4TP+GrIwsxQz8oMsRSIVwPZmyZGcn7GpYeqDgid/vUMCxPDCqDFMxelcH8mRg/VHOA/+YsfMxND3bpsHhNS9FEtEfpM/HIW6ICGjbk8m0l2AKUh4N732Q+UyLYVkOZ7sh2wSSXYluE/01e/u6vPgfguPZ/Bvt9ZxEuS70l2ANBiJiBVy8DAnMnwj/nHawFZ3dV+hY6/uHnq9pXykux7khywSSVEHEgtZfjPzMDwnzGa4T9b80duMYb5YeXG/9jZGw6U85Hse7gDCCVCoOVOQKWLgME+G8ht9ru78t9irRI+3m/fL21zCH87a4GdMTmWEwyBTSqhkCD/z5QKVBrnd3fFPmT5+PgjZ4P2rhf+wcajG36vkah8T7QDNimHijMwMgKDHOQGhmig5S+RNerXf/Tj+PenLmPNnHMi7z78933Zno7Lkm28Mx0ZGJjeeH1OJa4u2KQcBgxSxo3wIL+3/B+6Rp3aj2eBDmiM27Zmv9LTZ5eBiTLV503dbjSLeYFUDzDRujP8Zwjy+pJyjkgHROgCE5oA0OLD6BrkSz8oAyuYKGBx63+thR+c8rcIt7gyMLDMBiZQPZ93pZ+glgPFGIFiTDuB3BKg5VijiGAi5Ep/rwy0zIGVBYhBlQwLAwOQPggs8/tutvGfh6nbItg7k/E/CyPDP7Zixv9MMF+nAi3ezYAHYA0BzvT3ekAK1FC1B/GhNdsBFmbGAy8nCNzFZtBW/knA4GYBRgULK9ABW/D5mhgH6AIpMyA+8H2m4F1ChsAdwTvLCGg5P9Di/cTqGRxNMno5ANr/2ITc+UFxADZN////twEm0CPUEoOCjbBuIMHOKSiHdHZ2JlNDDG8IDBQAALIzcTCm2IjiAAAAAElFTkSuQmCC"

/***/ },
/* 286 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAAfSC3RAAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAB3RJTUUH3QwJDgc4t1EEiQAAAcNJREFUKM+Nks1KI0EUhb++VWLATtMLhYS0/bMUxAfwAVwkzyC+hctsssoT5El8AWFAFDdCtiGRthVBDJlIg91VNYuZtDrjYs7qVt06xbnnHm80Gv2o6/rYWstnOOfwPA/nXHPneR4igtZ6qeu6Pj4/P6eu6y+PRAQR4W+ICOPxONTWWpxznJ2dkSQJxhhOT095fHxksVgQxzEA9/f39Ho9+v0+xhhk80ur1aLT6VBVFUopkiRBKYVSCq01W1tbzRn4TdRaU1UV0+mUsiy5uLjg9fWVNE0pioI8zxER8jz/ShQRgiAgDEOMMby9vbFerwmCgJOTE7IswxhDFEXN3AKglGqM2dvbY39/n7u7O+bzOSLC4eEh29vbWGsbp/XGreVyyfv7O61Wi+fnZ56enlitVnS7XdrtNkdHR9zc3Hy4uynCMCQMw6ZxcHCAc46iKEjTFIDBYND09efdGWPwfb8hrddrXl5eKMsS5xxBEDThkM9Sfd8nSRKur6+5urpCa81qteLy8hLP85jNZv9K7XQ6xHHM7e0t1lp2dnZ4eHhgd3eXKIqw1pJl2YfUjb2TyYT/hVIKbzgcLoD4u5B/V/9J0s9f2FjHAkLdHMoAAAAASUVORK5CYII="

/***/ },
/* 287 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAjFJREFUeNqkk81rE0EYxt/Zj6SJNlvJBzkEiig0ubiJPdRDQVCkIojUW+PBg9KDJw+CQv4OIfSgR/+ABERIixCkVQgmYgwYCNFDFe0Su7tJm2x212dijKvmloEfs+/wzjvPvM8Oc12XZhkCzTikXC53ShCEy/gOA81xnG3btjutVmuSNK8+JsZYCjxDqIIalG+AhphMJm9ks9k74H4oFFLK5bKhaVodRSYFhuZHsoPp0vklv7q2EiTXsePt/d7qcDjMS+12O44ia91ul/iM+LmiKJtembbZpJ6hq6nFEPX7fUotClTa1bkSEjGWIpGIkkgkTheLxZ1CobAXCASeSJJUGQwGy8jZssRERXfPrPOT42GZXr39Ts1PnVq/f5xnkB2B3OtIjIFvKFhATw4ymQw/gCvZMqKPCPdNoT+THiBnAz1pSNh8YFnWU6/kaDRKpmlOYibvkD1/sYHctDcPh5E0zRpZlskwjEnsCEdkuxZU/GksYw6w//8PfD4f6br+F45yZWyjWAXur5mlRir4BlyBYAlx637bx9fAcq/Xqxz/+EALiWulm1fPqg/uZsjn98eb7aNVUZTzErfPO/hGLh8u8PALmrdpaTWam1PUSyvRkY18flE+HNk4tQfoNsFCLrsARmsocO/lG1O9cE6ivXdDHtfqpVskevaxcUEfCIKTYAEKwiDW1arVwYn19Ov3UuzzvlWvb99+ePh1t8P+KcDGD0ycguCB51mgy2Z9zj8FGADgHgwD6oj4yAAAAABJRU5ErkJggg=="

/***/ },
/* 288 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAAfSC3RAAAAAXNSR0IArs4c6QAAAAZiS0dEAP8A/wD/oL2nkwAAAAlwSFlzAAALEwAACxMBAJqcGAAAAAd0SU1FB9wGAwoODkBxqeUAAAFlSURBVCjPnZIxbuNADEUfRWoEGzAkNbmZDuAyQHIXAwng0oAPYF9B51GjaUcjzWyRSFCyW+3vhpxP/k9S7ve7m+f5NYTwJiIGpJwzOWcARAQRAShyznNVVZ9lWV4txvg6TdPlO8myLJgZADlnRIR5nlFVRIQQwgXApml6X0kA4zjSdR17PJ9P6rreuocQ3k1EdP9JVWmahpeXFwCGYcA596OQiKgBaVkWxnHEzNh3XzFNEyEElmWhbVtUNVnOGTOj6zqapuFfOJ/PAHjv6fuelBK2Tg/Y5K2D+R3z3iMipJQo+E/Y3tMwDH9138dWJUVRfBHneebxeOCcI8a4eVpxu91QVWKM1HWNqmJAsa5g3eNvlGXJ4XCgKDZnheWcl/W0AFJKeO/x3m/EGCPH43EvdzHn3EeM8bKeV9u29H2/Fco5czqdfryrqvowM7t+L/kNMFVNKSVSSl+aigJV3Y7cOfdpZtc/0guxqT7h+/IAAAAASUVORK5CYII="

/***/ },
/* 289 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAAfSC3RAAAAAXNSR0IArs4c6QAAAAZiS0dEAP8A/wD/oL2nkwAAAAlwSFlzAAALEwAACxMBAJqcGAAAAAd0SU1FB9wGAwoALuWcpKMAAAHHSURBVCjPdZJBSuxAEIa/6u7MMMEIQcQr9HqWWYp7mWMIyntHcSG4cuNa0J3gAQJzg5xiII4Gkkl1vYUkOIv3Qy+64Ov6q/qX5+fnxTiON33f34pIMLNkZpgZACIyHWdm43K5fMiy7DEcDoebYRjuAcZxxDmHc47T01MAPj8/SSmhqnjv6fv+HiAMw3A3QXmeU1UVMUbatmUcR87Ozmiahrqu6bqOEAJ93985EfGqSp7nbDYbYowAvL+/8/LyAkCMkc1mQ57nqCoi4p2ZJeccVVVRluU8m6qiqgCYGWVZUlUVzjnMLDkzwzk3dxIRALIsY9JUizFOIM7MKIpifnmSqs7331suiuIH5D86Pz+nbVu22+38Jb8VRIT9fn9kycy4urri+/ubj48PsixjvV4DsN/vEZEfMKVE0zTEGDEzRAQz4/r6mqIoWK1WADRNQ0ppBp2qUtc1FxcXlGV5ZOny8hKA3W5HXdeklAghOGdm6r2n6zpeX19pmubI9tTp7e2Nruvw3mNmKk9PT38Oh8O9maGqc+ROTk4A+Pr6IqVESgnvPQDL5fJvCCE8AgzDcBtCCGaWUkq0bXsU8hCCM7NxsVg8hBAe/wEV4Puq2zGzYAAAAABJRU5ErkJggg=="

/***/ },
/* 290 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 291 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 292 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAAfSC3RAAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAB3RJTUUH3gEJDigBhEwC8wAAATtJREFUKM+F0jFLllEYxvHf+0bg3KB2lqChIYqgexAaHEUE+wC5WBBIZK3RUEHgVwiCFKSpXJP6DHGDu1JB4LEip6xoiJbz5sNT6DXe5/zPdd0XZ6ApIs7gMWYwgR28wAoOMlNXwwbN4QPGMY+zuIur+IZJPQ2b0ytMZ+Ys3mbme2xm5kU8wLtmcEhGxHpEvHaEIuJ3RCz2o87gXkQ8PYK9g6U+OIHPuPlPnEN9wlQf3MF5bEfEk8z8H3wJm93BiVLKZGvwCjZKKeewW0r5WWv9HhFjeINrtdbdruMKLuA2xvAFj3A5Ik7iJfbxsbvKEAc4jfv40aI/wzR+tSSnsBcRC6NVBr3aF1t7U22nh81pr3PtRmauDTqQ/rfqnC3geWe0PHCMRg9GxHWs/m31OLDWOoK3SilfMYdbfwCBsGMAyM9nwQAAAABJRU5ErkJggg=="

/***/ },
/* 293 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAIAAACQKrqGAAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAB3RJTUUH3QwJDggEH6ZkwQAAASlJREFUKM+NkT+KwkAYxd/IEENaIbUnUdKYws7CImfwEB7CI0QQFBNCSBRJ4zUs0wUlZf5N5tviy8JarLuv+g38Zni8EdvttmkaIsLvEUKMx2PZNM10OjUM44Patm2e51II8Xg88Fcsy5KmaW42m77vP3ij0Wi/30sApmnGcfxB9TyPiCQfbNt2XRfA+XxerVYADofDer3WWp9OJ6UUgEHtuu71egHo+/75fBIRERVFAYCI3tSyLJMkYU7TlOF2uzG8qbZtLxYLIgqCYLlcaq2jKGJIkkQpNXRVShVF4fs+XzsejwxhGDLUdT28qrWeTCaz2YyIrtfrfD4noizLGO73O085FKiqKggC5svlwpBlGY/P3y4BGIbhOI7+Djfj/FxXAtjtdvhHvgCz/reiTTp6cgAAAABJRU5ErkJggg=="

/***/ },
/* 294 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAMAAAAoLQ9TAAAAolBMVEUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACgESU6AAAANXRSTlMAAQIDBAUGCQwNDxAREhMUFyApLzAxMkJHVFlebXF5e4CDm62+xcjKz9PZ3OTo6+/x9/n7/UnKJecAAAB/SURBVBgZBcGJQgEBAAXAcey6tY4KhcpVOgjv/3/NDMDob9MBAIfJ8w4AyktN6gB4WWmkBsD4u+lx3y4BeqcHPpK8wntymwLlTxdJ2gD7CkkKwOAMSQpA5xeSFIDZG2SXArCcQ57SB6QF6//L9WtRNZgcAXTn21vyOQQAzTq4A+uTC/LUhXbmAAAAAElFTkSuQmCC"

/***/ },
/* 295 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAMCAYAAABWdVznAAAAAXNSR0IArs4c6QAAAAZiS0dEAP8A/wD/oL2nkwAAAAlwSFlzAAALEwAACxMBAJqcGAAAAAd0SU1FB9wCGAEcCdgs1SoAAAHeSURBVCjPVZG9a1NhGMV/7/1okqaaUMutaClqrzSttTTYpa1KpVb/Bh3ERYqomYo4dNDNqUO0IAjq0KG4Z/JbEalYB7FRGhWFeA2xuammob03ue/rkmg904Hz4zzwHJ2GDMNASgmwb2DAnrGs9pPFovsJKG/J/sEN9RyfPJJeK9zdXCvc2ZyYHEsDPf8xTRMOhxKW1THrOrc3VGlGqdKMKuXnNiyrYzYcbkk0WdFo3m9Z7Re/rcxdMr2X4mo6pACupWrC0w+oPX2XbxR//roJ5DTAHh8fnn63eGXKcx8JKZX6nv8isstvRbm6qlZ/PBAvHp6ZGhu1pwFb9PZ23XqSOXc2IpyQL33lG64YPfqYIKjz7OlhKpW6EgJRq233Tp1+fs9QUuoq8EQVF3fTIRrV6eyMAKBpPoYRIADfrwilAl0vuZWVV28KOyZObEuEzd+GLurKbNkrDg7spM+uKE1IsVGV/vkLH+4vZ9euN9/ZH4+3zn/9eEyWnUOqLYpsiyLLzrD6/D4pY7GWeaC/cVYDwDT1oXjMWMi+7vWD9ZQK1lMqu9jjx2PGgmlqQ1tZAB3QgJHkYCSTW+r2c0vdfnIwkgFGGrkO/N0hCuwGWgG7a5eRAsg79TSQAzwgD6z/AVpowc7P3/iuAAAAAElFTkSuQmCC"

/***/ },
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */
69,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */,
/* 455 */,
/* 456 */,
/* 457 */,
/* 458 */,
/* 459 */,
/* 460 */,
/* 461 */,
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */,
/* 466 */,
/* 467 */,
/* 468 */,
/* 469 */,
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */,
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */,
/* 480 */,
/* 481 */,
/* 482 */,
/* 483 */,
/* 484 */,
/* 485 */,
/* 486 */,
/* 487 */,
/* 488 */,
/* 489 */,
/* 490 */,
/* 491 */,
/* 492 */,
/* 493 */,
/* 494 */,
/* 495 */,
/* 496 */,
/* 497 */,
/* 498 */,
/* 499 */,
/* 500 */,
/* 501 */,
/* 502 */,
/* 503 */,
/* 504 */,
/* 505 */,
/* 506 */,
/* 507 */,
/* 508 */,
/* 509 */,
/* 510 */,
/* 511 */,
/* 512 */,
/* 513 */,
/* 514 */,
/* 515 */,
/* 516 */,
/* 517 */,
/* 518 */,
/* 519 */,
/* 520 */,
/* 521 */,
/* 522 */,
/* 523 */,
/* 524 */,
/* 525 */,
/* 526 */,
/* 527 */,
/* 528 */,
/* 529 */,
/* 530 */,
/* 531 */,
/* 532 */,
/* 533 */,
/* 534 */,
/* 535 */,
/* 536 */,
/* 537 */,
/* 538 */,
/* 539 */,
/* 540 */,
/* 541 */,
/* 542 */,
/* 543 */,
/* 544 */,
/* 545 */,
/* 546 */,
/* 547 */,
/* 548 */,
/* 549 */,
/* 550 */,
/* 551 */,
/* 552 */,
/* 553 */,
/* 554 */,
/* 555 */,
/* 556 */,
/* 557 */,
/* 558 */,
/* 559 */,
/* 560 */,
/* 561 */,
/* 562 */,
/* 563 */,
/* 564 */,
/* 565 */,
/* 566 */,
/* 567 */,
/* 568 */,
/* 569 */,
/* 570 */,
/* 571 */,
/* 572 */,
/* 573 */,
/* 574 */,
/* 575 */,
/* 576 */,
/* 577 */,
/* 578 */,
/* 579 */,
/* 580 */,
/* 581 */,
/* 582 */,
/* 583 */,
/* 584 */,
/* 585 */,
/* 586 */,
/* 587 */,
/* 588 */,
/* 589 */,
/* 590 */,
/* 591 */,
/* 592 */,
/* 593 */,
/* 594 */,
/* 595 */,
/* 596 */,
/* 597 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = arrayClean;
	
	var _isEmpty = __webpack_require__(__webpack_module_template_argument_0__);
	
	var _isEmpty2 = _interopRequireDefault(_isEmpty);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Cleans the given array of _empty_ values
	 *
	 * @see {isEmpty} for how the values are determined to be empty.
	 *
	 * @param {Array} array The array to be _cleaned_
	 * @returns {Array} The clean array
	 *
	 * @throws {TypeError} When the passed array is not actually an array.
	 *
	 * @example
	 * const sourceArray = [undefined, null, true, '', {}];
	 * arrayClean(sourceArray); // Returns: [true, {}]
	 *
	 * @example
	 * arrayClean() // throws: Cannot read property 'length' of undefined
	 */
	// TODO: Could be written as `array.filter(isEmpty);`
	function arrayClean(array) {
	    var results = [],
	        i = 0,
	        ln = array.length,
	        // TODO: throws if the error is undefined
	    item;
	
	    for (; i < ln; i++) {
	        item = array[i];
	
	        if (!(0, _isEmpty2.default)(item)) {
	            results.push(item);
	        }
	    }
	
	    return results;
	}
	//# sourceMappingURL=arrayClean.js.map

/***/ },
/* 598 */,
/* 599 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = arraySort;
	
	var _isString = __webpack_require__(__webpack_module_template_argument_0__);
	
	var _isString2 = _interopRequireDefault(_isString);
	
	var _isNumber = __webpack_require__(__webpack_module_template_argument_1__);
	
	var _isNumber2 = _interopRequireDefault(_isNumber);
	
	var _isArray = __webpack_require__(__webpack_module_template_argument_2__);
	
	var _isArray2 = _interopRequireDefault(_isArray);
	
	var _isObject = __webpack_require__(__webpack_module_template_argument_3__);
	
	var _isObject2 = _interopRequireDefault(_isObject);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function arraySort(array, direction, key, emptyFirst) {
	    // supports [number], [string], [{key: number}], [{key: string}], [[string]], [[number]]
	
	    if (!(0, _isArray2.default)(array)) {
	        return;
	    }
	
	    key = !!key || (0, _isNumber2.default)(key) ? key : 'name';
	
	    array.sort(function (a, b) {
	        // if object, get the property values
	        if ((0, _isObject2.default)(a) && (0, _isObject2.default)(b)) {
	            a = a[key];
	            b = b[key];
	        }
	
	        // if array, get from the right index
	        if ((0, _isArray2.default)(a) && (0, _isArray2.default)(b)) {
	            a = a[key];
	            b = b[key];
	        }
	
	        // string
	        if ((0, _isString2.default)(a) && (0, _isString2.default)(b)) {
	            a = a.toLowerCase();
	            b = b.toLowerCase();
	
	            if (direction === 'DESC') {
	                // TODO: Case sensitive really required? Why not allow `desc`, `Desc` or `dEsC`?
	                return a < b ? 1 : a > b ? -1 : 0;
	            } else {
	                return a < b ? -1 : a > b ? 1 : 0;
	            }
	        }
	
	        // number
	        else if ((0, _isNumber2.default)(a) && (0, _isNumber2.default)(b)) {
	                return direction === 'DESC' ? b - a : a - b;
	            } else if (a === undefined || a === null) {
	                return emptyFirst ? -1 : 1;
	            } else if (b === undefined || b === null) {
	                return emptyFirst ? 1 : -1;
	            }
	
	        return -1;
	    });
	
	    return array;
	}
	//# sourceMappingURL=arraySort.js.map

/***/ },
/* 600 */,
/* 601 */,
/* 602 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = arrayTo;
	
	var _isArray = __webpack_require__(__webpack_module_template_argument_0__);
	
	var _isArray2 = _interopRequireDefault(_isArray);
	
	var _isObject = __webpack_require__(__webpack_module_template_argument_1__);
	
	var _isObject2 = _interopRequireDefault(_isObject);
	
	var _isString = __webpack_require__(__webpack_module_template_argument_2__);
	
	var _isString2 = _interopRequireDefault(_isString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Create an array from the passed `param`. (When the value is an object only takes the iterable properties from the object (not its prototypes))
	 *
	 * @param {Object|String|Array} param The value to transform to an array
	 * @returns {Array} Returns the `param` transformed into an array, or an empty array of the value can not be transformed.
	 *
	 * @example
	 * arrayTo('myData') // Returns: ['myData']
	 *
	 * @example
	 * const sourceObject = {
	 *     name: 'ANC First Visit',
	 *     shortName: 'ANC1',
	 *     level: 1,
	 * };
	 * arrayTo(sourceObject); // Returns: ['ANC First Visit', 'ANC1', 1]
	 *
	 * @example
	 * arrayTo(null); // Returns: []
	 */
	function arrayTo(param) {
	    if ((0, _isArray2.default)(param)) {
	        return param;
	    }
	
	    if ((0, _isObject2.default)(param)) {
	        var a = [];
	        for (var key in param) {
	            if (param.hasOwnProperty(key)) {
	                a.push(param[key]);
	            }
	        }
	        return a;
	    }
	
	    if ((0, _isString2.default)(param)) {
	        return param.split();
	    }
	
	    return [];
	}
	//# sourceMappingURL=arrayTo.js.map

/***/ },
/* 603 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isEmpty;
	
	var _isArray = __webpack_require__(__webpack_module_template_argument_0__);
	
	var _isArray2 = _interopRequireDefault(_isArray);
	
	var _lodash = __webpack_require__(80);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _lodash3 = __webpack_require__(82);
	
	var _lodash4 = _interopRequireDefault(_lodash3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Check if a value is concidered _empty_. An _empty_ value is an empty `Set`, `Map` or `Array`.
	 * Depending on if the `allowEmptyString` flag, empty strings are also considered _empty_
	 *
	 * @param {*} param Value to check
	 * @param {boolean} allowEmptyString When set to true an empty string will not be considered _empty_.
	 * @returns {boolean} Returns `true` when the value is _empty_, otherwise false
	 *
	 * @example
	 * isEmpty(''); // Returns: true
	 * isEmpty('', true); // Returns: false
	 * isEmpty(null); // Returns: true
	 * isEmpty(new Map()); // Returns: true
	 */
	function isEmpty(param, allowEmptyString) {
	  return param == null || (!allowEmptyString ? param === '' : false) || (0, _isArray2.default)(param) && param.length === 0 || ((0, _lodash2.default)(param) || (0, _lodash4.default)(param)) && param.size === 0;
	}
	//# sourceMappingURL=isEmpty.js.map

/***/ },
/* 604 */,
/* 605 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isNumber;
	
	var _numberIsFinite = __webpack_require__(__webpack_module_template_argument_0__);
	
	var _numberIsFinite2 = _interopRequireDefault(_numberIsFinite);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Check if a value is a number
	 *
	 * @name isNumber
	 * @param param Value that will be checked if it is a number
	 * @returns {boolean} Returns true when param is a Number otherwise false
	 */
	function isNumber(param) {
	  return typeof param === 'number' && (0, _numberIsFinite2.default)(param);
	}
	//# sourceMappingURL=isNumber.js.map

/***/ },
/* 606 */,
/* 607 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isObject;
	
	var _lodash = __webpack_require__(81);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _isArray = __webpack_require__(__webpack_module_template_argument_0__);
	
	var _isArray2 = _interopRequireDefault(_isArray);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Check if the value is an Object
	 *
	 * @param param Value to be checked
	 * @returns {boolean} Returns true when the `param` is an Object
	 */
	function isObject(param) {
	  return (0, _lodash2.default)(param) && !(0, _isArray2.default)(param);
	}
	//# sourceMappingURL=isObject.js.map

/***/ },
/* 608 */,
/* 609 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _dhis_highcharts = __webpack_require__(__webpack_module_template_argument_0__);
	
	var _dhis_highcharts2 = _interopRequireDefault(_dhis_highcharts);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    dhis_highcharts: _dhis_highcharts2.default
	};
	//# sourceMappingURL=index.js.map

/***/ },
/* 610 */,
/* 611 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _dhis = __webpack_require__(__webpack_module_template_argument_0__);
	
	var _dhis2 = _interopRequireDefault(_dhis);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var noValidation = function noValidation(data) {
	    return data;
	};
	
	exports.default = {
	    dhis: _dhis2.default,
	    noValidation: noValidation
	};
	//# sourceMappingURL=index.js.map

/***/ }
/******/ ])));


/** WEBPACK FOOTER **
 ** chart.js
 **/